var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { a as axios, r as render, b as render$1, c as render$2, d as render$3, e as render$4, f as render$5, C as Capacitor, g as registerPlugin, S as ScreenOrientation, h as StatusBar, A as AppLauncher, B as Browser, i as createI18n, j as render$6, k as render$7, l as entry_esm, m as render$8, n as moment, t as toZonedTime, o as format, u as useDebounceFn, p as render$9, q as render$a, s as render$b, v as useInfiniteScroll, w as format$1, x as render$c, F as Filesystem, D as Directory, y as Share, z as render$d, E as render$e, G as sortBy, H as render$f, I as render$g, J as parsePhoneNumber, W as WebPlugin, K as render$h, L as render$i, M as render$j, N as render$k, O as v4, P as render$l, Q as render$m, R as render$n, T as render$o, U as render$p, V as render$q, X as render$r, Y as render$s, Z as render$t, _ as render$u, $ as render$v, a0 as render$w, a1 as render$x, a2 as debounce, a3 as render$y, a4 as render$z, a5 as render$A, a6 as render$B, a7 as render$C, a8 as render$D, a9 as render$E, aa as render$F, ab as render$G, ac as render$H, ad as render$I, ae as jwtDecode, af as postscribe, ag as Recaptcha, ah as render$J, ai as render$K, aj as render$L, ak as render$M, al as render$N, am as render$O, an as render$P, ao as render$Q, ap as render$R, aq as render$S, ar as render$T, as as render$U, at as render$V, au as render$W, av as vOnClickOutside, aw as Cropper, ax as render$X, ay as render$Y, az as render$Z, aA as render$_, aB as render$$, aC as render$10, aD as render$11, aE as render$12, aF as render$13, aG as render$14, aH as render$15, aI as render$16, aJ as render$17, aK as render$18, aL as render$19, aM as render$1a, aN as render$1b, aO as render$1c, aP as render$1d, aQ as render$1e, aR as render$1f, aS as render$1g, aT as SafeArea } from "./vendor-DtHBi3De.js";
import { r as requests, i as isGokollab, A as AppState, g as getGokollabLocationId, d as deviceId, a as isMobileTablet, T as TEST_EMAILS, b as isPwa, c as TEST_EMAIL_ID, B as BRANDED_TEST_EMAIL_ID, f as formatDateDay, L as LocationState, U as UserState, e as UserService, C as CoursesService, h as CAPACITOR_PLATFORM, O as OpenInNativeAppWhitelist, j as CARD_ICON, V as VISA_ICON, k as UNIONPAY_ICON, M as MASTERCARD_ICON, J as JCB_ICON, D as DISCOVER_ICON, l as DINERS_ICON, m as AMEX_ICON, n as LANDING_PAGE_IMAGE, o as formatDate, N as NO_CERTIFICATES_THUMBNAIL, p as DEFAULT_CERTIFICATE_THUMBNAIL, t as truncateString, q as CommunitiesService, v as validateForm, S as SANITIZE_REGEX_PATTERN, s as logoutUser, u as ALLOWED_FILE_TYPES, w as MediaService, x as isAuthV2Enabled, y as UserServiceV2, z as COURSES_ICON, E as COMMUNITIES_ICON, F as BrandedAppState, K as KOLAB_IMAGE, G as externalPathRedirect, H as setAppLoading, I as NotificationState, P as setBadgeCount, Q as MAX_BADGE_COUNT_LIMIT, R as FACEBOOK_ICON, W as INSTAGRAM_ICON, X as LINKEDIN_ICON, Y as TWITTER_ICON, Z as YOUTUBE_ICON, _ as trackPendoEvents, $ as CP_Pendo_Events, a0 as ProfileScreen, a1 as addChatWidgetPositioningScript, a2 as NETWORK_ERROR_CODES, a3 as Screens, a4 as LoginEvents, a5 as postLogin, a6 as textValidation, a7 as handleRedirectToExternalBrowser, a8 as EMPTY_FOLDER, a9 as AnalyticsService, aa as UserPlatform, ab as CPPageEvents, ac as EstimateStatus, ad as DEFAULT_COVER, ae as isAppLoading, af as EMPTY_STATE, ag as GROUP_BRANDING_NAVBAR, ah as DEFAULT_AVATAR, ai as AppVersionsInstance, aj as WINDOW_EVENTS, ak as trackForceUpdateEvent, al as ForceUpdateEvents, am as FORCE_APP_UPDATE_BG, an as GOKOLLAB_GRADIENT_LOGO, ao as GOKOLLAB_LOGO, ap as GOKOLLAB_DEFAULT_LOGO, aq as createElementId, ar as DEFAULT_COURSE_LOGO, as as DEFAULT_COMMUNITY_LOGO, at as GOKOLLAB_K_LOGO_WITHOUT_BORDER, au as EXPLORE_ICON, av as ADD_ICON, aw as GOKOLLAB_MASTERMIND_LOGO, ax as LOGIN_LOGO, ay as SIGN_UP_LOGO, az as LOCKOUT_IMAGE, aA as DEFAULT_GROUP_LOGO, aB as DEFAULT_GROUP_COVER_IMAGE, aC as checkUserConsent, aD as FRAME1, aE as FRAME2, aF as FRAME3, aG as FRAME4, aH as MAIL_MOBILE_ICON, aI as TEST_LOCATION_ID, aJ as GROUP_MOBILE_ICON } from "./BrandedApp-BnlUHEvF.js";
import { useNotification, UICard, UITextLgMedium, UITextMdMedium, UITextMdNormal, UITextXsMedium, UIButton, UITag, UITextSmMedium, UILoadingBar, UIAvatar, UITextSmRegular, UIDivider, UITabs, UITabPane, UICollapseTransition, UIDatepicker, UISpin, UIDrawer, UIDrawerContent, UIRadio, UITextXsRegular, UISwitch, UISpace, UIForm, UIFormItem, UIInput, UISelect, UICheckbox, UIRadioGroup, UITextSmNormal, UIBadge, UISkeleton, renderIcon as renderIcon$1, UIEmpty, UIMenu, UITooltip, UIDisplaySmMedium, UIContentWrap, UIHeader, UIDisplaySmSemibold, UIModal, UIModalHeader, UIDropdown, UIProgress, UISlider, UIPopover, UIToolbarGroup, UIButtonGroup, UIPagination, UIModalFooter, UIModalContent, UIUpload, UIAlert, UIRadioGroupItem, UICarousel } from "@gohighlevel/ghl-ui";
import { reactive, computed, provide, defineComponent, ref, inject, onMounted, createElementBlock, openBlock, createElementVNode, createVNode, unref, withCtx, createTextVNode, toDisplayString, Fragment, renderList, resolveDirective, normalizeClass, createCommentVNode, createBlock, withDirectives, onBeforeUnmount, onUnmounted, watch, nextTick, resolveComponent, renderSlot, onBeforeMount, watchEffect, vModelText, resolveDynamicComponent, withKeys, withModifiers, h, useSlots, normalizeStyle, createStaticVNode, defineAsyncComponent, Transition, mergeProps, createSlots, vShow } from "vue";
import { _ as _export_sfc } from "./_plugin-vue_export-helper-1tPrXgE0.js";
import * as yup from "yup";
import { string } from "yup";
import { HLButton, HLModal, HLText, HLSpin, HLTooltip, HLDivider, HLPopover, HLSkeleton, HLAvatar, HLCard } from "@platform-ui/highrise";
import "firebase/compat/auth";
import "firebase/compat/app";
const BillingService = {
  verifyBillingOtp: (payload) => {
    const endpoint = isGokollab() ? `${AppState.getConfig().REST_API_URLS}/clientclub/v2/${getGokollabLocationId()}/auth/billing/otp` : `${AppState.getConfig().REST_API_URLS}/clientclub/auth/billing/otp`;
    return requests().post(endpoint, {
      email: payload.email,
      userId: payload.userId || "",
      token: payload.token || "",
      otp: payload.otp || null,
      deviceName: navigator.userAgent,
      deviceId,
      deviceType: isMobileTablet() ? "mobile" : "desktop",
      domainName: `${window.location.host}`,
      locationId: payload.locationId,
      ipAddress: "0.0.0.1",
      //not required
      redirectUrl: payload.redirectUrl || null,
      action: (payload == null ? void 0 : payload.action) || null,
      fullName: (payload == null ? void 0 : payload.fullName) || null,
      captchaToken: payload.captchaToken
    });
  },
  getSubscriptions: (payload) => {
    if (isGokollab()) {
      return BillingServiceGokollab.getSubscriptions(payload);
    }
    return requests().get(
      `${AppState.getConfig().REST_API_URLS}/clientclub/${payload.locationId}/billing/${payload.contactId}/subscriptions`,
      {
        params: {
          contactId: payload.contactId,
          endAt: payload.endAt,
          entityId: payload.entityId,
          entitySourceType: payload.entitySourceType,
          id: payload.id,
          limit: payload.limit || 10,
          offset: payload.offset || 0,
          paymentMode: payload.paymentMode,
          status: payload.status,
          startAt: payload.startAt,
          altId: payload.locationId
        }
      }
    );
  },
  getInvoices: (payload) => {
    if (isGokollab()) {
      return BillingServiceGokollab.getInvoices(payload);
    }
    return requests().get(
      `${AppState.getConfig().REST_API_URLS}/clientclub/${payload.locationId}/billing/${payload.contactId}/invoices`,
      {
        params: {
          contactId: payload.contactId,
          endAt: payload.endAt,
          entityId: payload.entityId,
          entitySourceType: payload.entitySourceType,
          id: payload.id,
          limit: payload.limit || 10,
          offset: payload.offset || 0,
          paymentMode: payload.paymentMode,
          status: payload.status,
          startAt: payload.startAt,
          altId: payload.locationId
        }
      }
    );
  },
  getEstimates: (payload) => {
    if (isGokollab()) {
      return BillingServiceGokollab.getEstimates(payload);
    }
    return requests().get(
      `${AppState.getConfig().REST_API_URLS}/clientclub/${payload.locationId}/billing/${payload.contactId}/estimates`,
      {
        params: {
          contactId: payload.contactId,
          limit: payload.limit || 10,
          offset: payload.offset || 0,
          status: payload.status,
          altId: payload.locationId
        }
      }
    );
  },
  getTransactions: (payload) => {
    if (isGokollab()) {
      return BillingServiceGokollab.getTransactions(payload);
    }
    return requests().get(
      `${AppState.getConfig().REST_API_URLS}/clientclub/${payload.locationId}/billing/${payload.contactId}/transactions`,
      {
        params: {
          contactId: payload.contactId,
          endAt: payload.endAt,
          entityId: payload.entityId,
          entitySourceType: payload.entitySourceType,
          id: payload.id,
          limit: payload.limit || 10,
          offset: payload.offset || 0,
          paymentMode: payload.paymentMode,
          status: payload.status,
          startAt: payload.startAt,
          altId: payload.locationId
        }
      }
    );
  },
  getSubscriptionsById: (payload) => requests().get(
    `${AppState.getConfig().REST_API_URLS}/clientclub/${payload.locationId}/billing/${payload.contactId}/subscriptions/${payload.subscriptionId}`,
    {
      params: {
        altId: payload.locationId
      }
    }
  ),
  getTransactionsById: (payload) => requests().get(
    `${AppState.getConfig().REST_API_URLS}/clientclub/${payload.locationId}/billing/${payload.contactId}/transactions/${payload.transactionId}`,
    {
      params: {
        altId: payload.locationId
      }
    }
  ),
  generateUrl: (payload) => requests().get(
    `${AppState.getConfig().REST_API_URLS}/clientclub/${payload.locationId}/billing/${payload.contactId}/invoices/gen-url/${payload.id}/${payload.type}`,
    {
      params: {
        altId: payload.locationId
      }
    }
  ),
  cancelSubscription: (payload) => requests().post(
    `${AppState.getConfig().REST_API_URLS}/clientclub/${payload.locationId}/billing/${payload.contactId}/subscriptions/cancel`,
    {
      id: payload.subscriptionId,
      altId: payload.locationId,
      altType: "location"
    }
  ),
  downloadInvoiceById: (payload) => requests().post(
    `${AppState.getConfig().REST_API_URLS}/clientclub/${payload.locationId}/billing/${payload.contactId}/invoices/download`,
    {
      invoiceId: payload.invoiceId,
      altId: payload.locationId,
      altType: "location"
    }
  ),
  getPaymentMethods: (payload) => {
    if (isGokollab()) {
      return BillingServiceGokollab.getPaymentMethods(payload);
    }
    return requests().get(
      `${AppState.getConfig().REST_API_URLS}/clientclub/${payload.locationId}/billing/${payload.contactId}/payment-methods`,
      {
        params: {
          liveMode: payload.liveMode
        }
      }
    );
  },
  getContracts: (payload) => {
    if (isGokollab()) {
      return BillingServiceGokollab.getContracts(payload);
    }
    return requests().get(
      `${AppState.getConfig().REST_API_URLS}/clientclub/${payload.locationId}/billing/${payload.contactId}/proposals`,
      {
        params: {
          limit: (payload == null ? void 0 : payload.limit) || 5,
          offset: (payload == null ? void 0 : payload.offset) || 0
        }
      }
    );
  },
  getSharedFiles: (payload) => {
    if (isGokollab()) {
      return BillingServiceGokollab.getSharedFiles(payload);
    }
    return requests().get(
      `${AppState.getConfig().REST_API_URLS}/clientclub/${payload.locationId}/billing/${payload.contactId}/documents`,
      {
        params: {
          contactId: payload.contactId,
          limit: (payload == null ? void 0 : payload.limit) || 10,
          skip: (payload == null ? void 0 : payload.skip) || 0,
          sharedWith: ["client_portal"],
          locationId: payload.locationId
        }
      }
    );
  },
  downloadSharedFile: (payload) => requests().get(
    `${AppState.getConfig().REST_API_URLS}/documents/download/${payload.documentId}`,
    {
      responseType: "blob"
    }
  ),
  downloadContractPdf: (payload) => requests().get(
    `${AppState.getConfig().REST_API_URLS}/proposals/document/public/download`,
    {
      params: payload
    }
  ),
  downloadEstimatePdf: (payload) => requests().post(
    `${AppState.getConfig().REST_API_URLS}/invoices/estimate/download`,
    {
      estimateId: payload.estimateId,
      altId: payload.locationId,
      altType: "location"
    }
  ),
  isLinkedForBilling: (payload) => requests().post(
    `${AppState.getConfig().REST_API_URLS}/clientclub/${payload.locationId}/billing/${payload.contactId}/payment-methods/is-linked-for-billing`,
    {
      altId: payload.locationId,
      altType: "location",
      contactId: payload.contactId,
      liveMode: payload.liveMode,
      paymentProvider: payload.paymentProvider,
      providerCustomerId: payload.providerCustomerId,
      providerPaymentMethodId: payload.providerPaymentMethodId
    }
  ),
  uploadSharedFiles: (payload) => requests().post(
    `${AppState.getConfig().REST_API_URLS}/clientclub/${payload.params.locationId}/billing/${payload.params.contactId}/documents/upload`,
    // Request body
    payload.data,
    // Assuming payload.data contains the body data
    {
      // Query parameters
      params: payload.params,
      headers: {
        "Content-Type": "multipart/form-data"
      }
    }
  ),
  deletePaymentMethod: (payload) => requests().delete(
    `${AppState.getConfig().REST_API_URLS}/clientclub/${payload.locationId}/billing/${payload.contactId}/payment-method`,
    {
      params: {
        altId: payload.locationId,
        altType: "location",
        contactId: payload.contactId,
        liveMode: payload.liveMode,
        paymentProvider: payload.paymentProvider,
        providerCustomerId: payload.providerCustomerId,
        providerPaymentMethodId: payload.providerPaymentMethodId
      }
    }
  ),
  deleteSharedFile: (payload) => {
    if (isGokollab()) {
      return BillingServiceGokollab.deleteSharedFile(payload);
    }
    return requests().delete(
      `${AppState.getConfig().REST_API_URLS}/clientclub/${payload.locationId}/billing/${payload.contactId}/documents/${payload.documentId}`,
      {
        params: {
          documentType: payload.documentType
        }
      }
    );
  }
};
const BillingServiceGokollab = {
  getPaymentMethods: (payload) => requests().get(
    `${AppState.getConfig().GOKOLLAB_SERVER_URL}/clientclub/${payload.locationId}/billing/${payload.contactId}/payment-methods`,
    {
      params: {
        liveMode: payload.liveMode
      }
    }
  ),
  getSubscriptions: (payload) => requests().get(
    `${AppState.getConfig().GOKOLLAB_SERVER_URL}/clientclub/${payload.locationId}/billing/${payload.contactId}/subscriptions`,
    {
      params: {
        contactId: payload.contactId,
        endAt: payload.endAt,
        entityId: payload.entityId,
        entitySourceType: payload.entitySourceType,
        id: payload.id,
        limit: payload.limit || 10,
        offset: payload.offset || 0,
        paymentMode: payload.paymentMode,
        status: payload.status,
        startAt: payload.startAt,
        altId: payload.locationId
      }
    }
  ),
  getTransactions: (payload) => requests().get(
    `${AppState.getConfig().GOKOLLAB_SERVER_URL}/clientclub/${payload.locationId}/billing/${payload.contactId}/transactions`,
    {
      params: {
        contactId: payload.contactId,
        endAt: payload.endAt,
        entityId: payload.entityId,
        entitySourceType: payload.entitySourceType,
        id: payload.id,
        limit: payload.limit || 10,
        offset: payload.offset || 0,
        paymentMode: payload.paymentMode,
        status: payload.status,
        startAt: payload.startAt,
        altId: payload.locationId
      }
    }
  ),
  getEstimates: (payload) => requests().get(
    `${AppState.getConfig().GOKOLLAB_SERVER_URL}/clientclub/${payload.locationId}/billing/${payload.contactId}/estimates`,
    {
      params: {
        contactId: payload.contactId,
        limit: payload.limit || 10,
        offset: payload.offset || 0,
        status: payload.status,
        altId: payload.locationId
      }
    }
  ),
  getInvoices: (payload) => requests().get(
    `${AppState.getConfig().GOKOLLAB_SERVER_URL}/clientclub/${payload.locationId}/billing/${payload.contactId}/invoices`,
    {
      params: {
        contactId: payload.contactId,
        endAt: payload.endAt,
        entityId: payload.entityId,
        entitySourceType: payload.entitySourceType,
        id: payload.id,
        limit: payload.limit || 10,
        offset: payload.offset || 0,
        paymentMode: payload.paymentMode,
        status: payload.status,
        startAt: payload.startAt,
        altId: payload.locationId
      }
    }
  ),
  getContracts: (payload) => requests().get(
    `${AppState.getConfig().GOKOLLAB_SERVER_URL}/clientclub/${payload.locationId}/billing/${payload.contactId}/proposals`,
    {
      params: {
        limit: (payload == null ? void 0 : payload.limit) || 5,
        offset: (payload == null ? void 0 : payload.offset) || 0
      }
    }
  ),
  getSharedFiles: (payload) => requests().get(
    `${AppState.getConfig().GOKOLLAB_SERVER_URL}/clientclub/${payload.locationId}/billing/${payload.contactId}/documents`,
    {
      params: {
        contactId: payload.contactId,
        limit: (payload == null ? void 0 : payload.limit) || 10,
        skip: (payload == null ? void 0 : payload.skip) || 0,
        sharedWith: ["client_portal"],
        locationId: payload.locationId
      }
    }
  ),
  deleteSharedFile: (payload) => requests().delete(
    `${AppState.getConfig().GOKOLLAB_SERVER_URL}/clientclub/${payload.locationId}/billing/${payload.contactId}/documents/${payload.documentId}`,
    {
      params: {
        documentType: payload.documentType
      }
    }
  )
};
const CertificateService = {
  pushPendoEvents: (payload) => requests().post(
    `/certificates/registry/public/track-pendo-events/${payload.eventData.certificateId}`,
    {
      event: payload.event,
      eventData: {
        certificateId: payload.eventData.certificateId,
        platform: payload.eventData.platform
      }
    }
  ),
  getCertificateFile: (certificateId, downloadUrl) => requests().get(
    `${AppState.getConfig().REST_API_URLS}/certificates/registry/public/download/${certificateId}?downloadUrl=${downloadUrl}`,
    { responseType: "arraybuffer" }
  ),
  getIssuedCertificateById: (certificateId) => requests().get(
    `${AppState.getConfig().REST_API_URLS}/certificates/registry/public/${certificateId}`
  ),
  getCertificateHtml: (downloadUrl) => axios.get(downloadUrl),
  getCertificatesByContact: (locationId, userId, skip, pageNumber, limit) => {
    return requests().get(
      `/certificates/locations/${locationId}/registry?contactId=${userId}&skip=${skip}&limit=${limit}&pageNumber=${pageNumber}`
    );
  }
};
const WIDGET_KEYS = {
  GROUPS: "groups",
  COURSES: "courses",
  INVOICES: "invoices",
  CONTRACTS: "contracts",
  ESTIMATES: "estimates",
  SHARED_FILES: "sharedFiles",
  AFFILIATES: "affiliates",
  MANAGE_SUBSCRIPTIONS: "manageSubscriptions"
};
const CUSTOM_PERMISSIONS = {
  testEmailRestricted: (email) => {
    var _a;
    return !TEST_EMAILS.includes((_a = email == null ? void 0 : email.toLowerCase()) == null ? void 0 : _a.trim());
  },
  sharedFilesRestricted: (email) => email !== TEST_EMAIL_ID && email !== BRANDED_TEST_EMAIL_ID,
  nonPwaOnly: () => !isPwa(),
  subscriptionManagement: (email) => {
    if (!email) return false;
    const emailLower = email.toLowerCase().trim();
    return !TEST_EMAILS.includes(emailLower);
  }
};
const COMPONENT_CONFIGURATIONS = {
  [WIDGET_KEYS.GROUPS]: {
    key: WIDGET_KEYS.GROUPS,
    title: "dashboard.recentGroups",
    component: "Groups",
    icon: render$5,
    permissions: ["communitiesEnabled"],
    dataKey: "groups",
    route: "communities",
    gradient: "gradientCommunities",
    description: "dashboard.engageCommunity"
  },
  [WIDGET_KEYS.COURSES]: {
    key: WIDGET_KEYS.COURSES,
    title: "dashboard.activeCourses",
    component: "Courses",
    icon: render$4,
    permissions: ["membershipEnabled"],
    dataKey: "courses",
    route: "courses/library-v2",
    path: "courses=my",
    gradient: "gradientCourses",
    description: "dashboard.exploreCourses"
  },
  [WIDGET_KEYS.INVOICES]: {
    key: WIDGET_KEYS.INVOICES,
    title: "dashboard.recentInvoices",
    component: "Invoices",
    icon: render$1,
    permissions: ["subscriptionsEnabled"],
    dataKey: "invoices",
    customPermission: "testEmailRestricted"
  },
  [WIDGET_KEYS.CONTRACTS]: {
    key: WIDGET_KEYS.CONTRACTS,
    title: "dashboard.contracts",
    component: "Contracts",
    icon: render,
    permissions: ["contractsEnabled"],
    dataKey: "contracts",
    customPermission: "testEmailRestricted"
  },
  [WIDGET_KEYS.ESTIMATES]: {
    key: WIDGET_KEYS.ESTIMATES,
    title: "dashboard.estimates",
    component: "Estimates",
    icon: render$3,
    permissions: ["estimatesEnabled"],
    dataKey: "estimates",
    customPermission: "testEmailRestricted"
  },
  [WIDGET_KEYS.SHARED_FILES]: {
    key: WIDGET_KEYS.SHARED_FILES,
    title: "dashboard.sharedFiles",
    component: "SharedFiles",
    icon: render$2,
    permissions: ["sharedFilesEnabled"],
    dataKey: "sharedFiles",
    customPermission: "sharedFilesRestricted"
  },
  [WIDGET_KEYS.AFFILIATES]: {
    key: WIDGET_KEYS.AFFILIATES,
    title: "dashboard.checkAffiliateEarnings",
    component: "Affiliates",
    icon: render$1,
    permissions: ["affiliateManagerEnabled"],
    dataKey: "affiliates",
    route: "affiliate/campaign",
    customPermission: "nonPwaOnly"
  },
  [WIDGET_KEYS.MANAGE_SUBSCRIPTIONS]: {
    key: WIDGET_KEYS.MANAGE_SUBSCRIPTIONS,
    title: "dashboard.manageSubscriptions",
    component: "ManageSubscriptions",
    icon: render,
    permissions: ["subscriptionsEnabled"],
    dataKey: "invoices",
    route: "account?activeTab=BillingSubscription",
    customPermission: "subscriptionManagement"
  }
};
const PLATFORM_CONFIGURATIONS = {
  webHome: [
    { widget: WIDGET_KEYS.GROUPS, order: 1 },
    {
      widget: WIDGET_KEYS.COURSES,
      order: 2,
      overrides: { dataKey: "coursesActivity" }
    },
    { widget: WIDGET_KEYS.INVOICES, order: 3 },
    { widget: WIDGET_KEYS.CONTRACTS, order: 4 },
    { widget: WIDGET_KEYS.ESTIMATES, order: 5 },
    {
      widget: WIDGET_KEYS.SHARED_FILES,
      order: 6,
      overrides: { requiredDataCount: 0 }
    }
  ],
  webSidebar: [
    {
      widget: WIDGET_KEYS.GROUPS,
      order: 1,
      overrides: { title: "dashboard.joinAGroup", requiredDataCount: 0 }
    },
    {
      widget: WIDGET_KEYS.COURSES,
      order: 2,
      overrides: { title: "dashboard.takeACourse" }
    },
    { widget: WIDGET_KEYS.MANAGE_SUBSCRIPTIONS, order: 3 },
    { widget: WIDGET_KEYS.AFFILIATES, order: 4 }
  ],
  webAppSwitcher: [
    {
      widget: WIDGET_KEYS.GROUPS,
      order: 1,
      overrides: {
        title: "navbar.communities",
        route: "communities/",
        requiredDataCount: 0
      }
    },
    {
      widget: WIDGET_KEYS.COURSES,
      order: 2,
      overrides: { title: "navbar.courses" }
    },
    {
      widget: WIDGET_KEYS.AFFILIATES,
      order: 3,
      overrides: {
        title: "navbar.affiliates",
        route: "affiliate"
      }
    }
  ],
  mobileHome: [
    { widget: WIDGET_KEYS.GROUPS, order: 1 },
    {
      widget: WIDGET_KEYS.COURSES,
      order: 2,
      overrides: { dataKey: "coursesActivity" }
    }
  ],
  mobileTabs: [
    {
      widget: WIDGET_KEYS.INVOICES,
      order: 1,
      overrides: {
        title: "billing.invoices",
        component: "InvoicesWidgets"
      }
    },
    {
      widget: WIDGET_KEYS.CONTRACTS,
      order: 2,
      overrides: {
        title: "userActivityOverview.contracts",
        component: "ContractsWidgets"
      }
    },
    {
      widget: WIDGET_KEYS.ESTIMATES,
      order: 3,
      overrides: {
        title: "widget.estimates",
        component: "EstimatesWidgets"
      }
    },
    {
      widget: WIDGET_KEYS.SHARED_FILES,
      order: 4,
      overrides: {
        title: isGokollab() ? "widget.fileManagement" : "widget.sharedFiles",
        component: "SharedFilesWidgets",
        requiredDataCount: 0
      }
    }
  ],
  mobileMenu: [
    {
      widget: WIDGET_KEYS.GROUPS,
      order: 1,
      overrides: { title: "dashboard.joinAGroup", requiredDataCount: 0 }
    },
    {
      widget: WIDGET_KEYS.COURSES,
      order: 2,
      overrides: { title: "dashboard.takeACourse" }
    },
    { widget: WIDGET_KEYS.AFFILIATES, order: 3 },
    { widget: WIDGET_KEYS.MANAGE_SUBSCRIPTIONS, order: 4 }
  ],
  mobileAppSwitcher: [
    {
      widget: WIDGET_KEYS.GROUPS,
      order: 1,
      overrides: { title: "dashboard.communities", requiredDataCount: 0 }
    },
    {
      widget: WIDGET_KEYS.COURSES,
      order: 2,
      overrides: { title: "dashboard.courses" }
    }
  ]
};
const getStatus = (invoice) => {
  if (invoice.status === "paid") {
    return {
      text: "dashboard.paidOn",
      status: `${formatDateDay(invoice.lastPaidAt)}`,
      isDownloadable: true,
      avatarColor: "bg-clientportal-fill",
      iconColor: "text-clientportal-font-primary",
      textColor: "text-clientportal-font-secondary"
    };
  } else if (invoice.status === "partially_paid") {
    return {
      text: "dashboard.partiallyPaidOn",
      status: `${formatDateDay(invoice.lastPaidAt)}`,
      isDownloadable: true,
      avatarColor: "bg-clientportal-fill",
      iconColor: "text-clientportal-font-primary",
      textColor: "text-clientportal-font-secondary"
    };
  } else {
    return {
      text: /* @__PURE__ */ new Date() > new Date(invoice.dueDate) ? "dashboard.overdueSince" : "dashboard.dueOn",
      status: `${formatDateDay(invoice.dueDate)}`,
      isDownloadable: false,
      avatarColor: "bg-clientportal-error-light",
      iconColor: "text-clientportal-error-primary",
      textColor: "text-clientportal-error-dark"
    };
  }
};
const getInvoiceStatus = (invoiceData) => invoiceData.value.map((invoice) => {
  return {
    ...invoice,
    customFields: getStatus(invoice)
  };
});
const calcHeight = (height) => {
  if (isGokollab()) {
    return "";
  }
  if (height === 2) {
    return "h-[calc(100vh-590px)]";
  } else if (height === 1) {
    return "h-[calc(100vh-466px)]";
  } else {
    return "h-[calc(100vh-280px)]";
  }
};
function downloadPdf(url) {
  const link = document.createElement("a");
  link.href = url;
  link.click();
  link.remove();
}
const getShortenedURL = (url) => {
  if (url.includes("https")) {
    return url.slice(8, url.length);
  } else if (url.includes("http")) {
    return url.slice(7, url.length);
  } else {
    return url;
  }
};
const AffiliatesService = {
  getAffiliateInfo: (payload) => {
    return requests().get(
      `${AppState.getConfig().OLD_API_URLS}/affiliate-client-portal/${payload.locationId}/affiliates/${payload.contactId}/info`
    );
  }
};
class DashboardService {
  static async fetchAllDashboardData() {
    try {
      const [
        invoicesResult,
        contractsResult,
        estimatesResult,
        sharedFilesResult,
        groupsResult,
        coursesActivityResult,
        coursesResult,
        affiliatesResult,
        manageSubscriptionsResult
      ] = await Promise.allSettled([
        this.fetchInvoices(),
        this.fetchContracts(),
        this.fetchEstimates(),
        this.fetchSharedFiles(),
        this.fetchGroups(),
        this.fetchCoursesActivity(),
        this.fetchCourses(),
        this.fetchAffiliates(),
        this.fetchSubscriptionsAndTransactions()
      ]);
      return {
        invoices: invoicesResult.status === "fulfilled" ? invoicesResult.value.data : [],
        contracts: contractsResult.status === "fulfilled" ? contractsResult.value.data : [],
        estimates: estimatesResult.status === "fulfilled" ? estimatesResult.value.data : [],
        sharedFiles: sharedFilesResult.status === "fulfilled" ? sharedFilesResult.value.data : [],
        groups: groupsResult.status === "fulfilled" ? groupsResult.value : [],
        coursesActivity: coursesActivityResult.status === "fulfilled" ? coursesActivityResult.value : {},
        courses: coursesResult.status === "fulfilled" ? coursesResult.value : [],
        affiliates: affiliatesResult.status === "fulfilled" ? affiliatesResult.value : [],
        manageSubscriptions: manageSubscriptionsResult.status === "fulfilled" ? manageSubscriptionsResult.value : []
      };
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
      return this.getEmptyDashboardData();
    }
  }
  static hasPermissionForWidget(widgetKey) {
    var _a, _b, _c, _d;
    const config = COMPONENT_CONFIGURATIONS[widgetKey];
    if (!config) return false;
    if (((_a = config.permissions) == null ? void 0 : _a.length) > 0) {
      const hasPermission = config.permissions.some(
        (permission) => {
          var _a2, _b2, _c2;
          return ((_c2 = (_b2 = (_a2 = LocationState) == null ? void 0 : _a2.state) == null ? void 0 : _b2.locationPermissions) == null ? void 0 : _c2[permission]) !== false;
        }
      );
      if (!hasPermission) return false;
    }
    if (config.customPermission) {
      const userEmail = (_d = (_c = (_b = UserState) == null ? void 0 : _b.state) == null ? void 0 : _c.email) == null ? void 0 : _d.toLowerCase().trim();
      const customPermissionFn = CUSTOM_PERMISSIONS[config.customPermission];
      if (customPermissionFn && !customPermissionFn(userEmail)) return false;
    }
    return true;
  }
  static async fetchInvoices(offset = 1) {
    var _a, _b, _c, _d;
    if (!this.hasPermissionForWidget(WIDGET_KEYS.INVOICES)) {
      return { data: [], total: 0 };
    }
    try {
      const response = await BillingService.getInvoices({
        contactId: UserState.state.userId,
        locationId: (_b = (_a = LocationState) == null ? void 0 : _a.state) == null ? void 0 : _b.locationId,
        limit: isPwa() ? 10 : 5,
        offset: (offset - 1) * (isPwa() ? 10 : 5)
      });
      const invoicesList = ((_c = response == null ? void 0 : response.data) == null ? void 0 : _c.invoices) || [];
      const processedInvoices = this.processInvoiceData(invoicesList);
      return {
        data: processedInvoices,
        total: ((_d = response == null ? void 0 : response.data) == null ? void 0 : _d.total) || 0
      };
    } catch (error) {
      console.error("Error fetching invoices:", error);
      return { data: [], total: 0 };
    }
  }
  static async fetchContracts(offset = 1) {
    var _a, _b, _c, _d;
    if (!this.hasPermissionForWidget(WIDGET_KEYS.CONTRACTS)) {
      return { data: [], total: 0 };
    }
    try {
      const response = await BillingService.getContracts({
        contactId: UserState.state.userId,
        locationId: (_b = (_a = LocationState) == null ? void 0 : _a.state) == null ? void 0 : _b.locationId,
        limit: isPwa() ? 10 : 5,
        offset: (offset - 1) * (isPwa() ? 10 : 5)
      });
      return {
        data: ((_c = response == null ? void 0 : response.data) == null ? void 0 : _c.documents) || [],
        total: ((_d = response == null ? void 0 : response.data) == null ? void 0 : _d.total) || 0
      };
    } catch (error) {
      console.error("Error fetching contracts:", error);
      return { data: [], total: 0 };
    }
  }
  static async fetchEstimates(offset = 1) {
    var _a, _b, _c, _d;
    if (!this.hasPermissionForWidget(WIDGET_KEYS.ESTIMATES)) {
      return { data: [], total: 0 };
    }
    try {
      const response = await BillingService.getEstimates({
        contactId: UserState.state.userId,
        locationId: (_b = (_a = LocationState) == null ? void 0 : _a.state) == null ? void 0 : _b.locationId,
        limit: isPwa() ? 10 : 5,
        offset: (offset - 1) * (isPwa() ? 10 : 5),
        status: "all"
      });
      const estimatesList = ((_c = response == null ? void 0 : response.data) == null ? void 0 : _c.estimates) || [];
      const processedEstimates = this.processInvoiceData(estimatesList);
      return {
        data: processedEstimates,
        total: ((_d = response == null ? void 0 : response.data) == null ? void 0 : _d.total) || 0
      };
    } catch (error) {
      console.error("Error fetching estimates:", error);
      return { data: [], total: 0 };
    }
  }
  static async fetchSharedFiles(skip = 1) {
    var _a, _b, _c, _d;
    if (!this.hasPermissionForWidget(WIDGET_KEYS.SHARED_FILES)) {
      return { data: [], total: 0 };
    }
    try {
      const response = await BillingService.getSharedFiles({
        contactId: UserState.state.userId,
        locationId: (_b = (_a = LocationState) == null ? void 0 : _a.state) == null ? void 0 : _b.locationId,
        limit: isPwa() ? 10 : 5,
        skip: (skip - 1) * (isPwa() ? 10 : 5)
      });
      return {
        data: ((_c = response == null ? void 0 : response.data) == null ? void 0 : _c.documents) || [],
        total: ((_d = response == null ? void 0 : response.data) == null ? void 0 : _d.totalCount) || 0
      };
    } catch (error) {
      console.error("Error fetching shared files:", error);
      return { data: [], total: 0 };
    }
  }
  static async fetchGroups() {
    if (!this.hasPermissionForWidget(WIDGET_KEYS.GROUPS)) {
      return [];
    }
    try {
      const response = await UserService.getRecentlyVisitedGroups({
        locationId: LocationState.state.locationId,
        contactId: UserState.state.userId,
        limit: 3,
        sort: "descending",
        sortKey: "lastVisitedAt"
      });
      return (response == null ? void 0 : response.data) || [];
    } catch (error) {
      console.error("Error fetching groups:", error);
      return [];
    }
  }
  static async fetchCoursesActivity() {
    if (!this.hasPermissionForWidget(WIDGET_KEYS.COURSES)) {
      return {};
    }
    try {
      const response = await UserService.coursesActivityData({
        locationId: LocationState.state.locationId,
        contactId: UserState.state.userId
      });
      return (response == null ? void 0 : response.data) || {};
    } catch (error) {
      console.error("Error fetching courses:", error);
      return {};
    }
  }
  static async fetchCourses() {
    if (!this.hasPermissionForWidget(WIDGET_KEYS.COURSES)) {
      return [];
    }
    try {
      const response = await CoursesService.getCourses(
        LocationState.state.locationId
      );
      return response || [];
    } catch (error) {
      console.error("Error fetching courses:", error);
      return [];
    }
  }
  static async fetchAffiliates() {
    var _a;
    if (!this.hasPermissionForWidget(WIDGET_KEYS.AFFILIATES)) {
      return [];
    }
    try {
      const response = await AffiliatesService.getAffiliateInfo({
        locationId: LocationState.state.locationId,
        contactId: UserState.state.userId
      });
      return (response == null ? void 0 : response.data) ? [true] : [];
    } catch (error) {
      if (((_a = error == null ? void 0 : error.response) == null ? void 0 : _a.status) === 404) {
        return [];
      }
      console.error("Error fetching affiliates:", error);
      return [];
    }
  }
  static async fetchSubscriptionsAndTransactions() {
    var _a, _b;
    if (!this.hasPermissionForWidget(WIDGET_KEYS.MANAGE_SUBSCRIPTIONS)) {
      return [];
    }
    try {
      const [subscriptionsResponse, transactionsResponse] = await Promise.all([
        BillingService.getSubscriptions({
          locationId: LocationState.state.locationId,
          contactId: UserState.state.userId,
          limit: 1
        }),
        BillingService.getTransactions({
          locationId: LocationState.state.locationId,
          contactId: UserState.state.userId,
          limit: 1
        })
      ]);
      const manageSubscriptions = ((_a = subscriptionsResponse == null ? void 0 : subscriptionsResponse.data) == null ? void 0 : _a.totalCount) > 0 || ((_b = transactionsResponse == null ? void 0 : transactionsResponse.data) == null ? void 0 : _b.totalCount) > 0;
      if (manageSubscriptions) return [true];
      return [];
    } catch (error) {
      console.error("Error fetching subscriptions:", error);
      return [];
    }
  }
  static processInvoiceData(invoices) {
    return getInvoiceStatus({ value: invoices });
  }
  static calculateDataCounters(data) {
    return {
      invoices: data.invoices.length,
      contracts: data.contracts.length,
      estimates: data.estimates.length,
      sharedFiles: data.sharedFiles.length,
      groups: data.groups.length,
      courses: data.courses.length,
      affiliates: data.affiliates.length,
      coursesActivity: Object.keys(data.coursesActivity).length
    };
  }
  static getEmptyDashboardData() {
    return {
      invoices: [],
      contracts: [],
      estimates: [],
      sharedFiles: [],
      groups: [],
      coursesActivity: {},
      courses: [],
      affiliates: [],
      manageSubscriptions: []
    };
  }
  static async uploadSharedFiles(locationId, contactId, folderKey, file) {
    try {
      const bodyFormData = new FormData();
      const files = Array.isArray(file) ? file : [file];
      files.forEach((fileObj) => {
        bodyFormData.append("files", fileObj);
      });
      bodyFormData.set(
        "contact",
        JSON.stringify({
          id: contactId,
          data: {
            location_id: locationId
          }
        })
      );
      const response = await BillingService.uploadSharedFiles({
        params: {
          locationId,
          contactId,
          folderKey
        },
        data: bodyFormData
      });
      return response;
    } catch (error) {
      console.error("Error uploading shared files:", error);
      return null;
    }
  }
}
const formatNameForAvatar = (name) => {
  const nameArr = name == null ? void 0 : name.split(/\s+/);
  return nameArr == null ? void 0 : nameArr.map((item) => item[0]).join("").toUpperCase();
};
const capitalizeFirstLetterName = (name) => {
  return name == null ? void 0 : name.split(/\s+/).map((item) => {
    var _a;
    return `${(_a = item[0]) == null ? void 0 : _a.toUpperCase()}${item == null ? void 0 : item.slice(1)}`;
  }).join(" ");
};
const capitalizeLetterRemoveUnderscored = (name) => {
  return name == null ? void 0 : name.split("_").map(
    (part) => part.split(" ").map((item) => {
      var _a;
      return `${(_a = item[0]) == null ? void 0 : _a.toUpperCase()}${item == null ? void 0 : item.slice(1)}`;
    }).join(" ")
  ).join(" ");
};
function getShortName(name) {
  if (name) {
    const nameArray = name == null ? void 0 : name.split(" ");
    if (nameArray.length > 1) {
      return (nameArray[0][0] + nameArray[1][0]).toUpperCase();
    } else {
      return nameArray[0][0].toUpperCase();
    }
  }
  return "";
}
function timestampFormat(originalTimestamp) {
  const date = new Date(originalTimestamp);
  const options = {
    day: "numeric",
    month: "long",
    hour: "numeric",
    minute: "numeric"
  };
  const formattedDate = new Intl.DateTimeFormat("en-US", options).format(date);
  return formattedDate;
}
class DashboardConfigManager {
  static register(platform, config) {
    switch (platform) {
      case "webHome":
        this.webConfigs.home.set(config.key, config);
        break;
      case "webSidebar":
        this.webConfigs.sidebar.set(config.key, config);
        break;
      case "webAppSwitcher":
        this.webConfigs.appSwitcher.set(config.key, config);
        break;
      case "mobileHome":
        this.mobileConfigs.home.set(config.key, config);
        break;
      case "mobileTabs":
        this.mobileConfigs.tabs.set(config.key, config);
        break;
      case "mobileMenu":
        this.mobileConfigs.menu.set(config.key, config);
        break;
      case "mobileAppSwitcher":
        this.mobileConfigs.appSwitcher.set(config.key, config);
        break;
    }
  }
  static getWebHome() {
    return Array.from(this.webConfigs.home.values()).sort(
      (a, b) => a.order - b.order
    );
  }
  static getWebSidebar() {
    return Array.from(this.webConfigs.sidebar.values()).sort(
      (a, b) => a.order - b.order
    );
  }
  static getWebAppSwitcher() {
    return Array.from(this.webConfigs.appSwitcher.values()).sort(
      (a, b) => a.order - b.order
    );
  }
  static getMobileHome() {
    return Array.from(this.mobileConfigs.home.values()).sort(
      (a, b) => a.order - b.order
    );
  }
  static getMobileTabs() {
    return Array.from(this.mobileConfigs.tabs.values()).sort(
      (a, b) => a.order - b.order
    );
  }
  static getMobileMenu() {
    return Array.from(this.mobileConfigs.menu.values()).sort(
      (a, b) => a.order - b.order
    );
  }
  static getMobileAppSwitcher() {
    return Array.from(this.mobileConfigs.appSwitcher.values()).sort(
      (a, b) => a.order - b.order
    );
  }
  static clear() {
    this.webConfigs.home.clear();
    this.webConfigs.sidebar.clear();
    this.webConfigs.appSwitcher.clear();
    this.mobileConfigs.home.clear();
    this.mobileConfigs.tabs.clear();
    this.mobileConfigs.menu.clear();
    this.mobileConfigs.appSwitcher.clear();
  }
}
__publicField(DashboardConfigManager, "webConfigs", {
  home: /* @__PURE__ */ new Map(),
  sidebar: /* @__PURE__ */ new Map(),
  appSwitcher: /* @__PURE__ */ new Map()
});
__publicField(DashboardConfigManager, "mobileConfigs", {
  home: /* @__PURE__ */ new Map(),
  tabs: /* @__PURE__ */ new Map(),
  menu: /* @__PURE__ */ new Map(),
  appSwitcher: /* @__PURE__ */ new Map()
});
function initializeDashboardConfigs() {
  DashboardConfigManager.clear();
  Object.entries(PLATFORM_CONFIGURATIONS).forEach(([platform, configs]) => {
    configs.forEach(({ widget: widget2, order, overrides = {} }) => {
      const baseConfig = COMPONENT_CONFIGURATIONS[widget2];
      const finalConfig = {
        ...baseConfig,
        ...overrides,
        order,
        ..."customPermission" in baseConfig && baseConfig.customPermission && {
          customPermissionCheck: CUSTOM_PERMISSIONS[baseConfig.customPermission]
        }
      };
      DashboardConfigManager.register(platform, finalConfig);
    });
  });
}
class DashboardManager {
  constructor() {
    __publicField(this, "state", reactive({
      initialized: false,
      loading: false,
      error: null,
      data: {
        invoices: [],
        contracts: [],
        estimates: [],
        sharedFiles: [],
        groups: [],
        coursesActivity: {},
        courses: [],
        affiliates: [],
        manageSubscriptions: []
      },
      counters: {
        invoices: 0,
        contracts: 0,
        estimates: 0,
        sharedFiles: 0,
        groups: 0,
        coursesActivity: 0,
        courses: 0,
        affiliates: 0,
        manageSubscriptions: 0
      },
      totals: {
        invoices: 0,
        contracts: 0,
        estimates: 0,
        sharedFiles: 0,
        manageSubscriptions: 0
      }
    }));
    this.initialize();
  }
  initialize() {
    if (!this.state.initialized) {
      initializeDashboardConfigs();
      this.state.initialized = true;
    }
  }
  //IMPORTANT: This is the function that determines
  // if a component should be shown based on the user's permissions and data availability
  shouldShowComponent(config) {
    var _a, _b, _c, _d;
    if (((_a = config.permissions) == null ? void 0 : _a.length) > 0) {
      const hasPermission = config.permissions.some(
        (permission) => {
          var _a2, _b2, _c2;
          return ((_c2 = (_b2 = (_a2 = LocationState) == null ? void 0 : _a2.state) == null ? void 0 : _b2.locationPermissions) == null ? void 0 : _c2[permission]) !== false;
        }
      );
      if (!hasPermission) return false;
    }
    if (config.customPermissionCheck) {
      const userEmail = (_d = (_c = (_b = UserState) == null ? void 0 : _b.state) == null ? void 0 : _c.email) == null ? void 0 : _d.toLowerCase().trim();
      if (!config.customPermissionCheck(userEmail)) return false;
    }
    const dataCount = this.state.counters[config.dataKey] || 0;
    if (config.requiredDataCount === 0) return true;
    const requiredCount = config.requiredDataCount || 1;
    if (config.key === WIDGET_KEYS.MANAGE_SUBSCRIPTIONS) {
      const manageSubscriptions = this.state.data.manageSubscriptions;
      if (manageSubscriptions.length > 0) return true;
    }
    return dataCount >= requiredCount;
  }
  async loadAllData() {
    this.state.loading = true;
    this.state.error = null;
    try {
      const data = await DashboardService.fetchAllDashboardData();
      this.state.data = data;
      this.updateCounters();
      return data;
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : "Failed to load dashboard data";
      this.state.error = errorMessage;
      console.error("Dashboard data loading failed:", error);
      throw error;
    } finally {
      this.state.loading = false;
    }
  }
  async refreshData(type, offset = 1) {
    try {
      let result;
      switch (type) {
        case WIDGET_KEYS.INVOICES:
          result = await DashboardService.fetchInvoices(offset);
          this.state.data.invoices = offset === 1 ? result.data : [...this.state.data.invoices, ...result.data];
          this.state.totals.invoices = result.total;
          break;
        case WIDGET_KEYS.CONTRACTS:
          result = await DashboardService.fetchContracts(offset);
          this.state.data.contracts = offset === 1 ? result.data : [...this.state.data.contracts, ...result.data];
          this.state.totals.contracts = result.total;
          break;
        case WIDGET_KEYS.ESTIMATES:
          result = await DashboardService.fetchEstimates(offset);
          this.state.data.estimates = offset === 1 ? result.data : [...this.state.data.estimates, ...result.data];
          this.state.totals.estimates = result.total;
          break;
        case WIDGET_KEYS.SHARED_FILES:
          result = await DashboardService.fetchSharedFiles(offset);
          this.state.data.sharedFiles = offset === 1 ? result.data : [...this.state.data.sharedFiles, ...result.data];
          this.state.totals.sharedFiles = result.total;
          break;
        case WIDGET_KEYS.GROUPS:
          this.state.data.groups = await DashboardService.fetchGroups();
          break;
        case WIDGET_KEYS.COURSES:
          this.state.data.courses = await DashboardService.fetchCourses();
          this.state.data.coursesActivity = await DashboardService.fetchCoursesActivity();
          break;
        case WIDGET_KEYS.AFFILIATES:
          this.state.data.affiliates = await DashboardService.fetchAffiliates();
          break;
        case WIDGET_KEYS.MANAGE_SUBSCRIPTIONS:
          result = await DashboardService.fetchSubscriptionsAndTransactions();
          this.state.data.manageSubscriptions = result;
          this.state.totals.manageSubscriptions = result.length;
          break;
      }
      this.updateCounters();
      return result;
    } catch (error) {
      console.error(`Error refreshing ${type} data:`, error);
      throw error;
    }
  }
  updateCounters() {
    this.state.counters = DashboardService.calculateDataCounters(
      this.state.data
    );
  }
  updateDataCounters(counters) {
    Object.assign(this.state.counters, counters);
  }
  getWebHomeWidgets() {
    return computed(() => {
      const configs = DashboardConfigManager.getWebHome().filter(
        (config) => this.shouldShowComponent(config)
      );
      return configs;
    });
  }
  getWebSidebarApps() {
    return computed(() => {
      const configs = DashboardConfigManager.getWebSidebar().filter(
        (config) => this.shouldShowComponent(config)
      );
      return configs;
    });
  }
  getWebAppSwitcherItems() {
    return computed(() => {
      const configs = DashboardConfigManager.getWebAppSwitcher().filter(
        (config) => this.shouldShowComponent(config)
      );
      return configs;
    });
  }
  getMobileHomeWidgets() {
    return computed(() => {
      const configs = DashboardConfigManager.getMobileHome().filter(
        (config) => this.shouldShowComponent(config)
      );
      return configs;
    });
  }
  getMobileTabWidgets() {
    return computed(() => {
      const configs = DashboardConfigManager.getMobileTabs().filter(
        (config) => this.shouldShowComponent(config)
      );
      return configs;
    });
  }
  getMobileMenuItems() {
    return computed(() => {
      const configs = DashboardConfigManager.getMobileMenu().filter(
        (config) => this.shouldShowComponent(config)
      );
      return configs;
    });
  }
  getMobileAppSwitcherItems() {
    return computed(() => {
      const configs = DashboardConfigManager.getMobileAppSwitcher().filter(
        (config) => this.shouldShowComponent(config)
      );
      return configs;
    });
  }
  get isLoading() {
    return this.state.loading;
  }
  get error() {
    return this.state.error;
  }
  get data() {
    return this.state.data;
  }
  get counters() {
    return this.state.counters;
  }
  get totals() {
    return this.state.totals;
  }
  hasAnyContent() {
    return computed(() => {
      const webHome = this.getWebHomeWidgets().value.length > 0;
      const webSidebar = this.getWebSidebarApps().value.length > 0;
      const mobileHome = this.getMobileHomeWidgets().value.length > 0;
      const mobileTabs = this.getMobileTabWidgets().value.length > 0;
      return webHome || webSidebar || mobileHome || mobileTabs;
    });
  }
  clearError() {
    this.state.error = null;
  }
  reset() {
    this.state.data = DashboardService.getEmptyDashboardData();
    this.state.counters = {
      invoices: 0,
      contracts: 0,
      estimates: 0,
      sharedFiles: 0,
      groups: 0,
      courses: 0,
      affiliates: 0,
      coursesActivity: 0
    };
    this.state.totals = {
      invoices: 0,
      contracts: 0,
      estimates: 0,
      sharedFiles: 0,
      manageSubscriptions: 0
    };
    this.state.error = null;
  }
  provideToComponents() {
    provide("dashboardManager", this);
    provide(
      "isLoading",
      computed(() => this.state.loading)
    );
    provide("webHomeWidgets", this.getWebHomeWidgets());
    provide("webSidebarApps", this.getWebSidebarApps());
    provide("webAppSwitcherItems", this.getWebAppSwitcherItems());
    provide("mobileHomeWidgets", this.getMobileHomeWidgets());
    provide("mobileTabWidgets", this.getMobileTabWidgets());
    provide("mobileMenuItems", this.getMobileMenuItems());
    provide("mobileAppSwitcherItems", this.getMobileAppSwitcherItems());
    provide("hasAnyContent", this.hasAnyContent());
    provide("sidebarApps", this.getWebSidebarApps());
    provide("homeWidgets", this.getWebHomeWidgets());
    provide(
      "rightWidgets",
      computed(() => [])
    );
    provide(
      "invoiceData",
      computed(() => this.state.data.invoices)
    );
    provide(
      "contractData",
      computed(() => this.state.data.contracts)
    );
    provide(
      "estimateData",
      computed(() => this.state.data.estimates)
    );
    provide(
      "sharedFilesData",
      computed(() => this.state.data.sharedFiles)
    );
    provide(
      "invoiceDataCount",
      computed(() => this.state.totals.invoices)
    );
    provide(
      "contractDataCount",
      computed(() => this.state.totals.contracts)
    );
    provide(
      "estimateDataCount",
      computed(() => this.state.totals.estimates)
    );
    provide(
      "sharedFilesDataCount",
      computed(() => this.state.totals.sharedFiles)
    );
    provide(
      "getInvoiceData",
      (offset) => this.refreshData(WIDGET_KEYS.INVOICES, offset)
    );
    provide(
      "getContractsData",
      (offset) => this.refreshData(WIDGET_KEYS.CONTRACTS, offset)
    );
    provide(
      "getEstimatesData",
      (offset) => this.refreshData(WIDGET_KEYS.ESTIMATES, offset)
    );
    provide(
      "getSharedFilesData",
      (offset) => this.refreshData(WIDGET_KEYS.SHARED_FILES, offset)
    );
  }
}
const dashboardManager = new DashboardManager();
async function setPullToRefreshAndroid(value) {
  try {
    if (Capacitor.getPlatform() == CAPACITOR_PLATFORM.ANDROID) {
      const PullToRefreshPlugin = registerPlugin("PullToRefresh");
      if (PullToRefreshPlugin) {
        await PullToRefreshPlugin.enablePullToRefresh({ value });
      }
    }
  } catch (error) {
    console.error("Error setting pull to refresh", error);
  }
}
const SafeScreenOrientation = {
  lock: async (options) => {
    try {
      if (!Capacitor.isNativePlatform()) return;
      await ScreenOrientation.lock(options);
    } catch (error) {
      console.error("Error locking screen orientation:", error);
    }
  },
  unlock: async () => {
    try {
      if (!Capacitor.isNativePlatform()) return;
      await ScreenOrientation.unlock();
    } catch (error) {
      console.error("Error unlocking screen orientation:", error);
    }
  },
  addListener: async (eventName, listenerFunc) => {
    try {
      if (!Capacitor.isNativePlatform()) return;
      await ScreenOrientation.addListener(eventName, listenerFunc);
    } catch (error) {
      console.error("Error adding screen orientation listener:", error);
    }
  },
  removeAllListeners: async () => {
    try {
      if (!Capacitor.isNativePlatform()) return;
      await ScreenOrientation.removeAllListeners();
    } catch (error) {
      console.error("Error removing all screen orientation listeners:", error);
    }
  }
};
const SafeStatusBar = {
  hide: async (options) => {
    try {
      if (!Capacitor.isNativePlatform()) return;
      await StatusBar.hide(options);
    } catch (error) {
      console.error("Error hiding status bar:", error);
    }
  },
  show: async (options) => {
    try {
      if (!Capacitor.isNativePlatform()) return;
      await StatusBar.show(options);
    } catch (error) {
      console.error("Error showing status bar:", error);
    }
  }
};
async function handleLinkClick(event, options = {
  tryNativeApp: false,
  newWindow: true
}) {
  const target = event.target;
  const link = target.closest("a");
  if (!link) return;
  event.preventDefault();
  const url = link.href;
  if (Capacitor.isNativePlatform()) {
    const shouldTryNativeApp = options.tryNativeApp || OpenInNativeAppWhitelist.matchesAny(url);
    if (shouldTryNativeApp) {
      const { value } = await AppLauncher.canOpenUrl({ url });
      if (value) {
        await AppLauncher.openUrl({ url });
        return;
      }
    }
    await Browser.open({ url });
  } else {
    window.open(url, options.newWindow ? "_blank" : "_self");
  }
}
const openNativeUrls = async (url) => {
  if (!url) {
    return;
  }
  if (Capacitor.isNativePlatform()) {
    try {
      const { value } = await AppLauncher.canOpenUrl({ url });
      if (value) {
        await AppLauncher.openUrl({ url });
        return;
      }
      await Browser.open({ url });
    } catch (error) {
      console.error("Error opening URL:", error);
    }
  } else {
    window.open(url, "_self");
  }
};
const KeyboardPlugin = Capacitor.isNativePlatform() && Capacitor.isPluginAvailable("KeyboardEvents") ? registerPlugin("KeyboardEvents") : null;
function getAllLocalStorageData() {
  try {
    const allStorageData = {};
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key) {
        allStorageData[key] = localStorage.getItem(key);
      }
    }
    return allStorageData;
  } catch (error) {
    console.error("Error accessing localStorage:", error);
    return { error: "Failed to access localStorage" };
  }
}
async function getAllIndexedDBData() {
  try {
    return new Promise((resolve) => {
      const databases = {};
      const request = indexedDB.databases();
      request.then(async (dbs) => {
        try {
          for (const db of dbs) {
            const dbName = db.name;
            if (!dbName) continue;
            const dbRequest = indexedDB.open(dbName);
            await new Promise((resolveDb) => {
              dbRequest.onsuccess = function(event) {
                try {
                  const db2 = event.target.result;
                  const stores = {};
                  const objectStoreNames = Array.from(db2.objectStoreNames);
                  let pendingStores = objectStoreNames.length;
                  if (pendingStores === 0) {
                    databases[dbName] = stores;
                    resolveDb();
                    return;
                  }
                  objectStoreNames.forEach((storeName) => {
                    try {
                      const transaction = db2.transaction(storeName, "readonly");
                      const objectStore = transaction.objectStore(storeName);
                      const storeData = [];
                      const cursorRequest = objectStore.openCursor();
                      cursorRequest.onsuccess = function(event2) {
                        try {
                          const cursor = event2.target.result;
                          if (cursor) {
                            storeData.push({
                              key: cursor.key,
                              value: cursor.value
                            });
                            cursor.continue();
                          } else {
                            stores[storeName] = storeData;
                            pendingStores--;
                            if (pendingStores === 0) {
                              databases[dbName] = stores;
                              db2.close();
                              resolveDb();
                            }
                          }
                        } catch (error) {
                          console.error(`Error processing cursor for store ${storeName}:`, error);
                          stores[storeName] = { error: "Failed to process cursor" };
                          pendingStores--;
                          if (pendingStores === 0) {
                            databases[dbName] = stores;
                            db2.close();
                            resolveDb();
                          }
                        }
                      };
                      cursorRequest.onerror = function(event2) {
                        console.error(`Error opening cursor for store ${storeName}:`, event2);
                        stores[storeName] = { error: "Failed to read store" };
                        pendingStores--;
                        if (pendingStores === 0) {
                          databases[dbName] = stores;
                          db2.close();
                          resolveDb();
                        }
                      };
                    } catch (error) {
                      console.error(`Error processing store ${storeName}:`, error);
                      stores[storeName] = { error: "Failed to process store" };
                      pendingStores--;
                      if (pendingStores === 0) {
                        databases[dbName] = stores;
                        db2.close();
                        resolveDb();
                      }
                    }
                  });
                } catch (error) {
                  console.error(`Error processing database ${dbName}:`, error);
                  databases[dbName] = { error: "Failed to process database" };
                  resolveDb();
                }
              };
              dbRequest.onerror = function(event) {
                console.error(`Error opening database ${dbName}:`, event);
                databases[dbName] = { error: "Failed to open database" };
                resolveDb();
              };
            });
          }
        } catch (error) {
          console.error("Error processing databases:", error);
          resolve({ error: "Failed to process databases" });
        }
        resolve(databases);
      }).catch((error) => {
        console.error("Error listing databases:", error);
        resolve({ error: "Failed to list databases" });
      });
    });
  } catch (error) {
    console.error("Error in getAllIndexedDBData:", error);
    return { error: "Failed to access IndexedDB" };
  }
}
async function getAllStorageData() {
  try {
    const localStorageData = getAllLocalStorageData();
    const indexedDBData = await getAllIndexedDBData();
    return {
      localStorage: localStorageData,
      indexedDB: indexedDBData,
      timestamp: Date.now()
    };
  } catch (error) {
    console.error("Error getting all storage data:", error);
    return {
      error: "Failed to get storage data",
      timestamp: Date.now()
    };
  }
}
const common$c = { "show": "Vis", "newPost": "Nyt indlæg", "active": "Aktiv", "change": "Skift", "remove": "Ryd", "cancel": "Annuller", "publish": "Udgiv", "save": "Gem", "draft": "Kladde", "scheduled": "Planlagt", "published": "Udgivet", "actions": "Handlinger", "archive": "Arkiv", "delete": "Slet", "edit": "Rediger", "settings": "Indstillinger", "updatedOn": "Opdateret den", "blogPost": "Blogindlæg", "category": "Kategori", "author": "Forfatter", "status": "Status", "errors": "Fejl", "error": "Fejl", "all": "Alle", "add": "Tilføj", "discussion": "Diskussion", "allCourses": "Alle kurser", "myCourses": "Mine kurser", "learning": "Læring", "leaderboard": "Rangliste", "documentsAndPayments": "Filer & Dokument håndtering", "more": "Mere", "profile": "Profil", "archived": " Arkiveret", "back": "Tilbage", "restore": "Gendan denne version", "next": "Næste", "previous": "Forrige", "continue": "Fortsæt", "details": "Oplysninger", "youtube": "YouTube", "action": "Handling", "view": "Vis", "download": "Download", "source": "Kilde", "title_column": "Titel", "copy": "Kopiér", "viewReceipt": "Vis kvittering", "id": "ID", "location": "Placering", "email": "E-mail", "title": "Titel", "logout": "Log ud", "login": "Login", "calender": "Kalender", "apply": "Anvend", "clear": "Ryd", "to": "Til", "from": "Fra", "type": "Type", "home": "Start", "description": "Description", "updated": "Opdateret", "networkError": { "title": "Ingen internetforbindelse.", "message": "Kontrollér din internetforbindelse, og prøv igen." } };
const account$c = { "settings": "Kontoindstillinger", "updateSettings": "Opdater dine kontoindstillinger her", "paymentDetails": "Betalingsoplysninger", "orderId": "Internt ordre-ID", "nextInvoice": "Næste faktura", "transactionDate": "Transaktionsdato", "expiryDate": "Udløbsdato", "manageAllSubscription": "Administrer alle dine abonnementer", "paymentMethod": "Betalingsmetode", "andTransactionHere": "og transaktioner her" };
const wallet$c = { "transactionId": "Transaktions-ID" };
const support$c = { "subscriptionId": "Abonnements-ID", "email": { "validation": "Indtast en gyldig e-mailadresse" }, "invoiceNo": "Fakturanummer" };
const social$c = { "title": "Sociale medier", "invalidURL": "Ugyldig URL", "phoneNumber": "Telefonnummer", "userPhone": "Dit telefonnummer", "userEmail": "Din e-mailadresse", "info": "Oplysninger om Sociale medier", "update": "Opdater oplysninger om sociale medier", "detailsHere": "Opdater dine oplysninger om sociale medier her", "updated": "Dine Sociale medier er opdateret", "visibility": "Offentligt synlig", "validUrl": "Indtast en gyldig URL", "validEmail": "Indtast en gyldig e-mail", "validPhoneNumber": "Indtast et gyldigt telefonnummer med korrekt landekode", "platforms": { "twitter": "Twitter", "instagram": "Instagram", "facebook": "Facebook", "youtube": "YouTube", "linkedin": "LinkedIn" } };
const validation$c = { "phone": "Indtast et gyldigt telefonnummer", "url": "Indtast en gyldig URL" };
const forms$c = { "phone": "Telefonnummer" };
const auth$c = { "clickToResend": "Klik for at sende igen", "authentication": "Godkendelse", "didntGetCode": "Har du ikke fået en kode?", "confirmationCode": "Bekræftelseskode", "sentVerificationEmail": "Vi har sendt en bekræftelseskode via e-mail til", "authenticateAccount": "Bekræft din konto", "incorrectOrExpired": "Engangskoden er ugyldig eller udløbet", "failedToSend": "Det lykkedes ikke at sende engangskoden", "checkEmailForSecureCode": "Tjek din e-mail for den sikre kode. Hvis du ikke har modtaget nogen email fra os,", "user": "Bruger", "verify": "Bekræft", "tapHereToResend": "tryk her for at sende igen.", "failedToVerifyOtp": "Kunne ikke bekræfte engangskoden", "failedToGetOtp": "Kunne ikke modtage engangskoden" };
const billing$c = { "endingIn": "slutter den", "billingInformation": "Faktureringsoplysninger", "billingAddress": "Faktureringsadresse:", "sourceType": "Kildetype:", "invoices": "Fakturaer", "subscription": "Abonnement", "transactions": "Transaktioner", "transaction": "Transaktion", "subscriptions": "Abonnementer", "invoiceName": "Fakturanavn", "subscriptionName": "Abonnementsnavn", "dueDate": "Forfaldsdato", "issueDate": "Udstedelsesdato", "amount": "Beløb", "manageSubscriptions": "Administrer alle dine abonnementer", "andSubscription": "og abonnement", "andTransaction": "og transaktion her", "billing": "Fakturering", "startDate": "Startdato", "fullName": "Fulde navn", "nextInvoiceOn": "Næste faktura den", "noDataFound": "Der blev ikke fundet nogen data", "invoiceNo": "Fakturanr. :", "manageSubscriptionsInvoicesAndTransactions": "Administrer abonnementer, fakturaer og transaktioner", "created": "Oprettet:", "transactionName": "Transaktionsnavn", "tid": "Tid :", "transactionDate": "Transaktionsdato:", "trial": "Prøveversion", "expired": "Udløbet", "pastDue": "Forfalden", "unpaid": "Ubetalt", "incompleteExpired": "Ufuldstændig faktura udløbet", "canceled": "Annulleret", "incomplete": "Ufuldstændig", "failed": "Mislykkedes", "sent": "Sendt", "paid": "Betalt", "paymentProcessing": "Betaling behandles", "partiallyPaid": "Delvist betalt", "overdue": "Forfalden", "succeeded": "Lykkedes", "processing": "Behandler", "refunded": "Refunderet", "pending": "Afventer", "membership": "Medlemskab", "communities": "Fællesskaber", "paymentLink": "Betalingslink", "expiresOn": "Udløber den", "errorFetchingPaymentMethods": "Fejl ved hentning af betalingsmetoder", "pageUrl": "Side -URL" };
const transactions$c = { "title": "Transaktioner", "name": "Navn på transaktioner" };
const cancelModal$c = { "subscriptionRenewNotice": "Hvis du ombestemmer dig, kan du til enhver tid forny dit abonnement.", "cancelSubscription": "Annuller abonnement", "subscriptionCancelNotice": "bliver annulleret med det samme. Du vil ikke blive opkrævet igen.", "yourPlanName": "Din plan", "currentPlan": "Aktuel plan", "subscriptionCancelError": "Der opstod en fejl under forsøget på at annullere abonnementet.", "cancelSubscriptionFailed": "Annullering af abonnementet mislykkedes" };
const certificates$c = { "title": "Certifikater", "certificatesDescription": "Download og slet certifikater, du har optjent.", "subtitle": "Download dine certifikater", "completedOn": "Færdig Til", "back": "Tilbage", "previous": "Forrige", "next": "Næste", "downloadYourCertificates": "Download dine certifikater", "downloadCertificate": "Download {type}", "viewCertificates": "Vis og download alle dine certifikater her.", "certificateNotFound": "Intet certifikat fundet", "issuedOn": "Udstedt den", "expiresOn": "Udløber den", "description": "Beskrivelse", "yourCertificateHasExpiredOn": "Din {type} har Udløbet Til", "issuedCertificatesNotFound": "Du har ikke optjent nogen certifikater endnu.", "shareCertificate": "Dele:", "preview": { "issuedTo": "Udstedt til", "issuedBy": "Udstedt af", "addToLinkedin": "Tilføj til LinkedIn-profil", "download": "Download", "credentialVerification": "Bekræftelse af legitimationsoplysninger", "issueDate": "Udstedelsesdato", "expiryDate": "Udløbsdato", "verifyCredential": "Bekræfte legitimationsoplysninger", "shareYourCredential": "Del dine legitimationsoplysninger", "showYourCredential": "Vis dine legitimationsoplysninger på dine Sociale medier", "expiredOn": "Udløb den", "expiredDesc": "Det er tid til at forny Dem og holde Dem opdateret. Gå ikke glip af fortsatte fordele og Kundeemner.", "verificationModal": { "title": "Bekræftelse af legitimationsoplysninger", "subtitle": "Dette er den gyldige legitimationsoplysning.", "description": " Denne legitimationsoplysning blev udstedt på sikker vis. Alle de viste oplysninger er gyldige.", "step1": { "title": "Verificering af modtageren", "description": "Ejer af denne legitimation er {recipient}" }, "step2": { "title": "Bekræfter udstederen", "description": "Denne legitimation blev udstedt af  {issuer}" }, "step3": { "title": "Bekræftelse af ID for legitimationsoplysninger", "description": "Identifikatoren {credentialId} er unik og gyldig." } }, "notFound": { "title": "Ups! Certifikat blev ikke fundet", "description": "Det Certifikat, du forsøger at Vis, er ikke tilgængeligt.", "subtitle": "Kontakt udstederen for at få hjælp." } }, "share": { "title": "Dit Certifikat", "text": "hende er dit certifikat", "dialogTitle": "Slet Eller Arkiv dit certifikat" }, "listing": { "courseAssignmentName": "Kursus-/opgavenavn", "offlineCertification": "Offline certificering", "completionDate": "Slutdato", "expiryDate": "Udløbsdato", "type": "Type", "sourceName": "Kildenavn", "action": "Handling" } };
const changePassword$c = { "showPasswords": "Vis adgangskoder", "retypePassword": "Indtast adgangskoden igen", "newPassword": "Ny adgangskode", "confirmNewPassword": "Confirm New Password", "currentPassword": "Nuværende adgangskode", "emailId": "E-mail-adresse", "passwordMinLength": "Indtast en adgangskode på mindst 8 tegn", "editAccount": "Rediger konto", "loginEmail": "Login-e-mail", "loginInformation": "Loginoplysninger", "accountDetails": "Kontodetaljer", "accountDetailsUpdate": "Opdater dine kontooplysninger her", "accountInformation": "Kontooplysninger", "changePassword": "Skift adgangskode", "hidePasswordChange": "Skjul ændring af adgangskode", "selectPageError": "Prøv igen senere", "systemErrorOccurred": "Der opstod en fejl", "passwordEntryInvalid": "Ugyldig adgangskode", "passwordUpdateSuccess": "Adgangskode opdateret", "passwordLengthRequired": "Indtast en adgangskode på minimum 8 tegn", "passwordMinimumLength": "Indtast en adgangskode på minimum 8 tegn", "passwordFieldRequired": "Adgangskode er påkrævet", "password": "Adgangskode" };
const deleteAccount$c = { "title": "Slet Konto", "deleteAccountDescription": "Din konto deaktiveres midlertidigt og vil blive permanent slettet, hvis du ikke logger ind inden for de næste 7 dage.", "deleteAccountDescription2": "Hvis du vil beholde kontoen, skal du blot logge ind før fristen. Når den er slettet, kan dine data ikke gendannes.", "deleteAccountButton": "Ja, Slet Konto" };
const chats$c = { "viewAll": "Vis alle", "viewLess": "Vis mindre", "updatedPreference": "Præference opdateret", "chatSettings": "Chatindstillinger", "chats": "Chats", "chatSettingsDescription": "Vælg chatindstillinger for dine grupper og kontakter", "groups": "Grupper", "blockedUsers": "Blokerede brugere", "noGroups": "Ingen grupper", "controlUsers": "Administrer hvilke brugere, du ikke ønsker at chatte med.", "blockedConversations": "Blokerede samtaler", "noBlockedUsers": "Ingen blokerede brugere", "unblock": "Fjern blokering", "noUsersBlocked": "Ingen brugere er blokeret", "noGroupsJoined": "Du er ikke medlem af nogen grupper", "controlGroups": "Administrer, hvilke gruppemedlemmer der kan kontakte dig, ved at slå din chattilgængelighed til eller fra herunder. Du kan kun modtage beskeder fra medlemmer af den gruppe, du er en del af. " };
const payments$c = { "shareLink": "Del link", "paymentLink": "Betalingslink" };
const profileSettings$c = { "complete": "FULDFØRT", "editBasicInformation": "Rediger grundlæggende oplysninger", "writeAboutYourself": "Skriv noget om dig selv ...", "selectTimezone": "Vælg tidszone", "description": "Dette vil blive vist på din profil", "timezone": "Tidszone", "enterLocation": "Indtast placering", "exampleDescription": "Eksempel: Hej, jeg hedder Thomas Jensen, og jeg er fotograf.", "enterABriefDescription": "Indtast en kort beskrivelse", "bio": "Biografi", "profileSlugNotAvailable": "Profil-slug er ikke tilgængelig", "findAndShareProfile": "Find og del nemt din profil med en personlig URL-slug.", "profileSlug": "Profil-slug", "enterTitle": "Indtast titel", "enterFullName": "Indtast fulde navn", "basicDetails": "Grundlæggende oplysninger", "updateProfileDetails": "Opdater dine profiloplysninger her", "basicInformation": "Grundlæggende oplysninger", "updatedProfileSettings": "Opdaterede profilindstillinger", "uploadStatusCode": "Upload mislykkedes med statuskode", "imageTypeNotSupported": "Billedtypen understøttes ikke", "nameIsRequired": "Navn er påkrævet", "invalidName": "Ugyldigt navn", "profileImage0": "Profilbillede", "profileImage": "Profilbillede", "uploadSvgPngJpg": "Upload en JPG-, PNG- eller SVG-fil. Anbefalet billedformat 1:1", "profilesBuildConnection": "Profiler skaber tillid og skaber forbindelse til andre", "clientPortalNames": "Kundeportalen føles underlig uden ansigter og navne.", "completeYourProfile": "Færdiggør din profil", "uploadFailed": "Upload mislykkedes", "fileSizeTooLarge": "Filen er for stor", "invalidFileFormatType": "Ugyldigt filformat/-type.", "pleaseUploadImage": "Upload et billede af typen SVG, PNG, JPG eller JPEG.", "pleaseUploadAFileLessThan100Mb": "Upload en fil på mindre end 100 MB.", "oopsUnableToUploadImage": "Ups! Billedet kunne ikke uploades.", "selectPageError": "Prøv igen senere", "search": "Søg", "searchTimezones": "Søg efter tidszoner", "noTimezonesFound": "Der blev ikke fundet nogen tidszoner", "editDetails": "Rediger oplysninger", "profilePicture": "Profilbillede", "profileCover": "Profilcover", "uploadPhoto": "Upload foto", "removePhoto": "Ryd foto", "invalidAspectRatio": "Ugyldigt billedformat", "recommendedAspectRatio169": "Anbefalet billedformat 16:9", "recommendedAspectRatio11": "Anbefalet billedformat 1:1", "editProfile": "Rediger profil", "manageYourGroupDetailsHere": "Administrer dine gruppeoplysninger her", "profileIcon": "Profil-ikon", "specialCharactersNotSupported": "Specialtegn understøttes ikke.", "slugValidation": { "containSpecialCharacters": "Slug må ikke indeholde specialtegn", "tooShort": "Slug skal være mindst 3 tegn lang", "tooLong": "Slug må ikke være længere end 50 tegn", "containOnlyNumbers": "Slug kan ikke kun indeholde tal", "startWithNumber": "Slug kan ikke starte med et tal", "startWithHyphen": "Slug kan ikke starte med en bindestreg", "endWithHyphen": "Slug må ikke slutte med en bindestreg", "containDoubleHyphen": "Slug må ikke indeholde dobbelte bindestreger", "containSpace": "Slug kan ikke indeholde mellemrum" } };
const languageSettings$c = { "title": "Sprogindstillinger", "detailsHere": "Vælg sprog for kundeportalen", "selectLanguage": "Vælg sprog", "useLocationLanguage": "Brug sprog efter placering", "languagePreferenceUpdated": "Sprogpræference opdateret", "errorUpdatingLanguage": "Fejl under opdatering af sprog", "description": "Vælg dit foretrukne sprog til visning af kundeportal-elementer, fællesskabsindhold, kurser og tilknyttede oplysninger. Denne indstilling giver dig mulighed for at se indhold på det sprog, du er mest komfortabel med. ", "shortDescription": "Vælg dit foretrukne sprog" };
const userActivityOverview$c = { "dustBunnies": "Der er ikke noget at se, medmindre du er til nullermænd.", "welcomeBanner": "Velkommen til", "contracts": "Kontrakter", "hiUser": "Hej", "estimates": "Skøn", "sharedFiles": "Delte filer" };
const widget$c = { "viewAll": "Vis alle", "addedOn": "Tilføjet den", "by": "via", "you": "Du", "admin": "Admin", "youDoNotHaveAny": "Du har ikke nogen!", "noContracts": "Ingen kontrakter", "maxFilesExceeded": "Du kan højst uploade 10 filer", "uploadFile": "Upload fil", "userActivityOverview.contracts": "Kontrakter", "selectPageError": "Prøv igen senere", "notAbleToDownloadContract": "Kan ikke downloade kontrakten", "completeCourse": "Gennemfør kursus", "courseProgress": "Kursusfremskridt", "viewAllGroups": "Vis alle grupper", "recentlyOpened": "Senest åbnet", "noInvoices": "Ingen fakturaer", "noEstimates": "Ingen estimater", "notAbleToDownloadInvoice": "Kan ikke downloade faktura", "contracts": "Kontrakter", "invoices": "Fakturaer", "youMarked": "Du har markeret", "inCourse": "i gang", "invoice": "Faktura", "makePayment": "Opret betaling", "downloadInvoice": "Download faktura", "viewGroup": "Vis gruppe", "payment": "Betaling", "download": "Download", "signContract": "Underskriv aftale", "sign": "Underskriv", "estimates": "Skøn", "notAbleToDownloadEstimate": "Kan ikke downloade estimat", "addFiles": "Tilføj filer", "sharedFiles": "Delte filer", "fileManagement": "Fil", "noFiles": "Ingen filer" };
const dashboard$c = { "joinAGroup": "Deltag i en gruppe", "takeACourse": "Tag et kursus", "checkAffiliateEarnings": "Kontrollér affiliate-indtjening", "manageSubscriptions": "Administrer abonnementer", "contracts": "Kontrakter", "estimates": "Estimater", "sharedFiles": "Delte filer", "paidOn": "Betalt den", "partiallyPaidOn": "Delvist betalt den", "overdueSince": "Forfalden siden", "dueOn": "Forfalder den", "hello": "Hej", "viewGroup": "Vis gruppe", "recentlyOpened": "For nylig åbnet", "noItemsYet": "Du har ikke nogen endnu!", "affiliates": "Tilknyttede enheder", "exploreHere": "Udforsk her", "selectApp": "Vælg din app", "exploreCourses": "Udforsk de tilgængelige kurser", "courses": "Kurser", "engageCommunity": "Deltag i fællesskabet", "communities": "Fællesskaber", "noDataAvailable": "Ingen tilgængelige data på minuttet", "noAppsAvailable": "Ingen tilgængelige Apps", "noWidgetsAvailable": "Ingen widgets til Visning", "noContentAvailable": "Ingen tilgængelig Indhold" };
const uploadDocument$c = { "uploadHeader": "Tilføj filer", "uploadDescription": "Vælg og upload op til 10 dokumenter", "uploadWarning": "Dette er synligt for portaladministratoren til visning og download", "uploadInstruction": "Klik for at uploade, eller træk og slip", "allowedFiles": "DOC, PNG, JPG , GIF , PPT Eller PDF (maks.. 100 MB)", "cancelButton": "Annuller", "uploadButton": "Upload", "confirmDeletion": "Bekræft sletning", "deleteFile": "Slet fil", "deleteFileDescription": "Er du sikker på, at du vil slette denne fil? Denne handling kan ikke fortrydes.", "deleteFileButton": "Ja, slet fil", "deleteFileSuccessTitle": "Filen blev slettet", "deleteFileErrorTitle": "Fejl under sletning af fil", "deleteFileErrorMessage": "Der opstod en fejl under forsøg på at slette filen.", "cancel": "Annuller", "notAbleToDownloadFile": "Kunne ikke downloade fil", "fileSizeExceeded": "Filstørrelsen overstiger 100 MB", "invalidFileType": "Ugyldig filtype", "notAbleToUploadFile": "Kunne ikke uploade fil", "downloadError": "Fejl under download af fil", "fileUploadedSuccessfully": "Fil blev uploadet", "fileDownloadedSuccessfully": "Fil downloadet" };
const navbar$c = { "hi": "Hej", "manageYourAccount": "Administrer din konto", "logOut": "Log ud", "affiliates": "Tilknyttede enheder", "courses": "Kurser", "communities": "Fællesskaber" };
const mandatedInfoModal$c = { "invalidFileFormat": "Ugyldigt filformat/-type.", "pleaseUploadImage": "Upload et billede af typen SVG, PNG, JPG, JPEG", "fileSizeTooLarge": "Filen er for stor", "oopsUnableToUploadImage": "Ups! Billedet kunne ikke uploades.", "pleaseUploadFileLessThan100MB": "Upload en fil på mindre end 100 MB", "pleaseTryAgainLater": "Prøv igen senere", "completeYourProfile": "Færdiggør din profil", "profilesBuildConnection": "Profiler skaber tillid og skaber forbindelse til andre", "putAFaceToYourProfile": "Sæt et ansigt på din profil!", "uploadASVGPNGJPG": "Upload en SVG-, PNG- eller JPG-fil.", "recommendedAspectRatio11": "Anbefalet billedformat 1:1", "complete": "FULDFØRT", "cropYourAvatar": "Beskær din avatar", "dragToReposition": "Træk for at flytte" };
const sideBar$c = { "languageSettings": "Sprogindstillinger", "profile": "Profil", "account": "Konto", "socialMedia": "Sociale medier", "certificates": "Certifikater", "billingSubscription": "Fakturering og abonnement", "communitiesChats": "Fællesskaber og chats", "affiliates": "Tilknyttede enheder", "notifications": "Notifikationer" };
const notifications$c = { "title": "Notifikationer", "all": "Alle", "unread": "Ulæst", "markAllRead": "Markér alle som læst", "noNotifications": "Ingen notifikationer endnu", "whenYouGetNotifications": "Når du får notifikationer, vises de her" };
const affiliates$c = { "payoutMethod": "Udbetalingsmetode", "leadCustomer": "Kundeemner/ Kunder", "commissions": "Provisioner", "description": "Henvis brugere til GoKollab", "title": "Tilknyttede enheder", "groupsGoKollab": "Oprettelse af grupper på GoKollab er helt gratis, men det er kun begyndelsen! Spændende nye funktioner er på vej til at hjælpe dig med at udvide din onlinevirksomhed og øge din indtjening. Når brugere opgraderer for at låse op for hele funktionspakken, vil du modtage en livslang tilbagevendende affiliate-kommission for deres abonnement. Jo før du begynder at henvise, jo bedre – gå ikke glip af dette utrolige affiliateprogram", "yourAffiliateLink": "Dit affiliate-link" };
const deleteCard$c = { "deleteCard": "Slet kort", "description": "Betalingsmetoden vil ikke længere kunne anvendes, efter at den er fjernet. Denne handling kan ikke fortrydes.", "activeCard": "Dette kort bruges til en eller flere aktive abonnementsbetalinger. Hvis du sletter dette kort uden at opdatere betalingsmetoden for de tilknyttede abonnementer, vil det påvirke fremtidige betalinger. Er du sikker på, at du vil slette dette kort?", "title": "Ryd betalingsmetode?", "cardCannotBeDeleted": "Kortet kan ikke slettes", "cardIsLinkedToSubscriptions": "Kortet er tilknyttet abonnementer", "errorInDeletingCard": "Fejl ved sletning af kort", "noCardAvailable": "Ingen tilgængelige kort", "cardRemovedSuccessfully": "Kortet blev fjernet." };
const notificationPreferences$c = { "title": "Notifikationspræferencer", "description": "Administrer, hvornår og hvad, du bliver påmindet om", "pushNotificationsTitle": "Push-Notifikationer", "pushNotificationsDescription": "Administrer push-notifikationer", "emailNotificationsTitle": "E-mailnotifikationer", "emailNotificationsDescription": "Administrer e-mailnotifikationer", "emailNotifications": "E-mailnotifikationer", "manageEmailNotifications": "Administrer e-mailnotifikationer", "newActivity": "Ny aktivitet", "email": "E-mail", "push": "Push", "allNotifications": "Alle notifikationer", "postTags": "Ved 'Tag' i opslag ", "postEveryoneTagged": "Ved {'@'}alle i opslag", "postMention": "Ved {'@'}mention i opslag", "postLike": "Ved 'Like' af opslag", "newComment": "Ny kommentar", "commentEveryoneTagged": "Ved {'@'}alle i kommentar", "commentMention": "Ved {'@'} mention i kommentaer", "commentLike": "Ved 'Like' af kommentar", "postEveryoneTaggedMobile": "Ved {'@'}alle i opslag", "postMentionMobile": "Ved {'@'}mention i opslag", "commentEveryoneTaggedMobile": "Ved {'@'}alle i kommentar", "commentMentionMobile": "Ved {'@'}mention", "newMemberRequestToJoinGroup": "Forespørgsel fra nyt medlem om at deltage i gruppen", "groupJoiningRequestApproved": "Forespørgsel om at deltage i gruppe - Accepteret", "groupJoiningRequestRejected": "Forespørgsel om at deltage i gruppe - Afvist", "roleUpdatedInPrivateChannel": "Rolle opdateret i privat kanal", "newCourseAvailable": "Nyt kursus tilføjet til gruppen", "newEventCreated": "Ny begivenhed oprettet", "newCourseComment": "Ny kursuskommentar", "certificateIssued": "Certifikat udstedt", "postEveryoneTaggedDescription": "Når nogen bruger {'@'}alle", "postMentionDescription": "Når nogen bruger {'@'}mention", "postLikeDescription": "Når nogen synes godt om dit Like", "newCommentDescription": "Når nogen kommenterer din deling", "commentEveryoneTaggedDescription": "Når nogen kommenterer på {'@'}alle", "commentMentionDescription": "Når nogen kommenterer {'@'}mention", "commentLikeDescription": "Når nogen synes godt om din kommentar", "newMemberRequestToJoinGroupDescription": "Når nogen forespørger på at deltage i gruppen", "groupJoiningRequestApprovedDescription": "Når nogens gruppe, der deltager i forespørgsler, er accepteret", "groupJoiningRequestRejectedDescription": "Når nogens gruppe, der deltager i forespørgsler, er afvist", "roleUpdatedInPrivateChannelDescription": "Når en persons rolle opdateres i en privat kanal", "newCourseAvailableDescription": "Når et nyt kursus er tilgængeligt", "newEventCreatedDescription": "Når en ny begivenhed oprettes", "newCourseCommentDescription": "Når nogen giver feedback til et kursus", "certificateIssuedDescription": "Når et certifikat er udstedt", "estimateReceivedDescription": "Når et nyt estimat er modtaget", "contractReceivedDescription": "Når en ny kontrakt er modtaget", "invoiceReceivedDescription": "Når en ny faktura er modtaget", "allEmailNotificationsDescription": "Aktiver/deaktiver alle email-notifikationer", "allPushNotificationsDescription": "Aktiver/deaktiver alle push-notifikationer", "errorUpdating": "Der opstod en fejl under opdatering af dine notifikationsindstillinger", "updateSuccess": "Dine notifikationsindstillinger er blevet opdateret", "willNotReceiveNotificationsIfAdminDisabled": "Du vil ikke modtage notifikationer for begivenheder, som din administrator har deaktiveret.", "estimateReceived": "Nyt estimat modtaget", "contractReceived": "Ny kontrakt modtaget", "invoiceReceived": "Ny faktura modtaget", "pushNotificationNotAvailable": "Push-notifikationer er ikke tilgængelig for denne begivenhed", "newsletter": "Nyhedsbrev", "emailNotificationNotAvailable": "E-mail-Notifikation er ikke tilgængelig for denne begivenhed", "newPostFollowers": "Nyt opslag fra en bruger, jeg følger", "newPostFollowersDescription": "Få besked, når en person, du følger, opretter et nyt opslag.", "newFollower": "Få besked, når nogen følger dig." };
const loginPage$c = { "forgotPassword": "Glemt adgangskode?", "login": "Log ind", "lastLogin": "sidste Log ind", "proceedToLogin": "Fortsæt til login", "secureCode": "Sikker kode", "newUser": "Ny bruger?", "resetPasswordLink": "Hvis den indtastede e-mail er korrekt, modtager du et link til nulstilling af adgangskode i mailen. Husk også at tjekke din spammappe.", "loginWithSecureCode": "Log ind med sikker kode", "signUp": "Tilmeld dig", "enterOtp": "Indtast engangskode", "selectAccount": "Vælg, hvilken Konto Du vil", "resetPassword": "Nulstil adgangskode", "selectUser": "Vælg bruger", "emailRequired": "Indtast en gyldig e-mail", "fullNameRequired": "Indtast dit navn", "passwordRequired": "Indtast en adgangskode på mindst 8 tegn", "generateSecureCode": "Generér sikker kode", "loginWithPassword": "Log ind med adgangskode", "secureCodeEmail": "Angiv din e-mail for at få den sikre kode. Hvis du ikke har modtaget en e-mail fra os,", "resendOtp": "tryk her for at sende igen.", "verifySecureCode": "Bekræft sikker kode", "secureCodeNumeric": "Den sikre kode skal være numerisk og bestå af 6 cifre", "alreadyHaveAccount": "Har du allerede en konto?", "email": "E-mail", "password": "Adgangskode", "fullName": "Fulde navn", "somethingWentWrong": "Der opstod en fejl", "signInWithEmail": "Eller log ind med din e-mail", "signUpWithEmail": "Eller tilmeld dig med din e-mail", "confirmPassword": "Bekræft adgangskode", "validationErrors": { "potentialSpamUser": { "title": "Konto Privat", "message": "Din konto har været Privat Skyldte for at potentiel spam Aktivitet. Kontakt support for at få hjælp." }, "somethingWentWrong": { "title": "Der opstod en fejl", "message": "Kunne ikke logge ind. Prøv igen senere." }, "bannedUser": { "title": "Konto Privat", "message": "Din konto er blevet Udelukket Skyldte til potentiel spam Aktivitet. Kontakt support for at få hjælp." } } };
const magicLink$c = { "newLinkSent": "Nyt link sendt", "portalWillSendLink": "Portalen har sendt et nyt link til din e-mailadresse", "failedToSendNewLink": "Kunne ikke sende linket", "pleaseTryAgain": "Prøv igen", "linkExpired": "Dette link fra din e-mail er udløbet.", "toContinue": "For at fortsætte skal du anmode om et nyt link eller logge ind på din portal", "sendNewLink": "SEND NYT LINK", "logIn": "Log ind", "clickToLogIn": "Klik her for at logge ind på din portal", "invalidToken": "Dette token fra din e-mail er ugyldigt.", "toContinueContactAdmin": "For at fortsætte skal du anmode om et nyt magisk link, kontakte en administrator eller logge ind på din portal" };
const setPassword$c = { "minLength": "Indtast en adgangskode på mindst 8 tegn", "passwordsMustMatch": "Adgangskoder skal matche", "setSecurePassword": "Vælg din sikre adgangskode", "setPasswordButton": "Angiv adgangskode" };
const alerts$c = { "tooManyAttempts": { "title": "For mange forsøg", "message": "Der er kun tilladt at lave højst 2 forsøg på slug-opdatering inden for en måned" }, "slugAlreadyExists": { "title": "Slug findes allerede", "message": "Prøv en anden Slug" }, "updateSlugError": { "title": "Der opstod en fejl", "message": "Kunne ikke opdatere profilslug. Prøv igen senere." }, "updateProfileError": { "title": "Der opstod en fejl", "message": "Profiloplysningerne kunne ikke opdateres. Prøv igen senere." } };
const bottomNavBar$c = { "home": "Start", "discover": "Opdage", "communities": "Fællesskaber", "courses": "Kurser", "more": "Mere" };
const forceUpdate$c = { "title": "Opdatering er tilgængelig", "description": "Opdater appen til den nyeste version", "buttonText": "Opdater nu!" };
const accessibility$c = { "copyAffiliateLink": "Kopiér affiliate-link til udklipsholderen", "deleteCard": "Slet kort", "appSwitcher": "Omskifter", "portalImage": "Portalbillede", "profileImage": "Profilbillede", "continueWithGoogle": "Fortsæt med Google" };
const resetPassword$c = { "passwordExpired": "Dit link til nulstilling af adgangskode er udløbet.", "regenerateLink": "Gendan link", "proceedToLogin": "Fortsæt til login", "passwordChangedSuccessfully": "Adgangskoden blev ændret", "changePassword": "Ændr adgangskode", "newPassword": "Indtast en adgangskode på mindst 8 tegn", "confirmPassword": "Adgangskoderne stemmer ikke overens", "setNewPassword": "Angiv ny adgangskode", "confirmNewPassword": "Bekræft ny adgangskode" };
const da = {
  common: common$c,
  account: account$c,
  wallet: wallet$c,
  support: support$c,
  social: social$c,
  validation: validation$c,
  forms: forms$c,
  auth: auth$c,
  billing: billing$c,
  transactions: transactions$c,
  cancelModal: cancelModal$c,
  certificates: certificates$c,
  changePassword: changePassword$c,
  deleteAccount: deleteAccount$c,
  chats: chats$c,
  payments: payments$c,
  profileSettings: profileSettings$c,
  languageSettings: languageSettings$c,
  userActivityOverview: userActivityOverview$c,
  widget: widget$c,
  dashboard: dashboard$c,
  uploadDocument: uploadDocument$c,
  navbar: navbar$c,
  mandatedInfoModal: mandatedInfoModal$c,
  sideBar: sideBar$c,
  notifications: notifications$c,
  affiliates: affiliates$c,
  deleteCard: deleteCard$c,
  notificationPreferences: notificationPreferences$c,
  loginPage: loginPage$c,
  magicLink: magicLink$c,
  setPassword: setPassword$c,
  alerts: alerts$c,
  bottomNavBar: bottomNavBar$c,
  forceUpdate: forceUpdate$c,
  accessibility: accessibility$c,
  resetPassword: resetPassword$c
};
const common$b = { "show": "Anzeigen", "newPost": "Neuer Post", "active": "Aktiv", "change": "Ändern", "remove": "Entfernen", "cancel": "Stornieren", "publish": "Veröffentlichen", "save": "Speichern", "draft": "Entwurf", "scheduled": "Geplant", "published": "Veröffentlicht", "actions": "Aktionen", "archive": "Archiv", "delete": "Löschen", "edit": "Bearbeiten", "settings": "Einstellungen", "updatedOn": "Aktualisiert am", "blogPost": "Blog-Post", "category": "Kategorie", "author": "Verfasser", "status": "Status", "errors": "Fehler", "error": "Fehler", "all": "Alle", "add": "Hinzufügen", "discussion": "Opslag", "allCourses": "Alle Kurse", "myCourses": "Meine Kurse", "learning": "Lernen", "leaderboard": "Bestenliste", "documentsAndPayments": "Dokumenten- und Dateiverwaltung", "more": "Mehr", "profile": "Profil", "archived": " Archiviert", "back": "Zurück", "restore": "Diese Version wiederherstellen", "next": "Nächste", "previous": "Vorherige", "continue": "Weiter", "details": "Details", "youtube": "Youtube", "action": "Aktion", "view": "Ansicht", "download": "Herunterladen", "source": "Quelle", "title_column": "Titel", "copy": "Kopieren", "viewReceipt": "Beleg anzeigen", "id": "ID", "location": "Ort", "email": "E-Mail", "title": "Titel", "logout": "Abmelden", "login": "Login", "calender": "Kalender", "apply": "Anwenden", "clear": "Klären", "to": "An", "from": "Von", "type": "Typ", "home": "Startseite", "description": "Description", "updated": "Aktualisiert", "networkError": { "title": "Keine Internetverbindung", "message": "Bitte überprüfen Sie Ihre Internetverbindung und versuchen Sie es erneut." } };
const account$b = { "settings": "Kontoeinstellungen", "updateSettings": "Aktualisieren Sie hier Ihre Kontoeinstellungen", "paymentDetails": "Zahlungsdetails", "orderId": "Interne Auftrags-ID", "nextInvoice": "Nächste Rechnung", "transactionDate": "Datum der Transaktion", "expiryDate": "Ablaufdatum", "manageAllSubscription": "Verwalten Sie alle Ihre Abonnements", "paymentMethod": "Zahlungsmethode", "andTransactionHere": "& Transaktion hier" };
const wallet$b = { "transactionId": "Transaktions-ID" };
const support$b = { "subscriptionId": "Abonnement-ID", "email": { "validation": "Gültige E-Mail eingeben" }, "invoiceNo": "Rechnungsnummer" };
const social$b = { "title": "Soziale Medien", "invalidURL": "Ungültige URL", "phoneNumber": "Telefonnummer", "userPhone": "Benutzertelefon", "userEmail": "Benutzer-Email", "info": "Informationen in den sozialen Medien", "update": "Soziale Medien-Informationen aktualisieren", "detailsHere": "Aktualisieren Sie hier die Details Ihrer sozialen Medien", "updated": "Aktualisierte soziale Medien", "visibility": "Öffentlich sichtbar", "validUrl": "Bitte eine gültige URL eingeben", "validEmail": "Bitte geben Sie eine gültige E-Mail-Adresse ein", "validPhoneNumber": "Bitte geben Sie eine gültige Telefonnummer mit einer entsprechenden Landesvorwahl ein.", "platforms": { "twitter": "Twitter", "instagram": "Instagram", "facebook": "Facebook", "youtube": "Youtube", "linkedin": "LinkedIn" } };
const validation$b = { "phone": "Geben Sie eine gültige Telefonnummer ein", "url": "Geben Sie eine gültige URL ein" };
const forms$b = { "phone": "Telefonnummer" };
const auth$b = { "clickToResend": "Zum erneuten Senden hier klicken", "authentication": "Authentifizierung", "didntGetCode": "Sie haben keinen Code erhalten?", "confirmationCode": "Bestätigungscode", "sentVerificationEmail": "Wir haben Ihnen einen Verifizierungscode per E-Mail gesendet an", "authenticateAccount": "Authentifizieren Sie Ihr Konto", "incorrectOrExpired": "Otp ist ungültig oder abgelaufen", "failedToSend": "Das Senden des OTP ist fehlgeschlagen", "checkEmailForSecureCode": "Bitte überprüfen Sie Ihre E-Mail auf den Sicherheitscode. Wenn Sie keine E-Mail von uns erhalten haben,", "user": "Benutzer", "verify": "Überprüfen", "tapHereToResend": "tippen Sie zum erneuten Senden hier.", "failedToVerifyOtp": "Die Verifizierung des OTP ist fehlgeschlagen", "failedToGetOtp": "Das Abrufen des OTP ist fehlgeschlagen" };
const billing$b = { "endingIn": "endet in", "billingInformation": "Abrechnungsdetails", "billingAddress": "Rechnungsadresse:", "sourceType": "Quellentyp:", "invoices": "Rechnungen", "subscription": "Abonnement", "transactions": "Transaktionen", "transaction": "Transaktionen", "subscriptions": "Abonnements", "invoiceName": "Rechnungsname", "subscriptionName": "Abonnementname", "dueDate": "Fälligkeitsdatum", "issueDate": "Ausstellungsdatum", "amount": "Betrag", "manageSubscriptions": "Verwalten Sie alle Ihre Abonnements", "andSubscription": "& Abonnement", "andTransaction": "und Transaktionen hier", "billing": "Abrechnung", "startDate": "Startdatum", "fullName": "Vollständiger Name", "nextInvoiceOn": "Nächste Rechnung am", "noDataFound": "Keine Daten gefunden", "invoiceNo": "Rechnung Nr. :", "manageSubscriptionsInvoicesAndTransactions": "Verwalten Sie Abonnements, Rechnungen und Transaktionen", "created": "Erstellt:", "transactionName": "Transaktionsname", "tid": "Zeit :", "transactionDate": "Transaktionsdatum:", "trial": "Trial", "expired": "Abgelaufen", "pastDue": "Überfällig", "unpaid": "Unbezahlt", "incompleteExpired": "Unvollständig Abgelaufen", "canceled": "Abgesagt", "incomplete": "Unvollständig", "failed": "Fehlgeschlagen", "sent": "Gesendet", "paid": "Bezahlt", "paymentProcessing": "Zahlungsabwicklung", "partiallyPaid": "Teilweise bezahlt", "overdue": "Überfällig", "succeeded": "Erfolgreich", "processing": "Verarbeitung", "refunded": "Erstattet", "pending": "Anhängig", "membership": "Mitgliedschaft", "communities": "Communitys", "paymentLink": "Zahlungslink", "expiresOn": "Läuft ab am", "errorFetchingPaymentMethods": "Fehler beim Abrufen der Zahlungsmethoden", "pageUrl": "Seite -URL" };
const transactions$b = { "title": "Transaktionen", "name": "Transaktionsname" };
const cancelModal$b = { "subscriptionRenewNotice": "Falls Sie Ihre Meinung ändern, können Sie Ihr Abonnement jederzeit erneuern.", "cancelSubscription": "Abonnement kündigen", "subscriptionCancelNotice": "wird sofort storniert. Es entstehen Ihnen keine weiteren Kosten.", "yourPlanName": "Ihr Zeitplan", "currentPlan": "Derzeitiger Plan", "subscriptionCancelError": "Beim Versuch, das Abonnement zu kündigen, ist ein Fehler aufgetreten.", "cancelSubscriptionFailed": "Kündigung des Abonnements fehlgeschlagen" };
const certificates$b = { "title": "Zertifikate", "certificatesDescription": "Laden Sie die Zertifikate Herunterladen und teilen Sie sie.", "subtitle": "Herunterladen Ihre Zertifikate herunter", "completedOn": "Erledigt An", "back": "Zurück", "previous": "Vorherige", "next": "Nächste", "downloadYourCertificates": "Laden Sie Ihre Zertifikate herunter", "downloadCertificate": "Herunterladen {type}", "viewCertificates": "Sehen Sie sich hier alle Ihre Zertifikate an und laden Sie sie herunter.", "certificateNotFound": "Kein Zertifikat gefunden", "issuedOn": "Ausgestellt An", "expiresOn": "Läuft ab An", "description": "Beschreibung", "yourCertificateHasExpiredOn": "Ihr {type} ist abgelaufen", "issuedCertificatesNotFound": "Sie haben noch keine Zertifikate erhalten.", "shareCertificate": "teilen:", "preview": { "issuedTo": "Ausgestellt an", "issuedBy": "Ausgestellt von", "addToLinkedin": "Zum LinkedIn Profil hinzufügen", "download": "Herunterladen", "credentialVerification": "Verifizierung der Anmeldeinformationen", "issueDate": "Ausstellungsdatum", "expiryDate": "Ablaufdatum", "verifyCredential": "Anmeldeinformationen Überprüfen", "shareYourCredential": "Teilen Sie Ihre Zugangsdaten", "showYourCredential": "Zeigen Sie Ihre Anmeldeinformationen in Ihren sozialen Medien an", "expiredOn": "Abgelaufen am", "expiredDesc": "Es ist an der Zeit, zu erneuern und auf dem neuesten Stand zu bleiben. Verpassen Sie nicht die fortlaufenden Vorteile und Interessenten.", "verificationModal": { "title": "Verifizierung der Anmeldeinformationen", "subtitle": "Dies ist das gültige Berechtigungsnachweis.", "description": " Dieses Berechtigungsnachweis wurde sicher ausgestellt. Alle angezeigten Informationen sind gültig.", "step1": { "title": "Empfänger wird überprüft", "description": "Der Eigentümer dieses Berechtigungsnachweises ist {recipient}" }, "step2": { "title": "Überprüfung des Herausgebers", "description": "Diese Anmeldeinformation wurde von  {issuer}ausgestellt." }, "step3": { "title": "Überprüfung der Berechtigungsnachweis-ID", "description": "Das Label {credentialId} ist eindeutig und gültig." } }, "notFound": { "title": "Oops! Zertifikat nicht gefunden.", "description": "Das Zertifikat, das Sie versuchen anzusehen, ist nicht verfügbar.", "subtitle": "Wenden Sie sich an den Herausgeber, um Unterstützung zu erhalten." } }, "share": { "title": "Ihr Zertifikat", "text": "hier ist Ihr Zertifikat", "dialogTitle": "teilen oder Archivieren Sie Ihr Zertifikat" }, "listing": { "courseAssignmentName": "Kurs-/ Name", "offlineCertification": "Offline-Zifizierung", "completionDate": "Enddatum", "expiryDate": "Ablaufdatum Datum", "type": "eintippen", "sourceName": "Quelle", "action": "Aktion" } };
const changePassword$b = { "showPasswords": "Passwörter anzeigen", "retypePassword": "Passwort erneut eingeben", "newPassword": "Neues Kennwort", "confirmNewPassword": "Confirm New Password", "currentPassword": "Aktuelles Kennwort", "emailId": "E-Mail-ID", "passwordMinLength": "Bitte geben Sie ein Kennwort mit mindestens 8 Zeichen ein.", "editAccount": "Konto bearbeiten", "loginEmail": "Login-E-Mail", "loginInformation": "Login-Informationen", "accountDetails": "Kontodetails", "accountDetailsUpdate": "Aktualisieren Sie hier Ihre Kontodetails", "accountInformation": "Kontoinformationen", "changePassword": "Kennwort ändern", "hidePasswordChange": "Kennwort ändern ausblenden", "selectPageError": "Bitte versuchen Sie es später erneut.", "systemErrorOccurred": "Etwas ist schiefgelaufen", "passwordEntryInvalid": "Ungültiges Kennwort", "passwordUpdateSuccess": "Kennwort wurde aktualisiert", "passwordLengthRequired": "Bitte geben Sie ein Kennwort mit mindestens 8 Zeichen ein.", "passwordMinimumLength": "Bitte geben Sie ein Kennwort mit mindestens 8 Zeichen ein.", "passwordFieldRequired": "Kennwort ist erforderlich", "password": "Kennwort" };
const deleteAccount$b = { "title": "Konto Löschen", "deleteAccountDescription": "Ihr Konto ist zur vorübergehenden Deaktivierung geplant und wird dauerhaft gelöscht, falls Sie sich nicht innerhalb der nächsten 7 Tage in .", "deleteAccountDescription2": "Um Ihr Konto Dynamisch zu halten, in Sie sich einfach vor dem Termin an. Sind sie einmal gelöscht, können Ihre Daten nicht wiederhergestellt werden.", "deleteAccountButton": "Ja , Konto Löschen" };
const chats$b = { "viewAll": "Alle anzeigen", "viewLess": "Weniger anzeigen", "updatedPreference": "Aktualisierte Präferenz", "chatSettings": "Chat-Einstellungen", "chats": "Chats", "chatSettingsDescription": "Wählen Sie Chat-Einstellungen für Ihre Gruppen und Kontakte", "groups": "Gruppen", "blockedUsers": "Blockierte Benutzer", "noGroups": "Keine Gruppen", "controlUsers": "Verwalten Sie, mit welchen Benutzern Sie nicht chatten möchten.", "blockedConversations": "Blockierte Konversationen", "noBlockedUsers": "Keine blockierten Benutzer", "unblock": "Entsperren", "noUsersBlocked": "Keine Benutzer blockiert", "noGroupsJoined": "Keine Gruppen beigetreten", "controlGroups": "Verwalten Sie, welche Gruppenbenutzer Sie kontaktieren können, indem Sie die Verfügbarkeit Ihres Chats unten ein- oder ausschalten. Sie können Nachrichten nur von Mitgliedern der Community erhalten, der Sie angehören. " };
const payments$b = { "shareLink": "Link teilen", "paymentLink": "Zahlungslink" };
const profileSettings$b = { "complete": "VOLLSTÄNDIG", "editBasicInformation": "Basisinformationen bearbeiten", "writeAboutYourself": "Schreiben Sie etwas über sich selbst …", "selectTimezone": "Zeitzone auswählen", "description": "Dies wird in Ihrem Profil angezeigt", "timezone": "Zeitzone", "enterLocation": "Ort eingeben", "exampleDescription": "Model: Hallo, ich bin Max Müller und ich bin Fotograf", "enterABriefDescription": "Geben Sie eine kurze Beschreibung ein", "bio": "Biografie", "profileSlugNotAvailable": "Profil-Slug nicht verfügbar", "findAndShareProfile": "Finden und teilen Sie Ihr Profil ganz einfach mit einem personalisierten URL-Slug.", "profileSlug": "Profil-Slug", "enterTitle": "Titel eingeben", "enterFullName": "Geben Sie den vollständigen Namen ein", "basicDetails": "Grundlegende Details", "updateProfileDetails": "Aktualisieren Sie hier Ihre Profildaten", "basicInformation": "Basisinformationen", "updatedProfileSettings": "Aktualisierte Profileinstellungen", "uploadStatusCode": "Upload mit Statuscode fehlgeschlagen", "imageTypeNotSupported": "Bildtyp wird nicht unterstützt", "nameIsRequired": "Name ist erforderlich", "invalidName": "Ungültiger Name", "profileImage0": "Profilbild", "profileImage": "Profilbild", "uploadSvgPngJpg": "Laden Sie eine SVG-, PNG- oder JPG-Datei hoch. Empfohlenes Seitenverhältnis 1:1", "profilesBuildConnection": "Profile schaffen Vertrauen und knüpfen Verbindungen zu anderen", "clientPortalNames": "Das Kundenportal fühlt sich ohne Gesichter und Namen seltsam an.", "completeYourProfile": "Ihr Profil vervollständigen", "uploadFailed": "Upload fehlgeschlagen", "fileSizeTooLarge": "Die Datei ist zu groß.", "invalidFileFormatType": "Ungültiges Dateiformat/ungültiger Dateityp.", "pleaseUploadImage": "Bitte laden Sie ein Bild im Format SVG, PNG, JPG oder JPEG hoch.", "pleaseUploadAFileLessThan100Mb": "Bitte laden Sie eine Datei mit einer Größe von weniger als 100 MB hoch.", "oopsUnableToUploadImage": "Oops! Foto kann nicht hochgeladen werden.", "selectPageError": "Bitte versuchen Sie es später erneut.", "search": "Suchen", "searchTimezones": "Zeitzonen suchen", "noTimezonesFound": "Keine Zeitzonen gefunden.", "editDetails": "Details bearbeiten", "profilePicture": "Profilbild", "profileCover": "Profil-Cover", "uploadPhoto": "Foto Upload", "removePhoto": "Foto entfernen", "invalidAspectRatio": "Ungültiges Seitenverhältnis", "recommendedAspectRatio169": "Empfohlenes Seitenverhältnis 16:9", "recommendedAspectRatio11": "Empfohlenes Seitenverhältnis 1:1", "editProfile": "Profil bearbeiten", "manageYourGroupDetailsHere": "Verwalten Sie hier Ihre Gruppendetails", "profileIcon": "Profil-Symbol", "specialCharactersNotSupported": "Sonderzeichen werden nicht unterstützt", "slugValidation": { "containSpecialCharacters": "Slug keine speziellen Zeichen enthalten", "tooShort": "Der Slug muss mindestens 3 Zeichen lang sein", "tooLong": "Der Slug muss weniger als 50 Zeichen lang sein", "containOnlyNumbers": "Slug kann nicht nur Zahlen enthalten", "startWithNumber": "Slug kann nicht mit einer Nummer beginnen", "startWithHyphen": "Slug kann nicht mit einem Trennzeichen beginnen", "endWithHyphen": "Slug kann nicht mit einem Trennzeichen enden", "containDoubleHyphen": "Slug darf keine doppelten Trennzeichen enthalten", "containSpace": "Slug darf Platz nicht enthalten" } };
const languageSettings$b = { "title": "Spracheinstellungen", "detailsHere": "Wählen Sie die Sprache des Kundenportals aus.", "selectLanguage": "Sprache auswählen", "useLocationLanguage": "Verwenden Sie Standort Sprache", "languagePreferenceUpdated": "Spracheinstellung aktualisiert", "errorUpdatingLanguage": "Fehler beim Aktualisieren der Sprache", "description": "Wählen Sie Ihre bevorzugte Sprache für die Anzeige von Client-Portal-Elementen, Community-Inhalten, Kursen und Affiliate-Informationen aus. Diese Einstellung ermöglicht es Ihnen, Inhalte in der Sprache anzuzeigen, mit der Sie sich am wohlsten fühlen. ", "shortDescription": "Wählen Sie Ihre bevorzugte Sprache aus." };
const userActivityOverview$b = { "dustBunnies": "Nichts zu sehen, es sei denn, Sie stehen auf Staubflusen.", "welcomeBanner": "Willkommen bei", "contracts": "Verträge", "hiUser": "Hallo", "estimates": "Schätzungen", "sharedFiles": "Geteilte Dateien" };
const widget$b = { "viewAll": "Alle anzeigen", "addedOn": "Hinzugefügt am", "by": "Via", "you": "Sie", "admin": "Admin", "youDoNotHaveAny": "Sie haben keine!", "noContracts": "Keine Verträge", "maxFilesExceeded": "Sie können nur bis zu 10 Dateien Upload", "uploadFile": "File Upload", "userActivityOverview.contracts": "Verträge", "selectPageError": "Bitte versuchen Sie es später erneut.", "notAbleToDownloadContract": "Der Vertrag kann nicht heruntergeladen werden", "completeCourse": "Kurs beenden", "courseProgress": "Kursfortschritt", "viewAllGroups": "Alle Gruppen anzeigen", "recentlyOpened": "Kürzlich eröffnet", "noInvoices": "Keine Rechnungen", "noEstimates": "Keine Schätzungen", "notAbleToDownloadInvoice": "Rechnung kann nicht heruntergeladen werden", "contracts": "Verträge", "invoices": "Rechnungen", "youMarked": "Sie haben markiert", "inCourse": "im Gange", "invoice": "Rechnung", "makePayment": "Zahlung vornehmen", "downloadInvoice": "Rechnung herunterladen", "viewGroup": "Gruppe anzeigen", "payment": "Zahlung", "download": "Herunterladen", "signContract": "Vertrag unterzeichnen", "sign": "Zeichen", "estimates": "Schätzungen", "notAbleToDownloadEstimate": "Schätzung kann nicht heruntergeladen werden", "addFiles": "Dateien Hinzufügen", "sharedFiles": "Geteilte Dateien", "fileManagement": "File", "noFiles": "Keine Dateien" };
const dashboard$b = { "joinAGroup": "Einer Gruppe beitreten", "takeACourse": "Nehmen Sie an einem Kurs teil", "checkAffiliateEarnings": "Überprüfen Sie die Affiliate-Einnahmen", "manageSubscriptions": "Abonnements verwalten", "contracts": "Vertrage", "estimates": "Schätzungen", "sharedFiles": "Geteilte Dateien", "paidOn": "Bezahlt am", "partiallyPaidOn": "Teilweise bezahlt am", "overdueSince": "Überfällig seit", "dueOn": "Fällig am", "hello": "Guten Tag", "viewGroup": "Gruppe anzeigen", "recentlyOpened": "Kürzlich geöffnet", "noItemsYet": "Sie haben noch keine!", "affiliates": "Affiliates", "exploreHere": "Hier erkunden", "selectApp": "Wählen Sie Ihre App", "exploreCourses": "Erkunden Sie die verfügbaren Kurse", "courses": "Kurse", "engageCommunity": "In der Community engagieren", "communities": "Communitys", "noDataAvailable": "Im Minute sind keine Daten verfügbar", "noAppsAvailable": "Keine Apps verfügbar", "noWidgetsAvailable": "Keine Display Widgets", "noContentAvailable": "Kein Inhalt verfügbar" };
const uploadDocument$b = { "uploadHeader": "Dateien Hinzufügen", "uploadDescription": "Klicken Sie bis zu 10 Dateien aus und laden Sie sie hoch.", "uploadWarning": "Dies ist für Portal Admin bei Ansicht und Herunterladen sichtbar", "uploadInstruction": "Zum Upload klicken oder per Drag & Drop ablegen", "allowedFiles": "DOC, PNG, JPG, GIF, PPT oder PDF (Max.. 100 MB)", "cancelButton": "Stornieren", "uploadButton": "Upload", "confirmDeletion": "Speichern Löschen", "deleteFile": "File Löschen", "deleteFileDescription": "Möchten Sie diese File wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.", "deleteFileButton": "Ja , File Löschen", "deleteFileSuccessTitle": "File erfolgreich Gelöscht", "deleteFileErrorTitle": "Fehler in Löschen File", "deleteFileErrorMessage": "Beim Versuch, die File zu löschen, ist ein Fehler aufgetreten.", "cancel": "unwirksam", "notAbleToDownloadFile": "File kann nicht herunterladen", "fileSizeExceeded": "File überschreitet 100 MB", "invalidFileType": "Ungültig File eintippen", "notAbleToUploadFile": "File kann nicht Upload werden", "downloadError": "Fehler in Herunterladen der File", "fileUploadedSuccessfully": "File erfolgreich hochgeladen", "fileDownloadedSuccessfully": "File Herunterladen erfolgreich" };
const navbar$b = { "hi": "Hallo", "manageYourAccount": "Verwalten Sie Ihr Konto", "logOut": "Abmelden", "affiliates": "Affiliates", "courses": "Kurse", "communities": "Communitys" };
const mandatedInfoModal$b = { "invalidFileFormat": "Ungültiges Dateiformat/ungültiger Dateityp.", "pleaseUploadImage": "Bitte laden Sie ein Bild im Format SVG, PNG, JPG oder JPEG hoch.", "fileSizeTooLarge": "Die Datei ist zu groß.", "oopsUnableToUploadImage": "Oops! Foto kann nicht hochgeladen werden.", "pleaseUploadFileLessThan100MB": "Bitte laden Sie ein Dokument mit einer Größe von weniger als 100 MB hoch.", "pleaseTryAgainLater": "Bitte versuchen Sie es später erneut.", "completeYourProfile": "Ihr Profil vervollständigen", "profilesBuildConnection": "Profile schaffen Vertrauen und knüpfen Verbindungen zu anderen", "putAFaceToYourProfile": "Verleihen Sie Ihrem Profil ein Gesicht!", "uploadASVGPNGJPG": "Laden Sie eine SVG-, PNG- oder JPG-Datei hoch.", "recommendedAspectRatio11": "Empfohlenes Seitenverhältnis 1:1", "complete": "VOLLSTÄNDIG", "cropYourAvatar": "Schneiden Sie Ihren Avatar zu", "dragToReposition": "Zur Neupositionierung ziehen" };
const sideBar$b = { "languageSettings": "Spracheinstellungen", "profile": "Profil", "account": "Konto", "socialMedia": "Soziale Medien", "certificates": "Zertifikate", "billingSubscription": "Abrechnung & Abonnement", "communitiesChats": "Communities und Chats", "affiliates": "Affiliates", "notifications": "Erinnerung" };
const notifications$b = { "title": "Benachrichtigungen", "all": "Alle", "unread": "Ungelesen", "markAllRead": "Alle als gelesen markieren", "noNotifications": "Noch keine Benachrichtigungen", "whenYouGetNotifications": "Wenn Sie Benachrichtigungen erhalten, werden diese hier angezeigt" };
const affiliates$b = { "payoutMethod": "Ausschüttung", "leadCustomer": "Interessenten/Kunde", "commissions": "Gebühren", "description": "Verweisen Sie Benutzer an GoKollab", "title": "Affiliates", "groupsGoKollab": "Das Erstellen von Gruppen auf GoKollab ist völlig kostenlos, aber das ist erst der Anfang! Es sind spannende neue Funktionen in Vorbereitung, die Ihnen helfen, Ihr Online-Geschäft auszubauen und Ihre Einnahmen zu steigern. Wenn Benutzer ein Upgrade durchführen, um den vollen Funktionsumfang freizuschalten, erhalten Sie eine lebenslange, wiederkehrende Affiliate-Provision für deren Abonnement. Je früher Sie mit dem Empfehlen beginnen, desto besser – dieses unglaubliche Affiliate-Programm dürfen Sie einfach nicht verpassen!", "yourAffiliateLink": "Ihr Affiliate-Link" };
const deleteCard$b = { "deleteCard": "Karte löschen", "description": "Die Zahlungsmethode ist nach dem Entfernen nicht mehr verwendbar. Diese Aktion kann nicht rückgängig gemacht werden.", "activeCard": "Diese Karte wird für eine oder mehrere aktive Abonnementzahlungen verwendet. Wenn Sie diese Karte löschen, ohne die Zahlungsmethode für die zugehörigen Abonnements zu aktualisieren, wirkt sich dies auf zukünftige Zahlungen aus. Sind Sie sicher, dass Sie diese Karte löschen möchten?", "title": "Zahlungsmethode entfernen?", "cardCannotBeDeleted": "Karte kann nicht gelöscht werden", "cardIsLinkedToSubscriptions": "Die Karte ist mit Abonnements verbunden", "errorInDeletingCard": "Fehler beim Löschen der Karte", "noCardAvailable": "Keine Karte ist verfügbar", "cardRemovedSuccessfully": "Karte erfolgreich entfernt" };
const notificationPreferences$b = { "title": "Einstellungen für Benachrichtigung", "description": "Verwalten Sie, wenn und was Sie benachrichtigt werden", "pushNotificationsTitle": "Push-Erinnerung", "pushNotificationsDescription": "Verwalten Push Erinnerung", "emailNotificationsTitle": "E-Mail-Erinnerung", "emailNotificationsDescription": "E-Mail-Erinnerung verwalten", "emailNotifications": "E-Mail-Erinnerung", "manageEmailNotifications": "E-Mail-Erinnerung verwalten", "newActivity": "Neue Aktivität", "email": "E-Mail", "push": "Push", "allNotifications": "jeder Erinnerung", "postTags": "Story Schlüsselwörter", "postEveryoneTagged": "Story {'@'}Alle Schlüsselwörter", "postMention": "Story {'@'}Erinnern", "postLike": "Story Like", "newComment": "Neuer Kommentar", "commentEveryoneTagged": "Kommentar {'@'}Alle Schlüsselwörter", "commentMention": "Kommentar {'@'}Erinnern", "commentLike": "Kommentar Like", "postEveryoneTaggedMobile": "Story {'@'}Alle Schlüsselwörter", "postMentionMobile": "Story {'@'}Erinnern", "commentEveryoneTaggedMobile": "Kommentar {'@'}Alle Schlüsselwörter", "commentMentionMobile": "Kommentar {'@'}Erinnern", "newMemberRequestToJoinGroup": "Neue Mitglieder Anfragen an beitreten Gruppe", "groupJoiningRequestApproved": "Gruppe beitretenden Anfragen angenommen", "groupJoiningRequestRejected": "Gruppe beitreten Anfragen Abgelehnt", "roleUpdatedInPrivateChannel": "Roll aktualisiert in Privaten Kanal", "newCourseAvailable": "Neu Kurs zur Gruppe hinzugefügt", "newEventCreated": "Neu Veranstaltung Erstellt", "newCourseComment": "Neuer Kurskommentar", "certificateIssued": "Zertifikat Ausgestellt", "postEveryoneTaggedDescription": "Wenn jemand {'@'}veröffentlicht, Alle Schlüsselwörter", "postMentionDescription": "Wenn jemand {'@'}Erzählung sendet", "postLikeDescription": "Wenn jemand Ihre Story Likes", "newCommentDescription": "Wenn jemand Feedback zu Ihrer Story gibt", "commentEveryoneTaggedDescription": "Wenn jemand Feedback {'@'}Alle Schlüsselwörter gibt", "commentMentionDescription": "Wenn jemand Feedback {'@'}kommentiert", "commentLikeDescription": "Wenn jemand deinen Kommentar Likes", "newMemberRequestToJoinGroupDescription": "Wenn jemand bucht, deiner Gruppe beitreten", "groupJoiningRequestApprovedDescription": "Wenn die Gruppe einer Person, die Anfragen beitritt, angenommen wird", "groupJoiningRequestRejectedDescription": "Wenn die Gruppe einer Person beitreten Anfragen wird Abgelehnt", "roleUpdatedInPrivateChannelDescription": "Wenn die Funktion einer Person in einem Privatkanal aktualisiert wird", "newCourseAvailableDescription": "Wenn ein Neu Kurs verfügbar ist", "newEventCreatedDescription": "Wenn eine neue Veranstaltung erstellt ist", "newCourseCommentDescription": "Wenn jemand Feedback zu einem Kurs gibt", "certificateIssuedDescription": "Wenn ein Zertifikat ausgegeben wird", "estimateReceivedDescription": "Wenn eine neue Schätzung erhalten wird", "contractReceivedDescription": "Wenn ein neuer Vertrag erhalten wird", "invoiceReceivedDescription": "Wenn eine neue Rechnung erhalten wird", "allEmailNotificationsDescription": "Umdrehen An/deaktiviert jede E-Mail-Erinnerung", "allPushNotificationsDescription": "Umdrehen An/deaktiviert jeder Push Erinnerung", "errorUpdating": "da war ein Fehler beim Aktualisieren Ihrer Benachrichtigungen Einstellungen", "updateSuccess": "Ihre Benachrichtigungs-Einstellungen wurden aktualisiert", "willNotReceiveNotificationsIfAdminDisabled": "Sie werden nicht über Ihren Administrator eine Erinnerung für Einstellungen deaktiviert.", "estimateReceived": "Neu Schätzung Empfangen", "contractReceived": "Neu Vertrag empfangen", "invoiceReceived": "Neu Rechnung empfangen", "pushNotificationNotAvailable": "Push-Benachrichtigung ist für diese Veranstaltung nicht verfügbar", "newsletter": "Newsletter", "emailNotificationNotAvailable": "Eine Email-Benachrichtigung ist für diese Veranstaltung nicht verfügbar.", "newPostFollowers": "Neuer Beitrag von einem gefolgten Benutzer", "newPostFollowersDescription": "Erhalten Sie eine Benachrichtigung, wenn jemand, dem Sie folgen, einen neuen Beitrag erstellt.", "newFollower": "Erhalten Sie eine Benachrichtigung, wenn Ihnen jemand folgt." };
const loginPage$b = { "forgotPassword": "Passwort vergessen?", "login": "Login", "lastLogin": "letzte Login", "proceedToLogin": "Fortfahren mit der Login fort", "secureCode": "sicherer Code", "newUser": "Neuer Benutzer?", "resetPasswordLink": "Wenn die eingegebene E-Mail richtig ist, werden Sie einen password Link in der E-Mail zurücksetzen. Bitte stellen Sie sicher, dass Sie auch den Spam-Ordner archivieren.", "loginWithSecureCode": "Login mit sicherem Code", "signUp": "Registrieren", "enterOtp": "Geben Sie OTP ein", "selectAccount": "Auswählen aus , welche Konto Sie möchten", "resetPassword": "Passwort Zurücksetzen", "selectUser": "Benutzer Auswählen", "emailRequired": "Bitte geben Sie eine gültige E-Mail-Adresse ein", "fullNameRequired": "Bitte geben Sie Ihren Namen ein", "passwordRequired": "Bitte geben Sie ein password von Min 8 Zeichen ein", "generateSecureCode": "Sicheren Code generieren", "loginWithPassword": "Login mit Passwort", "secureCodeEmail": "Bitte kreuzen Sie Ihre E-Mail für den sicherer Code an. Wenn Sie keine E-Mail von uns erhalten haben,", "resendOtp": "Klicken Sie hier, um Erneut zu senden.", "verifySecureCode": "Überprüfen den sichereren Code", "secureCodeNumeric": "Ein sicherer Code muss ein numerischer Wert sein und aus 6 Ziffern stammen", "alreadyHaveAccount": "Haben Sie bereits ein Konto?", "email": "E-Mail", "password": "Passwort", "fullName": "Vollständiger Name", "somethingWentWrong": "Etwas ist schiefgelaufen", "signInWithEmail": "Oder melden Sie sich mit Ihrer E-Mail an", "signUpWithEmail": "Oder mit Ihrer E-Mail registrieren", "confirmPassword": "Passwort bestätigen", "validationErrors": { "potentialSpamUser": { "title": "Konto Privat", "message": "Ihr Konto wurde gegenüber potenzieller Spam-Aktivität privater Geschuldet. Bitte kontaktiere den Support, um Hilfe zu erhalten." }, "somethingWentWrong": { "title": "Etwas ist schiefgelaufen", "message": "in nicht möglich. Bitte Erneut versuchen Sie es später." }, "bannedUser": { "title": "Konto Privat", "message": "Ihr Konto wurde gegen potenzielle Spam-Aktivität gesperrt. Bitte kontaktiere den Support, um Hilfe zu erhalten." } } };
const magicLink$b = { "newLinkSent": "Neu Link gesendet", "portalWillSendLink": "Portal wird einen neuen Link an Ihre E-Mail-Adresse Upload", "failedToSendNewLink": "Neuen Link Fehlgeschlagen Upload werden", "pleaseTryAgain": "Bitte Erneut versuchen", "linkExpired": "Dieser Link von Ihrer E-Mail ist abgelaufen.", "toContinue": "Um Weiter, Anfragen nach einem neuen Link oder sich in Ihremportal Portal Konto anzumelden", "sendNewLink": "Neuen Link Upload", "logIn": "melde dich in", "clickToLogIn": "Klicken Sie hier, um in in Ihremportal Portal Konto anzumelden", "invalidToken": "Dieses Token von Ihrer E-Mail ist nicht gültig.", "toContinueContactAdmin": "Um Weiter, Anfragen Magic Link Admin in an einen Neuen Kontakt Oder In Ihremportal Portal Konto" };
const setPassword$b = { "minLength": "Bitte geben Sie ein password von Min 8 Zeichen ein", "passwordsMustMatch": "Passwörter müssen übereinstimmen", "setSecurePassword": "Sammlung Ihr sicheres password", "setPasswordButton": "Sammlung Passwort" };
const alerts$b = { "tooManyAttempts": { "title": "Zu vielen Versuchen", "message": "in einem Fenster von Monat sind nicht mehr als 2 Versuche für die Slug Aktualisierung erlaubt" }, "slugAlreadyExists": { "title": "Slug existiert bereits", "message": "Bitte versuche es mit einem anderen Slug" }, "updateSlugError": { "title": "Etwas ist schiefgelaufen", "message": "Profil-Slug kann nicht aktualisiert werden. Bitte versuchen Sie es später mit einem Datum" }, "updateProfileError": { "title": "Etwas ist schiefgelaufen", "message": "Details können nicht aktualisiert werden. Bitte versuchen Sie es später mit einem Datum" } };
const bottomNavBar$b = { "home": "Startseite", "discover": "Discover", "communities": "Communities", "courses": "Kurse", "more": "Mehr" };
const forceUpdate$b = { "title": "Neu Update ist verfügbar", "description": "Aktualisierung Ihre Anwendung auf die neueste Version", "buttonText": "Jetzt Aktualisierung !" };
const accessibility$b = { "copyAffiliateLink": "Affiliate-Link in die Zwischenablage Kopieren", "deleteCard": "Karte Löschen", "appSwitcher": "App Switcher", "portalImage": "Portal Bild", "profileImage": "Profil Bild", "continueWithGoogle": "Weiter mit Google" };
const resetPassword$b = { "passwordExpired": "Ihr password -Zurücksetzen Link ist abgelaufen.", "regenerateLink": "Link neu generieren", "proceedToLogin": "Fortfahren mit der Login fort", "passwordChangedSuccessfully": "Passwort Dynamisch erfolgreich", "changePassword": "Passwort Ändern", "newPassword": "Bitte geben Sie ein password von Min 8 Zeichen ein", "confirmPassword": "Die password stimmt nicht überein", "setNewPassword": "Sammlung Neues Passwort", "confirmNewPassword": "Neues Passwort bestätigen" };
const de = {
  common: common$b,
  account: account$b,
  wallet: wallet$b,
  support: support$b,
  social: social$b,
  validation: validation$b,
  forms: forms$b,
  auth: auth$b,
  billing: billing$b,
  transactions: transactions$b,
  cancelModal: cancelModal$b,
  certificates: certificates$b,
  changePassword: changePassword$b,
  deleteAccount: deleteAccount$b,
  chats: chats$b,
  payments: payments$b,
  profileSettings: profileSettings$b,
  languageSettings: languageSettings$b,
  userActivityOverview: userActivityOverview$b,
  widget: widget$b,
  dashboard: dashboard$b,
  uploadDocument: uploadDocument$b,
  navbar: navbar$b,
  mandatedInfoModal: mandatedInfoModal$b,
  sideBar: sideBar$b,
  notifications: notifications$b,
  affiliates: affiliates$b,
  deleteCard: deleteCard$b,
  notificationPreferences: notificationPreferences$b,
  loginPage: loginPage$b,
  magicLink: magicLink$b,
  setPassword: setPassword$b,
  alerts: alerts$b,
  bottomNavBar: bottomNavBar$b,
  forceUpdate: forceUpdate$b,
  accessibility: accessibility$b,
  resetPassword: resetPassword$b
};
const common$a = { "show": "Show", "newPost": "New Post", "active": "Active", "change": "Change", "remove": "Remove", "cancel": "Cancel", "publish": "Publish", "save": "Save", "draft": "Draft", "scheduled": "Scheduled", "published": "Published", "actions": "Actions", "archive": "Archive", "delete": "Delete", "edit": "Edit", "settings": "Settings", "updatedOn": "Updated on", "blogPost": "Blog Post", "category": "Category", "author": "Author", "status": "Status", "errors": "Errors", "error": "Error", "all": "All", "add": "Add", "discussion": "Discussion", "allCourses": "All Courses", "myCourses": "My Courses", "learning": "Learning", "leaderboard": "Leaderboard", "documentsAndPayments": "Documents & File Management", "more": "More", "profile": "Profile", "archived": " Archived", "back": "Back", "restore": "Restore this version", "next": "Next", "previous": "Previous", "continue": "Continue", "details": "Details", "youtube": "Youtube", "action": "Action", "view": "View", "download": "Download", "source": "Source", "title_column": "Title", "copy": "Copy", "viewReceipt": "View Receipt", "id": "ID", "location": "Location", "email": "Email", "title": "Title", "logout": "Logout", "login": "Login", "calender": "Calender", "apply": "Apply", "clear": "Clear", "to": "To", "from": "From", "type": "Type", "home": "Home", "description": "Description", "updated": "Updated", "networkError": { "title": "No Internet Connection", "message": "Please check your internet connection and try again." } };
const account$a = { "settings": "Account Settings", "updateSettings": "Update your account settings here", "paymentDetails": "Payment Details", "orderId": "Internal Order ID", "nextInvoice": "Next Invoice", "transactionDate": "Transaction Date", "expiryDate": "Expiry Date", "manageAllSubscription": "Manage all your subscription", "paymentMethod": "Payment Method", "andTransactionHere": "& transaction here" };
const wallet$a = { "transactionId": "Transaction ID" };
const support$a = { "subscriptionId": "Subscription ID", "email": { "validation": "Enter Valid Email" }, "invoiceNo": "Invoice Number" };
const social$a = { "title": "Social Media", "invalidURL": "Invalid URL", "phoneNumber": "Phone Number", "userPhone": "User Phone", "userEmail": "User Email", "info": "Social Information", "update": "Update Social Media Info", "detailsHere": "Update your social media details here", "updated": "Social Media Updated", "visibility": "Publicly Visible", "validUrl": "Please enter a valid URL", "validEmail": "Please enter a valid email", "validPhoneNumber": "Please enter a valid Phone Number with an appropriate country code", "platforms": { "twitter": "Twitter", "instagram": "Instagram", "facebook": "Facebook", "youtube": "Youtube", "linkedin": "LinkedIn" } };
const validation$a = { "phone": "Enter Valid Phone", "url": "Enter Valid URL" };
const forms$a = { "phone": "Phone Number" };
const auth$a = { "clickToResend": "Click to resend", "authentication": "Authentication", "didntGetCode": "Didn't get a code?", "confirmationCode": "Confirmation code", "sentVerificationEmail": "We've sent a verification code via email to", "authenticateAccount": "Authenticate Your Account", "incorrectOrExpired": "Otp is incorrect or expired", "failedToSend": "Failed to send otp", "checkEmailForSecureCode": "Please check your email for the secure code. If you did not receive any email from us,", "user": "User", "verify": "Verify", "tapHereToResend": "tap here to resend.", "failedToVerifyOtp": "Failed to verify OTP", "failedToGetOtp": "Failed to get OTP" };
const billing$a = { "endingIn": "ending in", "billingInformation": "Billing Information", "billingAddress": "Billing Address:", "sourceType": "Source Type :", "invoices": "Invoices", "subscription": "Subscription", "transactions": "Transactions", "transaction": "Transaction", "subscriptions": "Subscriptions", "invoiceName": "Invoice Name", "subscriptionName": "Subscription Name", "dueDate": "Due Date", "issueDate": "Issue Date", "amount": "Amount", "manageSubscriptions": "Manage all your subscription", "andSubscription": "& Subscription", "andTransaction": "& transaction here", "billing": "Billing", "startDate": "Start Date", "fullName": "Full Name", "nextInvoiceOn": "Next invoice on", "noDataFound": "No Data Found", "invoiceNo": "Invoice No. :", "manageSubscriptionsInvoicesAndTransactions": "Manage subscriptions, invoices & transactions", "created": "Created :", "transactionName": "Transaction Name", "tid": "Tid :", "transactionDate": "Transaction Date :", "trial": "Trial", "expired": "Expired", "pastDue": "Past Due", "unpaid": "Unpaid", "incompleteExpired": "Incomplete Expired", "canceled": "Canceled", "incomplete": "Incomplete", "failed": "Failed", "sent": "Sent", "paid": "Paid", "paymentProcessing": "Payment Processing", "partiallyPaid": "Partially Paid", "overdue": "Overdue", "succeeded": "Succeeded", "processing": "Processing", "refunded": "Refunded", "pending": "Pending", "membership": "Membership", "communities": "Communities", "paymentLink": "Payment Link", "expiresOn": "Expires on", "errorFetchingPaymentMethods": "Error fetching payment methods", "pageUrl": "Page URL" };
const transactions$a = { "title": "Transactions", "name": "Transactions Name" };
const cancelModal$a = { "subscriptionRenewNotice": "If you change your mind you can renew your subscription anytime.", "cancelSubscription": "Cancel subscription", "subscriptionCancelNotice": "will be cancelled immediately. You will not be charged again.", "yourPlanName": "Your plan", "currentPlan": "Current Plan", "subscriptionCancelError": "An error occurred while trying to cancel the subscription.", "cancelSubscriptionFailed": "Cancel Subscription Failed" };
const certificates$a = { "title": "Certificates", "certificatesDescription": "Download & share certificates you have earned.", "subtitle": "Download your certificates", "completedOn": "Completed on", "back": "Back", "previous": "Previous", "next": "Next", "downloadYourCertificates": "Download Your Certificates", "downloadCertificate": "Download {type}", "viewCertificates": "View and download all your certificates here", "certificateNotFound": "No certificate found", "issuedOn": "Issued On", "expiresOn": "Expires On", "description": "Description", "yourCertificateHasExpiredOn": "Your {type} has expired on", "issuedCertificatesNotFound": "You have not earned any certificates yet.", "shareCertificate": "Share:", "preview": { "issuedTo": "Issued to", "issuedBy": "Issued by", "addToLinkedin": "Add to LinkedIn Profile", "download": "Download", "credentialVerification": "Credential Verification", "issueDate": "Issue Date", "expiryDate": "Expiry Date", "verifyCredential": "Verify Credential", "shareYourCredential": "Share Your Credential", "showYourCredential": "Show your credential on your social network", "expiredOn": "Expired On", "expiredDesc": "It's time to renew and stay up-to-date. Don't miss out on continued benefits and opportunities.", "verificationModal": { "title": "Credential Verification", "subtitle": "This is the valid credential.", "description": " This credential was securely issued. All the displayed information is valid.", "step1": { "title": "Verifying the recipient", "description": "The holder of this credential is {recipient}" }, "step2": { "title": "Verifying the issuer", "description": "This credential was issued by  {issuer}" }, "step3": { "title": "Verifying the credential's ID", "description": "The identifier {credentialId} is unique and valid." } }, "notFound": { "title": "Oops! Certificate Not Found", "description": "The certificate you're trying to view isn't available.", "subtitle": "Contact the issuer for assistance." } }, "share": { "title": "Your Certificate", "text": "Here is your certificate", "dialogTitle": "Share or Save your certificate" }, "listing": { "courseAssignmentName": "Course/Assignment Name", "offlineCertification": "Offline Certification", "completionDate": "Completion Date", "expiryDate": "Expiry Date", "type": "Type", "sourceName": "Source Name", "action": "Action" } };
const changePassword$a = { "showPasswords": "Show Passwords", "retypePassword": "Retype Password", "newPassword": "New Password", "confirmNewPassword": "Confirm New Password", "currentPassword": "Current Password", "emailId": "Email Id", "passwordMinLength": "Please enter a password of minimum 8 character", "editAccount": "Edit Account", "loginEmail": "Login Email", "loginInformation": "Login information", "accountDetails": "Account Details", "accountDetailsUpdate": "Update your account details here", "accountInformation": "Account Information", "changePassword": "Change Password", "hidePasswordChange": "Hide Change Password", "selectPageError": "Please try again later", "systemErrorOccurred": "Something went wrong", "passwordEntryInvalid": "Invalid Password", "passwordUpdateSuccess": "Password Updated", "passwordLengthRequired": "Please enter a password of minimum 8 character", "passwordMinimumLength": "Please enter a password of minimum 8 character", "passwordFieldRequired": "Password is required", "password": "Password" };
const deleteAccount$a = { "title": "Delete Account", "deleteAccountDescription": "Your account is scheduled for temporary deactivation and will be permanently deleted if you do not log in within the next 7 days.", "deleteAccountDescription2": "To keep your account active, simply log in before the deadline. Once deleted, your data cannot be recovered.", "deleteAccountButton": "Yes, Delete Account" };
const chats$a = { "viewAll": "View All", "viewLess": "View Less", "updatedPreference": "Updated Preference", "chatSettings": "Chat Settings", "chats": "Chats", "chatSettingsDescription": "Choose chat settings for your groups & contacts", "groups": "Groups", "blockedUsers": "Blocked Users", "noGroups": "No groups", "controlUsers": "Control which users you don't want to chat with.", "blockedConversations": "Blocked Conversations", "noBlockedUsers": "No blocked users", "unblock": "Unblock", "noUsersBlocked": "No users blocked", "noGroupsJoined": "No groups joined", "controlGroups": "Control which group users can contact you by toggling your chat availability on or off below. You can receive messages only from members of the group you are part of. " };
const payments$a = { "shareLink": "Share link", "paymentLink": "Payment Link" };
const profileSettings$a = { "complete": "COMPLETE", "editBasicInformation": "Edit Basic Information", "writeAboutYourself": "Write something about yourself...", "selectTimezone": "Select Timezone", "description": "This will be displayed on your profile", "timezone": "Timezone", "enterLocation": "Enter Location", "exampleDescription": "Example : Hi, I am John Deo and I am a photographer", "enterABriefDescription": "Enter a brief description", "bio": "Bio", "profileSlugNotAvailable": "Profile Slug Not Available", "findAndShareProfile": "Find and share your profile easily with a personalized URL slug.", "profileSlug": "Profile Slug", "enterTitle": "Enter Title", "enterFullName": "Enter Full Name", "basicDetails": "Basic Details", "updateProfileDetails": "Update your profile details here", "basicInformation": "Basic Information", "updatedProfileSettings": "Updated Profile Settings", "uploadStatusCode": "Upload failed with status code", "imageTypeNotSupported": "Image type not supported", "nameIsRequired": "Name is required", "invalidName": "Invalid Name", "profileImage0": "Profile Image", "profileImage": "Profile Image", "uploadSvgPngJpg": "Upload a SVG, PNG, JPG. Recommended Aspect Ratio 1:1", "profilesBuildConnection": "Profiles build trust and spark connection with others", "clientPortalNames": "Client Portal feel weird without faces and names.", "completeYourProfile": "Complete Your Profile", "uploadFailed": "Upload failed", "fileSizeTooLarge": "File size too large", "invalidFileFormatType": "Invalid File Format/Type.", "pleaseUploadImage": "Please upload an image of type SVG, PNG, JPG, or JPEG.", "pleaseUploadAFileLessThan100Mb": "Please upload a file less than 100 MB.", "oopsUnableToUploadImage": "Oops! Unable to upload image.", "selectPageError": "Please try again later", "search": "Search", "searchTimezones": "Search timezones", "noTimezonesFound": "No timezones found", "editDetails": "Edit Details", "profilePicture": "Profile picture", "profileCover": "Profile cover", "uploadPhoto": "Upload photo", "removePhoto": "Remove photo", "invalidAspectRatio": "Invalid Aspect Ratio", "recommendedAspectRatio169": "Recommended aspect ratio 16:9", "recommendedAspectRatio11": "Recommended aspect ratio 1:1", "editProfile": "Edit profile", "manageYourGroupDetailsHere": "Manage your group details here", "profileIcon": "Profile Icon", "specialCharactersNotSupported": "Special characters are not supported", "slugValidation": { "containSpecialCharacters": "Slug cannot contain special characters", "tooShort": "Slug must be at least 3 characters long", "tooLong": "Slug must be less than 50 characters long", "containOnlyNumbers": "Slug cannot contain only numbers", "startWithNumber": "Slug cannot start with a number", "startWithHyphen": "Slug cannot start with a hyphen", "endWithHyphen": "Slug cannot end with a hyphen", "containDoubleHyphen": "Slug cannot contain double hyphens", "containSpace": "Slug cannot contain spaces" } };
const languageSettings$a = { "title": "Language Settings", "detailsHere": "Choose client portal language", "selectLanguage": "Select Language", "useLocationLanguage": "Use Location Language", "languagePreferenceUpdated": "Language Preference Updated", "errorUpdatingLanguage": "Error in updating language", "description": "Select your preferred language for viewing client portal items, community content, courses, and affiliate information. This setting allows you to see content in the language you're most comfortable with. ", "shortDescription": "Select your preferred language" };
const userActivityOverview$a = { "dustBunnies": "Nothing to see, unless you're into dust bunnies.", "welcomeBanner": "Welcome to", "contracts": "Contracts", "hiUser": "Hi", "estimates": "Estimates", "sharedFiles": "Shared Files" };
const widget$a = { "viewAll": "View All", "addedOn": "Added on", "by": "by", "you": "You", "admin": "Admin", "youDoNotHaveAny": "You don’t have any!", "noContracts": "No Contracts", "maxFilesExceeded": "You can only upload up to 10 files", "uploadFile": "Upload File", "userActivityOverview.contracts": "Contracts", "selectPageError": "Please try again later", "notAbleToDownloadContract": "Not able to download contract", "completeCourse": "Complete Course", "courseProgress": "Course Progress", "viewAllGroups": "View all Groups", "recentlyOpened": "Recently opened", "noInvoices": "No Invoices", "noEstimates": "No Estimates", "notAbleToDownloadInvoice": "Not able to download invoice", "contracts": "Contracts", "invoices": "Invoices", "youMarked": "You marked", "inCourse": "in course", "invoice": "Invoice", "makePayment": "Make Payment", "downloadInvoice": "Download Invoice", "viewGroup": "View Group", "payment": "Payment", "download": "Download", "signContract": "Sign Contract", "sign": "Sign", "estimates": "Estimates", "notAbleToDownloadEstimate": "Not able to download estimate", "addFiles": "Add Files", "sharedFiles": "Shared Files", "fileManagement": "File Management", "noFiles": "No Files" };
const dashboard$a = { "joinAGroup": "Join a Group", "takeACourse": "Take a course", "checkAffiliateEarnings": "Check Affiliate Earnings", "manageSubscriptions": "Manage Subscriptions", "contracts": "Contracts", "estimates": "Estimates", "sharedFiles": "Shared Files", "paidOn": "Paid on", "partiallyPaidOn": "Partially Paid on", "overdueSince": "Overdue since", "dueOn": "Due on", "hello": "Hello", "viewGroup": "View Group", "recentlyOpened": "Recently Opened", "noItemsYet": "You don’t have any yet!", "affiliates": "Affiliates", "exploreHere": "Explore Here", "selectApp": "Select Your App", "exploreCourses": "Explore available courses", "courses": "Courses", "engageCommunity": "Engage in community", "communities": "Communities", "noDataAvailable": "No data available at the moment", "noAppsAvailable": "No applications available", "noWidgetsAvailable": "No widgets to display", "noContentAvailable": "No content available" };
const uploadDocument$a = { "uploadHeader": "Add Files", "uploadDescription": "Select and upload up to 10 documents", "uploadWarning": "This will be visible to portal admin to view and download", "uploadInstruction": "Click to upload or drag and drop", "allowedFiles": "DOC, PNG, JPG , GIF , PPT or PDF (max. 100MB)", "cancelButton": "Cancel", "uploadButton": "Upload", "confirmDeletion": "Confirm Deletion", "deleteFile": "Delete File", "deleteFileDescription": "Are you sure you want to delete this file? This action cannot be undone.", "deleteFileButton": "Yes, Delete File", "deleteFileSuccessTitle": "File Deleted Successfully", "deleteFileErrorTitle": "Error in Deleting File", "deleteFileErrorMessage": "An error occurred while trying to delete the file.", "cancel": "Cancel", "notAbleToDownloadFile": "Not able to download file", "fileSizeExceeded": "File size exceeds 100MB", "invalidFileType": "Invalid file type", "notAbleToUploadFile": "Not able to upload file", "downloadError": "Error in downloading file", "fileUploadedSuccessfully": "File uploaded successfully", "fileDownloadedSuccessfully": "File downloaded successfully" };
const navbar$a = { "hi": "Hi", "manageYourAccount": "Manage Your Account", "logOut": "Log Out", "affiliates": "Affiliates", "courses": "Courses", "communities": "Communities" };
const mandatedInfoModal$a = { "invalidFileFormat": "Invalid File Format/Type.", "pleaseUploadImage": "Please upload an image of type SVG, PNG, JPG, JPEG", "fileSizeTooLarge": "File size too large", "oopsUnableToUploadImage": "Oops! Unable to upload image.", "pleaseUploadFileLessThan100MB": "Please upload a file less than 100 MB", "pleaseTryAgainLater": "Please try again later", "completeYourProfile": "Complete Your Profile", "profilesBuildConnection": "Profiles build trust and spark connection with others", "putAFaceToYourProfile": "Put a face to your profile!", "uploadASVGPNGJPG": "Upload a SVG, PNG, JPG.", "recommendedAspectRatio11": "Recommended Aspect Ratio 1:1", "complete": "COMPLETE", "cropYourAvatar": "Crop Your Avatar", "dragToReposition": "Drag to reposition" };
const sideBar$a = { "languageSettings": "Language Settings", "profile": "Profile", "account": "Account", "socialMedia": "Social Media", "certificates": "Certificates", "billingSubscription": "Billing & Subscription", "communitiesChats": "Communities & Chats", "affiliates": "Affiliates", "notifications": "Notifications" };
const notifications$a = { "title": "Notifications", "all": "All", "unread": "Unread", "markAllRead": "Mark all as read", "noNotifications": "No notifications yet", "whenYouGetNotifications": "When you get notifications, they’ll show up here" };
const affiliates$a = { "payoutMethod": "Payout Method", "leadCustomer": "Leads/Customers", "commissions": "Commissions", "description": "Refer Users to GoKollab", "title": "Affiliates", "groupsGoKollab": "Creating groups on GoKollab is completely free, but that’s just the beginning! Exciting new features are on the way to help you grow your online business and increase your earnings. As users upgrade to unlock the full suite of features, you'll receive a lifetime recurring affiliate commission on their subscription. The sooner you start referring, the better—don’t miss out on this incredible affiliate program", "yourAffiliateLink": "Your affiliate link" };
const deleteCard$a = { "deleteCard": "Delete Card", "description": "The payment method will no longer be usable after removing it. This action cannot be undone.", "activeCard": "This card is used for one or more active subscription payments. Deleting this card without updating the payment method for the associated subscriptions will impact future payments. Are you sure you want to delete this card?", "title": "Remove payment method?", "cardCannotBeDeleted": "Card cannot be deleted", "cardIsLinkedToSubscriptions": "Card is linked to subscriptions", "errorInDeletingCard": "Error in deleting card", "noCardAvailable": "No Card Available", "cardRemovedSuccessfully": "Card removed successfully" };
const notificationPreferences$a = { "title": "Notification Preferences", "description": "Manage when and what you get notified for", "pushNotificationsTitle": "Push Notifications", "pushNotificationsDescription": "Manage push notifications", "emailNotificationsTitle": "Email Notifications", "emailNotificationsDescription": "Manage email notifications", "emailNotifications": "Email Notifications", "manageEmailNotifications": "Manage email notifications", "newActivity": "New Activity", "email": "Email", "push": "Push", "allNotifications": "All Notifications", "postTags": "Post Tags", "postEveryoneTagged": "Post {'@'}Everyone Tagged", "postMention": "Post {'@'}Mention", "postLike": "Post Like", "newComment": "New Comment", "commentEveryoneTagged": "Comment {'@'}Everyone Tagged", "commentMention": "Comment {'@'}Mention", "commentLike": "Comment Like", "postEveryoneTaggedMobile": "Post {'@'}Everyone Tagged", "postMentionMobile": "Post {'@'}Mention", "commentEveryoneTaggedMobile": "Comment {'@'}Everyone Tagged", "commentMentionMobile": "Comment {'@'}Mention", "newMemberRequestToJoinGroup": "New Member Request to Join Group", "groupJoiningRequestApproved": "Group Joining Request Approved", "groupJoiningRequestRejected": "Group Joining Request Rejected", "roleUpdatedInPrivateChannel": "Role Updated in Private Channel", "newCourseAvailable": "New Course Added to the Group", "newEventCreated": "New Event Created", "newCourseComment": "New Course Comment", "certificateIssued": "Certificate Issued", "postEveryoneTaggedDescription": "When someone posts {'@'}everyone tagged", "postMentionDescription": "When someone posts {'@'}mention", "postLikeDescription": "When someone likes your post", "newCommentDescription": "When someone comments on your post", "commentEveryoneTaggedDescription": "When someone comments {'@'}everyone tagged", "commentMentionDescription": "When someone comments {'@'}mention", "commentLikeDescription": "When someone likes your comment", "newMemberRequestToJoinGroupDescription": "When someone requests to join your group", "groupJoiningRequestApprovedDescription": "When someone's group joining request is approved", "groupJoiningRequestRejectedDescription": "When someone's group joining request is rejected", "roleUpdatedInPrivateChannelDescription": "When someone's role is updated in a private channel", "newCourseAvailableDescription": "When a new course is available", "newEventCreatedDescription": "When a new event is created", "newCourseCommentDescription": "When someone comments on a course", "certificateIssuedDescription": "When a certificate is issued", "estimateReceivedDescription": "When a new estimate is received", "contractReceivedDescription": "When a new contract is received", "invoiceReceivedDescription": "When a new invoice is received", "allEmailNotificationsDescription": "Turn on/off all email notifications", "allPushNotificationsDescription": "Turn on/off all push notifications", "errorUpdating": "There was an error updating your notification preferences", "updateSuccess": "Your notification preferences have been updated", "willNotReceiveNotificationsIfAdminDisabled": "You won't receive notifications for settings disabled by your administrator.", "estimateReceived": "New Estimate Received", "contractReceived": "New Contract Received", "invoiceReceived": "New Invoice Received", "pushNotificationNotAvailable": "Push notification is not available for this event", "newsletter": "Newsletter", "emailNotificationNotAvailable": "Email notification is not available for this event", "newPostFollowers": "New Post from Followed User", "newPostFollowersDescription": "Get notified when someone you follow creates a new post.", "newFollower": "Get notified when someone follows you." };
const loginPage$a = { "forgotPassword": "Forgot Password?", "login": "Login", "lastLogin": "Last Login", "proceedToLogin": "Proceed to Login", "secureCode": "Secure Code", "newUser": "New User?", "resetPasswordLink": "If the entered email is correct, you will receive a reset password link in the email. Please ensure to check the spam folder as well.", "loginWithSecureCode": "Login with secure code", "signUp": "Sign Up", "enterOtp": "Enter OTP", "selectAccount": "Select which account you want to", "resetPassword": "Reset Password", "selectUser": "Select User", "emailRequired": "Please enter a valid email", "fullNameRequired": "Please enter your name", "passwordRequired": "Please enter a password of minimum 8 character", "generateSecureCode": "Generate Secure Code", "loginWithPassword": "Login with Password", "secureCodeEmail": "Please check your email for the secure code. If you did not receive any email from us,", "resendOtp": "tap here to resend.", "verifySecureCode": "Verify Secure Code", "secureCodeNumeric": "Secure code must be a numeric value and must be of 6 digits", "alreadyHaveAccount": "Already have an account?", "email": "Email", "password": "Password", "fullName": "Full Name", "somethingWentWrong": "Something went wrong", "signInWithEmail": "Or, sign in with your email", "signUpWithEmail": "Or, sign up with your email", "confirmPassword": "Confirm Password", "validationErrors": { "potentialSpamUser": { "title": "Account Restricted", "message": "Your account has been restricted due to potential spam activity. Please contact support for assistance." }, "somethingWentWrong": { "title": "Something went wrong", "message": "Unable to sign in. Please try again later." }, "bannedUser": { "title": "Account Restricted", "message": "Your account has been banned due to potential spam activity. Please contact support for assistance." } } };
const magicLink$a = { "newLinkSent": "New Link Sent", "portalWillSendLink": "Portal will send a fresh link to your Email Address", "failedToSendNewLink": "Failed to send new link", "pleaseTryAgain": "Please try again", "linkExpired": "This link from your Email has Expired.", "toContinue": "To Continue, request a New Link or Log In to your Portal Account", "sendNewLink": "SEND NEW LINK", "logIn": "LOG IN", "clickToLogIn": "Click here to Log In to your Portal Account", "invalidToken": "This token from your Email is not Valid.", "toContinueContactAdmin": "To Continue, request a new Magic Link contact Admin or Log In to your Portal Account" };
const setPassword$a = { "minLength": "Please enter a password of minimum 8 characters", "passwordsMustMatch": "Passwords must match", "setSecurePassword": "Set your secure password", "setPasswordButton": "Set Password" };
const alerts$a = { "tooManyAttempts": { "title": "Too Many Attempts", "message": "Not more than 2 attempts for slug update are allowed in a window of 30 days" }, "slugAlreadyExists": { "title": "Slug Already Exists", "message": "Please try a different slug" }, "updateSlugError": { "title": "Something went wrong", "message": "Unable to update profile slug. Please try after some time" }, "updateProfileError": { "title": "Something went wrong", "message": "Unable to update profile details. Please try after some time" } };
const bottomNavBar$a = { "home": "Home", "discover": "Discover", "communities": "Communities", "courses": "Courses", "more": "More" };
const forceUpdate$a = { "title": "NEW UPDATE IS AVAILABLE", "description": "Update your application to the latest version", "buttonText": "Update Now!" };
const accessibility$a = { "copyAffiliateLink": "Copy affiliate link to clipboard", "deleteCard": "Delete Card", "appSwitcher": "App Switcher", "portalImage": "Portal Image", "profileImage": "Profile Image", "continueWithGoogle": "Continue with Google" };
const resetPassword$a = { "passwordExpired": "Your password reset link has expired.", "regenerateLink": "Regenerate Link", "proceedToLogin": "Proceed to Login", "passwordChangedSuccessfully": "Password changed successfully", "changePassword": "Change Password", "newPassword": "Please enter a password of minimum 8 character", "confirmPassword": "The password confirmation does not match", "setNewPassword": "Set New Password", "confirmNewPassword": "Confirm New Password" };
const en = {
  common: common$a,
  account: account$a,
  wallet: wallet$a,
  support: support$a,
  social: social$a,
  validation: validation$a,
  forms: forms$a,
  auth: auth$a,
  billing: billing$a,
  transactions: transactions$a,
  cancelModal: cancelModal$a,
  certificates: certificates$a,
  changePassword: changePassword$a,
  deleteAccount: deleteAccount$a,
  chats: chats$a,
  payments: payments$a,
  profileSettings: profileSettings$a,
  languageSettings: languageSettings$a,
  userActivityOverview: userActivityOverview$a,
  widget: widget$a,
  dashboard: dashboard$a,
  uploadDocument: uploadDocument$a,
  navbar: navbar$a,
  mandatedInfoModal: mandatedInfoModal$a,
  sideBar: sideBar$a,
  notifications: notifications$a,
  affiliates: affiliates$a,
  deleteCard: deleteCard$a,
  notificationPreferences: notificationPreferences$a,
  loginPage: loginPage$a,
  magicLink: magicLink$a,
  setPassword: setPassword$a,
  alerts: alerts$a,
  bottomNavBar: bottomNavBar$a,
  forceUpdate: forceUpdate$a,
  accessibility: accessibility$a,
  resetPassword: resetPassword$a
};
const common$9 = { "show": "Mostrar", "newPost": "Nueva publicación", "active": "Activo", "change": "Cambio", "remove": "Eliminar", "cancel": "Cancelar", "publish": "Publicar", "save": "Guardar", "draft": "Borrador", "scheduled": "Programado", "published": "Publicado", "actions": "Acciones", "archive": "Archivar", "delete": "Borrar", "edit": "Editar", "settings": "Configuración", "updatedOn": "Actualizado el", "blogPost": "Publicación de blog", "category": "Categoría", "author": "Autor", "status": "Estado", "errors": "Errores", "error": "Error", "all": "Todo", "add": "Añadir", "discussion": "Conversación", "allCourses": "Todos los cursos", "myCourses": "Mis cursos", "learning": "Aprendizaje", "leaderboard": "Tabla de clasificación", "documentsAndPayments": "Gestión de Documentos & Archivos", "more": "Más", "profile": "Perfil", "archived": " Archivado", "back": "Atrás", "restore": "Restaurar esta versión", "next": "Siguiente", "previous": "Anterior", "continue": "Continuar", "details": "Detalles", "youtube": "Youtube", "action": "Acción", "view": "Visualizar", "download": "Descargar", "source": "Fuente", "title_column": "Título", "copy": "Copiar", "viewReceipt": "Ver recibo", "id": "Id.", "location": "Ubicación", "email": "Correo electrónico", "title": "Título", "logout": "Cierre de sesión", "login": "Login", "calender": "Calendario", "apply": "Aplicar", "clear": "Borrar", "to": "A", "from": "De", "type": "Tipo", "home": "Inicio", "description": "Description", "updated": "Actualizado", "networkError": { "title": "Sin conexión a Internet", "message": "Compruebe su conexión a internet y vuelva a intentarlo." } };
const account$9 = { "settings": "Configuración de la cuenta", "updateSettings": "Actualice aquí la configuración de su cuenta", "paymentDetails": "Información del pago", "orderId": "ID de pedido interno", "nextInvoice": "Siguiente factura", "transactionDate": "Fecha de la transacción", "expiryDate": "Fecha de caducidad", "manageAllSubscription": "Gestione todas sus suscripciones", "paymentMethod": "Método de pago", "andTransactionHere": "& transacción aquí" };
const wallet$9 = { "transactionId": "Id. de la transacción" };
const support$9 = { "subscriptionId": "Id. de la suscripción", "email": { "validation": "Introduzca un correo electrónico válido" }, "invoiceNo": "Número de factura" };
const social$9 = { "title": "Redes sociales", "invalidURL": "URL no válida", "phoneNumber": "Número de teléfono", "userPhone": "Teléfono del usuario", "userEmail": "Correo electrónico del usuario", "info": "Información de redes sociales", "update": "Actualizar la información de redes sociales", "detailsHere": "Actualice los detalles de sus redes sociales aquí", "updated": "Redes sociales actualizadas", "visibility": "Visible públicamente", "validUrl": "Por favor, introduzca una URL válida", "validEmail": "Introduzca un correo electrónico válido", "validPhoneNumber": "Introduzca un número de teléfono válido con un código de país adecuado", "platforms": { "twitter": "Twitter", "instagram": "Instagram", "facebook": "Facebook", "youtube": "Youtube", "linkedin": "LinkedIn" } };
const validation$9 = { "phone": "Introduzca un teléfono válido", "url": "Introduzca una URL válida" };
const forms$9 = { "phone": "Número de teléfono" };
const auth$9 = { "clickToResend": "Hacer clic para reenviarlo", "authentication": "Autenticación", "didntGetCode": "¿No ha recibido ningún código?", "confirmationCode": "Código de verificación", "sentVerificationEmail": "Hemos enviado un código de verificación por correo electrónico a", "authenticateAccount": "Autentique su cuenta", "incorrectOrExpired": "la OTP es incorrecta o ha caducado", "failedToSend": "No se ha podido enviar la OTP", "checkEmailForSecureCode": "Compruebe su correo electrónico para obtener el código de seguridad. Si no has recibido ningún correo electrónico de nuestra parte,", "user": "Usuario", "verify": "Verificar", "tapHereToResend": "toque aquí para reenviarlo.", "failedToVerifyOtp": "No se ha podido verificar la OTP.", "failedToGetOtp": "No se ha podido obtener la OTP." };
const billing$9 = { "endingIn": "termina en", "billingInformation": "Información de facturación", "billingAddress": "Dirección de facturación:", "sourceType": "Tipo de fuente:", "invoices": "Facturas", "subscription": "Suscripción", "transactions": "Transacciones", "transaction": "Transacción", "subscriptions": "Suscripciones", "invoiceName": "Nombre de la factura", "subscriptionName": "Nombre de la suscripción", "dueDate": "Fecha de vencimiento", "issueDate": "Fecha de emisión", "amount": "Cantidad", "manageSubscriptions": "Gestione todas sus suscripciones", "andSubscription": "& Suscripción", "andTransaction": "& transacción aquí", "billing": "Facturación", "startDate": "Fecha de inicio", "fullName": "Nombre completo", "nextInvoiceOn": "Próxima factura el", "noDataFound": "No se han encontrado datos", "invoiceNo": "Factura n.º :", "manageSubscriptionsInvoicesAndTransactions": "Gestione suscripciones, facturas y transacciones", "created": "Creado el:", "transactionName": "Nombre de la transacción", "tid": "Hora:", "transactionDate": "Fecha de la transacción:", "trial": "Periodo de prueba", "expired": "Expirado", "pastDue": "Vencido", "unpaid": "No pagado", "incompleteExpired": "Incompleto caducado", "canceled": "Cancelado", "incomplete": "Incompleto", "failed": "Ha dado error", "sent": "Enviado", "paid": "Pagado", "paymentProcessing": "El pago se está procesando", "partiallyPaid": "Parcialmente pagado", "overdue": "Atrasado", "succeeded": "Correcto", "processing": "Procesando", "refunded": "Reembolsado", "pending": "Pendiente", "membership": "Suscripción", "communities": "Comunidades", "paymentLink": "Enlace de pago", "expiresOn": "Expira el", "errorFetchingPaymentMethods": "Error al obtener los métodos de pago", "pageUrl": "URL Página" };
const transactions$9 = { "title": "Transacciones", "name": "Nombre de las transacciones" };
const cancelModal$9 = { "subscriptionRenewNotice": "Si cambia de opinión, puede renovar su suscripción en cualquier momento.", "cancelSubscription": "Cancelar la suscripción", "subscriptionCancelNotice": "se cancelará inmediatamente. No se le volverá a cobrar.", "yourPlanName": "Su plan", "currentPlan": "Plan actual", "subscriptionCancelError": "Se ha producido un error al intentar cancelar la suscripción.", "cancelSubscriptionFailed": "No se ha podido cancelar la suscripción" };
const certificates$9 = { "title": "Certificados", "certificatesDescription": "Certificados Descargar y Compartir que Tú has ganado.", "subtitle": "Descargar tus certificados", "completedOn": "Hecho Activado", "back": "Atrás", "previous": "Anterior", "next": "Siguiente", "downloadYourCertificates": "Descargue sus certificados", "downloadCertificate": "Descargar {type}", "viewCertificates": "Vea y descargue todos sus certificados aquí", "certificateNotFound": "No hay certificado encontrado", "issuedOn": "Emitido Activado", "expiresOn": "Expira Activado", "description": "Descripción", "yourCertificateHasExpiredOn": "Tu {type} ha caducado activado", "issuedCertificatesNotFound": "Todavía no Tú obtenido ningún certificado.", "shareCertificate": "Compartir:", "preview": { "issuedTo": "Emitido a", "issuedBy": "Emitido vía", "addToLinkedin": "Añadir al perfil de LinkedIn", "download": "Descargar", "credentialVerification": "Verificación de Credenciales", "issueDate": "Fecha de emisión", "expiryDate": "Fecha de caducidad", "verifyCredential": "Verificar Credencial", "shareYourCredential": "Comparta su credencial", "showYourCredential": "Mostrar su credencial en sus Redes sociales", "expiredOn": "Fecha de caducidad", "expiredDesc": "Es hora de renovar y mantenerse al día. No se pierda los beneficios continuos y los Clientes potenciales.", "verificationModal": { "title": "Verificación de Credenciales", "subtitle": "Esta es la credencial válida", "description": " Esta credencial fue emitida de forma segura. Todos los Detalles mostrados son válidos.", "step1": { "title": "Verificando al destinatario", "description": "El Propietario de esta credencial es {recipient}" }, "step2": { "title": "Verificando el emisor", "description": "Esta credencial fue emitida por  {issuer}" }, "step3": { "title": "Verificación del ID de la credencial", "description": "La Etiqueta {credentialId} es única y válida." } }, "notFound": { "title": "¡Vaya! Certificado no encontrado.", "description": "El Certificado que Tú estás intentando Ver no está disponible.", "subtitle": "Póngase en contacto con el emisor para obtener ayuda." } }, "share": { "title": "Tu Certificado", "text": "aquí está tu Certificado", "dialogTitle": "Compartir O Archivar tu Certificado" }, "listing": { "courseAssignmentName": "Nombre del curso/área", "offlineCertification": "Certificación fuera de línea", "completionDate": "Fecha final", "expiryDate": "Fecha de Caducidad", "type": "Tipo", "sourceName": "Nombre de la Fuente", "action": "Acción" } };
const changePassword$9 = { "showPasswords": "Mostrar contraseñas", "retypePassword": "Vuelva a escribir la contraseña", "newPassword": "Nueva contraseña", "confirmNewPassword": "Confirm New Password", "currentPassword": "Contraseña actual", "emailId": "Id. del correo electrónico", "passwordMinLength": "Introduzca una contraseña de al menos 8 caracteres", "editAccount": "Editar cuenta", "loginEmail": "Correo electrónico de inicio de sesión", "loginInformation": "Información de inicio de sesión", "accountDetails": "Detalles de la cuenta", "accountDetailsUpdate": "Actualice aquí los datos de su cuenta", "accountInformation": "Detalles de la cuenta", "changePassword": "Cambiar la contraseña", "hidePasswordChange": "Ocultar cambiar la contraseña", "selectPageError": "Vuelva a intentarlo más tarde", "systemErrorOccurred": "Algo ha ido mal", "passwordEntryInvalid": "Contraseña no válida", "passwordUpdateSuccess": "Contraseña actualizada", "passwordLengthRequired": "Introduzca una contraseña de al menos 8 caracteres", "passwordMinimumLength": "Introduzca una contraseña de al menos 8 caracteres", "passwordFieldRequired": "La contraseña es obligatoria", "password": "Contraseña" };
const deleteAccount$9 = { "title": "Borrar Cuenta", "deleteAccountDescription": "Tu Cuenta está Programado para desactivación temporal y será Eliminado permanentemente Si Tú no inicias in en los Próximos 7 días.", "deleteAccountDescription2": "Para mantener tu Cuenta Dinámico, simplemente inicia in Antes de la fecha límite. Una vez eliminado, tus datos no se pueden recuperar.", "deleteAccountButton": "Sí, Borrar la Cuenta" };
const chats$9 = { "viewAll": "Ver todo", "viewLess": "Ver menos", "updatedPreference": "Preferencia actualizada", "chatSettings": "Configuración del chat", "chats": "Chats", "chatSettingsDescription": "Seleccione la configuración del chat para sus grupos y amigos.", "groups": "Grupos", "blockedUsers": "Usuarios bloqueados", "noGroups": "No hay grupos", "controlUsers": "Gestione con qué usuarios no desea chatear.", "blockedConversations": "Conversaciones bloqueadas", "noBlockedUsers": "No hay usuarios bloqueados", "unblock": "Desbloquear", "noUsersBlocked": "No hay usuarios bloqueados", "noGroupsJoined": "No se ha unido a ningún grupo", "controlGroups": "Controle qué usuarios del grupo pueden ponerse en contacto con usted activando o desactivando su disponibilidad de chat a continuación. Solo puede recibir mensajes de los miembros del grupo del que forma parte. " };
const payments$9 = { "shareLink": "Compartir el enlace", "paymentLink": "Enlace de pago" };
const profileSettings$9 = { "complete": "COMPLETAR", "editBasicInformation": "Editar la información básica", "writeAboutYourself": "Escriba algo acerca de usted...", "selectTimezone": "Seleccionar la zona horaria", "description": "Esto se mostrará en su perfil", "timezone": "Zona horaria", "enterLocation": "Introduzca la ubicación", "exampleDescription": "Ejemplo: Hola, soy José Pérez y soy fotógrafo.", "enterABriefDescription": "Introduzca una breve descripción", "bio": "Biografía", "profileSlugNotAvailable": "Slug del perfil no disponible", "findAndShareProfile": "Descubra y comparta su perfil fácilmente con un slug de URL personalizado.", "profileSlug": "Slug del perfil", "enterTitle": "Introduzca un título", "enterFullName": "Introduzca el nombre completo", "basicDetails": "Detalles básicos", "updateProfileDetails": "Actualice los detalles de su perfil aquí", "basicInformation": "Información básica", "updatedProfileSettings": "Configuración del perfil actualizada", "uploadStatusCode": "La carga ha fallado con el código de estado", "imageTypeNotSupported": "Tipo de imagen no compatible", "nameIsRequired": "El nombre es obligatorio", "invalidName": "Nombre no válido", "profileImage0": "Foto del perfil", "profileImage": "Foto del perfil", "uploadSvgPngJpg": "Suba un archivo SVG, PNG, JPG. Relación de aspecto recomendada 1:1", "profilesBuildConnection": "Los perfiles fomentan la confianza y la conexión con los demás", "clientPortalNames": "El portal del cliente se ve raro sin una cara ni un nombre.", "completeYourProfile": "Complete su perfil", "uploadFailed": "La carga ha fallado", "fileSizeTooLarge": "El tamaño del archivo es demasiado grande", "invalidFileFormatType": "Formato o tipo de archivo no válido.", "pleaseUploadImage": "Suba una imagen de tipo SVG, PNG, JPG o JPEG.", "pleaseUploadAFileLessThan100Mb": "Suba un archivo de menos de 100 MB.", "oopsUnableToUploadImage": "¡Vaya! No se ha podido subir la imagen.", "selectPageError": "Vuelva a intentarlo más tarde", "search": "Buscar", "searchTimezones": "Buscar zonas horarias", "noTimezonesFound": "No se han encontrado zonas horarias", "editDetails": "Editar los detalles", "profilePicture": "Foto del perfil", "profileCover": "Portada del perfil", "uploadPhoto": "Subir foto", "removePhoto": "Extraer foto", "invalidAspectRatio": "Relación de aspecto no válida", "recommendedAspectRatio169": "Relación de aspecto recomendada 16:9", "recommendedAspectRatio11": "Relación de aspecto recomendada 1:1", "editProfile": "Editar perfil", "manageYourGroupDetailsHere": "Gestione los detalles de su grupo aquí", "profileIcon": "Icono de perfil", "specialCharactersNotSupported": "No se admiten caracteres especiales", "slugValidation": { "containSpecialCharacters": "Slug no puede contener caracteres especiales", "tooShort": "Slug debe tener al menos 3 caracteres de largo", "tooLong": "Slug debe tener menos de 50 caracteres de longitud", "containOnlyNumbers": "El Slug no puede contener solo números", "startWithNumber": "Slug no puede empezar por un número", "startWithHyphen": "Slug no puede empezar por un guión", "endWithHyphen": "Slug no puede ser final con un guión", "containDoubleHyphen": "El Slug no puede contener guiones dobles", "containSpace": "Slug no puede contener Espacio" } };
const languageSettings$9 = { "title": "Configuración de idioma", "detailsHere": "Seleccionar el idioma del portal del cliente", "selectLanguage": "Seleccione el idioma", "useLocationLanguage": "Usar el Idioma de la Ubicación", "languagePreferenceUpdated": "Preferencia de idioma actualizada", "errorUpdatingLanguage": "Error al actualizar el idioma", "description": "Seleccione su idioma preferido para visualizar los elementos del portal del cliente, el contenido multimedia de la comunidad, los cursos y la información de afiliado. Este ajuste le permite ver el contenido multimedia en el idioma con el que se sienta más cómodo. ", "shortDescription": "Seleccione su idioma preferido" };
const userActivityOverview$9 = { "dustBunnies": "Nada que ver, a menos que le gusten las bolitas de polvo.", "welcomeBanner": "Le damos la bienvenida a", "contracts": "Contratos", "hiUser": "Hola", "estimates": "Estimaciones", "sharedFiles": "Archivos compartidos" };
const widget$9 = { "viewAll": "Ver todo", "addedOn": "Añadido el", "by": "Vía", "you": "Tú", "admin": "Administrador", "youDoNotHaveAny": "¡No tiene ninguno!", "noContracts": "Sin contratos", "maxFilesExceeded": "Tú solo puedes Subir hasta 10 Archivos", "uploadFile": "Subir Archivo", "userActivityOverview.contracts": "Contratos", "selectPageError": "Vuelva a intentarlo más tarde", "notAbleToDownloadContract": "No se puede descargar el contrato", "completeCourse": "Curso completo", "courseProgress": "Progreso del curso", "viewAllGroups": "Ver todos los grupos", "recentlyOpened": "Recientemente abierto", "noInvoices": "No hay facturas", "noEstimates": "Sin estimaciones", "notAbleToDownloadInvoice": "No se puede descargar la factura", "contracts": "Contratos", "invoices": "Facturas", "youMarked": "Usted marcó", "inCourse": "en curso", "invoice": "Factura", "makePayment": "Efectuar el pago", "downloadInvoice": "Descargar la factura", "viewGroup": "Ver grupo", "payment": "Pago", "download": "Descargar", "signContract": "Símbolos Trato", "sign": "Símbolos", "estimates": "Estimaciones", "notAbleToDownloadEstimate": "No se puede Descargar la Estimación", "addFiles": "Añadir Archivos", "sharedFiles": "Archivos compartidos", "fileManagement": "Gestión de Documentos", "noFiles": "No hay Archivos" };
const dashboard$9 = { "joinAGroup": "Únase a un grupo", "takeACourse": "Complete un curso", "checkAffiliateEarnings": "Verifique las ganancias de los afiliados", "manageSubscriptions": "Gestione las suscripciones", "contracts": "Contratos", "estimates": "Estimaciones", "sharedFiles": "Archivos compartidos", "paidOn": "Pagado el", "partiallyPaidOn": "Parcialmente pagado el", "overdueSince": "Atrasado desde", "dueOn": "Pendiente el", "hello": "Hola", "viewGroup": "Ver Grupo", "recentlyOpened": "Recientemente abierto", "noItemsYet": "¡Todavía no tiene ninguno!", "affiliates": "Afiliados", "exploreHere": "Explore aquí", "selectApp": "Seleccione su aplicación", "exploreCourses": "Explore los cursos disponibles", "courses": "Cursos", "engageCommunity": "Participe en la comunidad", "communities": "Comunidades", "noDataAvailable": "No hay datos disponibles en el minuto", "noAppsAvailable": "No hay aplicaciones disponibles", "noWidgetsAvailable": "No hay widgets para Visualización", "noContentAvailable": "No hay contenido disponible" };
const uploadDocument$9 = { "uploadHeader": "Añadir Archivos", "uploadDescription": "Seleccione y suba hasta 10 documentos", "uploadWarning": "Esto será visible para el Portal Administrador para Ver y Descargar", "uploadInstruction": "Haga clic para subir o arrastre y suelte", "allowedFiles": "DOC, PNG, JPG , GIF , PPT O PDF (Máx.. 100 MB)", "cancelButton": "Cancelar", "uploadButton": "Subir", "confirmDeletion": "Guardar Deletion", "deleteFile": "Borrar Archivo", "deleteFileDescription": "¿Estás seguro de que quieres borrar este Archivo? Esta acción no se puede deshacer.", "deleteFileButton": "Sí, Borrar el Archivo", "deleteFileSuccessTitle": "Archivo Eliminado correctamente", "deleteFileErrorTitle": "Error in Eliminar Archivo", "deleteFileErrorMessage": "Se ha producido un Error al intentar eliminar el Archivo.", "cancel": "Nulo", "notAbleToDownloadFile": "No se puede descargar Archivo", "fileSizeExceeded": "El tamaño del archivo supera los 100 MB", "invalidFileType": "No hay archivo válido tipo", "notAbleToUploadFile": "No se puede subir Archivo", "downloadError": "Error in descargar Archivo", "fileUploadedSuccessfully": "El Archivo se ha subido correctamente", "fileDownloadedSuccessfully": "Archivo Descargar con éxito" };
const navbar$9 = { "hi": "Hola", "manageYourAccount": "Gestione su cuenta", "logOut": "Cerrar sesión", "affiliates": "Afiliados", "courses": "Cursos", "communities": "Comunidades" };
const mandatedInfoModal$9 = { "invalidFileFormat": "Formato o tipo de archivo no válido.", "pleaseUploadImage": "Suba una imagen de tipo SVG, PNG, JPG, JPEG", "fileSizeTooLarge": "El tamaño del archivo es demasiado grande", "oopsUnableToUploadImage": "¡Vaya! No se ha podido subir la imagen.", "pleaseUploadFileLessThan100MB": "Por favor, suba un archivo de menos de 100 MB", "pleaseTryAgainLater": "Vuelva a intentarlo más tarde", "completeYourProfile": "Complete su Perfil", "profilesBuildConnection": "Los perfiles fomentan la confianza y la conexión con los demás", "putAFaceToYourProfile": "¡Póngale cara a su perfil!", "uploadASVGPNGJPG": "Suba un archivo SVG, PNG, JPG.", "recommendedAspectRatio11": "Relación de aspecto recomendada 1:1", "complete": "COMPLETAR", "cropYourAvatar": "Recorte su avatar", "dragToReposition": "Arrastrar para cambiar de posición" };
const sideBar$9 = { "languageSettings": "Configuración de idioma", "profile": "Perfil", "account": "Cuenta", "socialMedia": "Redes sociales", "certificates": "Certificados", "billingSubscription": "Facturación y suscripción", "communitiesChats": "Comunidades y Chats", "affiliates": "Afiliados", "notifications": "Recordatorio" };
const notifications$9 = { "title": "Notificaciones", "all": "Todos", "unread": "No leído", "markAllRead": "Marcar todo como leído", "noNotifications": "Aún no hay notificaciones", "whenYouGetNotifications": "Cuando reciba notificaciones, se mostrarán aquí" };
const affiliates$9 = { "payoutMethod": "Método de Pago", "leadCustomer": "Clientes potenciales/Clientes", "commissions": "Comisiones", "description": "Remita a los usuarios a GoKollab", "title": "Afiliados", "groupsGoKollab": "Crear grupos en GoKollab es completamente gratis, ¡pero eso es solo el comienzo! Nuevas y emocionantes funciones están en camino para ayudarle a hacer crecer su negocio en línea y aumentar sus ingresos. A medida que los usuarios actualicen para desbloquear el conjunto completo de funciones, usted recibirá una comisión recurrente de afiliado de por vida sobre su suscripción. Cuanto antes empiece a recomendar, mejor. No se pierda este increíble programa de afiliados", "yourAffiliateLink": "Su enlace de afiliado" };
const deleteCard$9 = { "deleteCard": "Eliminar tarjeta", "description": "El método de pago ya no se podrá utilizar después de eliminarlo. Esta acción no se puede deshacer.", "activeCard": "Esta tarjeta se utiliza para realizar pagos de una o más suscripciones activas. Eliminar esta tarjeta sin actualizar el método de pago de las suscripciones asociadas afectará a los pagos futuros. ¿Seguro que desea eliminar esta tarjeta?", "title": "¿Desea eliminar el método de pago?", "cardCannotBeDeleted": "La tarjeta no se puede eliminar", "cardIsLinkedToSubscriptions": "La tarjeta está vinculada a las suscripciones", "errorInDeletingCard": "Error al eliminar la tarjeta", "noCardAvailable": "No hay tarjeta disponible", "cardRemovedSuccessfully": "La tarjeta se ha eliminado correctamente" };
const notificationPreferences$9 = { "title": "Notificación Configuración", "description": "Gestionar cuando y por qué tú eres notificado", "pushNotificationsTitle": "Push Recordatorio", "pushNotificationsDescription": "Gestionar push Recordatorio", "emailNotificationsTitle": "Correo electrónico Recordatorio", "emailNotificationsDescription": "Gestionar correo electrónico Recordatorio", "emailNotifications": "Correo electrónico Recordatorio", "manageEmailNotifications": "Gestionar correo electrónico Recordatorio", "newActivity": "Nueva actividad", "email": "Correo electrónico", "push": "Empujar", "allNotifications": "cada Recordatorio", "postTags": "Compartir Palabras clave", "postEveryoneTagged": "Compartir {'@'}Todas las palabras clave", "postMention": "Compartir {'@'}Mención", "postLike": "Compartir Me gusta", "newComment": "Nuevo comentario", "commentEveryoneTagged": "Comentar {'@'}Todas las palabras clave", "commentMention": "Comentar {'@'}Mención", "commentLike": "Comentar Me gusta", "postEveryoneTaggedMobile": "Compartir {'@'}Todas las palabras clave", "postMentionMobile": "Compartir {'@'}Mención", "commentEveryoneTaggedMobile": "Comentar {'@'}Todas las palabras clave", "commentMentionMobile": "Comentar {'@'}Mención", "newMemberRequestToJoinGroup": "Nuevos miembros Solicitudes para unirse al Grupo", "groupJoiningRequestApproved": "Grupo Uniéndose a Solicitudes Aceptado", "groupJoiningRequestRejected": "Grupo Unirse a Solicitudes Negado", "roleUpdatedInPrivateChannel": "Rol actualizado in el Canal Privado", "newCourseAvailable": "Nuevo curso añadido al Grupo", "newEventCreated": "Nuevo Evento Creada", "newCourseComment": "Nuevo comentario del curso", "certificateIssued": "Certificado Emitido", "postEveryoneTaggedDescription": "Cuando alguien publique {'@'}Todas las palabras clave", "postMentionDescription": "Cuando alguien publique, {'@'}mencionar", "postLikeDescription": "Cuando alguien Me gusta (en plural, los me gusta) tu Compartir", "newCommentDescription": "Cuando alguien comentario/opinión Activado tu Compartir", "commentEveryoneTaggedDescription": "Cuando alguien comentario/opinión {'@'}Todas las palabras clave", "commentMentionDescription": "Cuando alguien comenta/opinión {'@'}menciona", "commentLikeDescription": "Cuando alguien Me gusta (en plural, los me gusta) tu comentario", "newMemberRequestToJoinGroupDescription": "Cuando alguien Solicitudes para unirse a tu Grupo", "groupJoiningRequestApprovedDescription": "Cuando se acepta el grupo de alguien que se une a solicitudes", "groupJoiningRequestRejectedDescription": "Cuando el grupo de alguien que se une a Solicitudes es Negado", "roleUpdatedInPrivateChannelDescription": "Cuando el rol de alguien está Actualizado in un canal Privado", "newCourseAvailableDescription": "Cuando hay un Nuevo curso disponible", "newEventCreatedDescription": "Cuando a Nuevo Evento se Crea", "newCourseCommentDescription": "Cuando alguien comentario/opinión Activado un curso", "certificateIssuedDescription": "Cuando a Certificado es Emitido", "estimateReceivedDescription": "Cuando se ha recibido una nueva estimación", "contractReceivedDescription": "Cuando se ha recibido un nuevo Trato", "invoiceReceivedDescription": "Cuando se recibe una nueva factura", "allEmailNotificationsDescription": "Girar Activado/Deshabilitado cada Correo electrónico Recordatorio", "allPushNotificationsDescription": "Girar Activado/Deshabilitado cada push Recordatorio", "errorUpdating": "Se ha producido un error al actualizar tu Notificación Configuración", "updateSuccess": "Tus Notificación Configuración se han actualizado", "willNotReceiveNotificationsIfAdminDisabled": "Tú no Heredarás el Recordatorio para la Configuración Deshabilitado Vía tu administrador.", "estimateReceived": "Nueva Estimación Recibido", "contractReceived": "Nuevo Trato Recibido", "invoiceReceived": "Nueva Factura Recibido", "pushNotificationNotAvailable": "La notificación automática no está disponible para este Evento", "newsletter": "Boletín", "emailNotificationNotAvailable": "La Notificación automática por Email no está disponible para este Evento", "newPostFollowers": "Nuevo mensaje del Usuario que Seguimos", "newPostFollowersDescription": "Recibe una notificación cuando alguien a quien sigues crea una nueva publicación.", "newFollower": "Recibe una notificación cuando alguien te siga." };
const loginPage$9 = { "forgotPassword": "¿Olvidaste la contraseña?", "login": "Iniciar sesión", "lastLogin": "última sesión", "proceedToLogin": "Proceder al Iniciar sesión", "secureCode": "Código seguro", "newUser": "¿Nuevo Usuario?", "resetPasswordLink": "Si el correo electrónico introducido es correcto, heredar un Restablecer password Enlace in el correo electrónico. Asegúrate también de la carpeta de correo no deseado a Marca de verificación.", "loginWithSecureCode": "Iniciar sesión con Código seguro", "signUp": "Regístrate", "enterOtp": "Introducir OTP", "selectAccount": "Seleccionar qué Cuenta Tú quieres", "resetPassword": "Restablecer contraseña", "selectUser": "Seleccionar Usuario", "emailRequired": "Por favor, introduzca un correo electrónico válido", "fullNameRequired": "Introduce tu nombre", "passwordRequired": "Por favor, introduce una password de Mín. 8 Carácter", "generateSecureCode": "Generar Código seguro", "loginWithPassword": "Iniciar sesión con contraseña", "secureCodeEmail": "Por favor, Marca de verificación de tu Correo electrónico para obtener el Código seguro. Si tú no heredaste ningún correo electrónico de nosotros,", "resendOtp": "tap aquí para Reenviar.", "verifySecureCode": "Verificar el Código de seguridad", "secureCodeNumeric": "El código de seguridad debe ser un Numérico Valor y debe tener 6 dígitos", "alreadyHaveAccount": "¿Ya tienes una Cuenta?", "email": "Correo electrónico", "password": "Contraseña", "fullName": "Nombre Completo", "somethingWentWrong": "Algo ha ido mal", "signInWithEmail": "O, Iniciar sesión con tu Correo electrónico", "signUpWithEmail": "O regístrate con tu correo electrónico", "confirmPassword": "Confirmar la contraseña", "validationErrors": { "potentialSpamUser": { "title": "Cuenta Privado", "message": "Tu cuenta ha sido privada debido a una potencial actividad no deseada. Ponte en contacto con el servicio de asistencia para obtener ayuda." }, "somethingWentWrong": { "title": "Algo ha ido mal", "message": "No se ha podido iniciar sesión. Por favor, Vuelva a intentarlo más tarde." }, "bannedUser": { "title": "Cuenta Privado", "message": "Tu cuenta ha sido vetada debido a una potencial actividad no deseada. Ponte en contacto con el servicio de asistencia para obtener ayuda." } } };
const magicLink$9 = { "newLinkSent": "Nuevo Enlace enviado", "portalWillSendLink": "Portal subir a un nuevo enlace a tu Dirección de correo electrónico", "failedToSendNewLink": "Error al subir el Nuevo Enlace", "pleaseTryAgain": "Por favor, Vuelve a intentarlo", "linkExpired": "Este enlace de tu correo electrónico ha caducado.", "toContinue": "Para continuar, Solicitudes a Nuevo Enlace O Inicia in en tu Portal Cuenta", "sendNewLink": "Subir Nuevo Enlace", "logIn": "in", "clickToLogIn": "hacer clic aquí para Iniciar in en tu Portal Cuenta", "invalidToken": "Este Token de tu correo electrónico no es válido.", "toContinueContactAdmin": "Para continuar, Solicitudes a Nuevo Enlace mágico Contacto Administrador O Inicia in en tu Portal Cuenta" };
const setPassword$9 = { "minLength": "Por favor, introduce una password de Mín. 8 Carácter", "passwordsMustMatch": "Las contraseñas deben coincidir", "setSecurePassword": "Colección tu passwordsegura", "setPasswordButton": "Contraseña de la colección" };
const alerts$9 = { "tooManyAttempts": { "title": "Demasiados intentos", "message": "No se permiten más de 2 intentos de actualización de Slug in una ventana de mes" }, "slugAlreadyExists": { "title": "El Slug ya existe", "message": "Inténtalo con un Slug diferente" }, "updateSlugError": { "title": "Algo ha ido mal", "message": "No se ha podido actualizar el Perfil Slug. Inténtalo Después alguna Fecha" }, "updateProfileError": { "title": "Algo ha ido mal", "message": "No se ha podido actualizar el perfil detalles. Inténtalo Después alguna Fecha" } };
const bottomNavBar$9 = { "home": "Inicio", "discover": "Descubrir", "communities": "Comunidades", "courses": "Cursos", "more": "Más" };
const forceUpdate$9 = { "title": "Nuevo ACTUALIZACIÓN ESTÁ DISPONIBLE", "description": "Actualizar tu aplicación a la última Versión", "buttonText": "¡Actualizar ahora!" };
const accessibility$9 = { "copyAffiliateLink": "Copiar Afiliado Enlace al portapapeles", "deleteCard": "Borrar tarjeta", "appSwitcher": "Conmutador de Aplicación", "portalImage": "Imagen del Portal", "profileImage": "Imagen de Perfil", "continueWithGoogle": "Continuar con Google" };
const resetPassword$9 = { "passwordExpired": "Su password Restablecer Enlace ha caducado.", "regenerateLink": "Regenerar Enlace", "proceedToLogin": "Proceder al Iniciar sesión", "passwordChangedSuccessfully": "La contraseña dinámica se ha realizado correctamente", "changePassword": "Cambiar contraseña", "newPassword": "Por favor, introduce una password de Mín. 8 Carácter", "confirmPassword": "La confirmación password no coincide", "setNewPassword": "Colección Nueva Contraseña", "confirmNewPassword": "Confirmar la nueva contraseña" };
const es = {
  common: common$9,
  account: account$9,
  wallet: wallet$9,
  support: support$9,
  social: social$9,
  validation: validation$9,
  forms: forms$9,
  auth: auth$9,
  billing: billing$9,
  transactions: transactions$9,
  cancelModal: cancelModal$9,
  certificates: certificates$9,
  changePassword: changePassword$9,
  deleteAccount: deleteAccount$9,
  chats: chats$9,
  payments: payments$9,
  profileSettings: profileSettings$9,
  languageSettings: languageSettings$9,
  userActivityOverview: userActivityOverview$9,
  widget: widget$9,
  dashboard: dashboard$9,
  uploadDocument: uploadDocument$9,
  navbar: navbar$9,
  mandatedInfoModal: mandatedInfoModal$9,
  sideBar: sideBar$9,
  notifications: notifications$9,
  affiliates: affiliates$9,
  deleteCard: deleteCard$9,
  notificationPreferences: notificationPreferences$9,
  loginPage: loginPage$9,
  magicLink: magicLink$9,
  setPassword: setPassword$9,
  alerts: alerts$9,
  bottomNavBar: bottomNavBar$9,
  forceUpdate: forceUpdate$9,
  accessibility: accessibility$9,
  resetPassword: resetPassword$9
};
const common$8 = { "show": "Näytä", "newPost": "Uusi julkaisu", "active": "Aktiivinen", "change": "Muuta", "remove": "Poista", "cancel": "Peruuta", "publish": "Julkaise", "save": "Tallenna", "draft": "Luonnos", "scheduled": "Ajoitettu", "published": "Julkaistu", "actions": "Toiminnot", "archive": "Arkistoi", "delete": "Poista", "edit": "Muokkaa", "settings": "Asetukset", "updatedOn": "Päivitetty", "blogPost": "Blogijulkaisu", "category": "Kategoria", "author": "Tekijä", "status": "Tila", "errors": "Virheet", "error": "Virhe", "all": "Kaikki", "add": "Lisää", "discussion": "Keskustelu", "allCourses": "Kaikki kurssit", "myCourses": "Omat kurssit", "learning": "Oppiminen", "leaderboard": "Tulostaulu", "documentsAndPayments": "Asiakirjojen ja tiedostojen hallinta", "more": "Lisää", "profile": "Profiili", "archived": " Arkistoitu", "back": "Takaisin", "restore": "Palauta tämä versio", "next": "Seuraava", "previous": "Edellinen", "continue": "Jatka", "details": "Tiedot", "youtube": "Youtube", "action": "Toiminta", "view": "Katso", "download": "Lataa", "source": "Lähde", "title_column": "Otsikko", "copy": "Kopioi", "viewReceipt": "Näytä kuitti", "id": "Tunnus", "location": "Sijainti", "email": "Sähköposti", "title": "Otsikko", "logout": "Kirjaudu ulos", "login": "Login", "calender": "Kalenteri", "apply": "Käytä", "clear": "Tyhjennä", "to": "Vastaanottaja", "from": "Lähettäjä", "type": "Tyyppi", "home": "Koti", "description": "Description", "updated": "Päivitetty", "networkError": { "title": "Ei internetyhteyttä", "message": "Tarkista internetyhteytesi ja yritä uudelleen." } };
const account$8 = { "settings": "Tilin asetukset", "updateSettings": "Päivitä tilisi asetukset tässä", "paymentDetails": "Maksutiedot", "orderId": "Sisäinen tilaustunnus", "nextInvoice": "Seuraava lasku", "transactionDate": "Transaktiopäivä", "expiryDate": "Vanhenemispäivä", "manageAllSubscription": "Hallinnoi kaikkia tilauksiasi", "paymentMethod": "Maksutapa", "andTransactionHere": "ja transaktio tässä" };
const wallet$8 = { "transactionId": "Transaktiotunnus" };
const support$8 = { "subscriptionId": "Tilaustunnus", "email": { "validation": "Anna hyväksyttävä sähköpostiosoite" }, "invoiceNo": "Laskun numero" };
const social$8 = { "title": "Sosiaalinen media", "invalidURL": "Virheellinen URL-osoite", "phoneNumber": "Puhelinnumero", "userPhone": "Käyttäjän puhelinnumero", "userEmail": "Käyttäjän sähköpostiosoite", "info": "Sosiaalisen median tiedot", "update": "Päivitä sosiaalisen median tiedot", "detailsHere": "Päivitä sosiaalisen median tietosi tässä", "updated": "Sosiaalinen media päivitetty", "visibility": "Julkisesti näkyvissä", "validUrl": "Anna oikeassa muodossa oleva URL-osoite", "validEmail": "Anna kelvollinen sähköpostiosoite", "validPhoneNumber": "Anna kelvollinen puhelinnumero ja sopiva maakoodi", "platforms": { "twitter": "Twitter", "instagram": "Instagram", "facebook": "Facebook", "youtube": "Youtube", "linkedin": "LinkedIn" } };
const validation$8 = { "phone": "Anna kelvollinen puhelinnumero", "url": "Anna kelvollinen URL-osoite" };
const forms$8 = { "phone": "Puhelinnumero" };
const auth$8 = { "clickToResend": "Lähetä uudelleen napsauttamalla", "authentication": "Todennus", "didntGetCode": "Etkö saanut koodia?", "confirmationCode": "Vahvistuskoodi", "sentVerificationEmail": "Olemme lähettäneet vahvistuskoodin sähköpostitse osoitteeseen", "authenticateAccount": "Todenna tilisi", "incorrectOrExpired": "Otp on virheellinen tai vanhentunut", "failedToSend": "Otp:n lähettäminen epäonnistui", "checkEmailForSecureCode": "Tarkista sähköpostistasi suojauskoodi. Jos et ole saanut meiltä sähköpostia,", "user": "Käyttäjä", "verify": "Tarkista", "tapHereToResend": "lähetä uudelleen napauttamalla tätä.", "failedToVerifyOtp": "OTP:n tarkistaminen epäonnistui", "failedToGetOtp": "OTP:n hankkiminen epäonnistui" };
const billing$8 = { "endingIn": "päättyy", "billingInformation": "Laskutustiedot", "billingAddress": "Laskutusosoite:", "sourceType": "Lähteen tyyppi:", "invoices": "Laskut", "subscription": "Tilaus", "transactions": "Transaktiot", "transaction": "Transaktio", "subscriptions": "Tilaukset", "invoiceName": "Laskun nimi", "subscriptionName": "Tilauksen nimi", "dueDate": "Eräpäivä", "issueDate": "Julkaisupäivä", "amount": "Määrä", "manageSubscriptions": "Hallinnoi kaikkia tilauksiasi", "andSubscription": "ja tilaus", "andTransaction": "ja transaktio tässä", "billing": "Laskutus", "startDate": "Aloituspäivämäärä", "fullName": "Koko nimi", "nextInvoiceOn": "Seuraavan laskun päivämäärä", "noDataFound": "Tietoja ei löytynyt", "invoiceNo": "Lasku nro:", "manageSubscriptionsInvoicesAndTransactions": "Hallinnoi tilauksia, laskuja ja transaktioita", "created": "Luotu:", "transactionName": "Transaktion nimi", "tid": "T-tunnus:", "transactionDate": "Transaktiopäivä:", "trial": "Kokeilu", "expired": "Päättynyt", "pastDue": "Erääntynyt", "unpaid": "Maksamaton", "incompleteExpired": "Keskeneräinen ja vanhentunut", "canceled": "Peruutettu", "incomplete": "Keskeneräinen", "failed": "Hylätty", "sent": "Lähetetty", "paid": "Maksettu", "paymentProcessing": "Maksua käsitellään", "partiallyPaid": "Osittain maksettu", "overdue": "Erääntynyt", "succeeded": "Onnistunut", "processing": "Käsitellään", "refunded": "Hyvitetty", "pending": "Odottaa", "membership": "Jäsenyys", "communities": "Yhteisöt", "paymentLink": "Maksulinkki", "expiresOn": "Vanhentuu", "errorFetchingPaymentMethods": "Virhe maksutapojen noutamisessa", "pageUrl": "Sivu URL-osoite" };
const transactions$8 = { "title": "Transaktiot", "name": "Transaktioiden nimi" };
const cancelModal$8 = { "subscriptionRenewNotice": "Jos muutat mieltäsi, voit uusia tilauksesi milloin tahansa.", "cancelSubscription": "Peruuta tilaus", "subscriptionCancelNotice": "peruutetaan heti. Sinua ei veloiteta uudelleen.", "yourPlanName": "Sinun suunnitelmasi", "currentPlan": "Tämänhetkinen aikataulu", "subscriptionCancelError": "Tilausta peruutettaessa tapahtui virhe.", "cancelSubscriptionFailed": "Tilauksen peruuttaminen epäonnistui" };
const certificates$8 = { "title": "Sertifikaatit", "certificatesDescription": "Sinä/Te on ansainnut Ladata & Jakaa -sertifikaatit.", "subtitle": "Ladata sertifikaatit", "completedOn": "Tehty Päällä", "back": "Takaisin", "previous": "Edellinen", "next": "Seuraava", "downloadYourCertificates": "Lataa sertifikaatit", "downloadCertificate": "Ladata {type}", "viewCertificates": "Katso ja lataa kaikki sertifikaatit täältä", "certificateNotFound": "Ei Sertifikaattia löytääty", "issuedOn": "Julkaistu Päällä", "expiresOn": "Päättyä Päällä", "description": "Kuvaus", "yourCertificateHasExpiredOn": "{type} on Vanhentunut Päällä", "issuedCertificatesNotFound": "Sinä/Te ole vielä ansainnut yhtään sertifikaattia.", "shareCertificate": "Jakaa:", "preview": { "issuedTo": "Julkaisun vastaanottaja", "issuedBy": "Julkaisija", "addToLinkedin": "Lisää LinkedIn-profiiliin", "download": "Lataa", "credentialVerification": "Tunnistetietojen vahvistus", "issueDate": "Julkaisupäivä", "expiryDate": "Päättymispäivä", "verifyCredential": "Tarkista tunnistetiedot", "shareYourCredential": "Jaa tunnistetiedot", "showYourCredential": "Näytä tunnistetiedot omassa sosiaalisessa verkostossa", "expiredOn": "Päättynyt", "expiredDesc": "On aika uudistua ja pysyä ajan tasalla. Älä jää paitsi jatkuvista eduista ja liideistä.", "verificationModal": { "title": "Tunnistetietojen vahvistus", "subtitle": "Nämä ovat voimassa olevat tunnistetiedot.", "description": " Nämä tunnistetiedot on julkaistu turvallisesti. Kaikki näytetyt tiedot ovat voimassa.", "step1": { "title": "Vastaanottajan vahvistaminen", "description": "Näiden tunnistetietojen haltija on {recipient}" }, "step2": { "title": "Julkaisijan vahvistaminen", "description": "Nämä tunnistetiedot on julkaissut {issuer}" }, "step3": { "title": "Vahvistetaan tunnistetietojen tunnus", "description": "Tunniste {credentialId} on yksilöllinen ja voimassa." } }, "notFound": { "title": "Hupsis! Sertifikaattia ei löydy", "description": "Sertifikaatti, jota yrität tarkastella, ei ole saatavilla.", "subtitle": "Ota yhteyttä julkaisijaan, niin saat apua." } }, "share": { "title": "Sinun Sertifikaatti", "text": "tämä on Sertifikaattisi", "dialogTitle": "Jakaa Tai Arkistoida sinun Sertifikaattisi" }, "listing": { "courseAssignmentName": "Kurssi/Tehtävä nimi", "offlineCertification": "Offline-sertifiointi", "completionDate": "Päättymispäivämäärä", "expiryDate": "Päättyminen Päivämäärä", "type": "Kirjoittaa", "sourceName": "Lähteen nimi", "action": "Toiminta" } };
const changePassword$8 = { "showPasswords": "Näytä salasanat", "retypePassword": "Kirjoita salasana uudelleen", "newPassword": "Uusi salasana", "confirmNewPassword": "Confirm New Password", "currentPassword": "Nykyinen salasana", "emailId": "Sähköpostitunnus", "passwordMinLength": "Anna vähintään 8 merkin pituinen salasana", "editAccount": "Muokkaa tiliä", "loginEmail": "Kirjautumissähköposti", "loginInformation": "Kirjautumistiedot", "accountDetails": "Tilin tiedot", "accountDetailsUpdate": "Päivitä tilisi tiedot tässä", "accountInformation": "Tilitiedot", "changePassword": "Vaihda salasana", "hidePasswordChange": "Piilota Vaihda salasana", "selectPageError": "Yritä myöhemmin uudelleen", "systemErrorOccurred": "Jokin meni pieleen", "passwordEntryInvalid": "Virheellinen salasana", "passwordUpdateSuccess": "Salasana on päivitetty", "passwordLengthRequired": "Anna vähintään 8 merkin pituinen salasana", "passwordMinimumLength": "Anna vähintään 8 merkin pituinen salasana", "passwordFieldRequired": "Salasana on pakollinen", "password": "Salasana" };
const deleteAccount$8 = { "title": "Poista Tili", "deleteAccountDescription": "Tilisi on Ajoitettu tilapäistä poistamista varten ja tulee pysyvästi Poistettu Jos Sinä/Te älä kirjaudu in Seuraavan 7 päivän kuluessa.", "deleteAccountDescription2": "Jos haluat säilyttää Tili Dynaamisen, kirjaudu in ennen määräpäivää. Kun Poistettu, tietojasi ei voi palauttaa.", "deleteAccountButton": "Kyllä, poista Tili" };
const chats$8 = { "viewAll": "Näytä kaikki", "viewLess": "Näytä vähemmän", "updatedPreference": "Päivitetty valinta", "chatSettings": "Keskusteluasetukset", "chats": "Keskustelut", "chatSettingsDescription": "Valitse keskusteluasetukset ryhmillesi ja kontakteillesi", "groups": "Ryhmät", "blockedUsers": "Estetyt käyttäjät", "noGroups": "Ei ryhmiä", "controlUsers": "Hallinnoi, keiden käyttäjien kanssa et halua keskustella.", "blockedConversations": "Estetyt keskustelut", "noBlockedUsers": "Ei estettyjä käyttäjiä", "unblock": "Kumoa esto", "noUsersBlocked": "Käyttäjiä ei ole estetty", "noGroupsJoined": "Ryhmiä ei ole liittynyt", "controlGroups": "Määritä, ketkä ryhmäkäyttäjät voivat ottaa sinuun yhteyttä, vaihtamalla chat-keskustelun saatavuus päälle tai pois päältä alla. Voit vastaanottaa viestejä vain sen ryhmän jäseniltä, johon kuulut. " };
const payments$8 = { "shareLink": "Jaa linkki", "paymentLink": "Maksulinkki" };
const profileSettings$8 = { "complete": "VALMIS", "editBasicInformation": "Muokkaa perustietoja", "writeAboutYourself": "Kirjoita jotain itsestäsi...", "selectTimezone": "Valitse aikavyöhyke", "description": "Tämä näkyy profiilissasi", "timezone": "Aikavyöhyke", "enterLocation": "Lisää sijainti", "exampleDescription": "Esimerkki: Hei, olen John Deo ja olen valokuvaaja", "enterABriefDescription": "Kirjoita lyhyt kuvaus", "bio": "Bio", "profileSlugNotAvailable": "Profiilin kestolinkki ei ole käytettävissä", "findAndShareProfile": "Löydä ja jaa profiilisi helposti mukautetun URL-kestolinkin avulla.", "profileSlug": "Profiilin kestolinkki", "enterTitle": "Anna otsikko", "enterFullName": "Kirjoita koko nimi", "basicDetails": "Perustiedot", "updateProfileDetails": "Päivitä profiilitietosi tässä", "basicInformation": "Perustiedot", "updatedProfileSettings": "Profiiliasetukset päivitetty", "uploadStatusCode": "Lataus epäonnistui tilakoodilla", "imageTypeNotSupported": "Kuvatyyppiä ei tueta", "nameIsRequired": "Nimi on pakollinen", "invalidName": "Virheellinen nimi", "profileImage0": "Profiilikuva", "profileImage": "Profiilikuva", "uploadSvgPngJpg": "Lataa SVG, PNG tai JPG. Suositeltu kuvasuhde: 1:1", "profilesBuildConnection": "Profiilit auttavat herättämään luottamusta ja luomaan yhteenkuuluvuuden tunnetta", "clientPortalNames": "Asiakasportaali tuntuu oudolta ilman kasvoja ja nimiä.", "completeYourProfile": "Täydennä profiilisi", "uploadFailed": "Lataus epäonnistui", "fileSizeTooLarge": "Tiedoston koko on liian suuri", "invalidFileFormatType": "Virheellinen tiedostomuoto/-tyyppi.", "pleaseUploadImage": "Lataa kuva, jonka tyyppi on SVG, PNG, JPG tai JPEG.", "pleaseUploadAFileLessThan100Mb": "Lataa tiedosto, jonka koko on alle 100 Mt.", "oopsUnableToUploadImage": "Hups! Kuvan lataaminen ei onnistu.", "selectPageError": "Yritä myöhemmin uudelleen", "search": "Haku", "searchTimezones": "Hae aikavyöhykkeitä", "noTimezonesFound": "Aikavyöhykkeitä ei löytynyt", "editDetails": "Muokkaa tietoja", "profilePicture": "Profiilikuva", "profileCover": "Profiilin kansi", "uploadPhoto": "Lataa valokuva", "removePhoto": "Poista valokuva", "invalidAspectRatio": "Virheellinen kuvasuhde", "recommendedAspectRatio169": "Suositeltu kuvasuhde 16:9", "recommendedAspectRatio11": "Suositeltu kuvasuhde: 1:1", "editProfile": "Muokkaa profiilia", "manageYourGroupDetailsHere": "Hallinnoi ryhmäsi tietoja tässä", "profileIcon": "Profiilikuvake", "specialCharactersNotSupported": "Erikoismerkkejä ei tueta", "slugValidation": { "containSpecialCharacters": "Kestolinkki ei voi sisältää erikois-Merkkiä", "tooShort": "Kestolinkin on oltava vähintään 3 Merkkiä pitkä", "tooLong": "Kestolinkin on oltava alle 50 Merkkiä pitkä", "containOnlyNumbers": "Kestolinkki ei voi sisältää vain numeroita", "startWithNumber": "Kestolinkki ei voi alkaa luku", "startWithHyphen": "Kestolinkki ei voi alkaa yhdysviivalla", "endWithHyphen": "Kestolinkki ei voi Loppua yhdysviivalla", "containDoubleHyphen": "Kestolinkki ei voi sisältää kaksoisyhdysmerkkejä", "containSpace": "Kestolinkki ei voi sisältää Tyhjä tilaa" } };
const languageSettings$8 = { "title": "Kieliasetukset", "detailsHere": "Valitse asiakasportaalin kieli", "selectLanguage": "Valitse kieli", "useLocationLanguage": "Käytä Sijainti Kieli", "languagePreferenceUpdated": "Kieliasetus päivitetty", "errorUpdatingLanguage": "Virhe kielen päivittämisessä", "description": "Valitse haluamasi kieli asiakasportaalin kohteiden, yhteisön sisällön, kurssien ja kumppanitietojen katseluun. Tämän asetuksen ansiosta voit nähdä sisällön kielellä, jonka hallitset parhaiten. ", "shortDescription": "Valitse haluamasi kieli" };
const userActivityOverview$8 = { "dustBunnies": "Ei mitään nähtävää, ellet pidä pölypupuista.", "welcomeBanner": "Tervetuloa", "contracts": "Sopimukset", "hiUser": "Hei", "estimates": "Arviot", "sharedFiles": "Jaetut Tiedostot" };
const widget$8 = { "viewAll": "Näytä kaikki", "addedOn": "Lisätty", "by": "Kautta", "you": "Sinä/Te", "admin": "Ylläpitäjä", "youDoNotHaveAny": "Sinulla ei ole vielä yhtään!", "noContracts": "Ei sopimuksia", "maxFilesExceeded": "Sinä/Te voi Ladata vain 10 Tiedostot asti", "uploadFile": "Ladata Tiedosto", "userActivityOverview.contracts": "Sopimukset", "selectPageError": "Yritä myöhemmin uudelleen", "notAbleToDownloadContract": "Sopimusta ei voi ladata", "completeCourse": "Suorita kurssi loppuun", "courseProgress": "Kurssilla edistyminen", "viewAllGroups": "Katso kaikki ryhmät", "recentlyOpened": "Äskettäin avattu", "noInvoices": "Ei laskuja", "noEstimates": "Ei arvioita", "notAbleToDownloadInvoice": "Laskua ei voi ladata", "contracts": "Sopimukset", "invoices": "Laskut", "youMarked": "Merkitsit", "inCourse": "kurssilla", "invoice": "Lasku", "makePayment": "Suorita maksu", "downloadInvoice": "Lataa lasku", "viewGroup": "Katso ryhmä", "payment": "Maksu", "download": "Lataa", "signContract": "Symbolit Sopimus", "sign": "Symbolit", "estimates": "Arviot", "notAbleToDownloadEstimate": "Arvion lataaminen ei onnistu", "addFiles": "Lisätä Tiedostot", "sharedFiles": "Jaetut Tiedostot", "fileManagement": "Tiedostojen hallinta", "noFiles": "Ei Tiedostot" };
const dashboard$8 = { "joinAGroup": "Liity ryhmään", "takeACourse": "Osallistu kurssille", "checkAffiliateEarnings": "Tarkista kumppanin tulot", "manageSubscriptions": "Hallinnoi tilauksia", "contracts": "Sopimukset", "estimates": "Arviot", "sharedFiles": "Jaetut Tiedostot", "paidOn": "Maksettu", "partiallyPaidOn": "Osittain maksettu", "overdueSince": "Erääntynyt", "dueOn": "Erääntyy", "hello": "Hei", "viewGroup": "Katso ryhmä", "recentlyOpened": "Äskettäin avattu", "noItemsYet": "Sinulla ei ole vielä yhtään!", "affiliates": "Kumppanit", "exploreHere": "Tutustu tässä", "selectApp": "Valitse sovelluksesi", "exploreCourses": "Tutustu tarjolla oleviin kursseihin", "courses": "Kurssit", "engageCommunity": "Osallistu yhteisöön", "communities": "Yhteisöt", "noDataAvailable": "Tietoja ei ole saatavilla minuutilla", "noAppsAvailable": "Sovelluksia ei ole saatavilla", "noWidgetsAvailable": "Ei widgetejä Näyttöön-", "noContentAvailable": "Sisältöä ei ole saatavilla" };
const uploadDocument$8 = { "uploadHeader": "Lisätä Tiedostot", "uploadDescription": "Valitse ja lataa enintään 10 asiakirjaa", "uploadWarning": "Tämä näkyy Portaali Ylläpitäjälle Katsoalle ja Ladatalle", "uploadInstruction": "Napsauta ladataksesi tai vedä ja pudota", "allowedFiles": "DOC, PNG, JPG , GIF , PPT Tai PDF (Maksimi. 100 Mt)", "cancelButton": "Peruuta", "uploadButton": "Ladata", "confirmDeletion": "Tallenna-poisto", "deleteFile": "Poista Tiedosto", "deleteFileDescription": "Haluatko varmasti Sinä/Te poistaa tämän tiedoston? Tätä toimintoa ei voi kumota.", "deleteFileButton": "Kyllä, poista Tiedosto", "deleteFileSuccessTitle": "Tiedosto Poistettu", "deleteFileErrorTitle": "Virhe in Tiedoston poistaminen", "deleteFileErrorMessage": "Virhe tapahtui yritettäessä poistaa Tiedosto.", "cancel": "Mitätöidä", "notAbleToDownloadFile": "Ei voi Ladata Tiedostoa", "fileSizeExceeded": "Tiedosto Koko on yli 100 Mt", "invalidFileType": "Virheellinen Tiedosto Kirjoittaa", "notAbleToUploadFile": "Ei voi Ladata Tiedostoa", "downloadError": "Virhe in Ladata Tiedostossa", "fileUploadedSuccessfully": "Tiedosto onnistui", "fileDownloadedSuccessfully": "Tiedosto Ladata onnistui" };
const navbar$8 = { "hi": "Hei", "manageYourAccount": "Hallinnoi tiliäsi", "logOut": "Kirjaudu ulos", "affiliates": "Kumppanit", "courses": "Kurssit", "communities": "Yhteisöt" };
const mandatedInfoModal$8 = { "invalidFileFormat": "Virheellinen tiedostomuoto/-tyyppi.", "pleaseUploadImage": "Lataa kuva, jonka tyyppi on SVG, PNG, JPG tai JPEG", "fileSizeTooLarge": "Tiedoston koko on liian suuri", "oopsUnableToUploadImage": "Hups! Kuvan lataaminen ei onnistu.", "pleaseUploadFileLessThan100MB": "Lataa tiedosto, jonka koko on alle 100 Mt", "pleaseTryAgainLater": "Yritä myöhemmin uudelleen", "completeYourProfile": "Täydennä profiilisi", "profilesBuildConnection": "Profiilit auttavat herättämään luottamusta ja luomaan yhteenkuuluvuuden tunnetta", "putAFaceToYourProfile": "Anna kasvot profiilillesi!", "uploadASVGPNGJPG": "Lataa SVG, PNG tai JPG.", "recommendedAspectRatio11": "Suositeltu kuvasuhde: 1:1", "complete": "VALMIS", "cropYourAvatar": "Rajaa avataria", "dragToReposition": "Siirrä vetämällä" };
const sideBar$8 = { "languageSettings": "Kieliasetukset", "profile": "Profiili", "account": "Tili", "socialMedia": "Sosiaalinen media", "certificates": "Sertifikaatit", "billingSubscription": "Laskutus ja tilaus", "communitiesChats": "Yhteisöt ja keskustelut", "affiliates": "Kumppanit", "notifications": "Muistutus" };
const notifications$8 = { "title": "Ilmoitukset", "all": "Kaikki", "unread": "Lukemattomat", "markAllRead": "Merkitse kaikki luetuksi", "noNotifications": "Ei ilmoituksia", "whenYouGetNotifications": "Saapuneet ilmoitukset näkyvät tässä" };
const affiliates$8 = { "payoutMethod": "Menetelmä", "leadCustomer": "Liidit/ Asiakkaat", "commissions": "Provisiot", "description": "Ohjaa käyttäjiä GoKollabiin", "title": "Kumppanit", "groupsGoKollab": "Ryhmien luominen GoKollabissa on täysin ilmaista, mutta se on vasta alkua! Tulossa on jännittäviä uusia ominaisuuksia, joilla voit kasvattaa verkkoliiketoimintaasi ja lisätä tulojasi. Kun käyttäjät päivittävät ja avaavat käyttöönsä täyden valikoiman ominaisuuksia, saat elinikäisen toistuvan kumppanipalkkion heidän tilauksestaan. Mitä nopeammin aloitat käyttäjien ohjaamisen palveluun, sitä parempi – älä jätä väliin tätä uskomatonta kumppaniohjelmaa", "yourAffiliateLink": "Kumppanilinkkisi" };
const deleteCard$8 = { "deleteCard": "Poista kortti", "description": "Maksutapaa ei voi enää käyttää sen poistamisen jälkeen. Tätä toimintoa ei voi kumota.", "activeCard": "Tätä korttia käytetään yhden tai useamman aktiivisen tilauksen maksuihin. Jos poistat tämän kortin päivittämättä siihen liittyvien tilausten maksutapaa, tämä vaikuttaa tuleviin maksuihin. Haluatko varmasti poistaa tämän kortin?", "title": "Poistetaanko maksutapa?", "cardCannotBeDeleted": "Korttia ei voi poistaa", "cardIsLinkedToSubscriptions": "Kortti on liitetty tilauksiin", "errorInDeletingCard": "Virhe kortin poistamisessa", "noCardAvailable": "Korttia ei ole saatavilla", "cardRemovedSuccessfully": "Kortin poistaminen onnistui" };
const notificationPreferences$8 = { "title": "Ilmoitus Asetukset", "description": "Hallinnoida Kun ja mistä Sinä/Te saat ilmoituksen", "pushNotificationsTitle": "Työnnä Muistutus", "pushNotificationsDescription": "Hallinnoida push Muistutus", "emailNotificationsTitle": "Sähköposti Muistutus", "emailNotificationsDescription": "Hallinnoida Sähköposti Muustus", "emailNotifications": "Sähköposti Muistutus", "manageEmailNotifications": "Hallinnoida Sähköposti Muustus", "newActivity": "uusi toiminta", "email": "Sähköposti", "push": "Työnnä", "allNotifications": "vastaan Muustutus", "postTags": "Jakaa Avainsanat", "postEveryoneTagged": "Jakaa {'@'}Kaikki Avainsanat", "postMention": "Jakaa {'@'}Maininta", "postLike": "Jakaa Tykätä", "newComment": "uusi kommentti", "commentEveryoneTagged": "Kommentti {'@'}Kaikki Avansat", "commentMention": "Kommentti {'@'}Mainitse", "commentLike": "Kommentoi Tykätä", "postEveryoneTaggedMobile": "Jakaa {'@'}Kaikki Avainsanat", "postMentionMobile": "Jakaa {'@'}Maininta", "commentEveryoneTaggedMobile": "Kommentti {'@'}Kaikki Avansat", "commentMentionMobile": "Kommentti {'@'}Mainitse", "newMemberRequestToJoinGroup": "uusi Jäsenet Pyynnöt to liittyäksesi Ryhmään", "groupJoiningRequestApproved": "Ryhmä Liittyy Pyynnöt Hyväksyttyyn", "groupJoiningRequestRejected": "Ryhmä liittyy Pyynnöt Kiellettyyn", "roleUpdatedInPrivateChannel": "Rooli Päivitetty Yksityinen- in", "newCourseAvailable": "uusi kurssi lisätty Ryhmään", "newEventCreated": "uusi Tapahtuma Luotu", "newCourseComment": "uusi kurssikommentti", "certificateIssued": "Sertifikaatti Julkaistu", "postEveryoneTaggedDescription": "Kun joku julkaisee {'@'}Kaikki Avansat", "postMentionDescription": "Kun joku julkaisee {'@'}maininnan", "postLikeDescription": "Kun joku Tykkäykset sinun Jakaasi", "newCommentDescription": "Kun joku palaute Päällä Jakaasi", "commentEveryoneTaggedDescription": "Kun joku palaute {'@'}Kaikki Avansat", "commentMentionDescription": "Kun joku palaute {'@'}mainita", "commentLikeDescription": "Kun joku Tykkäykset kommenttisi", "newMemberRequestToJoinGroupDescription": "Kun joku Pyynnöt liittymään Ryhmääni", "groupJoiningRequestApprovedDescription": "Kun jonkun Ryhmä Pyynnöihin liittymässä on Hyväksytty", "groupJoiningRequestRejectedDescription": "Kun jonkun Ryhmä Pyynneihin liittymässä on Kielletty", "roleUpdatedInPrivateChannelDescription": "Kun jonkun rooli on Päivitetty Yksityinen- in", "newCourseAvailableDescription": "Kun uusi kurssi on saatavilla", "newEventCreatedDescription": "Kun a uusi tapahtuma on Luotu", "newCourseCommentDescription": "Kun joku palaute Päällä kurssia", "certificateIssuedDescription": "Kun a Sertifikaatti on julkaistu", "estimateReceivedDescription": "Kun a uusi Arvio on vastaanotettu", "contractReceivedDescription": "Kun a uusi Sopimus on vastaanotettu", "invoiceReceivedDescription": "Kun a uusi Lasku on vastaanotettu", "allEmailNotificationsDescription": "Kääntää Päällä/Poistettu huoneessa Sähköposti Muistutus", "allPushNotificationsDescription": "Kääntää Päällä/Poistettu tässä push Muistutus", "errorUpdating": "läsnä oli virhe Ilmoitus Asetuksetsi päivittämisessä", "updateSuccess": "Ilmoitus Asetukset on päivitetty", "willNotReceiveNotificationsIfAdminDisabled": "Periä Muistutus for Asetukset Poistettuna Kautta ylläpitäjäsi.", "estimateReceived": "uusi Arvio Vastaanotettu", "contractReceived": "uusi Sopimus Vastaanotettu", "invoiceReceived": "uusi Lasku Vastaanotettu", "pushNotificationNotAvailable": "Push-ilmoitusta ei ole saatavilla tähän tapahtumaan", "newsletter": "Uutiskirje", "emailNotificationNotAvailable": "Sähköposti-ilmoituksia ei ole saatavilla tälle tapahtumalle", "newPostFollowers": "Uusi julkaisu seuratulta käyttäjältä", "newPostFollowersDescription": "Saat ilmoituksen, kun seuraamasi henkilö luo uuden julkaisun.", "newFollower": "Saat ilmoituksen, kun joku seuraa sinua." };
const loginPage$8 = { "forgotPassword": "Unohtuiko salasana?", "login": "Kirjautua sisään", "lastLogin": "viimeisin Kirjautua sisään", "proceedToLogin": "Edetä Kirjautua sisään", "secureCode": "Suojattu Koodi", "newUser": "uusi käyttäjä?", "resetPasswordLink": "Jos lisätty sähköposti on oikein, Sinä/Te Periä Nollata password Linkkiin in . Varmistathan myös roskapostin Kansio tunnukselle.", "loginWithSecureCode": "Kirjautua sisään suojatulla Koodilla", "signUp": "Rekisteröidy", "enterOtp": "Lisää OTP", "selectAccount": "Valita minkä Tili Sinä/Te haluaa", "resetPassword": "Nollata salasana", "selectUser": "Valita Käyttäjä", "emailRequired": "Anna kelvollinen sähköposti", "fullNameRequired": "Kirjoita nimesi", "passwordRequired": "Anna password - Minimi- 8 Merkki", "generateSecureCode": "Luoda suojattu Koodi", "loginWithPassword": "Kirjautua sisään sisään salasanalla", "secureCodeEmail": "Tämä merkki on suojattu Koodin sähköpostiisi. Jos Sinä/Te ei periä yhtään sähköpostia - us,", "resendOtp": "lähetä uudelleen.", "verifySecureCode": "Tarkistaa suojattu Koodi", "secureCodeNumeric": "Securen Koodin on oltava Numeerinen Arvo ja -6-numeroinen", "alreadyHaveAccount": "Onko sinulla jo Tili?", "email": "Sähköposti", "password": "Salasana", "fullName": "Täysi nimi", "somethingWentWrong": "Jokin meni pieleen", "signInWithEmail": "Tai, Kirjautua sisään sähköpostisi avulla", "signUpWithEmail": "Tai rekisteröidy sähköpostillasi", "confirmPassword": "Vahvista salasana", "validationErrors": { "potentialSpamUser": { "title": "Tili Yksityinen", "message": "Tilisi on ollut Yksityinen Maksettavaa to roskapostiin toiminta. Ota yhteyttä asiakaspalveluun." }, "somethingWentWrong": { "title": "Jokin meni pieleen", "message": "Kirjautua sisään ei voi. Yrittää myöhemmin uudelleen." }, "bannedUser": { "title": "Tili Yksityinen", "message": "Tilisi on hyväksytty Maksettavaa mahdolliseksi roskapostiksi Toiminta. Ota yhteyttä asiakaspalveluun." } } };
const magicLink$8 = { "newLinkSent": "uusi Linkki lähetetty", "portalWillSendLink": "Portaali lataa uuden Linkin sähköpostiosoitteesi", "failedToSendNewLink": "Epäonnistunut Ladata uudelle Linkille", "pleaseTryAgain": "Ole hyvä ja Yrittää uudelleen", "linkExpired": "Tässä Linkki - sähköpostissasi on Vanhentunut.", "toContinue": "Jatkaan, Pyynnöt a uusi Linkki Tai in Portaali Tiliin", "sendNewLink": "Ladata uusi Linkki", "logIn": "KIRJAA in", "clickToLogIn": "napsauttaa tässä to in Portaali Tiliin", "invalidToken": "Tämä Valtuus - sähköpostisi ei ole voimassa.", "toContinueContactAdmin": "To Jatkaa, Pyynnöt a uusi Taikalinkki Kontakti Ylläpitäjä Tai in Portaali Tiliin" };
const setPassword$8 = { "minLength": "Anna password - Minimi- 8 Merkki", "passwordsMustMatch": "Salasanojen on oltava samat", "setSecurePassword": "Kokoelma suojattu password", "setPasswordButton": "Kokoelma Salasana" };
const alerts$8 = { "tooManyAttempts": { "title": "Liian monta yritystä", "message": "Enintään 2 Kestolinkki-päivityksen yritystä sallittu in - Kuukaudessa" }, "slugAlreadyExists": { "title": "Kestolinkki on jo olemassa", "message": "Kokeile toista Kestolinkkia" }, "updateSlugError": { "title": "Jokin meni pieleen", "message": "Profiili Kestolinkin päivittäminen ei onnistu. Kokeile Jälkeen some Päivämäärä" }, "updateProfileError": { "title": "Jokin meni pieleen", "message": "Profiili Yksityiskohtaiset kohdat ei voi päivittää. Kokeile Jälkeen some Päivämäärä" } };
const bottomNavBar$8 = { "home": "Etusivu", "discover": "Löytää", "communities": "yhteisöt", "courses": "Kurssit", "more": "Lisää" };
const forceUpdate$8 = { "title": "uusi PÄIVITYS ON SAATAVILLA", "description": "Päivitä sovelluksesi uusimpaan versioon", "buttonText": "Päivitä nyt!" };
const accessibility$8 = { "copyAffiliateLink": "Kopioida Kumppani Linkki leikepöydälle", "deleteCard": "Poista kortti", "appSwitcher": "Sovelluksen Valitsin", "portalImage": "Portaali Kuva", "profileImage": "Profiilikuva", "continueWithGoogle": "Jatkaa Googleavulla" };
const resetPassword$8 = { "passwordExpired": "password Nollata Linkki on Vanhentunut.", "regenerateLink": "Linkki uudelleen", "proceedToLogin": "Edetä Kirjautua sisään", "passwordChangedSuccessfully": "Salasana Dynaaminen onnistui", "changePassword": "Muuttaa salasana", "newPassword": "Anna password - Minimi- 8 Merkki", "confirmPassword": "password vahvistus ei vastaa", "setNewPassword": "Kokoelma uusi Salasana", "confirmNewPassword": "Vahvista uusi salasana" };
const fi = {
  common: common$8,
  account: account$8,
  wallet: wallet$8,
  support: support$8,
  social: social$8,
  validation: validation$8,
  forms: forms$8,
  auth: auth$8,
  billing: billing$8,
  transactions: transactions$8,
  cancelModal: cancelModal$8,
  certificates: certificates$8,
  changePassword: changePassword$8,
  deleteAccount: deleteAccount$8,
  chats: chats$8,
  payments: payments$8,
  profileSettings: profileSettings$8,
  languageSettings: languageSettings$8,
  userActivityOverview: userActivityOverview$8,
  widget: widget$8,
  dashboard: dashboard$8,
  uploadDocument: uploadDocument$8,
  navbar: navbar$8,
  mandatedInfoModal: mandatedInfoModal$8,
  sideBar: sideBar$8,
  notifications: notifications$8,
  affiliates: affiliates$8,
  deleteCard: deleteCard$8,
  notificationPreferences: notificationPreferences$8,
  loginPage: loginPage$8,
  magicLink: magicLink$8,
  setPassword: setPassword$8,
  alerts: alerts$8,
  bottomNavBar: bottomNavBar$8,
  forceUpdate: forceUpdate$8,
  accessibility: accessibility$8,
  resetPassword: resetPassword$8
};
const common$7 = { "show": "Afficher", "newPost": "Nouveau poste", "active": "Actif", "change": "Changement", "remove": "Supprimer", "cancel": "Annuler", "publish": "Publier", "save": "Sauvegarder", "draft": "Ébauche", "scheduled": "Prévu", "published": "Publié", "actions": "Actions", "archive": "Archives", "delete": "Supprimer", "edit": "Modifier", "settings": "Réglages", "updatedOn": "Mise à jour le", "blogPost": "Article de blogue", "category": "Catégorie", "author": "Auteur", "status": "Statut", "errors": "Erreurs", "error": "Erreur", "all": "Tous", "add": "Ajouter", "discussion": "Discussion", "allCourses": "Tous les cours", "myCourses": "Mes cours", "learning": "Apprentissage", "leaderboard": "Leaderboard", "documentsAndPayments": "Gestion des documents et des fichiers", "more": "Plus", "profile": "Profil", "archived": " Archivé", "back": "Retour", "restore": "Restaurer cette version", "next": "Suivant", "previous": "Précédent", "continue": "Continuer", "details": "Détails", "youtube": "Youtube", "action": "Action", "view": "Voir", "download": "Télécharger", "source": "Source", "title_column": "Titre", "copy": "Copier", "viewReceipt": "Voir le reçu", "id": "ID", "location": "Emplacement", "email": "Courriel", "title": "Titre", "logout": "Déconnexion", "login": "Login", "calender": "Calendrier", "apply": "Applique", "clear": "Effacer", "to": "À", "from": "De", "type": "Type", "home": "Accueil", "description": "Description", "updated": "Mis à jour", "networkError": { "title": "Aucune connexion Internet", "message": "Veuillez vérifier votre connexion Internet et réessayer." } };
const account$7 = { "settings": "Paramètres du compte", "updateSettings": "Mettez à jour les paramètres de votre compte ici", "paymentDetails": "Détails du paiement", "orderId": "ID de commande interne", "nextInvoice": "Prochaine facture", "transactionDate": "Date de transaction", "expiryDate": "Date d'expiration", "manageAllSubscription": "Gérez tous vos abonnements", "paymentMethod": "Mode de paiement", "andTransactionHere": "& transaction ici" };
const wallet$7 = { "transactionId": "ID de la transaction" };
const support$7 = { "subscriptionId": "ID de l'abonnement", "email": { "validation": "Veuillez saisir un courriel valide" }, "invoiceNo": "Numéro de facture" };
const social$7 = { "title": "Médias sociaux", "invalidURL": "URL non valide", "phoneNumber": "Numéro de téléphone", "userPhone": "Téléphone de l'utilisateur", "userEmail": "Courriel de l'utilisateur", "info": "Détails sur les réseaux sociaux", "update": "Mettre à jour les informations sur les réseaux sociaux", "detailsHere": "Mettez à jour les détails de vos réseaux sociaux ici", "updated": "Médias sociaux mis à jour", "visibility": "Visible au public", "validUrl": "Veuillez saisir une URL valide", "validEmail": "Saisissez un courriel valide", "validPhoneNumber": "Veuillez entrer un numéro de téléphone valide avec un code de pays approprié.", "platforms": { "twitter": "Twitter", "instagram": "Instagram", "facebook": "Facebook", "youtube": "Youtube", "linkedin": "LinkedIn" } };
const validation$7 = { "phone": "Veuillez entrer un numéro de téléphone valide", "url": "Entrez l'URL valide" };
const forms$7 = { "phone": "Numéro de téléphone" };
const auth$7 = { "clickToResend": "Cliquer pour renvoyer", "authentication": "Authentification", "didntGetCode": "Vous n'avez pas reçu de code?", "confirmationCode": "Code de confirmation", "sentVerificationEmail": "Nous avons envoyé un code de vérification via courriel à", "authenticateAccount": "Authentifiez votre compte", "incorrectOrExpired": "Le code OTP est invalide ou expiré", "failedToSend": "Impossible d'envoyer le code OTP", "checkEmailForSecureCode": "Veuillez vérifier votre courriel pour le code sécurisé. Si vous n'avez pas reçu de courriel de notre part,", "user": "Utilisateur", "verify": "Vérifier", "tapHereToResend": "Appuyez ici pour renvoyer.", "failedToVerifyOtp": "Échec de la vérification du code OTP", "failedToGetOtp": "Échec de l'obtention du code OTP" };
const billing$7 = { "endingIn": "se terminant par", "billingInformation": "Détails de facturation", "billingAddress": "Adresse de facturation :", "sourceType": "Type de source :", "invoices": "Factures", "subscription": "Abonnement", "transactions": "Transactions", "transaction": "Transaction", "subscriptions": "Abonnements", "invoiceName": "Nom de la facture", "subscriptionName": "Nom de l'abonnement", "dueDate": "Date d’échéance", "issueDate": "Date d’émission", "amount": "Montant", "manageSubscriptions": "Gérez tous vos abonnements", "andSubscription": "et abonnement", "andTransaction": "& transaction ici", "billing": "Facturation", "startDate": "Date de début", "fullName": "Nom complet", "nextInvoiceOn": "Prochaine facture le", "noDataFound": "Aucune donnée trouvée", "invoiceNo": "N° de facture :", "manageSubscriptionsInvoicesAndTransactions": "Gérer les abonnements, les factures et les ventes", "created": "Créé :", "transactionName": "Nom de la transaction", "tid": "Heure :", "transactionDate": "Date de transaction :", "trial": "Essai", "expired": "Expiré", "pastDue": "En retard", "unpaid": "Impayé", "incompleteExpired": "Incomplet Expiré", "canceled": "Annulé", "incomplete": "Incomplet", "failed": "Échec", "sent": "Envoyé", "paid": "Payé", "paymentProcessing": "Traitement des paiements", "partiallyPaid": "Partiellement payé", "overdue": "En retard", "succeeded": "Réussi", "processing": "Traitement en cours", "refunded": "Remboursé", "pending": "En attente", "membership": "Abonnement", "communities": "Communautés", "paymentLink": "Lien de paiement", "expiresOn": "Expire le", "errorFetchingPaymentMethods": "Erreur d’extraction des méthodes de paiement", "pageUrl": "URL de la Page" };
const transactions$7 = { "title": "Transactions", "name": "Nom des transactions" };
const cancelModal$7 = { "subscriptionRenewNotice": "Si vous changez d'avis, vous pouvez renouveler votre abonnement à tout moment.", "cancelSubscription": "Annuler l'abonnement", "subscriptionCancelNotice": "sera annulé immédiatement. Vous ne serez pas facturé de nouveau.", "yourPlanName": "Votre calendrier", "currentPlan": "Calendrier actuel", "subscriptionCancelError": "Une erreur s'est produite lors de la tentative d'annulation de l'abonnement.", "cancelSubscriptionFailed": "L'annulation de l'abonnement a échoué" };
const certificates$7 = { "title": "Certificats", "certificatesDescription": "Télécharger et Partager des formulaires que vous avez gagnés.", "subtitle": "Télécharger vos formulaires", "completedOn": "Terminaire", "back": "Retour", "previous": "Précédent", "next": "Suivant", "downloadYourCertificates": "Téléchargez vos certificats", "downloadCertificate": "Télécharger {type}", "viewCertificates": "Veuillez voir et télécharger tous vos certificats ici.", "certificateNotFound": "Aucun Certificat trouvé", "issuedOn": "Développeur Allumé", "expiresOn": "Allumé d'expiration", "description": "Beskrivelse", "yourCertificateHasExpiredOn": "Votre {type} a expiré", "issuedCertificatesNotFound": "Vous n'avez pas encore gagné de formulaires.", "shareCertificate": "Partager:", "preview": { "issuedTo": "Délivré à", "issuedBy": "Émis par", "addToLinkedin": "Ajouter au profil LinkedIn", "download": "Télécharger", "credentialVerification": "Vérification des identifiants", "issueDate": "Date d’émission", "expiryDate": "Date d'expiration", "verifyCredential": "Vérifier les crédits", "shareYourCredential": "Partagez vos titres d’identité", "showYourCredential": "Affichez votre identité sur votre réseau social", "expiredOn": "Expiré le", "expiredDesc": "Il est temps de renouveler et de rester à jour. Ne ratez pas les avantages et les Pistes.", "verificationModal": { "title": "Vérification des identifiants", "subtitle": "Il s'agit de la référence valide.", "description": " Cette preuve d'identité a été délivrée en toute sécurité. Toutes les informations affichées sont valides.", "step1": { "title": "Vérification du destinataire", "description": "Le Propriétaire de ce certificat est {recipient}" }, "step2": { "title": "Vérification de l'émetteur", "description": "Ce certificat a été délivré par  {issuer}" }, "step3": { "title": "Vérification de l'identifiant du justificatif", "description": "L’Étiquette {credentialId} est unique et valide." } }, "notFound": { "title": "Oups ! Certificat non trouvé !", "description": "Le certificat que vous essayez de consulter n'est pas disponible.", "subtitle": "Veuillez contacter l'émetteur pour obtenir de l'aide." } }, "share": { "title": "Votre Certificat", "text": "ici est votre Certificat", "dialogTitle": "Partager votre Certificat" }, "listing": { "courseAssignmentName": "Cours/ Nom de Tâche", "offlineCertification": "Certificat hors ligne", "completionDate": "Date de fin", "expiryDate": "Date Expiration", "type": "Type", "sourceName": "Nom de la Source", "action": "Action" } };
const changePassword$7 = { "showPasswords": "Afficher les mots de passe", "retypePassword": "Retapez le mot de passe", "newPassword": "Nouveau mot de passe", "confirmNewPassword": "Confirm New Password", "currentPassword": "Mot de passe actuel", "emailId": "ID du courriel", "passwordMinLength": "Veuillez entrer un mot de passe comportant au moins 8 caractères.", "editAccount": "Modifier le compte", "loginEmail": "Courriel de connexion", "loginInformation": "Informations de connexion", "accountDetails": "Détails du compte", "accountDetailsUpdate": "Mettez à jour les détails de votre compte ici", "accountInformation": "Renseignements sur le compte", "changePassword": "Modifier le mot de passe", "hidePasswordChange": "Cacher le changement de mot de passe", "selectPageError": "Veuillez réessayer plus tard", "systemErrorOccurred": "Une erreur s'est produite", "passwordEntryInvalid": "Mot de passe invalide", "passwordUpdateSuccess": "Mot de passe mis à jour", "passwordLengthRequired": "Veuillez entrer un mot de passe comportant au moins 8 caractères.", "passwordMinimumLength": "Veuillez entrer un mot de passe comportant au moins 8 caractères.", "passwordFieldRequired": "Le mot de passe est obligatoire", "password": "Mot de passe" };
const deleteAccount$7 = { "title": "Supprimer le Compte", "deleteAccountDescription": "Votre compte est en cours de désactivation temporairement et sera définitivement pris en charge Si vous ne vous in pas dans les 7 jours suivants.", "deleteAccountDescription2": "Pour garder votre compte dynamique, veuillez simplement in avant l'échéance. Une fois pris en charge, vos données ne peuvent pas être récupérées.", "deleteAccountButton": "Oui, Supprimer le Compte" };
const chats$7 = { "viewAll": "Voir tout", "viewLess": "Afficher moins", "updatedPreference": "Préférence mise à jour", "chatSettings": "Paramètres de clavardage", "chats": "Clavardages", "chatSettingsDescription": "Sélectionner les paramètres de clavardage pour vos groupes et amis.", "groups": "Groupes", "blockedUsers": "Utilisateurs bloqués", "noGroups": "Aucun groupe", "controlUsers": "Gérer les utilisateurs avec lesquels vous ne souhaitez pas clavarder.", "blockedConversations": "Conversations bloquées", "noBlockedUsers": "Aucun utilisateur bloqué", "unblock": "Débloquer", "noUsersBlocked": "Aucun utilisateur n'est bloqué", "noGroupsJoined": "Aucun groupe rejoint", "controlGroups": "Gérer les utilisateurs de groupe qui peuvent vous contacter en activant ou désactivant votre disponibilité pour le clavardage ci-dessous. Vous pouvez recevoir des messages uniquement des membres du groupe dont vous faites partie. " };
const payments$7 = { "shareLink": "Partager le lien", "paymentLink": "Lien de paiement" };
const profileSettings$7 = { "complete": "COMPLET", "editBasicInformation": "Modifier les informations de base", "writeAboutYourself": "Écrivez quelque chose sur vous-même...", "selectTimezone": "Sélectionnez le fuseau horaire", "description": "Ceci sera affiché sur votre profil", "timezone": "Fuseau horaire", "enterLocation": "Entrez l'emplacement", "exampleDescription": "Modèle : Bonjour, je m’appelle John Deo et je suis photographe.", "enterABriefDescription": "Saisissez une brève Beskrivelse", "bio": "Biographie", "profileSlugNotAvailable": "Identifiant de profil non disponible", "findAndShareProfile": "Trouvez et partagez facilement votre profil avec un identifiant URL personnalisé.", "profileSlug": "Identifiant de profil", "enterTitle": "Entrez le titre", "enterFullName": "Entrez le nom complet", "basicDetails": "Détails de base", "updateProfileDetails": "Mettez à jour les détails de votre profil ici", "basicInformation": "Renseignements de base", "updatedProfileSettings": "Paramètres de profil mis à jour", "uploadStatusCode": "Le téléchargement a échoué avec le code de statut.", "imageTypeNotSupported": "Type d’image non pris en charge", "nameIsRequired": "Le nom est obligatoire", "invalidName": "Nom invalide", "profileImage0": "Photo de profil", "profileImage": "Photo de profil", "uploadSvgPngJpg": "Téléverser un fichier SVG, PNG, JPG. Rapport hauteur/largeur recommandé 1:1", "profilesBuildConnection": "Les profils instaurent la confiance et créent des liens avec les autres", "clientPortalNames": "Le portail client semble étrange sans visages ni noms.", "completeYourProfile": "Complétez votre Profil", "uploadFailed": "Échec du téléchargement", "fileSizeTooLarge": "La taille du fichier est trop grande.", "invalidFileFormatType": "Format/type de document non valide.", "pleaseUploadImage": "Veuillez téléverser une image de type SVG, PNG, JPG ou JPEG.", "pleaseUploadAFileLessThan100Mb": "Veuillez téléverser un fichier dont la taille est inférieure à 100 Mo.", "oopsUnableToUploadImage": "Oups! Impossible de télécharger la photo.", "selectPageError": "Veuillez réessayer plus tard", "search": "Rechercher", "searchTimezones": "Rechercher des fuseaux horaires", "noTimezonesFound": "Aucun fuseau horaire n'a été trouvé", "editDetails": "Modifier les détails", "profilePicture": "Photo de profil", "profileCover": "Couverture de profil", "uploadPhoto": "Téléverser une photo", "removePhoto": "Supprimer la photo", "invalidAspectRatio": "Rapport d'aspect invalide", "recommendedAspectRatio169": "Format d'image recommandé 16:9", "recommendedAspectRatio11": "Rapport hauteur/largeur recommandé 1:1", "editProfile": "Modifier le profil", "manageYourGroupDetailsHere": "Gérez les détails de votre groupe ici", "profileIcon": "Icône de profil", "specialCharactersNotSupported": "Les caractères spéciaux ne sont pas pris en charge", "slugValidation": { "containSpecialCharacters": "Limace ne peut pas contenir de caractères spéciaux", "tooShort": "Limace doit comporter au moins 3 caractères", "tooLong": "Limace doit comporter moins de 50 caractères", "containOnlyNumbers": "Le Limace ne peut contenir que des numéros", "startWithNumber": "Le Limace ne peut pas commencer avec un nombre", "startWithHyphen": "Le Limace ne peut pas commencer avec un message", "endWithHyphen": "Limace ne peut pas être terminé avec un .", "containDoubleHyphen": "Le Limace ne peut pas contenir de doubles signatures", "containSpace": "Limace ne peut pas contenir d'espace" } };
const languageSettings$7 = { "title": "Paramètres de langue", "detailsHere": "Sélectionner la langue du portail client", "selectLanguage": "Sélectionnez la langue", "useLocationLanguage": "Utiliser la Langue de Emplacement", "languagePreferenceUpdated": "Préférence de langue mise à jour", "errorUpdatingLanguage": "Erreur lors de la mise à jour de la langue", "description": "Cliquez sur votre Langue préférée pour afficher les éléments du portail client, le contenu de la communauté, les Cours et les informations sur les Affiliations. Ce paramètre vous permet d'afficher le contenu dans la langue dans laquelle vous êtes le plus à l’aise. ", "shortDescription": "Sélectionnez votre langue préférée." };
const userActivityOverview$7 = { "dustBunnies": "Rien à voir, sauf si vous aimez les amas de poussière.", "welcomeBanner": "Bienvenue à", "contracts": "Contrats", "hiUser": "Bonjour", "estimates": "Estimations", "sharedFiles": "Fichiers partagé" };
const widget$7 = { "viewAll": "Voir tout", "addedOn": "Ajouté le", "by": "via", "you": "Vous", "admin": "Administrateur", "youDoNotHaveAny": "Vous n'en avez pas!", "noContracts": "Aucun contrat", "maxFilesExceeded": "Vous ne pouvez téléverser que 10 fichiers au maximum", "uploadFile": "Téléverser un Fichier", "userActivityOverview.contracts": "Contrats", "selectPageError": "Veuillez réessayer plus tard", "notAbleToDownloadContract": "Impossible de télécharger le contrat", "completeCourse": "Compléter le cours", "courseProgress": "Progrès du cours", "viewAllGroups": "Voir tous les groupes", "recentlyOpened": "Récemment ouvert", "noInvoices": "Aucune facture", "noEstimates": "Aucune estimation", "notAbleToDownloadInvoice": "Impossible de télécharger la facture", "contracts": "Contrats", "invoices": "Factures", "youMarked": "Vous avez marqué", "inCourse": "en cours", "invoice": "Facture", "makePayment": "Effectuer un paiement", "downloadInvoice": "Télécharger la facture", "viewGroup": "Voir le groupe", "payment": "Paiement", "download": "Télécharger", "signContract": "D'accord", "sign": "Symboles", "estimates": "Estimations", "notAbleToDownloadEstimate": "Impossible de télécharger l’estimation", "addFiles": "Ajouter des Fichiers", "sharedFiles": "Fichiers partagé", "fileManagement": "Gestion des fichiers", "noFiles": "Aucun Fichiers" };
const dashboard$7 = { "joinAGroup": "Rejoindre un groupe", "takeACourse": "Suivez un cours", "checkAffiliateEarnings": "Vérifiez les revenus d'affiliation", "manageSubscriptions": "Gérez les abonnements", "contracts": "Contacts", "estimates": "Estimations", "sharedFiles": "Fichiers partagé", "paidOn": "Date du paiement", "partiallyPaidOn": "Payé partiellement le", "overdueSince": "En retard depuis", "dueOn": "Dû le", "hello": "Bonjour", "viewGroup": "Voir le groupe", "recentlyOpened": "Récemment ouvert", "noItemsYet": "Vous n'en avez pas encore!", "affiliates": "Affiliation", "exploreHere": "Découvrez ici", "selectApp": "Sélectionnez votre application", "exploreCourses": "Explorez les cours disponibles", "courses": "Cours", "engageCommunity": "Participer à la communauté", "communities": "Communautés", "noDataAvailable": "Aucune donnée disponible à la minute", "noAppsAvailable": "Aucune application disponible", "noWidgetsAvailable": "Aucun widget à afficher", "noContentAvailable": "Aucune contenu disponible" };
const uploadDocument$7 = { "uploadHeader": "Ajouter des Fichiers", "uploadDescription": "Sélectionnez et téléversez jusqu'à 10 documents.", "uploadWarning": "Cela sera visible par l'administrateur du Portail pour voir et télécharger", "uploadInstruction": "Cliquez pour téléverser ou glisser-déposer.", "allowedFiles": "UTILISATEUR, PNG, JPG , GIF, PPT PDF 100 Mo)", "cancelButton": "Annuler", "uploadButton": "Téléverser", "confirmDeletion": "Enregistrer la suppression", "deleteFile": "Supprimer le Fichier", "deleteFileDescription": "Voulez-vous vraiment supprimer ce fichier? Cette Action ne peut pas être annulée.", "deleteFileButton": "Oui, Supprimer le Fichier", "deleteFileSuccessTitle": "Le Fichier a bien Supprimé .", "deleteFileErrorTitle": "Erreur in la Supprimer", "deleteFileErrorMessage": "Une erreur s'est produite lors de la suppression du fichier.", "cancel": "Vidéo", "notAbleToDownloadFile": "Impossible de télécharger", "fileSizeExceeded": "La taille du fichier dépasse 100 Mo", "invalidFileType": "Type de fichier non valide", "notAbleToUploadFile": "Impossible de téléverser", "downloadError": "Erreur in téléchargement", "fileUploadedSuccessfully": "Fichier téléchargé avec succès", "fileDownloadedSuccessfully": "Chargement" };
const navbar$7 = { "hi": "Bonjour", "manageYourAccount": "Gérez votre compte", "logOut": "Se déconnecter", "affiliates": "Affiliation", "courses": "Cours", "communities": "Communautés" };
const mandatedInfoModal$7 = { "invalidFileFormat": "Format/type de document non valide.", "pleaseUploadImage": "Veuillez téléverser une image de type SVG, PNG, JPG, JPEG", "fileSizeTooLarge": "La taille du fichier est trop grande.", "oopsUnableToUploadImage": "Oups! Impossible de télécharger la photo.", "pleaseUploadFileLessThan100MB": "Veuillez téléverser un fichier de moins de 100 Mo", "pleaseTryAgainLater": "Veuillez réessayer plus tard", "completeYourProfile": "Finissez votre Profil", "profilesBuildConnection": "Les profils instaurent la confiance et créent des liens avec les autres", "putAFaceToYourProfile": "Ajoutez une photo à votre profil !", "uploadASVGPNGJPG": "Téléverser un fichier SVG, PNG, JPG.", "recommendedAspectRatio11": "Rapport hauteur/largeur recommandé 1:1", "complete": "COMPLET", "cropYourAvatar": "Rognez votre avatar", "dragToReposition": "Traîner pour repositionner" };
const sideBar$7 = { "languageSettings": "Paramètres de langue", "profile": "Profil", "account": "Compte", "socialMedia": "Médias sociaux", "certificates": "Certificats", "billingSubscription": "Facturation et abonnement", "communitiesChats": "Communautés et clavardages", "affiliates": "Affiliation", "notifications": "Rappel" };
const notifications$7 = { "title": "Notifications", "all": "Tous", "unread": "Non lu", "markAllRead": "Marquer tout comme lu", "noNotifications": "Aucune notification pour le moment", "whenYouGetNotifications": "Quand vous recevez des notifications, elles s'afficheront ici" };
const affiliates$7 = { "payoutMethod": "Méthode de Paiement", "leadCustomer": "Pistes/ Clients", "commissions": "Commandes", "description": "Référer des utilisateurs à GoKollab", "title": "Affiliation", "groupsGoKollab": "La création de groupes sur GoKollab est entièrement gratuite, et ce n'est que le début! De nouvelles fonctionnalités passionnantes sont en cours de développement pour vous aider à développer votre entreprise en ligne et à multiplier vos revenus. Lorsque les utilisateurs passent à un abonnement supérieur pour accéder à l'ensemble des fonctionnalités, vous bénéficierez d'une commission d'affiliation récurrente à vie sur leur abonnement. Plus tôt vous commencerez à référer, mieux ce sera—ne manquez pas ce programme d'affiliation incroyable.", "yourAffiliateLink": "Votre lien d'affiliation" };
const deleteCard$7 = { "deleteCard": "Supprimer la carte", "description": "La méthode de paiement ne sera plus utilisable après sa suppression. Cette action ne pourra pas être annulée.", "activeCard": "Cette carte est utilisée pour un ou plusieurs paiements d'abonnements actifs. La suppression de cette carte sans mettre à jour le mode de paiement des abonnements associés affectera les paiements futurs. Voulez-vous vraiment supprimer cette carte?", "title": "Supprimer le mode de paiement?", "cardCannotBeDeleted": "La carte ne peut pas être supprimée.", "cardIsLinkedToSubscriptions": "La carte est associée aux abonnements.", "errorInDeletingCard": "Erreur lors de la suppression de la carte.", "noCardAvailable": "Aucune carte disponible", "cardRemovedSuccessfully": "Carte supprimée avec succès." };
const notificationPreferences$7 = { "title": "Réglages de Notification", "description": "Gérer Quand et ce que vous souhaitez recevoir une notification", "pushNotificationsTitle": "Récupérer", "pushNotificationsDescription": "Personnaliser l'appel", "emailNotificationsTitle": "Courriel d'appel", "emailNotificationsDescription": "Gérer l'appel de Courriel", "emailNotifications": "Courriel d'appel", "manageEmailNotifications": "Gérer l'appel de Courriel", "newActivity": "Nouvelle activité", "email": "Courriel", "push": "Cliquer", "allNotifications": "Tout le d'appel", "postTags": "Partager les mots clés", "postEveryoneTagged": "{'@'}", "postMention": "{'@'}", "postLike": "Partager J'AI", "newComment": "Nouveau commentaire", "commentEveryoneTagged": "Comment {'@'}je vous aider aujourd'hui ?", "commentMention": "Commentaire {'@'}", "commentLike": "Comment puis-je vous aider aujourd'hui ?", "postEveryoneTaggedMobile": "{'@'}", "postMentionMobile": "{'@'}", "commentEveryoneTaggedMobile": "Comment {'@'}je vous aider aujourd'hui ?", "commentMentionMobile": "Commentaire {'@'}", "newMemberRequestToJoinGroup": "Nouveaux demandes au groupe", "groupJoiningRequestApproved": "Demandes d'adhésion du groupe accepté", "groupJoiningRequestRejected": "Refuser les demandes de groupe", "roleUpdatedInPrivateChannel": "Mise à jour du formulaire in le Canal privé", "newCourseAvailable": "Nouveau cours ajouté au Groupe", "newEventCreated": "Nouveau événement", "newCourseComment": "Nouveau commentaire sur le cours", "certificateIssued": "Certificat Délivré", "postEveryoneTaggedDescription": "Quand quelqu'un commente {'@'}", "postMentionDescription": "Quand quelqu'un {'@'}", "postLikeDescription": "Quand quelqu'un commente « J'AI » votre partage", "newCommentDescription": "Quand quelqu'un n'arrive pas à partager", "commentEveryoneTaggedDescription": "Quand quelqu'un s'agit {'@'} .", "commentMentionDescription": "Quand quelqu'un n'arrive {'@'}à le décrire", "commentLikeDescription": "Quand quelqu'un commente « J'AI » votre commentaire", "newMemberRequestToJoinGroupDescription": "Quand quelqu'un demande à votre groupe", "groupJoiningRequestApprovedDescription": "Quand les demandes de groupe de quelqu'un sont acceptés", "groupJoiningRequestRejectedDescription": "Quand le groupe de quelqu'un pour rejoindre des demandes est refusé", "roleUpdatedInPrivateChannelDescription": "Quand le poste de quelqu'un est mis à jour in un canal privé", "newCourseAvailableDescription": "Quand un Nouveau cours est disponible", "newEventCreatedDescription": "Quand un nouveau événement est créé", "newCourseCommentDescription": "Quand quelqu'un s'il vous plaît", "certificateIssuedDescription": "Quand un permis est supprimé", "estimateReceivedDescription": "Quand une nouvelle estimation est reçue", "contractReceivedDescription": "Quand un nouvel consentement est reçu", "invoiceReceivedDescription": "Quand une nouvelle facture est rejetée", "allEmailNotificationsDescription": "Aller à l'allumage du Courriel", "allPushNotificationsDescription": "Retour", "errorUpdating": "Une erreur s'est produite lors de la mise à jour de vos paramètres de Notification", "updateSuccess": "Vos paramètres de Notification ont été mis à jour", "willNotReceiveNotificationsIfAdminDisabled": "Vous n'Hériterez pas d'occasions via votre administrateur.", "estimateReceived": "Nouvelle estimation", "contractReceived": "D'accord", "invoiceReceived": "D'accord", "pushNotificationNotAvailable": "La Notification contextuelle n'est pas disponible pour cet événement", "newsletter": "Bulletin d’information", "emailNotificationNotAvailable": "La notification contextuelle par courriel n'est pas disponible pour cet événement.", "newPostFollowers": "Nouvelle publication d'un utilisateur suivi", "newPostFollowersDescription": "Recevez une notification quand quelqu'un que vous suivez crée une nouvelle publication.", "newFollower": "Recevez une notification quand quelqu'un vous suit." };
const loginPage$7 = { "forgotPassword": "Mot de passe oublié?", "login": "Ouvrir une session", "lastLogin": "Dernière session", "proceedToLogin": "Poursuivre pour la Ouvrir une session", "secureCode": "Code sûr", "newUser": "Nouveaux utilisateurs?", "resetPasswordLink": "Si le courriel saisi est incorrect, vous pourrez Hériter d'un lien password à zéro in le courriel. Veuillez vous assurer de vérifier également le dossier des pourriels.", "loginWithSecureCode": "Ouvrir la session avec Code de sécurité", "signUp": "S’inscrire", "enterOtp": "Entrez le OTP", "selectAccount": "Sélectionne les comptes que tu souhaites", "resetPassword": "Remise à zéro le mot de passe", "selectUser": "Sélectionner un Utilisateur", "emailRequired": "Veuillez saisir un courriel valide", "fullNameRequired": "Veuillez saisir votre nom", "passwordRequired": "Veuillez saisir un password de 8 Min", "generateSecureCode": "Générer un Code sûr", "loginWithPassword": "Ouvrir une session avec mot de passe", "secureCodeEmail": "Veuillez Case à cocher de votre Courriel pour le Code de sécurité. Si vous n'avez pas hérité de courriels de nous,", "resendOtp": "Taper ici pour renvoyer.", "verifySecureCode": "Vérifier le Code sûr", "secureCodeNumeric": "Le Code sûr doit être une valeur numérique et doit comporter 6 chiffres", "alreadyHaveAccount": "Vous avez déjà un compte?", "email": "Courriel", "password": "Mot de passe", "fullName": "Nom Plein", "somethingWentWrong": "Quelque chose s'est mal passé", "signInWithEmail": "Oups, une session avec votre Courriel", "signUpWithEmail": "Ou inscrivez-vous avec votre e-mail", "confirmPassword": "Confirmer le mot de passe", "validationErrors": { "potentialSpamUser": { "title": "Compte privé", "message": "Votre compte a été privé de l'activité des pourriels. Veuillez Contact le service de soutien pour obtenir de l'aide." }, "somethingWentWrong": { "title": "Quelque chose s'est mal passé", "message": "Impossible d'ouverture d'une session. Veuillez réessayer plus tard." }, "bannedUser": { "title": "Compte privé", "message": "Votre compte a été autorisé pour l'activité des pourriels. Veuillez Contact le service de soutien pour obtenir de l'aide." } } };
const magicLink$7 = { "newLinkSent": "Nouveau lien envoyé", "portalWillSendLink": "Portail téléverser un nouveau lien vers votre adresse électronique", "failedToSendNewLink": "Échec de la téléverser un nouveau lien", "pleaseTryAgain": "Veuillez réessayer", "linkExpired": "Ce lien de votre courriel a expiré.", "toContinue": "Pour continuer, demande un nouveau lien pour in à votre compte de Portail", "sendNewLink": "Téléverser un nouveau lien", "logIn": "in", "clickToLogIn": "Cliquez ici pour in à votre compte de Portail", "invalidToken": "Ce Jeton de votre Courriel n'est pas valide.", "toContinueContactAdmin": "Pour continuer, demande un nouveau lien Contact' administrateur pour in à votre compte de Portail" };
const setPassword$7 = { "minLength": "Veuillez saisir un password de 8 Min", "passwordsMustMatch": "Les mots de passe doivent correspondre", "setSecurePassword": "Collection votre password", "setPasswordButton": "Mot de passe de la Collection" };
const alerts$7 = { "tooManyAttempts": { "title": "trop de tentatives", "message": "Les 2 tentatives pour la mise à jour de Limace sont autorisées in une fenêtre de mois" }, "slugAlreadyExists": { "title": "Le Limace existe déjà", "message": "Veuillez essayer un autre Limace" }, "updateSlugError": { "title": "Quelque chose s'est mal passé", "message": "Impossible de mettre à jour le profil Limace. Veuillez essayer après une Date" }, "updateProfileError": { "title": "Quelque chose s'est mal passé", "message": "Impossible de mettre à jour les détails du profil. Veuillez essayer après une Date" } };
const bottomNavBar$7 = { "home": "Accueil", "discover": "Découvrir", "communities": "Groupes", "courses": "Cours", "more": "Plus" };
const forceUpdate$7 = { "title": "La nouvelle mise à jour est disponible", "description": "Mise à jour votre demande vers la dernière Version", "buttonText": "Mise à jour maintenant!" };
const accessibility$7 = { "copyAffiliateLink": "Copier le lien d'adhésion dans le presse-papiers", "deleteCard": "Supprimer la carte", "appSwitcher": "Commutateur Application", "portalImage": "Image du Portail", "profileImage": "Image de Profil", "continueWithGoogle": "Continuer avec Google" };
const resetPassword$7 = { "passwordExpired": "Votre password Remise à zéro Lien a expiré.", "regenerateLink": "Réinitialiser le Lien", "proceedToLogin": "Poursuivre pour la Ouvrir une session", "passwordChangedSuccessfully": "Mot de passe dynamique avec succès", "changePassword": "Changement de mot de passe", "newPassword": "Veuillez saisir un password de 8 Min", "confirmPassword": "La confirmation password ne correspond pas", "setNewPassword": "Nouveau mot de passe de la Collection", "confirmNewPassword": "Confirmer le nouveau mot de passe" };
const frCA = {
  common: common$7,
  account: account$7,
  wallet: wallet$7,
  support: support$7,
  social: social$7,
  validation: validation$7,
  forms: forms$7,
  auth: auth$7,
  billing: billing$7,
  transactions: transactions$7,
  cancelModal: cancelModal$7,
  certificates: certificates$7,
  changePassword: changePassword$7,
  deleteAccount: deleteAccount$7,
  chats: chats$7,
  payments: payments$7,
  profileSettings: profileSettings$7,
  languageSettings: languageSettings$7,
  userActivityOverview: userActivityOverview$7,
  widget: widget$7,
  dashboard: dashboard$7,
  uploadDocument: uploadDocument$7,
  navbar: navbar$7,
  mandatedInfoModal: mandatedInfoModal$7,
  sideBar: sideBar$7,
  notifications: notifications$7,
  affiliates: affiliates$7,
  deleteCard: deleteCard$7,
  notificationPreferences: notificationPreferences$7,
  loginPage: loginPage$7,
  magicLink: magicLink$7,
  setPassword: setPassword$7,
  alerts: alerts$7,
  bottomNavBar: bottomNavBar$7,
  forceUpdate: forceUpdate$7,
  accessibility: accessibility$7,
  resetPassword: resetPassword$7
};
const common$6 = { "show": "Afficher", "newPost": "Nouvelle publication", "active": "Actif", "change": "Modification", "remove": "Supprimé", "cancel": "Annuler", "publish": "Publier", "save": "Sauvegarder", "draft": "Brouillon", "scheduled": "Programmées", "published": "Publié", "actions": "Actions", "archive": "Archiver", "delete": "Supprimer", "edit": "Modifier", "settings": "Paramètres", "updatedOn": "Mis à jour le", "blogPost": "Article de blog", "category": "Catégorie", "author": "Auteur", "status": "Statut", "errors": "Erreurs", "error": "Erreur", "all": "Tout", "add": "Ajouter", "discussion": "Discussion", "allCourses": "Tous les cours", "myCourses": "Mes cours", "learning": "Apprentissage", "leaderboard": "Classement", "documentsAndPayments": "Gestion des documents & fichiers", "more": "Plus", "profile": "Profil", "archived": " Archivé", "back": "Retour", "restore": "Restaurer cette version", "next": "Suivant", "previous": "Précédent", "continue": "Continuer", "details": "Informations", "youtube": "YouTube", "action": "Action", "view": "afficher", "download": "Télécharger", "source": "Source", "title_column": "Titre", "copy": "Copier", "viewReceipt": "Voir le reçu", "id": "ID", "location": "Lieu", "email": "E-mail", "title": "Titre", "logout": "Déconnexion", "login": "Login", "calender": "Calendrier", "apply": "Appliquer", "clear": "Effacer", "to": "À", "from": "De", "type": "Type", "home": "accueil", "description": "Description", "updated": "Mis à jour", "networkError": { "title": "Aucune connexion Internet", "message": "Veuillez vérifier votre connexion Internet et réessayer." } };
const account$6 = { "settings": "Paramètres du compte", "updateSettings": "Mettez à jour les paramètres de votre compte ici", "paymentDetails": "Détails du paiement", "orderId": "ID de commande interne", "nextInvoice": "Facture suivante", "transactionDate": "Date de transaction", "expiryDate": "Date d'expiration", "manageAllSubscription": "Gérez tous vos abonnements", "paymentMethod": "Mode de paiement", "andTransactionHere": "& transaction ici" };
const wallet$6 = { "transactionId": "ID de transaction" };
const support$6 = { "subscriptionId": "ID d'abonnement", "email": { "validation": "Veuillez saisir une adresse e-mail valide" }, "invoiceNo": "Numéro de facture" };
const social$6 = { "title": "Réseau social", "invalidURL": "URL non valide", "phoneNumber": "Numéro de téléphone", "userPhone": "Téléphone de l'utilisateur", "userEmail": "Adresse e-mail de l'utilisateur", "info": "Informations sur les réseaux sociaux", "update": "Mettre à jour les informations des réseaux sociaux", "detailsHere": "Mettez à jour vos informations de réseaux sociaux ici", "updated": "Réseaux sociaux mis à jour", "visibility": "Visible publiquement", "validUrl": "Veuillez saisir une URL valide", "validEmail": "Veuillez saisir une adresse e-mail valide", "validPhoneNumber": "Veuillez saisir un numéro de téléphone valide avec un code de pays approprié", "platforms": { "twitter": "Twitter", "instagram": "Instagram", "facebook": "Facebook", "youtube": "YouTube", "linkedin": "LinkedIn" } };
const validation$6 = { "phone": "Veuillez saisir un numéro de téléphone valide.", "url": "Saisissez une URL valide" };
const forms$6 = { "phone": "Numéro de téléphone" };
const auth$6 = { "clickToResend": "Cliquez pour renvoyer", "authentication": "Authentification", "didntGetCode": "Vous n'avez pas reçu de code ?", "confirmationCode": "Code de confirmation", "sentVerificationEmail": "Nous avons envoyé un code de vérification par e-mail à", "authenticateAccount": "Authentifiez votre compte", "incorrectOrExpired": "Le mot de passe à usage unique est non valide ou arrivé à expiration", "failedToSend": "Impossible d'envoyer le mot de passe à usage unique", "checkEmailForSecureCode": "Recherchez le code sécurisé dans votre boîte de réception. Si vous n'avez pas reçu d'email de notre part,", "user": "Utilisateur", "verify": "Vérifier", "tapHereToResend": "Appuyez ici pour renvoyer.", "failedToVerifyOtp": "Échec de la vérification du mot de passe à usage unique", "failedToGetOtp": "Échec de l'obtention du mot de passe à usage unique" };
const billing$6 = { "endingIn": "finissant par", "billingInformation": "Informations de facturation", "billingAddress": "Adresse de facturation :", "sourceType": "Type de source :", "invoices": "Factures", "subscription": "Abonnement", "transactions": "Transactions", "transaction": "Transaction", "subscriptions": "Abonnements", "invoiceName": "Nom de la facture", "subscriptionName": "Nom de l'abonnement", "dueDate": "Date d'échéance", "issueDate": "Date d'émission", "amount": "Montant", "manageSubscriptions": "Gérez tous vos abonnements", "andSubscription": "et abonnement", "andTransaction": "& transaction ici", "billing": "Facturation", "startDate": "Date de début", "fullName": "Nom complet", "nextInvoiceOn": "Prochaine facture le", "noDataFound": "Aucune donnée trouvée", "invoiceNo": "Facture n° :", "manageSubscriptionsInvoicesAndTransactions": "Gérez les abonnements, les factures et les ventes", "created": "Créé :", "transactionName": "Nom de la transaction", "tid": "Heure :", "transactionDate": "Date de transaction :", "trial": "Essai", "expired": "Arrivé à expiration", "pastDue": "Échéance passée", "unpaid": "Impayé", "incompleteExpired": "Incomplet et arrivé à expiration", "canceled": "Annulé", "incomplete": "Incomplet", "failed": "Échec", "sent": "Envoyé", "paid": "Payé", "paymentProcessing": "Paiement en cours de traitement", "partiallyPaid": "Partiellement payée", "overdue": "En retard", "succeeded": "Réussi", "processing": "En cours de traitement", "refunded": "Remboursé", "pending": "En attente", "membership": "Abonnement", "communities": "Communautés", "paymentLink": "Lien de paiement", "expiresOn": "Expire en", "errorFetchingPaymentMethods": "erreur de la récupération des modes de paiement", "pageUrl": "URL de la page" };
const transactions$6 = { "title": "Transactions", "name": "Nom de la transaction" };
const cancelModal$6 = { "subscriptionRenewNotice": "Si vous changez d'avis, vous pouvez renouveler votre abonnement à tout moment.", "cancelSubscription": "Résilier l'abonnement", "subscriptionCancelNotice": "sera annulé immédiatement. Vous ne serez pas facturé à nouveau.", "yourPlanName": "Votre forfait", "currentPlan": "Forfait en cours", "subscriptionCancelError": "Une erreur s'est produite lors de la tentative d'annulation de l'abonnement.", "cancelSubscriptionFailed": "Annulation de l'abonnement impossible" };
const certificates$6 = { "title": "certificats", "certificatesDescription": "Téléchargez et partagez des certificats que vous avez gagné.", "subtitle": "télécharger vos certificats", "completedOn": "Terminaison", "back": "Retour", "previous": "Précédent", "next": "Suivant", "downloadYourCertificates": "Téléchargez vos certificats", "downloadCertificate": "télécharger {type}", "viewCertificates": "Affichez et téléchargez tous vos certificats ici", "certificateNotFound": "Aucun certificat trouvé", "issuedOn": "émis", "expiresOn": "expirer", "description": "Beskrivelse", "yourCertificateHasExpiredOn": "Votre {type} a réussi à expiration", "issuedCertificatesNotFound": "vous n'avez pas encore remporté de certificats.", "shareCertificate": "partager:", "preview": { "issuedTo": "Émis à", "issuedBy": "Émis par", "addToLinkedin": "Ajouter à votre profil LinkedIn", "download": "Télécharger", "credentialVerification": "Vérification des identifiants", "issueDate": "Date d'émission", "expiryDate": "Date d'expiration", "verifyCredential": "Vérifiez les informations d'identification", "shareYourCredential": "Partagez vos informations d'identification", "showYourCredential": "Affichez votre identité sur votre réseau social", "expiredOn": "Expiré le", "expiredDesc": "Il est temps de renouveler et de rester à jour. Ne manquez pas les avantages et prospects continus.", "verificationModal": { "title": "Vérification des identifiants", "subtitle": "C'est le titre en cours de validité.", "description": " Cette accréditation a été émise en toute sécurité. Toutes les informations affichées sont valides.", "step1": { "title": "Vérifiez le destinataire", "description": "Le propriétaire de cet identifiant est {recipient}" }, "step2": { "title": "Vérification de l'émetteur", "description": "Cette accréditation a été émise par  {issuer}" }, "step3": { "title": "Vérification de l'ID du justificatif", "description": "L’intitulé {credentialId} est unique et valide." } }, "notFound": { "title": "Oups ! Certificat non trouvé !", "description": "Le certificat que vous essayez de consulter n'est pas disponible.", "subtitle": "Veuillez contacter l'émetteur pour obtenir de l'assistance." } }, "share": { "title": "Votre certificat", "text": "est votre certificat ici", "dialogTitle": "Partager notre archiver votre certificat" }, "listing": { "courseAssignmentName": "Nom du cours", "offlineCertification": "certificat hors ligne", "completionDate": "date de fin", "expiryDate": "Date expiration", "type": "saisir", "sourceName": "Nom de la Source", "action": "Action" } };
const changePassword$6 = { "showPasswords": "Afficher les mots de passe", "retypePassword": "Saisissez à nouveau le mot de passe", "newPassword": "Nouveau mot de passe", "confirmNewPassword": "Confirm New Password", "currentPassword": "Mot de passe actuel", "emailId": "ID d'e-mail", "passwordMinLength": "Veuillez entrer un mot de passe d'au moins 8 caractères", "editAccount": "Modifier le compte", "loginEmail": "Adresse e-mail de connexion", "loginInformation": "Informations de connexion", "accountDetails": "Informations sur le compte", "accountDetailsUpdate": "Mettez à jour les informations de votre compte ici", "accountInformation": "Informations du compte", "changePassword": "Modifier le mot de passe", "hidePasswordChange": "Masquer le changement de mot de passe", "selectPageError": "Veuillez réessayer plus tard", "systemErrorOccurred": "Une erreur s'est produite", "passwordEntryInvalid": "Mot de passe non valide", "passwordUpdateSuccess": "Mot de passe mis à jour", "passwordLengthRequired": "Veuillez entrer un mot de passe d'au moins 8 caractères", "passwordMinimumLength": "Veuillez entrer un mot de passe d'au moins 8 caractères", "passwordFieldRequired": "Un mot de passe est obligatoire", "password": "Mot de passe" };
const deleteAccount$6 = { "title": "Supprimer le compte", "deleteAccountDescription": "Votre compte est programmé pour une désactivation temporairement et sera définitivement supprimé si vous ne vous in pas dans les 7 jours suivants.", "deleteAccountDescription2": "Pour conserver votre compte dynamique, il vous suffit de in avant l'échéance. Une fois supprimés, vos données ne peuvent pas être récupérées.", "deleteAccountButton": "oui, Supprimer le compte" };
const chats$6 = { "viewAll": "Afficher tout", "viewLess": "Afficher moins", "updatedPreference": "Préférences mises à jour", "chatSettings": "Paramètres du chat", "chats": "Chats", "chatSettingsDescription": "Sélectionner les paramètres de chat pour vos groupes et vos contacts", "groups": "Groupes", "blockedUsers": "Utilisateurs bloqués", "noGroups": "Aucun groupe", "controlUsers": "Gérer les utilisateurs avec lesquels vous ne souhaitez pas discuter.", "blockedConversations": "Conversations bloquées", "noBlockedUsers": "Aucun utilisateur bloqué", "unblock": "Débloquer", "noUsersBlocked": "Aucun utilisateur n'est bloqué", "noGroupsJoined": "Aucun groupe membre", "controlGroups": "Gérez les utilisateurs du groupe qui peuvent vous contacter en activant ou en désactivant la disponibilité de votre chat ci-dessous. Vous pouvez recevoir des messages uniquement des membres du groupe auquel vous appartenez. " };
const payments$6 = { "shareLink": "Partager le lien", "paymentLink": "Lien de paiement" };
const profileSettings$6 = { "complete": "COMPLET", "editBasicInformation": "Modifier les informations de base", "writeAboutYourself": "Rédigez quelque chose à propos de vous-même…", "selectTimezone": "Sélectionner le fuseau horaire", "description": "Cet élément sera affiché sur votre profil", "timezone": "Fuseau horaire", "enterLocation": "Saisissez le lieu", "exampleDescription": "Exemple : Bonjour, je m'appelle John Deo et je suis photographe.", "enterABriefDescription": "Saisissez une brève Beskrivelse", "bio": "Biographie", "profileSlugNotAvailable": "Slug de profil non disponible", "findAndShareProfile": "Découvrez et partagez facilement votre profil avec un slug d'URL personnalisé.", "profileSlug": "Slug du profil", "enterTitle": "Entrez un titre", "enterFullName": "Entrez le nom complet", "basicDetails": "Détails de base", "updateProfileDetails": "Mettez à jour vos informations de profil ici", "basicInformation": "Informations de base", "updatedProfileSettings": "Paramètres du profil mis à jour", "uploadStatusCode": "Le téléchargement a échoué avec le code de statut", "imageTypeNotSupported": "Le type d'image n'est pas pris en charge", "nameIsRequired": "Le nom est obligatoire", "invalidName": "Nom non valide", "profileImage0": "Photo de profil", "profileImage": "Photo de profil", "uploadSvgPngJpg": "Téléchargez un fichier SVG, PNG, JPG. Rapport hauteur/largeur recommandé 1:1", "profilesBuildConnection": "Les profils instaurent la confiance et créent des liens avec les autres", "clientPortalNames": "Le portail client n'est pas pareil sans visages ni noms.", "completeYourProfile": "Terminez votre profil", "uploadFailed": "Le téléchargement a échoué", "fileSizeTooLarge": "La taille du fichier est trop grande.", "invalidFileFormatType": "Format/type de document non valide.", "pleaseUploadImage": "Veuillez télécharger une image de type SVG, PNG, JPG ou JPEG.", "pleaseUploadAFileLessThan100Mb": "Veuillez télécharger un fichier dont la taille est inférieure à 100 Mo.", "oopsUnableToUploadImage": "Oups ! Impossible de télécharger l'image.", "selectPageError": "Veuillez réessayer plus tard", "search": "Rechercher", "searchTimezones": "Recherchez des fuseaux horaires", "noTimezonesFound": "Aucun fuseau horaire trouvé", "editDetails": "Modifier les informations", "profilePicture": "Photo de profil", "profileCover": "Couverture de profil", "uploadPhoto": "Télécharger une photo", "removePhoto": "Supprimer la photo", "invalidAspectRatio": "Rapport d'aspect invalide", "recommendedAspectRatio169": "Format d'image recommandé 16:9", "recommendedAspectRatio11": "Format d'image recommandé 1:1", "editProfile": "Modifier le profil", "manageYourGroupDetailsHere": "Gérez les informations sur votre groupe ici", "profileIcon": "Icône de profil", "specialCharactersNotSupported": "Les caractères spéciaux ne sont pas pris en charge", "slugValidation": { "containSpecialCharacters": "slug ne peut pas contenir un caractère spécial", "tooShort": "Le slug doit comporter au moins 3 caractères", "tooLong": "Le slug doit être inférieur à 50 caractères", "containOnlyNumbers": "Le slug ne peut pas contenir uniquement des chiffres", "startWithNumber": "Le slug ne peut pas commencer par un nombre", "startWithHyphen": "Le slug ne peut pas commencer par un enregistrement", "endWithHyphen": "slug ne peut pas se terminer avec un enregistrement", "containDoubleHyphen": "Le slug ne peut pas contenir de doubles indicatifs", "containSpace": "slug ne peut pas contenir d'espace" } };
const languageSettings$6 = { "title": "Paramètres de langue", "detailsHere": "Sélectionner la langue du portail client", "selectLanguage": "Sélectionner la langue", "useLocationLanguage": "Utiliser la Langue de emplacement", "languagePreferenceUpdated": "Préférences de langue mises à jour", "errorUpdatingLanguage": "Erreur lors de la mise à jour de la langue", "description": "Sélectionnez votre langue préférée pour visualiser les éléments du portail client, le contenu de la communauté, les cours et les informations sur les affiliés. Ce paramètre vous permet de voir le contenu dans la langue avec laquelle vous êtes le plus à l’aise. ", "shortDescription": "Sélectionnez votre langue préférée" };
const userActivityOverview$6 = { "dustBunnies": "Rien à voir, sauf si vous aimez les moutons de poussière.", "welcomeBanner": "Bienvenue sur", "contracts": "Contrats", "hiUser": "Bonjour", "estimates": "estimations", "sharedFiles": "fichiers partagés" };
const widget$6 = { "viewAll": "Afficher tout", "addedOn": "Ajouté le", "by": "via", "you": "vous", "admin": "admin", "youDoNotHaveAny": "Vous n'en avez pas.", "noContracts": "Pas de contrats", "maxFilesExceeded": "vous pouvez au maximum télécharger 10 fichiers", "uploadFile": "télécharger le fichier", "userActivityOverview.contracts": "Contrats", "selectPageError": "Veuillez réessayer plus tard", "notAbleToDownloadContract": "Impossible de télécharger le contrat.", "completeCourse": "Terminer le cours", "courseProgress": "Progression du cours", "viewAllGroups": "Afficher tous les Groupes", "recentlyOpened": "Récemment ouvert", "noInvoices": "Aucune facture", "noEstimates": "Aucune estimation", "notAbleToDownloadInvoice": "Impossible de télécharger la facture", "contracts": "Contrats", "invoices": "Factures", "youMarked": "Vous avez marqué", "inCourse": "en cours", "invoice": "Facture", "makePayment": "Faire un paiement", "downloadInvoice": "Télécharger la facture", "viewGroup": "Afficher le groupe", "payment": "Paiement", "download": "Télécharger", "signContract": "accord sur les symboles", "sign": "symboles", "estimates": "estimations", "notAbleToDownloadEstimate": "Impossible de télécharger l’estimation", "addFiles": "ajouter des fichiers", "sharedFiles": "fichiers partagés", "fileManagement": "Gestion des documents", "noFiles": "Aucun fichiers" };
const dashboard$6 = { "joinAGroup": "Rejoindre un groupe", "takeACourse": "Suivre un cours", "checkAffiliateEarnings": "Vérifiez les gains des affiliés", "manageSubscriptions": "Gérer les abonnements", "contracts": "contrat", "estimates": "estimations", "sharedFiles": "fichiers partagés", "paidOn": "Payé le", "partiallyPaidOn": "Partiellement payé le", "overdueSince": "En retard depuis", "dueOn": "À payer le", "hello": "Bonjour", "viewGroup": "Afficher le groupe", "recentlyOpened": "Récemment ouvert", "noItemsYet": "Vous n'en avez pas.", "affiliates": "Affiliés", "exploreHere": "Explorez ici", "selectApp": "Sélectionnez votre application", "exploreCourses": "Explorez les cours disponibles", "courses": "Cours", "engageCommunity": "Participez à la communauté", "communities": "Communautés", "noDataAvailable": "Aucune donnée disponible à la minute", "noAppsAvailable": "Aucune applications disponible", "noWidgetsAvailable": "Aucun widget à afficher", "noContentAvailable": "Aucun contenu disponible" };
const uploadDocument$6 = { "uploadHeader": "ajouter des fichiers", "uploadDescription": "Sélectionnez et téléchargez jusqu'à 10 documents.", "uploadWarning": "Ce paramètre sera visible dans admin du portail pour afficher et télécharger", "uploadInstruction": "Cliquez pour télécharger ou glissez-déposez.", "allowedFiles": "ACH, PNG, JPG, GIF, PPT ou PDF (max. 100 Mo)", "cancelButton": "Annuler", "uploadButton": "télécharger", "confirmDeletion": "suppression", "deleteFile": "Supprimer le fichier", "deleteFileDescription": "Voulez-vous vraiment supprimer ce fichier ? Cette Action est irréversible.", "deleteFileButton": "oui, Supprimer le fichier", "deleteFileSuccessTitle": "fichier supprimé avec succès", "deleteFileErrorTitle": "erreur in la suppression du fichier", "deleteFileErrorMessage": "Une erreur s'est produite lors de la tentative de suppression du fichier.", "cancel": "nul", "notAbleToDownloadFile": "Impossible de télécharger le fichier", "fileSizeExceeded": "La taille du fichier dépasse 100 Mo", "invalidFileType": "champ non valide", "notAbleToUploadFile": "Impossible de télécharger le fichier", "downloadError": "erreur in le fichier", "fileUploadedSuccessfully": "Télécharger le fichier", "fileDownloadedSuccessfully": "télécharger avec succès" };
const navbar$6 = { "hi": "Bonjour", "manageYourAccount": "Gérez votre compte", "logOut": "Se déconnecter", "affiliates": "Affiliés", "courses": "Cours", "communities": "Communautés" };
const mandatedInfoModal$6 = { "invalidFileFormat": "Format/type de document non valide.", "pleaseUploadImage": "Veuillez télécharger une image de type SVG, PNG, JPG, JPEG", "fileSizeTooLarge": "Le fichier est trop volumineux.", "oopsUnableToUploadImage": "Oups ! Impossible de télécharger l'image.", "pleaseUploadFileLessThan100MB": "Veuillez télécharger un fichier de moins de 100 Mo", "pleaseTryAgainLater": "Veuillez réessayer plus tard", "completeYourProfile": "Terminez votre profil", "profilesBuildConnection": "Les profils instaurent la confiance et créent des liens avec les autres", "putAFaceToYourProfile": "Ajoutez une photo à votre profil !", "uploadASVGPNGJPG": "Téléchargez un fichier SVG, PNG, JPG.", "recommendedAspectRatio11": "Rapport hauteur/largeur recommandé 1:1", "complete": "COMPLET", "cropYourAvatar": "Rognez votre avatar", "dragToReposition": "Faites glisser pour repositionner" };
const sideBar$6 = { "languageSettings": "Paramètres de Langue", "profile": "Profil", "account": "Compte", "socialMedia": "Réseau social", "certificates": "Certificats", "billingSubscription": "Facturation et abonnement", "communitiesChats": "Communautés et chats", "affiliates": "Affiliés", "notifications": "rappel" };
const notifications$6 = { "title": "Notifications", "all": "Tout", "unread": "Non lu", "markAllRead": "Marquer tous les textes comme lus", "noNotifications": "Pas encore de rappel", "whenYouGetNotifications": "Quand vous recevez des rappels, ils s’affichent ici" };
const affiliates$6 = { "payoutMethod": "méthode de paiement", "leadCustomer": "prospects/ clients", "commissions": "Campagnes", "description": "Recommandez GoKollab aux utilisateurs", "title": "Affiliés", "groupsGoKollab": "Créer des groupes sur GoKollab est entièrement gratuit, mais ce n'est que le début ! De nouvelles fonctionnalités passionnantes sont en cours de développement pour vous aider à développer votre entreprise en ligne et à multiplier vos revenus. À mesure que les utilisateurs effectuent une mise à niveau pour débloquer la suite complète de fonctionnalités, vous recevrez une commission d'affiliation récurrente à vie sur leur abonnement. Plus tôt vous commencez à parrainer, mieux c’est : ne passez pas à côté de cet incroyable programme d’affiliation", "yourAffiliateLink": "Votre lien d'affilié" };
const deleteCard$6 = { "deleteCard": "Supprimer la carte", "description": "Le mode de paiement ne sera plus utilisable après sa suppression. Cette action est irréversible.", "activeCard": "Cette carte est utilisée pour un ou plusieurs paiements d'abonnements actifs. La suppression de cette carte sans mettre à jour le mode de paiement des abonnements associés affectera les paiements futurs. Voulez-vous vraiment supprimer cette carte ?", "title": "Supprimer le mode de paiement ?", "cardCannotBeDeleted": "La carte ne peut pas être supprimée", "cardIsLinkedToSubscriptions": "La carte est associée à des abonnements", "errorInDeletingCard": "Erreur lors de la suppression de la carte", "noCardAvailable": "Aucune carte disponible", "cardRemovedSuccessfully": "Carte supprimée avec succès" };
const notificationPreferences$6 = { "title": "paramètres de notification", "description": "Gérez et qu'avez-vous besoin de faire traduire ?", "pushNotificationsTitle": "rappel", "pushNotificationsDescription": "rappel", "emailNotificationsTitle": "rappel par e-mail", "emailNotificationsDescription": "gérer le rappel par e-mail", "emailNotifications": "rappel par e-mail", "manageEmailNotifications": "gérer le rappel par e-mail", "newActivity": "activité", "email": "des E-mail", "push": "push", "allNotifications": "rappel", "postTags": "mots-clés", "postEveryoneTagged": "Partager {'@'}tout le monde", "postMention": "Partager la mention {'@'}", "postLike": "aimer", "newComment": "Nouveau commentaire", "commentEveryoneTagged": "Comment {'@'}je vous aider aujourd'hui ?", "commentMention": "Comment puis {'@'}je vous aider aujourd'hui ?", "commentLike": "aimer les commentaires", "postEveryoneTaggedMobile": "Partager {'@'}tout le monde", "postMentionMobile": "Partager la mention {'@'}", "commentEveryoneTaggedMobile": "Comment {'@'}je vous aider aujourd'hui ?", "commentMentionMobile": "Comment puis {'@'}je vous aider aujourd'hui ?", "newMemberRequestToJoinGroup": "Les nouveaux membres du groupe", "groupJoiningRequestApproved": "Demandes de groupe acceptés", "groupJoiningRequestRejected": "Rejoindre le groupe", "roleUpdatedInPrivateChannel": "Le rôle mis à jour in le canal privé", "newCourseAvailable": "Nouveau cours ajouté au Groupe", "newEventCreated": "Nouveau lieu", "newCourseComment": "Nouveau commentaire", "certificateIssued": "certificat émis", "postEveryoneTaggedDescription": "{'@'}le monde", "postMentionDescription": "quand quelqu'un publiera une mention {'@'}", "postLikeDescription": "Quand quelqu'un mentions J'aime votre partage", "newCommentDescription": "quand quelqu'un a des feedback sur votre e-mail", "commentEveryoneTaggedDescription": "{'@'}le feedback", "commentMentionDescription": "quand quelqu'un a des feedback {'@'}", "commentLikeDescription": "Quand quelqu'un mentions J'aime votre commentaire", "newMemberRequestToJoinGroupDescription": "Quand quelqu'un demande à rejoindre votre groupe", "groupJoiningRequestApprovedDescription": "Quand le groupe de quelqu'un a accepté", "groupJoiningRequestRejectedDescription": "Quand le groupe de quelqu'un est refusé", "roleUpdatedInPrivateChannelDescription": "Quand le rôle de quelqu'un est manqué à jour in un canal privé", "newCourseAvailableDescription": "Quand un nouveau cours est disponible", "newEventCreatedDescription": "Quand un nouvel événement est créé", "newCourseCommentDescription": "Quand quelqu'un a des feedback concernant un cours", "certificateIssuedDescription": "Quand un certificat est émis", "estimateReceivedDescription": "Quand une nouvelle estimation est reçue", "contractReceivedDescription": "Quand un nouvel accord est refusé", "invoiceReceivedDescription": "Quand un nouveau facture est reçu", "allEmailNotificationsDescription": "rappel", "allPushNotificationsDescription": "rappel", "errorUpdating": "Il y a eu une erreur lors de la mise à jour de vos paramètres notification", "updateSuccess": "Vos paramètres notification ont été manqué à jour", "willNotReceiveNotificationsIfAdminDisabled": "vous n'avez pas l'autorisation de vous aider. Veuillez fournir le texte que vous souhaitez traduire.", "estimateReceived": "Nouvelle estimation reçue", "contractReceived": "absence", "invoiceReceived": "Nouveau facture reçue", "pushNotificationNotAvailable": "notification push n'est pas disponible pour cet événement", "newsletter": "newsletter", "emailNotificationNotAvailable": "La notification push par Email n’est pas disponible pour cet Événement.", "newPostFollowers": "Nouvelle publication d'un utilisateur suivi", "newPostFollowersDescription": "Soyez averti quand quelqu’un que vous suivez crée une nouvelle publication.", "newFollower": "Soyez averti quand quelqu’un vous suit." };
const loginPage$6 = { "forgotPassword": "Mot de passe perdu ?", "login": "se connecter", "lastLogin": "dernier contact", "proceedToLogin": "poursuivre à la se connecter", "secureCode": "code sécurisé", "newUser": "Nouveau utilisateur ?", "resetPasswordLink": "Si l'e-mail saisi est correct, vous hériter d'un lien password in l'e-mail. Veuillez vous assurer que vous codez également le dossier de spam.", "loginWithSecureCode": "se connecter avec un code sécurisé", "signUp": "S’inscrire", "enterOtp": "Saisissez le mot de passe à usage unique", "selectAccount": "Sélectionner le compte que vous souhaitez ajouter", "resetPassword": "réinitialiser le mot de passe", "selectUser": "Sélectionner un utilisateur", "emailRequired": "Saisissez une adresse e-mail valide", "fullNameRequired": "Veuillez entrer votre nom", "passwordRequired": "Veuillez saisir un password de minimum 8 caractères", "generateSecureCode": "générer un code sécurisé", "loginWithPassword": "se connecter avec votre mot de passe", "secureCodeEmail": "Veuillez coder votre adresse e-mail pour le code sécurisé . Si vous n'avez pas reçu d'e-mail de notre part,", "resendOtp": "Appuyez ici pour renvoyer.", "verifySecureCode": "vérifier le code sécurisé", "secureCodeNumeric": "code sécurisé doit être d'une valeur numérique et doit être de 6 chiffres", "alreadyHaveAccount": "Vous avez déjà un compte ?", "email": "des E-mail", "password": "Mot de passe", "fullName": "Nom complet", "somethingWentWrong": "Une erreur s'est produite", "signInWithEmail": "ous, connecter avec votre adresse e-mail", "signUpWithEmail": "Ou inscrivez-vous avec votre e-mail", "confirmPassword": "Confirmer le mot de passe", "validationErrors": { "potentialSpamUser": { "title": "compte privé", "message": "Votre compte a été privé de l'activité de spam. Veuillez Contact le support pour obtenir de l'aide." }, "somethingWentWrong": { "title": "Une erreur s'est produite", "message": "Impossible de se connecter. Veuillez réessayer plus tard." }, "bannedUser": { "title": "compte privé", "message": "Votre compte a été banni en raison de l'activité de spam potentiel. Veuillez Contact le support pour obtenir de l'aide." } } };
const magicLink$6 = { "newLinkSent": "Nouveau lien", "portalWillSendLink": "portail", "failedToSendNewLink": "échec de télécharger le nouveau lien", "pleaseTryAgain": "Veuillez réessayer", "linkExpired": "Ce lien de votre E-mail a arrivé à expiration.", "toContinue": "Pour continuer, demandes un nouveau lien ou in à votre compte de portail", "sendNewLink": "télécharger le lien", "logIn": "inconnecter", "clickToLogIn": "Cliquez ici pour in à votre compte", "invalidToken": "Ce jeton de votre E-mail n'est pas valide.", "toContinueContactAdmin": "Pour continuer, demandes un nouveau Contact in votre compte d'administrateurs." };
const setPassword$6 = { "minLength": "Veuillez saisir un password de minimum 8 caractères", "passwordsMustMatch": "Les mots de passe doivent correspondre", "setSecurePassword": "collecter votre passwordsécurisé", "setPasswordButton": "Mot de passe de la collection" };
const alerts$6 = { "tooManyAttempts": { "title": "Trop de tentatives", "message": "Pas plus de 2 tentatives de mise à jour slug sont autorisées in une fenêtre de mois" }, "slugAlreadyExists": { "title": "Le slug existe déjà", "message": "Veuillez réessayer un autre slug" }, "updateSlugError": { "title": "Une erreur s'est produite", "message": "Impossible de mettre à jour le slug du profil. Veuillez réessayer après une Date" }, "updateProfileError": { "title": "Une erreur s'est produite", "message": "Impossible de mettre à jour les informations de votre profil. Veuillez réessayer après une Date" } };
const bottomNavBar$6 = { "home": "accueil", "discover": "découvrir", "communities": "communautés", "courses": "cours", "more": "Plus" };
const forceUpdate$6 = { "title": "La mise à jour est disponible", "description": "Mettre à jour votre application vers la dernière version", "buttonText": "Mettre à jour maintenant !" };
const accessibility$6 = { "copyAffiliateLink": "copier le lien d'affilié dans le presse-papiers", "deleteCard": "Supprimer la carte", "appSwitcher": "application à bouton à bascule", "portalImage": "image de portail", "profileImage": "image de profil", "continueWithGoogle": "continuer avec Google" };
const resetPassword$6 = { "passwordExpired": "Votre lien d'expiration a atteint l'expiration password .", "regenerateLink": "Réinitialiser le lien", "proceedToLogin": "poursuivre à la se connecter", "passwordChangedSuccessfully": "Mot de passe dynamique", "changePassword": "modifier le mot de passe", "newPassword": "Veuillez saisir un password de minimum 8 caractères", "confirmPassword": "La confirmation password ne correspond pas", "setNewPassword": "collection Nouveau mot de passe", "confirmNewPassword": "Confirmer le nouveau mot de passe" };
const frFR = {
  common: common$6,
  account: account$6,
  wallet: wallet$6,
  support: support$6,
  social: social$6,
  validation: validation$6,
  forms: forms$6,
  auth: auth$6,
  billing: billing$6,
  transactions: transactions$6,
  cancelModal: cancelModal$6,
  certificates: certificates$6,
  changePassword: changePassword$6,
  deleteAccount: deleteAccount$6,
  chats: chats$6,
  payments: payments$6,
  profileSettings: profileSettings$6,
  languageSettings: languageSettings$6,
  userActivityOverview: userActivityOverview$6,
  widget: widget$6,
  dashboard: dashboard$6,
  uploadDocument: uploadDocument$6,
  navbar: navbar$6,
  mandatedInfoModal: mandatedInfoModal$6,
  sideBar: sideBar$6,
  notifications: notifications$6,
  affiliates: affiliates$6,
  deleteCard: deleteCard$6,
  notificationPreferences: notificationPreferences$6,
  loginPage: loginPage$6,
  magicLink: magicLink$6,
  setPassword: setPassword$6,
  alerts: alerts$6,
  bottomNavBar: bottomNavBar$6,
  forceUpdate: forceUpdate$6,
  accessibility: accessibility$6,
  resetPassword: resetPassword$6
};
const common$5 = { "show": "Mostra", "newPost": "Nuovo post", "active": "Attivo", "change": "Modifica", "remove": "Rimuovi", "cancel": "Annulla", "publish": "Pubblica", "save": "Salva", "draft": "Bozza", "scheduled": "Programmato", "published": "Pubblicato", "actions": "Azioni", "archive": "Archivia", "delete": "Elimina", "edit": "Modifica", "settings": "Impostazioni", "updatedOn": "Aggiornato il", "blogPost": "Post del blog", "category": "Categoria", "author": "Autore", "status": "Stato", "errors": "Errori", "error": "Errore", "all": "Tutto", "add": "Aggiungi", "discussion": "Discussione", "allCourses": "Tutti i corsi", "myCourses": "I miei corsi", "learning": "Apprendimento", "leaderboard": "Classifica", "documentsAndPayments": "Gestione documenti & file", "more": "Più", "profile": "Profilo", "archived": " Archiviato", "back": "Indietro", "restore": "Ripristina questa versione", "next": "Successivo", "previous": "Precedente", "continue": "Continua", "details": "Dettagli", "youtube": "Youtube", "action": "Azione", "view": "Visualizza", "download": "Scarica", "source": "Fonte", "title_column": "Titolo", "copy": "Copia", "viewReceipt": "Visualizza ricevuta", "id": "ID", "location": "Luogo", "email": "Email", "title": "Titolo", "logout": "Disconnessione", "login": "Login", "calender": "Calendario", "apply": "Applica", "clear": "Rimuovi", "to": "A", "from": "Da", "type": "Tipo", "home": "Home", "description": "Description", "updated": "Aggiornato", "networkError": { "title": "Nessuna connessione Internet", "message": "Controlla la tua connessione internet e riprova." } };
const account$5 = { "settings": "Impostazioni dell'account", "updateSettings": "Aggiorna qui le impostazioni del tuo account", "paymentDetails": "Dati di pagamento", "orderId": "ID ordine interno", "nextInvoice": "Prossima fattura", "transactionDate": "Data della transazione", "expiryDate": "Data di scadenza", "manageAllSubscription": "Gestisca tutti i suoi abbonamenti", "paymentMethod": "Metodo di pagamento", "andTransactionHere": "& transazione qui" };
const wallet$5 = { "transactionId": "ID transazione" };
const support$5 = { "subscriptionId": "ID abbonamento", "email": { "validation": "Inserisci un'email valida" }, "invoiceNo": "Numero fattura" };
const social$5 = { "title": "Social media", "invalidURL": "URL non valido", "phoneNumber": "Numero di telefono", "userPhone": "Telefono dell'utente", "userEmail": "Email dell'utente", "info": "Informazioni social", "update": "Aggiorna le informazioni sui social media", "detailsHere": "Aggiorna qui i dettagli dei tuoi social media", "updated": "Social media aggiornati", "visibility": "Visibile pubblicamente", "validUrl": "Inserisca un URL valido", "validEmail": "Inserisci un'email valida", "validPhoneNumber": "Inserisci un numero di telefono valido con il prefisso internazionale appropriato", "platforms": { "twitter": "Twitter", "instagram": "Instagram", "facebook": "Facebook", "youtube": "Youtube", "linkedin": "LinkedIn" } };
const validation$5 = { "phone": "Inserisci un numero di telefono valido", "url": "Inserisca un URL valido" };
const forms$5 = { "phone": "Numero di telefono" };
const auth$5 = { "clickToResend": "Fai clic per inviarlo nuovamente", "authentication": "Autenticazione", "didntGetCode": "Non hai ricevuto il codice?", "confirmationCode": "Codice di verifica", "sentVerificationEmail": "Abbiamo inviato un codice di verifica tramite email a", "authenticateAccount": "Autentichi il Suo account", "incorrectOrExpired": "L'OTP è errato o scaduto", "failedToSend": "Invio dell'OTP non riuscito", "checkEmailForSecureCode": "Controlla la tua email per visualizzare il codice di sicurezza. Se non hai ricevuto nessuna email da parte nostra,", "user": "Utente", "verify": "Verifica", "tapHereToResend": "tocca qui per inviarla nuovamente.", "failedToVerifyOtp": "Verifica dell'OTP non riuscita", "failedToGetOtp": "Non è stato possibile ottenere l'OTP" };
const billing$5 = { "endingIn": "termina con", "billingInformation": "Dati di fatturazione", "billingAddress": "Indirizzo di fatturazione:", "sourceType": "Tipo di fonte:", "invoices": "Fatture", "subscription": "Abbonamento", "transactions": "Transazioni", "transaction": "Transazione", "subscriptions": "Abbonamenti", "invoiceName": "Nome della fattura", "subscriptionName": "Nome dell'abbonamento", "dueDate": "Data di scadenza", "issueDate": "Data di emissione", "amount": "Importo", "manageSubscriptions": "Gestisci tutti i tuoi abbonamenti", "andSubscription": "& Abbonamento", "andTransaction": "e le tue transazioni qui", "billing": "Fatturazione", "startDate": "Data di inizio", "fullName": "Nome e cognome", "nextInvoiceOn": "Prossima fattura in data", "noDataFound": "Nessun dato trovato", "invoiceNo": "N. fattura:", "manageSubscriptionsInvoicesAndTransactions": "Gestisci abbonamenti, fatture e transazioni", "created": "Creato:", "transactionName": "Nome della transazione", "tid": "Ora:", "transactionDate": "Data della transazione:", "trial": "Prova", "expired": "Scaduta", "pastDue": "Scadenza superata", "unpaid": "Non pagata", "incompleteExpired": "Incompleta scaduta", "canceled": "Annullata", "incomplete": "Incompleta", "failed": "Non riuscita", "sent": "Inviata", "paid": "Pagata", "paymentProcessing": "Elaborazione del pagamento", "partiallyPaid": "Pagata parzialmente", "overdue": "Scaduta", "succeeded": "Riuscita", "processing": "Elaborazione in corso", "refunded": "Rimborsata", "pending": "In sospeso", "membership": "Abbonamento", "communities": "Comunità", "paymentLink": "Link di pagamento", "expiresOn": "Scade il", "errorFetchingPaymentMethods": "Errore durante il recupero dei metodi di pagamento", "pageUrl": "URL Pagina" };
const transactions$5 = { "title": "Transazioni", "name": "Nome delle transazioni" };
const cancelModal$5 = { "subscriptionRenewNotice": "Se cambi idea, puoi rinnovare l'abbonamento in qualsiasi momento.", "cancelSubscription": "Annulla abbonamento", "subscriptionCancelNotice": "verrà annullato immediatamente. Non ti verrà addebitato di nuovo.", "yourPlanName": "Il tuo piano", "currentPlan": "Piano attuale", "subscriptionCancelError": "Si è verificato un errore nel tentativo di annullare l'abbonamento.", "cancelSubscriptionFailed": "Annullamento dell'abbonamento non riuscito" };
const certificates$5 = { "title": "Certificati", "certificatesDescription": "Certificati Scarica e Condividi ottenuti da te.", "subtitle": "Scarica i tuoi certificati", "completedOn": "Fatto Attivo", "back": "Indietro", "previous": "Precedente", "next": "Successivo", "downloadYourCertificates": "Scarica i tuoi certificati", "downloadCertificate": "Scarica {type}", "viewCertificates": "Visualizza e scarica qui tutti i tuoi certificati", "certificateNotFound": "Nessun Certificato trovato", "issuedOn": "Emesso Attivo", "expiresOn": "Scade Attivo", "description": "Descrizione", "yourCertificateHasExpiredOn": "Il tuo {type} ha Scaduto Attivo", "issuedCertificatesNotFound": "Non Tu ancora ottenuto alcun certificato.", "shareCertificate": "Condividi:", "preview": { "issuedTo": "Emesso a", "issuedBy": "Emesso da", "addToLinkedin": "Aggiungi al profilo LinkedIn", "download": "Scarica", "credentialVerification": "Verifica credenziali", "issueDate": "Data di emissione", "expiryDate": "Data di scadenza", "verifyCredential": "Verifica Credenziale", "shareYourCredential": "Condividi le tue credenziali", "showYourCredential": "Mostra le tue credenziali sul tuo Social Sistema", "expiredOn": "Scaduto il", "expiredDesc": "È ora di rinnovare e rimanere aggiornati. Non perdere i continui vantaggi e le Potenziali clienti.", "verificationModal": { "title": "Verifica credenziali", "subtitle": "Queste sono le credenziali valide.", "description": " Questa credenziale è stata emessa in modo sicuro. Tutti i Dettagli visualizzati sono validi.", "step1": { "title": "Verifica del destinatario", "description": "Il titolare di questa credenziale è {recipient}" }, "step2": { "title": "Verifica dell'emittente", "description": "Questa credenziale è stata emessa da  {issuer}" }, "step3": { "title": "Verifica dell'ID della credenziale", "description": "L\\'Etichetta {credentialId} è unica e valida." } }, "notFound": { "title": "Ops! Certificato non trovato!", "description": "Il certificato che stai cercando di visualizzare non è disponibile.", "subtitle": "Contatti l'emittente per assistenza." } }, "share": { "title": "Il tuo Certificato", "text": "qui è il tuo certificato", "dialogTitle": "Condividi O Archivia il tuo Certificato" }, "listing": { "courseAssignmentName": "Nome del corso/attività", "offlineCertification": "Certificazione offline", "completionDate": "I dati vanno bene", "expiryDate": "Data Scadenza", "type": "Digita", "sourceName": "Nome Fonte", "action": "Azione" } };
const changePassword$5 = { "showPasswords": "Mostra password", "retypePassword": "Digita nuovamente la password", "newPassword": "Nuova password", "confirmNewPassword": "Confirm New Password", "currentPassword": "Password attuale", "emailId": "ID email", "passwordMinLength": "Digita una password di almeno 8 caratteri", "editAccount": "Modifica Account", "loginEmail": "Email di accesso", "loginInformation": "Dati di accesso", "accountDetails": "Dettagli dell'account", "accountDetailsUpdate": "Aggiorna qui i dettagli del tuo account", "accountInformation": "Informazioni sull'account", "changePassword": "Modifica password", "hidePasswordChange": "Nascondi modifica password", "selectPageError": "Riprova più tardi", "systemErrorOccurred": "Qualcosa è andato storto", "passwordEntryInvalid": "Password non valida", "passwordUpdateSuccess": "Password aggiornata", "passwordLengthRequired": "Digita una password di almeno 8 caratteri", "passwordMinimumLength": "Digita una password di almeno 8 caratteri", "passwordFieldRequired": "La password è obbligatoria", "password": "Password" };
const deleteAccount$5 = { "title": "Elimina Account", "deleteAccountDescription": "Il tuo Account è programmato per la disattivazione temporanea e sarà in modo permanente Eliminato Se Tu non effettua l' in entro i Successivo 7 giorni.", "deleteAccountDescription2": "Per Mantieni il tuo Account Dinamico, ti basterà in a Prima entro la scadenza. Una volta Eliminato, i tuoi dati non possono essere recuperati.", "deleteAccountButton": "Sì, Elimina Account" };
const chats$5 = { "viewAll": "Mostra tutto", "viewLess": "Mostra meno", "updatedPreference": "Preferenza aggiornata", "chatSettings": "Impostazioni di chat", "chats": "Chat", "chatSettingsDescription": "Configura le impostazioni di chat per i tuoi gruppi e contatti", "groups": "Gruppi", "blockedUsers": "Utenti bloccati", "noGroups": "Nessun gruppo", "controlUsers": "Gestisci con quali utenti non vuoi chattare.", "blockedConversations": "Conversazioni bloccate", "noBlockedUsers": "Nessun utente bloccato", "unblock": "Sblocca", "noUsersBlocked": "Nessun utente bloccato", "noGroupsJoined": "Unione effettuata con nessun gruppo", "controlGroups": "Controlla quali utenti del gruppo possono contattarti attivando o disattivando qui sotto la tua disponibilità a chattare. Puoi ricevere messaggi solo dai membri del gruppo di cui fai parte. " };
const payments$5 = { "shareLink": "Condividi link", "paymentLink": "Link di pagamento" };
const profileSettings$5 = { "complete": "COMPLETATO", "editBasicInformation": "Modifica le informazioni di base", "writeAboutYourself": "Scrivi qualcosa su di te...", "selectTimezone": "Seleziona il fuso orario", "description": "Sarà visibile sul tuo profilo", "timezone": "Fuso orario", "enterLocation": "Inserisci la località", "exampleDescription": "Esempio: Ciao, mi chiamo John Deo e sono un fotografo", "enterABriefDescription": "Inserisci una breve descrizione", "bio": "Biografia", "profileSlugNotAvailable": "Slug del profilo non disponibile", "findAndShareProfile": "Trova e condividi facilmente il tuo profilo con uno slug URL personalizzato.", "profileSlug": "Slug del profilo", "enterTitle": "Inserisci titolo", "enterFullName": "Inserisci nome e cognome", "basicDetails": "Informazioni di base", "updateProfileDetails": "Aggiorna qui i dati del tuo profilo", "basicInformation": "Informazioni di base", "updatedProfileSettings": "Impostazioni del profilo aggiornate", "uploadStatusCode": "Caricamento non riuscito con codice di stato", "imageTypeNotSupported": "Tipo di immagine non supportato", "nameIsRequired": "Il nome è obbligatorio", "invalidName": "Nome non valido", "profileImage0": "Immagine del profilo", "profileImage": "Immagine del profilo", "uploadSvgPngJpg": "Carica un file SVG, PNG o JPG. Rapporto d'aspetto consigliato: 1:1", "profilesBuildConnection": "I profili generano fiducia e incentivano la connessione con gli altri", "clientPortalNames": "Senza volti e nomi, il portale clienti sembra strano.", "completeYourProfile": "Completa il tuo profilo", "uploadFailed": "Caricamento non riuscito", "fileSizeTooLarge": "La dimensione del file è troppo grande", "invalidFileFormatType": "Formato/tipo di file non valido.", "pleaseUploadImage": "Carica un'immagine in formato SVG, PNG, JPG o JPEG.", "pleaseUploadAFileLessThan100Mb": "Carica un file di dimensioni inferiori a 100 MB.", "oopsUnableToUploadImage": "Ops! Impossibile caricare l'immagine.", "selectPageError": "Riprova più tardi", "search": "Cerca", "searchTimezones": "Cerca fusi orari", "noTimezonesFound": "Nessun fuso orario trovato", "editDetails": "Modifica informazioni", "profilePicture": "Foto del profilo", "profileCover": "Copertina del profilo", "uploadPhoto": "Carica la foto", "removePhoto": "Rimuovi foto", "invalidAspectRatio": "Rapporto d'aspetto non valido", "recommendedAspectRatio169": "Rapporto d'aspetto consigliato: 16:9", "recommendedAspectRatio11": "Rapporto d'aspetto consigliato: 1:1", "editProfile": "Modifica profilo", "manageYourGroupDetailsHere": "Gestisci qui i dettagli del tuo gruppo", "profileIcon": "Icona del profilo", "specialCharactersNotSupported": "I caratteri speciali non sono supportati", "slugValidation": { "containSpecialCharacters": "Slug non può contenere un Carattere speciale", "tooShort": "Slug deve essere lungo almeno 3 Caratteri", "tooLong": "Slug deve essere lungo meno di 50 Carattere", "containOnlyNumbers": "Slug non può contenere solo numeri", "startWithNumber": "Slug non può iniziare con un numero", "startWithHyphen": "Slug non può iniziare con un trattino", "endWithHyphen": "Slug non può andare bene con un trattino", "containDoubleHyphen": "Slug non può contenere doppi trattini", "containSpace": "Slug non può contenere Spazio" } };
const languageSettings$5 = { "title": "Impostazioni della lingua", "detailsHere": "Scegli la lingua del portale clienti", "selectLanguage": "Seleziona lingua", "useLocationLanguage": "Usa la Lingua Luogo", "languagePreferenceUpdated": "Preferenze sulla lingua aggiornate", "errorUpdatingLanguage": "Aggiornamento della lingua non riuscito", "description": "Seleziona la tua lingua preferita per la visualizzazione delle sezioni del portale clienti, dei contenuti della comunità, dei corsi e delle informazioni sugli affiliati. Questa impostazione ti consente di visualizzare i contenuti nella lingua che ti fa sentire più a tuo agio. ", "shortDescription": "Seleziona la tua lingua preferita" };
const userActivityOverview$5 = { "dustBunnies": "Niente da vedere, a meno che non ti piacciano i batuffoli di polvere.", "welcomeBanner": "Ti diamo il benvenuto su", "contracts": "Contratti", "hiUser": "Salve", "estimates": "Stime", "sharedFiles": "File condivisi" };
const widget$5 = { "viewAll": "Mostra tutto", "addedOn": "Aggiunto in data", "by": "Tramite", "you": "Tu", "admin": "Amministratore", "youDoNotHaveAny": "Non ne hai!", "noContracts": "Nessun contratto", "maxFilesExceeded": "Tu puoi caricare solo fino a 10 File", "uploadFile": "Carica File", "userActivityOverview.contracts": "Contratti", "selectPageError": "Riprova più tardi", "notAbleToDownloadContract": "Impossibile scaricare il contratto", "completeCourse": "Corso completato", "courseProgress": "Avanzamento del corso", "viewAllGroups": "Visualizza tutti i gruppi", "recentlyOpened": "Aperto di recente", "noInvoices": "Nessuna fattura", "noEstimates": "Nessuna stima", "notAbleToDownloadInvoice": "Impossibile scaricare la fattura", "contracts": "Contratti", "invoices": "Fatture", "youMarked": "Hai completato:", "inCourse": "nel corso", "invoice": "Fattura", "makePayment": "Effettua pagamento", "downloadInvoice": "Scarica fattura", "viewGroup": "Visualizza gruppo", "payment": "Pagamento", "download": "Scarica", "signContract": "Simboli Accordo", "sign": "Simboli", "estimates": "Stime", "notAbleToDownloadEstimate": "Impossibile scaricare la stima", "addFiles": "Aggiungi File", "sharedFiles": "File condivisi", "fileManagement": "Gestione documenti", "noFiles": "Nessun File" };
const dashboard$5 = { "joinAGroup": "Unisciti a un gruppo", "takeACourse": "Segui un corso", "checkAffiliateEarnings": "Controlla i guadagni degli affiliati", "manageSubscriptions": "Gestisci abbonamenti", "contracts": "Contratti", "estimates": "Stime", "sharedFiles": "File condivisi", "paidOn": "Pagamento in data", "partiallyPaidOn": "Pagamento parziale in data", "overdueSince": "Scaduto dal", "dueOn": "In scadenza giorno", "hello": "Salve", "viewGroup": "Visualizza gruppo", "recentlyOpened": "Aperto di recente", "noItemsYet": "Non ne hai ancora!", "affiliates": "Affiliati", "exploreHere": "Esplora qui", "selectApp": "Seleziona la tua app", "exploreCourses": "Esplora i corsi disponibili", "courses": "Corsi", "engageCommunity": "Interagisci con la comunità", "communities": "Comunità", "noDataAvailable": "Nessun dato disponibile al minuto", "noAppsAvailable": "Nessuna App disponibile", "noWidgetsAvailable": "Nessun widget per Visualizzazione", "noContentAvailable": "Nessun contenuto disponibile" };
const uploadDocument$5 = { "uploadHeader": "Aggiungi File", "uploadDescription": "Fai clic e carica fino a 10 documenti", "uploadWarning": "Questo sarà visibile al Portale Amministratore per Visualizza e Scarica", "uploadInstruction": "Fai clic per caricare oppure trascina e rilascia", "allowedFiles": "DOC, PNG, JPG , GIF , PPT O PDF (Massimo. 100MB)", "cancelButton": "Annulla", "uploadButton": "Carica", "confirmDeletion": "Eliminazione di salvataggio", "deleteFile": "Elimina File", "deleteFileDescription": "Sei sicuro che tu vuoi eliminare questo File? Questa Azione non può essere annullata.", "deleteFileButton": "Sì, Elimina il File", "deleteFileSuccessTitle": "File Eliminato", "deleteFileErrorTitle": "Errore in Eliminazione File", "deleteFileErrorMessage": "Si è verificato un errore durante il tentativo di eliminare il File.", "cancel": "Nullo", "notAbleToDownloadFile": "Impossibile scaricare il File", "fileSizeExceeded": "La dimensione File supera i 100 MB", "invalidFileType": "File Digita non valido", "notAbleToUploadFile": "Impossibile eseguire il File Carica", "downloadError": "Errore in scaricamento File", "fileUploadedSuccessfully": "File caricato con successo", "fileDownloadedSuccessfully": "Scarica File con successo" };
const navbar$5 = { "hi": "Salve", "manageYourAccount": "Gestisci il tuo account", "logOut": "Disconnettiti", "affiliates": "Affiliati", "courses": "Corsi", "communities": "Comunità" };
const mandatedInfoModal$5 = { "invalidFileFormat": "Formato/tipo di file non valido.", "pleaseUploadImage": "Carica un'immagine in formato SVG, PNG, JPG o JPEG", "fileSizeTooLarge": "La dimensione del file è troppo grande", "oopsUnableToUploadImage": "Ops! Impossibile caricare l'immagine.", "pleaseUploadFileLessThan100MB": "Carica un file di dimensioni inferiori a 100 MB", "pleaseTryAgainLater": "Riprova più tardi", "completeYourProfile": "Completa il tuo profilo", "profilesBuildConnection": "I profili generano fiducia e incentivano la connessione con gli altri", "putAFaceToYourProfile": "Dai un volto al tuo profilo!", "uploadASVGPNGJPG": "Carica un file SVG, PNG o JPG.", "recommendedAspectRatio11": "Rapporto d'aspetto consigliato: 1:1", "complete": "COMPLETATO", "cropYourAvatar": "Ritaglia il tuo avatar", "dragToReposition": "Trascina per riposizionare" };
const sideBar$5 = { "languageSettings": "Impostazioni della lingua", "profile": "Profilo", "account": "Account", "socialMedia": "Social media", "certificates": "Certificati", "billingSubscription": "Fatturazione e abbonamento", "communitiesChats": "Comunità e chat", "affiliates": "Affiliati", "notifications": "Promemoria" };
const notifications$5 = { "title": "Notifiche", "all": "Tutto", "unread": "Non letto", "markAllRead": "Contrassegna tutte come lette", "noNotifications": "Ancora nessuna notifica", "whenYouGetNotifications": "Quando ricevi le notifiche, verranno mostrate qui" };
const affiliates$5 = { "payoutMethod": "Metodo Pagamento", "leadCustomer": "Potenziali clienti/Clienti", "commissions": "Commissioni", "description": "Indirizza gli utenti a GoKollab", "title": "Affiliati", "groupsGoKollab": "La creazione di gruppi su GokolLab è completamente gratuita, ma questo è solo l'inizio! Sono in arrivo nuove ed entusiasmanti funzionalità che ti aiuteranno a far crescere la tua attività online e ad aumentare i tuoi guadagni. Quando gli utenti effettuano l'upgrade per sbloccare l'intera suite di funzionalità, ricevi una commissione di affiliazione ricorrente a vita per il loro abbonamento. Prima inizi a indirizzare gli utenti, meglio è: non lasciarti sfuggire questo incredibile programma di affiliazione", "yourAffiliateLink": "Il tuo link di affiliazione" };
const deleteCard$5 = { "deleteCard": "Elimina la carta", "description": "Il metodo di pagamento non sarà più utilizzabile dopo la rimozione. Questa azione non può essere annullata.", "activeCard": "Questa carta è utilizzata per uno o più pagamenti di abbonamenti attivi. L'eliminazione di questa carta senza aggiornare il metodo di pagamento per gli abbonamenti associati influenzerà i pagamenti futuri. Vuoi davvero eliminare questa carta?", "title": "Rimuovere il metodo di pagamento?", "cardCannotBeDeleted": "La carta non può essere eliminata", "cardIsLinkedToSubscriptions": "La carta è collegata agli abbonamenti", "errorInDeletingCard": "Errore durante l'eliminazione della carta", "noCardAvailable": "Nessuna carta disponibile", "cardRemovedSuccessfully": "Carta rimossa correttamente" };
const notificationPreferences$5 = { "title": "Impostazioni di notifica", "description": "Gestisci Quando e per cosa Tu ricevi una notifica", "pushNotificationsTitle": "Spingi Promemoria", "pushNotificationsDescription": "Gestisci spingi Promemoria", "emailNotificationsTitle": "Email Promemoria", "emailNotificationsDescription": "Gestisci Email Promemoria", "emailNotifications": "Email Promemoria", "manageEmailNotifications": "Gestisci Email Promemoria", "newActivity": "Nuove attività", "email": "Email", "push": "Spingi", "allNotifications": "ogni Promemoria", "postTags": "Condividi Parole chiave", "postEveryoneTagged": "Condividi {'@'}Tutti Parole chiave", "postMention": "Condividi {'@'}Menzione", "postLike": "Condividi Metti Mi piace", "newComment": "Nuovo commento", "commentEveryoneTagged": "Commenta {'@'}Tutti Parole chiave", "commentMention": "Commenta {'@'}Menzione", "commentLike": "Commenta Metti Mi piace", "postEveryoneTaggedMobile": "Condividi {'@'}Tutti Parole chiave", "postMentionMobile": "Condividi {'@'}Menzione", "commentEveryoneTaggedMobile": "Commenta {'@'}Tutti Parole chiave", "commentMentionMobile": "Commenta {'@'}Menzione", "newMemberRequestToJoinGroup": "Nuovo Membri Richieste a unisciti Gruppo", "groupJoiningRequestApproved": "Gruppo Entra a far parte di Richieste Accettato", "groupJoiningRequestRejected": "Il Gruppo si unisce a Richieste Negato", "roleUpdatedInPrivateChannel": "Ruolo aggiornato in Privato Canale", "newCourseAvailable": "Nuovo corso aggiunto al Gruppo", "newEventCreated": "Nuovo Evento Creato", "newCourseComment": "Commento al nuovo corso", "certificateIssued": "Certificato Emesso", "postEveryoneTaggedDescription": "Quando qualcuno pubblica {'@'}Tutti Parole chiave", "postMentionDescription": "Quando qualcuno pubblica {'@'}menzione", "postLikeDescription": "Quando qualcuno Mi piace la tua condivisione", "newCommentDescription": "Quando qualcuno feedback Attivo la tua Condividi", "commentEveryoneTaggedDescription": "Quando qualcuno feedback {'@'}Tutti Parole chiave", "commentMentionDescription": "Quando qualcuno commenta {'@'}un feedback", "commentLikeDescription": "Quando a qualcuno Mi piace il tuo commento", "newMemberRequestToJoinGroupDescription": "Quando qualcuno Richieste per unisciti il tuo Gruppo", "groupJoiningRequestApprovedDescription": "Quando il Gruppo di qualcuno che aderisce a Richieste è Accettato", "groupJoiningRequestRejectedDescription": "Quando qualcuno nel Gruppo che entra a far parte di Richieste è Negato", "roleUpdatedInPrivateChannelDescription": "Quando il ruolo di qualcuno è Aggiornato in un canale privato", "newCourseAvailableDescription": "Quando è disponibile un Nuovo corso", "newEventCreatedDescription": "Quando un nuovo evento è Creato", "newCourseCommentDescription": "Quando qualcuno feedback Attivo a course", "certificateIssuedDescription": "Quando un certificato è Emesso", "estimateReceivedDescription": "Quando un Nuovo Stima è Ricevuto", "contractReceivedDescription": "Quando un nuovo Accordo è Ricevuto", "invoiceReceivedDescription": "Quando una nuova Fattura è Ricevuto", "allEmailNotificationsDescription": "Gira Attivo/Disabilitato ogni Email Promemoria", "allPushNotificationsDescription": "Gira Attivo/Disabilitato ogni push Promemoria", "errorUpdating": "Si è verificato un errore durante l'aggiornamento delle impostazioni di notifica", "updateSuccess": "La tua notifica Impostazioni sono state aggiornate", "willNotReceiveNotificationsIfAdminDisabled": "Tu non Eredita Promemoria per Impostazioni Disabilitato tramite il tuo amministratore.", "estimateReceived": "Nuovo Stima Ricevuto", "contractReceived": "Nuovo Accordo Ricevuto", "invoiceReceived": "Nuova Fattura Ricevuto", "pushNotificationNotAvailable": "La notifica push non è disponibile per questo evento", "newsletter": "Newsletter", "emailNotificationNotAvailable": "La notifica Email non è disponibile per questo Evento.", "newPostFollowers": "Nuovo Condividi da Utente Segui", "newPostFollowersDescription": "Ricevi una notifica quando qualcuno che Segui crea un nuovo post.", "newFollower": "Ricevi una notifica quando qualcuno ti Segui." };
const loginPage$5 = { "forgotPassword": "Password dimenticata?", "login": "Accedi", "lastLogin": "ultimo Accedi", "proceedToLogin": "Procedi con Accedi", "secureCode": "Codice di sicurezza", "newUser": "Nuovo Utente?", "resetPasswordLink": "Se l' Email inserita è corretta, Tu eredita un Link Ripristina la password in . Per favore assicurati di Segno di spunta anche lo spam Cartella.", "loginWithSecureCode": "Accedi con codice sicuro", "signUp": "Iscriviti", "enterOtp": "Inserisci OTP", "selectAccount": "Seleziona quale Account vuoi", "resetPassword": "Ripristina la password", "selectUser": "Seleziona Utente", "emailRequired": "Si prega di inserire Email valida", "fullNameRequired": "Per favore, inserisci il tuo nome", "passwordRequired": "Per favore inserisci una password di Minimo 8 Carattere", "generateSecureCode": "Genera Codice di sicurezza", "loginWithPassword": "Accedi con password", "secureCodeEmail": "Per favore, Segno di spunta la tua Email per il codice sicuro. Se tu non ha inviato alcuna Email da noi,", "resendOtp": "tocca qui per Rinvia.", "verifySecureCode": "Verifica il Codice di sicurezza", "secureCodeNumeric": "Il Codice di sicurezza deve essere un Numerico Valore e deve essere di 6 cifre", "alreadyHaveAccount": "Hai già un Account?", "email": "Email", "password": "Password", "fullName": "Nome Pieno", "somethingWentWrong": "Qualcosa è andato storto", "signInWithEmail": "O, accedi con la tua Email", "signUpWithEmail": "Oppure iscriviti con la tua e-mail", "confirmPassword": "Conferma la password", "validationErrors": { "potentialSpamUser": { "title": "Account privato", "message": "Il tuo Account è stato Privato Dovuto per le potenziali attività spam. Si prega di contattare il supporto per assistenza." }, "somethingWentWrong": { "title": "Qualcosa è andato storto", "message": "Impossibile accedere. Riprova più tardi." }, "bannedUser": { "title": "Account privato", "message": "Il tuo Account è stato Vietato Dovuto alle potenziali attività spam. Si prega di contattare il supporto per assistenza." } } };
const magicLink$5 = { "newLinkSent": "Nuovo Link inviato", "portalWillSendLink": "Portale caricherà un nuovo Link al tuo indirizzo email", "failedToSendNewLink": "Non riuscito accedere al Link Carica Nuovo", "pleaseTryAgain": "Riprova", "linkExpired": "Questo Link dalla tua Email ha Scaduto.", "toContinue": "Per Continua, Richieste un nuovo Link O in al tuo AccountPortale", "sendNewLink": "Link Carica Nuovo", "logIn": "in", "clickToLogIn": "fai clic qui per in al tuo AccountPortale", "invalidToken": "Questo Token dalla tua Email non è valida.", "toContinueContactAdmin": "To Continua, Richieste a Nuovo Magic link Contatto Amministratore O in al tuo AccountPortale" };
const setPassword$5 = { "minLength": "Per favore inserisci una password di Minimo 8 Carattere", "passwordsMustMatch": "Le password devono corrispondere", "setSecurePassword": "Raccogli la tua passwordsicura", "setPasswordButton": "Collezione Password" };
const alerts$5 = { "tooManyAttempts": { "title": "Troppi tentativi", "message": "Non sono consentiti più di 2 tentativi di aggiornamento Slug in una Finestra di Mese" }, "slugAlreadyExists": { "title": "Slug esiste già", "message": "Prova uno Slug diverso" }, "updateSlugError": { "title": "Qualcosa è andato storto", "message": "Impossibile aggiornare Profilo Slug. Prova Dopo alcuni dati" }, "updateProfileError": { "title": "Qualcosa è andato storto", "message": "Impossibile aggiornare Profilo Dettagli. Prova Dopo alcuni dati" } };
const bottomNavBar$5 = { "home": "Home", "discover": "Scopri", "communities": "Comunità", "courses": "Corsi", "more": "Più" };
const forceUpdate$5 = { "title": "Nuovo L'AGGIORNAMENTO È DISPONIBILE", "description": "Aggiorna la tua applicazione all'ultima versione", "buttonText": "Aggiorna ora!" };
const accessibility$5 = { "copyAffiliateLink": "Copia Affiliato Link agli appunti", "deleteCard": "Elimina scheda", "appSwitcher": "Strumento di cambio App", "portalImage": "Immagine Portale", "profileImage": "Immagine Profilo", "continueWithGoogle": "Continua con Google" };
const resetPassword$5 = { "passwordExpired": "La tua password Ripristina Link ha Scaduto.", "regenerateLink": "Rigenera Link", "proceedToLogin": "Procedi con Accedi", "passwordChangedSuccessfully": "Password Dinamico con successo", "changePassword": "Modifica password", "newPassword": "Per favore inserisci una password di Minimo 8 Carattere", "confirmPassword": "La conferma della password non corrisponde", "setNewPassword": "Password Collezione Nuovo", "confirmNewPassword": "Conferma la nuova password" };
const it = {
  common: common$5,
  account: account$5,
  wallet: wallet$5,
  support: support$5,
  social: social$5,
  validation: validation$5,
  forms: forms$5,
  auth: auth$5,
  billing: billing$5,
  transactions: transactions$5,
  cancelModal: cancelModal$5,
  certificates: certificates$5,
  changePassword: changePassword$5,
  deleteAccount: deleteAccount$5,
  chats: chats$5,
  payments: payments$5,
  profileSettings: profileSettings$5,
  languageSettings: languageSettings$5,
  userActivityOverview: userActivityOverview$5,
  widget: widget$5,
  dashboard: dashboard$5,
  uploadDocument: uploadDocument$5,
  navbar: navbar$5,
  mandatedInfoModal: mandatedInfoModal$5,
  sideBar: sideBar$5,
  notifications: notifications$5,
  affiliates: affiliates$5,
  deleteCard: deleteCard$5,
  notificationPreferences: notificationPreferences$5,
  loginPage: loginPage$5,
  magicLink: magicLink$5,
  setPassword: setPassword$5,
  alerts: alerts$5,
  bottomNavBar: bottomNavBar$5,
  forceUpdate: forceUpdate$5,
  accessibility: accessibility$5,
  resetPassword: resetPassword$5
};
const common$4 = { "show": "Tonen", "newPost": "Nieuw bericht", "active": "Actief", "change": "Wijzigen", "remove": "Verwijderen", "cancel": "Annuleren", "publish": "Publiceren", "save": "Opslaan", "draft": "Concept", "scheduled": "Ingepland", "published": "Gepubliceerd", "actions": "Acties", "archive": "Archiveren", "delete": "Verwijderen", "edit": "Bewerken", "settings": "Instellingen", "updatedOn": "Bijgewerkt op", "blogPost": "Blogpost", "category": "Categorie", "author": "Auteur", "status": "Status", "errors": "Fouten", "error": "Fout", "all": "Alle", "add": "Toevoegen", "discussion": "Discussie", "allCourses": "Alle cursussen", "myCourses": "Mijn cursussen", "learning": "Leren", "leaderboard": "Leaderboard", "documentsAndPayments": "Documenten & Bestandsbeheer", "more": "Meer", "profile": "Profiel", "archived": " Gearchiveerd", "back": "Terug", "restore": "Herstel deze versie", "next": "Volgende", "previous": "Vorige", "continue": "Doorgaan", "details": "Details", "youtube": "Youtube", "action": "Actie", "view": "Bekijken", "download": "Downloaden", "source": "Bron", "title_column": "Titel", "copy": "Kopiëren", "viewReceipt": "Betalingsbewijs bekijken", "id": "ID", "location": "Locatie", "email": "E-mail", "title": "Titel", "logout": "Uitloggen", "login": "Login", "calender": "Kalender", "apply": "Aanmelden", "clear": "Wissen", "to": "Aan", "from": "Van", "type": "Type", "home": "Startpagina", "description": "Description", "updated": "Bijgewerkt", "networkError": { "title": "Geen internetverbinding", "message": "Controleer uw internetverbinding en probeer het opnieuw." } };
const account$4 = { "settings": "Accountinstellingen", "updateSettings": "Update hier uw accountinstellingen", "paymentDetails": "Betalingsgegevens", "orderId": "Intern bestellings-ID", "nextInvoice": "Volgende factuur", "transactionDate": "Transactiedatum", "expiryDate": "Vervaldatum", "manageAllSubscription": "Beheer al uw abonnementen", "paymentMethod": "Betaalmethode", "andTransactionHere": "& transactie hier" };
const wallet$4 = { "transactionId": "Transactie-ID" };
const support$4 = { "subscriptionId": "Abonnement-ID", "email": { "validation": "Voer een geldig e-mailadres in" }, "invoiceNo": "Factuurnummer" };
const social$4 = { "title": "Sociale media", "invalidURL": "Ongeldige url", "phoneNumber": "Telefoonnummer", "userPhone": "Telefoonnummer van gebruiker", "userEmail": "E-mailadres van gebruiker", "info": "Details van sociale media", "update": "Gegevens van sociale media bijwerken", "detailsHere": "Werk hier de gegevens van uw sociale media bij", "updated": "Sociale media bijgewerkt", "visibility": "Openbaar zichtbaar", "validUrl": "Voer een geldige URL in", "validEmail": "Voer een geldig e-mailadres in", "validPhoneNumber": "Voer een geldig telefoonnummer in met een geschikte landcode", "platforms": { "twitter": "X (voorheen Twitter)", "instagram": "Instagram", "facebook": "Facebook", "youtube": "Youtube", "linkedin": "LinkedIn" } };
const validation$4 = { "phone": "Voer een geldig telefoonnummer in", "url": "Voer een geldige URL in." };
const forms$4 = { "phone": "Telefoonnummer" };
const auth$4 = { "clickToResend": "Klik om opnieuw te verzenden", "authentication": "Authenticatie", "didntGetCode": "Geen code gekregen?", "confirmationCode": "Verificatiecode", "sentVerificationEmail": "We hebben per e-mail een verificatiecode gestuurd naar", "authenticateAccount": "Verifieer uw account", "incorrectOrExpired": "Otp is ongeldig of verlopen", "failedToSend": "Verzenden van otp mislukt", "checkEmailForSecureCode": "Controleer uw e-mail voor de beveiligingscode. Als u geen email van ons hebt ontvangen,", "user": "Gebruiker", "verify": "Verifiëren", "tapHereToResend": "tik dan hier om hem opnieuw te laten verzenden.", "failedToVerifyOtp": "OTP verifiëren mislukt", "failedToGetOtp": "OTP ophalen mislukt" };
const billing$4 = { "endingIn": "eindigend in", "billingInformation": "Factuurgegevens", "billingAddress": "Factuuradres:", "sourceType": "Brontype:", "invoices": "Facturen", "subscription": "Abonnement", "transactions": "Transacties", "transaction": "Transactie", "subscriptions": "Abonnementen", "invoiceName": "Factuurnaam", "subscriptionName": "Abonnementnaam", "dueDate": "Vervaldatum", "issueDate": "Uitgiftedatum", "amount": "Bedrag", "manageSubscriptions": "Beheer al uw abonnementen", "andSubscription": "& Abonnement", "andTransaction": "& transactie hier", "billing": "Facturering", "startDate": "Begindatum", "fullName": "Volledige naam", "nextInvoiceOn": "Volgende factuur op", "noDataFound": "Geen gegevens gevonden", "invoiceNo": "Factuurnummer:", "manageSubscriptionsInvoicesAndTransactions": "Beheer abonnementen, facturen en transacties", "created": "Gemaakt:", "transactionName": "Transactienaam", "tid": "Tijd :", "transactionDate": "Transactiedatum:", "trial": "Proefperiode", "expired": "Vervallen", "pastDue": "Achterstallig", "unpaid": "Onbetaald", "incompleteExpired": "Onvolledig vervallen", "canceled": "Opgezegd", "incomplete": "Onvolledig", "failed": "Mislukt", "sent": "Verzonden", "paid": "Betaald", "paymentProcessing": "Betalingsverwerking", "partiallyPaid": "Gedeeltelijk betaald", "overdue": "Achterstallig", "succeeded": "Voltooid", "processing": "Aan het verwerken", "refunded": "Terugbetaald", "pending": "Lopend", "membership": "Lidmaatschap", "communities": "Community's", "paymentLink": "Betaallink", "expiresOn": "Verloopt op", "errorFetchingPaymentMethods": "Fout bij het ophalen van betaalmethodes", "pageUrl": "Page URL" };
const transactions$4 = { "title": "Transacties", "name": "Transacties naam" };
const cancelModal$4 = { "subscriptionRenewNotice": "Als u van gedachten verandert, kunt u uw abonnement op elk moment verlengen.", "cancelSubscription": "Abonnement annuleren", "subscriptionCancelNotice": "wordt onmiddellijk opgezegd. Er worden geen kosten meer in rekening gebracht.", "yourPlanName": "Uw plan", "currentPlan": "Huidig Plan", "subscriptionCancelError": "Er is een fout opgetreden tijdens het opzeggen van het abonnement", "cancelSubscriptionFailed": "Abonnement opzeggen mislukt" };
const certificates$4 = { "title": "Certificaten", "certificatesDescription": "Download & Share certificaten die You hebt verdiend.", "subtitle": "Uw certificaten Download", "completedOn": "Done On", "back": "Terug", "previous": "Vorige", "next": "Volgende", "downloadYourCertificates": "Download uw certificaten", "downloadCertificate": "Downloaden {type}", "viewCertificates": "Bekijk en download hier al uw certificaten.", "certificateNotFound": "Geen Certificate found", "issuedOn": "Issued On", "expiresOn": "Expires", "description": "Beschrijving", "yourCertificateHasExpiredOn": "Uw {type} On Expired", "issuedCertificatesNotFound": "Je hebt nog geen certificaten verdiend.", "shareCertificate": "Delen:", "preview": { "issuedTo": "Uitgegeven aan", "issuedBy": "Uitgegeven door", "addToLinkedin": "Toevoegen aan LinkedIn-profiel", "download": "Downloaden", "credentialVerification": "Verificatie van referenties", "issueDate": "Factuurdatum", "expiryDate": "Vervaldatum", "verifyCredential": "Verifieer inloggegevens", "shareYourCredential": "Deel uw inloggegevens.", "showYourCredential": "Toon uw referenties op uw sociale media.", "expiredOn": "Verlopen op", "expiredDesc": "Het is tijd om te vernieuwen en up-to-date te blijven. Mis geen blijvende voordelen en Potentiële klanten.", "verificationModal": { "title": "Verificatie van referenties", "subtitle": "Dit is de geldige inloggegevens.", "description": " Deze referentie is veilig uitgegeven. Alle weergegeven Details zijn geldig.", "step1": { "title": "De ontvanger verifiëren", "description": "De Eigenaar van deze inloggegevens is {recipient}." }, "step2": { "title": "De uitgever verifiëren", "description": "Deze referentie is uitgegeven door  {issuer}." }, "step3": { "title": "De ID van de referentie controleren", "description": "De identificatie {credentialId} is uniek en geldig." } }, "notFound": { "title": "Oeps! Certificaat niet gevonden!", "description": "Het certificaat dat u probeert te bekijken, is niet beschikbaar.", "subtitle": "Neem contact op met de uitgevende instelling voor assistentie." } }, "share": { "title": "Uw Certificate", "text": "here is je Certificate", "dialogTitle": "Uw Certificate Share of Archive" }, "listing": { "courseAssignmentName": "Naam cursus/ Task", "offlineCertification": "Offline certificering", "completionDate": "End Date", "expiryDate": "Expiry Date", "type": "Type", "sourceName": "Naam bron", "action": "Actie" } };
const changePassword$4 = { "showPasswords": "Toon wachtwoorden", "retypePassword": "Typ wachtwoord opnieuw", "newPassword": "Nieuw wachtwoord", "confirmNewPassword": "Confirm New Password", "currentPassword": "Huidig wachtwoord", "emailId": "E-mail-id", "passwordMinLength": "Voer een wachtwoord in van minimaal 8 tekens", "editAccount": "Account bewerken", "loginEmail": "E-mail voor inloggen", "loginInformation": "Inloggegevens", "accountDetails": "Accountgegevens", "accountDetailsUpdate": "Werk hier uw accountgegevens bij", "accountInformation": "Accountgegevens", "changePassword": "Wachtwoord wijzigen", "hidePasswordChange": "Wachtwoord wijzigen verbergen", "selectPageError": "Probeer het later opnieuw", "systemErrorOccurred": "Er is iets misgegaan", "passwordEntryInvalid": "Ongeldig wachtwoord", "passwordUpdateSuccess": "Wachtwoord is bijgewerkt", "passwordLengthRequired": "Voer een wachtwoord in van minimaal 8 tekens", "passwordMinimumLength": "Voer een wachtwoord in van minimaal 8 tekens", "passwordFieldRequired": "Wachtwoord is vereist", "password": "Wachtwoord" };
const deleteAccount$4 = { "title": "Account verwijderen", "deleteAccountDescription": "Je Account is Scheduled voor tijdelijke deactivatie en wordt permanent Deleted. If You niet in binnen de Next 7 dagen.", "deleteAccountDescription2": "Om uw Account Dynamic Keep , logt u in voor de deadline. Eenmaal Deleted, kunnen uw gegevens niet worden hersteld.", "deleteAccountButton": "Ja, Account verwijderen" };
const chats$4 = { "viewAll": "Alles bekijken", "viewLess": "Minder bekijken", "updatedPreference": "Bijgewerkte voorkeur", "chatSettings": "Chatinstellingen", "chats": "Chats", "chatSettingsDescription": "Selecteer chatinstellingen voor uw groepen en contactpersonen", "groups": "Groepen", "blockedUsers": "Geblokkeerde gebruikers", "noGroups": "Geen groepen", "controlUsers": "Beheer met welke gebruikers u niet wilt chatten.", "blockedConversations": "Geblokkeerde communicatie", "noBlockedUsers": "Geen geblokkeerde gebruikers", "unblock": "Deblokkeren", "noUsersBlocked": "Er zijn geen gebruikers geblokkeerd", "noGroupsJoined": "U bent niet toegetreden tot groepen", "controlGroups": "Beheer welke groep gebruikers contact met u kan opnemen door uw chatbeschikbaarheid hieronder in of uit te schakelen. U kunt alleen berichten ontvangen van leden van de groep waarvan u deel uitmaakt. " };
const payments$4 = { "shareLink": "Link delen", "paymentLink": "Betaallink" };
const profileSettings$4 = { "complete": "VOLTOOIEN", "editBasicInformation": "Basisgegevens bewerken", "writeAboutYourself": "Schrijf iets over uzelf...", "selectTimezone": "Selecteer tijdzone", "description": "Dit wordt weergegeven op uw profiel", "timezone": "Tijdzone", "enterLocation": "Locatie invoeren", "exampleDescription": "Voorbeeld: Hallo, ik ben John Deo en ik ben fotograaf", "enterABriefDescription": "Voer een korte beschrijving in", "bio": "Biografie", "profileSlugNotAvailable": "Slug van het profiel niet beschikbaar", "findAndShareProfile": "Vind en deel uw profiel eenvoudig met een Aangepaste URL-slug.", "profileSlug": "Profielslug", "enterTitle": "Voer een titel in", "enterFullName": "Voer uw volledige naam in", "basicDetails": "Basisgegevens", "updateProfileDetails": "Werk hier uw profielgegevens bij", "basicInformation": "Basisgegevens", "updatedProfileSettings": "Profielinstellingen bijgewerkt", "uploadStatusCode": "Uploaden is mislukt met statuscode", "imageTypeNotSupported": "Afbeeldingstype wordt niet ondersteund", "nameIsRequired": "Naam is vereist", "invalidName": "Ongeldige naam", "profileImage0": "Profielafbeelding", "profileImage": "Profielafbeelding", "uploadSvgPngJpg": "Upload een SVG, PNG, JPG. Aanbevolen beeldverhouding 1:1", "profilesBuildConnection": "Profielen zorgen voor vertrouwen en verbinding met anderen", "clientPortalNames": "Het klantenportaal voelt ongezellig aan zonder gezichten en namen.", "completeYourProfile": "Uw profiel voltooien", "uploadFailed": "Uploaden is mislukt", "fileSizeTooLarge": "Het bestand is te groot.", "invalidFileFormatType": "Ongeldig bestandsformaat/-type.", "pleaseUploadImage": "Upload een afbeelding van het type SVG, PNG, JPG of JPEG.", "pleaseUploadAFileLessThan100Mb": "Upload een bestand kleiner dan 100 MB.", "oopsUnableToUploadImage": "Kan de afbeelding niet uploaden.", "selectPageError": "Probeer het later opnieuw", "search": "Zoeken", "searchTimezones": "Zoek tijdzones", "noTimezonesFound": "Er zijn geen tijdzones gevonden", "editDetails": "Details bewerken", "profilePicture": "Profielfoto", "profileCover": "Profielomslag", "uploadPhoto": "Foto uploaden", "removePhoto": "Foto verwijderen", "invalidAspectRatio": "Ongeldige beeldverhouding", "recommendedAspectRatio169": "Aanbevolen beeldverhouding 16:9", "recommendedAspectRatio11": "Aanbevolen beeldverhouding 1:1", "editProfile": "Profiel bewerken", "manageYourGroupDetailsHere": "Beheer hier uw groepsdetails", "profileIcon": "Profielpictogram", "specialCharactersNotSupported": "Speciale tekens worden niet ondersteund", "slugValidation": { "containSpecialCharacters": "Slug mag geen speciaal Character bevatten", "tooShort": "Slug moet minstens 3 Character lang zijn", "tooLong": "Slug moet minder dan 50 Character lang zijn", "containOnlyNumbers": "Slug kan niet alleen uit getallen bestaan", "startWithNumber": "Slug kan niet beginnen met een getal", "startWithHyphen": "Slug kan niet beginnen met een koppelteken", "endWithHyphen": "Slug kan niet End met een koppelteken", "containDoubleHyphen": "Slug mag geen dubbele koppeltekens bevatten", "containSpace": "Slug mag Room niet bevatten" } };
const languageSettings$4 = { "title": "Taalinstellingen", "detailsHere": "Selecteer de taal van het klantenportaal", "selectLanguage": "Selecteer Taal", "useLocationLanguage": "Gebruik Location Language", "languagePreferenceUpdated": "Taalvoorkeur is bijgewerkt", "errorUpdatingLanguage": "Fout bij het bijwerken van de taal", "description": "Selecteer uw voorkeurstaal voor het bekijken van items in het klantenportaal, community-inhoud, cursussen en partnerinformatie. Met deze instelling kunt u de content bekijken in de taal waarin u zich het meest comfortabel voelt. ", "shortDescription": "Selecteer uw voorkeurstaal" };
const userActivityOverview$4 = { "dustBunnies": "Hier is niets te zien.", "welcomeBanner": "Welkom bij", "contracts": "Contracten", "hiUser": "Hallo", "estimates": "Offertes", "sharedFiles": "Gedeelde Files" };
const widget$4 = { "viewAll": "Alles bekijken", "addedOn": "Toegevoegd op", "by": "Via", "you": "You", "admin": "Admin", "youDoNotHaveAny": "U hebt er geen.", "noContracts": "Geen contracten", "maxFilesExceeded": "You kunt maximaal 10 Files Upload", "uploadFile": "File Upload", "userActivityOverview.contracts": "Contracten", "selectPageError": "Probeer het later opnieuw", "notAbleToDownloadContract": "Kan het contract niet downloaden", "completeCourse": "Cursus voltooien", "courseProgress": "Cursusvoortgang", "viewAllGroups": "Alle groepen bekijken", "recentlyOpened": "Onlangs geopend", "noInvoices": "Geen facturen", "noEstimates": "Geen offertes", "notAbleToDownloadInvoice": "Kan de factuur niet downloaden", "contracts": "Contracten", "invoices": "Facturen", "youMarked": "U heeft gemarkeerd", "inCourse": "in cursus", "invoice": "Factuur", "makePayment": "Betalen", "downloadInvoice": "Factuur downloaden", "viewGroup": "Groep weergeven", "payment": "Betaling", "download": "Download", "signContract": "Symbols Deal", "sign": "Symbols", "estimates": "Offertes", "notAbleToDownloadEstimate": "Kan de offerte niet downloaden", "addFiles": "Add Files", "sharedFiles": "Gedeelde Files", "fileManagement": "Bestandsbeheer", "noFiles": "Files" };
const dashboard$4 = { "joinAGroup": "Toetreden tot een groep", "takeACourse": "Een cursus volgen", "checkAffiliateEarnings": "Partnerverdiensten controleren", "manageSubscriptions": "Abonnementen beheren", "contracts": "Contracten", "estimates": "Offertes", "sharedFiles": "Gedeelde Files", "paidOn": "Betaald op", "partiallyPaidOn": "Gedeeltelijk betaald op", "overdueSince": "Achterstallig sinds", "dueOn": "Verschuldigd op", "hello": "Hallo", "viewGroup": "Groep bekijken", "recentlyOpened": "Recent geopend", "noItemsYet": "U hebt er nog geen.", "affiliates": "Partners", "exploreHere": "Hier verkennen", "selectApp": "Selecteer uw app", "exploreCourses": "Verken beschikbare cursussen", "courses": "Cursussen", "engageCommunity": "Deelnemen aan community", "communities": "Community's", "noDataAvailable": "Geen data beschikbaar op dit minute", "noAppsAvailable": "Geen Apps beschikbaar", "noWidgetsAvailable": "Geen widgets om Display", "noContentAvailable": "Geen Content beschikbaar" };
const uploadDocument$4 = { "uploadHeader": "Add Files", "uploadDescription": "Selecteer en upload maximaal 10 documenten", "uploadWarning": "Dit is zichtbaar voor de Portal Admin om View en Download", "uploadInstruction": "Klik om te uploaden of sleep en zet neer", "allowedFiles": "DOC, PNG, JPG, GIF, PPT van PDF (Max. 100MB)", "cancelButton": "Annuleren", "uploadButton": "Uploaden", "confirmDeletion": "Saving Verwijdering", "deleteFile": "Bestand verwijderen", "deleteFileDescription": "Weet je zeker dat je dit File wilt verwijderen? Deze Action kan niet ongedaan worden gemaakt.", "deleteFileButton": "Yes, File verwijderen", "deleteFileSuccessTitle": "File Deleted Succesvol", "deleteFileErrorTitle": "Fout in het verwijderen van File", "deleteFileErrorMessage": "Er is een Fout opgetreden bij het verwijderen van het File.", "cancel": "Annuleren", "notAbleToDownloadFile": "File niet Download", "fileSizeExceeded": "Het Size is groter dan 100 MB", "invalidFileType": "Invalid File", "notAbleToUploadFile": "File niet Upload", "downloadError": "File in Download", "fileUploadedSuccessfully": "Bestand is geüpload", "fileDownloadedSuccessfully": "File Download succesvol" };
const navbar$4 = { "hi": "Hallo", "manageYourAccount": "Uw account beheren", "logOut": "Uitloggen", "affiliates": "Partners", "courses": "Cursussen", "communities": "Community's" };
const mandatedInfoModal$4 = { "invalidFileFormat": "Ongeldig bestandsformaat/-type.", "pleaseUploadImage": "Upload een afbeelding van het type SVG, PNG, JPG, JPEG", "fileSizeTooLarge": "Het bestand is te groot.", "oopsUnableToUploadImage": "Kan de afbeelding niet uploaden.", "pleaseUploadFileLessThan100MB": "Upload een bestand kleiner dan 100 MB", "pleaseTryAgainLater": "Probeer het later opnieuw", "completeYourProfile": "Uw profiel voltooien", "profilesBuildConnection": "Profielen zorgen voor vertrouwen en verbinding met anderen", "putAFaceToYourProfile": "Geef uw profiel een gezicht!", "uploadASVGPNGJPG": "Upload een SVG, PNG, JPG.", "recommendedAspectRatio11": "Aanbevolen beeldverhouding 1:1", "complete": "VOLTOOIEN", "cropYourAvatar": "Uw avatar bijsnijden", "dragToReposition": "Sleep om te verplaatsen" };
const sideBar$4 = { "languageSettings": "Taalinstellingen", "profile": "Profiel", "account": "Account", "socialMedia": "Sociale media", "certificates": "Certificaten", "billingSubscription": "Facturering en abonnement", "communitiesChats": "Gemeenschappen en Chats", "affiliates": "Partners", "notifications": "Reminder" };
const notifications$4 = { "title": "Meldingen", "all": "Alle", "unread": "Ongelezen", "markAllRead": "Alles als gelezen markeren", "noNotifications": "Nog geen meldingen", "whenYouGetNotifications": "Wanneer u meldingen ontvangt, worden ze hier weergegeven" };
const affiliates$4 = { "payoutMethod": "Method", "leadCustomer": "Potentiële klanten/ Customers", "commissions": "Provisies", "description": "Verwijs gebruikers naar GoKollab", "title": "Partners", "groupsGoKollab": "Het maken van groepen op GoKollab is volledig gratis, maar dat is nog maar het begin! Er zijn geweldige nieuwe functies op komst om u te helpen uw online bedrijf te laten groeien en uw inkomsten te verhogen. Wanneer gebruikers upgraden om de volledige reeks functies te ontgrendelen, ontvangt u een levenslange terugkerende partnercommissie op hun abonnement. Hoe eerder u begint met verwijzen, hoe beter – mis dit geweldige partnerprogramma niet.", "yourAffiliateLink": "Uw partnerlink" };
const deleteCard$4 = { "deleteCard": "Kaart verwijderen", "description": "Na verwijdering is de betaalmethode niet meer bruikbaar. Deze actie kan niet ongedaan worden gemaakt.", "activeCard": "Deze kaart wordt gebruikt voor de betaling van één of meerdere actieve abonnementen. De verwijdering van deze kaart zonder de betaalmethode voor de bijbehorende abonnementen bij te werken, is van invloed op toekomstige betalingen. Weet u zeker dat u deze kaart wilt verwijderen?", "title": "Betaalmethode verwijderen?", "cardCannotBeDeleted": "Kaart kan niet worden verwijderd", "cardIsLinkedToSubscriptions": "De kaart is gekoppeld aan abonnementen", "errorInDeletingCard": "Fout bij verwijderen kaart", "noCardAvailable": "Geen kaart beschikbaar", "cardRemovedSuccessfully": "Kaart verwijderd!" };
const notificationPreferences$4 = { "title": "Alert Settings", "description": "You notificaties voor When en waarvoor", "pushNotificationsTitle": "Push Reminder", "pushNotificationsDescription": "Manage push Reminder", "emailNotificationsTitle": "Reminder Email", "emailNotificationsDescription": "Manage Email Reminder", "emailNotifications": "Reminder Email", "manageEmailNotifications": "Manage Email Reminder", "newActivity": "new Activity", "email": "E-mail", "push": "Push", "allNotifications": "every Reminder", "postTags": "Share", "postEveryoneTagged": "Share {'@'}Everyone Keywords", "postMention": "{'@'}vermelding Share", "postLike": "Like Share", "newComment": "new Comment", "commentEveryoneTagged": "Commentaar {'@'}Everyone Keywords", "commentMention": "Commentaar {'@'}Vermelding", "commentLike": "Commentaar Vind ik leuk", "postEveryoneTaggedMobile": "Share {'@'}Everyone Keywords", "postMentionMobile": "{'@'}vermelding Share", "commentEveryoneTaggedMobile": "Commentaar {'@'}Everyone Keywords", "commentMentionMobile": "Commentaar {'@'}Vermelding", "newMemberRequestToJoinGroup": "new Members Requests to join Group", "groupJoiningRequestApproved": "Group Joining Requests Accepted", "groupJoiningRequestRejected": "Group Joining Requests Denied", "roleUpdatedInPrivateChannel": "Rol Updated in Private", "newCourseAvailable": "new Cursus toegevoegd aan de Group", "newEventCreated": "new By", "newCourseComment": "commentaar new", "certificateIssued": "Certificate Issued", "postEveryoneTaggedDescription": "When iemand {'@'}Everyone zoekwoorden . plaatst", "postMentionDescription": "Wanneer iemand {'@'}vermelding . plaatst", "postLikeDescription": "When iemand je Share Likes", "newCommentDescription": "When Share feedback On", "commentEveryoneTaggedDescription": "When iemand feedback {'@'}Everyone Keywords", "commentMentionDescription": "When iemand in de feedback {'@'}melding maakt", "commentLikeDescription": "When iemand je opmerking Likes", "newMemberRequestToJoinGroupDescription": "When iemand Requests om join aan uw Group", "groupJoiningRequestApprovedDescription": "When iemand's Group join Requests is Accepted", "groupJoiningRequestRejectedDescription": "When iemands Group join Requests is Denied", "roleUpdatedInPrivateChannelDescription": "When wordt iemands rol Updated in een Private kanaal", "newCourseAvailableDescription": "When een new cursus beschikbaar is", "newEventCreatedDescription": "When new is Created", "newCourseCommentDescription": "When iemand feedback On een cursus", "certificateIssuedDescription": "When a Certificate is Issued", "estimateReceivedDescription": "When a new Estimate is Received", "contractReceivedDescription": "When een new Deal wordt Received", "invoiceReceivedDescription": "When an new Invoice is Received", "allEmailNotificationsDescription": "Flip Email - Reminder On", "allPushNotificationsDescription": "Disabled On Flip", "errorUpdating": "There is een fout opgetreden bij het Settings van je Alert", "updateSuccess": "Settings Alert Updated", "willNotReceiveNotificationsIfAdminDisabled": "Inherit voor Disabled Settings Via je You .", "estimateReceived": "new Estimate Received", "contractReceived": "new Deal Received", "invoiceReceived": "new Invoice Received", "pushNotificationNotAvailable": "Er is geen Push Notification beschikbaar voor deze Event", "newsletter": "Nieuwsbrief", "emailNotificationNotAvailable": "Email is niet beschikbaar voor deze Gebeurtenis.", "newPostFollowers": "Nieuw bericht van gevolgde gebruiker", "newPostFollowersDescription": "Ontvang een melding wanneer iemand die u volgt een nieuw bericht deelt.", "newFollower": "Ontvang een melding wanneer iemand u volgt." };
const loginPage$4 = { "forgotPassword": "Wachtwoord vergeten?", "login": "Login", "lastLogin": "last Login", "proceedToLogin": "Continue", "secureCode": "Beveiligde Code", "newUser": "new Operator?", "resetPasswordLink": "If het ingevoerde Email correct is, zal You Inherit een password voor Reset in de Email. Zorg ervoor dat Check Mark ook op de Folder komt.", "loginWithSecureCode": "Login met beveiligde Code", "signUp": "Aanmelden", "enterOtp": "OTP invoeren", "selectAccount": "Select naar welke Account You wilt", "resetPassword": "Reset wachtwoord", "selectUser": "Operator Select", "emailRequired": "Voer een geldig Email in", "fullNameRequired": "Voer je naam in", "passwordRequired": "Voer een password in of Min 8 Character", "generateSecureCode": "Secure CodeGenerate", "loginWithPassword": "Login met wachtwoord", "secureCodeEmail": "Check Mark je Email aan voor de beveiligde Code. If You Inherit geen Email From us,", "resendOtp": "tik here om Resend.", "verifySecureCode": "Secure CodeVerify", "secureCodeNumeric": "De Code moet een Numeric Value zijn en bestaan of 6 cijfers", "alreadyHaveAccount": "Heeft u al een Account?", "email": "E-mail", "password": "Wachtwoord", "fullName": "Full naam", "somethingWentWrong": "Er is iets misgegaan", "signInWithEmail": "Of, Login met je Email", "signUpWithEmail": "Of aanmelden met je e-mail", "confirmPassword": "Bevestig wachtwoord", "validationErrors": { "potentialSpamUser": { "title": "Account Private", "message": "Uw Account is Private Owed voor potential Activity. Neem Contact op met support voor hulp." }, "somethingWentWrong": { "title": "Er is iets misgegaan", "message": "Kan niet Login. Try again ." }, "bannedUser": { "title": "Account Private", "message": "Uw Account is Owed aan potential spam Activity. Neem Contact op met support voor hulp." } } };
const magicLink$4 = { "newLinkSent": "new Link sent", "portalWillSendLink": "Portal Upload een new Link naar uw Email address", "failedToSendNewLink": "new Link Upload", "pleaseTryAgain": "Try again", "linkExpired": "Deze Link From uw Email is Expired.", "toContinue": "To Continue , een new Link Requests of Log in op uw Portal Account", "sendNewLink": "Een new Link Upload", "logIn": "in", "clickToLogIn": "click here om in te in op uw Portal Account", "invalidToken": "Deze Token From uw Email is niet geldig.", "toContinueContactAdmin": "To Continue, Requests a new Magic Link Contact Admin Of Log in op uw Portal Account" };
const setPassword$4 = { "minLength": "Voer een password in of Min 8 Character", "passwordsMustMatch": "Wachtwoorden moeten overeenkomen", "setSecurePassword": "Uw veilige passwordCollection", "setPasswordButton": "Wachtwoord Collection" };
const alerts$4 = { "tooManyAttempts": { "title": "Te veel pogingen", "message": "Er zijn niet meer dan 2 pogingen voor Slug -update toegestaan in een Window of Month" }, "slugAlreadyExists": { "title": "Slug bestaat al", "message": "Probeer een andere Slug" }, "updateSlugError": { "title": "Er is iets misgegaan", "message": "Kan Profile Slug niet bijwerken. Probeer After wat Date" }, "updateProfileError": { "title": "Er is iets misgegaan", "message": "Kan Profile Details bijwerken. Probeer After wat Date" } };
const bottomNavBar$4 = { "home": "Start", "discover": "Ontdekken", "communities": "Community's", "courses": "Cursussen", "more": "Meer" };
const forceUpdate$4 = { "title": "new UPDATE IS BESCHIKBAAR", "description": "Werk je applicatie bij naar de laatste Version", "buttonText": "Update now!" };
const accessibility$4 = { "copyAffiliateLink": "Affiliate Copy Link naar klembord", "deleteCard": "Kaart verwijderen", "appSwitcher": "App- Switcher", "portalImage": "Portal Image", "profileImage": "Profile Image", "continueWithGoogle": "Doorgaan met Google" };
const resetPassword$4 = { "passwordExpired": "Uw password Reset Link has Expired.", "regenerateLink": "Link opnieuw genereren", "proceedToLogin": "Continue", "passwordChangedSuccessfully": "Wachtwoord Dynamic succesvol", "changePassword": "Wachtwoord Change", "newPassword": "Voer een password in of Min 8 Character", "confirmPassword": "De password komt niet overeen", "setNewPassword": "new wachtwoord Collection", "confirmNewPassword": "Bevestig nieuw wachtwoord" };
const nl = {
  common: common$4,
  account: account$4,
  wallet: wallet$4,
  support: support$4,
  social: social$4,
  validation: validation$4,
  forms: forms$4,
  auth: auth$4,
  billing: billing$4,
  transactions: transactions$4,
  cancelModal: cancelModal$4,
  certificates: certificates$4,
  changePassword: changePassword$4,
  deleteAccount: deleteAccount$4,
  chats: chats$4,
  payments: payments$4,
  profileSettings: profileSettings$4,
  languageSettings: languageSettings$4,
  userActivityOverview: userActivityOverview$4,
  widget: widget$4,
  dashboard: dashboard$4,
  uploadDocument: uploadDocument$4,
  navbar: navbar$4,
  mandatedInfoModal: mandatedInfoModal$4,
  sideBar: sideBar$4,
  notifications: notifications$4,
  affiliates: affiliates$4,
  deleteCard: deleteCard$4,
  notificationPreferences: notificationPreferences$4,
  loginPage: loginPage$4,
  magicLink: magicLink$4,
  setPassword: setPassword$4,
  alerts: alerts$4,
  bottomNavBar: bottomNavBar$4,
  forceUpdate: forceUpdate$4,
  accessibility: accessibility$4,
  resetPassword: resetPassword$4
};
const common$3 = { "show": "Vis", "newPost": "Nytt innlegg", "active": "Aktiv", "change": "Endre", "remove": "Fjern", "cancel": "Kanseller", "publish": "Publiser", "save": "Lagre", "draft": "Utkast", "scheduled": "Planlagt", "published": "Publisert", "actions": "Handlinger", "archive": "Arkiver", "delete": "Slett", "edit": "Rediger", "settings": "Innstillinger", "updatedOn": "Oppdatert den", "blogPost": "Blogginnlegg", "category": "Kategori", "author": "Forfatter", "status": "Status", "errors": "Feil", "error": "Feil", "all": "Alle", "add": "Legg til", "discussion": "Diskusjon", "allCourses": "Alle kurs", "myCourses": "Mine kurs", "learning": "Læring", "leaderboard": "Ledertavle", "documentsAndPayments": "Filer og dokument håndtering", "more": "Flere", "profile": "Profil", "archived": " Arkivert", "back": "Tilbake", "restore": "Tilbakestill denne versjonen", "next": "Neste", "previous": "Forrige", "continue": "Fortsett", "details": "Detaljer", "youtube": "Youtube", "action": "Handling", "view": "Vis", "download": "Last ned", "source": "Kilde", "title_column": "Tittel", "copy": "Kopier", "viewReceipt": "Se kvittering", "id": "ID", "location": "Sted", "email": "E-post", "title": "Tittel", "logout": "Logg ut", "login": "Login", "calender": "Kalender", "apply": "Bruk", "clear": "Fjern", "to": "Til", "from": "Fra", "type": "Type", "home": "Hjem", "description": "Description", "updated": "Oppdatert", "networkError": { "title": "Ingen internettforbindelse", "message": "Sjekk internettforbindelsen din og prøv igjen." } };
const account$3 = { "settings": "Kontoinnstillinger", "updateSettings": "Oppdater kontoinnstillingene dine her", "paymentDetails": "Betalingsdetaljer", "orderId": "Intern ordre-ID", "nextInvoice": "Neste faktura", "transactionDate": "Transaksjonsdato", "expiryDate": "Utløpsdato", "manageAllSubscription": "Administrer alle abonnementer", "paymentMethod": "Betalingsmåte", "andTransactionHere": "og transaksjoner her" };
const wallet$3 = { "transactionId": "Transaksjons-ID" };
const support$3 = { "subscriptionId": "Abonnements-ID", "email": { "validation": "Skriv inn en gyldig e-postadresse" }, "invoiceNo": "Fakturanummer" };
const social$3 = { "title": "Sosiale medier", "invalidURL": "Ugyldig URL", "phoneNumber": "Telefonnummer", "userPhone": "Brukertelefon", "userEmail": "Brukerens e-post", "info": "Sosiale opplysninger", "update": "Oppdater opplysninger om sosiale medier", "detailsHere": "Oppdater opplysninger om sosiale medieder her", "updated": "Sosiale medier er oppdatert", "visibility": "Offentlig synlig", "validUrl": "Skriv inn en gyldig URL", "validEmail": "Skriv inn en gyldig e-postadresse", "validPhoneNumber": "Skriv inn et gyldig telefonnummer med en korrekt landskode", "platforms": { "twitter": "Twitter", "instagram": "Instagram", "facebook": "Facebook", "youtube": "Youtube", "linkedin": "LinkedIn" } };
const validation$3 = { "phone": "Skriv inn gyldig telefon", "url": "Skriv inn en gyldig URL" };
const forms$3 = { "phone": "Telefonnummer" };
const auth$3 = { "clickToResend": "Klikk for å sende på nytt", "authentication": "Autentisering", "didntGetCode": "Fikk du ikke en kode?", "confirmationCode": "Bekreftelseskode", "sentVerificationEmail": "Vi har sendt en bekreftelseskode via e-post til", "authenticateAccount": "Autentiser konto", "incorrectOrExpired": "Otp er ugyldig eller utløpt", "failedToSend": "Kunne ikke sende OTP", "checkEmailForSecureCode": "Sjekk e-posten din for den sikre koden. Hvis du ikke har mottatt noen e-post fra oss,", "user": "Bruker", "verify": "Verifiser", "tapHereToResend": "Trykk her for å sende på nytt.", "failedToVerifyOtp": "Kunne ikke verifisere OTP", "failedToGetOtp": "Kunne ikke motta OTP" };
const billing$3 = { "endingIn": "som avsluttes om", "billingInformation": "Fakturadetaljer", "billingAddress": "Fakturaadresse:", "sourceType": "Kildetype:", "invoices": "Fakturaer", "subscription": "Abonnement", "transactions": "Transaksjoner", "transaction": "Transaksjon", "subscriptions": "Abonnementer", "invoiceName": "Fakturanavn", "subscriptionName": "Abonnementnavn", "dueDate": "Forfallsdato", "issueDate": "Utstedelsesdato", "amount": "Beløp", "manageSubscriptions": "Administrer alle abonnementer", "andSubscription": "og abonnement", "andTransaction": "og transaksjoner her", "billing": "Fakturering", "startDate": "Startdato", "fullName": "Fullt navn", "nextInvoiceOn": "Neste fakturadato", "noDataFound": "Finner ingen info", "invoiceNo": "Fakturanr. :", "manageSubscriptionsInvoicesAndTransactions": "Administrer abonnementer, fakturaer og salg", "created": "Opprettet:", "transactionName": "Transaksjonsnavn", "tid": "Tid:", "transactionDate": "Transaksjonsdato:", "trial": "Prøveperiode", "expired": "Utløpt", "pastDue": "Forfalt", "unpaid": "Ubetalt", "incompleteExpired": "Ufullstendig, utløpt", "canceled": "Avlyst", "incomplete": "Ufullstendig", "failed": "Mislyktes", "sent": "Sendt", "paid": "Betalt", "paymentProcessing": "Betaling under behandling", "partiallyPaid": "Delvis betalt", "overdue": "Forfalt", "succeeded": "Vellykket", "processing": "Under behandling", "refunded": "Refundert", "pending": "Avventer", "membership": "Medlemskap", "communities": "Samfunn", "paymentLink": "Betalingslenke", "expiresOn": "Utløper den", "errorFetchingPaymentMethods": "Feil ved henting av betalingsmåter", "pageUrl": "Side URL" };
const transactions$3 = { "title": "Transaksjoner", "name": "Transaksjonsnavn" };
const cancelModal$3 = { "subscriptionRenewNotice": "Hvis du ombestemmer deg, kan du fornye abonnementet ditt når som helst.", "cancelSubscription": "Kanseller abonnement", "subscriptionCancelNotice": "vil bli kansellert umiddelbart. Du vil ikke bli belastet igjen.", "yourPlanName": "Planen din", "currentPlan": "Nåværende plan", "subscriptionCancelError": "Det oppstod en feil under kansellering av abonnementet.", "cancelSubscriptionFailed": "Kansellering av abonnement mislyktes" };
const certificates$3 = { "title": "Sertifikater", "certificatesDescription": "Last ned og slett sertifikater du har opptjent.", "subtitle": "Laste ned sertifikatene dine", "completedOn": "Ferdig På", "back": "Tilbake", "previous": "Forrige", "next": "Neste", "downloadYourCertificates": "Last ned sertifikatene dine.", "downloadCertificate": "Laste ned {type}", "viewCertificates": "Se og last ned alle sertifikatene dine her.", "certificateNotFound": "Ingen sertifikat funnet", "issuedOn": "Utstedt På", "expiresOn": "Utløper På", "description": "Beskrivelse", "yourCertificateHasExpiredOn": "Din {type} har Utløpt På", "issuedCertificatesNotFound": "Du har ikke fått noen sertifikater ennå.", "shareCertificate": "Dele:", "preview": { "issuedTo": "Utstedt til", "issuedBy": "Utstedt av", "addToLinkedin": "Legg til i LinkedIn-profilen", "download": "Last ned", "credentialVerification": "Verifisering av legitimasjon", "issueDate": "Utstedelsesdato", "expiryDate": "Utløpsdato", "verifyCredential": "Verifisere legitimasjon", "shareYourCredential": "Del Deres påloggingsinformasjon", "showYourCredential": "Vis legitimasjonen din på dine sosiale medier.", "expiredOn": "Utløpt den", "expiredDesc": "Det er på tide å fornye og holde seg oppdatert. Ikke gå glipp av fortsatte fordeler og potensielle kunder.", "verificationModal": { "title": "Verifisering av legitimasjon", "subtitle": "Dette er den gyldige legitimasjonen.", "description": " Denne legitimasjonen ble sikkert utstedt. Alle detaljer som vises er gyldig.", "step1": { "title": "Verifisering av mottaker", "description": "Eieren av denne legitimasjonen er {recipient}" }, "step2": { "title": "Verifisering av utstederen", "description": "Dette sertifikatet ble utstedt av  {issuer}" }, "step3": { "title": "Verifisering av legitimasjonens ID", "description": "Identifikatoren {credentialId} er unik og gyldig." } }, "notFound": { "title": "Oops! Sertifikatet ble ikke funnet", "description": "Sertifikatet du prøver å se er ikke tilgjengelig.", "subtitle": "Kontakt utstederen for assistanse." } }, "share": { "title": "Ditt Sertifikat", "text": "henne er sertifikatet ditt", "dialogTitle": "Slett eller arkivere sertifikatet ditt" }, "listing": { "courseAssignmentName": "Navn på kurs/Oppgave", "offlineCertification": "Offline sertifisering", "completionDate": "Sluttdato", "expiryDate": "Utløp Dato", "type": "Type", "sourceName": "Kildenavn", "action": "Handling" } };
const changePassword$3 = { "showPasswords": "Vis passordene", "retypePassword": "Skriv inn passordet på nytt", "newPassword": "Nytt passord", "confirmNewPassword": "Confirm New Password", "currentPassword": "Nåværende passord", "emailId": "E-post-ID", "passwordMinLength": "Skriv inn et password med min. åtte tegn", "editAccount": "Rediger konto.", "loginEmail": "Logg inn med e-post", "loginInformation": "Påloggingsopplysninger", "accountDetails": "Kontodetaljer", "accountDetailsUpdate": "Oppdater kontodetaljene dine her", "accountInformation": "Kontoinformasjon", "changePassword": "Endre passord", "hidePasswordChange": "Skjul endre passord", "selectPageError": "Prøv igjen senere", "systemErrorOccurred": "Noe gikk galt", "passwordEntryInvalid": "Ugyldig passord", "passwordUpdateSuccess": "Passord ble oppdatert", "passwordLengthRequired": "Skriv inn et password med min. åtte tegn", "passwordMinimumLength": "Skriv inn et password med min. åtte tegn", "passwordFieldRequired": "Passord er obligatorisk", "password": "Passord" };
const deleteAccount$3 = { "title": "Slett Konto", "deleteAccountDescription": "Din Konto er planlagt for midlertidig deaktivering og vil bli permanent Slettet Hvis Du ikke logger in innen de neste 7 dagene.", "deleteAccountDescription2": "For å se din Konto Dynamisk, logger du bare in før fristen. Når Slettet først har gått, kan ikke dataene dine gjenopprettes.", "deleteAccountButton": "Ja, slett Konto" };
const chats$3 = { "viewAll": "Vis alt", "viewLess": "Vis mindre", "updatedPreference": "Preferansene er oppdatert", "chatSettings": "Chatinnstillinger", "chats": "Chatter", "chatSettingsDescription": "Velg chatinnstillinger for gruppene og kontaktene dine.", "groups": "Grupper", "blockedUsers": "Blokkerte brukere", "noGroups": "Ingen grupper", "controlUsers": "Administrer hvilke brukere du ikke ønsker å chatte med.", "blockedConversations": "Blokkerte samtaler", "noBlockedUsers": "Ingen blokkerte brukere", "unblock": "Fjern blokkeringen", "noUsersBlocked": "Ingen brukere er blokkert", "noGroupsJoined": "Ingen grupper ble med.", "controlGroups": "Administrer hvilke gruppebrukere som kan kontakte deg ved å slå chat på eller av nedenfor. Du kan kun motta meldinger fra medlemmer av gruppen du er en del av. " };
const payments$3 = { "shareLink": "Del lenke", "paymentLink": "Betalingslenke" };
const profileSettings$3 = { "complete": "FULLFØRT", "editBasicInformation": "Rediger grunnleggende informasjon", "writeAboutYourself": "Skriv noe om deg selv ...", "selectTimezone": "Velg tidssone", "description": "Dette vil bli vist på profilen din", "timezone": "Tidssone", "enterLocation": "Oppgi sted", "exampleDescription": "Eksempel: Hei, jeg er John Deo og jeg er fotograf", "enterABriefDescription": "Skriv inn en kort beskrivelse", "bio": "Biografi", "profileSlugNotAvailable": "Profil-slug kan ikke benyttes", "findAndShareProfile": "Oppdag og del profilen din med en tilpasset URL-slug.", "profileSlug": "Profil-slug", "enterTitle": "Skriv inn en tittel", "enterFullName": "Skriv inn fullt navn", "basicDetails": "Grunnleggende detaljer", "updateProfileDetails": "Oppdater profildetaljene dine her", "basicInformation": "Grunnleggende informasjon", "updatedProfileSettings": "Oppdaterte profilinnstillinger", "uploadStatusCode": "Opplasting mislyktes, med statuskode.", "imageTypeNotSupported": "Bildetypen støttes ikke", "nameIsRequired": "Navn er påkrevd", "invalidName": "Ugyldig navn", "profileImage0": "Profilbilde", "profileImage": "Profilbilde", "uploadSvgPngJpg": "Last opp en SVG, PNG eller JPG. Anbefalt størrelsesforhold 1:1", "profilesBuildConnection": "Profiler bygger tillit og skaper forbindelser med andre", "clientPortalNames": "Kundeportalen føles rar uten ansikter og navn.", "completeYourProfile": "Fullfør profilen din", "uploadFailed": "Opplasting mislyktes", "fileSizeTooLarge": "Filstørrelsen er for stor.", "invalidFileFormatType": "Ugyldig filformat/-type.", "pleaseUploadImage": "Last opp et bilde av typen SVG, PNG, JPG eller JPEG.", "pleaseUploadAFileLessThan100Mb": "Last opp en fil som er mindre enn 100 MB.", "oopsUnableToUploadImage": "Oops! Kunne ikke laste opp bildet.", "selectPageError": "Prøv igjen senere", "search": "Søk", "searchTimezones": "Søk etter tidssoner", "noTimezonesFound": "Ingen tidssoner funnet", "editDetails": "Rediger detaljer", "profilePicture": "Portrettbilde", "profileCover": "Profilforside", "uploadPhoto": "Last opp foto", "removePhoto": "Fjern foto", "invalidAspectRatio": "Ugyldig størrelsesforhold", "recommendedAspectRatio169": "Anbefalt størrelsesforhold 16:9", "recommendedAspectRatio11": "Anbefalt størrelsesforhold 1:1", "editProfile": "Rediger profil", "manageYourGroupDetailsHere": "Administrer gruppedetaljene dine her", "profileIcon": "Profil-ikon", "specialCharactersNotSupported": "Spesialtegn støttes ikke", "slugValidation": { "containSpecialCharacters": "Slug kan ikke inneholde spesiell Tegn", "tooShort": "Slug må være minst 3 Tegn", "tooLong": "Slug må være mindre enn 50 Tegn", "containOnlyNumbers": "Slug kan ikke bare inneholde tall", "startWithNumber": "Slug kan ikke starte med et tall", "startWithHyphen": "Slug kan ikke starte med bindestrek", "endWithHyphen": "Slug kan ikke slutte med bindestrek", "containDoubleHyphen": "Slug kan ikke inneholde doble bindestreker", "containSpace": "Slug kan ikke inneholde rom" } };
const languageSettings$3 = { "title": "Språkinnstillinger", "detailsHere": "Velg språk for kundeportalen", "selectLanguage": "Velg språk", "useLocationLanguage": "Språk Sted", "languagePreferenceUpdated": "Språkpreferanse er oppdatert", "errorUpdatingLanguage": "Feil ved oppdatering av språk", "description": "Velg ditt foretrukne språk for å se elementer i kundeportalen, fellesskapsinnhold, kurs og tilknyttet informasjon. Denne innstillingen lar deg se innhold på det språket du er mest vant med. ", "shortDescription": "Velg ditt foretrukne språk" };
const userActivityOverview$3 = { "dustBunnies": "Ingenting å se, med mindre du er interessert i hybelkaniner.", "welcomeBanner": "Velkommen til", "contracts": "Kontrakter", "hiUser": "Hei", "estimates": "Estimater", "sharedFiles": "Delte Filer" };
const widget$3 = { "viewAll": "Vis alt", "addedOn": "Lagt til den", "by": "Via", "you": "Du", "admin": "Admin", "youDoNotHaveAny": "Du har ingen!", "noContracts": "Ingen kontrakter", "maxFilesExceeded": "Du kan bare vare opp til 10 filer", "uploadFile": "Fil Laste opp fil", "userActivityOverview.contracts": "Kontrakter", "selectPageError": "Prøv igjen senere", "notAbleToDownloadContract": "Kan ikke laste ned kontrakten", "completeCourse": "Fullstendig kurs", "courseProgress": "Kursfremgang", "viewAllGroups": "Se alle Grupper", "recentlyOpened": "Nylig åpnet", "noInvoices": "Ingen fakturaer", "noEstimates": "Ingen estimater", "notAbleToDownloadInvoice": "Kan ikke laste ned faktura", "contracts": "Kontrakter", "invoices": "Fakturaer", "youMarked": "Du merket", "inCourse": "under kurs", "invoice": "Faktura", "makePayment": "Lag betaling", "downloadInvoice": "Last ned faktura", "viewGroup": "Vis gruppe", "payment": "Betaling", "download": "Last ned", "signContract": "Symboler Avtale", "sign": "Symboler", "estimates": "Estimater", "notAbleToDownloadEstimate": "Kan ikke laste ned estimatet", "addFiles": "Legge til Filer", "sharedFiles": "Delte Filer", "fileManagement": "Fil", "noFiles": "Ingen Filer" };
const dashboard$3 = { "joinAGroup": "Bli med i en gruppe", "takeACourse": "Ta et kurs", "checkAffiliateEarnings": "Sjekk partnerinntekter", "manageSubscriptions": "Administrer abonnementer", "contracts": "Kontrakter", "estimates": "Estimater", "sharedFiles": "Delte Filer", "paidOn": "Betalt den", "partiallyPaidOn": "Delvis betalt den", "overdueSince": "Forfalt siden", "dueOn": "Forfaller den", "hello": "Hei", "viewGroup": "Vis gruppe", "recentlyOpened": "Nylig åpnet", "noItemsYet": "Du har ingen ennå!", "affiliates": "Partnere", "exploreHere": "Utforsk her", "selectApp": "Velg appen", "exploreCourses": "Utforsk mulige kurs", "courses": "Kurs", "engageCommunity": "Engasjer deg i samfunnet", "communities": "Samfunn", "noDataAvailable": "Ingen data tilgjengelig på minuttet", "noAppsAvailable": "Ingen Apper tilgjengelig", "noWidgetsAvailable": "Ingen widgets til Visning", "noContentAvailable": "Ingen Innhold tilgjengelig" };
const uploadDocument$3 = { "uploadHeader": "Legge til Filer", "uploadDescription": "Velg og last opp opptil 10 dokumenter", "uploadWarning": "Dette vil være synlig for Portal Admin for å se og laste ned", "uploadInstruction": "Klikk for å laste opp eller dra og slipp", "allowedFiles": "DOC, PNG, JPG , GIF , PPT eller PDF (Maks. 100 MB)", "cancelButton": "Avbryt", "uploadButton": "Laste opp", "confirmDeletion": "Lagre-sletting", "deleteFile": "Slett Fil", "deleteFileDescription": "Er du sikker på at du vil slette denne filen? Denne håndteringen kan ikke angres.", "deleteFileButton": "Ja, slett Fil", "deleteFileSuccessTitle": "Fil Slettet", "deleteFileErrorTitle": "Feil in å slette fil", "deleteFileErrorMessage": "Det oppsto en feil under forsøk på å slette filen.", "cancel": "Annuller", "notAbleToDownloadFile": "Kan ikke laste ned fil", "fileSizeExceeded": "Fil Størrelse overstiger 100 MB", "invalidFileType": "Ugyldig Type", "notAbleToUploadFile": "Ikke i stand til å Laste opp Fil", "downloadError": "Feil in Laste ned fil", "fileUploadedSuccessfully": "Fil ble lastet opp", "fileDownloadedSuccessfully": "Filen ble lastet ned" };
const navbar$3 = { "hi": "Hei", "manageYourAccount": "Administrer kontoen din", "logOut": "Logg ut", "affiliates": "Partnere", "courses": "Kurs", "communities": "Samfunn" };
const mandatedInfoModal$3 = { "invalidFileFormat": "Ugyldig filformat/-type.", "pleaseUploadImage": "Last opp et bilde av typen SVG, PNG, JPG, JPEG.", "fileSizeTooLarge": "Filstørrelsen er for stor.", "oopsUnableToUploadImage": "Oops! Kunne ikke laste opp bildet.", "pleaseUploadFileLessThan100MB": "Last opp en fil som er mindre enn 100 MB", "pleaseTryAgainLater": "Prøv igjen senere", "completeYourProfile": "Fullfør profilen din", "profilesBuildConnection": "Profiler bygger tillit og skaper forbindelser med andre", "putAFaceToYourProfile": "Sett et ansikt på profilen din!", "uploadASVGPNGJPG": "Last opp en SVG, PNG eller JPG.", "recommendedAspectRatio11": "Anbefalt størrelsesforhold 1:1", "complete": "FULLFØRT", "cropYourAvatar": "Beskjær avataren din", "dragToReposition": "Dra for å flytte" };
const sideBar$3 = { "languageSettings": "Språkinnstillinger", "profile": "Profil", "account": "Konto", "socialMedia": "Sosiale medier", "certificates": "Sertifikater", "billingSubscription": "Fakturering og abonnement", "communitiesChats": "Fellesskap og chatter", "affiliates": "Partnere", "notifications": "Påminnelse" };
const notifications$3 = { "title": "Notifikasjoner", "all": "Alle", "unread": "Ulest", "markAllRead": "Merk alle som lest", "noNotifications": "Ingen varsler ennå", "whenYouGetNotifications": "Når du får varsler, vil de vises her" };
const affiliates$3 = { "payoutMethod": "Metode", "leadCustomer": "Potensielle kunder/Kunder", "commissions": "Provisjoner", "description": "Henvis brukere til GoKollab", "title": "Partnere", "groupsGoKollab": "Å opprette grupper på GoKollab er helt gratis, men det er bare begynnelsen! Spennende nye egenskaper er på vei for å hjelpe deg med å utvide internettvirksomheten din og øke inntektene. Når brukerne oppgraderer for å låse opp hele funksjonspakken, vil du motta en partnerprovisjon som er vedvarende og gjentakende basert på brukerens abonnement. Jo før du begynner å henvise, desto bedre – ikke gå glipp av dette utrolige partnerprogrammet", "yourAffiliateLink": "Din partnerlenke" };
const deleteCard$3 = { "deleteCard": "Slett kort", "description": "Betalingsmetoden vil ikke lenger kunne brukes etter at den er fjernet. Denne handlingen kan ikke angres.", "activeCard": "Dette kortet brukes til ett eller flere aktive abonnementsbetalinger. Å slette dette kortet uten å oppdatere betalingsmetoden for de tilknyttede abonnementene vil påvirke fremtidige betalinger. Er du sikker på at du vil slette dette kortet?", "title": "Fjerne betalingsmetode?", "cardCannotBeDeleted": "Kortet kan ikke slettes", "cardIsLinkedToSubscriptions": "Kortet er knyttet til abonnementer", "errorInDeletingCard": "Feil ved sletting av kort", "noCardAvailable": "Ingen kort er tilgjengelig", "cardRemovedSuccessfully": "Kortet ble slettet" };
const notificationPreferences$3 = { "title": "Notifikasjon Innstillinger", "description": "Administrere Når og hva du blir varslet for", "pushNotificationsTitle": "Push Påminnelse", "pushNotificationsDescription": "Administrere push Påminnelse", "emailNotificationsTitle": "E-post Påminnelse", "emailNotificationsDescription": "Administrere E-post Påminnelse", "emailNotifications": "E-post Påminnelse", "manageEmailNotifications": "Administrere E-post Påminnelse", "newActivity": "ny Aktivitet", "email": "E-post", "push": "Skyv", "allNotifications": "hver eneste Påminnelse", "postTags": "Dele Nåkkelord", "postEveryoneTagged": "Dele {'@'}Alle Nøkkelord", "postMention": "Slett {'@'}omtale", "postLike": "Slett Like", "newComment": "ny Kommentar", "commentEveryoneTagged": "Kommenter {'@'}Alle Nøkkelord", "commentMention": "Kommentar {'@'}omtale", "commentLike": "Kommenter Like", "postEveryoneTaggedMobile": "Dele {'@'}Alle Nøkkelord", "postMentionMobile": "Slett {'@'}omtale", "commentEveryoneTaggedMobile": "Kommenter {'@'}Alle Nøkkelord", "commentMentionMobile": "Kommentar {'@'}omtale", "newMemberRequestToJoinGroup": "ny Medlemmer Forespørsler to bli med Gruppe", "groupJoiningRequestApproved": "Gruppe Joining Forespørsler Godkjent", "groupJoiningRequestRejected": "Gruppe Blir med i Forespørsler Nektet", "roleUpdatedInPrivateChannel": "Rolle Oppdatert in Privat kanal", "newCourseAvailable": "ny kurs lagt til i gruppen", "newEventCreated": "ny Hendelse Opprettet", "newCourseComment": "ny Kurskommentar", "certificateIssued": "Sertifikat Utstedt", "postEveryoneTaggedDescription": "Når noen legger ut {'@'}Alle Nøkkelord", "postMentionDescription": "Når noen legger ut {'@'}omtale", "postLikeDescription": "Når noen liker Dele", "newCommentDescription": "Når noen tilbakemelding På din Dele", "commentEveryoneTaggedDescription": "Når noen tilbakemelding {'@'}Alle Nøkkelord", "commentMentionDescription": "Når noen tilbakemelding {'@'}nevner", "commentLikeDescription": "Når noen liker kommentaren din", "newMemberRequestToJoinGroupDescription": "Når noen Forespørsler skal bli med din Gruppe", "groupJoiningRequestApprovedDescription": "Når noens Gruppe blir med i Forespørsler er Godkjent", "groupJoiningRequestRejectedDescription": "Når noens Gruppe blir med i Forespørsler er Nektet", "roleUpdatedInPrivateChannelDescription": "Når noens rolle er Oppdatert in en privat kanal", "newCourseAvailableDescription": "Når et ny kurs er ledig", "newEventCreatedDescription": "Når en ny Hendelse er Opprettet", "newCourseCommentDescription": "Når noen tilbakemelding På et kurs", "certificateIssuedDescription": "Når et sertifikat er Utstedt", "estimateReceivedDescription": "Når et ny Estimat er Mottatt", "contractReceivedDescription": "Når en ny Avtale er Mottatt", "invoiceReceivedDescription": "Når en ny Faktura er Mottatt", "allEmailNotificationsDescription": "Vend På/Deaktivert hver eneste E-post Påminnelse", "allPushNotificationsDescription": "Vend På/Deaktivert hver eneste push notifikationer", "errorUpdating": "Det oppsto en feil under oppdatering av Notifikasjonsinnstillinger", "updateSuccess": "Din notifikasjon Innstillinger har vært Oppdatert", "willNotReceiveNotificationsIfAdminDisabled": "Du vil ikke Arve Påminnelse for Innstillinger deaktivert Via din administrator.", "estimateReceived": "ny Estimat Mottatt", "contractReceived": "ny Avtale Mottatt", "invoiceReceived": "ny Faktura Mottatt", "pushNotificationNotAvailable": "Push-varsel er ikke tilgjengelig for denne Hendelsen", "newsletter": "Nyhetsbrev", "emailNotificationNotAvailable": "Email-varsel er ikke tilgjengelig for denne Hendelsen", "newPostFollowers": "Nytt innlegg fra fulgt bruker", "newPostFollowersDescription": "Bli varslet når noen du følger oppretter et nytt innlegg.", "newFollower": "Bli varslet Når noen Følge Du." };
const loginPage$3 = { "forgotPassword": "Glemt passord?", "login": "Logg inn", "lastLogin": "siste Logg inn", "proceedToLogin": "Fortsette til Logg inn", "secureCode": "Sikker Kode", "newUser": "ny Bruker?", "resetPasswordLink": "Hvis den angitte e-posten er riktig, vil du få et Tilbakestill- password Lenke in e-posten. Sørg for å Hake spam-mappe også.", "loginWithSecureCode": "Logg inn med sikker kode", "signUp": "Registrer deg", "enterOtp": "Skriv inn OTP", "selectAccount": "Velge hvilke Konto Du ønsker å", "resetPassword": "Tilbakestill passord", "selectUser": "Velge Bruker", "emailRequired": "Skriv inn en gyldig e-post", "fullNameRequired": "Vennligst skriv inn navnet ditt", "passwordRequired": "Vennligst skriv inn et password av Min.. 8 Tegn", "generateSecureCode": "Generere sikker Kode", "loginWithPassword": "Logg inn med passord", "secureCodeEmail": "Vennligst skriv inn e-posten din for å få den sikre koden. Hvis du ikke mottok noen e-post fra oss,", "resendOtp": "trykk på henne for å Send på nytt.", "verifySecureCode": "Verifisere sikker Kode", "secureCodeNumeric": "Sikker kode må være en Numerisk Verdi og må være på seks sifre", "alreadyHaveAccount": "Har du allerede en konto?", "email": "E-post", "password": "Passord", "fullName": "Full navn", "somethingWentWrong": "Noe gikk galt", "signInWithEmail": "Eller, logg inmed e-posten din", "signUpWithEmail": "Eller registrer deg med e-post", "confirmPassword": "Bekreft passord", "validationErrors": { "potentialSpamUser": { "title": "Konto Privat", "message": "Din konto har blitt Privat Skyldig til potensiell spam-aktivitet. Ta kontakt med kundestøtte for å få hjelp." }, "somethingWentWrong": { "title": "Noe gikk galt", "message": "Kan ikke logge inn. Vennligst prøv igjen senere." }, "bannedUser": { "title": "Konto Privat", "message": "Din konto har blitt Utestengt Skyldig til potensiell spam Aktivitet. Ta kontakt med kundestøtte for å få hjelp." } } };
const magicLink$3 = { "newLinkSent": "ny Lenke sendt", "portalWillSendLink": "Portal vil vare opp a ny Lenke til e-postadressen din", "failedToSendNewLink": "Kunne ikke laste opp ny Lenke", "pleaseTryAgain": "Vennligst prøv igjen", "linkExpired": "Denne Lenke Fra e-posten din har Utløpt.", "toContinue": "Til Fortsette, Forespørsler a ny Lenke Eller Logg in på Portal din", "sendNewLink": "Laste opp ny Lenke", "logIn": "LOGG in", "clickToLogIn": "Klikk her for å logge in på Portal din", "invalidToken": "Dette Token fra e-posten din er ikke gyldig.", "toContinueContactAdmin": "Til Fortsette, Forespørsler a ny Magisk lenke Kontakt Admin Eller Logg in på Portal din" };
const setPassword$3 = { "minLength": "Vennligst skriv inn et password av Min.. 8 Tegn", "passwordsMustMatch": "Passordene må samsvare", "setSecurePassword": "Samling av det sikre passwordditt", "setPasswordButton": "Samling-passord" };
const alerts$3 = { "tooManyAttempts": { "title": "For mange forsøk", "message": "Ikke mer enn 2 forsøk på Slug -oppdatering er tillatt in en Vindu av Måned" }, "slugAlreadyExists": { "title": "Slug finnes allerede", "message": "Prøv en annen Slug" }, "updateSlugError": { "title": "Noe gikk galt", "message": "Kan ikke oppdatere Profil Slug. Vennligst prøv Etter noen Dato" }, "updateProfileError": { "title": "Noe gikk galt", "message": "Kan ikke oppdatere profildetaljer. Vennligst prøv Etter noen Dato" } };
const bottomNavBar$3 = { "home": "Hjem", "discover": "Oppdage", "communities": "Fellesskap", "courses": "Kurs", "more": "Mer" };
const forceUpdate$3 = { "title": "NY OPPDATERING ER TILGJENGELIG", "description": "Oppdater applikasjonen din til siste versjon", "buttonText": "Oppdater nå!" };
const accessibility$3 = { "copyAffiliateLink": "Kopier Tilknyttet Lenke til utklippstavlen", "deleteCard": "Slett kort", "appSwitcher": "Bryter", "portalImage": "Portal", "profileImage": "Profilbilde", "continueWithGoogle": "Fortsette med Google" };
const resetPassword$3 = { "passwordExpired": "Ditt password Tilbakestill Lenke har Utløpt.", "regenerateLink": "Regenerer Lenke", "proceedToLogin": "Fortsette til Logg inn", "passwordChangedSuccessfully": "Password Dynamisk vellykket", "changePassword": "Endre passord", "newPassword": "Vennligst skriv inn et password av Min.. 8 Tegn", "confirmPassword": "password samsvarer ikke", "setNewPassword": "Samling ny passord", "confirmNewPassword": "Bekreft nytt passord" };
const no = {
  common: common$3,
  account: account$3,
  wallet: wallet$3,
  support: support$3,
  social: social$3,
  validation: validation$3,
  forms: forms$3,
  auth: auth$3,
  billing: billing$3,
  transactions: transactions$3,
  cancelModal: cancelModal$3,
  certificates: certificates$3,
  changePassword: changePassword$3,
  deleteAccount: deleteAccount$3,
  chats: chats$3,
  payments: payments$3,
  profileSettings: profileSettings$3,
  languageSettings: languageSettings$3,
  userActivityOverview: userActivityOverview$3,
  widget: widget$3,
  dashboard: dashboard$3,
  uploadDocument: uploadDocument$3,
  navbar: navbar$3,
  mandatedInfoModal: mandatedInfoModal$3,
  sideBar: sideBar$3,
  notifications: notifications$3,
  affiliates: affiliates$3,
  deleteCard: deleteCard$3,
  notificationPreferences: notificationPreferences$3,
  loginPage: loginPage$3,
  magicLink: magicLink$3,
  setPassword: setPassword$3,
  alerts: alerts$3,
  bottomNavBar: bottomNavBar$3,
  forceUpdate: forceUpdate$3,
  accessibility: accessibility$3,
  resetPassword: resetPassword$3
};
const common$2 = { "show": "Exibir", "newPost": "Nova publicação", "active": "Ativo", "change": "Alterar", "remove": "Remover", "cancel": "Cancelar", "publish": "Publicar", "save": "Salvar", "draft": "Rascunho", "scheduled": "Programado", "published": "Publicado", "actions": "Ações", "archive": "Arquivar", "delete": "Excluir", "edit": "Editar", "settings": "Configurações", "updatedOn": "Atualizado(a) em", "blogPost": "Publicar no blog", "category": "Categoria", "author": "Autor", "status": "Status", "errors": "Erros", "error": "Erro", "all": "Todos", "add": "Adicionar", "discussion": "Discussão", "allCourses": "Todos os cursos", "myCourses": "Meus cursos", "learning": "Aprendizado", "leaderboard": "Tabela de classificação", "documentsAndPayments": "Documentos e gerenciamento de arquivos", "more": "Mais", "profile": "Perfil", "archived": " Arquivado", "back": "Voltar", "restore": "Restaurar esta versão", "next": "Seguinte", "previous": "Anterior", "continue": "Continuar", "details": "Informações", "youtube": "Youtube", "action": "Ação", "view": "Visualizar", "download": "Baixar", "source": "Fonte", "title_column": "Título", "copy": "Copiar", "viewReceipt": "Visualizar recibo", "id": "ID", "location": "Localização", "email": "E-mail", "title": "Título", "logout": "Logout", "login": "Login", "calender": "Calendário", "apply": "Aplicar", "clear": "Limpar", "to": "Para", "from": "De", "type": "Tipo", "home": "Página inicial", "description": "Description", "updated": "Atualizado", "networkError": { "title": "Sem conexão com a internet", "message": "Verifique sua conexão com a internet e tente novamente." } };
const account$2 = { "settings": "Configurações da conta", "updateSettings": "Atualize as configurações da sua conta aqui", "paymentDetails": "Detalhes do pagamento", "orderId": "ID do pedido interno", "nextInvoice": "Próxima fatura", "transactionDate": "Data da transação", "expiryDate": "Data de validade", "manageAllSubscription": "Gerencie todas as suas assinaturas", "paymentMethod": "Método de pagamento", "andTransactionHere": "e transação aqui" };
const wallet$2 = { "transactionId": "ID da transação" };
const support$2 = { "subscriptionId": "ID da assinatura", "email": { "validation": "Insira um e-mail válido" }, "invoiceNo": "Número da fatura" };
const social$2 = { "title": "Redes sociais", "invalidURL": "URL inválido", "phoneNumber": "Número de telefone", "userPhone": "Telefone do usuário", "userEmail": "E-mail do usuário", "info": "Informações sociais", "update": "Atualizar informações de redes sociais", "detailsHere": "Atualize os detalhes de suas redes sociais aqui", "updated": "Redes sociais atualizadas", "visibility": "Visível publicamente", "validUrl": "Por favor, insira um URL válido", "validEmail": "Insira um e-mail válido", "validPhoneNumber": "Insira um número de telefone válido com um código de país apropriado", "platforms": { "twitter": "Twitter", "instagram": "Instagram", "facebook": "Facebook", "youtube": "Youtube", "linkedin": "LinkedIn" } };
const validation$2 = { "phone": "Digite um telefone válido", "url": "Insira um URL válido" };
const forms$2 = { "phone": "Número de telefone" };
const auth$2 = { "clickToResend": "Clique para reenviar", "authentication": "Autenticação", "didntGetCode": "Não recebeu um código?", "confirmationCode": "Código de verificação", "sentVerificationEmail": "Enviamos um código de verificação por e-mail para", "authenticateAccount": "Autentique a sua conta", "incorrectOrExpired": "O OTP está incorreto ou expirado", "failedToSend": "Falha ao enviar OTP", "checkEmailForSecureCode": "Verifique seu email para o código de segurança. Caso não tenha recebido nenhum e-mail nosso,", "user": "Usuário", "verify": "Verificar", "tapHereToResend": "toque aqui para reenviar.", "failedToVerifyOtp": "Falha ao verificar o OTP", "failedToGetOtp": "Não foi possível obter o OTP" };
const billing$2 = { "endingIn": "terminando in", "billingInformation": "Informações de faturamento", "billingAddress": "Endereço de faturamento:", "sourceType": "Tipo de fonte:", "invoices": "Faturas", "subscription": "Assinatura", "transactions": "Vendas", "transaction": "Transação", "subscriptions": "Assinaturas", "invoiceName": "Nome da fatura", "subscriptionName": "Nome da Assinatura", "dueDate": "Data de vencimento", "issueDate": "Data de emissão", "amount": "Valor", "manageSubscriptions": "Gerencie todas as suas assinaturas", "andSubscription": "e Assinatura", "andTransaction": "& transação aqui", "billing": "Faturamento", "startDate": "Data de início", "fullName": "Nome completo", "nextInvoiceOn": "Próxima fatura em", "noDataFound": "Nenhum dado encontrado", "invoiceNo": "N.º da fatura:", "manageSubscriptionsInvoicesAndTransactions": "Gerenciar assinaturas, faturas e transações", "created": "Criado:", "transactionName": "Nome da transação", "tid": "Hora :", "transactionDate": "Data da transação:", "trial": "Teste", "expired": "Vencido", "pastDue": "Vencido", "unpaid": "Não pago", "incompleteExpired": "Incompleta e vencida", "canceled": "Cancelado", "incomplete": "Incompleto", "failed": "Falhou", "sent": "Enviado", "paid": "Pago", "paymentProcessing": "Processamento de pagamento", "partiallyPaid": "Parcialmente paga", "overdue": "Atrasada", "succeeded": "Com êxito", "processing": "Processando", "refunded": "Reembolsado", "pending": "Pendente", "membership": "Assinatura", "communities": "Comunidades", "paymentLink": "Link de pagamento", "expiresOn": "Expira em", "errorFetchingPaymentMethods": "Erro ao buscar métodos de pagamento", "pageUrl": "URL da Página" };
const transactions$2 = { "title": "Vendas", "name": "Nome das vendas" };
const cancelModal$2 = { "subscriptionRenewNotice": "Se você mudar de ideia, pode renovar sua assinatura a qualquer momento.", "cancelSubscription": "Cancelar assinatura", "subscriptionCancelNotice": "será cancelado imediatamente. Você não será cobrado novamente.", "yourPlanName": "Seu plano", "currentPlan": "Plano Atual", "subscriptionCancelError": "Ocorreu um erro ao tentar cancelar a assinatura.", "cancelSubscriptionFailed": "Falha ao cancelar assinatura" };
const certificates$2 = { "title": "Certificados", "certificatesDescription": "Certificados de Baixar e Compartilhar Você ganha.", "subtitle": "Baixar seus Certificados", "completedOn": "Concluído ativado", "back": "Voltar", "previous": "Anterior", "next": "Próximo", "downloadYourCertificates": "Baixe seus certificados", "downloadCertificate": "Baixar {type}", "viewCertificates": "Visualize e baixe todos os seus certificados aqui", "certificateNotFound": "Nenhum Certificado encontrado", "issuedOn": "Emitido ativado", "expiresOn": "Vence ativado", "description": "Descrição", "yourCertificateHasExpiredOn": "Seu {type} tem Vencido Ativado", "issuedCertificatesNotFound": "Você ainda não ganha nenhum Certificado.", "shareCertificate": "Compartilhar:", "preview": { "issuedTo": "Emitido para", "issuedBy": "Emitido por", "addToLinkedin": "Adicionar ao Perfil do Linkedin", "download": "Baixar", "credentialVerification": "Verificação de credenciais", "issueDate": "Data de emissão", "expiryDate": "Data de validade", "verifyCredential": "Verificar credencial", "shareYourCredential": "Compartilhe sua credencial", "showYourCredential": "Exibir suas credenciais nas suas Redes sociais", "expiredOn": "Expirado em", "expiredDesc": "É hora de renovar e manter-se atualizado. Não perca os benefícios e Oportunidades contínuas.", "verificationModal": { "title": "Verificação de credenciais", "subtitle": "Esta é a credencial válida.", "description": " Esta credencial foi emitida de forma segura. Todos os Detalhes exibidos são válidos.", "step1": { "title": "Verificando o destinatário", "description": "O Proprietário desta credencial é {recipient}" }, "step2": { "title": "Verificando o emissor", "description": "Esta credencial foi emitida por  {issuer}" }, "step3": { "title": "Verificando o ID da credencial", "description": "O Rótulo {credentialId} é único e válido." } }, "notFound": { "title": "Ops! Certificado não encontrado", "description": "O certificado que você está tentando visualizar não está disponível.", "subtitle": "Entre em contato com o emissor para obter assistência." } }, "share": { "title": "Seu Certificado", "text": "aqui é seu Certificado", "dialogTitle": "Compartilhar Ou Arquivar seu Certificado" }, "listing": { "courseAssignmentName": "Nome do curso/tarefa", "offlineCertification": "Certificado off-line", "completionDate": "Data de término", "expiryDate": "Data de Expiração", "type": "Digitar", "sourceName": "Nome da Fonte", "action": "Ação" } };
const changePassword$2 = { "showPasswords": "Mostrar senhas", "retypePassword": "Digite novamente a senha", "newPassword": "Nova senha", "confirmNewPassword": "Confirm New Password", "currentPassword": "Senha atual", "emailId": "ID de e-mail", "passwordMinLength": "Insira uma password de no mínimo 8 caracteres", "editAccount": "Editar Conta", "loginEmail": "Email de Login", "loginInformation": "Informações de login", "accountDetails": "Detalhes da conta", "accountDetailsUpdate": "Atualize os detalhes da sua conta aqui", "accountInformation": "Informações da conta", "changePassword": "Alterar senha", "hidePasswordChange": "Ocultar a opção de alterar a senha", "selectPageError": "Tente novamente mais tarde", "systemErrorOccurred": "Algo deu errado", "passwordEntryInvalid": "Senha inválida", "passwordUpdateSuccess": "Senha atualizada", "passwordLengthRequired": "Insira uma password de no mínimo 8 caracteres", "passwordMinimumLength": "Insira uma password de no mínimo 8 caracteres", "passwordFieldRequired": "A senha é obrigatória", "password": "Senha" };
const deleteAccount$2 = { "title": "Excluir Conta", "deleteAccountDescription": "Sua conta está programada para desativação temporário e será Apagado permanentemente Se Você não faça in nos Próximos 7 dias.", "deleteAccountDescription2": "Para manter sua Conta Dinâmico, basta fazer in antes do data limite. Depois do Apagado, seus dados não podem ser recuperados.", "deleteAccountButton": "Sim, excluir Conta" };
const chats$2 = { "viewAll": "Visualizar tudo", "viewLess": "Visualizar menos", "updatedPreference": "Preferência atualizada", "chatSettings": "Configurações do chat", "chats": "Chats", "chatSettingsDescription": "Selecione as configurações de chat para seus grupos e amigos", "groups": "Grupos", "blockedUsers": "Usuários bloqueados", "noGroups": "Sem grupos", "controlUsers": "Gerenciar com quais usuários você não deseja conversar por chat.", "blockedConversations": "Conversas Bloqueadas", "noBlockedUsers": "Sem usuários bloqueados", "unblock": "Desbloquear", "noUsersBlocked": "Nenhum usuário bloqueado", "noGroupsJoined": "Nenhum grupo entrou", "controlGroups": "Gerenciar quais usuários do grupo podem entrar em contato com você, alternando sua disponibilidade de chat para habilitado ou desabilitado abaixo. Você pode receber mensagens apenas de membros da comunidade da qual você faz parte. " };
const payments$2 = { "shareLink": "Compartilhar link", "paymentLink": "Link de pagamento" };
const profileSettings$2 = { "complete": "CONCLUIR", "editBasicInformation": "Editar detalhes básicos", "writeAboutYourself": "Escreva algo sobre si...", "selectTimezone": "Selecionar fuso horário", "description": "Isso será exibido em seu perfil", "timezone": "Fuso horário", "enterLocation": "Digite a localização", "exampleDescription": "Modelo: Olá, eu sou John Deo e sou fotógrafo", "enterABriefDescription": "Insira uma breve descrição", "bio": "Bio", "profileSlugNotAvailable": "Slug de perfil não disponível", "findAndShareProfile": "Descubra e compartilhe seu perfil facilmente com um slug de URL personalizado.", "profileSlug": "Slug do Perfil", "enterTitle": "Insira o título", "enterFullName": "Insira o nome completo", "basicDetails": "Detalhes básicos", "updateProfileDetails": "Atualize os detalhes do seu perfil aqui", "basicInformation": "Detalhes básicos", "updatedProfileSettings": "Configurações de perfil atualizadas", "uploadStatusCode": "O carregamento falhou com o código de status", "imageTypeNotSupported": "Tipo de imagem não suportado", "nameIsRequired": "O nome é obrigatório", "invalidName": "Nome inválido", "profileImage0": "Foto de perfil", "profileImage": "Foto de perfil", "uploadSvgPngJpg": "Carregue um SVG, PNG ou JPG. Proporção de aspecto recomendada 1:1", "profilesBuildConnection": "Perfis geram confiança e estimulam a conexão com outras pessoas", "clientPortalNames": "O Portal do cliente parece estranho sem rostos e nomes.", "completeYourProfile": "Conclua seu perfil", "uploadFailed": "Falha ao carregar", "fileSizeTooLarge": "O tamanho do arquivo é muito grande", "invalidFileFormatType": "Formato/tipo de arquivo inválido.", "pleaseUploadImage": "Carregue uma imagem do tipo SVG, PNG, JPG ou JPEG.", "pleaseUploadAFileLessThan100Mb": "Selecione um arquivo com menos de 100 MB.", "oopsUnableToUploadImage": "Ops! Não foi possível carregar a imagem.", "selectPageError": "Tente novamente mais tarde", "search": "Pesquisar", "searchTimezones": "Pesquisar fusos horários", "noTimezonesFound": "Nenhum fuso horário encontrado", "editDetails": "Editar detalhes", "profilePicture": "Foto de perfil", "profileCover": "Capa de perfil", "uploadPhoto": "Carregar foto", "removePhoto": "Remover foto", "invalidAspectRatio": "Proporção de aspecto inválida", "recommendedAspectRatio169": "Proporção de aspecto recomendada 16:9", "recommendedAspectRatio11": "Proporção de aspecto recomendada 1:1", "editProfile": "Editar perfil", "manageYourGroupDetailsHere": "Gerencie os detalhes do seu grupo aqui", "profileIcon": "Ícone de Perfil", "specialCharactersNotSupported": "Caracteres especiais não são compatíveis", "slugValidation": { "containSpecialCharacters": "Slug não pode conter caracteres especiais", "tooShort": "Slug deve ter pelo menos 3 caracteres", "tooLong": "Slug deve ter menos de 50 caracteres", "containOnlyNumbers": "O Slug não pode conter apenas números", "startWithNumber": "O Slug não pode começar com um número", "startWithHyphen": "O Slug não pode começar com um Híbrido", "endWithHyphen": "Slug não pode Fim com um Híbrido", "containDoubleHyphen": "O Slug não pode conter funis duplos", "containSpace": "Slug não pode conter espaço" } };
const languageSettings$2 = { "title": "Configurações de Idioma", "detailsHere": "Selecione o idioma do Portal do cliente", "selectLanguage": "Selecione o idioma", "useLocationLanguage": "Usar Idioma de Localização", "languagePreferenceUpdated": "Preferência de idioma atualizada", "errorUpdatingLanguage": "Erro ao atualizar o idioma", "description": "Selecione o seu idioma preferido para visualizar itens do Portal do cliente, conteúdo da comunidade, Cursos e informações de afiliado. Esta configuração permite que você veja o conteúdo no idioma com o qual você se sente mais confortável. ", "shortDescription": "Selecione o seu idioma preferido" };
const userActivityOverview$2 = { "dustBunnies": "Nada para ver, a menos que você goste de coelhinhos de poeira.", "welcomeBanner": "Bem-vindo ao", "contracts": "Contratos", "hiUser": "Olá", "estimates": "Estimativas", "sharedFiles": "Arquivos compartilhados" };
const widget$2 = { "viewAll": "Visualizar tudo", "addedOn": "Adicionado em", "by": "Via", "you": "Você", "admin": "Administrador", "youDoNotHaveAny": "Você não tem nenhum!", "noContracts": "Sem contratos", "maxFilesExceeded": "Você só pode carregar até 10 Arquivos", "uploadFile": "Carregar Arquivo", "userActivityOverview.contracts": "Contratos", "selectPageError": "Tente novamente mais tarde", "notAbleToDownloadContract": "Não é possível baixar o contrato", "completeCourse": "Curso completo", "courseProgress": "Progresso do curso", "viewAllGroups": "Visualizar todos os Grupos", "recentlyOpened": "Aberto recentemente", "noInvoices": "Nenhuma fatura", "noEstimates": "Sem estimativas", "notAbleToDownloadInvoice": "Não é possível baixar a fatura", "contracts": "Contratos", "invoices": "Faturas", "youMarked": "Você marcou", "inCourse": "em andamento", "invoice": "Fatura", "makePayment": "Faça o pagamento", "downloadInvoice": "Baixar fatura", "viewGroup": "Exibir grupo", "payment": "Pagamento", "download": "Baixar", "signContract": "Símbolos de acordo", "sign": "Símbolos", "estimates": "Estimativas", "notAbleToDownloadEstimate": "Não é possível baixar a estimativa", "addFiles": "Adicionar Arquivos", "sharedFiles": "Arquivos compartilhados", "fileManagement": "Gestão de Documentos", "noFiles": "Nenhum Arquivos" };
const dashboard$2 = { "joinAGroup": "Participar de uma comunidade", "takeACourse": "Faça um curso", "checkAffiliateEarnings": "Verifique os ganhos do afiliado", "manageSubscriptions": "Gerencie assinaturas", "contracts": "contratos", "estimates": "Estimativas", "sharedFiles": "Arquivos compartilhados", "paidOn": "Pago em", "partiallyPaidOn": "Parcialmente pago em", "overdueSince": "Atrasada desde", "dueOn": "Devido em", "hello": "Olá", "viewGroup": "Exibir grupo", "recentlyOpened": "Aberto recentemente", "noItemsYet": "Você ainda não tem nenhum!", "affiliates": "Afiliados", "exploreHere": "Explore aqui", "selectApp": "Selecione seu app", "exploreCourses": "Explore os cursos disponíveis", "courses": "Cursos", "engageCommunity": "Interaja com a comunidade", "communities": "Comunidades", "noDataAvailable": "Não há dados disponíveis no minuto", "noAppsAvailable": "Nenhum Apps disponível", "noWidgetsAvailable": "Nenhum widget para a Exibição", "noContentAvailable": "Nenhum conteúdo disponível" };
const uploadDocument$2 = { "uploadHeader": "Adicionar Arquivos", "uploadDescription": "Selecione e carregue até 10 arquivos", "uploadWarning": "Isso ficará visível para o Administrador do Portal para Visualizar e Baixar", "uploadInstruction": "Clicar para carregar ou arraste e solte", "allowedFiles": "DOC, PNG, JPG , GIF , PPT Ou PDF (Máximo. 100 MB)", "cancelButton": "Cancelar", "uploadButton": "Carregar", "confirmDeletion": "Salvar exclusão", "deleteFile": "Excluir Arquivo", "deleteFileDescription": "Tem certeza de que deseja excluir este arquivo? Essa ação não pode ser desfeita.", "deleteFileButton": "Sim, excluir Arquivo", "deleteFileSuccessTitle": "Arquivo Apagado com sucesso", "deleteFileErrorTitle": "Erro in excluir o arquivo", "deleteFileErrorMessage": "Ocorreu um erro ao tentar excluir o Arquivo.", "cancel": "Anulado", "notAbleToDownloadFile": "Não é possível baixar o arquivo", "fileSizeExceeded": "Tamanho do arquivo exceder 100 MB", "invalidFileType": "Inválido Arquivo digital", "notAbleToUploadFile": "Não é possível carregar o arquivo", "downloadError": "Erro in baixar arquivo", "fileUploadedSuccessfully": "Arquivo carregado com sucesso", "fileDownloadedSuccessfully": "Arquivo Baixar com sucesso" };
const navbar$2 = { "hi": "Olá", "manageYourAccount": "Gerencie sua conta", "logOut": "Sair", "affiliates": "Afiliados", "courses": "Cursos", "communities": "Comunidades" };
const mandatedInfoModal$2 = { "invalidFileFormat": "Formato/tipo de arquivo inválido.", "pleaseUploadImage": "Carregue uma imagem do tipo SVG, PNG, JPG ou JPEG", "fileSizeTooLarge": "O tamanho do arquivo é muito grande", "oopsUnableToUploadImage": "Ops! Não foi possível carregar a imagem.", "pleaseUploadFileLessThan100MB": "Carregue um arquivo com menos de 100 MB", "pleaseTryAgainLater": "Tente novamente mais tarde", "completeYourProfile": "Conclua seu perfil", "profilesBuildConnection": "Perfis geram confiança e estimulam a conexão com outras pessoas", "putAFaceToYourProfile": "Adicione uma foto ao seu perfil!", "uploadASVGPNGJPG": "Carregue um SVG, PNG ou JPG.", "recommendedAspectRatio11": "Proporção de aspecto recomendada 1:1", "complete": "CONCLUIR", "cropYourAvatar": "Corte seu avatar", "dragToReposition": "Arraste para reposicionar" };
const sideBar$2 = { "languageSettings": "Configurações de idioma", "profile": "Perfil", "account": "Conta", "socialMedia": "Redes sociais", "certificates": "Certificados", "billingSubscription": "Cobrança e assinatura", "communitiesChats": "Comunidades e Chats", "affiliates": "Afiliados", "notifications": "Lembrete" };
const notifications$2 = { "title": "Lembretes", "all": "Todos", "unread": "Não lidos", "markAllRead": "Marcar tudo como lido", "noNotifications": "Ainda não há lembretes", "whenYouGetNotifications": "Quando você receber notificações, elas aparecerão aqui" };
const affiliates$2 = { "payoutMethod": "Método de pagamento", "leadCustomer": "Oportunidades/ Clientes", "commissions": "Comissões", "description": "Indique usuários para o GoKollab", "title": "Afiliados", "groupsGoKollab": "Criar grupos no GoKollab é totalmente gratuito, mas isso é apenas o começo! Novos e empolgantes recursos estão a caminho para ajudá-lo a expandir o seu negócio on-line e aumentar os seus ganhos. À medida que os usuários fizerem upgrade para desbloquear o conjunto completo de recursos, você receberá uma comissão vitalícia recorrente de afiliado sobre a assinatura deles. Quanto mais cedo você começar a indicar, melhor — não perca este incrível programa de afiliados", "yourAffiliateLink": "Seu link de afiliado" };
const deleteCard$2 = { "deleteCard": "Excluir cartão", "description": "O método de pagamento não estará mais disponível depois de removê-lo. Esta ação não pode ser desfeita.", "activeCard": "Este cartão é utilizado para um ou mais pagamentos de assinaturas ativas. Excluir este cartão sem atualizar o método de pagamento das assinaturas associadas impactará os pagamentos futuros. Tem certeza de que deseja excluir este cartão?", "title": "Remover método de pagamento?", "cardCannotBeDeleted": "O cartão não pode ser apagado", "cardIsLinkedToSubscriptions": "O cartão está associado a assinaturas", "errorInDeletingCard": "Erro ao excluir cartão", "noCardAvailable": "Nenhum cartão disponível", "cardRemovedSuccessfully": "Cartão removido com sucesso" };
const notificationPreferences$2 = { "title": "Notificação Configurações", "description": "Gerenciar Quando e para que Você é enviado", "pushNotificationsTitle": "Enviar lembrete", "pushNotificationsDescription": "Gerenciar push Lembrete", "emailNotificationsTitle": "Enviar e-mail lembrete", "emailNotificationsDescription": "Gerenciar e-mail de lembrete", "emailNotifications": "Enviar e-mail lembrete", "manageEmailNotifications": "Gerenciar e-mail de lembrete", "newActivity": "novo Atividade", "email": "E-mail", "push": "Enviar", "allNotifications": "todos se lembram", "postTags": "Compartilhar Palavras-chave", "postEveryoneTagged": "Compartilhar {'@'}Todo o mundo Palavras-chave", "postMention": "Compartilhar {'@'}Menção", "postLike": "Compartilhar Curtir", "newComment": "novo comentário", "commentEveryoneTagged": "Comentário {'@'}Todo o mundo Palavras-chave", "commentMention": "Comentário {'@'}Menção", "commentLike": "Comentário Curtir", "postEveryoneTaggedMobile": "Compartilhar {'@'}Todo o mundo Palavras-chave", "postMentionMobile": "Compartilhar {'@'}Menção", "commentEveryoneTaggedMobile": "Comentário {'@'}Todo o mundo Palavras-chave", "commentMentionMobile": "Comentário {'@'}Menção", "newMemberRequestToJoinGroup": "novo Membros Solicitações para participar do Grupo", "groupJoiningRequestApproved": "Grupo entrando em Solicitações Aceito", "groupJoiningRequestRejected": "Grupo que se inscreve em Solicitações Negadas", "roleUpdatedInPrivateChannel": "Funções Atualizado in canal Privado", "newCourseAvailable": "novo curso adicionado ao grupo", "newEventCreated": "novo evento criado", "newCourseComment": "Comentário do novo curso", "certificateIssued": "Certificado Emitido", "postEveryoneTaggedDescription": "Quando alguém publicar {'@'}Todo mundo Palavras-chave", "postMentionDescription": "Quando alguém publicar {'@'}menção", "postLikeDescription": "Quando alguém Curtidas sua Compartilhar", "newCommentDescription": "Quando alguém feedback Ativado sua Compartilhar", "commentEveryoneTaggedDescription": "Quando alguém feedback {'@'}Todo o mundo Palavras-chave", "commentMentionDescription": "Quando o feedback de alguém {'@'}menção", "commentLikeDescription": "Quando alguém Curtidas seu comentário", "newMemberRequestToJoinGroupDescription": "Quando alguém Solicitações para participar do seu grupo", "groupJoiningRequestApprovedDescription": "Quando o grupo de alguém que está entrando no Solicitações é Aceito", "groupJoiningRequestRejectedDescription": "Quando o grupo de alguém que está entrando no Solicitações é Negado", "roleUpdatedInPrivateChannelDescription": "Quando a função de alguém é Atualizado in um canal da Privado", "newCourseAvailableDescription": "Quando um novo curso está disponível", "newEventCreatedDescription": "Quando um novo evento é criado", "newCourseCommentDescription": "Quando alguém feedback Ativado um curso", "certificateIssuedDescription": "Quando a Certificado é Emitido", "estimateReceivedDescription": "Quando uma nova estimativa é recebida", "contractReceivedDescription": "Quando um novo acordo é recebido do", "invoiceReceivedDescription": "Quando uma nova Fatura é recebida", "allEmailNotificationsDescription": "Virar Ativado/ Desabilitado todos E-mail Lembrete", "allPushNotificationsDescription": "Virar Ativado/ Desabilitado todos push Lembrete", "errorUpdating": "Lá foi um erro ao atualizar suas configurações de notificação", "updateSuccess": "Suas configurações de notificação foram atualizadas", "willNotReceiveNotificationsIfAdminDisabled": "Você não Herdar Lembrete para configurações desabilitadas Via seu administrador.", "estimateReceived": "nova Estimativa recebida", "contractReceived": "novo acordo recebido", "invoiceReceived": "nova Fatura recebida", "pushNotificationNotAvailable": "A notificação push não está disponível para este evento", "newsletter": "Newsletter", "emailNotificationNotAvailable": "A notificação por Email não está disponível para este Evento", "newPostFollowers": "Novo Compartilhar de Usuário Seguido", "newPostFollowersDescription": "Receba notificações Quando alguém que você Seguir cria uma nova publicação.", "newFollower": "Seja notificado quando alguém te Seguir." };
const loginPage$2 = { "forgotPassword": "Esqueceu a senha?", "login": "Login", "lastLogin": "último Login", "proceedToLogin": "Prosseguir para Login", "secureCode": "Código de segurança", "newUser": "novo usuário?", "resetPasswordLink": "Se o e-mail inserida estiver correto, Você terá um Link de redefinição password in e-mail. Certifique-se de marcar de verificação também as pastas de spam.", "loginWithSecureCode": "Login com código de segurança", "signUp": "Cadastrar-se", "enterOtp": "Insira o OTP", "selectAccount": "selecione qual Conta Você deseja", "resetPassword": "Redefinir senha", "selectUser": "Selecionar Usuário", "emailRequired": "Insira um e-mail válido", "fullNameRequired": "Digite seu nome", "passwordRequired": "Crie uma senha com no mínimo 8 caracteres", "generateSecureCode": "Gerar Código de segurança", "loginWithPassword": "Login com senha", "secureCodeEmail": "Marca de verificação seu e-mail para o código de segurança. Se Você não Herdar nenhum e-mail De nós,", "resendOtp": "pressione aqui para Reenviar.", "verifySecureCode": "Verificar Código de segurança", "secureCodeNumeric": "O código de segurança deve ser um valor numérico e deve ter 6 dígitos", "alreadyHaveAccount": "Já tem uma conta?", "email": "E-mail", "password": "Senha", "fullName": "Nome Completo", "somethingWentWrong": "Algo deu errado", "signInWithEmail": "Ou entre com o seu e-mail", "signUpWithEmail": "Ou cadastre-se com seu e-mail", "confirmPassword": "Confirmar senha", "validationErrors": { "potentialSpamUser": { "title": "Conta privada", "message": "Sua conta foi privada devido a uma potencial atividade de spam. Entre em contato com o suporte para obter assistência." }, "somethingWentWrong": { "title": "Algo deu errado", "message": "Não é possível fazerin. Tente de novo mais tarde." }, "bannedUser": { "title": "Conta privada", "message": "Sua conta foi banido devido a uma atividade de spam em potencial. Entre em contato com o suporte para obter assistência." } } };
const magicLink$2 = { "newLinkSent": "novo Link enviado", "portalWillSendLink": "Portal carregará um novo Link para seu endereço de e-mail", "failedToSendNewLink": "Falha ao carregar o novo Link", "pleaseTryAgain": "Por favor, tente de novo", "linkExpired": "Este Link do seu e-mail tem Vencido.", "toContinue": "Para continuar, solicitar um novo Link ou fazer in na sua conta Portal", "sendNewLink": "Carregar novo Link", "logIn": "in", "clickToLogIn": "clicar aqui para fazer in na sua conta Portal", "invalidToken": "Este Token de seu e-mail não é válido.", "toContinueContactAdmin": "Para continuar, solicitações a novo Link mágico Contato Administrador Ou Faça in na sua conta Portal" };
const setPassword$2 = { "minLength": "Crie uma senha com no mínimo 8 caracteres", "passwordsMustMatch": "As senhas devem corresponder", "setSecurePassword": "Coleção sua passwordsegurança", "setPasswordButton": "Senha da coleção" };
const alerts$2 = { "tooManyAttempts": { "title": "Devidas tentativas", "message": "Não são permitidas mais de 2 tentativas de atualização do Slug in uma Janela de Mês" }, "slugAlreadyExists": { "title": "O Slug já existe", "message": "Tente um Slug diferente" }, "updateSlugError": { "title": "Algo deu errado", "message": "Não foi possível atualizar o perfil Slug. Tente Depois de alguns dados" }, "updateProfileError": { "title": "Algo deu errado", "message": "Não foi possível atualizar o perfil Detalhes. Tente Depois de alguns dados" } };
const bottomNavBar$2 = { "home": "Página inicial", "discover": "Descobrir", "communities": "Comunidades", "courses": "Cursos", "more": "Mais" };
const forceUpdate$2 = { "title": "novo Aartualização está disponível", "description": "Atualize seu aplicativo para a versão mais recente", "buttonText": "Atualizar agora!" };
const accessibility$2 = { "copyAffiliateLink": "Copiar Link do afiliado para a área de transferência", "deleteCard": "Excluir cartão", "appSwitcher": "Comutador de apps", "portalImage": "Imagem do Portal", "profileImage": "Imagem de Perfil", "continueWithGoogle": "Continuar com o Google" };
const resetPassword$2 = { "passwordExpired": "O Link de redefinir sua password tem Vencido.", "regenerateLink": "Gerar Link novamente", "proceedToLogin": "Prosseguir para Login", "passwordChangedSuccessfully": "Senha Dinâmico com sucesso", "changePassword": "Alterar a senha", "newPassword": "Crie uma senha com no mínimo 8 caracteres", "confirmPassword": "A confirmação password não corresponde", "setNewPassword": "Criar Nova Senha", "confirmNewPassword": "Confirmar nova senha" };
const ptBR = {
  common: common$2,
  account: account$2,
  wallet: wallet$2,
  support: support$2,
  social: social$2,
  validation: validation$2,
  forms: forms$2,
  auth: auth$2,
  billing: billing$2,
  transactions: transactions$2,
  cancelModal: cancelModal$2,
  certificates: certificates$2,
  changePassword: changePassword$2,
  deleteAccount: deleteAccount$2,
  chats: chats$2,
  payments: payments$2,
  profileSettings: profileSettings$2,
  languageSettings: languageSettings$2,
  userActivityOverview: userActivityOverview$2,
  widget: widget$2,
  dashboard: dashboard$2,
  uploadDocument: uploadDocument$2,
  navbar: navbar$2,
  mandatedInfoModal: mandatedInfoModal$2,
  sideBar: sideBar$2,
  notifications: notifications$2,
  affiliates: affiliates$2,
  deleteCard: deleteCard$2,
  notificationPreferences: notificationPreferences$2,
  loginPage: loginPage$2,
  magicLink: magicLink$2,
  setPassword: setPassword$2,
  alerts: alerts$2,
  bottomNavBar: bottomNavBar$2,
  forceUpdate: forceUpdate$2,
  accessibility: accessibility$2,
  resetPassword: resetPassword$2
};
const common$1 = { "show": "Mostrar", "newPost": "Nova publicação", "active": "Ativo", "change": "Alterar", "remove": "Remover", "cancel": "Cancelar", "publish": "Publicar", "save": "Guardar", "draft": "Rascunho", "scheduled": "Agendado", "published": "Publicado", "actions": "Ações", "archive": "Arquivar", "delete": "Eliminar", "edit": "Editar", "settings": "Definições", "updatedOn": "Atualizado em", "blogPost": "Publicação no blogue", "category": "Categoria", "author": "Autor", "status": "Estado", "errors": "Erros", "error": "Erro", "all": "Todos", "add": "Adicionar", "discussion": "Discussão", "allCourses": "Todos os cursos", "myCourses": "Os meus cursos", "learning": "Aprendizagem", "leaderboard": "Tabela de classificação", "documentsAndPayments": "Documentos e Gestão de Ficheiros", "more": "Mais", "profile": "Perfil", "archived": " Arquivado", "back": "Voltar", "restore": "Restaurar esta versão", "next": "Seguinte", "previous": "Anterior", "continue": "Continuar", "details": "Informações", "youtube": "YouTube", "action": "Ação", "view": "Ver", "download": "Descarregar", "source": "Fonte", "title_column": "Título", "copy": "Copiar", "viewReceipt": "Ver recibo", "id": "ID", "location": "Localização", "email": "E-mail", "title": "Título", "logout": "Sair", "login": "Login", "calender": "Calendário", "apply": "Aplicar", "clear": "Limpar", "to": "Para", "from": "De", "type": "Tipo", "home": "Início", "description": "Description", "updated": "Atualizado", "networkError": { "title": "Sem ligação à Internet", "message": "Verifique a sua ligação à Internet e tente novamente." } };
const account$1 = { "settings": "Configurações da Conta", "updateSettings": "Atualize as definições da sua conta aqui", "paymentDetails": "Detalhes do pagamento", "orderId": "ID da encomenda interna", "nextInvoice": "Próxima fatura", "transactionDate": "Data da transação", "expiryDate": "Data de validade", "manageAllSubscription": "Gerir todas as suas assinaturas", "paymentMethod": "Método de pagamento", "andTransactionHere": "e transação aqui" };
const wallet$1 = { "transactionId": "ID da transação" };
const support$1 = { "subscriptionId": "ID da assinatura", "email": { "validation": "Introduza um e-mail válido" }, "invoiceNo": "Número da fatura" };
const social$1 = { "title": "Redes sociais", "invalidURL": "URL inválido", "phoneNumber": "Número de telefone", "userPhone": "Telefone do utilizador", "userEmail": "E-mail do Utilizador", "info": "Informações de Redes Sociais", "update": "Atualizar informações de Redes Sociais", "detailsHere": "Atualize os seus detalhes de redes sociais aqui", "updated": "Redes sociais atualizadas", "visibility": "Visível Publicamente", "validUrl": "Introduza um URL válido", "validEmail": "Introduza um e-mail válido", "validPhoneNumber": "Introduza um Número de telefone válido com um indicativo de país apropriado", "platforms": { "twitter": "Twitter", "instagram": "Instagram", "facebook": "Facebook", "youtube": "YouTube", "linkedin": "LinkedIn" } };
const validation$1 = { "phone": "Introduza um número de telefone válido", "url": "Introduza um URL válido" };
const forms$1 = { "phone": "Número de telefone" };
const auth$1 = { "clickToResend": "Clique para reenviar", "authentication": "Autenticação", "didntGetCode": "Não recebeu nenhum código?", "confirmationCode": "Código de confirmação", "sentVerificationEmail": "Enviámos um Código de verificação por e-mail para", "authenticateAccount": "Autentique a sua conta", "incorrectOrExpired": "O OTP é inválido ou expirou", "failedToSend": "Falha ao enviar o OTP", "checkEmailForSecureCode": "Verifique o seu e-mail para obter o código seguro. Se não recebeu nenhum email nosso,", "user": "Utilizador", "verify": "Verificar", "tapHereToResend": "toque aqui para reenviar.", "failedToVerifyOtp": "Falha ao verificar o OTP", "failedToGetOtp": "Falha ao obter o OTP" };
const billing$1 = { "endingIn": "termina em", "billingInformation": "Informações de Faturação", "billingAddress": "Endereço de Faturação:", "sourceType": "Tipo de fonte:", "invoices": "Faturas", "subscription": "Assinatura", "transactions": "Transações", "transaction": "Transação", "subscriptions": "Assinaturas", "invoiceName": "Nome da fatura", "subscriptionName": "Nome da Assinatura", "dueDate": "Data de vencimento", "issueDate": "Data de emissão", "amount": "Montante", "manageSubscriptions": "Gerir todas as suas assinaturas", "andSubscription": "e Assinatura", "andTransaction": "& transação aqui", "billing": "Faturação", "startDate": "Data de início", "fullName": "Nome completo", "nextInvoiceOn": "Próxima fatura em", "noDataFound": "Nenhum dado encontrado", "invoiceNo": "N.º da fatura:", "manageSubscriptionsInvoicesAndTransactions": "Gerir assinaturas, faturas e transações", "created": "Criado:", "transactionName": "Nome da Transação", "tid": "Hora :", "transactionDate": "Data da transação:", "trial": "Avaliação", "expired": "Expirado", "pastDue": "Vencido", "unpaid": "Não pago", "incompleteExpired": "Incompleto expirado", "canceled": "Cancelado", "incomplete": "Incompleto", "failed": "Reprovado", "sent": "Enviado", "paid": "Pago", "paymentProcessing": "Processamento de pagamento", "partiallyPaid": "Parcialmente pago", "overdue": "Vencido", "succeeded": "Obteve sucesso", "processing": "A processar", "refunded": "Reembolsado", "pending": "Pendente", "membership": "Associação", "communities": "Comunidades", "paymentLink": "Link de pagamento", "expiresOn": "Expira a", "errorFetchingPaymentMethods": "Erro ao obter métodos de pagamento", "pageUrl": "URL da Página" };
const transactions$1 = { "title": "Transações", "name": "Nome das Transações" };
const cancelModal$1 = { "subscriptionRenewNotice": "Se mudar de ideias, pode renovar a sua Assinatura em qualquer altura.", "cancelSubscription": "Cancelar assinatura", "subscriptionCancelNotice": "será cancelado imediatamente. Não será cobrado novamente.", "yourPlanName": "O seu plano", "currentPlan": "Plano Atual", "subscriptionCancelError": "Ocorreu um erro ao tentar cancelar a assinatura.", "cancelSubscriptionFailed": "Falha ao Cancelar Assinatura" };
const certificates$1 = { "title": "Certificados", "certificatesDescription": "Descarregar & Partilhar Certificados que o utilizador ganha.", "subtitle": "Descarregar os seus Certificados", "completedOn": "Concluído Ativado", "back": "Voltar", "previous": "Anterior", "next": "Seguinte", "downloadYourCertificates": "Descarregue os seus certificados", "downloadCertificate": "Descarregar {type}", "viewCertificates": "Veja e descarregue todos os seus certificados aqui", "certificateNotFound": "Nenhum Certificado encontrado", "issuedOn": "Emido Ativado", "expiresOn": "Expira Ativado", "description": "Descrição", "yourCertificateHasExpiredOn": "O seu {type} tem Expirado Ativado", "issuedCertificatesNotFound": "Ainda não utilizador nenhum Certificado.", "shareCertificate": "Partilhar:", "preview": { "issuedTo": "Emitido para", "issuedBy": "Emitido por", "addToLinkedin": "Adicionar ao Perfil do Linkedin", "download": "Descarregar", "credentialVerification": "Verificação de credenciais", "issueDate": "Data de emissão", "expiryDate": "Data de Expiração", "verifyCredential": "Verificar Credenciais", "shareYourCredential": "Partilhe a Sua Credencial", "showYourCredential": "Mostrar a sua credencial nas Redes sociais", "expiredOn": "Expirado a", "expiredDesc": "Está na hora de renovar e manter-se atualizado. Não perca os benefícios e Oportunidades potenciais.", "verificationModal": { "title": "Verificação de credenciais", "subtitle": "Esta é a credencial válida.", "description": " Esta credencial foi emitida de forma segura. Todos os Detalhes apresentados são válidos.", "step1": { "title": "Verificar o destinatário", "description": "O Proprietário desta credencial é {recipient}" }, "step2": { "title": "A verificar o emissor", "description": "Esta credencial foi emitida por  {issuer}" }, "step3": { "title": "A verificar o ID da credencial", "description": "A Etiqueta {credentialId} é única e válida." } }, "notFound": { "title": "Ups! Certificado não encontrado!", "description": "O certificado que está a tentar ver não está disponível.", "subtitle": "Contacto o emitente para obter assistência." } }, "share": { "title": "O seu Certificado", "text": "aqui está o seu Certificado", "dialogTitle": "Partilhar Ou Arquivar o seu Certificado" }, "listing": { "courseAssignmentName": "Nome do curso/tarefa", "offlineCertification": "Certificado offline", "completionDate": "Data de fim", "expiryDate": "Data de Prazo de validade", "type": "Tipo", "sourceName": "Nome da Fonte", "action": "Ação" } };
const changePassword$1 = { "showPasswords": "Mostrar palavras-passe", "retypePassword": "Redigitar a palavra-passe", "newPassword": "Nova palavra-passe", "confirmNewPassword": "Confirm New Password", "currentPassword": "Palavra-passe atual", "emailId": "ID de Email", "passwordMinLength": "Introduza uma palavra-passe com um mínimo de 8 carateres", "editAccount": "Editar Conta", "loginEmail": "E-mail de início de sessão", "loginInformation": "Detalhes de início de sessão", "accountDetails": "Detalhes da Conta", "accountDetailsUpdate": "Atualize os detalhes da sua conta aqui", "accountInformation": "Detalhes da Conta", "changePassword": "Alterar palavra-passe", "hidePasswordChange": "Ocultar a opção de Alterar palavra-passe", "selectPageError": "Tente novamente mais tarde", "systemErrorOccurred": "Algo correu mal", "passwordEntryInvalid": "Palavra-passe inválida", "passwordUpdateSuccess": "Palavra-passe Atualizada", "passwordLengthRequired": "Introduza uma palavra-passe com um mínimo de 8 carateres", "passwordMinimumLength": "Introduza uma palavra-passe com um mínimo de 8 carateres", "passwordFieldRequired": "A palavra-passe é necessária", "password": "Palavra-passe" };
const deleteAccount$1 = { "title": "Eliminar Conta", "deleteAccountDescription": "A sua conta está agendada para desativação temporária e será permanentemente eliminada Se o utilizador não iniciar in dentro de 7 dias.", "deleteAccountDescription2": "Para Manter a sua Conta Dinâmico, basta in sessão Antes da data limite. Depois de Eliminado, os seus dados não podem ser recuperados.", "deleteAccountButton": "Sim, eliminar Conta" };
const chats$1 = { "viewAll": "Ver tudo", "viewLess": "Ver menos", "updatedPreference": "Preferência atualizada", "chatSettings": "Configurações de Chat", "chats": "Chats", "chatSettingsDescription": "Selecione as Configurações de chat para os seus Grupos e Contactos", "groups": "Grupos", "blockedUsers": "Utilizadores Bloqueados", "noGroups": "Sem grupos", "controlUsers": "Controle com que utilizadores não pretende conversar.", "blockedConversations": "Conversas Bloqueadas", "noBlockedUsers": "Nenhum utilizador bloqueado", "unblock": "Desbloquear", "noUsersBlocked": "Nenhum utilizador bloqueado", "noGroupsJoined": "Sem grupos aderidos", "controlGroups": "Controle que utilizadores do grupo podem entrar em contacto consigo, ativando ou desativando a sua disponibilidade para conversas abaixo. Pode receber mensagens apenas dos membros do grupo de que faz parte. " };
const payments$1 = { "shareLink": "Partilhar link", "paymentLink": "Link de pagamento" };
const profileSettings$1 = { "complete": "COMPLETO", "editBasicInformation": "Editar Informações Básicas", "writeAboutYourself": "Escreva algo sobre si...", "selectTimezone": "Selecione o fuso horário", "description": "Esta informação será mostrada no seu Perfil", "timezone": "Fuso horário", "enterLocation": "Introduza a Localização", "exampleDescription": "Modelo: Olá, sou Miguel Silva e sou fotógrafo", "enterABriefDescription": "Introduza uma breve descrição", "bio": "Biografia", "profileSlugNotAvailable": "Slug do Perfil Não Disponível", "findAndShareProfile": "Encontre e partilhe o seu perfil facilmente com um URL personalizado.", "profileSlug": "Slug do Perfil", "enterTitle": "Introduza um título", "enterFullName": "Introduza o Nome Completo", "basicDetails": "Detalhes básicos", "updateProfileDetails": "Atualize os detalhes do seu perfil aqui", "basicInformation": "Informações básicas", "updatedProfileSettings": "Configurações do Perfil atualizadas", "uploadStatusCode": "O carregamento falhou com o código de estado", "imageTypeNotSupported": "Tipo de imagem não suportado", "nameIsRequired": "O nome é necessário", "invalidName": "Nome inválido", "profileImage0": "Fotografia de Perfil", "profileImage": "Fotografia de Perfil", "uploadSvgPngJpg": "Carregue um SVG, PNG, JPG. Proporção de aspeto recomendada 1:1", "profilesBuildConnection": "Os perfis criam confiança e uma ligação com outras pessoas", "clientPortalNames": "O Portal do cliente parece estranho sem rostos nem nomes.", "completeYourProfile": "Complete o seu Perfil", "uploadFailed": "O carregamento falhou", "fileSizeTooLarge": "O tamanho do ficheiro é demasiado grande", "invalidFileFormatType": "Formato/Tipo de ficheiro inválido.", "pleaseUploadImage": "Carregue uma imagem do tipo SVG, PNG, JPG ou JPEG.", "pleaseUploadAFileLessThan100Mb": "Carregue um ficheiro com menos de 100 MB.", "oopsUnableToUploadImage": "Ups! Não foi possível carregar a imagem.", "selectPageError": "Tente novamente mais tarde", "search": "Pesquisar", "searchTimezones": "Pesquisar fusos horários", "noTimezonesFound": "Não foram encontrados fusos horários", "editDetails": "Editar detalhes", "profilePicture": "Fotografia de perfil", "profileCover": "Capa de perfil", "uploadPhoto": "Carregar fotografia", "removePhoto": "Remover fotografia", "invalidAspectRatio": "Proporção de aspeto inválida", "recommendedAspectRatio169": "Proporção de aspeto recomendada 16:9", "recommendedAspectRatio11": "Proporção de aspeto recomendada 1:1", "editProfile": "Editar Perfil", "manageYourGroupDetailsHere": "Faça a gestão dos detalhes do seu grupo aqui", "profileIcon": "Ícone de perfil", "specialCharactersNotSupported": "Não são suportados carateres especiais", "slugValidation": { "containSpecialCharacters": "Slug não pode conter Caráter especial", "tooShort": "Slug tem de ter pelo menos 3 Caráter de comprimento", "tooLong": "Slug tem de ter menos de 50 Caráter de comprimento", "containOnlyNumbers": "O Slug não pode conter apenas números", "startWithNumber": "O Slug não pode começar com um número", "startWithHyphen": "O Slug não pode começar com um hífen", "endWithHyphen": "Slug não pode Fim com um hífen", "containDoubleHyphen": "O Slug não pode conter hífens duplos", "containSpace": "Slug não pode conter Espaço" } };
const languageSettings$1 = { "title": "Configurações de língua", "detailsHere": "Selecionar a língua do Portal do Cliente", "selectLanguage": "Selecionar língua", "useLocationLanguage": "Utilizar Língua de Localização", "languagePreferenceUpdated": "Preferência de Língua Atualizada", "errorUpdatingLanguage": "Erro ao atualizar a Língua", "description": "Selecione a sua língua preferida para visualizar itens do Portal do cliente, conteúdo da comunidade, Cursos e Informações de Afiliado. Esta configuração permite-lhe visualizar o conteúdo na língua com a qual se sente mais à vontade. ", "shortDescription": "Selecione a sua Língua preferida" };
const userActivityOverview$1 = { "dustBunnies": "Não há nada para ver, só cotão.", "welcomeBanner": "Bem-vindo ao", "contracts": "Contratos", "hiUser": "Olá", "estimates": "Estimativas", "sharedFiles": "Ficheiros partilhados" };
const widget$1 = { "viewAll": "Ver tudo", "addedOn": "Adicionado Ativado", "by": "Via", "you": "utilizador", "admin": "Administrador", "youDoNotHaveAny": "Ainda não tem nenhum!", "noContracts": "Sem contratos", "maxFilesExceeded": "o utilizador só pode carregar até 10 Ficheiros", "uploadFile": "Carregar Ficheiro", "userActivityOverview.contracts": "Contratos", "selectPageError": "Tente novamente mais tarde", "notAbleToDownloadContract": "Não é possível descarregar o contrato", "completeCourse": "Curso Completo", "courseProgress": "Progresso do Curso", "viewAllGroups": "Ver todos os Grupos", "recentlyOpened": "Recentemente aberto", "noInvoices": "Sem faturas", "noEstimates": "Sem estimativas", "notAbleToDownloadInvoice": "Não foi possível descarregar a fatura", "contracts": "Contratos", "invoices": "Faturas", "youMarked": "Avaliou", "inCourse": "em curso", "invoice": "Fatura", "makePayment": "Efetuar Pagamento", "downloadInvoice": "Descarregar fatura", "viewGroup": "Ver Grupo", "payment": "Pagamento", "download": "Descarregar", "signContract": "Símbolos Negócio", "sign": "Símbolos", "estimates": "Estimativas", "notAbleToDownloadEstimate": "Não é possível descarregar a estimativa", "addFiles": "Adicionar Ficheiros", "sharedFiles": "Ficheiros partilhados", "fileManagement": "Gestão de Documentos", "noFiles": "Nenhum Ficheiros" };
const dashboard$1 = { "joinAGroup": "Registar-se num Grupo", "takeACourse": "Fazer um curso", "checkAffiliateEarnings": "Verificar ganhos de afiliados", "manageSubscriptions": "Gerir Assinaturas", "contracts": "Contratos", "estimates": "Estimativas", "sharedFiles": "Ficheiros partilhados", "paidOn": "Pago em", "partiallyPaidOn": "Parcialmente Pago em", "overdueSince": "vencido desde", "dueOn": "Devido em", "hello": "Olá", "viewGroup": "Ver Grupo", "recentlyOpened": "Recentemente aberto", "noItemsYet": "Ainda não tem nenhum!", "affiliates": "Afiliados", "exploreHere": "Explore aqui", "selectApp": "Selecione a sua aplicação", "exploreCourses": "Explore os cursos disponíveis", "courses": "Cursos", "engageCommunity": "Interagir com a comunidade", "communities": "Comunidades", "noDataAvailable": "Não há dados disponíveis no minuto", "noAppsAvailable": "Nenhuma aplicação disponível", "noWidgetsAvailable": "Sem widgets para Ecrã, visualização", "noContentAvailable": "Nenhum conteúdo disponível" };
const uploadDocument$1 = { "uploadHeader": "Adicionar Ficheiros", "uploadDescription": "Selecione e carregue até 10 ficheiros", "uploadWarning": "Isto estará visível para o Administrador do Portal para Ver e Descarregar", "uploadInstruction": "Clicar para carregar ou arrastar e largar", "allowedFiles": "DOC, PNG, JPG , GIF , PPT Ou PDF (Máximo. 100MB)", "cancelButton": "Cancelar", "uploadButton": "Carregar", "confirmDeletion": "Eliminação de Guardar", "deleteFile": "Eliminar Ficheiro", "deleteFileDescription": "O utilizador tem a certeza de que pretende eliminar este Ficheiro? Esta ação não pode ser anulada.", "deleteFileButton": "Sim, eliminar Ficheiro", "deleteFileSuccessTitle": "Ficheiro Eliminado com sucesso", "deleteFileErrorTitle": "Erro in eliminar o Ficheiro", "deleteFileErrorMessage": "Ocorreu um erro ao tentar eliminar o Ficheiro.", "cancel": "Anulado", "notAbleToDownloadFile": "Não é possível descarregar o Ficheiro", "fileSizeExceeded": "O tamanho do ficheiro exceder 100 MB", "invalidFileType": "Inválido Ficheiro Tipo", "notAbleToUploadFile": "Não é possível carregar o Ficheiro", "downloadError": "Erro in descarregar Ficheiro", "fileUploadedSuccessfully": "Ficheiro carregado com sucesso", "fileDownloadedSuccessfully": "Ficheiro Descarregar com sucesso" };
const navbar$1 = { "hi": "Olá", "manageYourAccount": "Gerir a sua Conta", "logOut": "Terminar sessão", "affiliates": "Afiliados", "courses": "Cursos", "communities": "Comunidades" };
const mandatedInfoModal$1 = { "invalidFileFormat": "Formato/Tipo de ficheiro inválido.", "pleaseUploadImage": "Carregue uma imagem do tipo SVG, PNG, JPG, JPEG", "fileSizeTooLarge": "O tamanho do ficheiro é demasiado grande", "oopsUnableToUploadImage": "Ups! Não foi possível carregar a imagem.", "pleaseUploadFileLessThan100MB": "Carregue um ficheiro com menos de 100 MB", "pleaseTryAgainLater": "Tente novamente mais tarde", "completeYourProfile": "Complete o seu Perfil", "profilesBuildConnection": "Os perfis criam confiança e uma ligação com outras pessoas", "putAFaceToYourProfile": "Adicione uma foto ao seu perfil!", "uploadASVGPNGJPG": "Carregue um SVG, PNG, JPG.", "recommendedAspectRatio11": "Proporção de aspeto recomendada 1:1", "complete": "COMPLETO", "cropYourAvatar": "Cortar o seu avatar", "dragToReposition": "Arrastar para reposicionar" };
const sideBar$1 = { "languageSettings": "Configurações de língua", "profile": "Perfil", "account": "Conta", "socialMedia": "Redes sociais", "certificates": "Certificados", "billingSubscription": "Faturação e Assinatura", "communitiesChats": "Comunidades e Chats", "affiliates": "Afiliados", "notifications": "Lembrete" };
const notifications$1 = { "title": "Notificações", "all": "Todos", "unread": "Não lido", "markAllRead": "Marcar tudo como lido", "noNotifications": "Ainda sem notificações", "whenYouGetNotifications": "Quando receber notificações, elas serão mostradas aqui" };
const affiliates$1 = { "payoutMethod": "Método de pagamento", "leadCustomer": "Oportunidades potenciais/ Clientes", "commissions": "Comissões", "description": "Encaminhe os Utilizadores para o GoKollab", "title": "Afiliados", "groupsGoKollab": "Criar grupos no GoKollab é completamente gratuito, mas isso é apenas o início! Novas funcionalidades empolgantes estão a caminho para ajudar a expandir o seu negócio online e aumentar os seus ganhos. À medida que os Utilizadores fazem upgrade para desbloquear o conjunto completo de Caraterísticas, receberá uma comissão de Afiliado Recorrente vitalícia sobre a Assinatura deles. Quanto mais cedo começar a fazer recomendações, melhor — não perca este incrível programa de afiliados", "yourAffiliateLink": "O seu link de afiliado" };
const deleteCard$1 = { "deleteCard": "Eliminar Cartão", "description": "O método de pagamento deixará de estar disponível após a sua remoção. Esta ação não pode ser anulada.", "activeCard": "Este cartão é utilizado para um ou mais pagamentos de assinaturas ativas. A eliminação deste cartão sem atualizar o método de pagamento para as assinaturas associadas vai afetar os pagamentos futuros. Tem a certeza de que pretende eliminar este cartão?", "title": "Remover método de pagamento?", "cardCannotBeDeleted": "Não é possível eliminar o cartão", "cardIsLinkedToSubscriptions": "O cartão está associado a assinaturas", "errorInDeletingCard": "Erro ao eliminar cartão", "noCardAvailable": "Nenhum cartão disponível", "cardRemovedSuccessfully": "Cartão removido com êxito" };
const notificationPreferences$1 = { "title": "Definições de notificação", "description": "Gerir Quando e para que utilizador são notificados", "pushNotificationsTitle": "push lembretete", "pushNotificationsDescription": "Gerir push Lembrete", "emailNotificationsTitle": "E-mail Lembrete", "emailNotificationsDescription": "Gerir E-mail Lembrete", "emailNotifications": "E-mail Lembrete", "manageEmailNotifications": "Gerir E-mail Lembrete", "newActivity": "novo Atividade", "email": "E-mail", "push": "Enviar", "allNotifications": "todos Lembrete", "postTags": "História Palavras-chave", "postEveryoneTagged": "História {'@'}Todos os Palavras-chave", "postMention": "História {'@'}Menção", "postLike": "História Gosto", "newComment": "novo Comentário", "commentEveryoneTagged": "Comentário {'@'}Todas as Palavras-chave", "commentMention": "Comentário {'@'}Menção", "commentLike": "Comentário Gosto", "postEveryoneTaggedMobile": "História {'@'}Todos os Palavras-chave", "postMentionMobile": "História {'@'}Menção", "commentEveryoneTaggedMobile": "Comentário {'@'}Todas as Palavras-chave", "commentMentionMobile": "Comentário {'@'}Menção", "newMemberRequestToJoinGroup": "novo Membros Pedidos para registar-se Grupo", "groupJoiningRequestApproved": "Grupo Aderir Pedidos Aceite", "groupJoiningRequestRejected": "Grupo Aderir Pedidos Negado", "roleUpdatedInPrivateChannel": "Função atualizada in canal Privado", "newCourseAvailable": "novo Curso Adicionado ao Grupo", "newEventCreated": "novo Evento Criado", "newCourseComment": "Comentário do novo curso", "certificateIssued": "Certificado Emitido", "postEveryoneTaggedDescription": "Quando alguém publica {'@'}Todas as Palavras-chave", "postMentionDescription": "Quando alguém publica {'@'}menção", "postLikeDescription": "Quando alguém Gosto da sua História", "newCommentDescription": "Quando alguém comentários Ativado a sua História", "commentEveryoneTaggedDescription": "Quando alguém comentários {'@'}Todos Palavras-chave", "commentMentionDescription": "Quando alguém faz comentários, {'@'}menção", "commentLikeDescription": "Quando alguém Gostos do seu comentário", "newMemberRequestToJoinGroupDescription": "Quando alguém Pedidos para registar-se o seu Grupo", "groupJoiningRequestApprovedDescription": "Quando o Grupo de alguém que adere a Pedidos é Aceite", "groupJoiningRequestRejectedDescription": "Quando o Grupo de alguém que adere a Pedidos é Negado", "roleUpdatedInPrivateChannelDescription": "Quando a função de alguém é Atualizado in canal Privado", "newCourseAvailableDescription": "Quando um novo curso está disponível", "newEventCreatedDescription": "Quando um novo Evento é Criado", "newCourseCommentDescription": "Quando alguém comentários Ativado um curso", "certificateIssuedDescription": "Quando um Certificado é Emitido", "estimateReceivedDescription": "Quando uma nova Estimativa é recebida", "contractReceivedDescription": "Quando um novo Negócio é Recebido", "invoiceReceivedDescription": "Quando a novo Fatura é recebido", "allEmailNotificationsDescription": "Inverter Ativado/Desativado todos E-mail Lembrete", "allPushNotificationsDescription": "Inverter Ativado/Desativado todos push Lembrete", "errorUpdating": "Lá foi um erro ao atualizar as suas definições de notificação", "updateSuccess": "As suas definições de notificação foram atualizadas", "willNotReceiveNotificationsIfAdminDisabled": "o utilizador não irá Herdar Lembrete para Definições Desativado Via o seu administrador.", "estimateReceived": "nova Estimativa Recebida", "contractReceived": "novo Negócio Recebido", "invoiceReceived": "novo Fatura Recebida", "pushNotificationNotAvailable": "A notificação push não está disponível para este evento", "newsletter": "Newsletter", "emailNotificationNotAvailable": "A notificação por Email não está disponível para este Evento", "newPostFollowers": "Novo Partilhar de Utilizador Seguido", "newPostFollowersDescription": "Seja notificado quando alguém que você segue cria uma nova publicação.", "newFollower": "Seja notificado quando alguém o Seguir." };
const loginPage$1 = { "forgotPassword": "Esqueceu a senha?", "login": "Iniciar sessão", "lastLogin": "última sessão", "proceedToLogin": "Prosseguir para o Iniciar sessão", "secureCode": "Código de segurança", "newUser": "Utilizador novo?", "resetPasswordLink": "Se o e-mail introduzida estiver correto, o utilizador irá Herdar uma password Ligar, vincular in e-mail. Certifique-se de que marca de verificação as pastas de spam também.", "loginWithSecureCode": "Inicie a sessão com Código protegido", "signUp": "Inscrever-se", "enterOtp": "Insira OTP", "selectAccount": "selecionar qual Conta utilizador deseja", "resetPassword": "Repor palavra-passe", "selectUser": "Selecionar Utilizador", "emailRequired": "Insira um e-mail válido", "fullNameRequired": "Introduza o seu nome", "passwordRequired": "Insira uma password de Mínimo 8 Caráter", "generateSecureCode": "Gerar Código protegido", "loginWithPassword": "Iniciar sessão com palavra-passe", "secureCodeEmail": "Marque de verificação o seu e-mail para o código seguro. O utilizador não Herdar nenhum e-mail De nós,", "resendOtp": "clique aqui para Reenviar.", "verifySecureCode": "Verificar Código protegido", "secureCodeNumeric": "O Código protegido deve ser um valor numérico e deve ter de 6 dígitos", "alreadyHaveAccount": "Já tem uma Conta?", "email": "E-mail", "password": "Senha", "fullName": "Nome Completo", "somethingWentWrong": "Algo correu mal.", "signInWithEmail": "Ou entre com o seu e-mail", "signUpWithEmail": "Ou inscreva-se com o seu e-mail", "confirmPassword": "Confirmar palavra-passe", "validationErrors": { "potentialSpamUser": { "title": "Conta Privado", "message": "A sua Conta foi Privado Devido a uma potencial atividade de spam. Contacte o serviço de apoio para obter assistência." }, "somethingWentWrong": { "title": "Algo correu mal.", "message": "Não é possível iniciar sessão. Por favor, tentar novamente mais tarde." }, "bannedUser": { "title": "Conta Privado", "message": "A sua Conta foi Banido Devido a uma atividade potencial de spam. Contacte o serviço de apoio para obter assistência." } } };
const magicLink$1 = { "newLinkSent": "novo Ligar, vincular enviado", "portalWillSendLink": "Portal irá Carregar um novo Ligar, vincular ao seu Endereço de e-mail", "failedToSendNewLink": "Falha ao carregar o novo Ligar, vincular", "pleaseTryAgain": "Por favor, tentar novamente", "linkExpired": "Este Ligar, vincular De seu e-mail tem Expirado.", "toContinue": "Para Continuar, Pedidos a novo Ligar, vincular Ou Inicie in no seu Portal Conta", "sendNewLink": "Carregar novo Ligar, vincular", "logIn": "insessão", "clickToLogIn": "clicar aqui para Inicie in no seu Portal Conta", "invalidToken": "Este Token do seu e-mail não é válido.", "toContinueContactAdmin": "Para Continuar, Pedidos a nova Ligação mágica Contacto Administrador Ou Inicie in no seu Portal Conta" };
const setPassword$1 = { "minLength": "Insira uma password de Mínimo 8 Caráter", "passwordsMustMatch": "As palavra-passe devem corresponder", "setSecurePassword": "Coleção a sua passwordsegura", "setPasswordButton": "Senha de Coleção" };
const alerts$1 = { "tooManyAttempts": { "title": "Demasiadas tentativas", "message": "Não são permitidos mais de 2 tentativas de atualização do Slug in Janela de Mês" }, "slugAlreadyExists": { "title": "O Slug já existe", "message": "Tente um Slug diferente" }, "updateSlugError": { "title": "Algo correu mal.", "message": "Não é possível atualizar o Perfil Slug. Por favor, tente Depois de alguns Dados" }, "updateProfileError": { "title": "Algo correu mal.", "message": "Não é possível atualizar o Perfil Detalhes. Por favor, tente Depois de alguns Dados" } };
const bottomNavBar$1 = { "home": "Início", "discover": "Descobrir", "communities": "Comunidades", "courses": "Cursos", "more": "Mais" };
const forceUpdate$1 = { "title": "novo A ATtualização está disponível", "description": "Atualize a sua aplicação para a versão mais recente", "buttonText": "Atualizar agora!" };
const accessibility$1 = { "copyAffiliateLink": "Copiar Afiliado Ligar, vincular para a área de transferência", "deleteCard": "Eliminar cartão", "appSwitcher": "Comutador de Aplicações", "portalImage": "Imagem do Portal", "profileImage": "Imagem de Perfil", "continueWithGoogle": "Continuar com o Google" };
const resetPassword$1 = { "passwordExpired": "A sua password Denunciar Ligar, vincular tem Expirado.", "regenerateLink": "Regerar Ligar, vincular", "proceedToLogin": "Prosseguir para o Iniciar sessão", "passwordChangedSuccessfully": "Palavra-passe Dinâmico com sucesso", "changePassword": "Alterar palavra-passe", "newPassword": "Insira uma password de Mínimo 8 Caráter", "confirmPassword": "A confirmação password não corresponde", "setNewPassword": "Coleção nova Palavra-passe", "confirmNewPassword": "Confirmar nova palavra-passe" };
const ptPT = {
  common: common$1,
  account: account$1,
  wallet: wallet$1,
  support: support$1,
  social: social$1,
  validation: validation$1,
  forms: forms$1,
  auth: auth$1,
  billing: billing$1,
  transactions: transactions$1,
  cancelModal: cancelModal$1,
  certificates: certificates$1,
  changePassword: changePassword$1,
  deleteAccount: deleteAccount$1,
  chats: chats$1,
  payments: payments$1,
  profileSettings: profileSettings$1,
  languageSettings: languageSettings$1,
  userActivityOverview: userActivityOverview$1,
  widget: widget$1,
  dashboard: dashboard$1,
  uploadDocument: uploadDocument$1,
  navbar: navbar$1,
  mandatedInfoModal: mandatedInfoModal$1,
  sideBar: sideBar$1,
  notifications: notifications$1,
  affiliates: affiliates$1,
  deleteCard: deleteCard$1,
  notificationPreferences: notificationPreferences$1,
  loginPage: loginPage$1,
  magicLink: magicLink$1,
  setPassword: setPassword$1,
  alerts: alerts$1,
  bottomNavBar: bottomNavBar$1,
  forceUpdate: forceUpdate$1,
  accessibility: accessibility$1,
  resetPassword: resetPassword$1
};
const common = { "show": "Visa", "newPost": "Nytt inlägg", "active": "Aktiv", "change": "Ändra", "remove": "Ta bort", "cancel": "Avbryt", "publish": "Publicera", "save": "Spara", "draft": "Utkast", "scheduled": "Schemalagd", "published": "Publicerad", "actions": "Åtgärder", "archive": "Arkivera", "delete": "Radera", "edit": "Redigera", "settings": "Inställningar", "updatedOn": "Uppdaterad den", "blogPost": "Blogginlägg", "category": "Kategori", "author": "Författare", "status": "Status", "errors": "Fel", "error": "Fel", "all": "Alla", "add": "Lägg till", "discussion": "Diskussion", "allCourses": "Alla kurser", "myCourses": "Mina kurser", "learning": "Utbildning", "leaderboard": "Topplista", "documentsAndPayments": "Dokument- och filhantering", "more": "Mer", "profile": "Profil", "archived": " Arkiverad", "back": "Tillbaka", "restore": "Återställ den här versionen", "next": "Nästa", "previous": "Föregående", "continue": "Fortsätt", "details": "Detaljer", "youtube": "YouTube", "action": "Åtgärd", "view": "Visa", "download": "Ladda ner", "source": "Källa", "title_column": "Titel", "copy": "Kopiera", "viewReceipt": "Visa kvitto", "id": "ID", "location": "Plats", "email": "E-post", "title": "Titel", "logout": "Logga ut", "login": "Login", "calender": "Kalender", "apply": "Tillämpa", "clear": "Rensa", "to": "Till", "from": "Från", "type": "Typ", "home": "Hem", "description": "Description", "updated": "Uppdaterad", "networkError": { "title": "Ingen internetanslutning", "message": "Kontrollera din internetanslutning och försök igen." } };
const account = { "settings": "Kontoinställningar", "updateSettings": "Uppdatera dina kontoinställningar här", "paymentDetails": "Betalningsuppgifter", "orderId": "Internt beställnings-ID", "nextInvoice": "Nästa faktura", "transactionDate": "Transaktionsdatum", "expiryDate": "Utgångsdatum", "manageAllSubscription": "Hantera alla dina abonnemang", "paymentMethod": "Betalningsmetod", "andTransactionHere": "& transaktion här" };
const wallet = { "transactionId": "Transaktions-ID" };
const support = { "subscriptionId": "Abonnemangs-ID", "email": { "validation": "Ange giltig e-postadress" }, "invoiceNo": "Fakturanummer" };
const social = { "title": "Sociala medier", "invalidURL": "Ogiltig URL", "phoneNumber": "Telefonnummer", "userPhone": "Användarens telefon", "userEmail": "Användarmejl", "info": "Social information", "update": "Uppdatera information för sociala medier", "detailsHere": "Uppdatera dina uppgifter för sociala medier här", "updated": "Sociala medier uppdaterade", "visibility": "Offentligt synlig", "validUrl": "Ange en giltig URL", "validEmail": "Ange en giltig e-postadress", "validPhoneNumber": "Ange ett giltigt telefonnummer med en lämplig landskod", "platforms": { "twitter": "Twitter", "instagram": "Instagram", "facebook": "Facebook", "youtube": "YouTube", "linkedin": "LinkedIn" } };
const validation = { "phone": "Ange ett giltigt telefonnummer", "url": "Ange en giltig URL" };
const forms = { "phone": "Telefonnummer" };
const auth = { "clickToResend": "Klicka för att skicka igen", "authentication": "Autentisering", "didntGetCode": "Fick du ingen kod?", "confirmationCode": "Bekräftelsekod", "sentVerificationEmail": "Vi har skickat en verifieringskod via e-post till", "authenticateAccount": "Autentisera ditt konto", "incorrectOrExpired": "OTP är ogiltig eller har gått ut", "failedToSend": "Det gick inte att skicka OTP", "checkEmailForSecureCode": "Kolla efter säkerhetskoden på din e-post. Om du inte har fått ett mejl från oss,", "user": "Användare", "verify": "Verifiera", "tapHereToResend": "tryck här för att skicka igen.", "failedToVerifyOtp": "Det gick inte att verifiera OTP", "failedToGetOtp": "Det gick inte att hämta OTP" };
const billing = { "endingIn": "slutar på", "billingInformation": "Faktureringsuppgifter", "billingAddress": "Faktureringsadress:", "sourceType": "Typ av källa :", "invoices": "Fakturor", "subscription": "Abonnemang", "transactions": "Transaktioner", "transaction": "Transaktion", "subscriptions": "Abonnemang", "invoiceName": "Fakturanamn", "subscriptionName": "Abonnemangsnamn", "dueDate": "Förfallodatum", "issueDate": "Datum för utfärdande", "amount": "Antal", "manageSubscriptions": "Hantera alla dina abonnemang", "andSubscription": "& Abonnemang", "andTransaction": "& transaktion här", "billing": "Fakturering", "startDate": "Startdatum", "fullName": "Fullständigt namn", "nextInvoiceOn": "Nästa faktura den", "noDataFound": "Inga data hittades", "invoiceNo": "Fakturanummer:", "manageSubscriptionsInvoicesAndTransactions": "Hantera abonnemang, fakturor och transaktioner", "created": "Skapad:", "transactionName": "Transaktionsnamn", "tid": "Tid:", "transactionDate": "Transaktionsdatum:", "trial": "Provperiod", "expired": "Utgått", "pastDue": "Förfallen", "unpaid": "Obetald", "incompleteExpired": "Ofullständig och har löpt ut", "canceled": "Avbokad", "incomplete": "Ofullständig", "failed": "Misslyckad", "sent": "Skickat", "paid": "Betald", "paymentProcessing": "Betalningen behandlas", "partiallyPaid": "Delvis betald", "overdue": "Förfallna", "succeeded": "Lyckades", "processing": "Behandlar", "refunded": "Återbetald", "pending": "Väntande", "membership": "Medlemskap", "communities": "Communities", "paymentLink": "Betalningslänk", "expiresOn": "Utgår den", "errorFetchingPaymentMethods": "Fel vid hämtning av betalningsmetoder", "pageUrl": "Sida URL" };
const transactions = { "title": "Transaktioner", "name": "Transaktionsnamn" };
const cancelModal = { "subscriptionRenewNotice": "Om du ändrar dig kan du när som helst förnya ditt abonnemang.", "cancelSubscription": "Annullera abonnemang", "subscriptionCancelNotice": "kommer att annulleras omedelbart. Du kommer inte att debiteras igen.", "yourPlanName": "Ditt abonnemang", "currentPlan": "Nuvarande abonnemang", "subscriptionCancelError": "Ett fel inträffade när du försökte annullera abonnemanget.", "cancelSubscriptionFailed": "Det gick inte att annullera abonnemanget" };
const certificates = { "title": "Certifikat", "certificatesDescription": "Ladda ner & Dela-certifikat Du har tjänat in.", "subtitle": "Ladda ner dina certifikat", "completedOn": "Klar På", "back": "Tillbaka", "previous": "Föregående", "next": "Nästa", "downloadYourCertificates": "Ladda ner dina certifikat", "downloadCertificate": "Ladda ner {type}", "viewCertificates": "Visa och ladda ner alla dina certifikat här", "certificateNotFound": "Inget certifikat hittades", "issuedOn": "Utfärdade På", "expiresOn": "Går ut På", "description": "Beskrivning", "yourCertificateHasExpiredOn": "Din {type} har Utgått På", "issuedCertificatesNotFound": "Du har inte tjänat några certifikat än.", "shareCertificate": "Dela:", "preview": { "issuedTo": "Utfärdat till", "issuedBy": "Utfärdat av", "addToLinkedin": "Lägg till i LinkedIn-profilen", "download": "Ladda ner", "credentialVerification": "Verifiering av referenser", "issueDate": "Datum för utfärdande", "expiryDate": "Utgångsdatum", "verifyCredential": "Verifiera autentiseringsuppgifter", "shareYourCredential": "Dela dina inloggningsuppgifter", "showYourCredential": "Visa dina referenser på dina sociala medier", "expiredOn": "Utgick den", "expiredDesc": "Det är dags att förnya och hålla sig uppdaterad. Missa inte fortsatta fördelar och Potentiella kunder.", "verificationModal": { "title": "Verifiering av referenser", "subtitle": "Detta är den giltiga referensen.", "description": " Denna legitimation utfärdades säkert. All information som visas är giltig.", "step1": { "title": "Verifierar mottagaren", "description": "Ägaren av denna behörighet är {recipient}" }, "step2": { "title": "Verifierar emittenten", "description": "Denna inloggningsuppgift utfärdades av  {issuer}" }, "step3": { "title": "Verifiera autentiseringsuppgiftens ID", "description": "Etiketten {credentialId} är unik och giltig." } }, "notFound": { "title": "Hoppsan! Certifikatet hittades inte", "description": "Certifikatet som ni försöker visa är inte tillgängligt.", "subtitle": "Kontakta utgivaren för att få hjälp." } }, "share": { "title": "Ditt Certifikat", "text": "här är ditt certifikat", "dialogTitle": "Dela Eller Arkivera ditt Certifikat" }, "listing": { "courseAssignmentName": "Namn på kursen/Uppgift", "offlineCertification": "Offline-certifiering", "completionDate": "Slutdatum", "expiryDate": "Utgångsdatum", "type": "Typ", "sourceName": "Källa Namn", "action": "Åtgärd" } };
const changePassword = { "showPasswords": "Visa lösenord", "retypePassword": "Skriv in lösenordet igen", "newPassword": "Nytt lösenord", "confirmNewPassword": "Confirm New Password", "currentPassword": "Nuvarande lösenord", "emailId": "ID för e-post", "passwordMinLength": "Ange ett lösenord med minst 8 tecken", "editAccount": "Redigera konto", "loginEmail": "Inloggningsmejl", "loginInformation": "Inloggningsinformation", "accountDetails": "Kontodetaljer", "accountDetailsUpdate": "Uppdatera dina kontouppgifter här", "accountInformation": "Kontoinformation", "changePassword": "Ändra lösenord", "hidePasswordChange": "Dölj Ändra lösenord", "selectPageError": "Försök igen senare", "systemErrorOccurred": "Något gick fel", "passwordEntryInvalid": "Ogiltigt lösenord", "passwordUpdateSuccess": "Lösenordet har uppdaterats", "passwordLengthRequired": "Ange ett lösenord med minst 8 tecken", "passwordMinimumLength": "Ange ett lösenord med minst 8 tecken", "passwordFieldRequired": "Lösenord krävs", "password": "Lösenord" };
const deleteAccount = { "title": "Radera Konto", "deleteAccountDescription": "Ditt konto är Schemalagd för tillfällig avaktivering och kommer att vara permanent Raderad Om Du loggar inte in inom de Nästa 7 dagarna.", "deleteAccountDescription2": "För att Behålla ditt Konto Dynamisk loggar du bara in innan deadline. När Raderad har gått kan din data inte återställas.", "deleteAccountButton": "Ja, Radera Konto" };
const chats = { "viewAll": "Visa alla", "viewLess": "Visa mindre", "updatedPreference": "Uppdaterade inställningar", "chatSettings": "Chattinställningar", "chats": "Chattar", "chatSettingsDescription": "Välj chattinställningar för dina grupper och kontakter", "groups": "Grupper", "blockedUsers": "Blockerade användare", "noGroups": "Inga grupper", "controlUsers": "Hantera vilka användare du inte vill chatta med.", "blockedConversations": "Blockerade konversationer", "noBlockedUsers": "Inga blockerade användare", "unblock": "Avblockera", "noUsersBlocked": "Inga användare är blockerade", "noGroupsJoined": "Har inte gått med i några grupper", "controlGroups": "Hantera vilka gruppanvändare som kan kontakta dig genom att aktivera eller inaktivera din chatt-tillgänglighet nedan. Du kan endast ta emot meddelanden från medlemmar i gruppen du är med i. " };
const payments = { "shareLink": "Dela länk", "paymentLink": "Betalningslänk" };
const profileSettings = { "complete": "SLUTFÖR", "editBasicInformation": "Redigera grundläggande information", "writeAboutYourself": "Skriv något om dig själv ...", "selectTimezone": "Välj tidszon", "description": "Detta kommer att visas på din profil", "timezone": "Tidszon", "enterLocation": "Ange plats", "exampleDescription": "Exempel: Hej, jag heter Johan Svensson och jag är fotograf", "enterABriefDescription": "Ange en kort beskrivning", "bio": "Biografi", "profileSlugNotAvailable": "Profilens slug inte tillgänglig", "findAndShareProfile": "Hitta och dela enkelt din profil med en personlig URL-slug.", "profileSlug": "Profilens slug", "enterTitle": "Ange en titel", "enterFullName": "Ange fullständigt namn", "basicDetails": "Grundläggande information", "updateProfileDetails": "Uppdatera dina profiluppgifter här", "basicInformation": "Grundläggande information", "updatedProfileSettings": "Uppdaterade profilinställningar", "uploadStatusCode": "Uppladdningen misslyckades med statuskod", "imageTypeNotSupported": "Bildtyp stöds inte", "nameIsRequired": "Namn krävs", "invalidName": "Ogiltigt namn", "profileImage0": "Profilbild", "profileImage": "Profilbild", "uploadSvgPngJpg": "Ladda upp en SVG, PNG, JPG. Rekommenderat bildförhållande 1:1", "profilesBuildConnection": "Profiler inger förtroende och skapar kontakt med andra", "clientPortalNames": "Kundportalen känns konstig utan ansikten och namn.", "completeYourProfile": "Slutför din profil", "uploadFailed": "Uppladdningen misslyckades", "fileSizeTooLarge": "Filstorleken är för stor", "invalidFileFormatType": "Ogiltigt filformat/-typ.", "pleaseUploadImage": "Ladda upp en bild med formaten SVG, PNG, JPG eller JPEG.", "pleaseUploadAFileLessThan100Mb": "Ladda upp en fil som är mindre än 100 MB.", "oopsUnableToUploadImage": "Hoppsan! Det gick inte att ladda upp bilden.", "selectPageError": "Försök igen senare", "search": "Sök", "searchTimezones": "Sök efter tidszoner", "noTimezonesFound": "Inga tidszoner hittades", "editDetails": "Redigera detaljer", "profilePicture": "Porträttbild", "profileCover": "Profilomslag", "uploadPhoto": "Ladda upp foto", "removePhoto": "Ta bort foto", "invalidAspectRatio": "Ogiltigt bildförhållande", "recommendedAspectRatio169": "Rekommenderat bildförhållande 16:9", "recommendedAspectRatio11": "Rekommenderat bildförhållande 1:1", "editProfile": "Redigera profil", "manageYourGroupDetailsHere": "Hantera din gruppinformation här", "profileIcon": "Profilikon", "specialCharactersNotSupported": "Specialtecken stöds ej", "slugValidation": { "containSpecialCharacters": "Slug kan inte innehålla speciell Tecken", "tooShort": "Slug måste vara minst 3 Tecken lång", "tooLong": "Slug måste vara mindre än 50 Tecken lång", "containOnlyNumbers": "Slug kan inte bara innehålla siffror", "startWithNumber": "Slug kan inte börja med en siffra", "startWithHyphen": "Slug kan inte börja med ett bindestreck", "endWithHyphen": "Slug kan inte Sluta med ett bindestreck", "containDoubleHyphen": "Slug kan inte innehålla dubbla bindestreck", "containSpace": "Slug kan inte innehålla Yta" } };
const languageSettings = { "title": "Språkinställningar", "detailsHere": "Välj språk för kundportalen", "selectLanguage": "Välj språk", "useLocationLanguage": "Använd Plats Språk", "languagePreferenceUpdated": "Språkinställningar har uppdaterats", "errorUpdatingLanguage": "Fel vid uppdatering av språk", "description": "Välj ditt föredragna språk som visas i kundportalen, communityinnehåll, kurser och partnerinformation. Med den här inställningen kan du se innehåll på det språk som du är mest bekväm med. ", "shortDescription": "Välj ert föredragna språk" };
const userActivityOverview = { "dustBunnies": "Inget att se, om du inte är intresserad av dammråttor.", "welcomeBanner": "Välkommen till", "contracts": "Avtal", "hiUser": "Hej", "estimates": "Uppskattningar", "sharedFiles": "Delade Filer" };
const widget = { "viewAll": "Visa alla", "addedOn": "Tillagd på", "by": "Via", "you": "Du", "admin": "Admin", "youDoNotHaveAny": "Du har inga!", "noContracts": "Inga avtal", "maxFilesExceeded": "Du kan endast ladda upp upp till 10 Filer", "uploadFile": "Ladda upp Fil", "userActivityOverview.contracts": "Avtal", "selectPageError": "Försök igen senare", "notAbleToDownloadContract": "Det går inte att ladda ner avtalet", "completeCourse": "Slutför kurs", "courseProgress": "Kursframsteg", "viewAllGroups": "Visa alla grupper", "recentlyOpened": "Nyligen öppnade", "noInvoices": "Inga fakturor", "noEstimates": "Inga uppskattningar", "notAbleToDownloadInvoice": "Det går inte att ladda ner fakturan", "contracts": "Avtal", "invoices": "Fakturor", "youMarked": "Du markerade", "inCourse": "i kurs", "invoice": "Faktura", "makePayment": "Gör betalning", "downloadInvoice": "Ladda ner faktura", "viewGroup": "Visa grupp", "payment": "Betalning", "download": "Ladda ner", "signContract": "Symboler Avtal", "sign": "Symboler", "estimates": "Uppskattningar", "notAbleToDownloadEstimate": "Det går inte att ladda ner uppskattningen", "addFiles": "Lägg till Filer", "sharedFiles": "Delade Filer", "fileManagement": "Fil", "noFiles": "Inga Filer" };
const dashboard = { "joinAGroup": "Gå med i en grupp", "takeACourse": "Gå en kurs", "checkAffiliateEarnings": "Kontrollera partnerintäkter", "manageSubscriptions": "Hantera abonnemang", "contracts": "Kontrakt", "estimates": "Uppskattningar", "sharedFiles": "Delade Filer", "paidOn": "Betald den", "partiallyPaidOn": "Delvis betald den", "overdueSince": "Förfallen sedan", "dueOn": "Förfaller den", "hello": "Hej", "viewGroup": "Visa grupp", "recentlyOpened": "Nyligen öppnade", "noItemsYet": "Du har inga än!", "affiliates": "Partners", "exploreHere": "Utforska här", "selectApp": "Välj din app", "exploreCourses": "Utforska de tillgängliga kurserna", "courses": "Kurser", "engageCommunity": "Engagera dig i communityn", "communities": "Communities", "noDataAvailable": "Inga uppgifter tillgängliga per minut", "noAppsAvailable": "Inget Appar tillgängligt", "noWidgetsAvailable": "Inga widgetar till Visning", "noContentAvailable": "Inget Innehåll tillgängligt" };
const uploadDocument = { "uploadHeader": "Lägg till Filer", "uploadDescription": "Välj och ladda upp max 10 dokument", "uploadWarning": "Detta kommer att vara synligt för Portal Admin till Visa och Laddaner", "uploadInstruction": "Klicka för att ladda upp eller dra och släpp", "allowedFiles": "DOC, PNG, JPG , GIF , PPT Eller PDF (Max. 100 MB)", "cancelButton": "Avbryt", "uploadButton": "Ladda upp", "confirmDeletion": "Radering av Spara", "deleteFile": "Radera Fil", "deleteFileDescription": "Är du säker på att du vill ta bort den här filen? Denna Åtgärd kan inte ångras.", "deleteFileButton": "Ja, Radera Fil", "deleteFileSuccessTitle": "Fil Raderad raderats", "deleteFileErrorTitle": "Fel in Raderar Fil", "deleteFileErrorMessage": "Ett fel inträffade när jag försökte radera filen.", "cancel": "Annullera", "notAbleToDownloadFile": "Kan inte Ladda ner Fil", "fileSizeExceeded": "Fil Storlek överstiger 100 MB", "invalidFileType": "Ogiltig Fil Typ", "notAbleToUploadFile": "Kan inte Ladda upp Fil", "downloadError": "Fel in Ladda ner Fil", "fileUploadedSuccessfully": "Fil har laddats upp", "fileDownloadedSuccessfully": "Fil Ladda ner har lyckats" };
const navbar = { "hi": "Hej", "manageYourAccount": "Hantera ditt konto", "logOut": "Logga ut", "affiliates": "Partners", "courses": "Kurser", "communities": "Communities" };
const mandatedInfoModal = { "invalidFileFormat": "Ogiltigt filformat/-typ.", "pleaseUploadImage": "Ladda upp en bild med formaten SVG, PNG, JPG, JPEG", "fileSizeTooLarge": "Filstorleken är för stor", "oopsUnableToUploadImage": "Hoppsan! Det gick inte att ladda upp bilden.", "pleaseUploadFileLessThan100MB": "Ladda upp en fil som är mindre än 100 MB", "pleaseTryAgainLater": "Försök igen senare", "completeYourProfile": "Slutför din profil", "profilesBuildConnection": "Profiler inger förtroende och skapar kontakt med andra", "putAFaceToYourProfile": "Sätt ett ansikte på din profil!", "uploadASVGPNGJPG": "Ladda upp en SVG, PNG, JPG.", "recommendedAspectRatio11": "Rekommenderat bildförhållande 1:1", "complete": "SLUTFÖR", "cropYourAvatar": "Beskär din avatar", "dragToReposition": "Dra för att flytta" };
const sideBar = { "languageSettings": "Språkinställningar", "profile": "Profil", "account": "Konto", "socialMedia": "Sociala medier", "certificates": "Certifikat", "billingSubscription": "Fakturering & Abonnemang", "communitiesChats": "Gemenskaper och chattar", "affiliates": "Partners", "notifications": "Påminnelse" };
const notifications = { "title": "Aviseringar", "all": "Alla", "unread": "Oläst", "markAllRead": "Markera alla som lästa", "noNotifications": "Inga aviseringar än", "whenYouGetNotifications": "När du får aviseringar visas de här" };
const affiliates = { "payoutMethod": "Utbetalning", "leadCustomer": "Potentiella kunder/ Kunder", "commissions": "Provisioner", "description": "Hänvisa användare till GoKollab", "title": "Partners", "groupsGoKollab": "Att skapa grupper på GoKollab är helt gratis, men det är bara början! Spännande nya funktioner är på väg som kommer hjälpa dig att utöka din onlineverksamhet och höja intäkterna. När användare uppgraderar för att låsa upp hela funktionspaketet kommer du att få en livslång återkommande partnerprovision på deras abonnemang. Ju tidigare du börjar värva, desto bättre – missa inte det här otroliga partnerprogrammet", "yourAffiliateLink": "Din partnerlänk" };
const deleteCard = { "deleteCard": "Radera kort", "description": "Betalningsmetoden kommer inte att kunna användas efter att den har tagits bort. Åtgärden kan inte ångras.", "activeCard": "Detta kort används för en eller flera aktiva abonnemangsbetalningar. Om du tar bort det här kortet utan att uppdatera betalningsmetoden för de associerade abonnemangen kommer det att påverka framtida betalningar. Är du säker på att du vill radera det här kortet?", "title": "Ta bort betalningsmetod?", "cardCannotBeDeleted": "Kortet kan inte raderas", "cardIsLinkedToSubscriptions": "Kortet är kopplat till abonnemang", "errorInDeletingCard": "Fel vid radering av kort", "noCardAvailable": "Inget kort är tillgängligt", "cardRemovedSuccessfully": "Kortet har raderats" };
const notificationPreferences = { "title": "Avisering Inställningar", "description": "Hantera När och vad Du får besked för", "pushNotificationsTitle": "Push Påminnelse", "pushNotificationsDescription": "Hantera push Påminnelse", "emailNotificationsTitle": "E-post Påminnelse", "emailNotificationsDescription": "Hantera E-post Påminnelse", "emailNotifications": "E-post Påminnelse", "manageEmailNotifications": "Hantera E-post Påminnelse", "newActivity": "Ny Aktivitet", "email": "E-post", "push": "Tryck", "allNotifications": "varje Påminnelse", "postTags": "Story Nyckelord", "postEveryoneTagged": "Story {'@'}Alla Nyckelord", "postMention": "Omnämnande av Story {'@'}", "postLike": "Story Gilla", "newComment": "Ny kommentar", "commentEveryoneTagged": "Kommentera {'@'}Alla Nyckelord", "commentMention": "Kommentera {'@'}Nämn", "commentLike": "Kommentera Gilla", "postEveryoneTaggedMobile": "Story {'@'}Alla Nyckelord", "postMentionMobile": "Omnämnande av Story {'@'}", "commentEveryoneTaggedMobile": "Kommentera {'@'}Alla Nyckelord", "commentMentionMobile": "Kommentera {'@'}Nämn", "newMemberRequestToJoinGroup": "Ny Medlemmar Förfrågningar att gå med Grupp", "groupJoiningRequestApproved": "Grupp Joining Förfrågningar Godkänd", "groupJoiningRequestRejected": "Grupp Går med i Förfrågningar Avböjde", "roleUpdatedInPrivateChannel": "Roll Uppdaterad in Privat Kanal", "newCourseAvailable": "Ny kurs har lagts till i Grupp", "newEventCreated": "Ny Händelse Skapad", "newCourseComment": "Ny kurskommentar", "certificateIssued": "Certifikat Utfärdade", "postEveryoneTaggedDescription": "När någon gör inlägg {'@'}Alla Nyckelord", "postMentionDescription": "När någon lägger upp {'@'}omnämnande", "postLikeDescription": "När någon Gilla-markeringar din Story", "newCommentDescription": "När någon feedback På din Story", "commentEveryoneTaggedDescription": "När någon feedback {'@'}Alla Nyckelord", "commentMentionDescription": "När någon feedback {'@'}nämns", "commentLikeDescription": "När någon Gilla-markeringar din kommentar", "newMemberRequestToJoinGroupDescription": "När någon Förfrågningar att gå med din Grupp", "groupJoiningRequestApprovedDescription": "När someone's Grupp joining Förfrågningar är Godkänd", "groupJoiningRequestRejectedDescription": "När någons Grupp går med i Förfrågningar är Avböjde", "roleUpdatedInPrivateChannelDescription": "När någons roll är Uppdaterad in en Privat kanal", "newCourseAvailableDescription": "När en Ny kurs är ledig", "newEventCreatedDescription": "När a Ny Händelse skapas", "newCourseCommentDescription": "När någon feedback På en kurs", "certificateIssuedDescription": "När a Certifikat är Utfärdade", "estimateReceivedDescription": "När a Ny Uppskattning är Mottagen", "contractReceivedDescription": "När a Ny Avtal är Mottagen", "invoiceReceivedDescription": "När a Ny Faktura är Mottagen", "allEmailNotificationsDescription": "Vänd På/Inaktiverad varje E-post Påminnelse", "allPushNotificationsDescription": "Vänd På/Inaktiverad varje push notifikationer", "errorUpdating": "Där uppstod ett fel när din Avisering Inställningar skulle uppdateras", "updateSuccess": "Din Avisering Inställningar har Uppdaterad", "willNotReceiveNotificationsIfAdminDisabled": "Du won't Ärv Påminnelse för Inställningar Inaktiverad Via din administratör.", "estimateReceived": "Ny Uppskattning Mottagen", "contractReceived": "Ny Avtal Mottagen", "invoiceReceived": "Ny Faktura Mottagen", "pushNotificationNotAvailable": "Pushnotis finns inte tillgänglig för denna Händelse", "newsletter": "Nyhetsbrev", "emailNotificationNotAvailable": "Email-avisering är inte tillgänglig för denna Händelse", "newPostFollowers": "Nytt inlägg från en Användare som ni Följ", "newPostFollowersDescription": "Få en notifikation när någon du följer skapar ett nytt inlägg.", "newFollower": "Få en avisering när någon följer dig." };
const loginPage = { "forgotPassword": "Glömt lösenordet?", "login": "Logga in", "lastLogin": "senaste Logga in", "proceedToLogin": "Fortsätt till Logga in", "secureCode": "Säker Kod", "newUser": "Ny Användare?", "resetPasswordLink": "Om det angivna e-postmeddelandet är korrekt kommer Du att Ärv a Återställ password in e-postmeddelandet. Se till att blockera skräppostkartan också.", "loginWithSecureCode": "Logga in med säker Kod", "signUp": "Registrera dig", "enterOtp": "Ange engångslösenordet", "selectAccount": "Välj vilket Konto Du vill", "resetPassword": "Återställ lösenord", "selectUser": "Välj Användare", "emailRequired": "Vänligen ange ett giltigt e-inlägg", "fullNameRequired": "Vänligen ange ditt namn", "passwordRequired": "Vänligen ange ett password av Min 8 Tecken", "generateSecureCode": "Generera säker Kod", "loginWithPassword": "Logga in med lösenord", "secureCodeEmail": "Vänligen boka ditt e-postmeddelande för den säkra Kod. Om Du skrev inget e-postmeddelande från oss,", "resendOtp": "tap här till Skicka igen.", "verifySecureCode": "Verifiera säker Kod", "secureCodeNumeric": "Secure Kod måste vara en Numerisk Värde och vara på 6 siffror", "alreadyHaveAccount": "Har du redan ett konto?", "email": "E-post", "password": "Lösenord", "fullName": "Full Namn", "somethingWentWrong": "Något gick fel", "signInWithEmail": "Eller, logga in med ditt e-inlägg", "signUpWithEmail": "Eller registrera dig med din e-post", "confirmPassword": "Bekräfta lösenord", "validationErrors": { "potentialSpamUser": { "title": "Konto Privat", "message": "Ditt konto har varit Privat Utestående till potentiell spamaktivitet. Kontakta supporten för hjälp." }, "somethingWentWrong": { "title": "Något gick fel", "message": "Det gick inte att logga in. Försök igen senare." }, "bannedUser": { "title": "Konto Privat", "message": "Ditt konto har varit Bannlyst Utestående till potentiell spam Aktivitet. Kontakta supporten för hjälp." } } };
const magicLink = { "newLinkSent": "Ny Länk skickade", "portalWillSendLink": "Portal laddar upp en Ny länk till din e-postadress", "failedToSendNewLink": "Det Misslyckades att Ladda upp Ny Länk", "pleaseTryAgain": "Försök igen", "linkExpired": "Den här länken Från ditt e-inlägg har Utgått.", "toContinue": "To Fortsätt, Förfrågningar a Ny Länk Eller Logga in på ditt Portal", "sendNewLink": "Ladda upp Ny Länk", "logIn": "LOGGA in", "clickToLogIn": "klicka här för att Logga in på ditt Portal", "invalidToken": "Denna Token från ditt e-inlägg är inte giltig.", "toContinueContactAdmin": "För att Fortsätt, Förfrågningar a Ny Magisk länk Kontakt Admin Eller Logga in på ditt Portal" };
const setPassword = { "minLength": "Vänligen ange ett password av Min 8 Tecken", "passwordsMustMatch": "Lösenorden måste matcha", "setSecurePassword": "Samling av ditt säkra password", "setPasswordButton": "Samlinglösenord" };
const alerts = { "tooManyAttempts": { "title": "För många försök", "message": "Högst 2 försök för Slug -uppdatering är tillåtna in en Fönster av Månad" }, "slugAlreadyExists": { "title": "Slug finns redan", "message": "Försök med en annan Slug" }, "updateSlugError": { "title": "Något gick fel", "message": "Det gick inte att uppdatera Profil Slug. Försök med Efter some Datum" }, "updateProfileError": { "title": "Något gick fel", "message": "Det gick inte att uppdatera profildetaljer. Försök med Efter some Datum" } };
const bottomNavBar = { "home": "Hem", "discover": "Upptäck", "communities": "Communities", "courses": "Kurser", "more": "Mer" };
const forceUpdate = { "title": "Ny UPPDATERING FINNS", "description": "Uppdatera din applikation till den senaste Version", "buttonText": "Uppdatera nu!" };
const accessibility = { "copyAffiliateLink": "Kopiera Partner Länk till urklipp", "deleteCard": "Radera kort", "appSwitcher": "App Växlare", "portalImage": "Portal Bild", "profileImage": "Profil Bild", "continueWithGoogle": "Fortsätt med Google" };
const resetPassword = { "passwordExpired": "Ditt password Återställ Länk har Utgått.", "regenerateLink": "Återskapa Länk", "proceedToLogin": "Fortsätt till Logga in", "passwordChangedSuccessfully": "Lösenordsdynamiken har genomförts", "changePassword": "Ändra lösenord", "newPassword": "Vänligen ange ett password av Min 8 Tecken", "confirmPassword": "password stämmer inte", "setNewPassword": "Lösenord för Samling Ny", "confirmNewPassword": "Bekräfta Ny lösenord" };
const sv = {
  common,
  account,
  wallet,
  support,
  social,
  validation,
  forms,
  auth,
  billing,
  transactions,
  cancelModal,
  certificates,
  changePassword,
  deleteAccount,
  chats,
  payments,
  profileSettings,
  languageSettings,
  userActivityOverview,
  widget,
  dashboard,
  uploadDocument,
  navbar,
  mandatedInfoModal,
  sideBar,
  notifications,
  affiliates,
  deleteCard,
  notificationPreferences,
  loginPage,
  magicLink,
  setPassword,
  alerts,
  bottomNavBar,
  forceUpdate,
  accessibility,
  resetPassword
};
function getLocalePreference() {
  var _a, _b, _c;
  return ((_b = (_a = UserState) == null ? void 0 : _a.state) == null ? void 0 : _b.languagePreference) || ((_c = LocationState.state) == null ? void 0 : _c.languagePreferenceBuilder) || "en";
}
var NotificationOptionType = /* @__PURE__ */ ((NotificationOptionType2) => {
  NotificationOptionType2["PUSH"] = "push";
  NotificationOptionType2["EMAIL"] = "email";
  return NotificationOptionType2;
})(NotificationOptionType || {});
var SourceApp = /* @__PURE__ */ ((SourceApp2) => {
  SourceApp2["COMMUNITIES"] = "COMMUNITIES";
  SourceApp2["COURSES"] = "COURSES";
  SourceApp2["CERTIFICATES"] = "CERTIFICATES";
  SourceApp2["ESTIMATES"] = "ESTIMATES";
  SourceApp2["CONTRACTS"] = "CONTRACTS";
  SourceApp2["INVOICES"] = "INVOICES";
  SourceApp2["CLIENT_PORTAL"] = "CLIENT_PORTAL";
  return SourceApp2;
})(SourceApp || {});
var NotificationTypeIds = /* @__PURE__ */ ((NotificationTypeIds2) => {
  NotificationTypeIds2["ALL_PUSH"] = "ALL_PUSH";
  NotificationTypeIds2["ALL_EMAIL"] = "ALL_EMAIL";
  NotificationTypeIds2["COMMUNITIES_POST_MENTION"] = "COMMUNITIES_POST_MENTION";
  NotificationTypeIds2["COMMUNITIES_POST_EVERYONE_MENTION"] = "COMMUNITIES_POST_EVERYONE_MENTION";
  NotificationTypeIds2["COMMUNITIES_POST_LIKE"] = "COMMUNITIES_POST_LIKE";
  NotificationTypeIds2["COMMUNITIES_COMMENT_MENTION"] = "COMMUNITIES_COMMENT_MENTION";
  NotificationTypeIds2["COMMUNITIES_COMMENT_EVERYONE_MENTION"] = "COMMUNITIES_COMMENT_EVERYONE_MENTION";
  NotificationTypeIds2["COMMUNITIES_COMMENT_LIKE"] = "COMMUNITIES_COMMENT_LIKE";
  NotificationTypeIds2["COMMUNITIES_NEW_COMMENT"] = "COMMUNITIES_NEW_COMMENT";
  NotificationTypeIds2["COMMUNITIES_NEW_MEMBER_REQUEST"] = "COMMUNITIES_NEW_MEMBER_REQUEST";
  NotificationTypeIds2["COMMUNITIES_GROUP_JOINING_REQUEST_APPROVED"] = "COMMUNITIES_GROUP_JOINING_REQUEST_APPROVED";
  NotificationTypeIds2["COMMUNITIES_GROUP_JOINING_REQUEST_REJECTED"] = "COMMUNITIES_GROUP_JOINING_REQUEST_REJECTED";
  NotificationTypeIds2["ROLE_UPDATED_IN_PRIVATE_CHANNEL"] = "COMMUNITIES_ROLE_UPDATED_IN_PRIVATE_CHANNEL";
  NotificationTypeIds2["COMMUNITIES_NEW_COURSE_AVAILABLE"] = "COMMUNITIES_NEW_COURSE_AVAILABLE";
  NotificationTypeIds2["COMMUNITIES_NEW_EVENT_CREATED"] = "COMMUNITIES_NEW_EVENT_CREATED";
  NotificationTypeIds2["COURSES_NEW_COURSE_COMMENT"] = "COURSES_NEW_COURSE_COMMENT";
  NotificationTypeIds2["CERTIFICATE_ISSUED"] = "CERTIFICATE_ISSUED";
  NotificationTypeIds2["CLIENT_PORTAL_NEW_ESTIMATE_SENT"] = "CLIENT_PORTAL_NEW_ESTIMATE_SENT";
  NotificationTypeIds2["CLIENT_PORTAL_NEW_CONTRACT_SENT"] = "CLIENT_PORTAL_NEW_CONTRACT_SENT";
  NotificationTypeIds2["CLIENT_PORTAL_NEW_INVOICE_SENT"] = "CLIENT_PORTAL_NEW_INVOICE_SENT";
  NotificationTypeIds2["COMMUNITIES_NEW_POST_FOLLOWERS"] = "COMMUNITIES_NEW_POST_FOLLOWERS";
  return NotificationTypeIds2;
})(NotificationTypeIds || {});
const disabledPushOptions = [
  "CLIENT_PORTAL_NEW_INVOICE_SENT",
  "CLIENT_PORTAL_NEW_ESTIMATE_SENT",
  "CLIENT_PORTAL_NEW_CONTRACT_SENT"
  /* CLIENT_PORTAL_NEW_CONTRACT_SENT */
];
const notificationOptionDescriptions = {
  [
    "COMMUNITIES_POST_MENTION"
    /* COMMUNITIES_POST_MENTION */
  ]: "notificationPreferences.postMentionDescription",
  [
    "COMMUNITIES_POST_EVERYONE_MENTION"
    /* COMMUNITIES_POST_EVERYONE_MENTION */
  ]: "notificationPreferences.postEveryoneTaggedDescription",
  [
    "COMMUNITIES_POST_LIKE"
    /* COMMUNITIES_POST_LIKE */
  ]: "notificationPreferences.postLikeDescription",
  [
    "COMMUNITIES_NEW_COMMENT"
    /* COMMUNITIES_NEW_COMMENT */
  ]: "notificationPreferences.newCommentDescription",
  [
    "COMMUNITIES_COMMENT_EVERYONE_MENTION"
    /* COMMUNITIES_COMMENT_EVERYONE_MENTION */
  ]: "notificationPreferences.commentEveryoneTaggedDescription",
  [
    "COMMUNITIES_COMMENT_MENTION"
    /* COMMUNITIES_COMMENT_MENTION */
  ]: "notificationPreferences.commentMentionDescription",
  [
    "COMMUNITIES_COMMENT_LIKE"
    /* COMMUNITIES_COMMENT_LIKE */
  ]: "notificationPreferences.commentLikeDescription",
  [
    "COMMUNITIES_NEW_MEMBER_REQUEST"
    /* COMMUNITIES_NEW_MEMBER_REQUEST */
  ]: "notificationPreferences.newMemberRequestToJoinGroupDescription",
  [
    "COMMUNITIES_GROUP_JOINING_REQUEST_APPROVED"
    /* COMMUNITIES_GROUP_JOINING_REQUEST_APPROVED */
  ]: "notificationPreferences.groupJoiningRequestApprovedDescription",
  [
    "COMMUNITIES_GROUP_JOINING_REQUEST_REJECTED"
    /* COMMUNITIES_GROUP_JOINING_REQUEST_REJECTED */
  ]: "notificationPreferences.groupJoiningRequestRejectedDescription",
  [
    "COMMUNITIES_ROLE_UPDATED_IN_PRIVATE_CHANNEL"
    /* ROLE_UPDATED_IN_PRIVATE_CHANNEL */
  ]: "notificationPreferences.roleUpdatedInPrivateChannelDescription",
  [
    "COMMUNITIES_NEW_COURSE_AVAILABLE"
    /* COMMUNITIES_NEW_COURSE_AVAILABLE */
  ]: "notificationPreferences.newCourseAvailableDescription",
  [
    "COMMUNITIES_NEW_EVENT_CREATED"
    /* COMMUNITIES_NEW_EVENT_CREATED */
  ]: "notificationPreferences.newEventCreatedDescription",
  [
    "COURSES_NEW_COURSE_COMMENT"
    /* COURSES_NEW_COURSE_COMMENT */
  ]: "notificationPreferences.newCourseCommentDescription",
  [
    "CERTIFICATE_ISSUED"
    /* CERTIFICATE_ISSUED */
  ]: "notificationPreferences.certificateIssuedDescription",
  [
    "CLIENT_PORTAL_NEW_ESTIMATE_SENT"
    /* CLIENT_PORTAL_NEW_ESTIMATE_SENT */
  ]: "notificationPreferences.estimateReceivedDescription",
  [
    "CLIENT_PORTAL_NEW_CONTRACT_SENT"
    /* CLIENT_PORTAL_NEW_CONTRACT_SENT */
  ]: "notificationPreferences.contractReceivedDescription",
  [
    "CLIENT_PORTAL_NEW_INVOICE_SENT"
    /* CLIENT_PORTAL_NEW_INVOICE_SENT */
  ]: "notificationPreferences.invoiceReceivedDescription",
  [
    "COMMUNITIES_NEW_POST_FOLLOWERS"
    /* COMMUNITIES_NEW_POST_FOLLOWERS */
  ]: "notificationPreferences.newPostFollowersDescription"
};
const SOURCE_APPS_MAPPING = {
  COMMUNITIES_POST_MENTION: "COMMUNITIES",
  COMMUNITIES_POST_EVERYONE_MENTION: "COMMUNITIES",
  COMMUNITIES_POST_LIKE: "COMMUNITIES",
  COMMUNITIES_COMMENT_MENTION: "COMMUNITIES",
  COMMUNITIES_COMMENT_EVERYONE_MENTION: "COMMUNITIES",
  COMMUNITIES_COMMENT_LIKE: "COMMUNITIES",
  COMMUNITIES_NEW_COMMENT: "COMMUNITIES",
  COMMUNITIES_NEW_MEMBER_REQUEST: "COMMUNITIES",
  COMMUNITIES_GROUP_JOINING_REQUEST_APPROVED: "COMMUNITIES",
  COMMUNITIES_GROUP_JOINING_REQUEST_REJECTED: "COMMUNITIES",
  ROLE_UPDATED_IN_PRIVATE_CHANNEL: "COMMUNITIES",
  COMMUNITIES_NEW_COURSE_AVAILABLE: "COMMUNITIES",
  COMMUNITIES_NEW_EVENT_CREATED: "COMMUNITIES",
  COURSES_NEW_COURSE_COMMENT: "COURSES",
  CERTIFICATE_ISSUED: "CERTIFICATES",
  CLIENT_PORTAL_NEW_ESTIMATE_SENT: "CLIENT_PORTAL",
  CLIENT_PORTAL_NEW_CONTRACT_SENT: "CLIENT_PORTAL",
  CLIENT_PORTAL_NEW_INVOICE_SENT: "CLIENT_PORTAL",
  COMMUNITIES_NEW_POST_FOLLOWERS: "COMMUNITIES"
  /* COMMUNITIES */
};
const getNotificationOptionsTemplate = () => {
  var _a, _b;
  const locationPermissions = (_b = (_a = LocationState) == null ? void 0 : _a.state) == null ? void 0 : _b.locationPermissions;
  const notificationOptionsTemplate = {};
  if (locationPermissions == null ? void 0 : locationPermissions.communitiesEnabled) {
    notificationOptionsTemplate[
      "COMMUNITIES"
      /* COMMUNITIES */
    ] = [
      {
        title: "notificationPreferences.postLike",
        key: "COMMUNITIES_POST_LIKE"
        /* COMMUNITIES_POST_LIKE */
      },
      {
        title: "notificationPreferences.newPostFollowers",
        key: "COMMUNITIES_NEW_POST_FOLLOWERS"
        /* COMMUNITIES_NEW_POST_FOLLOWERS */
      },
      {
        title: "notificationPreferences.postMentionMobile",
        key: "COMMUNITIES_POST_MENTION"
        /* COMMUNITIES_POST_MENTION */
      },
      {
        title: "notificationPreferences.postEveryoneTaggedMobile",
        key: "COMMUNITIES_POST_EVERYONE_MENTION"
        /* COMMUNITIES_POST_EVERYONE_MENTION */
      },
      {
        title: "notificationPreferences.newComment",
        key: "COMMUNITIES_NEW_COMMENT"
        /* COMMUNITIES_NEW_COMMENT */
      },
      {
        title: "notificationPreferences.commentLike",
        key: "COMMUNITIES_COMMENT_LIKE"
        /* COMMUNITIES_COMMENT_LIKE */
      },
      {
        title: "notificationPreferences.commentMentionMobile",
        key: "COMMUNITIES_COMMENT_MENTION"
        /* COMMUNITIES_COMMENT_MENTION */
      },
      {
        title: "notificationPreferences.commentEveryoneTaggedMobile",
        key: "COMMUNITIES_COMMENT_EVERYONE_MENTION"
        /* COMMUNITIES_COMMENT_EVERYONE_MENTION */
      },
      {
        title: "notificationPreferences.newMemberRequestToJoinGroup",
        key: "COMMUNITIES_NEW_MEMBER_REQUEST"
        /* COMMUNITIES_NEW_MEMBER_REQUEST */
      },
      {
        title: "notificationPreferences.groupJoiningRequestApproved",
        key: "COMMUNITIES_GROUP_JOINING_REQUEST_APPROVED"
        /* COMMUNITIES_GROUP_JOINING_REQUEST_APPROVED */
      },
      {
        title: "notificationPreferences.groupJoiningRequestRejected",
        key: "COMMUNITIES_GROUP_JOINING_REQUEST_REJECTED"
        /* COMMUNITIES_GROUP_JOINING_REQUEST_REJECTED */
      },
      {
        title: "notificationPreferences.roleUpdatedInPrivateChannel",
        key: "COMMUNITIES_ROLE_UPDATED_IN_PRIVATE_CHANNEL"
        /* ROLE_UPDATED_IN_PRIVATE_CHANNEL */
      },
      {
        title: "notificationPreferences.newCourseAvailable",
        key: "COMMUNITIES_NEW_COURSE_AVAILABLE"
        /* COMMUNITIES_NEW_COURSE_AVAILABLE */
      },
      {
        title: "notificationPreferences.newEventCreated",
        key: "COMMUNITIES_NEW_EVENT_CREATED"
        /* COMMUNITIES_NEW_EVENT_CREATED */
      }
    ];
  }
  if (locationPermissions == null ? void 0 : locationPermissions.certificatesEnabled) {
    notificationOptionsTemplate[
      "CERTIFICATES"
      /* CERTIFICATES */
    ] = [
      {
        title: "notificationPreferences.certificateIssued",
        key: "CERTIFICATE_ISSUED"
        /* CERTIFICATE_ISSUED */
      }
    ];
  }
  notificationOptionsTemplate[
    "CLIENT_PORTAL"
    /* CLIENT_PORTAL */
  ] = [
    ...[
      (locationPermissions == null ? void 0 : locationPermissions.subscriptionsEnabled) && {
        title: "notificationPreferences.invoiceReceived",
        key: "CLIENT_PORTAL_NEW_INVOICE_SENT"
        /* CLIENT_PORTAL_NEW_INVOICE_SENT */
      },
      (locationPermissions == null ? void 0 : locationPermissions.contractsEnabled) && {
        title: "notificationPreferences.contractReceived",
        key: "CLIENT_PORTAL_NEW_CONTRACT_SENT"
        /* CLIENT_PORTAL_NEW_CONTRACT_SENT */
      },
      (locationPermissions == null ? void 0 : locationPermissions.estimatesEnabled) && {
        title: "notificationPreferences.estimateReceived",
        key: "CLIENT_PORTAL_NEW_ESTIMATE_SENT"
        /* CLIENT_PORTAL_NEW_ESTIMATE_SENT */
      }
    ].filter(Boolean)
  ];
  return notificationOptionsTemplate;
};
const NOTIFICATION_PREFERENCES_TYPE = "notification-preferences";
const GENERAL_CATEGORY = "general";
let t$1 = null;
function setupVueI18n(locale) {
  const i18nInstance = createI18n({
    locale: locale ? locale : "en",
    globalInjection: true,
    legacy: false,
    messages: {
      en,
      es,
      "fr-CA": frCA,
      "fr-FR": frFR,
      "pt-BR": ptBR,
      "pt-PT": ptPT,
      fi,
      de,
      da,
      it,
      no,
      sv,
      nl
    }
  });
  t$1 = i18nInstance.global.t;
  return t$1;
}
const _hoisted_1$1H = { class: "flex flex-col h-screen w-full fixed bg-white z-[100] overflow-y-auto" };
const _hoisted_2$1j = {
  id: "edit-info-navbar",
  class: "fixed left-0 right-0 top-0 z-50 w-full bg-white"
};
const _hoisted_3$1b = { class: "relative z-50 inline-flex w-full bg-white" };
const _hoisted_4$14 = { class: "relative z-50 flex items-center justify-center gap-[13px] bg-white" };
const _hoisted_5$W = { class: "relative z-50 flex items-start justify-center gap-2.5 bg-white" };
const _hoisted_6$P = { class: "flex items-start justify-start gap-1" };
const _hoisted_7$K = { class: "inline-flex flex-col items-start justify-start" };
const _hoisted_8$y = { class: "flex flex-col mt-36 items-center justify-center min-h-[20vh]" };
const _hoisted_9$t = { class: "relative flex items-center justify-center" };
const _hoisted_10$r = { class: "absolute rounded-full bg-blue-300 w-20 h-20 flex items-center justify-center" };
const _hoisted_11$r = { class: "px-6" };
const _sfc_main$1U = /* @__PURE__ */ defineComponent({
  __name: "AuthPage",
  setup(__props) {
    const routerInstance = AppState.getRouterInstance();
    const otpCode = ref("");
    const otpData = ref();
    const notification = useNotification();
    const t2 = inject("t");
    const buttonDisabled = ref(false);
    const handleOnChange = (value) => {
      otpCode.value = value;
    };
    function notificationFailureAlert(title, content) {
      notification.error({
        title,
        content,
        duration: 5e3
      });
    }
    onMounted(async () => {
      const TEN_MINUTES = 10 * 60 * 1e3;
      const LAST_CALL_TIMESTAMP_KEY = "lastBillingOtpCall";
      const lastCallTimestamp = localStorage.getItem(LAST_CALL_TIMESTAMP_KEY);
      if (!lastCallTimestamp || Date.now() - Number(lastCallTimestamp) > TEN_MINUTES) {
        await getBillingOtp();
        localStorage.setItem(LAST_CALL_TIMESTAMP_KEY, Date.now().toString());
      }
    });
    const getBillingOtp = async () => {
      var _a, _b;
      try {
        const { data } = await BillingService.verifyBillingOtp({
          email: UserState.state.email.trim(),
          locationId: LocationState.state.locationId,
          action: "BILLING",
          userId: UserState.state.userId,
          fullName: ((_b = (_a = UserState) == null ? void 0 : _a.state) == null ? void 0 : _b.fullName) || t2.value("auth.user")
        });
        otpData.value = data;
      } catch (error) {
        notificationFailureAlert(
          t2.value("common.error"),
          t2.value("auth.failedToGetOtp")
        );
      }
    };
    const isResendButtonDisabled = ref(false);
    const resendOtp = async () => {
      isResendButtonDisabled.value = true;
      await getBillingOtp();
      setTimeout(() => {
        isResendButtonDisabled.value = false;
      }, 3e4);
    };
    const handleRoutes = async (queryValue) => {
      var _a, _b;
      const otpToken = isGokollab() ? (_a = otpData.value) == null ? void 0 : _a.otpToken : (_b = otpData.value) == null ? void 0 : _b.token;
      if (otpToken) {
        try {
          const billingOtpResponse = await BillingService.verifyBillingOtp({
            email: UserState.state.email.trim(),
            otp: Number(otpCode.value),
            locationId: LocationState.state.locationId,
            token: otpToken,
            userId: UserState.state.userId
          });
          if (isGokollab()) {
            UserState.saveBillingToken(billingOtpResponse.data.billingToken);
          }
          const currentPath = window.location.pathname;
          if (routerInstance) {
            routerInstance.push({
              path: `${currentPath}`,
              query: { activeScreen: queryValue }
            });
          }
          buttonDisabled.value = false;
        } catch (error) {
          notificationFailureAlert(
            t2.value("common.error"),
            t2.value("auth.failedToVerifyOtp")
          );
        }
      }
    };
    const handleBack = () => {
      var _a, _b;
      if ((_b = (_a = window == null ? void 0 : window.history) == null ? void 0 : _a.state) == null ? void 0 : _b.back) {
        routerInstance.go(-1);
      } else {
        routerInstance.push({ path: "/profile" });
      }
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$1H, [
        createElementVNode("div", _hoisted_2$1j, [
          createVNode(unref(UICard), { class: "relative z-50 h-full w-full !rounded-none bg-white" }, {
            default: withCtx(() => [
              createElementVNode("div", _hoisted_3$1b, [
                createElementVNode("div", _hoisted_4$14, [
                  createElementVNode("div", _hoisted_5$W, [
                    createElementVNode("div", {
                      onClick: handleBack,
                      class: "relative h-6 w-6 cursor-pointer"
                    }, [
                      createVNode(unref(render$6))
                    ])
                  ]),
                  createElementVNode("div", _hoisted_6$P, [
                    createElementVNode("div", _hoisted_7$K, [
                      createVNode(unref(UITextLgMedium), { class: "text-fontPrimary" }, {
                        default: withCtx(() => [
                          createTextVNode(toDisplayString(unref(t2)("auth.authentication")), 1)
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ])
            ]),
            _: 1
          })
        ]),
        createElementVNode("div", _hoisted_8$y, [
          createElementVNode("div", _hoisted_9$t, [
            _cache[2] || (_cache[2] = createElementVNode("div", { class: "absolute rounded-full bg-blue-100 w-36 h-36" }, null, -1)),
            _cache[3] || (_cache[3] = createElementVNode("div", { class: "absolute rounded-full bg-blue-200 w-28 h-28" }, null, -1)),
            createElementVNode("div", _hoisted_10$r, [
              createVNode(unref(render$7), { class: "text-white w-8 h-8" })
            ])
          ]),
          createVNode(unref(UITextMdMedium), { class: "mt-20 text-xl text-clientportal-font-primary font-semibold font-sans" }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(unref(t2)("auth.authenticateAccount")), 1)
            ]),
            _: 1
          })
        ]),
        createElementVNode("div", _hoisted_11$r, [
          createVNode(unref(UITextMdNormal), { class: "text-clientportal-font-secondary font-sans" }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(unref(t2)("auth.confirmationCode")), 1)
            ]),
            _: 1
          }),
          createVNode(unref(entry_esm), {
            class: "justify-center",
            ref: "otpInput",
            "input-classes": "otpStyle",
            value: otpCode.value,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event) => otpCode.value = $event),
            separator: " ",
            "num-inputs": 6,
            "should-auto-focus": true,
            "input-type": "tel",
            placeholder: ["0", "0", "0", "0", "0", "0"],
            onOnChange: handleOnChange
          }, null, 8, ["value"]),
          createVNode(unref(UITextXsMedium), { class: "text-gray-900 mt-2 font-normal" }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(unref(t2)("auth.checkEmailForSecureCode")), 1),
              createElementVNode("span", null, [
                createVNode(unref(UIButton), {
                  id: "resend-otp--button",
                  class: "underline-offset-4",
                  onClick: resendOtp,
                  disabled: isResendButtonDisabled.value,
                  text: true
                }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(unref(t2)("auth.tapHereToResend")), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ])
            ]),
            _: 1
          }),
          createVNode(unref(UIButton), {
            type: "primary",
            class: "!bg-black h-12 w-full row-span-1 mt-4 buttonBorder text-white",
            id: "signin-btn",
            size: "large",
            onClick: _cache[1] || (_cache[1] = ($event) => handleRoutes("BillingSubscription")),
            disabled: buttonDisabled.value
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(unref(t2)("auth.verify")), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ]);
    };
  }
});
const AuthPage = /* @__PURE__ */ _export_sfc(_sfc_main$1U, [["__scopeId", "data-v-3f15d5e3"]]);
var PaymentMethodNames = /* @__PURE__ */ ((PaymentMethodNames2) => {
  PaymentMethodNames2["US_BANK_ACCOUNT"] = "us_bank_account";
  PaymentMethodNames2["VISA"] = "visa";
  PaymentMethodNames2["MASTERCARD"] = "mastercard";
  PaymentMethodNames2["AMERICAN_EXPRESS"] = "american_express";
  PaymentMethodNames2["DINERS"] = "diners";
  PaymentMethodNames2["DISCOVER"] = "discover";
  PaymentMethodNames2["JCB"] = "jcb";
  PaymentMethodNames2["UNIONPAY"] = "unionpay";
  return PaymentMethodNames2;
})(PaymentMethodNames || {});
function getStatusType(status) {
  switch (status) {
    case "paid":
      return "success";
    case "active":
      return "success";
    case "succeeded":
      return "success";
    case "pending":
      return "warning";
    case "processing":
      return "info";
    case "trialing":
      return "info";
    case "payment_processing":
      return "info";
    case "partially_paid":
      return "warning";
    case "unpaid":
      return "warning";
    case "canceled":
      return "warning";
    case "incomplete_expired":
      return "error";
    case "incomplete":
      return "error";
    case "past_due":
      return "error";
    case "failed":
      return "error";
    default:
      return "default";
  }
}
const statusSubscriptions = [
  {
    id: "all",
    value: "all",
    title: "common.all"
  },
  {
    id: "active",
    value: "active",
    title: "common.active"
  },
  {
    id: "trialing",
    value: "trialing",
    title: "billing.trial"
  },
  {
    id: "unpaid",
    value: "unpaid",
    title: "billing.unpaid"
  },
  {
    id: "incomplete_expired",
    value: "incomplete_expired",
    title: "billing.failed"
  },
  {
    id: "canceled",
    value: "canceled",
    title: "billing.canceled"
  },
  {
    id: "incomplete",
    value: "incomplete",
    title: "billing.incomplete"
  }
];
const statusInvoices = [
  {
    id: "all",
    value: "all",
    title: "common.all"
  },
  {
    id: "draft",
    value: "draft",
    title: "common.draft"
  },
  {
    id: "sent",
    value: "sent",
    title: "billing.sent"
  },
  {
    id: "paid",
    value: "paid",
    title: "billing.paid"
  },
  {
    id: "paymentProcessing",
    value: "paymentProcessing",
    title: "billing.paymentProcessing"
  },
  {
    id: "partiallyPaid",
    value: "partiallyPaid",
    title: "billing.partiallyPaid"
  },
  {
    id: "overdue",
    value: "overdue",
    title: "billing.overdue"
  }
];
const statusTransactions = [
  {
    id: "all",
    value: "all",
    title: "common.all"
  },
  {
    id: "succeeded",
    value: "succeeded",
    title: "billing.succeeded"
  },
  {
    id: "processing",
    value: "processing",
    title: "billing.processing"
  },
  {
    id: "refunded",
    value: "refunded",
    title: "billing.refunded"
  },
  {
    id: "failed",
    value: "failed",
    title: "billing.failed"
  },
  {
    id: "pending",
    value: "pending",
    title: "billing.pending"
  }
];
const sourceType = [
  {
    id: "all",
    value: "all",
    title: "common.all"
  },
  {
    id: "communities",
    value: "communities",
    title: "billing.communities"
  },
  {
    id: "membership",
    value: "membership",
    title: "billing.membership"
  }
];
function getCardIcon(type) {
  switch (type.toLowerCase()) {
    case "american_express":
      return AMEX_ICON;
    case "diners":
      return DINERS_ICON;
    case "discover":
      return DISCOVER_ICON;
    case "jcb":
      return JCB_ICON;
    case "mastercard":
      return MASTERCARD_ICON;
    case "unionpay":
      return UNIONPAY_ICON;
    case "visa":
      return VISA_ICON;
    default:
      return CARD_ICON;
  }
}
var SourceType = /* @__PURE__ */ ((SourceType2) => {
  SourceType2["CLIENT_PORTAL"] = "CLIENT_PORTAL";
  SourceType2["ADMIN"] = "ADMIN";
  return SourceType2;
})(SourceType || {});
var FileAction = /* @__PURE__ */ ((FileAction2) => {
  FileAction2["DOWNLOAD"] = "Download";
  FileAction2["PREVIEW"] = "Preview";
  FileAction2["DELETE"] = "Delete";
  return FileAction2;
})(FileAction || {});
const currency = {
  USD: {
    symbol: "US$",
    name: "US Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "USD",
    name_plural: "US dollars"
  },
  CAD: {
    symbol: "CA$",
    name: "Canadian Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "CAD",
    name_plural: "Canadian dollars"
  },
  EUR: {
    symbol: "€",
    name: "Euro",
    symbol_native: "€",
    decimal_digits: 2,
    rounding: 0,
    code: "EUR",
    name_plural: "euros"
  },
  AED: {
    symbol: "AED",
    name: "United Arab Emirates Dirham",
    symbol_native: "د.إ.",
    decimal_digits: 2,
    rounding: 0,
    code: "AED",
    name_plural: "UAE dirhams"
  },
  AFN: {
    symbol: "Af",
    name: "Afghan Afghani",
    symbol_native: "؋",
    decimal_digits: 0,
    rounding: 0,
    code: "AFN",
    name_plural: "Afghan Afghanis"
  },
  ALL: {
    symbol: "ALL",
    name: "Albanian Lek",
    symbol_native: "Lek",
    decimal_digits: 0,
    rounding: 0,
    code: "ALL",
    name_plural: "Albanian lekë"
  },
  AMD: {
    symbol: "AMD",
    name: "Armenian Dram",
    symbol_native: "դր.",
    decimal_digits: 0,
    rounding: 0,
    code: "AMD",
    name_plural: "Armenian drams"
  },
  ARS: {
    symbol: "AR$",
    name: "Argentine Peso",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "ARS",
    name_plural: "Argentine pesos"
  },
  AUD: {
    symbol: "AU$",
    name: "Australian Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "AUD",
    name_plural: "Australian dollars"
  },
  AZN: {
    symbol: "man.",
    name: "Azerbaijani Manat",
    symbol_native: "ман.",
    decimal_digits: 2,
    rounding: 0,
    code: "AZN",
    name_plural: "Azerbaijani manats"
  },
  BAM: {
    symbol: "KM",
    name: "Bosnia-Herzegovina Convertible Mark",
    symbol_native: "KM",
    decimal_digits: 2,
    rounding: 0,
    code: "BAM",
    name_plural: "Bosnia-Herzegovina convertible marks"
  },
  BBD: {
    symbol: "Bds$",
    name: "Barbados Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "BBD",
    name_plural: "Barbados dollars"
  },
  BDT: {
    symbol: "Tk",
    name: "Bangladeshi Taka",
    symbol_native: "৳",
    decimal_digits: 2,
    rounding: 0,
    code: "BDT",
    name_plural: "Bangladeshi takas"
  },
  BGN: {
    symbol: "BGN",
    name: "Bulgarian Lev",
    symbol_native: "лв.",
    decimal_digits: 2,
    rounding: 0,
    code: "BGN",
    name_plural: "Bulgarian leva"
  },
  BHD: {
    symbol: "BD",
    name: "Bahraini Dinar",
    symbol_native: "د.ب.",
    decimal_digits: 3,
    rounding: 0,
    code: "BHD",
    name_plural: "Bahraini dinars"
  },
  BIF: {
    symbol: "FBu",
    name: "Burundian Franc",
    symbol_native: "FBu",
    decimal_digits: 0,
    rounding: 0,
    code: "BIF",
    name_plural: "Burundian francs"
  },
  BMD: {
    symbol: "BM$",
    name: "Bermudian Dollar",
    symbol_native: "",
    decimal_digits: 0,
    rounding: 0,
    code: "BMD",
    name_plural: "Bermudian dollars"
  },
  BND: {
    symbol: "BN$",
    name: "Brunei Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "BND",
    name_plural: "Brunei dollars"
  },
  BOB: {
    symbol: "Bs",
    name: "Bolivian Boliviano",
    symbol_native: "Bs",
    decimal_digits: 2,
    rounding: 0,
    code: "BOB",
    name_plural: "Bolivian bolivianos"
  },
  BRL: {
    symbol: "R$",
    name: "Brazilian Real",
    symbol_native: "R$",
    decimal_digits: 2,
    rounding: 0,
    code: "BRL",
    name_plural: "Brazilian reals"
  },
  BWP: {
    symbol: "BWP",
    name: "Botswanan Pula",
    symbol_native: "P",
    decimal_digits: 2,
    rounding: 0,
    code: "BWP",
    name_plural: "Botswanan pulas"
  },
  BYR: {
    symbol: "BYR",
    name: "Belarusian Ruble",
    symbol_native: "BYR",
    decimal_digits: 0,
    rounding: 0,
    code: "BYR",
    name_plural: "Belarusian rubles"
  },
  BZD: {
    symbol: "BZ$",
    name: "Belize Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "BZD",
    name_plural: "Belize dollars"
  },
  CDF: {
    symbol: "CDF",
    name: "Congolese Franc",
    symbol_native: "FrCD",
    decimal_digits: 2,
    rounding: 0,
    code: "CDF",
    name_plural: "Congolese francs"
  },
  CHF: {
    symbol: "CHF",
    name: "Swiss Franc",
    symbol_native: "CHF",
    decimal_digits: 2,
    rounding: 0.05,
    code: "CHF",
    name_plural: "Swiss francs"
  },
  CLP: {
    symbol: "CL$",
    name: "Chilean Peso",
    symbol_native: "$",
    decimal_digits: 0,
    rounding: 0,
    code: "CLP",
    name_plural: "Chilean pesos"
  },
  CNY: {
    symbol: "CN¥",
    name: "Chinese Yuan",
    symbol_native: "CN¥",
    decimal_digits: 2,
    rounding: 0,
    code: "CNY",
    name_plural: "Chinese yuan"
  },
  COP: {
    symbol: "CO$",
    name: "Colombian Peso",
    symbol_native: "$",
    decimal_digits: 0,
    rounding: 0,
    code: "COP",
    name_plural: "Colombian pesos"
  },
  CRC: {
    symbol: "₡",
    name: "Costa Rican Colón",
    symbol_native: "₡",
    decimal_digits: 0,
    rounding: 0,
    code: "CRC",
    name_plural: "Costa Rican colóns"
  },
  CVE: {
    symbol: "CV$",
    name: "Cape Verdean Escudo",
    symbol_native: "CV$",
    decimal_digits: 2,
    rounding: 0,
    code: "CVE",
    name_plural: "Cape Verdean escudos"
  },
  CZK: {
    symbol: "Kč",
    name: "Czech Republic Koruna",
    symbol_native: "Kč",
    decimal_digits: 2,
    rounding: 0,
    code: "CZK",
    name_plural: "Czech Republic korunas"
  },
  DJF: {
    symbol: "Fdj",
    name: "Djiboutian Franc",
    symbol_native: "Fdj",
    decimal_digits: 0,
    rounding: 0,
    code: "DJF",
    name_plural: "Djiboutian francs"
  },
  DKK: {
    symbol: "Dkr",
    name: "Danish Krone",
    symbol_native: "kr",
    decimal_digits: 2,
    rounding: 0,
    code: "DKK",
    name_plural: "Danish kroner"
  },
  DOP: {
    symbol: "RD$",
    name: "Dominican Peso",
    symbol_native: "RD$",
    decimal_digits: 2,
    rounding: 0,
    code: "DOP",
    name_plural: "Dominican pesos"
  },
  DZD: {
    symbol: "DA",
    name: "Algerian Dinar",
    symbol_native: "د.ج.",
    decimal_digits: 2,
    rounding: 0,
    code: "DZD",
    name_plural: "Algerian dinars"
  },
  EEK: {
    symbol: "Ekr",
    name: "Estonian Kroon",
    symbol_native: "kr",
    decimal_digits: 2,
    rounding: 0,
    code: "EEK",
    name_plural: "Estonian kroons"
  },
  EGP: {
    symbol: "EGP",
    name: "Egyptian Pound",
    symbol_native: "ج.م.",
    decimal_digits: 2,
    rounding: 0,
    code: "EGP",
    name_plural: "Egyptian pounds"
  },
  ERN: {
    symbol: "Nfk",
    name: "Eritrean Nakfa",
    symbol_native: "Nfk",
    decimal_digits: 2,
    rounding: 0,
    code: "ERN",
    name_plural: "Eritrean nakfas"
  },
  ETB: {
    symbol: "Br",
    name: "Ethiopian Birr",
    symbol_native: "Br",
    decimal_digits: 2,
    rounding: 0,
    code: "ETB",
    name_plural: "Ethiopian birrs"
  },
  GBP: {
    symbol: "£",
    name: "British Pound Sterling",
    symbol_native: "£",
    decimal_digits: 2,
    rounding: 0,
    code: "GBP",
    name_plural: "British pounds sterling"
  },
  GEL: {
    symbol: "GEL",
    name: "Georgian Lari",
    symbol_native: "GEL",
    decimal_digits: 2,
    rounding: 0,
    code: "GEL",
    name_plural: "Georgian laris"
  },
  GHS: {
    symbol: "GH₵",
    name: "Ghanaian Cedi",
    symbol_native: "GH₵",
    decimal_digits: 2,
    rounding: 0,
    code: "GHS",
    name_plural: "Ghanaian cedis"
  },
  GNF: {
    symbol: "FG",
    name: "Guinean Franc",
    symbol_native: "FG",
    decimal_digits: 0,
    rounding: 0,
    code: "GNF",
    name_plural: "Guinean francs"
  },
  GTQ: {
    symbol: "GTQ",
    name: "Guatemalan Quetzal",
    symbol_native: "Q",
    decimal_digits: 2,
    rounding: 0,
    code: "GTQ",
    name_plural: "Guatemalan quetzals"
  },
  HKD: {
    symbol: "HK$",
    name: "Hong Kong Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "HKD",
    name_plural: "Hong Kong dollars"
  },
  HNL: {
    symbol: "HNL",
    name: "Honduran Lempira",
    symbol_native: "L",
    decimal_digits: 2,
    rounding: 0,
    code: "HNL",
    name_plural: "Honduran lempiras"
  },
  HRK: {
    symbol: "kn",
    name: "Croatian Kuna",
    symbol_native: "kn",
    decimal_digits: 2,
    rounding: 0,
    code: "HRK",
    name_plural: "Croatian kunas"
  },
  HUF: {
    symbol: "Ft",
    name: "Hungarian Forint",
    symbol_native: "Ft",
    decimal_digits: 0,
    rounding: 0,
    code: "HUF",
    name_plural: "Hungarian forints"
  },
  IDR: {
    symbol: "Rp",
    name: "Indonesian Rupiah",
    symbol_native: "Rp",
    decimal_digits: 0,
    rounding: 0,
    code: "IDR",
    name_plural: "Indonesian rupiahs"
  },
  ILS: {
    symbol: "₪",
    name: "Israeli New Sheqel",
    symbol_native: "₪",
    decimal_digits: 2,
    rounding: 0,
    code: "ILS",
    name_plural: "Israeli new sheqels"
  },
  INR: {
    symbol: "₹",
    name: "Indian Rupee",
    symbol_native: "টকা",
    decimal_digits: 2,
    rounding: 0,
    code: "INR",
    name_plural: "Indian rupees"
  },
  IQD: {
    symbol: "IQD",
    name: "Iraqi Dinar",
    symbol_native: "د.ع.",
    decimal_digits: 0,
    rounding: 0,
    code: "IQD",
    name_plural: "Iraqi dinars"
  },
  IRR: {
    symbol: "IRR",
    name: "Iranian Rial",
    symbol_native: "﷼",
    decimal_digits: 0,
    rounding: 0,
    code: "IRR",
    name_plural: "Iranian rials"
  },
  ISK: {
    symbol: "Ikr",
    name: "Icelandic Króna",
    symbol_native: "kr",
    decimal_digits: 0,
    rounding: 0,
    code: "ISK",
    name_plural: "Icelandic krónur"
  },
  JMD: {
    symbol: "J$",
    name: "Jamaican Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "JMD",
    name_plural: "Jamaican dollars"
  },
  JOD: {
    symbol: "JD",
    name: "Jordanian Dinar",
    symbol_native: "د.أ.",
    decimal_digits: 3,
    rounding: 0,
    code: "JOD",
    name_plural: "Jordanian dinars"
  },
  JPY: {
    symbol: "¥",
    name: "Japanese Yen",
    symbol_native: "￥",
    decimal_digits: 0,
    rounding: 0,
    code: "JPY",
    name_plural: "Japanese yen"
  },
  KGS: {
    symbol: "som ",
    name: "Kyrgyzstani som",
    symbol_native: "som",
    decimal_digits: 2,
    rounding: 0,
    code: "KGS",
    name_plural: "Kyrgyzstani som"
  },
  KES: {
    symbol: "Ksh",
    name: "Kenyan Shilling",
    symbol_native: "Ksh",
    decimal_digits: 2,
    rounding: 0,
    code: "KES",
    name_plural: "Kenyan shillings"
  },
  KHR: {
    symbol: "KHR",
    name: "Cambodian Riel",
    symbol_native: "៛",
    decimal_digits: 2,
    rounding: 0,
    code: "KHR",
    name_plural: "Cambodian riels"
  },
  KMF: {
    symbol: "CF",
    name: "Comorian Franc",
    symbol_native: "FC",
    decimal_digits: 0,
    rounding: 0,
    code: "KMF",
    name_plural: "Comorian francs"
  },
  KRW: {
    symbol: "₩",
    name: "South Korean Won",
    symbol_native: "₩",
    decimal_digits: 0,
    rounding: 0,
    code: "KRW",
    name_plural: "South Korean won"
  },
  KWD: {
    symbol: "KD",
    name: "Kuwaiti Dinar",
    symbol_native: "د.ك.",
    decimal_digits: 3,
    rounding: 0,
    code: "KWD",
    name_plural: "Kuwaiti dinars"
  },
  KZT: {
    symbol: "KZT",
    name: "Kazakhstani Tenge",
    symbol_native: "тңг.",
    decimal_digits: 2,
    rounding: 0,
    code: "KZT",
    name_plural: "Kazakhstani tenges"
  },
  LBP: {
    symbol: "LB£",
    name: "Lebanese Pound",
    symbol_native: "ل.ل.",
    decimal_digits: 0,
    rounding: 0,
    code: "LBP",
    name_plural: "Lebanese pounds"
  },
  LKR: {
    symbol: "SLRs",
    name: "Sri Lankan Rupee",
    symbol_native: "SL Re",
    decimal_digits: 2,
    rounding: 0,
    code: "LKR",
    name_plural: "Sri Lankan rupees"
  },
  LTL: {
    symbol: "Lt",
    name: "Lithuanian Litas",
    symbol_native: "Lt",
    decimal_digits: 2,
    rounding: 0,
    code: "LTL",
    name_plural: "Lithuanian litai"
  },
  LVL: {
    symbol: "Ls",
    name: "Latvian Lats",
    symbol_native: "Ls",
    decimal_digits: 2,
    rounding: 0,
    code: "LVL",
    name_plural: "Latvian lati"
  },
  LYD: {
    symbol: "LD",
    name: "Libyan Dinar",
    symbol_native: "د.ل.",
    decimal_digits: 3,
    rounding: 0,
    code: "LYD",
    name_plural: "Libyan dinars"
  },
  MAD: {
    symbol: "MAD",
    name: "Moroccan Dirham",
    symbol_native: "د.م.",
    decimal_digits: 2,
    rounding: 0,
    code: "MAD",
    name_plural: "Moroccan dirhams"
  },
  MDL: {
    symbol: "MDL",
    name: "Moldovan Leu",
    symbol_native: "MDL",
    decimal_digits: 2,
    rounding: 0,
    code: "MDL",
    name_plural: "Moldovan lei"
  },
  MGA: {
    symbol: "MGA",
    name: "Malagasy Ariary",
    symbol_native: "MGA",
    decimal_digits: 0,
    rounding: 0,
    code: "MGA",
    name_plural: "Malagasy Ariaries"
  },
  MKD: {
    symbol: "MKD",
    name: "Macedonian Denar",
    symbol_native: "MKD",
    decimal_digits: 2,
    rounding: 0,
    code: "MKD",
    name_plural: "Macedonian denari"
  },
  MMK: {
    symbol: "MMK",
    name: "Myanma Kyat",
    symbol_native: "K",
    decimal_digits: 0,
    rounding: 0,
    code: "MMK",
    name_plural: "Myanma kyats"
  },
  MOP: {
    symbol: "MOP$",
    name: "Macanese Pataca",
    symbol_native: "MOP$",
    decimal_digits: 2,
    rounding: 0,
    code: "MOP",
    name_plural: "Macanese patacas"
  },
  MUR: {
    symbol: "MURs",
    name: "Mauritian Rupee",
    symbol_native: "MURs",
    decimal_digits: 0,
    rounding: 0,
    code: "MUR",
    name_plural: "Mauritian rupees"
  },
  MXN: {
    symbol: "MX$",
    name: "Mexican Peso",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "MXN",
    name_plural: "Mexican pesos"
  },
  MYR: {
    symbol: "RM",
    name: "Malaysian Ringgit",
    symbol_native: "RM",
    decimal_digits: 2,
    rounding: 0,
    code: "MYR",
    name_plural: "Malaysian ringgits"
  },
  MZN: {
    symbol: "MTn",
    name: "Mozambican Metical",
    symbol_native: "MTn",
    decimal_digits: 2,
    rounding: 0,
    code: "MZN",
    name_plural: "Mozambican meticals"
  },
  NAD: {
    symbol: "N$",
    name: "Namibian Dollar",
    symbol_native: "N$",
    decimal_digits: 2,
    rounding: 0,
    code: "NAD",
    name_plural: "Namibian dollars"
  },
  NGN: {
    symbol: "₦",
    name: "Nigerian Naira",
    symbol_native: "₦",
    decimal_digits: 2,
    rounding: 0,
    code: "NGN",
    name_plural: "Nigerian nairas"
  },
  NIO: {
    symbol: "C$",
    name: "Nicaraguan Córdoba",
    symbol_native: "C$",
    decimal_digits: 2,
    rounding: 0,
    code: "NIO",
    name_plural: "Nicaraguan córdobas"
  },
  NOK: {
    symbol: "Nkr",
    name: "Norwegian Krone",
    symbol_native: "kr",
    decimal_digits: 2,
    rounding: 0,
    code: "NOK",
    name_plural: "Norwegian kroner"
  },
  NPR: {
    symbol: "NPRs",
    name: "Nepalese Rupee",
    symbol_native: "नेरू",
    decimal_digits: 2,
    rounding: 0,
    code: "NPR",
    name_plural: "Nepalese rupees"
  },
  NZD: {
    symbol: "NZ$",
    name: "New Zealand Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "NZD",
    name_plural: "New Zealand dollars"
  },
  OMR: {
    symbol: "OMR",
    name: "Omani Rial",
    symbol_native: "ر.ع.",
    decimal_digits: 3,
    rounding: 0,
    code: "OMR",
    name_plural: "Omani rials"
  },
  PAB: {
    symbol: "B/.",
    name: "Panamanian Balboa",
    symbol_native: "B/.",
    decimal_digits: 2,
    rounding: 0,
    code: "PAB",
    name_plural: "Panamanian balboas"
  },
  PEN: {
    symbol: "S/.",
    name: "Peruvian Nuevo Sol",
    symbol_native: "S/.",
    decimal_digits: 2,
    rounding: 0,
    code: "PEN",
    name_plural: "Peruvian nuevos soles"
  },
  PHP: {
    symbol: "₱",
    name: "Philippine Peso",
    symbol_native: "₱",
    decimal_digits: 2,
    rounding: 0,
    code: "PHP",
    name_plural: "Philippine pesos"
  },
  PKR: {
    symbol: "PKRs",
    name: "Pakistani Rupee",
    symbol_native: "₨",
    decimal_digits: 0,
    rounding: 0,
    code: "PKR",
    name_plural: "Pakistani rupees"
  },
  PLN: {
    symbol: "zł",
    name: "Polish Zloty",
    symbol_native: "zł",
    decimal_digits: 2,
    rounding: 0,
    code: "PLN",
    name_plural: "Polish zlotys"
  },
  PYG: {
    symbol: "₲",
    name: "Paraguayan Guarani",
    symbol_native: "₲",
    decimal_digits: 0,
    rounding: 0,
    code: "PYG",
    name_plural: "Paraguayan guaranis"
  },
  QAR: {
    symbol: "QR",
    name: "Qatari Rial",
    symbol_native: "ر.ق.",
    decimal_digits: 2,
    rounding: 0,
    code: "QAR",
    name_plural: "Qatari rials"
  },
  RON: {
    symbol: "RON",
    name: "Romanian Leu",
    symbol_native: "RON",
    decimal_digits: 2,
    rounding: 0,
    code: "RON",
    name_plural: "Romanian lei"
  },
  RSD: {
    symbol: "din.",
    name: "Serbian Dinar",
    symbol_native: "дин.",
    decimal_digits: 0,
    rounding: 0,
    code: "RSD",
    name_plural: "Serbian dinars"
  },
  RUB: {
    symbol: "RUB",
    name: "Russian Ruble",
    symbol_native: "руб.",
    decimal_digits: 2,
    rounding: 0,
    code: "RUB",
    name_plural: "Russian rubles"
  },
  RWF: {
    symbol: "RWF",
    name: "Rwandan Franc",
    symbol_native: "FR",
    decimal_digits: 0,
    rounding: 0,
    code: "RWF",
    name_plural: "Rwandan francs"
  },
  SAR: {
    symbol: "SR",
    name: "Saudi Riyal",
    symbol_native: "ر.س.",
    decimal_digits: 2,
    rounding: 0,
    code: "SAR",
    name_plural: "Saudi riyals"
  },
  SDG: {
    symbol: "SDG",
    name: "Sudanese Pound",
    symbol_native: "SDG",
    decimal_digits: 2,
    rounding: 0,
    code: "SDG",
    name_plural: "Sudanese pounds"
  },
  SEK: {
    symbol: "kr",
    name: "Swedish Krona",
    symbol_native: "kr",
    decimal_digits: 2,
    rounding: 0,
    code: "SEK",
    name_plural: "Swedish kronor"
  },
  SGD: {
    symbol: "S$",
    name: "Singapore Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "SGD",
    name_plural: "Singapore dollars"
  },
  SOS: {
    symbol: "Ssh",
    name: "Somali Shilling",
    symbol_native: "Ssh",
    decimal_digits: 0,
    rounding: 0,
    code: "SOS",
    name_plural: "Somali shillings"
  },
  SRD: {
    symbol: "Sr$",
    name: "Surinamese Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "SRD",
    name_plural: "Surinamese dollars"
  },
  SYP: {
    symbol: "SY£",
    name: "Syrian Pound",
    symbol_native: "ل.س.",
    decimal_digits: 0,
    rounding: 0,
    code: "SYP",
    name_plural: "Syrian pounds"
  },
  THB: {
    symbol: "฿",
    name: "Thai Baht",
    symbol_native: "฿",
    decimal_digits: 2,
    rounding: 0,
    code: "THB",
    name_plural: "Thai baht"
  },
  TND: {
    symbol: "DT",
    name: "Tunisian Dinar",
    symbol_native: "د.ت.",
    decimal_digits: 3,
    rounding: 0,
    code: "TND",
    name_plural: "Tunisian dinars"
  },
  TOP: {
    symbol: "T$",
    name: "Tongan Paʻanga",
    symbol_native: "T$",
    decimal_digits: 2,
    rounding: 0,
    code: "TOP",
    name_plural: "Tongan paʻanga"
  },
  TRY: {
    symbol: "TL",
    name: "Turkish Lira",
    symbol_native: "TL",
    decimal_digits: 2,
    rounding: 0,
    code: "TRY",
    name_plural: "Turkish Lira"
  },
  TTD: {
    symbol: "TT$",
    name: "Trinidad and Tobago Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "TTD",
    name_plural: "Trinidad and Tobago dollars"
  },
  TWD: {
    symbol: "NT$",
    name: "New Taiwan Dollar",
    symbol_native: "NT$",
    decimal_digits: 2,
    rounding: 0,
    code: "TWD",
    name_plural: "New Taiwan dollars"
  },
  TZS: {
    symbol: "TSh",
    name: "Tanzanian Shilling",
    symbol_native: "TSh",
    decimal_digits: 0,
    rounding: 0,
    code: "TZS",
    name_plural: "Tanzanian shillings"
  },
  UAH: {
    symbol: "₴",
    name: "Ukrainian Hryvnia",
    symbol_native: "₴",
    decimal_digits: 2,
    rounding: 0,
    code: "UAH",
    name_plural: "Ukrainian hryvnias"
  },
  UGX: {
    symbol: "USh",
    name: "Ugandan Shilling",
    symbol_native: "USh",
    decimal_digits: 0,
    rounding: 0,
    code: "UGX",
    name_plural: "Ugandan shillings"
  },
  UYU: {
    symbol: "$U",
    name: "Uruguayan Peso",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "UYU",
    name_plural: "Uruguayan pesos"
  },
  UZS: {
    symbol: "UZS",
    name: "Uzbekistan Som",
    symbol_native: "UZS",
    decimal_digits: 0,
    rounding: 0,
    code: "UZS",
    name_plural: "Uzbekistan som"
  },
  VEF: {
    symbol: "Bs.F.",
    name: "Venezuelan Bolívar",
    symbol_native: "Bs.F.",
    decimal_digits: 2,
    rounding: 0,
    code: "VEF",
    name_plural: "Venezuelan bolívars"
  },
  VND: {
    symbol: "₫",
    name: "Vietnamese Dong",
    symbol_native: "₫",
    decimal_digits: 0,
    rounding: 0,
    code: "VND",
    name_plural: "Vietnamese dong"
  },
  VUV: {
    symbol: "VT",
    name: "Vatu",
    symbol_native: "VT",
    decimal_digits: 0,
    rounding: 0,
    code: "VUV",
    name_plural: "Vatu"
  },
  XAF: {
    symbol: "FCFA",
    name: "CFA Franc BEAC",
    symbol_native: "FCFA",
    decimal_digits: 0,
    rounding: 0,
    code: "XAF",
    name_plural: "CFA francs BEAC"
  },
  XCD: {
    symbol: "EC$",
    name: "East Caribbean Dollar",
    symbol_native: "EC$",
    decimal_digits: 0,
    rounding: 0,
    code: "XCD",
    name_plural: "East caribbean dollars"
  },
  XOF: {
    symbol: "CFA",
    name: "CFA Franc BCEAO",
    symbol_native: "CFA",
    decimal_digits: 0,
    rounding: 0,
    code: "XOF",
    name_plural: "CFA francs BCEAO"
  },
  YER: {
    symbol: "YR",
    name: "Yemeni Rial",
    symbol_native: "ر.ي.",
    decimal_digits: 0,
    rounding: 0,
    code: "YER",
    name_plural: "Yemeni rials"
  },
  ZAR: {
    symbol: "R",
    name: "South African Rand",
    symbol_native: "R",
    decimal_digits: 2,
    rounding: 0,
    code: "ZAR",
    name_plural: "South African rand"
  },
  ZMK: {
    symbol: "ZK",
    name: "Zambian Kwacha",
    symbol_native: "ZK",
    decimal_digits: 0,
    rounding: 0,
    code: "ZMK",
    name_plural: "Zambian kwachas"
  }
};
const currencyCode = {
  US: "USD",
  CA: "CAD",
  DE: "EUR",
  AU: "AUD",
  GB: "GBP",
  KE: "KES",
  IE: "EUR",
  PH: "PHP",
  IT: "EUR",
  HK: "HKD",
  AF: "AFN",
  AX: "EUR",
  AL: "ALL",
  DZ: "DZD",
  AS: "USD",
  AD: "EUR",
  AO: "AOA",
  AI: "USD",
  AQ: "USD",
  AG: "USD",
  AR: "USD",
  AM: "AMD",
  AW: "AWG",
  AT: "EUR",
  AZ: "AZN",
  BS: "USD",
  BD: "BDT",
  BB: "BBD",
  BE: "EUR",
  BZ: "BZD",
  BJ: "XOF",
  BM: "BMD",
  BT: "INR",
  BO: "BOB",
  BA: "BAM",
  BW: "BWP",
  BV: "NOK",
  BR: "BRL",
  IO: "USD",
  BN: "BND",
  BG: "BGN",
  BF: "XOF",
  BI: "BIF",
  KH: "KHR",
  CM: "XAF",
  CV: "CVE",
  KY: "KYD",
  CF: "XAF",
  TD: "XAF",
  CL: "CLP",
  CN: "CNY",
  CX: "AUD",
  CC: "AUD",
  CO: "COP",
  KM: "KMF",
  CG: "XAF",
  CD: "CDF",
  CK: "NZD",
  CR: "CRC",
  CI: "XOF",
  HR: "EUR",
  CY: "EUR",
  CZ: "CZK",
  DK: "DKK",
  DJ: "DJF",
  DM: "XCD",
  DO: "DOP",
  EC: "USD",
  EG: "EGP",
  SV: "USD",
  GQ: "XAF",
  EE: "EUR",
  ET: "ETB",
  FK: "FKP",
  FO: "DKK",
  FJ: "FJD",
  FI: "EUR",
  FR: "EUR",
  GF: "EUR",
  PF: "XPF",
  TF: "EUR",
  GA: "GEL",
  GM: "GMD",
  GE: "GEL",
  GI: "GIP",
  GR: "EUR",
  GL: "DKK",
  GD: "XCD",
  GP: "EUR",
  GU: "EUR",
  GT: "GTQ",
  GG: "GBP",
  GN: "GNF",
  GW: "XOF",
  GY: "GYD",
  HT: "HTG",
  HM: "AUD",
  HN: "HNL",
  HU: "HUF",
  IS: "ISK",
  IN: "INR",
  ID: "IDR",
  IM: "GBP",
  IL: "ILS",
  JD: "JOD",
  JM: "JMD",
  JP: "JPY",
  JE: "GBP",
  KZ: "KZT",
  KI: "AUD",
  KR: "KRW",
  KG: "KGS",
  LA: "LAK",
  LV: "EUR",
  LB: "LBP",
  LS: "LSL",
  LR: "LRD",
  LI: "CHF",
  LT: "EUR",
  LU: "EUR",
  MO: "MOP",
  MK: "MKD",
  MG: "MGA",
  MW: "MWK",
  MY: "MYR",
  MV: "MVR.",
  ML: "XOF",
  MT: "EUR",
  MH: "USD",
  MQ: "EUR",
  MU: "MUR",
  YT: "EUR",
  MX: "MXN",
  FM: "USD",
  MD: "MDL",
  MC: "EUR",
  MN: "MNT",
  ME: "EUR",
  MS: "XCD",
  MA: "MAD",
  MZ: "MZN",
  MM: "MMK",
  NA: "NAD",
  NR: "AUD",
  NP: "NPR",
  NL: "EUR",
  AN: "ANG",
  NC: "XPF",
  NZ: "NZD",
  NI: "NIO",
  NE: "XOF",
  NG: "NGN",
  NU: "NZD",
  NF: "AUD",
  MP: "USD",
  NO: "NOK",
  PK: "PKR",
  PW: "USD",
  PA: "PAB",
  PG: "PGK",
  PY: "PYG",
  PE: "PEN",
  PN: "NZD",
  PL: "PLN",
  PT: "EUR",
  PR: "USD",
  QA: "QAR",
  RE: "EUR",
  RO: "RON",
  RU: "RUB",
  RW: "RWF",
  SH: "SHP",
  KN: "XCD",
  LC: "XCD",
  PM: "EUR",
  VC: "XCD",
  WS: "WST",
  SM: "EUR",
  SA: "SAR",
  SN: "XOF",
  RS: "RSD",
  SC: "SCR",
  SL: "SLL",
  SG: "SGD",
  SK: "EUR",
  SI: "EUR",
  SB: "SBD",
  SO: "SOS",
  ZA: "ZAR",
  ES: "EUR",
  LK: "LKR",
  SD: "SDG",
  SR: "SRD",
  SJ: "NOK",
  SZ: "SZL",
  SE: "SEK",
  CH: "CHF",
  SY: "SYP",
  TW: "TWD",
  TJ: "TJS",
  TZ: "TZS",
  TH: "THB",
  TL: "USD",
  TG: "XOF",
  TK: "NZD",
  TO: "TOP",
  TT: "TTD",
  TR: "TRY",
  TC: "USD",
  TV: "AUD",
  UG: "UGX",
  UA: "UAH",
  AE: "AED",
  UM: "USD",
  UY: "UYU",
  UZ: "UZS",
  VU: "VUV",
  VN: "VND",
  VG: "USD",
  VI: "USD",
  WF: "XPF",
  EH: "MAD",
  YE: "YER",
  ZM: "ZMW",
  KD: "KWD"
};
const getCurrencySymbol = (countryCode) => {
  if (!countryCode) return "";
  return currency[countryCode].symbol || "";
};
const StripeMinimumChargeAmount = {
  USD: 1,
  AED: 2,
  AUD: 1,
  BGN: 1,
  BRL: 1,
  CAD: 1,
  CHF: 1,
  CZK: 15,
  DKK: 2.5,
  EUR: 1,
  GBP: 1,
  HKD: 4,
  HRK: 5,
  HUF: 175,
  INR: 1,
  JPY: 50,
  MXN: 10,
  MYR: 2,
  NOK: 3,
  NZD: 1,
  PLN: 2,
  RON: 2,
  SEK: 3,
  SGD: 1,
  THB: 10,
  ILS: 3,
  PHP: 50,
  ZAR: 10,
  PKR: 150,
  NPR: 100,
  TWD: 20,
  VUV: 70,
  JOD: 0.5,
  IDR: 1e4
};
const _hoisted_1$1G = {
  key: 0,
  class: "flex items-center justify-center flex-col mt-4"
};
const _hoisted_2$1i = ["src"];
const _hoisted_3$1a = ["onClick"];
const _hoisted_4$13 = { class: "flex justify-between" };
const _hoisted_5$V = { class: "flex justify-between mt-8" };
const _hoisted_6$O = { class: "flex" };
const _hoisted_7$J = { class: "ml-3" };
const _sfc_main$1T = /* @__PURE__ */ defineComponent({
  __name: "InvoiceTable",
  props: {
    invoiceData: {
      type: Array,
      required: true
    }
  },
  setup(__props) {
    const t2 = inject("t");
    const props = __props;
    const handleInvoice = async (id) => {
      var _a;
      const link = await BillingService.generateUrl({
        locationId: LocationState.state.locationId,
        id,
        type: "invoice",
        contactId: UserState.state.userId
      });
      await Browser.open({ url: (_a = link == null ? void 0 : link.data) == null ? void 0 : _a.url });
    };
    return (_ctx, _cache) => {
      return props.invoiceData.length === 0 ? (openBlock(), createElementBlock("div", _hoisted_1$1G, [
        createElementVNode("img", {
          src: unref(LANDING_PAGE_IMAGE),
          alt: "arrow"
        }, null, 8, _hoisted_2$1i),
        createVNode(unref(UITextMdMedium), { class: "text-clientportal-font-primary font-sans" }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(unref(t2)("billing.noDataFound")), 1)
          ]),
          _: 1
        })
      ])) : (openBlock(true), createElementBlock(Fragment, { key: 1 }, renderList(props.invoiceData, (invoice) => {
        return openBlock(), createElementBlock("div", {
          key: invoice._id,
          onClick: ($event) => handleInvoice(invoice._id),
          class: "col-span-8 p-6 my-2 rounded-xl bg-clientportal-liteBackground"
        }, [
          createElementVNode("div", _hoisted_4$13, [
            createElementVNode("div", null, [
              createVNode(unref(UITextMdMedium), { class: "text-clientportal-font-primary font-sans" }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(invoice.name), 1)
                ]),
                _: 2
              }, 1024),
              createVNode(unref(UITextXsMedium), { class: "text-clientportal-font-secondary font-sans" }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(unref(t2)("billing.invoiceNo") + " " + invoice.invoiceNumber), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            createVNode(unref(UITag), {
              type: unref(getStatusType)(invoice.status),
              closable: false,
              size: "medium",
              round: true,
              bordered: true
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(unref(capitalizeLetterRemoveUnderscored)(invoice.status)), 1)
              ]),
              _: 2
            }, 1032, ["type"])
          ]),
          createElementVNode("div", _hoisted_5$V, [
            createElementVNode("div", _hoisted_6$O, [
              createElementVNode("div", null, [
                createVNode(unref(UITextSmMedium), { class: "text-clientportal-font-secondary font-sans" }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(unref(t2)("billing.issueDate")), 1)
                  ]),
                  _: 1
                }),
                createVNode(unref(UITextXsMedium), { class: "text-clientportal-font-primary font-sans" }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(unref(formatDate)(invoice.issueDate)), 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              createElementVNode("div", _hoisted_7$J, [
                createVNode(unref(UITextSmMedium), { class: "text-clientportal-font-secondary font-sans" }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(unref(t2)("billing.dueDate")), 1)
                  ]),
                  _: 1
                }),
                createVNode(unref(UITextXsMedium), { class: "text-clientportal-font-primary font-sans" }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(unref(formatDate)(invoice.dueDate)), 1)
                  ]),
                  _: 2
                }, 1024)
              ])
            ]),
            createVNode(unref(UITextLgMedium), { class: "text-clientportal-font-primary font-sans text-left mr-2" }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(unref(getCurrencySymbol)((invoice == null ? void 0 : invoice.currency.toUpperCase()) || "USD")) + " " + toDisplayString(invoice.total), 1)
              ]),
              _: 2
            }, 1024)
          ])
        ], 8, _hoisted_3$1a);
      }), 128));
    };
  }
});
const _hoisted_1$1F = {
  key: 0,
  class: "flex items-center justify-center flex-col mt-4"
};
const _hoisted_2$1h = ["src"];
const _hoisted_3$19 = ["onClick"];
const _hoisted_4$12 = { class: "flex justify-between" };
const _hoisted_5$U = { class: "text-clientportal-font-primary font-sans" };
const _hoisted_6$N = { class: "flex justify-between mt-8" };
const _hoisted_7$I = { class: "flex items-center" };
const _sfc_main$1S = /* @__PURE__ */ defineComponent({
  __name: "SubscriptionTable",
  props: {
    subscriptionData: {
      type: Array,
      required: true
    }
  },
  setup(__props) {
    const routerInstance = AppState.getRouterInstance();
    const t2 = inject("t");
    const props = __props;
    const handleRoutes = (queryValue, subscription) => {
      AppState.state.billingId = subscription._id;
      AppState.state.billingObj = subscription;
      AppState.state.isSubscription = true;
      const currentPath = window.location.pathname;
      if (routerInstance) {
        routerInstance.push({
          path: `${currentPath}`,
          query: { activeScreen: queryValue }
        });
      }
    };
    return (_ctx, _cache) => {
      return props.subscriptionData.length === 0 ? (openBlock(), createElementBlock("div", _hoisted_1$1F, [
        createElementVNode("img", {
          src: unref(LANDING_PAGE_IMAGE),
          alt: "arrow"
        }, null, 8, _hoisted_2$1h),
        createVNode(unref(UITextMdMedium), { class: "text-clientportal-font-primary font-sans" }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(unref(t2)("billing.noDataFound")), 1)
          ]),
          _: 1
        })
      ])) : (openBlock(true), createElementBlock(Fragment, { key: 1 }, renderList(props.subscriptionData, (subscription) => {
        return openBlock(), createElementBlock("div", {
          key: subscription._id,
          onClick: ($event) => handleRoutes("SubscriptionDetail", subscription),
          class: "col-span-8 p-6 my-2 rounded-xl bg-clientportal-liteBackground"
        }, [
          createElementVNode("div", _hoisted_4$12, [
            createElementVNode("div", null, [
              createVNode(unref(UITextMdMedium), { class: "text-clientportal-font-primary font-sans truncate max-w-52" }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(subscription.entitySourceName), 1)
                ]),
                _: 2
              }, 1024),
              createVNode(unref(UITextSmMedium), { class: "text-clientportal-font-secondary font-sans truncate max-w-52" }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(unref(t2)("billing.sourceType")) + " ", 1),
                  createElementVNode("span", _hoisted_5$U, toDisplayString(subscription.entitySourceType), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            createVNode(unref(UITag), {
              type: unref(getStatusType)(subscription.status),
              closable: false,
              size: "medium",
              round: true,
              bordered: true
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(unref(capitalizeLetterRemoveUnderscored)(subscription.status)), 1)
              ]),
              _: 2
            }, 1032, ["type"])
          ]),
          createElementVNode("div", _hoisted_6$N, [
            createElementVNode("div", _hoisted_7$I, [
              createVNode(unref(UITextSmMedium), { class: "text-clientportal-font-secondary font-sans" }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(unref(t2)("billing.created")), 1)
                ]),
                _: 1
              }),
              createVNode(unref(UITextSmMedium), { class: "text-clientportal-font-primary ml-1 font-sans" }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(unref(formatDate)(subscription.createdAt)), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            createVNode(unref(UITextLgMedium), { class: "text-clientportal-font-primary font-sans text-left mr-2" }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(unref(getCurrencySymbol)((subscription == null ? void 0 : subscription.currency.toUpperCase()) || "USD")) + " " + toDisplayString(subscription.amount), 1)
              ]),
              _: 2
            }, 1024)
          ])
        ], 8, _hoisted_3$19);
      }), 128));
    };
  }
});
const _hoisted_1$1E = {
  key: 0,
  class: "flex items-center justify-center flex-col mt-4"
};
const _hoisted_2$1g = ["src"];
const _hoisted_3$18 = ["onClick"];
const _hoisted_4$11 = { class: "flex justify-between" };
const _hoisted_5$T = { class: "text-clientportal-font-secondary font-sans" };
const _hoisted_6$M = { class: "text-clientportal-font-primary font-sans" };
const _hoisted_7$H = { class: "flex justify-between mt-8" };
const _hoisted_8$x = { class: "flex items-center" };
const _sfc_main$1R = /* @__PURE__ */ defineComponent({
  __name: "TransactionTable",
  props: {
    transactionData: {
      type: Array,
      required: true
    }
  },
  setup(__props) {
    const routerInstance = AppState.getRouterInstance();
    const props = __props;
    const t2 = inject("t");
    const handleRoutes = (queryValue, transaction) => {
      AppState.state.billingId = transaction._id;
      AppState.state.transactionObj = transaction;
      AppState.state.isSubscription = false;
      const currentPath = window.location.pathname;
      if (routerInstance) {
        routerInstance.push({
          path: `${currentPath}`,
          query: { activeScreen: queryValue }
        });
      }
    };
    return (_ctx, _cache) => {
      return props.transactionData.length === 0 ? (openBlock(), createElementBlock("div", _hoisted_1$1E, [
        createElementVNode("img", {
          src: unref(LANDING_PAGE_IMAGE),
          alt: "arrow"
        }, null, 8, _hoisted_2$1g),
        createVNode(unref(UITextMdMedium), { class: "text-clientportal-font-primary font-sans" }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(unref(t2)("billing.noDataFound")), 1)
          ]),
          _: 1
        })
      ])) : (openBlock(true), createElementBlock(Fragment, { key: 1 }, renderList(props.transactionData, (transaction) => {
        return openBlock(), createElementBlock("div", {
          key: transaction._id,
          onClick: ($event) => handleRoutes("SubscriptionDetail", transaction),
          class: "col-span-8 p-6 my-2 rounded-xl bg-clientportal-liteBackground"
        }, [
          createElementVNode("div", _hoisted_4$11, [
            createElementVNode("div", null, [
              createVNode(unref(UITextMdMedium), { class: "text-clientportal-font-primary font-sans" }, {
                default: withCtx(() => [
                  createElementVNode("span", _hoisted_5$T, toDisplayString(unref(t2)("billing.tid")), 1),
                  createTextVNode(" " + toDisplayString(transaction._id), 1)
                ]),
                _: 2
              }, 1024),
              createVNode(unref(UITextSmMedium), { class: "text-clientportal-font-secondary font-sans truncate max-w-52" }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(unref(t2)("billing.sourceType")) + " ", 1),
                  createElementVNode("span", _hoisted_6$M, toDisplayString(transaction.entitySourceType), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            createVNode(unref(UITag), {
              type: unref(getStatusType)(transaction.status),
              closable: false,
              size: "medium",
              round: true,
              bordered: true
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(unref(capitalizeLetterRemoveUnderscored)(transaction.status)), 1)
              ]),
              _: 2
            }, 1032, ["type"])
          ]),
          createElementVNode("div", _hoisted_7$H, [
            createElementVNode("div", _hoisted_8$x, [
              createVNode(unref(UITextSmMedium), { class: "text-clientportal-font-secondary font-sans" }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(unref(t2)("billing.transactionDate")), 1)
                ]),
                _: 1
              }),
              createVNode(unref(UITextSmMedium), { class: "text-clientportal-font-primary ml-1 font-sans" }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(unref(formatDate)(transaction.updatedAt)), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            createVNode(unref(UITextLgMedium), { class: "text-clientportal-font-primary font-sans text-left mr-2" }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(unref(getCurrencySymbol)((transaction == null ? void 0 : transaction.currency.toUpperCase()) || "USD")) + " " + toDisplayString(transaction.amount), 1)
              ]),
              _: 2
            }, 1024)
          ])
        ], 8, _hoisted_3$18);
      }), 128));
    };
  }
});
const _hoisted_1$1D = {
  id: "edit-info-navbar",
  class: "fixed left-0 right-0 top-0 z-50 w-full bg-white"
};
const _hoisted_2$1f = { class: "relative z-50 inline-flex w-full bg-white" };
const _hoisted_3$17 = { class: "relative z-50 flex items-center justify-center gap-[13px] bg-white" };
const _hoisted_4$10 = { class: "relative z-50 flex items-start justify-center gap-2.5 bg-white" };
const _hoisted_5$S = { class: "flex items-start justify-start gap-1" };
const _hoisted_6$L = { class: "inline-flex flex-col items-start justify-start" };
const _hoisted_7$G = { key: 0 };
const _hoisted_8$w = { class: "w-full col-span-8 flex justify-between mb-4" };
const _hoisted_9$s = { class: "items-center flex" };
const _hoisted_10$q = { class: "col-span-2 mr-4" };
const _hoisted_11$q = { class: "col-span-6" };
const _hoisted_12$l = { class: "col-span-8 row-span-1 mt-4" };
const _hoisted_13$j = { class: "py-6 px-4" };
const _hoisted_14$f = { class: "flex justify-between" };
const _hoisted_15$c = {
  key: 0,
  class: "bg-clientportal-liteBackground my-4 w-[94%] p-4 rounded-lg"
};
const _hoisted_16$a = { class: "flex items-center justify-between" };
const _hoisted_17$8 = { class: "w-[80%] mr-4 border-solid border-x-0 border-t-0 border-b-1 border-gray-200" };
const _hoisted_18$8 = { class: "w-[80%] mr-4 border-solid border-x-0 border-t-0 border-b-1 border-gray-200" };
const _hoisted_19$7 = { class: "flex mt-3 mr-4 justify-end" };
const _hoisted_20$6 = {
  key: 0,
  class: "flex items-center justify-center h-[40vh]"
};
const _hoisted_21$6 = { key: 1 };
const _hoisted_22$6 = { class: "flex flex-col" };
const _hoisted_23$6 = { class: "p-0" };
const _hoisted_24$6 = { class: "flex justify-between items-center" };
const MOBILE_WIDTH$1 = 768;
const _sfc_main$1Q = /* @__PURE__ */ defineComponent({
  __name: "BillingSubscription",
  setup(__props) {
    const boxRef = ref(null);
    const t2 = inject("t");
    const activeTab = ref(t2.value("billing.subscriptions"));
    const routerInstance = AppState.getRouterInstance();
    const showProfileDrawer = ref(false);
    const filterTitle = ref("");
    const filters = ref({
      checkedValueSubscriptionStatus: "all",
      checkedValueSubscriptionSource: "all",
      checkedValueTransactionStatus: "all",
      checkedValueTransactionSource: "all",
      checkedValueInvoiceStatus: "all",
      startAt: "",
      endAt: ""
    });
    const checkedValue = ref("");
    const drawerOptions = ref([]);
    const isLoading = ref(false);
    const showFilter = ref(false);
    const contactsData = ref();
    const subscriptionData = ref([]);
    const invoiceData = ref([]);
    const currentPageNumber = ref(1);
    const transactionData = ref([]);
    const transactionDataCount = ref(0);
    const subscriptionDataCount = ref(0);
    const invoiceDataCount = ref(0);
    const toDate = ref(null);
    const fromDate = ref(null);
    const originalFiltersOptions = [
      {
        id: t2.value("common.status"),
        title: t2.value("common.status")
      },
      {
        id: t2.value("common.source"),
        title: t2.value("common.source")
      },
      {
        id: t2.value("common.calender"),
        title: t2.value("common.calender")
      }
    ];
    const isFutureDate = (date) => {
      return moment(date).isAfter(moment().format("YYYY-MM-DD"), "day");
    };
    const isDateDisabled = (date) => {
      const minDate = new Date(filters.value.startAt);
      const maxDate = /* @__PURE__ */ new Date();
      return date < minDate || date > maxDate;
    };
    async function onChangeFrom(value) {
      fromDate.value = value;
      if (value === null) {
        filters.value.startAt = "";
        return;
      } else {
        filters.value.startAt = moment(value).format("YYYY-MM-DD");
      }
    }
    async function onChangeTo(value) {
      toDate.value = value;
      if (value === null) {
        filters.value.endAt = "";
        return;
      } else {
        filters.value.endAt = moment(value).format("YYYY-MM-DD");
      }
    }
    const filtersOptions = ref([...originalFiltersOptions]);
    function updateActiveTab(tab) {
      if (tab === t2.value("billing.invoices")) {
        filtersOptions.value = filtersOptions.value.filter(
          (filter) => filter.id !== t2.value("common.source")
        );
      } else {
        filtersOptions.value = [...originalFiltersOptions];
      }
      currentPageNumber.value = 1;
      activeTab.value = tab;
    }
    onMounted(async () => {
      isLoading.value = true;
      await getContactDetails();
      await getSubscriptionData();
      await getInvoiceData();
      await getTransactionData();
      isLoading.value = false;
      setupDatePickerPositionFix();
    });
    const getContactDetails = async () => {
      const data = await UserService.getContactDetails({
        contactId: UserState.state.userId,
        locationId: LocationState.state.locationId
      });
      contactsData.value = data.data;
    };
    const getSubscriptionData = async () => {
      const data = await BillingService.getSubscriptions({
        contactId: UserState.state.userId,
        locationId: LocationState.state.locationId,
        status: filters.value.checkedValueSubscriptionStatus === "all" ? void 0 : filters.value.checkedValueSubscriptionStatus,
        entitySourceType: filters.value.checkedValueSubscriptionSource === "all" ? void 0 : filters.value.checkedValueSubscriptionSource,
        startAt: filters.value.startAt,
        endAt: filters.value.endAt,
        limit: 10,
        offset: (currentPageNumber.value - 1) * 10
      });
      subscriptionData.value = [...subscriptionData.value, ...data.data.data];
      subscriptionDataCount.value = data.data.totalCount;
    };
    const getTransactionData = async () => {
      const data = await BillingService.getTransactions({
        contactId: UserState.state.userId,
        locationId: LocationState.state.locationId,
        status: filters.value.checkedValueTransactionStatus === "all" ? void 0 : filters.value.checkedValueTransactionStatus,
        entitySourceType: filters.value.checkedValueTransactionSource === "all" ? void 0 : filters.value.checkedValueTransactionSource,
        startAt: filters.value.startAt,
        endAt: filters.value.endAt,
        limit: 10,
        offset: (currentPageNumber.value - 1) * 10
      });
      transactionData.value = [...transactionData.value, ...data.data.data];
      transactionDataCount.value = data.data.totalCount;
    };
    const getInvoiceData = async () => {
      const data = await BillingService.getInvoices({
        contactId: UserState.state.userId,
        locationId: LocationState.state.locationId,
        status: filters.value.checkedValueInvoiceStatus === "all" ? void 0 : filters.value.checkedValueInvoiceStatus,
        startAt: filters.value.startAt,
        endAt: filters.value.endAt,
        limit: 10,
        offset: (currentPageNumber.value - 1) * 10
      });
      invoiceData.value = [...invoiceData.value, ...data.data.invoices];
      invoiceDataCount.value = data.data.total;
    };
    const handleChange = (e) => {
      checkedValue.value = e.target.value;
      if (activeTab.value === t2.value("billing.subscriptions")) {
        if (filterTitle.value === t2.value("common.status")) {
          filters.value.checkedValueSubscriptionStatus = e.target.value;
        } else if (filterTitle.value === t2.value("common.source")) {
          filters.value.checkedValueSubscriptionSource = e.target.value;
        }
      } else if (activeTab.value === t2.value("billing.invoices")) {
        if (filterTitle.value === t2.value("common.status")) {
          filters.value.checkedValueInvoiceStatus = e.target.value;
        }
      } else if (activeTab.value === t2.value("transactions.title")) {
        if (filterTitle.value === t2.value("common.status")) {
          filters.value.checkedValueTransactionStatus = e.target.value;
        } else if (filterTitle.value === t2.value("common.source")) {
          filters.value.checkedValueTransactionSource = e.target.value;
        }
      }
    };
    const handleBack = () => {
      var _a;
      if ((_a = window == null ? void 0 : window.history) == null ? void 0 : _a.state.back.includes("AuthPage")) {
        routerInstance.go(-2);
      } else {
        routerInstance.go(-1);
      }
    };
    const handleCheckedData = (value) => {
      if (activeTab.value === t2.value("billing.subscriptions")) {
        if (filterTitle.value === t2.value("common.status")) {
          return filters.value.checkedValueSubscriptionStatus === value;
        } else if (filterTitle.value === t2.value("common.source")) {
          return filters.value.checkedValueSubscriptionSource === value;
        }
      } else if (activeTab.value === t2.value("transactions.title")) {
        if (filterTitle.value === t2.value("common.status")) {
          return filters.value.checkedValueTransactionStatus === value;
        } else if (filterTitle.value === t2.value("common.source")) {
          return filters.value.checkedValueTransactionSource === value;
        }
      } else {
        return filters.value.checkedValueInvoiceStatus === value;
      }
    };
    const handleRoutes = async (queryValue) => {
      const currentPath = window.location.pathname;
      if (routerInstance) {
        routerInstance.push({
          path: `${currentPath}`,
          query: { activeScreen: queryValue }
        });
      }
    };
    const handleFilters = (filter) => {
      filterTitle.value = filter;
      if (filter === t2.value("common.status")) {
        showProfileDrawer.value = true;
        if (activeTab.value === t2.value("billing.subscriptions")) {
          drawerOptions.value = statusSubscriptions;
        } else if (activeTab.value === t2.value("billing.invoices")) {
          drawerOptions.value = statusInvoices;
        } else if (activeTab.value === t2.value("transactions.title")) {
          drawerOptions.value = statusTransactions;
        }
      } else if (filter === t2.value("common.source")) {
        showProfileDrawer.value = true;
        if (activeTab.value === t2.value("billing.subscriptions")) {
          drawerOptions.value = sourceType;
        } else if (activeTab.value === t2.value("transactions.title")) {
          drawerOptions.value = sourceType;
        }
      } else ;
    };
    async function handleScroll(event) {
      const { scrollTop, scrollHeight, clientHeight } = event.target;
      if (scrollTop + clientHeight >= scrollHeight - 5) {
        currentPageNumber.value += 1;
        if (activeTab.value === t2.value("transactions.title") && transactionData.value.length < transactionDataCount.value) {
          await getTransactionData();
        } else if (activeTab.value === t2.value("billing.invoices") && invoiceData.value.length < invoiceDataCount.value) {
          await getInvoiceData();
        } else if (activeTab.value === t2.value("billing.subscriptions") && subscriptionData.value.length < subscriptionDataCount.value) {
          await getSubscriptionData();
        }
      }
    }
    const handleApply = async () => {
      currentPageNumber.value = 1;
      if (activeTab.value === t2.value("billing.subscriptions")) {
        subscriptionData.value = [];
        await getSubscriptionData();
      } else if (activeTab.value === t2.value("billing.invoices")) {
        invoiceData.value = [];
        await getInvoiceData();
      } else if (activeTab.value === t2.value("transactions.title")) {
        transactionData.value = [];
        await getTransactionData();
      }
      showProfileDrawer.value = false;
    };
    const handleClear = async () => {
      filters.value.startAt = "";
      filters.value.endAt = "";
      toDate.value = null;
      fromDate.value = null;
      handleApply();
    };
    const tabs = [
      {
        name: t2.value("billing.subscriptions")
      },
      {
        name: t2.value("billing.invoices")
      },
      {
        name: t2.value("transactions.title")
      }
    ];
    const setupDatePickerPositionFix = () => {
      if (window.innerWidth > MOBILE_WIDTH$1) {
        return;
      }
      const fixDatePickerPosition = () => {
        const datePickerPopups = document.querySelectorAll(
          '.v-binder-follower-content[v-placement="bottom-start"], .v-binder-follower-content[v-placement="bottom-end"]'
        );
        datePickerPopups.forEach((popup) => {
          const htmlElement = popup;
          const currentTransform = htmlElement.style.transform;
          const placement = htmlElement.getAttribute("v-placement");
          if (currentTransform) {
            if (placement === "bottom-start") {
              if (currentTransform.match(/translateX\([^)]+\)/)) {
                htmlElement.style.transform = currentTransform.replace(
                  /translateX\([^)]+\)/,
                  "translateX(0px)"
                );
              }
            } else if (placement === "bottom-end") {
              const translateYMatch = currentTransform.match(/translateY\([^)]+\)/);
              if (translateYMatch) {
                const translateY = translateYMatch[0];
                htmlElement.style.transform = `translateX(0px) ${translateY}`;
              }
            }
          }
        });
      };
      setTimeout(fixDatePickerPosition, 100);
      const observer = new MutationObserver((mutations) => {
        let shouldFix = false;
        mutations.forEach((mutation) => {
          var _a;
          if (mutation.type === "childList") {
            mutation.addedNodes.forEach((node) => {
              var _a2, _b;
              if (node.nodeType === Node.ELEMENT_NODE) {
                const element = node;
                if (((_a2 = element.classList) == null ? void 0 : _a2.contains("v-binder-follower-container")) || ((_b = element.querySelector) == null ? void 0 : _b.call(element, ".v-binder-follower-content"))) {
                  shouldFix = true;
                }
              }
            });
          } else if (mutation.type === "attributes" && mutation.attributeName === "style" && ((_a = mutation.target.classList) == null ? void 0 : _a.contains(
            "v-binder-follower-content"
          ))) {
            shouldFix = true;
          }
        });
        if (shouldFix) {
          setTimeout(fixDatePickerPosition, 10);
        }
      });
      observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ["style"]
      });
    };
    return (_ctx, _cache) => {
      var _a;
      const _directive_swipe = resolveDirective("swipe");
      return openBlock(), createElementBlock(Fragment, null, [
        createElementVNode("div", {
          onScroll: handleScroll,
          class: "flex flex-col h-screen w-full fixed bg-white z-[100] overflow-y-auto"
        }, [
          createElementVNode("div", _hoisted_1$1D, [
            createVNode(unref(UICard), { class: "relative z-50 h-full w-full !rounded-none bg-white" }, {
              default: withCtx(() => [
                createElementVNode("div", _hoisted_2$1f, [
                  createElementVNode("div", _hoisted_3$17, [
                    createElementVNode("div", _hoisted_4$10, [
                      createElementVNode("div", {
                        onClick: handleBack,
                        class: "relative h-6 w-6 cursor-pointer"
                      }, [
                        createVNode(unref(render$6))
                      ])
                    ]),
                    createElementVNode("div", _hoisted_5$S, [
                      createElementVNode("div", _hoisted_6$L, [
                        createVNode(unref(UITextLgMedium), { class: "text-fontPrimary" }, {
                          default: withCtx(() => [
                            createTextVNode(toDisplayString(unref(t2)("billing.billing")) + " " + toDisplayString(unref(t2)("billing.andSubscription")), 1)
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          createElementVNode("div", {
            class: normalizeClass(unref(isGokollab)() ? "mt-10" : "")
          }, [
            !unref(isGokollab)() ? (openBlock(), createElementBlock("div", _hoisted_7$G, [
              createElementVNode("div", {
                ref_key: "boxRef",
                ref: boxRef,
                class: "mt-[50px] py-6 grid grid-cols-8 row-span-1 px-4"
              }, [
                createVNode(unref(UILoadingBar), {
                  ref: "loadingRef",
                  to: boxRef.value
                }, null, 8, ["to"]),
                createElementVNode("div", _hoisted_8$w, [
                  createVNode(unref(UITextMdMedium), { class: "text-clientportal-font-primary font-sans font-semibold" }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(unref(t2)("billing.billingInformation")), 1)
                    ]),
                    _: 1
                  }),
                  createVNode(unref(UITextMdMedium), {
                    class: "text-clientportal-tertiary font-sans font-semibold",
                    onClick: _cache[0] || (_cache[0] = ($event) => handleRoutes("PaymentMethods"))
                  }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(unref(t2)("account.paymentMethod")), 1)
                    ]),
                    _: 1
                  })
                ]),
                createElementVNode("div", _hoisted_9$s, [
                  createElementVNode("div", _hoisted_10$q, [
                    createVNode(unref(UIAvatar), {
                      class: "h-20 w-20",
                      size: "large",
                      src: (_a = unref(UserState).state) == null ? void 0 : _a.avatar
                    }, null, 8, ["src"])
                  ]),
                  createElementVNode("div", _hoisted_11$q, [
                    createVNode(unref(UITextLgMedium), { class: "text-clientportal-font-primary font-sans truncate max-w-[70vw]" }, {
                      default: withCtx(() => {
                        var _a2;
                        return [
                          createTextVNode(toDisplayString((_a2 = unref(UserState).state) == null ? void 0 : _a2.fullName), 1)
                        ];
                      }),
                      _: 1
                    }),
                    createVNode(unref(UITextMdNormal), { class: "text-clientportal-font-secondary font-sans truncate max-w-[70vw]" }, {
                      default: withCtx(() => {
                        var _a2;
                        return [
                          createTextVNode(toDisplayString((_a2 = unref(UserState).state) == null ? void 0 : _a2.email), 1)
                        ];
                      }),
                      _: 1
                    }),
                    createVNode(unref(UITextMdNormal), { class: "text-clientportal-font-secondary font-sans truncate max-w-[70vw]" }, {
                      default: withCtx(() => {
                        var _a2;
                        return [
                          createTextVNode(toDisplayString(((_a2 = contactsData.value) == null ? void 0 : _a2.phone) || "-"), 1)
                        ];
                      }),
                      _: 1
                    })
                  ])
                ]),
                createElementVNode("div", _hoisted_12$l, [
                  createVNode(unref(UITextMdNormal), { class: "text-clientportal-font-primary font-sans" }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(unref(t2)("billing.billingAddress")), 1)
                    ]),
                    _: 1
                  }),
                  createVNode(unref(UITextSmRegular), { class: "mt-2 text-clientportal-font-secondary font-sans truncate max-w-[70vw]" }, {
                    default: withCtx(() => {
                      var _a2;
                      return [
                        createTextVNode(toDisplayString(((_a2 = contactsData.value) == null ? void 0 : _a2.address1) || "-"), 1)
                      ];
                    }),
                    _: 1
                  })
                ])
              ], 512),
              createVNode(unref(UIDivider), {
                class: "!my-0 !px-4",
                titlePlacement: "center",
                dashed: false,
                vertical: false
              })
            ])) : createCommentVNode("", true)
          ], 2),
          createElementVNode("div", _hoisted_13$j, [
            createVNode(unref(UITabs), {
              type: "segment",
              animated: true,
              placement: "top",
              "onUpdate:value": updateActiveTab,
              defaultValue: void 0,
              value: activeTab.value,
              justifyContent: "center",
              size: "medium"
            }, {
              default: withCtx(() => [
                (openBlock(), createElementBlock(Fragment, null, renderList(tabs, (tab) => {
                  return createVNode(unref(UITabPane), {
                    key: tab.name,
                    name: tab.name,
                    tab: tab.name
                  }, {
                    default: withCtx(() => [
                      createElementVNode("div", _hoisted_14$f, [
                        createVNode(unref(UITextMdMedium), { class: "text-clientportal-font-primary font-sans mb-5" }, {
                          default: withCtx(() => [
                            createTextVNode(toDisplayString(tab.name), 1)
                          ]),
                          _: 2
                        }, 1024),
                        createVNode(unref(render$8), {
                          onClick: _cache[1] || (_cache[1] = ($event) => showFilter.value = !showFilter.value),
                          class: "w-6 h-6 text-clientportal-font-secondary"
                        })
                      ]),
                      createVNode(unref(UICollapseTransition), {
                        class: "mb-2",
                        appear: false,
                        show: showFilter.value
                      }, {
                        default: withCtx(() => [
                          (openBlock(true), createElementBlock(Fragment, null, renderList(filtersOptions.value, (option) => {
                            return openBlock(), createBlock(unref(UITag), {
                              key: option.id,
                              class: "ml-2",
                              type: "primary",
                              closable: false,
                              size: "medium",
                              round: true,
                              bordered: true,
                              onClick: ($event) => handleFilters(option.id)
                            }, {
                              default: withCtx(() => [
                                createTextVNode(toDisplayString(option.title), 1)
                              ]),
                              _: 2
                            }, 1032, ["onClick"]);
                          }), 128)),
                          filterTitle.value === unref(t2)("common.calender") ? (openBlock(), createElementBlock("div", _hoisted_15$c, [
                            createElementVNode("div", _hoisted_16$a, [
                              createElementVNode("div", _hoisted_17$8, [
                                createVNode(unref(UIDatepicker), {
                                  class: "date-picker-container",
                                  id: "date-from",
                                  clearable: false,
                                  placeholder: unref(t2)("common.from"),
                                  value: fromDate.value,
                                  format: "MMMM d, yyyy",
                                  isDateDisabled: isFutureDate,
                                  "onUpdate:value": onChangeFrom
                                }, null, 8, ["placeholder", "value", "isDateDisabled"])
                              ]),
                              createElementVNode("div", _hoisted_18$8, [
                                createVNode(unref(UIDatepicker), {
                                  class: "date-picker-container",
                                  id: "date-to",
                                  value: toDate.value,
                                  clearable: false,
                                  placeholder: unref(t2)("common.to"),
                                  format: "MMMM d, yyyy",
                                  isDateDisabled,
                                  "onUpdate:value": onChangeTo
                                }, null, 8, ["value", "placeholder", "isDateDisabled"])
                              ])
                            ]),
                            createElementVNode("div", _hoisted_19$7, [
                              createVNode(unref(UIButton), {
                                id: "clear-btn",
                                type: "default",
                                text: true,
                                class: "text-red-500 mr-4",
                                onClick: handleClear
                              }, {
                                default: withCtx(() => [
                                  createTextVNode(toDisplayString(unref(t2)("common.clear")), 1)
                                ]),
                                _: 1
                              }),
                              createVNode(unref(UIButton), {
                                id: "apply-btn",
                                type: "default",
                                text: true,
                                class: "text-blue-500",
                                onClick: handleApply
                              }, {
                                default: withCtx(() => [
                                  createTextVNode(toDisplayString(unref(t2)("common.apply")), 1)
                                ]),
                                _: 1
                              })
                            ])
                          ])) : createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["show"]),
                      isLoading.value ? (openBlock(), createElementBlock("div", _hoisted_20$6, [
                        createVNode(unref(UISpin), { size: "medium" })
                      ])) : (openBlock(), createElementBlock("div", _hoisted_21$6, [
                        tab.name === unref(t2)("billing.subscriptions") ? (openBlock(), createBlock(_sfc_main$1S, {
                          key: 0,
                          subscriptionData: subscriptionData.value
                        }, null, 8, ["subscriptionData"])) : createCommentVNode("", true),
                        tab.name === unref(t2)("billing.invoices") ? (openBlock(), createBlock(_sfc_main$1T, {
                          key: 1,
                          invoiceData: invoiceData.value
                        }, null, 8, ["invoiceData"])) : createCommentVNode("", true),
                        tab.name === unref(t2)("transactions.title") ? (openBlock(), createBlock(_sfc_main$1R, {
                          key: 2,
                          transactionData: transactionData.value
                        }, null, 8, ["transactionData"])) : createCommentVNode("", true)
                      ]))
                    ]),
                    _: 2
                  }, 1032, ["name", "tab"]);
                }), 64))
              ]),
              _: 1
            }, 8, ["value"])
          ])
        ], 32),
        createVNode(unref(UIDrawer), {
          class: "rounded-t-xl bg-white",
          show: showProfileDrawer.value,
          "onUpdate:show": _cache[2] || (_cache[2] = ($event) => showProfileDrawer.value = $event),
          placement: "bottom",
          id: "image-drawer",
          height: 600
        }, {
          default: withCtx(() => [
            withDirectives((openBlock(), createBlock(unref(UIDrawerContent), {
              id: "image-drawer-menu",
              class: "p-0",
              closable: false
            }, {
              default: withCtx(() => [
                createElementVNode("div", _hoisted_22$6, [
                  _cache[3] || (_cache[3] = createElementVNode("div", { class: "mt-2 h-1 w-16 mb-4 rounded-md border border-solid bg-gray-200 border-gray-200 self-center" }, null, -1)),
                  createElementVNode("div", _hoisted_23$6, [
                    createElementVNode("div", _hoisted_24$6, [
                      createVNode(unref(UITextLgMedium), { class: "text-lg font-semibold mb-4" }, {
                        default: withCtx(() => [
                          createTextVNode(toDisplayString(filterTitle.value), 1)
                        ]),
                        _: 1
                      }),
                      createVNode(unref(UIButton), {
                        id: "apply-btn",
                        text: true,
                        class: "text-base !font-semibold mb-4",
                        onClick: handleApply
                      }, {
                        default: withCtx(() => [
                          createTextVNode(toDisplayString(unref(t2)("common.apply")), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    (openBlock(true), createElementBlock(Fragment, null, renderList(drawerOptions.value, (status) => {
                      return openBlock(), createElementBlock("div", {
                        key: status.value,
                        class: "mb-2"
                      }, [
                        createVNode(unref(UIRadio), {
                          name: "radio-btn",
                          class: "radio-container py-4",
                          checked: handleCheckedData(status.value),
                          id: status.id,
                          onChange: handleChange,
                          value: status.value
                        }, {
                          default: withCtx(() => [
                            createTextVNode(toDisplayString(unref(t2)(status.title)), 1)
                          ]),
                          _: 2
                        }, 1032, ["checked", "id", "value"]),
                        createVNode(unref(UIDivider), {
                          class: "",
                          titlePlacement: "center",
                          dashed: false,
                          vertical: false
                        })
                      ]);
                    }), 128))
                  ])
                ])
              ]),
              _: 1
            })), [
              [_directive_swipe, {
                direction: "down",
                callback: () => showProfileDrawer.value = !showProfileDrawer.value
              }]
            ])
          ]),
          _: 1
        }, 8, ["show"])
      ], 64);
    };
  }
});
const BillingSubscription = /* @__PURE__ */ _export_sfc(_sfc_main$1Q, [["__scopeId", "data-v-820313f8"]]);
const SOCIAL_MEDIA_PLATFORMS = [
  {
    name: "facebook",
    url: "https://www.facebook.com/sharer/sharer.php?u=",
    icon: "https://storage.googleapis.com/revex-certificates-production/assets/shared-certificates-assets/fb.svg"
  },
  // {
  //   name: 'instagram',
  //   url: 'https://www.instagram.com/sharer/sharer.php?u=',
  //   icon: 'https://storage.googleapis.com/revex-certificates-production/assets/shared-certificates-assets/instagram.svg',
  // },
  {
    name: "linkedin",
    url: "https://www.linkedin.com/shareArticle?url=",
    icon: "https://storage.googleapis.com/revex-certificates-production/assets/shared-certificates-assets/linkedin.svg"
  },
  {
    name: "x",
    url: "https://x.com/share?url=",
    icon: "https://storage.googleapis.com/revex-certificates-production/assets/shared-certificates-assets/x.svg"
  },
  // {
  //   name: 'telegram',
  //   url: 'https://t.me/share/url?url=',
  //   icon: 'https://storage.googleapis.com/revex-certificates-production/assets/shared-certificates-assets/telegram.svg',
  // },
  {
    name: "whatsapp",
    url: "https://wa.me/?text=",
    icon: "https://storage.googleapis.com/revex-certificates-production/assets/shared-certificates-assets/whatsapp.svg"
  }
];
var CertificatesPendoEventTypes = /* @__PURE__ */ ((CertificatesPendoEventTypes2) => {
  CertificatesPendoEventTypes2["CERTIFICATE_ISSUED"] = "certificate_issued_events";
  CertificatesPendoEventTypes2["CERTIFICATE_DOWNLOAD"] = "certificate_download_events";
  CertificatesPendoEventTypes2["CERTIFICATE_PREVIEW_PAGE_VIEW"] = "certificate_preview_page_view_events";
  CertificatesPendoEventTypes2["CERTIFICATE_SHARE"] = "certificate_share_events";
  return CertificatesPendoEventTypes2;
})(CertificatesPendoEventTypes || {});
var AuthProvider = /* @__PURE__ */ ((AuthProvider2) => {
  AuthProvider2["GOOGLE"] = "Google";
  return AuthProvider2;
})(AuthProvider || {});
function addAllHtmlEle() {
  let result = "";
  this.forEach((ele) => {
    result += ele.outerHTML;
  });
  return result;
}
const convertDateToCurrentTimeZone = (newDate, currentTimeZone) => {
  const timeZone = currentTimeZone || "UTC";
  const zonedDate = toZonedTime(newDate, timeZone);
  return format(zonedDate, "dd/MM/yyyy", { timeZone });
};
function getPreviewUrl(templateId) {
  const config = AppState.getConfig();
  return `https://${config.certificatesRegistryDomain}/certificates/${templateId}`;
}
const _hoisted_1$1C = {
  key: 0,
  class: "mt-4 w-full col-span-3 text-center"
};
const _hoisted_2$1e = {
  key: 1,
  class: "mt-4 w-full col-span-3 text-center"
};
const _hoisted_3$16 = {
  key: 2,
  class: "mt-4 w-full col-span-3 text-center"
};
const _hoisted_4$$ = {
  key: 3,
  class: "certificates-preview-wrapper max-w-full col-span-3"
};
const _hoisted_5$R = ["innerHTML"];
const _hoisted_6$K = { class: "mt-10 flex w-full items-center justify-center sm:w-[600px]" };
const _hoisted_7$F = { class: "my-4 w-full break-all rounded-lg border border-solid border-gray-200 px-4 py-2" };
const _hoisted_8$v = { class: "flex w-full flex-col items-start justify-center gap-4 sm:w-[600px]" };
const _hoisted_9$r = { class: "flex w-full flex-wrap items-center justify-evenly gap-4 rounded-[10.5px] bg-gray-50 py-3" };
const _hoisted_10$p = ["href", "onClick"];
const _hoisted_11$p = ["src", "alt"];
const _hoisted_12$k = { class: "mx-auto mt-10 flex w-full max-w-[600px] flex-col items-start" };
const _hoisted_13$i = { class: "mt-2 flex w-full items-start gap-2" };
const _hoisted_14$e = { class: "flex flex-1" };
const _hoisted_15$b = { class: "flex flex-col items-start" };
const _hoisted_16$9 = { class: "flex flex-1" };
const _hoisted_17$7 = { class: "flex flex-col items-start" };
const _hoisted_18$7 = {
  key: 4,
  class: "mt-4 w-full col-span-3 text-center"
};
const _sfc_main$1P = /* @__PURE__ */ defineComponent({
  __name: "CertificatesPreview",
  props: ["certificateId", "certificate"],
  setup(__props) {
    const CredentialType = {
      Certificate: "certificate"
    };
    const notification = useNotification();
    const props = __props;
    const t2 = inject("t");
    const loadingCertificate = ref(false);
    const certificateIsExpired = ref(false);
    const certificateExpiryDate = ref("");
    const certificateIssuedDate = ref("");
    const certificateDownloadUrl = ref("");
    const htmlContent = ref(null);
    const credentialType = ref("");
    const currentUrl = getPreviewUrl(props.certificateId);
    const links = ref("");
    const styles = ref("");
    const firstMount = ref(true);
    const certificateNotFound = ref(false);
    const lastWindowSize = ref({
      width: window.innerWidth,
      height: window.innerHeight
    });
    const isCertificate = computed(
      () => credentialType.value === CredentialType.Certificate || !credentialType.value
    );
    function copyUrl(url) {
      window.navigator.clipboard.writeText(url);
      notification.success({
        content: "Link copied successfully",
        duration: 3e3
      });
    }
    const isMobile = ref(false);
    function checkMobileStyling() {
      if (window.innerWidth <= 768) {
        isMobile.value = true;
      } else {
        isMobile.value = false;
      }
    }
    onBeforeUnmount(() => {
      window.removeEventListener("resize", checkMobileStyling);
    });
    onMounted(async () => {
      window.addEventListener("resize", checkMobileStyling);
      checkMobileStyling();
    });
    const adjustCertificateScale = () => {
      try {
        const currentWidth = window.innerWidth;
        const currentHeight = window.innerHeight;
        if (!firstMount.value) {
          if (lastWindowSize.value.width === currentWidth && lastWindowSize.value.height === currentHeight) {
            return;
          }
        } else {
          firstMount.value = false;
        }
        lastWindowSize.value = { width: currentWidth, height: currentHeight };
        const previewWrapper = document.querySelector(
          ".certificates-preview-wrapper"
        );
        const previewContainer = document.querySelector(
          ".certificates-preview-container"
        );
        let certificatePreview = null;
        if (isCertificate.value) {
          certificatePreview = document.querySelector(".certificates-preview");
        } else {
          certificatePreview = document.querySelector(
            ".certificates-preview-container > svg"
          );
        }
        if (!previewWrapper || !previewContainer || !certificatePreview) {
          console.error("Required elements for scaling not found.");
          return;
        }
        const baseWidth = certificatePreview.style.width ? parseInt(certificatePreview.style.width, 10) : certificatePreview.getBoundingClientRect().width || 750;
        const baseHeight = certificatePreview.style.height ? parseInt(certificatePreview.style.height, 10) : certificatePreview.getBoundingClientRect().height || 600;
        const previewHeight = previewWrapper.clientHeight;
        const previewWidth = previewWrapper.clientWidth;
        const scaleWidth = previewWidth / baseWidth;
        const scaleHeight = previewHeight / baseHeight;
        const scale = Math.min(scaleWidth, scaleHeight);
        const adjustedScale = scale > 1 ? 1 : scale || 0.4;
        previewContainer.style.transform = `scale(${adjustedScale})`;
      } catch (error) {
        console.error("Error adjusting certificate scale:", error);
        const previewContainer = document.querySelector(
          ".certificates-preview-container"
        );
        if (previewContainer) {
          let fallbackScale = 0.4;
          if (window.innerWidth <= 480) {
            fallbackScale = 0.3;
          } else if (window.innerWidth <= 768) {
            fallbackScale = 0.5;
          } else if (window.innerWidth <= 1024) {
            fallbackScale = 0.7;
          } else {
            fallbackScale = 1;
          }
          previewContainer.style.transform = `scale(${fallbackScale})`;
        }
      }
    };
    onMounted(async () => {
      window.addEventListener(
        "resize",
        useDebounceFn(function() {
          adjustCertificateScale();
        }, 500)
      );
    });
    onUnmounted(() => {
      window.removeEventListener("resize", adjustCertificateScale);
      window.removeEventListener("resize", checkMobileStyling);
    });
    watch(htmlContent, async () => {
      if (htmlContent.value) {
        await nextTick();
        adjustCertificateScale();
      }
    });
    function isIOSorSafari() {
      const ua = window.navigator.userAgent;
      const isIOS = /iPad|iPhone|iPod/.test(ua) || navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;
      const isSafari = /^((?!chrome|android|crios|fxios|edg|opr).)*safari/i.test(ua);
      return isIOS || isSafari;
    }
    function debugiOSText(content = "") {
      if (!content) return content;
      try {
        const container = document.createElement("div");
        container.innerHTML = content;
        const foreignObjects = container.querySelectorAll("foreignObject");
        foreignObjects.forEach((foreignObj) => {
          const heightAttr = foreignObj.getAttribute("height");
          if (heightAttr && heightAttr.includes("min-content")) {
            const estimatedHeight = 60;
            foreignObj.setAttribute("height", `${estimatedHeight}`);
          }
          const divs = foreignObj.querySelectorAll("div");
          divs.forEach((div) => {
            if (!div.hasAttribute("xmlns")) {
              div.setAttribute("xmlns", "http://www.w3.org/1999/xhtml");
            }
            const style = div.getAttribute("style") || "";
            if (style.includes("min-contentpx")) {
              div.setAttribute("style", style.replace("min-contentpx", "min-content"));
            }
            if (style.includes("background-clip: text") && style.includes("color: transparent")) {
              const newStyle = div.getAttribute("style");
              let fallbackColor = "#000000";
              if (style.includes("linear-gradient")) {
                const gradientMatch = style.match(/linear-gradient\([^)]+\)/i);
                if (gradientMatch) {
                  const gradient = gradientMatch[0];
                  const colorMatch = gradient.match(/#[0-9A-F]{3,6}|rgba?\([^)]+\)|hsla?\([^)]+\)|(?:red|green|blue|white|black|yellow|orange|purple|pink|gray|grey|brown|cyan|magenta|lime|navy|olive|teal|silver|maroon|aqua|fuchsia)\b/ig);
                  if (colorMatch && colorMatch.length > 0) {
                    fallbackColor = colorMatch[colorMatch.length - 1];
                  }
                }
              }
              if (isIOSorSafari()) {
                div.setAttribute(
                  "style",
                  newStyle ? newStyle.replace("color: transparent", `color: ${fallbackColor}`) : ""
                );
              }
            }
          });
        });
        return container.innerHTML;
      } catch (error) {
        console.error("Error fixing iOS foreignObject rendering:", error);
        return content;
      }
    }
    async function processCertificateData(certificate) {
      try {
        loadingCertificate.value = true;
        certificateNotFound.value = false;
        const timeZone = UserState.state.timeZone;
        certificateDownloadUrl.value = certificate.downloadUrl;
        certificateIsExpired.value = certificate.isExpired;
        certificateExpiryDate.value = certificate.expiryAt;
        credentialType.value = certificate == null ? void 0 : certificate.type;
        certificateIssuedDate.value = certificate.createdAt ? convertDateToCurrentTimeZone(certificate.createdAt, timeZone) : "--";
        if (!certificate.downloadUrl) {
          throw new Error("Certificate not found");
        }
        if (certificate.downloadUrl) {
          const content = await CertificateService.getCertificateHtml(certificate.downloadUrl);
          htmlContent.value = isIOSorSafari() ? debugiOSText(content.data) : content.data;
          if (!content.data) {
            throw new Error("Certificate not found");
          }
          const container = document.createElement("div");
          container.innerHTML = htmlContent.value;
          links.value = addAllHtmlEle.call(container.querySelectorAll("link"));
          styles.value = addAllHtmlEle.call(container.querySelectorAll("style"));
        }
      } catch (error) {
        console.error("Error processing certificate data:", error == null ? void 0 : error.message);
        certificateNotFound.value = true;
      } finally {
        loadingCertificate.value = false;
      }
    }
    function pushSharePendoEvent(platform) {
      const id = props.certificateId;
      CertificateService.pushPendoEvents({
        event: CertificatesPendoEventTypes.CERTIFICATE_SHARE,
        eventData: { certificateId: id, platform }
      });
    }
    watch(() => props.certificate, async (newCertificate) => {
      if (newCertificate) {
        await processCertificateData(newCertificate);
      }
    }, {
      deep: true,
      immediate: true
    });
    onMounted(async () => {
      try {
        const id = props.certificateId;
        CertificateService.pushPendoEvents({
          event: CertificatesPendoEventTypes.CERTIFICATE_PREVIEW_PAGE_VIEW,
          eventData: {
            certificateId: id
          }
        });
      } catch (error) {
        console.error("Error pushing pendo event:", error);
      }
    });
    return (_ctx, _cache) => {
      const _component_UITextLgMedium = resolveComponent("UITextLgMedium");
      const _component_UITextSmMedium = resolveComponent("UITextSmMedium");
      return loadingCertificate.value ? (openBlock(), createElementBlock("div", _hoisted_1$1C, [
        createVNode(unref(UISpin), { class: "mt-4" })
      ])) : certificateIsExpired.value ? (openBlock(), createElementBlock("div", _hoisted_2$1e, toDisplayString(unref(t2)("certificates.yourCertificateHasExpiredOn")) + " " + toDisplayString(certificateExpiryDate.value), 1)) : certificateNotFound.value ? (openBlock(), createElementBlock("div", _hoisted_3$16, toDisplayString(unref(t2)("certificates.certificateNotFound")), 1)) : htmlContent.value ? (openBlock(), createElementBlock("div", _hoisted_4$$, [
        createElementVNode("div", {
          class: "certificates-preview-container",
          innerHTML: htmlContent.value
        }, null, 8, _hoisted_5$R),
        createElementVNode("div", _hoisted_6$K, [
          createElementVNode("div", _hoisted_7$F, toDisplayString(unref(currentUrl)), 1),
          createVNode(unref(UIButton), {
            id: "copy-url",
            class: "ml-2",
            text: true,
            onClick: _cache[0] || (_cache[0] = () => copyUrl(unref(currentUrl)))
          }, {
            default: withCtx(() => [
              createVNode(unref(render$9), { class: "h-5 w-5" })
            ]),
            _: 1
          })
        ]),
        createElementVNode("div", _hoisted_8$v, [
          createVNode(_component_UITextLgMedium, null, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(unref(t2)("certificates.shareCertificate")), 1)
            ]),
            _: 1
          }),
          createElementVNode("div", _hoisted_9$r, [
            (openBlock(true), createElementBlock(Fragment, null, renderList(unref(SOCIAL_MEDIA_PLATFORMS), (platform) => {
              return openBlock(), createElementBlock("a", {
                key: platform.name,
                href: `${platform.url}${unref(currentUrl)}`,
                target: "_blank",
                onClick: () => pushSharePendoEvent(platform.name)
              }, [
                createElementVNode("img", {
                  src: platform.icon,
                  alt: `Share on ${platform.name}`,
                  class: "social-icon"
                }, null, 8, _hoisted_11$p)
              ], 8, _hoisted_10$p);
            }), 128))
          ])
        ]),
        createElementVNode("div", _hoisted_12$k, [
          createVNode(unref(UITextMdMedium), { class: "mb-4 font-bold" }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(unref(t2)("certificates.description")), 1)
            ]),
            _: 1
          }),
          createElementVNode("div", _hoisted_13$i, [
            createElementVNode("div", _hoisted_14$e, [
              createVNode(unref(render$a), { class: "mr-2 h-6 w-6" }),
              createElementVNode("div", _hoisted_15$b, [
                createVNode(_component_UITextSmMedium, { class: "font-bold" }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(unref(t2)("certificates.issuedOn")), 1)
                  ]),
                  _: 1
                }),
                createVNode(unref(UITextSmRegular), null, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(certificateIssuedDate.value), 1)
                  ]),
                  _: 1
                })
              ])
            ]),
            createElementVNode("div", _hoisted_16$9, [
              createVNode(unref(render$b), { class: "mr-2 h-6 w-6" }),
              createElementVNode("div", _hoisted_17$7, [
                createVNode(_component_UITextSmMedium, { class: "font-bold" }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(unref(t2)("certificates.expiresOn")), 1)
                  ]),
                  _: 1
                }),
                createVNode(unref(UITextSmRegular), null, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(certificateExpiryDate.value), 1)
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ])) : (openBlock(), createElementBlock("div", _hoisted_18$7, toDisplayString(unref(t2)("certificates.certificateNotFound")), 1));
    };
  }
});
const _hoisted_1$1B = { class: "flex flex-col h-screen w-full fixed bg-white z-[100]" };
const _hoisted_2$1d = {
  id: "edit-profile-navbar",
  class: "fixed left-0 right-0 top-0 z-50 w-full bg-white"
};
const _hoisted_3$15 = { class: "relative z-50 inline-flex w-full bg-white" };
const _hoisted_4$_ = { class: "relative z-50 flex items-center justify-center gap-[13px] bg-white" };
const _hoisted_5$Q = { class: "relative z-50 flex items-start justify-center gap-2.5 bg-white" };
const _hoisted_6$J = { class: "flex items-start justify-start gap-1" };
const _hoisted_7$E = { class: "inline-flex flex-col items-start justify-start" };
const _hoisted_8$u = { class: "text-lg font-medium text-slate-700" };
const _hoisted_9$q = { class: "flex grow items-center justify-end" };
const _hoisted_10$o = { class: "flex items-start justify-start gap-4" };
const _hoisted_11$o = {
  key: 0,
  class: "relative cursor-pointer",
  onClick: () => {
  }
};
const _hoisted_12$j = { class: "w-full col-span-3 grid grid-cols-3 row-span-1 px-4 py-6 content" };
const _hoisted_13$h = {
  key: 0,
  class: "w-full col-span-3"
};
const _hoisted_14$d = { class: "w-full col-span-3" };
const _hoisted_15$a = {
  key: 0,
  class: "w-full h-screen col-span-3 mt-6"
};
const _hoisted_16$8 = { class: "flex flex-col gap-8 items-center justify-center h-1/2" };
const _hoisted_17$6 = ["src"];
const _hoisted_18$6 = { class: "w-full col-span-3 mt-6" };
const _hoisted_19$6 = ["onClick"];
const _hoisted_20$5 = { class: "flex flex-row gap-4 items-center" };
const _hoisted_21$5 = ["src"];
const _hoisted_22$5 = { class: "flex flex-col items-start" };
const _hoisted_23$5 = { class: "text-primary-500" };
const _hoisted_24$5 = {
  key: 1,
  class: "w-full col-span-3 mt-6"
};
const _hoisted_25$4 = { class: "flex items-center justify-center" };
const _hoisted_26$3 = {
  key: 2,
  class: "w-full col-span-3 mt-4"
};
const _hoisted_27$2 = { class: "flex items-center justify-center" };
const _hoisted_28$2 = {
  key: 1,
  class: "w-full col-span-3"
};
const _sfc_main$1O = /* @__PURE__ */ defineComponent({
  __name: "CertificatesListing",
  setup(__props) {
    const routerInstance = AppState.getRouterInstance();
    const t2 = inject("t");
    const selectedCertificate = ref({});
    const pdfDownloadLoading = ref(false);
    const isListingLoading = ref(false);
    const isLoadingMore = ref(false);
    const issuedCertificates = ref([]);
    const currentPageNumber = ref(1);
    const pageSize = ref(10);
    const mobileScrollContainer = ref();
    const isModePreview = ref(false);
    const currentDownloadingCertificateId = ref("");
    const totalIssuedCertificates = ref(0);
    const hasMoreCertificates = ref(true);
    useInfiniteScroll(
      mobileScrollContainer,
      async () => {
        if (!hasMoreCertificates.value || isLoadingMore.value || isListingLoading.value) return;
        currentPageNumber.value++;
        await getIssuedCertificatesByLocationId(currentPageNumber.value);
      },
      {
        distance: 100,
        canLoadMore: () => hasMoreCertificates.value && !isLoadingMore.value && !isListingLoading.value
      }
    );
    const downloadCertificate = async (event, certificate) => {
      event == null ? void 0 : event.stopPropagation();
      const id = certificate == null ? void 0 : certificate._id;
      if (!id || (certificate == null ? void 0 : certificate.isExpired)) return;
      currentDownloadingCertificateId.value = id;
      pdfDownloadLoading.value = true;
      try {
        const fileData = await getFileData(certificate);
        if (!fileData) return;
        if (Capacitor.isNativePlatform()) {
          await shareFileOnNativePlatform(fileData);
        } else {
          downloadFileOnWeb(fileData);
        }
        CertificateService.pushPendoEvents({
          event: CertificatesPendoEventTypes.CERTIFICATE_DOWNLOAD,
          eventData: {
            certificateId: id
          }
        });
      } catch (error) {
        console.error("Error while downloading certificate:", error.message);
      } finally {
        pdfDownloadLoading.value = false;
      }
    };
    async function getFileData(certificate) {
      const { downloadUrl, credentialImage } = certificate;
      if (!downloadUrl && !credentialImage) return null;
      if (credentialImage) {
        const response = await axios.get(credentialImage, { responseType: "arraybuffer" });
        return response.data;
      } else {
        const { data } = await CertificateService.getCertificateFile(certificate._id, downloadUrl);
        return data;
      }
    }
    async function shareFileOnNativePlatform(fileData) {
      const fileName = `certificate-${format$1(/* @__PURE__ */ new Date(), "yyyy-MM-dd-HH-mm-ss")}.png`;
      const blob = new Blob([fileData], { type: "image/png" });
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = async function() {
          try {
            const base64data = reader.result;
            const base64Content = base64data.split(",")[1];
            const result = await Filesystem.writeFile({
              path: fileName,
              data: base64Content,
              directory: Directory.Cache,
              recursive: true
            });
            await Share.share({
              title: t2.value("certificates.share.title"),
              text: t2.value("certificates.share.text"),
              url: result.uri,
              dialogTitle: t2.value("certificates.share.dialogTitle")
            });
            resolve(true);
          } catch (fileError) {
            console.error("Error saving file:", fileError);
            reject(fileError);
          }
        };
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    }
    function downloadFileOnWeb(fileData) {
      const url = window.URL.createObjectURL(
        new Blob([fileData], { type: "image/png" })
      );
      const a = document.createElement("a");
      a.href = url;
      a.download = `certificate-${format$1(/* @__PURE__ */ new Date(), "yyyy-MM-dd-HH-mm-ss")}.png`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    }
    function onClickCertificateCard(certificate) {
      selectedCertificate.value = certificate;
      isModePreview.value = true;
    }
    async function getIssuedCertificatesByLocationId(pageNumber) {
      try {
        if (pageNumber === 1) {
          isListingLoading.value = true;
        } else {
          isLoadingMore.value = true;
        }
        const offset = ((pageNumber || 1) - 1) * pageSize.value;
        const { data } = await CertificateService.getCertificatesByContact(
          LocationState.state.locationId,
          UserState.state.userId,
          offset,
          pageNumber,
          pageSize.value
        );
        const newCertificates = (data == null ? void 0 : data.issuedCertificates) || [];
        if (pageNumber === 1) {
          issuedCertificates.value = newCertificates;
          totalIssuedCertificates.value = (data == null ? void 0 : data.totalCount) || 0;
        } else {
          const existingIds = new Set(issuedCertificates.value.map((cert) => cert._id));
          const uniqueNewCertificates = newCertificates.filter((cert) => !existingIds.has(cert._id));
          issuedCertificates.value = [...issuedCertificates.value, ...uniqueNewCertificates];
        }
        hasMoreCertificates.value = issuedCertificates.value.length < totalIssuedCertificates.value;
      } catch (error) {
        console.error("Error in getIssuedCertificatesByLocationId:", error);
        hasMoreCertificates.value = false;
      } finally {
        isListingLoading.value = false;
        isLoadingMore.value = false;
      }
    }
    function onBackButtonClick() {
      var _a;
      if ((_a = selectedCertificate.value) == null ? void 0 : _a._id) {
        selectedCertificate.value = {};
        isModePreview.value = false;
      } else if (routerInstance) {
        routerInstance.go(-1);
      }
    }
    onMounted(async () => {
      await getIssuedCertificatesByLocationId(currentPageNumber.value);
    });
    return (_ctx, _cache) => {
      var _a;
      return openBlock(), createElementBlock("div", _hoisted_1$1B, [
        createElementVNode("div", _hoisted_2$1d, [
          createVNode(unref(UICard), { class: "relative z-50 h-full w-full !rounded-none bg-white" }, {
            default: withCtx(() => {
              var _a2, _b;
              return [
                createElementVNode("div", _hoisted_3$15, [
                  createElementVNode("div", _hoisted_4$_, [
                    createElementVNode("div", _hoisted_5$Q, [
                      createElementVNode("div", {
                        onClick: onBackButtonClick,
                        class: "relative h-5 w-5 cursor-pointer"
                      }, [
                        createVNode(unref(render$6))
                      ])
                    ]),
                    createElementVNode("div", _hoisted_6$J, [
                      createElementVNode("div", _hoisted_7$E, [
                        createElementVNode("div", _hoisted_8$u, toDisplayString(unref(t2)("certificates.title")), 1)
                      ])
                    ])
                  ]),
                  createElementVNode("div", _hoisted_9$q, [
                    createElementVNode("div", _hoisted_10$o, [
                      isModePreview.value ? (openBlock(), createElementBlock("div", _hoisted_11$o, [
                        pdfDownloadLoading.value ? (openBlock(), createBlock(unref(UISpin), {
                          key: 0,
                          size: "small"
                        })) : (openBlock(), createBlock(unref(UIButton), {
                          key: 1,
                          id: "details-save-btn",
                          onClick: _cache[0] || (_cache[0] = (event) => downloadCertificate(event, selectedCertificate.value)),
                          class: "text-primary-500 text-lg",
                          disabled: !((_a2 = selectedCertificate.value) == null ? void 0 : _a2._id) || ((_b = selectedCertificate.value) == null ? void 0 : _b.isExpired),
                          text: true
                        }, {
                          default: withCtx(() => [
                            createTextVNode(toDisplayString(unref(t2)("common.download")), 1)
                          ]),
                          _: 1
                        }, 8, ["disabled"]))
                      ])) : createCommentVNode("", true)
                    ])
                  ])
                ])
              ];
            }),
            _: 1
          })
        ]),
        createElementVNode("div", {
          id: "mobile-scroll-container",
          ref_key: "mobileScrollContainer",
          ref: mobileScrollContainer,
          class: "mt-[50px] w-full overflow-y-auto flex"
        }, [
          createElementVNode("div", _hoisted_12$j, [
            !isModePreview.value ? (openBlock(), createElementBlock("div", _hoisted_13$h, [
              createElementVNode("div", _hoisted_14$d, [
                createVNode(unref(UITextMdMedium), null, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(unref(t2)("certificates.subtitle")), 1)
                  ]),
                  _: 1
                })
              ]),
              !isListingLoading.value && issuedCertificates.value.length === 0 ? (openBlock(), createElementBlock("div", _hoisted_15$a, [
                createElementVNode("div", _hoisted_16$8, [
                  createElementVNode("img", {
                    src: unref(NO_CERTIFICATES_THUMBNAIL),
                    alt: "no-certificates",
                    class: "w-1/2"
                  }, null, 8, _hoisted_17$6),
                  createVNode(unref(UITextMdMedium), { class: "text-gray-500" }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(unref(t2)("certificates.issuedCertificatesNotFound")), 1)
                    ]),
                    _: 1
                  })
                ])
              ])) : createCommentVNode("", true),
              createElementVNode("div", _hoisted_18$6, [
                (openBlock(true), createElementBlock(Fragment, null, renderList(issuedCertificates.value, (certificate) => {
                  return openBlock(), createElementBlock("div", {
                    class: "max-w-full px-4 py-[22px] bg-gray-50 rounded-[10.5px] flex items-center justify-between cursor-pointer mb-4",
                    key: certificate == null ? void 0 : certificate._id,
                    onClick: ($event) => onClickCertificateCard(certificate)
                  }, [
                    createElementVNode("div", _hoisted_20$5, [
                      createElementVNode("img", {
                        src: (certificate == null ? void 0 : certificate.credentialImage) || unref(DEFAULT_CERTIFICATE_THUMBNAIL),
                        alt: "certificate-thumbnail",
                        class: "min-w-20 max-w-20 h-16 rounded-lg border border-gray-200"
                      }, null, 8, _hoisted_21$5),
                      createElementVNode("div", _hoisted_22$5, [
                        createVNode(unref(UITextSmMedium), { class: "" }, {
                          default: withCtx(() => {
                            var _a2, _b;
                            return [
                              createTextVNode(toDisplayString(unref(truncateString)((_b = (_a2 = certificate == null ? void 0 : certificate.meta) == null ? void 0 : _a2.membership) == null ? void 0 : _b.productTitle, 60)), 1)
                            ];
                          }),
                          _: 2
                        }, 1024),
                        createVNode(unref(UITextXsRegular), { class: "text-gray-400" }, {
                          default: withCtx(() => [
                            createTextVNode(toDisplayString(unref(t2)("certificates.issuedOn")) + " ", 1),
                            createElementVNode("span", _hoisted_23$5, toDisplayString(unref(format$1)(new Date(certificate == null ? void 0 : certificate.createdAt), "dd MMM yyyy")), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ])
                    ]),
                    pdfDownloadLoading.value && (certificate == null ? void 0 : certificate._id) === currentDownloadingCertificateId.value ? (openBlock(), createBlock(unref(UISpin), {
                      key: 0,
                      size: "small"
                    })) : (openBlock(), createBlock(unref(render$c), {
                      key: 1,
                      class: "min-w-6 h-6 text-gray-400 cursor-pointer",
                      onClick: (event) => downloadCertificate(event, certificate)
                    }, null, 8, ["onClick"]))
                  ], 8, _hoisted_19$6);
                }), 128))
              ]),
              isListingLoading.value ? (openBlock(), createElementBlock("div", _hoisted_24$5, [
                createElementVNode("div", _hoisted_25$4, [
                  createVNode(unref(UISpin), { size: "medium" })
                ])
              ])) : createCommentVNode("", true),
              isLoadingMore.value ? (openBlock(), createElementBlock("div", _hoisted_26$3, [
                createElementVNode("div", _hoisted_27$2, [
                  createVNode(unref(UISpin), { size: "small" })
                ])
              ])) : createCommentVNode("", true)
            ])) : (openBlock(), createElementBlock("div", _hoisted_28$2, [
              createVNode(_sfc_main$1P, {
                "certificate-id": (_a = selectedCertificate.value) == null ? void 0 : _a._id,
                certificate: selectedCertificate.value
              }, null, 8, ["certificate-id", "certificate"])
            ]))
          ])
        ], 512)
      ]);
    };
  }
});
const CertificatesListing = /* @__PURE__ */ _export_sfc(_sfc_main$1O, [["__scopeId", "data-v-c7158693"]]);
class CommunitiesChatsState {
  constructor() {
    __publicField(this, "state", reactive({
      userGroups: new Array(),
      blockedConversations: new Array(),
      isBlockedUsersNextPageAvailable: true
    }));
  }
  async fetchUserGroups(locationId) {
    try {
      if (this.state.userGroups.length > 0) return;
      const userGroups = await CommunitiesService.getUsersGroup(locationId);
      for (const group of userGroups) {
        group.isChatDisabled = group.isChatDisabled ? group.isChatDisabled : false;
      }
      this.state.userGroups = userGroups;
    } catch (e) {
      console.error(e);
    }
  }
  async fetchBlockedUsers(locationId, previousId) {
    try {
      if (!this.state.isBlockedUsersNextPageAvailable) return;
      if (!previousId && this.state.blockedConversations.length > 0) {
        return;
      }
      if (previousId && previousId != this.state.blockedConversations.at(-1)._id) {
        return;
      }
      const blockedUsers = await CommunitiesService.getBlockedUsers(
        locationId,
        {
          limit: 100,
          previousId,
          sort: "ascending"
        }
      );
      this.state.blockedConversations.push(...blockedUsers);
      if ((blockedUsers == null ? void 0 : blockedUsers.length) < 10) {
        this.state.isBlockedUsersNextPageAvailable = false;
      }
    } catch (e) {
      console.error(e);
    }
  }
  async unblockConversation(locationId, conversationId) {
    this.state.blockedConversations = this.state.blockedConversations.filter(
      (c) => c._id !== conversationId
    );
    await CommunitiesService.unblockConversation(locationId, conversationId);
  }
  async updateChatPreference(locationId, groupId, isChatDisabled) {
    try {
      await CommunitiesService.toggleChatPreference(locationId, groupId, {
        isChatDisabled
      });
      return true;
    } catch (e) {
      console.error(e);
    }
  }
}
const CommunitiesChatState = new CommunitiesChatsState();
const __default__$f = {
  name: "MobileScrollContainer"
};
const _sfc_main$1N = /* @__PURE__ */ defineComponent({
  ...__default__$f,
  props: {
    enablePullToRefresh: {
      type: Boolean,
      default: true
      // Default true for backward compatibility
    }
  },
  setup(__props) {
    const props = __props;
    const mobileScrollContainer = ref(null);
    let PTRPlugin;
    const isPullToRefreshAvailable = ref(
      Capacitor.isPluginAvailable("PullToRefresh")
    );
    const isPullToRefreshEnabled = ref(true);
    const handleScroll = () => {
      if (Capacitor.getPlatform() != CAPACITOR_PLATFORM.ANDROID && !mobileScrollContainer.value)
        return;
      const shouldBeEnabled = mobileScrollContainer.value.scrollTop === 0 && props.enablePullToRefresh;
      if (shouldBeEnabled !== isPullToRefreshEnabled.value) {
        isPullToRefreshEnabled.value = shouldBeEnabled;
        try {
          PTRPlugin.enablePullToRefresh({ value: shouldBeEnabled });
        } catch (error) {
          console.error("Error setting up pull to refresh", error);
        }
      }
    };
    onMounted(() => {
      if (isPullToRefreshAvailable.value) {
        PTRPlugin = registerPlugin("PullToRefresh");
        if (mobileScrollContainer.value) {
          mobileScrollContainer.value.addEventListener("scroll", handleScroll);
        }
      }
    });
    onUnmounted(() => {
      if (isPullToRefreshAvailable.value) {
        if (mobileScrollContainer.value) {
          mobileScrollContainer.value.removeEventListener("scroll", handleScroll);
        }
      }
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        id: "mobile-scroll-container",
        ref_key: "mobileScrollContainer",
        ref: mobileScrollContainer,
        class: "overflow-y-auto overflow-x-hidden"
      }, [
        renderSlot(_ctx.$slots, "scroll-slot")
      ], 512);
    };
  }
});
const _hoisted_1$1A = { class: "flex flex-col h-screen w-full fixed bg-white z-[100] overflow-y-auto" };
const _hoisted_2$1c = {
  id: "edit-info-navbar",
  class: "fixed left-0 right-0 top-0 z-50 w-full bg-white"
};
const _hoisted_3$14 = { class: "relative z-50 inline-flex w-full bg-white" };
const _hoisted_4$Z = { class: "relative z-50 flex items-center justify-center gap-[13px] bg-white" };
const _hoisted_5$P = { class: "relative z-50 flex items-start justify-center gap-2.5 bg-white" };
const _hoisted_6$I = { class: "flex items-start justify-start gap-1" };
const _hoisted_7$D = { class: "inline-flex flex-col items-start justify-start" };
const _hoisted_8$t = { class: "text-lg font-medium leading-7 text-slate-700" };
const _hoisted_9$p = { class: "flex w-full flex-col gap-10" };
const _hoisted_10$n = { class: "grid w-full grid-cols-5 items-center" };
const _hoisted_11$n = { class: "col-span-3 flex flex-col" };
const _hoisted_12$i = {
  key: 0,
  class: "flex justify-center justify-self-end self-start col-span-2"
};
const _hoisted_13$g = {
  key: 0,
  class: "ml-3"
};
const _hoisted_14$c = ["id"];
const _hoisted_15$9 = { class: "col-span-4 flex flex-row items-center gap-3" };
const _hoisted_16$7 = {
  key: 2,
  class: "self-center"
};
const _hoisted_17$5 = { class: "flex w-full flex-col gap-10" };
const _hoisted_18$5 = { class: "grid w-full grid-cols-5 items-center" };
const _hoisted_19$5 = { class: "col-span-3 flex flex-col" };
const _hoisted_20$4 = {
  key: 0,
  class: "flex justify-center justify-self-end self-start col-span-2"
};
const _hoisted_21$4 = {
  key: 0,
  class: "ml-3"
};
const _hoisted_22$4 = ["id"];
const _hoisted_23$4 = { class: "col-span-4 flex flex-row items-center gap-3" };
const _hoisted_24$4 = { class: "place-self-center pr-5" };
const _hoisted_25$3 = ["id", "onClick"];
const _hoisted_26$2 = {
  key: 2,
  class: "self-center"
};
const maxVisibleItems = 3;
const _sfc_main$1M = /* @__PURE__ */ defineComponent({
  __name: "ChatSettings",
  setup(__props) {
    const routerInstance = AppState.getRouterInstance();
    const isLoading = ref(false);
    const showAllGroups = ref(false);
    const showAllBlockedUsers = ref(false);
    const isListLoading = ref(false);
    const t2 = inject("t");
    onMounted(async () => {
      isListLoading.value = true;
      await Promise.all([
        CommunitiesChatState.fetchUserGroups(LocationState.state.locationId),
        CommunitiesChatState.fetchBlockedUsers(LocationState.state.locationId)
      ]);
      isListLoading.value = false;
    });
    const visibleGroups = computed(() => {
      return showAllGroups.value ? CommunitiesChatState.state.userGroups : CommunitiesChatState.state.userGroups.slice(0, maxVisibleItems);
    });
    const visibleBlockedConversations = computed(() => {
      return showAllBlockedUsers.value ? CommunitiesChatState.state.blockedConversations : CommunitiesChatState.state.blockedConversations.slice(0, maxVisibleItems);
    });
    function toggleShowAllGroups() {
      showAllGroups.value = !showAllGroups.value;
    }
    function toggleShowAllBlockedUsers() {
      showAllBlockedUsers.value = !showAllBlockedUsers.value;
    }
    function unblockConversation(conversationId) {
      CommunitiesChatState.unblockConversation(
        LocationState.state.locationId,
        conversationId
      );
    }
    const notification = useNotification();
    function notificationAlert(title, content) {
      notification.create({
        title,
        content,
        duration: 5e3
      });
    }
    async function updateChatPreference(userGroup, isChatDisabled) {
      try {
        await CommunitiesChatState.updateChatPreference(
          LocationState.state.locationId,
          userGroup.groupId,
          isChatDisabled
        );
        notificationAlert(t2.value("chats.updatedPreference") + userGroup.name, "");
      } catch (e) {
        console.error(e);
      } finally {
        isLoading.value = false;
      }
    }
    return (_ctx, _cache) => {
      const _component_UISkeleton = resolveComponent("UISkeleton");
      return openBlock(), createElementBlock("div", _hoisted_1$1A, [
        createElementVNode("div", _hoisted_2$1c, [
          createVNode(unref(UICard), { class: "relative z-50 h-full w-full !rounded-none bg-white" }, {
            default: withCtx(() => [
              createElementVNode("div", _hoisted_3$14, [
                createElementVNode("div", _hoisted_4$Z, [
                  createElementVNode("div", _hoisted_5$P, [
                    createElementVNode("div", {
                      onClick: _cache[0] || (_cache[0] = () => {
                        if (unref(routerInstance)) {
                          unref(routerInstance).back();
                        }
                      }),
                      class: "relative h-6 w-6 cursor-pointer"
                    }, [
                      createVNode(unref(render$6))
                    ])
                  ]),
                  createElementVNode("div", _hoisted_6$I, [
                    createElementVNode("div", _hoisted_7$D, [
                      createElementVNode("div", _hoisted_8$t, toDisplayString(unref(t2)("chats.chatSettings")), 1)
                    ])
                  ])
                ])
              ])
            ]),
            _: 1
          })
        ]),
        createVNode(_sfc_main$1N, { class: "overflow-y-auto overflow-x-hidden flex flex-col gap-8 mt-[50px] py-6 px-4" }, {
          "scroll-slot": withCtx(() => [
            createElementVNode("div", _hoisted_9$p, [
              createElementVNode("div", _hoisted_10$n, [
                createElementVNode("div", _hoisted_11$n, [
                  createVNode(unref(UITextMdMedium), { class: "text-clientportal-font-primary font-semibold" }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(unref(t2)("chats.groups")), 1)
                    ]),
                    _: 1
                  }),
                  createVNode(unref(UITextXsRegular), { class: "text-clientportal-font-secondary" }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(unref(t2)("chats.controlGroups")), 1)
                    ]),
                    _: 1
                  })
                ]),
                unref(CommunitiesChatState).state.userGroups.length > maxVisibleItems ? (openBlock(), createElementBlock("div", _hoisted_12$i, [
                  createElementVNode("div", {
                    onClick: toggleShowAllGroups,
                    class: "flex cursor-pointer flex-row gap-2 text-clientportal-font-primary"
                  }, [
                    createVNode(unref(UITextSmMedium), { class: "font-semibold" }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(showAllGroups.value ? "View Less" : "View All"), 1)
                      ]),
                      _: 1
                    }),
                    !showAllGroups.value ? (openBlock(), createBlock(unref(render$d), {
                      key: 0,
                      class: "h-5 w-5"
                    })) : (openBlock(), createBlock(unref(render$e), {
                      key: 1,
                      class: "h-5 w-5"
                    }))
                  ])
                ])) : createCommentVNode("", true)
              ]),
              isListLoading.value ? (openBlock(), createElementBlock("div", _hoisted_13$g, [
                createVNode(_component_UISkeleton, { class: "my-4 h-6 w-[75%]" }),
                createVNode(_component_UISkeleton, { class: "my-4 h-6 w-[75%]" }),
                createVNode(_component_UISkeleton, { class: "my-4 h-6 w-[75%]" })
              ])) : visibleGroups.value.length > 0 ? (openBlock(true), createElementBlock(Fragment, { key: 1 }, renderList(visibleGroups.value, (group) => {
                var _a;
                return openBlock(), createElementBlock("div", {
                  key: group._id,
                  id: group._id,
                  class: "ml-3 grid w-full grid-cols-5 items-center"
                }, [
                  createElementVNode("div", _hoisted_15$9, [
                    createVNode(unref(UIAvatar), {
                      round: false,
                      size: 40,
                      src: ((_a = group == null ? void 0 : group.branding) == null ? void 0 : _a.logo) ?? "https://storage.googleapis.com/highlevel-staging.appspot.com/communities/sTPu59jO68qjLE5h10Ny/groups/255f2156-6614-4f6c-9229-b014960fd2aa"
                    }, null, 8, ["src"]),
                    createVNode(unref(UITextMdMedium), { class: "text-clientportal-font-primary" }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(group.name), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  createVNode(unref(UISwitch), {
                    value: group.isChatDisabled,
                    "onUpdate:value": [($event) => group.isChatDisabled = $event, ($event) => updateChatPreference(group, $event)],
                    uncheckedValue: true,
                    checkedValue: false
                  }, null, 8, ["value", "onUpdate:value"])
                ], 8, _hoisted_14$c);
              }), 128)) : (openBlock(), createElementBlock("div", _hoisted_16$7, [
                createVNode(unref(UITextXsRegular), { class: "text-clientportal-font-secondary italic" }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(unref(t2)("chats.noGroupsJoined")), 1)
                  ]),
                  _: 1
                })
              ]))
            ]),
            createElementVNode("div", _hoisted_17$5, [
              createElementVNode("div", _hoisted_18$5, [
                createElementVNode("div", _hoisted_19$5, [
                  createVNode(unref(UITextMdMedium), { class: "text-clientportal-font-primary font-semibold" }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(unref(t2)("chats.blockedUsers")), 1)
                    ]),
                    _: 1
                  }),
                  createVNode(unref(UITextXsRegular), { class: "text-clientportal-font-secondary" }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(unref(t2)("chats.controlUsers")), 1)
                    ]),
                    _: 1
                  })
                ]),
                unref(CommunitiesChatState).state.blockedConversations.length > maxVisibleItems ? (openBlock(), createElementBlock("div", _hoisted_20$4, [
                  createElementVNode("div", {
                    onClick: toggleShowAllBlockedUsers,
                    class: "flex cursor-pointer flex-row gap-2 text-clientportal-font-primary"
                  }, [
                    createVNode(unref(UITextSmMedium), { class: "font-semibold" }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(showAllBlockedUsers.value ? unref(t2)("chats.viewLess") : unref(t2)("chats.viewAll")), 1)
                      ]),
                      _: 1
                    }),
                    !showAllBlockedUsers.value ? (openBlock(), createBlock(unref(render$d), {
                      key: 0,
                      class: "h-5 w-5"
                    })) : (openBlock(), createBlock(unref(render$e), {
                      key: 1,
                      class: "h-5 w-5"
                    }))
                  ])
                ])) : createCommentVNode("", true)
              ]),
              isListLoading.value ? (openBlock(), createElementBlock("div", _hoisted_21$4, [
                createVNode(_component_UISkeleton, { class: "my-4 h-6 w-[75%]" }),
                createVNode(_component_UISkeleton, { class: "my-4 h-6 w-[75%]" }),
                createVNode(_component_UISkeleton, { class: "my-4 h-6 w-[75%]" })
              ])) : visibleBlockedConversations.value.length > 0 ? (openBlock(true), createElementBlock(Fragment, { key: 1 }, renderList(visibleBlockedConversations.value, (conversation) => {
                var _a, _b;
                return openBlock(), createElementBlock("div", {
                  key: conversation._id,
                  id: conversation._id,
                  class: "ml-3 grid w-full grid-cols-5 items-center justify-center"
                }, [
                  createElementVNode("div", _hoisted_23$4, [
                    ((_a = conversation == null ? void 0 : conversation.members[0]) == null ? void 0 : _a.avatar) ? (openBlock(), createBlock(unref(UIAvatar), {
                      key: 0,
                      size: 40,
                      src: (_b = conversation == null ? void 0 : conversation.members[0]) == null ? void 0 : _b.avatar
                    }, null, 8, ["src"])) : (openBlock(), createBlock(unref(UIAvatar), {
                      key: 1,
                      size: 40,
                      class: "text-md flex items-center justify-center bg-clientportal-fill font-medium text-clientportal-font-secondary"
                    }, {
                      default: withCtx(() => [
                        createVNode(unref(UITextSmMedium), { class: "text-[14px]" }, {
                          default: withCtx(() => {
                            var _a2;
                            return [
                              createTextVNode(toDisplayString(unref(getShortName)(
                                ((_a2 = conversation == null ? void 0 : conversation.members[0]) == null ? void 0 : _a2.fullName) || "Deleted User"
                              )), 1)
                            ];
                          }),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)),
                    createVNode(unref(UITextMdMedium), { class: "text-clientportal-font-primary" }, {
                      default: withCtx(() => {
                        var _a2;
                        return [
                          createTextVNode(toDisplayString((_a2 = conversation == null ? void 0 : conversation.members[0]) == null ? void 0 : _a2.fullName), 1)
                        ];
                      }),
                      _: 2
                    }, 1024)
                  ]),
                  createElementVNode("div", _hoisted_24$4, [
                    createElementVNode("div", {
                      id: `unblock-button-${conversation._id}`,
                      class: "font-semibold",
                      onClick: ($event) => unblockConversation(conversation._id)
                    }, [
                      createVNode(unref(UITextMdMedium), { class: "font-sans font-semibold" }, {
                        default: withCtx(() => [
                          createTextVNode(toDisplayString(unref(t2)("chats.unblock")), 1)
                        ]),
                        _: 1
                      })
                    ], 8, _hoisted_25$3)
                  ])
                ], 8, _hoisted_22$4);
              }), 128)) : (openBlock(), createElementBlock("div", _hoisted_26$2, [
                createVNode(unref(UITextXsRegular), { class: "text-clientportal-font-secondary italic" }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(unref(t2)("chats.noBlockedUsers")), 1)
                  ]),
                  _: 1
                })
              ]))
            ])
          ]),
          _: 1
        })
      ]);
    };
  }
});
const ChatSettings = /* @__PURE__ */ _export_sfc(_sfc_main$1M, [["__scopeId", "data-v-814b2910"]]);
const _hoisted_1$1z = { class: "max-w-xs" };
const _hoisted_2$1b = { class: "text-gray-800" };
const _hoisted_3$13 = { class: "text-gray-600" };
const _sfc_main$1L = /* @__PURE__ */ defineComponent({
  __name: "SpaceComponent",
  props: {
    title: {
      type: String
    },
    description: {
      type: String
    }
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(UISpace), {
        align: "center",
        justify: "space-between"
      }, {
        default: withCtx(() => [
          createElementVNode("div", _hoisted_1$1z, [
            createElementVNode("div", _hoisted_2$1b, toDisplayString(props.title), 1),
            createElementVNode("div", _hoisted_3$13, toDisplayString(props.description), 1)
          ]),
          renderSlot(_ctx.$slots, "space-slot")
        ]),
        _: 3
      });
    };
  }
});
const _hoisted_1$1y = { class: "flex flex-col h-screen w-full fixed bg-white z-[100] overflow-y-auto" };
const _hoisted_2$1a = {
  id: "edit-account-navbar",
  class: "fixed left-0 right-0 top-0 z-50 w-full bg-white"
};
const _hoisted_3$12 = { class: "relative z-50 inline-flex w-full bg-white" };
const _hoisted_4$Y = { class: "relative z-50 flex items-center justify-center gap-[13px] bg-white" };
const _hoisted_5$O = { class: "relative z-50 flex items-start justify-center gap-2.5 bg-white" };
const _hoisted_6$H = { class: "flex items-start justify-start gap-1" };
const _hoisted_7$C = { class: "inline-flex flex-col items-start justify-start" };
const _hoisted_8$s = { class: "text-lg font-medium leading-7 text-slate-700" };
const _hoisted_9$o = { class: "flex grow items-center justify-end" };
const _hoisted_10$m = { class: "flex items-start justify-start gap-4" };
const _hoisted_11$m = {
  class: "relative cursor-pointer",
  onClick: () => {
  }
};
const _hoisted_12$h = { class: "w-full col-span-3" };
const _sfc_main$1K = /* @__PURE__ */ defineComponent({
  __name: "EditAccount",
  setup(__props) {
    const routerInstance = AppState.getRouterInstance();
    const boxRef = ref(null);
    const loadingRef = ref(null);
    const t2 = inject("t");
    onBeforeMount(async () => {
      var _a, _b;
      loginEmail.value = (_b = (_a = UserState) == null ? void 0 : _a.state) == null ? void 0 : _b.email;
    });
    const isLoading = ref(false);
    const loginEmail = ref("");
    const isFieldRequired = ref(false);
    const accountForm = reactive({
      currentPassword: "",
      newPassword: "",
      confirmPassword: ""
    });
    watchEffect(() => {
      isFieldRequired.value = !accountForm.currentPassword.trim() && !accountForm.newPassword.trim() && !accountForm.confirmPassword.trim();
    });
    const rules = {
      currentPassword: {
        required: !isFieldRequired.value,
        message: t2.value("changePassword.passwordFieldRequired"),
        trigger: ["input", "blur"]
      },
      newPassword: {
        min: 8,
        required: !isFieldRequired.value,
        message: t2.value("changePassword.passwordMinLength"),
        trigger: ["input", "blur"]
      },
      confirmPassword: {
        min: 8,
        required: !isFieldRequired.value,
        message: t2.value("changePassword.passwordMinLength"),
        trigger: ["input", "blur"]
      }
    };
    const root = ref();
    async function updatePassword() {
      var _a, _b, _c, _d, _e, _f, _g;
      const isValid = await validateForm(root.value);
      if (!isValid) {
        return;
      }
      try {
        (_a = loadingRef.value) == null ? void 0 : _a.startLoadBar();
        isLoading.value = true;
        await UserState.changePassword({
          ...accountForm,
          locationId: (_c = (_b = LocationState) == null ? void 0 : _b.state) == null ? void 0 : _c.locationId,
          contactId: (_e = (_d = UserState) == null ? void 0 : _d.state) == null ? void 0 : _e.userId
        });
        (_f = loadingRef.value) == null ? void 0 : _f.stopLoadBar();
        setTimeout(() => {
          if (routerInstance) {
            routerInstance.back();
          }
        }, 300);
      } catch (error) {
        console.error(error);
        (_g = loadingRef.value) == null ? void 0 : _g.errorLoadBar();
        if (error.response.data.message == t2.value("changePassword.passwordEntryInvalid")) {
          notificationAlert(t2.value("changePassword.passwordEntryInvalid"), "");
        } else {
          notificationAlert(
            t2.value("changePassword.systemErrorOccurred"),
            t2.value("mandatedInfoModal.pleaseTryAgainLater")
          );
        }
      } finally {
        isLoading.value = false;
      }
    }
    const changePasswordSubmitButton = computed(() => {
      return (accountForm == null ? void 0 : accountForm.newPassword) && (accountForm == null ? void 0 : accountForm.currentPassword) && (accountForm == null ? void 0 : accountForm.confirmPassword) && accountForm.newPassword == accountForm.confirmPassword ? false : true;
    });
    const notification = useNotification();
    function notificationAlert(title, content) {
      notification.create({
        title,
        content,
        duration: 5e3
      });
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$1y, [
        createElementVNode("div", _hoisted_2$1a, [
          createVNode(unref(UICard), { class: "relative z-50 h-full w-full !rounded-none bg-white" }, {
            default: withCtx(() => [
              createElementVNode("div", _hoisted_3$12, [
                createElementVNode("div", _hoisted_4$Y, [
                  createElementVNode("div", _hoisted_5$O, [
                    createElementVNode("div", {
                      onClick: _cache[0] || (_cache[0] = () => {
                        if (unref(routerInstance)) {
                          unref(routerInstance).back();
                        }
                      }),
                      class: "relative h-6 w-6 cursor-pointer"
                    }, [
                      createVNode(unref(render$6))
                    ])
                  ]),
                  createElementVNode("div", _hoisted_6$H, [
                    createElementVNode("div", _hoisted_7$C, [
                      createElementVNode("div", _hoisted_8$s, toDisplayString(unref(t2)("changePassword.editAccount")), 1)
                    ])
                  ])
                ]),
                createElementVNode("div", _hoisted_9$o, [
                  createElementVNode("div", _hoisted_10$m, [
                    createElementVNode("div", _hoisted_11$m, [
                      createVNode(unref(UIButton), {
                        id: "basic-info-save-btn",
                        onClick: updatePassword,
                        disabled: changePasswordSubmitButton.value,
                        class: "text-primary-500 text-lg",
                        text: true
                      }, {
                        default: withCtx(() => [
                          createTextVNode(toDisplayString(unref(t2)("common.save")), 1)
                        ]),
                        _: 1
                      }, 8, ["disabled"])
                    ])
                  ])
                ])
              ])
            ]),
            _: 1
          })
        ]),
        createElementVNode("div", {
          ref_key: "boxRef",
          ref: boxRef,
          class: "mt-[50px] w-full overflow-y-auto flex"
        }, [
          createVNode(_sfc_main$1N, { class: "w-full col-span-3 py-6 grid grid-cols-3 row-span-1 px-4 overflow-y-auto content" }, {
            "scroll-slot": withCtx(() => [
              createVNode(unref(UILoadingBar), {
                ref_key: "loadingRef",
                ref: loadingRef,
                to: boxRef.value
              }, null, 8, ["to"]),
              createElementVNode("div", _hoisted_12$h, [
                createVNode(unref(UIForm), {
                  ref_key: "root",
                  ref: root,
                  model: accountForm,
                  rules,
                  id: "account-form"
                }, {
                  default: withCtx(() => [
                    createVNode(unref(UITextMdMedium), { class: "text-black" }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(unref(t2)("changePassword.loginInformation")), 1)
                      ]),
                      _: 1
                    }),
                    createVNode(_sfc_main$1L, {
                      title: unref(t2)("changePassword.loginEmail"),
                      inline: false,
                      wrapItem: true,
                      justify: "start",
                      size: "medium",
                      vertical: true,
                      wrap: true,
                      class: "mt-6"
                    }, {
                      "space-slot": withCtx(() => [
                        createVNode(unref(UIFormItem), { path: "login-email" }, {
                          default: withCtx(() => [
                            createVNode(unref(UIInput), {
                              modelValue: loginEmail.value,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => loginEmail.value = $event),
                              id: "account-input",
                              placeholder: unref(t2)("changePassword.emailId"),
                              disabled: true
                            }, null, 8, ["modelValue", "placeholder"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["title"]),
                    createVNode(unref(UITextMdMedium), { class: "text-black mt-2" }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(unref(t2)("changePassword.changePassword")), 1)
                      ]),
                      _: 1
                    }),
                    createVNode(_sfc_main$1L, {
                      title: unref(t2)("changePassword.currentPassword"),
                      align: void 0,
                      inline: false,
                      wrapItem: true,
                      justify: "start",
                      size: "medium",
                      vertical: true,
                      wrap: true,
                      class: "mt-6"
                    }, {
                      "space-slot": withCtx(() => [
                        createVNode(unref(UIFormItem), { path: "currentPassword" }, {
                          default: withCtx(() => [
                            createVNode(unref(UIInput), {
                              modelValue: accountForm.currentPassword,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => accountForm.currentPassword = $event),
                              type: "password",
                              id: "account-input",
                              "show-password-on": "click"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["title"]),
                    createVNode(_sfc_main$1L, {
                      title: unref(t2)("changePassword.newPassword"),
                      align: void 0,
                      inline: false,
                      wrapItem: true,
                      justify: "start",
                      size: "medium",
                      vertical: true,
                      wrap: true
                    }, {
                      "space-slot": withCtx(() => [
                        createVNode(unref(UIFormItem), { path: "newPassword" }, {
                          default: withCtx(() => [
                            createVNode(unref(UIInput), {
                              modelValue: accountForm.newPassword,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => accountForm.newPassword = $event),
                              type: "password",
                              id: "account-input",
                              "show-password-on": "click"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["title"]),
                    createVNode(_sfc_main$1L, {
                      title: unref(t2)("changePassword.retypePassword"),
                      align: void 0,
                      inline: false,
                      wrapItem: true,
                      justify: "start",
                      size: "medium",
                      vertical: true,
                      wrap: true
                    }, {
                      "space-slot": withCtx(() => [
                        createVNode(unref(UIFormItem), { path: "confirmPassword" }, {
                          default: withCtx(() => [
                            createVNode(unref(UIInput), {
                              modelValue: accountForm.confirmPassword,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => accountForm.confirmPassword = $event),
                              type: "password",
                              id: "account-input",
                              "show-password-on": "click"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["title"])
                  ]),
                  _: 1
                }, 8, ["model"])
              ])
            ]),
            _: 1
          })
        ], 512)
      ]);
    };
  }
});
const EditAccount = /* @__PURE__ */ _export_sfc(_sfc_main$1K, [["__scopeId", "data-v-25942d2a"]]);
const _hoisted_1$1x = { class: "flex flex-col h-screen w-full fixed bg-white z-[100] overflow-y-auto" };
const _hoisted_2$19 = {
  id: "edit-info-navbar",
  class: "fixed left-0 right-0 top-0 z-50 w-full bg-white"
};
const _hoisted_3$11 = { class: "relative z-50 inline-flex w-full bg-white" };
const _hoisted_4$X = { class: "relative z-50 flex items-center justify-center gap-[13px] bg-white" };
const _hoisted_5$N = { class: "relative z-50 flex items-start justify-center gap-2.5 bg-white" };
const _hoisted_6$G = { class: "flex items-start justify-start gap-1" };
const _hoisted_7$B = { class: "inline-flex flex-col items-start justify-start" };
const _hoisted_8$r = { class: "text-lg font-medium leading-7 text-slate-700" };
const _hoisted_9$n = { class: "flex grow items-center justify-end" };
const _hoisted_10$l = { class: "flex items-start justify-start gap-4" };
const _hoisted_11$l = { class: "relative cursor-pointer" };
const _hoisted_12$g = { class: "w-full col-span-3" };
const _hoisted_13$f = { class: "flex flex-col gap-2 w-full" };
const _hoisted_14$b = {
  key: 0,
  class: "w-full text-rose-600"
};
const _sfc_main$1J = /* @__PURE__ */ defineComponent({
  __name: "EditBasicInfo",
  setup(__props) {
    const t2 = inject("t");
    const notification = useNotification();
    function notificationAlert(title, content) {
      notification.create({
        title,
        content,
        duration: 5e3
      });
    }
    onBeforeMount(async () => {
      setFormData();
    });
    const profileSlug = ref("");
    const slugError = ref(false);
    const slugErrorMessage = ref("");
    const originalFullName = ref("");
    const validateSlug = (value) => {
      const slugMinLength = 3;
      const slugMaxLength = 50;
      const regex = {
        containOnlyNumbers: /^\d+$/,
        startWithNumber: /^\d/,
        startWithHyphen: /^-/,
        endWithHyphen: /-$/,
        containDoubleHyphen: /--/,
        containSpace: /\s/,
        containOnlyAlphanumericAndLatins: /^[\p{L}\p{N}][\p{L}\p{N}-]*$/u
      };
      switch (true) {
        case value.length < slugMinLength:
          slugError.value = true;
          slugErrorMessage.value = t2.value(
            "profileSettings.slugValidation.tooShort"
          );
          break;
        case regex.containOnlyNumbers.test(value):
          slugError.value = true;
          slugErrorMessage.value = t2.value(
            "profileSettings.slugValidation.containOnlyNumbers"
          );
          break;
        case regex.startWithNumber.test(value):
          slugError.value = true;
          slugErrorMessage.value = t2.value(
            "profileSettings.slugValidation.startWithNumber"
          );
          break;
        case regex.startWithHyphen.test(value):
          slugError.value = true;
          slugErrorMessage.value = t2.value(
            "profileSettings.slugValidation.startWithHyphen"
          );
          break;
        case regex.endWithHyphen.test(value):
          slugError.value = true;
          slugErrorMessage.value = t2.value(
            "profileSettings.slugValidation.endWithHyphen"
          );
          break;
        case regex.containDoubleHyphen.test(value):
          slugError.value = true;
          slugErrorMessage.value = t2.value(
            "profileSettings.slugValidation.containDoubleHyphen"
          );
          break;
        case regex.containSpace.test(value):
          slugError.value = true;
          slugErrorMessage.value = t2.value(
            "profileSettings.slugValidation.containSpace"
          );
          break;
        case !regex.containOnlyAlphanumericAndLatins.test(value):
          slugError.value = true;
          slugErrorMessage.value = t2.value(
            "profileSettings.slugValidation.containSpecialCharacters"
          );
          break;
        case value.length > slugMaxLength:
          slugError.value = true;
          slugErrorMessage.value = t2.value("profileSettings.slugValidation.tooLong");
          break;
        default:
          slugError.value = false;
          slugErrorMessage.value = "";
          profileSlug.value = value;
          break;
      }
    };
    function setFormData() {
      var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l;
      originalFullName.value = (_b = (_a = UserState) == null ? void 0 : _a.state) == null ? void 0 : _b.fullName;
      profileForm.value.fullName = (_d = (_c = UserState) == null ? void 0 : _c.state) == null ? void 0 : _d.fullName;
      profileForm.value.title = (_f = (_e = UserState) == null ? void 0 : _e.state) == null ? void 0 : _f.title;
      profileForm.value.slug = (_h = (_g = UserState) == null ? void 0 : _g.state) == null ? void 0 : _h.slug;
      profileForm.value.bio = (_j = (_i = UserState) == null ? void 0 : _i.state) == null ? void 0 : _j.bio;
      profileSlug.value = (_l = (_k = UserState) == null ? void 0 : _k.state) == null ? void 0 : _l.slug;
      slugError.value = false;
      slugErrorMessage.value = "";
    }
    const routerInstance = AppState.getRouterInstance();
    const boxRef = ref(null);
    const loadingRef = ref(null);
    const profileForm = ref({
      fullName: "",
      title: "",
      bio: ""
    });
    const textValidation2 = string().required(t2.value("profileSettings.nameIsRequired")).test(
      "is-text",
      t2.value("profileSettings.specialCharactersNotSupported"),
      (value) => {
        return SANITIZE_REGEX_PATTERN.test(value);
      }
    );
    const rules = {
      fullName: {
        validator: (_, value) => {
          return textValidation2.validate(value);
        },
        trigger: ["input"]
      },
      title: {
        validator: (_, value) => {
          if ((value == null ? void 0 : value.length) > 0) {
            return textValidation2.validate(value);
          }
          return true;
        },
        trigger: ["input", "blur"]
      },
      bio: {
        validator: (_, value) => {
          if ((value == null ? void 0 : value.length) > 0) {
            return textValidation2.validate(value);
          }
          return true;
        },
        trigger: ["input", "blur"]
      }
    };
    const updatingProfileSetting = ref(false);
    const root = ref();
    async function saveProfile() {
      var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q;
      const isValid = await validateForm(root.value);
      if (!isValid) {
        return;
      }
      try {
        (_a = loadingRef.value) == null ? void 0 : _a.startLoadBar();
        updatingProfileSetting.value = true;
        if (profileSlug.value !== ((_c = (_b = UserState) == null ? void 0 : _b.state) == null ? void 0 : _c.slug)) {
          try {
            await UserState.updateUserSlug(
              (_e = (_d = LocationState) == null ? void 0 : _d.state) == null ? void 0 : _e.locationId,
              profileSlug.value
            );
          } catch (error) {
            if (((_g = (_f = error == null ? void 0 : error["response"]) == null ? void 0 : _f.data) == null ? void 0 : _g["statusCode"]) === 429) {
              notificationAlert(
                t2.value("alerts.tooManyAttempts.title"),
                t2.value("alerts.tooManyAttempts.message")
              );
            } else if (((_i = (_h = error == null ? void 0 : error["response"]) == null ? void 0 : _h.data) == null ? void 0 : _i["statusCode"]) === 409) {
              notificationAlert(
                t2.value("alerts.slugAlreadyExists.title"),
                t2.value("alerts.slugAlreadyExists.message")
              );
            } else {
              notificationAlert(
                t2.value("alerts.updateSlugError.title"),
                t2.value("alerts.updateSlugError.message")
              );
            }
            updatingProfileSetting.value = false;
            (_j = loadingRef.value) == null ? void 0 : _j.errorLoadBar();
            return;
          }
        }
        const { fullName, ...basePayload } = profileForm.value ?? {};
        const fullNameHasChanged = ((fullName == null ? void 0 : fullName.trim()) ?? "") !== (((_k = originalFullName == null ? void 0 : originalFullName.value) == null ? void 0 : _k.trim()) ?? "");
        const updatePayload = {
          ...basePayload,
          locationId: (_m = (_l = LocationState) == null ? void 0 : _l.state) == null ? void 0 : _m.locationId,
          userId: (_o = (_n = UserState) == null ? void 0 : _n.state) == null ? void 0 : _o.userId,
          ...fullNameHasChanged ? { fullName } : {}
        };
        await UserState.updateUserProfile({
          ...updatePayload
        });
        updatingProfileSetting.value = false;
        (_p = loadingRef.value) == null ? void 0 : _p.stopLoadBar();
        setTimeout(() => {
          if (routerInstance) {
            routerInstance.back();
          }
        }, 300);
      } catch (error) {
        (_q = loadingRef.value) == null ? void 0 : _q.errorLoadBar();
        console.error(error);
      }
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$1x, [
        createElementVNode("div", _hoisted_2$19, [
          createVNode(unref(UICard), { class: "relative z-50 h-full w-full !rounded-none bg-white" }, {
            default: withCtx(() => [
              createElementVNode("div", _hoisted_3$11, [
                createElementVNode("div", _hoisted_4$X, [
                  createElementVNode("div", _hoisted_5$N, [
                    createElementVNode("div", {
                      onClick: _cache[0] || (_cache[0] = () => {
                        if (unref(routerInstance)) {
                          unref(routerInstance).back();
                        }
                      }),
                      class: "relative h-6 w-6 cursor-pointer"
                    }, [
                      createVNode(unref(render$6))
                    ])
                  ]),
                  createElementVNode("div", _hoisted_6$G, [
                    createElementVNode("div", _hoisted_7$B, [
                      createElementVNode("div", _hoisted_8$r, toDisplayString(unref(t2)("profileSettings.editBasicInformation")), 1)
                    ])
                  ])
                ]),
                createElementVNode("div", _hoisted_9$n, [
                  createElementVNode("div", _hoisted_10$l, [
                    createElementVNode("div", _hoisted_11$l, [
                      createVNode(unref(UIButton), {
                        id: "basic-info-save-btn",
                        onClick: saveProfile,
                        class: "text-primary-500 text-lg",
                        text: true
                      }, {
                        default: withCtx(() => [
                          createTextVNode(toDisplayString(unref(t2)("common.save")), 1)
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ])
            ]),
            _: 1
          })
        ]),
        createElementVNode("div", {
          ref_key: "boxRef",
          ref: boxRef,
          class: "mt-[50px] w-full overflow-y-auto flex"
        }, [
          createVNode(_sfc_main$1N, { class: "w-full col-span-3 py-6 grid grid-cols-3 row-span-1 px-4 overflow-y-auto" }, {
            "scroll-slot": withCtx(() => [
              createVNode(unref(UILoadingBar), {
                ref_key: "loadingRef",
                ref: loadingRef,
                to: boxRef.value
              }, null, 8, ["to"]),
              createElementVNode("div", _hoisted_12$g, [
                createVNode(unref(UIForm), {
                  ref_key: "root",
                  ref: root,
                  model: profileForm.value,
                  rules,
                  id: "profile-form"
                }, {
                  default: withCtx(() => [
                    createVNode(_sfc_main$1L, {
                      title: unref(t2)("billing.fullName"),
                      align: void 0,
                      inline: false,
                      wrapItem: true,
                      justify: "start",
                      size: "medium",
                      vertical: true,
                      wrap: true
                    }, {
                      "space-slot": withCtx(() => [
                        createVNode(unref(UIFormItem), { path: "fullName" }, {
                          default: withCtx(() => [
                            createVNode(unref(UIInput), {
                              modelValue: profileForm.value.fullName,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => profileForm.value.fullName = $event),
                              id: "basic-info-input",
                              maxlength: 50,
                              placeholder: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["title"]),
                    createVNode(_sfc_main$1L, {
                      title: unref(t2)("common.title_column"),
                      align: void 0,
                      inline: false,
                      wrapItem: true,
                      justify: "start",
                      size: "medium",
                      vertical: true,
                      wrap: true
                    }, {
                      "space-slot": withCtx(() => [
                        createVNode(unref(UIFormItem), { path: "title" }, {
                          default: withCtx(() => [
                            createVNode(unref(UIInput), {
                              modelValue: profileForm.value.title,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => profileForm.value.title = $event),
                              id: "basic-info-input",
                              maxlength: 50,
                              placeholder: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["title"]),
                    createVNode(_sfc_main$1L, {
                      title: unref(t2)("profileSettings.profileSlug"),
                      align: void 0,
                      inline: false,
                      wrapItem: true,
                      justify: "start",
                      size: "medium",
                      vertical: true,
                      wrap: true
                    }, {
                      "space-slot": withCtx(() => [
                        createVNode(unref(UIFormItem), { path: "slug" }, {
                          default: withCtx(() => [
                            createElementVNode("div", _hoisted_13$f, [
                              createVNode(unref(UIInput), {
                                modelValue: profileSlug.value,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => profileSlug.value = $event),
                                id: "basic-info-input",
                                maxlength: 50,
                                placeholder: "",
                                disabled: false,
                                onInput: validateSlug
                              }, null, 8, ["modelValue"]),
                              slugError.value ? (openBlock(), createElementBlock("div", _hoisted_14$b, toDisplayString(slugErrorMessage.value), 1)) : createCommentVNode("", true)
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["title"]),
                    createVNode(_sfc_main$1L, {
                      title: unref(t2)("profileSettings.bio"),
                      align: void 0,
                      inline: false,
                      wrapItem: true,
                      justify: "start",
                      size: "medium",
                      vertical: true,
                      wrap: true
                    }, {
                      "space-slot": withCtx(() => [
                        createVNode(unref(UIFormItem), { path: "bio" }, {
                          default: withCtx(() => [
                            createVNode(unref(UIInput), {
                              modelValue: profileForm.value.bio,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => profileForm.value.bio = $event),
                              type: "textarea",
                              readonly: false,
                              rows: 5,
                              cols: 100,
                              maxlength: 200,
                              clearable: false,
                              size: "large",
                              showCount: true,
                              disabled: void 0,
                              id: "basic-info-input",
                              placeholder: unref(t2)("profileSettings.writeAboutYourself")
                            }, null, 8, ["modelValue", "placeholder"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["title"])
                  ]),
                  _: 1
                }, 8, ["model"])
              ])
            ]),
            _: 1
          })
        ], 512)
      ]);
    };
  }
});
const EditBasicInfo = /* @__PURE__ */ _export_sfc(_sfc_main$1J, [["__scopeId", "data-v-ceec00e0"]]);
const timezonesWhiteList = [
  "Etc/GMT+12",
  "Pacific/Midway",
  "Pacific/Honolulu",
  "America/Juneau",
  "US/Alaska",
  "America/Dawson",
  "America/Los_Angeles",
  "America/Phoenix",
  "America/Tijuana",
  "US/Arizona",
  "America/Belize",
  "America/Boise",
  "America/Chihuahua",
  "America/Denver",
  "America/Edmonton",
  "America/Guatemala",
  "America/Managua",
  "America/Regina",
  "Canada/Saskatchewan",
  "US/Mountain",
  "America/Bahia_Banderas",
  "America/Bogota",
  "America/Cancun",
  "America/Chicago",
  "America/Mexico_City",
  "US/Central",
  "America/Caracas",
  "America/Detroit",
  "America/Indiana/Indianapolis",
  "America/Louisville",
  "America/Manaus",
  "America/New_York",
  "America/Santiago",
  "America/Santo_Domingo",
  "America/Toronto",
  "US/East-Indiana",
  "US/Eastern",
  "America/Argentina/Buenos_Aires",
  "America/Glace_Bay",
  "America/Montevideo",
  "America/Sao_Paulo",
  "Canada/Atlantic",
  "America/St_Johns",
  "Canada/Newfoundland",
  "America/Godthab",
  "America/Noronha",
  "Etc/GMT+2",
  "Atlantic/Cape_Verde",
  "Atlantic/Azores",
  "UTC",
  "Africa/Algiers",
  "Africa/Casablanca",
  "Africa/Lagos",
  "Atlantic/Canary",
  "Europe/London",
  "Africa/Cairo",
  "Africa/Harare",
  "Europe/Amsterdam",
  "Europe/Belgrade",
  "Europe/Brussels",
  "Europe/Madrid",
  "Europe/Oslo",
  "Europe/Sarajevo",
  "Africa/Nairobi",
  "Asia/Amman",
  "Asia/Baghdad",
  "Asia/Jerusalem",
  "Asia/Kuwait",
  "Asia/Qatar",
  "Europe/Athens",
  "Europe/Bucharest",
  "Europe/Helsinki",
  "Europe/Moscow",
  "Asia/Baku",
  "Asia/Dubai",
  "Asia/Kabul",
  "Asia/Tehran",
  "Asia/Karachi",
  "Asia/Yekaterinburg",
  "Asia/Colombo",
  "Asia/Kolkata",
  "Asia/Calcutta",
  "Asia/Kathmandu",
  "Asia/Almaty",
  "Asia/Dhaka",
  "Asia/Rangoon",
  "Asia/Bangkok",
  "Asia/Krasnoyarsk",
  "Asia/Irkutsk",
  "Asia/Kuala_Lumpur",
  "Asia/Shanghai",
  "Asia/Taipei",
  "Australia/Perth",
  "Asia/Seoul",
  "Asia/Tokyo",
  "Asia/Yakutsk",
  "Australia/Adelaide",
  "Australia/Darwin",
  "Asia/Vladivostok",
  "Australia/Brisbane",
  "Australia/Canberra",
  "Australia/Hobart",
  "Australia/Sydney",
  "Pacific/Guam",
  "Asia/Magadan",
  "Pacific/Auckland",
  "Pacific/Fiji",
  "Pacific/Tongatapu"
];
const timezones = sortBy(
  timezonesWhiteList.map((zone) => {
    var _a;
    const now = /* @__PURE__ */ new Date();
    const zonedDate = toZonedTime(now, zone);
    const offset = format(zonedDate, "xxx", { timeZone: zone });
    const currentTime = format(zonedDate, "hh:mm a", { timeZone: zone });
    const timezoneAbbr = ((_a = new Intl.DateTimeFormat("en-US", {
      timeZone: zone,
      timeZoneName: "shortGeneric"
    }).formatToParts(zonedDate).find((part) => part.type === "timeZoneName")) == null ? void 0 : _a.value) || "";
    return {
      label: `GMT${offset} ${zone} (${timezoneAbbr})`,
      value: zone,
      currentTime
    };
  }),
  (m) => {
    const now = /* @__PURE__ */ new Date();
    const zonedDate = toZonedTime(now, m.value);
    return new Date(zonedDate).getTimezoneOffset();
  }
);
const _hoisted_1$1w = { class: "flex flex-col h-screen w-full fixed bg-white z-[100]" };
const _hoisted_2$18 = {
  id: "edit-details-navbar",
  class: "fixed left-0 right-0 top-0 z-50 w-full bg-white"
};
const _hoisted_3$10 = { class: "relative z-50 inline-flex w-full bg-white" };
const _hoisted_4$W = { class: "relative z-50 flex items-center justify-center gap-[13px] bg-white" };
const _hoisted_5$M = { class: "relative z-50 flex items-start justify-center gap-2.5 bg-white" };
const _hoisted_6$F = { class: "flex items-start justify-start gap-1" };
const _hoisted_7$A = { class: "inline-flex flex-col items-start justify-start" };
const _hoisted_8$q = { class: "text-lg font-medium leading-7 text-slate-700" };
const _hoisted_9$m = { class: "flex grow items-center justify-end" };
const _hoisted_10$k = { class: "flex items-start justify-start gap-4" };
const _hoisted_11$k = { class: "relative cursor-pointer" };
const _hoisted_12$f = { class: "w-full col-span-3" };
const _hoisted_13$e = { class: "flex w-full place-content-end" };
const _hoisted_14$a = { class: "flex w-full place-content-end" };
const _hoisted_15$8 = { class: "flex flex-col items-center px-4" };
const _hoisted_16$6 = { class: "flex flex-col w-full sticky pb-2 z-50 bg-white top-0 items-center" };
const _hoisted_17$4 = { class: "mt-2 h-1 w-16 mb-4 rounded-md border border-solid bg-gray-200 border-gray-200 self-center" };
const _hoisted_18$4 = { class: "flex border- w-full border-b-2 border-gray-500 px-2 mt-6" };
const _hoisted_19$4 = ["aria-label", "placeholder"];
const _hoisted_20$3 = { class: "py-1" };
const _hoisted_21$3 = { class: "flex flex-col w-full" };
const _hoisted_22$3 = {
  key: 0,
  class: "w-full flex flex-col overflow-auto h-full"
};
const _hoisted_23$3 = { class: "w-full flex justify-center items-center" };
const _hoisted_24$3 = { class: "h-[41px] w-[57px] bg-[#ECF0FF] flex items-center justify-center rounded-md" };
const _hoisted_25$2 = { class: "ml-4 flex flex-col w-full" };
const _sfc_main$1I = /* @__PURE__ */ defineComponent({
  __name: "EditDetails",
  setup(__props) {
    onBeforeMount(async () => {
      setFormData();
    });
    const boxRef = ref(null);
    const loadingRef = ref(null);
    const t2 = inject("t");
    const searchText = ref("");
    const showTimezones = ref(false);
    const routerInstance = AppState.getRouterInstance();
    const root = ref();
    const socialMediaForm = ref({
      location: "",
      timeZone: "",
      email: "",
      phoneNumber: "",
      facebook: "",
      instagram: "",
      twitter: "",
      youtube: "",
      linkedin: "",
      emailVisibility: "private",
      phoneVisibility: "private"
    });
    function setFormData() {
      var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _A, _B, _C, _D, _E;
      socialMediaForm.value.location = (_b = (_a = UserState) == null ? void 0 : _a.state) == null ? void 0 : _b.location;
      socialMediaForm.value.timeZone = (_d = (_c = UserState) == null ? void 0 : _c.state) == null ? void 0 : _d.timeZone;
      socialMediaForm.value.phoneNumber = (_g = (_f = (_e = UserState) == null ? void 0 : _e.state) == null ? void 0 : _f.socials) == null ? void 0 : _g.phoneNumber;
      socialMediaForm.value.email = (_j = (_i = (_h = UserState) == null ? void 0 : _h.state) == null ? void 0 : _i.socials) == null ? void 0 : _j.email;
      socialMediaForm.value.facebook = (_m = (_l = (_k = UserState) == null ? void 0 : _k.state) == null ? void 0 : _l.socials) == null ? void 0 : _m.facebook;
      socialMediaForm.value.twitter = (_p = (_o = (_n = UserState) == null ? void 0 : _n.state) == null ? void 0 : _o.socials) == null ? void 0 : _p.twitter;
      socialMediaForm.value.instagram = (_s = (_r = (_q = UserState) == null ? void 0 : _q.state) == null ? void 0 : _r.socials) == null ? void 0 : _s.instagram;
      socialMediaForm.value.youtube = (_v = (_u = (_t = UserState) == null ? void 0 : _t.state) == null ? void 0 : _u.socials) == null ? void 0 : _v.youtube;
      socialMediaForm.value.linkedin = (_y = (_x = (_w = UserState) == null ? void 0 : _w.state) == null ? void 0 : _x.socials) == null ? void 0 : _y.linkedin;
      socialMediaForm.value.emailVisibility = (_B = (_A = (_z = UserState) == null ? void 0 : _z.state) == null ? void 0 : _A.socials) == null ? void 0 : _B.emailVisibility;
      socialMediaForm.value.phoneVisibility = (_E = (_D = (_C = UserState) == null ? void 0 : _C.state) == null ? void 0 : _D.socials) == null ? void 0 : _E.phoneVisibility;
    }
    const urlValidationSchema = string().test(
      "is-url",
      t2.value("social.invalidURL"),
      (value) => {
        if (!value) return true;
        const urlRegex = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i;
        return urlRegex.test(value);
      }
    );
    const urlValidationRule = {
      validator: (_, value) => {
        return urlValidationSchema.validate(value);
      },
      message: t2.value("social.validUrl"),
      trigger: ["input", "blur"]
    };
    const textValidation2 = string().required().test(
      "is-text",
      t2.value("profileSettings.specialCharactersNotSupported"),
      (value) => {
        return SANITIZE_REGEX_PATTERN.test(value);
      }
    );
    const rules = {
      email: {
        validator: (_, value) => {
          return string().email().validate(value);
        },
        message: t2.value("social.validEmail"),
        trigger: ["input", "blur"]
      },
      phoneNumber: {
        trigger: ["input", "blur"],
        validator: (_, value) => {
          if (!value) return true;
          try {
            const phoneNumberObj = parsePhoneNumber(value);
            if (phoneNumberObj && phoneNumberObj.isValid() && phoneNumberObj.number === value) {
              return true;
            }
            return false;
          } catch (error) {
            return false;
          }
        },
        message: t2.value("social.validPhoneNumber")
      },
      facebook: urlValidationRule,
      instagram: urlValidationRule,
      twitter: urlValidationRule,
      youtube: urlValidationRule,
      linkedin: urlValidationRule,
      location: {
        validator: (_, value) => {
          if ((value == null ? void 0 : value.length) > 0) {
            return textValidation2.validate(value);
          }
          return true;
        },
        trigger: ["input", "blur"]
      }
    };
    const updatingSocialMediaDetails = ref(false);
    async function saveSocialMediaDetails(e) {
      var _a, _b, _c, _d, _e, _f, _g;
      const isValid = await validateForm(root.value);
      if (!isValid) {
        return;
      }
      try {
        (_a = loadingRef.value) == null ? void 0 : _a.startLoadBar();
        updatingSocialMediaDetails.value = true;
        await UserState.updateUserProfile({
          socials: {
            facebook: socialMediaForm.value.facebook,
            instagram: socialMediaForm.value.instagram,
            linkedin: socialMediaForm.value.linkedin,
            youtube: socialMediaForm.value.youtube,
            twitter: socialMediaForm.value.twitter,
            email: socialMediaForm.value.email,
            emailVisibility: socialMediaForm.value.emailVisibility,
            phoneNumber: socialMediaForm.value.phoneNumber,
            phoneVisibility: socialMediaForm.value.phoneVisibility
          },
          location: socialMediaForm.value.location,
          timeZone: socialMediaForm.value.timeZone,
          locationId: (_c = (_b = LocationState) == null ? void 0 : _b.state) == null ? void 0 : _c.locationId,
          userId: (_e = (_d = UserState) == null ? void 0 : _d.state) == null ? void 0 : _e.userId
        });
        (_f = loadingRef.value) == null ? void 0 : _f.stopLoadBar();
        setTimeout(() => {
          if (routerInstance) {
            routerInstance.back();
          }
        }, 300);
      } catch (e2) {
        (_g = loadingRef.value) == null ? void 0 : _g.errorLoadBar();
        console.error(e2);
      } finally {
        updatingSocialMediaDetails.value = false;
      }
    }
    const filteredTimezones = ref([]);
    watchEffect(() => {
      filteredTimezones.value = timezones.filter((timezone) => {
        return timezone.value.toLowerCase().includes(searchText.value.toLowerCase());
      });
    });
    function handleTimeZone(timezone) {
      socialMediaForm.value.timeZone = timezone;
      showTimezones.value = !showTimezones.value;
      searchText.value = "";
    }
    return (_ctx, _cache) => {
      const _directive_swipe = resolveDirective("swipe");
      return openBlock(), createElementBlock("div", _hoisted_1$1w, [
        createElementVNode("div", _hoisted_2$18, [
          createVNode(unref(UICard), { class: "relative z-50 h-full w-full !rounded-none bg-white" }, {
            default: withCtx(() => [
              createElementVNode("div", _hoisted_3$10, [
                createElementVNode("div", _hoisted_4$W, [
                  createElementVNode("div", _hoisted_5$M, [
                    createElementVNode("div", {
                      onClick: _cache[0] || (_cache[0] = () => {
                        if (unref(routerInstance)) {
                          unref(routerInstance).back();
                        }
                      }),
                      class: "relative h-6 w-6 cursor-pointer"
                    }, [
                      createVNode(unref(render$6))
                    ])
                  ]),
                  createElementVNode("div", _hoisted_6$F, [
                    createElementVNode("div", _hoisted_7$A, [
                      createElementVNode("div", _hoisted_8$q, toDisplayString(unref(t2)("profileSettings.editDetails")), 1)
                    ])
                  ])
                ]),
                createElementVNode("div", _hoisted_9$m, [
                  createElementVNode("div", _hoisted_10$k, [
                    createElementVNode("div", _hoisted_11$k, [
                      createVNode(unref(UIButton), {
                        id: "details-save-btn",
                        onClick: saveSocialMediaDetails,
                        class: "text-primary-500 text-lg",
                        text: true
                      }, {
                        default: withCtx(() => [
                          createTextVNode(toDisplayString(unref(t2)("common.save")), 1)
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ])
            ]),
            _: 1
          })
        ]),
        createElementVNode("div", {
          ref_key: "boxRef",
          ref: boxRef,
          class: "mt-[50px] w-full overflow-y-auto flex"
        }, [
          createVNode(unref(UILoadingBar), {
            ref_key: "loadingRef",
            ref: loadingRef,
            to: boxRef.value
          }, null, 8, ["to"]),
          createVNode(_sfc_main$1N, { class: "w-full col-span-3 grid grid-cols-3 row-span-1 px-4 py-6 overflow-y-auto content" }, {
            "scroll-slot": withCtx(() => [
              createElementVNode("div", _hoisted_12$f, [
                createVNode(unref(UIForm), {
                  ref_key: "root",
                  ref: root,
                  model: socialMediaForm.value,
                  rules,
                  id: "social-media-form"
                }, {
                  default: withCtx(() => [
                    createVNode(_sfc_main$1L, {
                      title: unref(t2)("common.location"),
                      align: void 0,
                      inline: false,
                      wrapItem: true,
                      justify: "start",
                      size: "medium",
                      vertical: true,
                      wrap: true
                    }, {
                      "space-slot": withCtx(() => [
                        createVNode(unref(UIFormItem), { path: "location" }, {
                          default: withCtx(() => [
                            createVNode(unref(UIInput), {
                              modelValue: socialMediaForm.value.location,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => socialMediaForm.value.location = $event),
                              id: "details-input",
                              maxlength: 40,
                              showCount: true
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["title"]),
                    createVNode(_sfc_main$1L, {
                      title: unref(t2)("profileSettings.timezone"),
                      align: void 0,
                      inline: false,
                      wrapItem: true,
                      justify: "start",
                      size: "medium",
                      vertical: true,
                      wrap: true
                    }, {
                      "space-slot": withCtx(() => [
                        createVNode(unref(UISelect), {
                          id: "details-select",
                          value: socialMediaForm.value.timeZone,
                          "onUpdate:value": _cache[2] || (_cache[2] = ($event) => socialMediaForm.value.timeZone = $event),
                          show: false,
                          onClick: _cache[3] || (_cache[3] = () => showTimezones.value = !showTimezones.value),
                          placeholder: unref(t2)("profileSettings.selectTimezone")
                        }, null, 8, ["value", "placeholder"])
                      ]),
                      _: 1
                    }, 8, ["title"]),
                    createVNode(_sfc_main$1L, {
                      title: unref(t2)("social.phoneNumber"),
                      align: void 0,
                      inline: false,
                      wrapItem: true,
                      justify: "start",
                      size: "medium",
                      vertical: true,
                      wrap: true,
                      class: "mt-6"
                    }, {
                      "space-slot": withCtx(() => [
                        createVNode(unref(UIFormItem), { path: "phoneNumber" }, {
                          default: withCtx(() => [
                            createVNode(unref(UIInput), {
                              modelValue: socialMediaForm.value.phoneNumber,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => socialMediaForm.value.phoneNumber = $event),
                              id: "details-input"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        createElementVNode("div", _hoisted_13$e, [
                          createVNode(unref(UICheckbox), {
                            "onUpdate:checked": _cache[5] || (_cache[5] = (c) => c ? socialMediaForm.value.phoneVisibility = "public" : socialMediaForm.value.phoneVisibility = "private"),
                            checked: socialMediaForm.value.phoneVisibility === "public" ? true : false,
                            id: "checkbox",
                            src: "",
                            fallbackSrc: "",
                            type: "default",
                            class: "place-content-end"
                          }, {
                            default: withCtx(() => [
                              createTextVNode(toDisplayString(unref(t2)("social.visibility")), 1)
                            ]),
                            _: 1
                          }, 8, ["checked"])
                        ])
                      ]),
                      _: 1
                    }, 8, ["title"]),
                    createVNode(_sfc_main$1L, {
                      title: unref(t2)("common.email"),
                      align: void 0,
                      inline: false,
                      wrapItem: true,
                      justify: "start",
                      size: "medium",
                      vertical: true,
                      wrap: true,
                      class: "mt-6"
                    }, {
                      "space-slot": withCtx(() => [
                        createVNode(unref(UIFormItem), { path: "email" }, {
                          default: withCtx(() => [
                            createVNode(unref(UIInput), {
                              modelValue: socialMediaForm.value.email,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => socialMediaForm.value.email = $event),
                              id: "details-input"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        createElementVNode("div", _hoisted_14$a, [
                          createVNode(unref(UICheckbox), {
                            "onUpdate:checked": _cache[7] || (_cache[7] = (c) => c ? socialMediaForm.value.emailVisibility = "public" : socialMediaForm.value.emailVisibility = "private"),
                            checked: socialMediaForm.value.emailVisibility === "public" ? true : false,
                            id: "checkbox",
                            src: "",
                            fallbackSrc: "",
                            type: "default",
                            class: "place-content-end"
                          }, {
                            default: withCtx(() => [
                              createTextVNode(toDisplayString(unref(t2)("social.visibility")), 1)
                            ]),
                            _: 1
                          }, 8, ["checked"])
                        ])
                      ]),
                      _: 1
                    }, 8, ["title"]),
                    createVNode(_sfc_main$1L, {
                      title: unref(t2)("social.platforms.twitter"),
                      align: void 0,
                      inline: false,
                      wrapItem: true,
                      justify: "start",
                      size: "medium",
                      vertical: true,
                      wrap: true
                    }, {
                      "space-slot": withCtx(() => [
                        createVNode(unref(UIFormItem), { path: "twitter" }, {
                          default: withCtx(() => [
                            createVNode(unref(UIInput), {
                              modelValue: socialMediaForm.value.twitter,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => socialMediaForm.value.twitter = $event),
                              id: "details-input",
                              maxlength: 50,
                              placeholder: "https://twitter.com/marketing"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["title"]),
                    createVNode(_sfc_main$1L, {
                      title: unref(t2)("social.platforms.instagram"),
                      align: void 0,
                      inline: false,
                      wrapItem: true,
                      justify: "start",
                      size: "medium",
                      vertical: true,
                      wrap: true
                    }, {
                      "space-slot": withCtx(() => [
                        createVNode(unref(UIFormItem), { path: "instagram" }, {
                          default: withCtx(() => [
                            createVNode(unref(UIInput), {
                              modelValue: socialMediaForm.value.instagram,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => socialMediaForm.value.instagram = $event),
                              id: "details-input",
                              maxlength: 50,
                              placeholder: "https://instagram.com/marketing"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["title"]),
                    createVNode(_sfc_main$1L, {
                      title: unref(t2)("social.platforms.facebook"),
                      align: void 0,
                      inline: false,
                      wrapItem: true,
                      justify: "start",
                      size: "medium",
                      vertical: true,
                      wrap: true
                    }, {
                      "space-slot": withCtx(() => [
                        createVNode(unref(UIFormItem), { path: "facebook" }, {
                          default: withCtx(() => [
                            createVNode(unref(UIInput), {
                              modelValue: socialMediaForm.value.facebook,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => socialMediaForm.value.facebook = $event),
                              id: "details-input",
                              maxlength: 50,
                              placeholder: "https://facebook.com/marketing"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["title"]),
                    createVNode(_sfc_main$1L, {
                      title: unref(t2)("common.youtube"),
                      align: void 0,
                      inline: false,
                      wrapItem: true,
                      justify: "start",
                      size: "medium",
                      vertical: true,
                      wrap: true
                    }, {
                      "space-slot": withCtx(() => [
                        createVNode(unref(UIFormItem), { path: "youtube" }, {
                          default: withCtx(() => [
                            createVNode(unref(UIInput), {
                              modelValue: socialMediaForm.value.youtube,
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => socialMediaForm.value.youtube = $event),
                              id: "details-input",
                              maxlength: 50,
                              placeholder: "https://youtube.com/marketing"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["title"]),
                    createVNode(_sfc_main$1L, {
                      title: unref(t2)("social.platforms.linkedin"),
                      align: void 0,
                      inline: false,
                      wrapItem: true,
                      justify: "start",
                      size: "medium",
                      vertical: true,
                      wrap: true
                    }, {
                      "space-slot": withCtx(() => [
                        createVNode(unref(UIFormItem), { path: "linkedin" }, {
                          default: withCtx(() => [
                            createVNode(unref(UIInput), {
                              modelValue: socialMediaForm.value.linkedin,
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => socialMediaForm.value.linkedin = $event),
                              id: "details-input",
                              maxlength: 50,
                              placeholder: "https://linkedin.com/marketing"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["title"])
                  ]),
                  _: 1
                }, 8, ["model"])
              ])
            ]),
            _: 1
          })
        ], 512),
        createVNode(unref(UIDrawer), {
          class: "rounded-t-xl p-0 !h-[110vw]",
          show: showTimezones.value,
          "onUpdate:show": _cache[15] || (_cache[15] = ($event) => showTimezones.value = $event),
          placement: "bottom",
          id: "timezones-options-drawer",
          "auto-focus": false
        }, {
          default: withCtx(() => [
            createVNode(unref(UIDrawerContent), {
              id: "timezones-options-drawer-menu",
              class: "p-0 timezone",
              closable: false
            }, {
              default: withCtx(() => [
                createElementVNode("div", _hoisted_15$8, [
                  createElementVNode("div", _hoisted_16$6, [
                    withDirectives(createElementVNode("div", _hoisted_17$4, null, 512), [
                      [_directive_swipe, {
                        direction: "down",
                        callback: () => {
                          showTimezones.value = !showTimezones.value;
                        }
                      }]
                    ]),
                    createVNode(unref(UITextMdMedium), { class: "text-black mt-4 mb-4" }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(unref(t2)("profileSettings.selectTimezone")), 1)
                      ]),
                      _: 1
                    }),
                    createVNode(unref(UIDivider), { class: "w-full" }),
                    createElementVNode("div", _hoisted_18$4, [
                      withDirectives(createElementVNode("input", {
                        id: "search",
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => searchText.value = $event),
                        "aria-label": unref(t2)("profileSettings.search"),
                        name: "search",
                        type: "text",
                        maxlength: "64",
                        class: "border-0 appearance-none border-gray-400 rounded-none relative block w-full px-3 pb-2 focus:outline-none placeholder-gray-400 text-gray-900 sm:text-sm sm:leading-5",
                        placeholder: unref(t2)("profileSettings.searchTimezones")
                      }, null, 8, _hoisted_19$4), [
                        [
                          vModelText,
                          searchText.value,
                          void 0,
                          { trim: true }
                        ]
                      ]),
                      createElementVNode("div", _hoisted_20$3, [
                        createVNode(unref(render$f), {
                          name: "search",
                          class: "w-5 h-5 text-gray-400"
                        })
                      ])
                    ]),
                    createVNode(unref(UIDivider), {
                      id: "searchDivider",
                      class: "w-full"
                    })
                  ]),
                  createElementVNode("div", _hoisted_21$3, [
                    createVNode(unref(UIRadioGroup), {
                      value: socialMediaForm.value.timeZone,
                      "onUpdate:value": _cache[14] || (_cache[14] = ($event) => socialMediaForm.value.timeZone = $event),
                      name: "radioButtonGroup1",
                      disabled: false,
                      id: "search-timezone-radio",
                      size: "medium",
                      "default-value": socialMediaForm.value.timeZone
                    }, {
                      default: withCtx(() => {
                        var _a;
                        return [
                          ((_a = filteredTimezones.value) == null ? void 0 : _a.length) > 0 ? (openBlock(), createElementBlock("div", _hoisted_22$3, [
                            (openBlock(true), createElementBlock(Fragment, null, renderList(filteredTimezones.value, (timeZone) => {
                              return openBlock(), createBlock(unref(UIRadio), {
                                id: timeZone.value,
                                key: timeZone.value,
                                value: timeZone.value,
                                label: timeZone.value,
                                onChange: ($event) => handleTimeZone(timeZone.value),
                                class: "py-6 w-full items-center !border-b-2 !border-gray-400"
                              }, {
                                default: withCtx(() => [
                                  createElementVNode("div", _hoisted_23$3, [
                                    createElementVNode("div", _hoisted_24$3, [
                                      createVNode(unref(render$g), { class: "text-primary-500 h-5 w-5" })
                                    ]),
                                    createElementVNode("div", _hoisted_25$2, [
                                      createVNode(unref(UITextMdMedium), null, {
                                        default: withCtx(() => [
                                          createTextVNode(toDisplayString(timeZone == null ? void 0 : timeZone.value), 1)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      createVNode(unref(UITextSmNormal), null, {
                                        default: withCtx(() => [
                                          createTextVNode(toDisplayString((timeZone == null ? void 0 : timeZone.label.split(" ")[0]) + " " + (timeZone == null ? void 0 : timeZone.label.split(" ")[2]) + " | " + (timeZone == null ? void 0 : timeZone.currentTime)), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ])
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["id", "value", "label", "onChange"]);
                            }), 128))
                          ])) : (openBlock(), createBlock(unref(UITextMdNormal), {
                            key: 1,
                            class: "text-gray-400 mt-4 text-center"
                          }, {
                            default: withCtx(() => [
                              createTextVNode(toDisplayString(unref(t2)("profileSettings.noTimezonesFound")), 1)
                            ]),
                            _: 1
                          }))
                        ];
                      }),
                      _: 1
                    }, 8, ["value", "default-value"])
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["show"])
      ]);
    };
  }
});
const EditDetails = /* @__PURE__ */ _export_sfc(_sfc_main$1I, [["__scopeId", "data-v-9cfc7709"]]);
function loadImage(image) {
  return new Promise((resolve, reject) => {
    image.addEventListener("load", () => {
      resolve(image);
    });
    image.addEventListener("error", (error) => {
      reject(error);
    });
  });
}
function preloadImage(url) {
  const img = new Image();
  img.src = url;
  return img;
}
class ContentUploadWeb extends WebPlugin {
  async uploadFile() {
    throw new Error(
      "ContentUpload is not available on web. Use web upload instead."
    );
  }
  async cancelUpload() {
    throw new Error("ContentUpload is not available on web");
  }
  async cancelAllUploads() {
    throw new Error("ContentUpload is not available on web");
  }
}
const ContentUpload = registerPlugin("ContentUpload", {
  web: new ContentUploadWeb()
});
const _sfc_main$1H = /* @__PURE__ */ defineComponent({
  __name: "DeleteAccountDrawer",
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:show"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const showDrawer = ref(false);
    const t2 = inject("t");
    watch(
      () => props.show,
      (newVal) => {
        showDrawer.value = newVal;
      }
    );
    const handleClose = () => {
      emit("update:show", false);
    };
    const handleDeleteAccount = async () => {
      emit("update:show", false);
      await logoutUser();
    };
    return (_ctx, _cache) => {
      const _directive_swipe = resolveDirective("swipe");
      return openBlock(), createBlock(unref(UIDrawer), {
        class: "rounded-t-xl bg-white",
        show: showDrawer.value,
        "onUpdate:show": [
          _cache[0] || (_cache[0] = ($event) => showDrawer.value = $event),
          handleClose
        ],
        placement: "bottom",
        id: "image-drawer",
        height: 280
      }, {
        default: withCtx(() => [
          withDirectives((openBlock(), createBlock(unref(UIDrawerContent), {
            id: "image-drawer-menu",
            class: "p-0",
            closable: false
          }, {
            default: withCtx(() => [
              createElementVNode("div", null, [
                _cache[1] || (_cache[1] = createElementVNode("div", { class: "flex justify-center items-center" }, [
                  createElementVNode("div", { class: "mt-2 h-1 w-16 mb-4 rounded-md border border-solid bg-gray-200 border-gray-200 self-center" })
                ], -1)),
                createVNode(unref(UITextMdMedium), { class: "text-black" }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(unref(t2)("deleteAccount.title")), 1)
                  ]),
                  _: 1
                }),
                createVNode(unref(UITextSmRegular), { class: "text-gray-400 mt-4" }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(unref(t2)("deleteAccount.deleteAccountDescription")), 1)
                  ]),
                  _: 1
                }),
                createVNode(unref(UITextSmRegular), { class: "text-gray-400 mt-4" }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(unref(t2)("deleteAccount.deleteAccountDescription2")), 1)
                  ]),
                  _: 1
                }),
                createVNode(unref(UIButton), {
                  type: "error",
                  id: "logout-btn",
                  class: "w-full mt-4 mb-4",
                  onClick: handleDeleteAccount
                }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(unref(t2)("deleteAccount.deleteAccountButton")), 1)
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          })), [
            [_directive_swipe, {
              direction: "down",
              callback: () => handleClose()
            }]
          ])
        ]),
        _: 1
      }, 8, ["show"]);
    };
  }
});
const DeleteAccountDrawer = /* @__PURE__ */ _export_sfc(_sfc_main$1H, [["__scopeId", "data-v-705ff668"]]);
const _hoisted_1$1v = { class: "flex flex-col h-screen w-full fixed bg-white z-[100]" };
const _hoisted_2$17 = {
  id: "edit-profile-navbar",
  class: "fixed left-0 right-0 top-0 z-50 w-full bg-white"
};
const _hoisted_3$$ = { class: "relative z-50 inline-flex w-full bg-white" };
const _hoisted_4$V = { class: "relative z-50 flex items-center justify-center gap-[13px] bg-white" };
const _hoisted_5$L = { class: "relative z-50 flex items-start justify-center gap-2.5 bg-white" };
const _hoisted_6$E = { class: "flex items-start justify-start gap-1" };
const _hoisted_7$z = { class: "inline-flex flex-col items-start justify-start" };
const _hoisted_8$p = { class: "text-lg font-medium text-slate-700" };
const _hoisted_9$l = { class: "flex grow items-center justify-end" };
const _hoisted_10$j = { class: "flex items-start justify-start gap-4" };
const _hoisted_11$j = {
  class: "relative cursor-pointer",
  onClick: () => {
  }
};
const _hoisted_12$e = { class: "w-full col-span-3" };
const _hoisted_13$d = { class: "flex place-content-between" };
const _hoisted_14$9 = { class: "flex mt-4 place-content-center" };
const _hoisted_15$7 = {
  key: 1,
  class: "text-xs text-gray-500"
};
const _hoisted_16$5 = ["src"];
const _hoisted_17$3 = { class: "mt-10 w-full col-span-3" };
const _hoisted_18$3 = { class: "flex place-content-between" };
const _hoisted_19$3 = { class: "flex mt-4 place-content-center" };
const _hoisted_20$2 = {
  key: 0,
  class: "flex flex-col items-center"
};
const _hoisted_21$2 = {
  key: 1,
  class: "text-xs text-gray-500"
};
const _hoisted_22$2 = ["src"];
const _hoisted_23$2 = { class: "mt-10 w-full col-span-3" };
const _hoisted_24$2 = { class: "flex place-content-between" };
const _hoisted_25$1 = { class: "flex flex-col w-full mt-4 place-content-center gap-4 overflow-hidden" };
const _hoisted_26$1 = { class: "mt-10 w-full col-span-3" };
const _hoisted_27$1 = { class: "flex place-content-between" };
const _hoisted_28$1 = { class: "flex flex-col w-full mt-4 place-content-center gap-4 overflow-hidden" };
const _hoisted_29$1 = { class: "mt-10 w-full col-span-3" };
const _hoisted_30$1 = { class: "flex place-content-between" };
const _hoisted_31$1 = { class: "flex flex-col w-full mt-4 place-content-center gap-4 overflow-hidden" };
const _hoisted_32 = { class: "flex flex-col" };
const _hoisted_33 = ["onClick"];
const _hoisted_34 = {
  key: 0,
  class: "hover inline-flex h-full w-[95%] items-center justify-start gap-2 rounded-lg"
};
const _hoisted_35 = { class: "inline-flex flex-col items-start justify-center gap-4" };
const _hoisted_36 = { class: "inline-flex items-center justify-start gap-4" };
const _hoisted_37 = { class: "relative h-10 w-10" };
const _hoisted_38 = { class: "h-10 w-10 rounded-md bg-gray-200" };
const _hoisted_39 = { class: "flex h-10 w-10 items-center justify-center rounded-full" };
const _hoisted_40 = { class: "flex h-8 w-8 cursor-pointer items-center justify-center rounded-full bg-gray-200 text-gray-600" };
const _hoisted_41 = { class: "inline-flex flex-col items-start justify-start" };
const _sfc_main$1G = /* @__PURE__ */ defineComponent({
  __name: "EditProfile",
  emits: ["update:show", "update:save", "update:edited"],
  setup(__props, { emit: __emit }) {
    const routerInstance = AppState.getRouterInstance();
    const boxRef = ref(null);
    const loadingRef = ref(null);
    const t2 = inject("t");
    onBeforeMount(async () => {
      setFormData();
    });
    function setFormData() {
      var _a, _b, _c, _d, _e, _f, _g, _h;
      profileForm.value.avatar = ((_b = (_a = UserState) == null ? void 0 : _a.state) == null ? void 0 : _b.avatar) ? [
        {
          status: "finished",
          name: t2.value("profileSettings.profilePicture"),
          type: "image/jpeg",
          url: (_d = (_c = UserState) == null ? void 0 : _c.state) == null ? void 0 : _d.avatar
        }
      ] : [];
      profileForm.value.profileCover = ((_f = (_e = UserState) == null ? void 0 : _e.state) == null ? void 0 : _f.profileCover) ? [
        {
          status: "finished",
          name: t2.value("profileSettings.profileCover"),
          type: "image/jpeg",
          url: (_h = (_g = UserState) == null ? void 0 : _g.state) == null ? void 0 : _h.profileCover
        }
      ] : [];
    }
    const showImageDrawer = ref(false);
    const showDeleteAccountDrawer = ref(false);
    const fileUpload = ref(null);
    const uploadType = ref("");
    const avatarLoading = ref(false);
    const profileCoverLoading = ref(false);
    const uploadProgress = ref(0);
    const isUploading = ref(false);
    const openDrawer = (value, type) => {
      if (!value) {
        imageDrawerOptions[1].showOnMobile = false;
      } else {
        imageDrawerOptions[1].showOnMobile = true;
      }
      uploadType.value = type;
      showImageDrawer.value = !showImageDrawer.value;
    };
    const imageDrawerOptions = [
      {
        id: "upload-photo",
        title: t2.value("profileSettings.uploadPhoto"),
        component: render$h,
        showOnMobile: true,
        reaction: () => {
          fileUpload.value.click();
          showImageDrawer.value = !showImageDrawer.value;
        }
      },
      {
        id: "remove-photo",
        title: t2.value("profileSettings.removePhoto"),
        component: render$i,
        showOnMobile: true,
        reaction: () => {
          profileForm.value[uploadType.value] = [];
          showImageDrawer.value = !showImageDrawer.value;
        }
      }
    ];
    function handleFileInputChange(event) {
      const { files } = event.target;
      if (!files || !files.length) {
        console.debug("[handleFileInputChange] No files selected");
        return;
      }
      if (isUploading.value) {
        console.warn(
          "[handleFileInputChange] Upload already in progress, ignoring new file selection"
        );
        notificationAlert(
          "Upload in progress",
          "Please wait for the current upload to finish."
        );
        return;
      }
      console.debug(
        "[handleFileInputChange] Files selected:",
        files.length,
        "files"
      );
      console.debug("[handleFileInputChange] Upload type:", uploadType.value);
      console.debug("[handleFileInputChange] Is PWA:", isPwa());
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        file.status = "not-started";
        file.id = v4();
        if (isPwa() && (file.webkitRelativePath || navigator.userAgent.includes("Mobile"))) {
          console.debug("[handleFileInputChange] Creating native-style file object");
          const nativeStyleFile = {
            name: file.name,
            type: file.type,
            size: file.size,
            lastModified: file.lastModified,
            id: file.id,
            status: "not-started",
            // Add path property to trigger native upload
            path: URL.createObjectURL(file),
            // Use blob URL as path for native processing
            _originalFile: file
            // Keep reference to original file for web fallback
          };
          console.debug(
            "[handleFileInputChange] Native-style file created:",
            nativeStyleFile
          );
          beforeUpload(uploadType.value, nativeStyleFile);
        } else {
          file.useNativeUpload = false;
          console.debug(
            "[handleFileInputChange] Processing web file:",
            file.name,
            "Type:",
            file.type,
            "Size:",
            file.size
          );
          beforeUpload(uploadType.value, file);
        }
      }
      event.target.value = "";
    }
    const uploadedUrl = reactive({
      avatar: {},
      profileCover: {}
    });
    const actionUrl = reactive({
      avatar: {},
      profileCover: {}
    });
    const profileBasicInformation = computed(() => {
      var _a, _b, _c, _d;
      return [
        {
          title: t2.value("billing.fullName"),
          value: (_a = UserState.state) == null ? void 0 : _a.fullName
        },
        {
          title: t2.value("common.title"),
          value: (_b = UserState.state) == null ? void 0 : _b.title
        },
        {
          title: t2.value("profileSettings.profileSlug"),
          value: (_c = UserState.state) == null ? void 0 : _c.slug
        },
        {
          title: t2.value("profileSettings.bio"),
          value: (_d = UserState.state) == null ? void 0 : _d.bio
        }
      ];
    });
    const hasProfileBasicInformation = computed(() => {
      return !profileBasicInformation.value.every((item) => !item.value);
    });
    const profileDetails = computed(() => {
      var _a, _b, _c, _d, _e, _f, _g, _h, _i;
      return [
        {
          title: t2.value("common.location"),
          value: (_a = UserState.state) == null ? void 0 : _a.location
        },
        {
          title: t2.value("profileSettings.timezone"),
          value: (_b = UserState.state) == null ? void 0 : _b.timeZone
        },
        {
          title: t2.value("social.phoneNumber"),
          value: (_c = UserState.state) == null ? void 0 : _c.socials.phoneNumber
        },
        {
          title: t2.value("common.email"),
          value: (_d = UserState.state) == null ? void 0 : _d.socials.email
        },
        {
          title: t2.value("social.platforms.twitter"),
          value: (_e = UserState.state) == null ? void 0 : _e.socials.twitter
        },
        {
          title: t2.value("social.platforms.instagram"),
          value: (_f = UserState.state) == null ? void 0 : _f.socials.instagram
        },
        {
          title: t2.value("social.platforms.facebook"),
          value: (_g = UserState.state) == null ? void 0 : _g.socials.facebook
        },
        {
          title: t2.value("common.youtube"),
          value: (_h = UserState.state) == null ? void 0 : _h.socials.youtube
        },
        {
          title: t2.value("social.platforms.linkedin"),
          value: (_i = UserState.state) == null ? void 0 : _i.socials.linkedin
        }
      ];
    });
    const hasProfileDetails = computed(() => {
      return !profileDetails.value.every((item) => !item.value);
    });
    const userAccount = computed(() => {
      var _a, _b, _c;
      const result = [
        {
          title: t2.value("changePassword.loginEmail"),
          value: (_a = UserState.state) == null ? void 0 : _a.email
        },
        {
          title: t2.value("changePassword.password"),
          value: "**********"
        }
      ];
      if (TEST_EMAILS.includes((_c = (_b = UserState) == null ? void 0 : _b.state) == null ? void 0 : _c.email.toLowerCase().trim())) {
        result.push({
          title: t2.value("deleteAccount.title"),
          titleClass: "text-red-500",
          value: "",
          action: () => {
            showDeleteAccountDrawer.value = true;
          }
        });
      }
      return result;
    });
    const handleEditRoutes = (queryValue) => {
      const currentPath = window.location.pathname;
      if (routerInstance) {
        routerInstance.push({
          path: `${currentPath}`,
          query: { activeScreen: queryValue }
        });
      }
    };
    const profileForm = ref({
      avatar: [],
      profileCover: []
    });
    const state = ref({
      file: null,
      avatar: { aspectRatioError: false, aspectRatio: 1 },
      profileCover: { aspectRatioError: false, aspectRatio: 1.78 }
    });
    const notification = useNotification();
    function notificationAlert(title, content) {
      notification.create({
        title,
        content,
        duration: 5e3
      });
    }
    function handleRemoveUploadedImage(data, type) {
      profileForm.value[type] = [];
    }
    async function beforeUpload(type, data) {
      try {
        const file = data;
        state.value.file = file;
        if (file && ALLOWED_FILE_TYPES.includes(data.type)) {
          if (isPwa() && file.path) {
            console.debug(
              "[beforeUpload] Native file detected, skipping image validation"
            );
            state.value[type].aspectRatioError = false;
            await getSignedUrlAndUpload(type, data);
            return true;
          } else {
            const img = new Image();
            const blobedFile = new File([file], file.name, {
              type: file.type
            });
            img.src = URL.createObjectURL(blobedFile);
            await loadImage(img);
            state.value[type].aspectRatioError = false;
            await getSignedUrlAndUpload(type, data);
            return true;
          }
        } else {
          notificationAlert(t2.value("profileSettings.imageTypeNotSupported"), "");
          await handleRemoveUploadedImage(data, type);
          return false;
        }
      } catch (error) {
        if (error === t2.value("profileSettings.invalidAspectRatio")) {
          state.value[type].aspectRatioError = true;
          if (type === "avatar") {
            notificationAlert(
              t2.value("profileSettings.recommendedAspectRatio11"),
              ""
            );
          } else if (type === "profileCover") {
            notificationAlert(
              t2.value("profileSettings.recommendedAspectRatio169"),
              ""
            );
          } else {
            notificationAlert(t2.value("profileSettings.invalidAspectRatio"), "");
          }
        } else {
          notificationAlert(
            t2.value("mandatedInfoModal.oopsUnableToUploadImage"),
            t2.value("mandatedInfoModal.pleaseTryAgainLater")
          );
        }
        console.error(error);
        return false;
      }
    }
    async function getSignedUrlAndUpload(type, data) {
      if (!ALLOWED_FILE_TYPES.includes(data.type)) {
        console.error("[getSignedUrlAndUpload] File type not supported:", data.type);
        notificationAlert(t2.value("profileSettings.imageTypeNotSupported"), "");
        return false;
      }
      isUploading.value = true;
      uploadProgress.value = 0;
      const name = v4();
      try {
        const { url, signedUrl } = (await MediaService.generateSignedUrl({
          name,
          folder: "users",
          type: data.type
        })).data;
        actionUrl[type].value = signedUrl;
        uploadedUrl[type].value = url;
        if (type === "avatar") {
          avatarLoading.value = true;
        } else if (type === "profileCover") {
          profileCoverLoading.value = true;
        }
        let uploadResult;
        if (isPwa() && data.path) {
          uploadResult = await uploadFileNative(data, name, signedUrl, url);
        } else {
          uploadResult = await uploadFileWeb(data, name, signedUrl, url);
        }
        profileForm.value[type] = [];
        profileForm.value[type].push({
          name: uploadResult.name,
          status: uploadResult.status,
          url: uploadResult.url,
          type: uploadResult.type
        });
      } catch (error) {
        console.error("[getSignedUrlAndUpload] Upload failed:", error);
        notificationAlert(
          t2.value("changePassword.systemErrorOccurred"),
          t2.value("mandatedInfoModal.pleaseTryAgainLater")
        );
      } finally {
        avatarLoading.value = false;
        profileCoverLoading.value = false;
        isUploading.value = false;
        uploadProgress.value = 0;
      }
    }
    async function uploadFileWeb(file, name, signedUrl, url) {
      console.debug("[uploadFileWeb] Starting web upload");
      console.debug("[uploadFileWeb] File:", file.name, "Size:", file.size);
      const blobedFile = new File([file], name);
      const xhr = new XMLHttpRequest();
      return new Promise(function(resolve, reject) {
        const formData = new FormData();
        formData.append("file", blobedFile);
        xhr.open("PUT", signedUrl, true);
        xhr.onload = () => {
          const status = xhr.status;
          console.debug("[uploadFileWeb] Upload completed with status:", status);
          if (status === 200) {
            resolve({
              id: file.id,
              url,
              name: file.name,
              type: file.type,
              size: file.size,
              status: "completed"
            });
          } else {
            console.error("[uploadFileWeb] Upload failed with status:", status);
            reject(t2.value("changePassword.systemErrorOccurred"));
            notificationAlert(
              t2.value("changePassword.systemErrorOccurred"),
              t2.value("mandatedInfoModal.pleaseTryAgainLater")
            );
          }
        };
        xhr.onerror = () => {
          console.error("[uploadFileWeb] Upload error occurred");
          reject(t2.value("changePassword.systemErrorOccurred"));
          notificationAlert(
            t2.value("changePassword.systemErrorOccurred"),
            t2.value("mandatedInfoModal.pleaseTryAgainLater")
          );
        };
        xhr.setRequestHeader("Content-Type", file.type);
        if (file.progressUpdate) {
          xhr.upload.onprogress = function(event) {
            if (event.lengthComputable) {
              const percentComplete = Number(
                (event.loaded / event.total * 100).toFixed()
              );
              uploadProgress.value = percentComplete;
              file.progressUpdate(percentComplete);
            }
          };
        }
        xhr.send(blobedFile);
      });
    }
    async function uploadFileNative(file, name, signedUrl, url) {
      console.debug("[uploadFileNative] Starting native upload");
      console.debug("[uploadFileNative] File path:", file.path);
      console.debug("[uploadFileNative] File name:", file.name);
      if (file.path && file.path.startsWith("blob:") && file._originalFile) {
        console.debug(
          "[uploadFileNative] Detected blob URL path, falling back to web upload with original file"
        );
        return await uploadFileWeb(file._originalFile, name, signedUrl, url);
      }
      try {
        ContentUpload == null ? void 0 : ContentUpload.addListener("uploadProgress", (data) => {
          if (data.uploadId === file.id) {
            console.debug(
              "[uploadFileNative] Upload progress:",
              data.progress + "%"
            );
            uploadProgress.value = data.progress;
          }
        });
        await (ContentUpload == null ? void 0 : ContentUpload.uploadFile({
          filePath: file.path,
          signedUrl,
          uploadId: file.id
        }));
        console.debug("[uploadFileNative] Native upload completed successfully");
        return {
          id: file.id,
          url,
          name: file.name,
          type: file.type,
          size: file.size,
          status: "completed"
        };
      } catch (error) {
        console.error("[uploadFileNative] Native upload failed:", error);
        if (file._originalFile) {
          console.debug("[uploadFileNative] Falling back to web upload");
          return await uploadFileWeb(file._originalFile, name, signedUrl, url);
        }
        throw error;
      }
    }
    const root = ref();
    async function validateForm2() {
      return new Promise((resolve, reject) => {
        root.value.getForm().validate().then(() => resolve(true)).catch((e) => {
          console.error("error", e);
          reject(e);
        });
      });
    }
    const updatingProfileSetting = ref(false);
    async function saveProfile() {
      var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l;
      await validateForm2();
      try {
        (_a = loadingRef.value) == null ? void 0 : _a.startLoadBar();
        updatingProfileSetting.value = true;
        await ((_j = UserState) == null ? void 0 : _j.updateUserProfile({
          avatar: ((_c = (_b = profileForm.value) == null ? void 0 : _b.avatar[0]) == null ? void 0 : _c.url) || "",
          profileCover: ((_e = (_d = profileForm.value) == null ? void 0 : _d.profileCover[0]) == null ? void 0 : _e.url) || "",
          locationId: (_g = (_f = LocationState) == null ? void 0 : _f.state) == null ? void 0 : _g.locationId,
          userId: (_i = (_h = UserState) == null ? void 0 : _h.state) == null ? void 0 : _i.userId
        }));
        updatingProfileSetting.value = false;
        (_k = loadingRef.value) == null ? void 0 : _k.stopLoadBar();
        setTimeout(() => {
          if (routerInstance) {
            routerInstance.back();
          }
        }, 300);
      } catch (e) {
        (_l = loadingRef.value) == null ? void 0 : _l.errorLoadBar();
        console.error(e);
      }
    }
    return (_ctx, _cache) => {
      const _directive_swipe = resolveDirective("swipe");
      return openBlock(), createElementBlock("div", _hoisted_1$1v, [
        createElementVNode("div", _hoisted_2$17, [
          createVNode(unref(UICard), { class: "relative z-50 h-full w-full !rounded-none bg-white" }, {
            default: withCtx(() => [
              createElementVNode("div", _hoisted_3$$, [
                createElementVNode("div", _hoisted_4$V, [
                  createElementVNode("div", _hoisted_5$L, [
                    createElementVNode("div", {
                      onClick: _cache[0] || (_cache[0] = () => {
                        if (unref(routerInstance)) {
                          unref(routerInstance).back();
                        }
                      }),
                      class: "relative h-5 w-5 cursor-pointer"
                    }, [
                      createVNode(unref(render$6))
                    ])
                  ]),
                  createElementVNode("div", _hoisted_6$E, [
                    createElementVNode("div", _hoisted_7$z, [
                      createElementVNode("div", _hoisted_8$p, toDisplayString(unref(t2)("profileSettings.editProfile")), 1)
                    ])
                  ])
                ]),
                createElementVNode("div", _hoisted_9$l, [
                  createElementVNode("div", _hoisted_10$j, [
                    createElementVNode("div", _hoisted_11$j, [
                      createVNode(unref(UIButton), {
                        id: "details-save-btn",
                        onClick: saveProfile,
                        class: "text-primary-500 text-lg",
                        text: true
                      }, {
                        default: withCtx(() => [
                          createTextVNode(toDisplayString(unref(t2)("common.save")), 1)
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ])
            ]),
            _: 1
          })
        ]),
        createElementVNode("div", {
          ref_key: "boxRef",
          ref: boxRef,
          class: "mt-[50px] w-full overflow-y-auto flex"
        }, [
          createVNode(_sfc_main$1N, { class: "w-full col-span-3 grid grid-cols-3 row-span-1 px-4 py-6 overflow-y-auto content" }, {
            "scroll-slot": withCtx(() => [
              createVNode(unref(UILoadingBar), {
                ref_key: "loadingRef",
                ref: loadingRef,
                to: boxRef.value
              }, null, 8, ["to"]),
              createVNode(unref(UIForm), {
                class: "w-full col-span-3",
                ref_key: "root",
                ref: root,
                model: profileForm.value,
                id: "profile-form"
              }, {
                default: withCtx(() => {
                  var _a;
                  return [
                    createElementVNode("input", {
                      class: "hidden",
                      accept: "image/*",
                      type: "file",
                      ref_key: "fileUpload",
                      ref: fileUpload,
                      onChange: handleFileInputChange
                    }, null, 544),
                    createElementVNode("div", _hoisted_12$e, [
                      createElementVNode("div", _hoisted_13$d, [
                        createVNode(unref(UITextMdMedium), { class: "text-black" }, {
                          default: withCtx(() => [
                            createTextVNode(toDisplayString(unref(t2)("profileSettings.profilePicture")), 1)
                          ]),
                          _: 1
                        }),
                        createVNode(unref(UITextMdMedium), {
                          onClick: _cache[1] || (_cache[1] = ($event) => {
                            var _a2;
                            return openDrawer((_a2 = profileForm.value) == null ? void 0 : _a2.avatar[0], "avatar");
                          }),
                          class: "text-primary-500 cursor-pointer"
                        }, {
                          default: withCtx(() => {
                            var _a2;
                            return [
                              createTextVNode(toDisplayString(((_a2 = profileForm.value) == null ? void 0 : _a2.avatar[0]) ? unref(t2)("common.edit") : unref(t2)("common.add")), 1)
                            ];
                          }),
                          _: 1
                        })
                      ]),
                      createElementVNode("div", _hoisted_14$9, [
                        !profileForm.value.avatar[0] ? (openBlock(), createBlock(unref(UIButton), {
                          key: 0,
                          class: "!bg-clientportal-liteBackground rounded-full w-[141px] h-[141px]",
                          id: "profile-avatar",
                          type: "tertiary",
                          size: "large",
                          disabled: false,
                          loading: avatarLoading.value || isUploading.value && uploadType.value === "avatar",
                          ghost: false,
                          quaternary: true,
                          circle: true,
                          text: false,
                          onClick: _cache[2] || (_cache[2] = ($event) => {
                            var _a2;
                            return openDrawer((_a2 = profileForm.value) == null ? void 0 : _a2.avatar[0], "avatar");
                          })
                        }, {
                          default: withCtx(() => [
                            !avatarLoading.value && !(isUploading.value && uploadType.value === "avatar") ? (openBlock(), createBlock(unref(render$j), {
                              key: 0,
                              class: "w-16 h-16 text-gray-300"
                            })) : createCommentVNode("", true),
                            isUploading.value && uploadType.value === "avatar" ? (openBlock(), createElementBlock("div", _hoisted_15$7, toDisplayString(uploadProgress.value) + "% ", 1)) : createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 8, ["loading"])) : (openBlock(), createBlock(unref(UIButton), {
                          key: 1,
                          class: "!bg-clientportal-liteBackground rounded-full w-[141px] h-[141px]",
                          id: void 0,
                          type: "tertiary",
                          size: "large",
                          disabled: false,
                          loading: false,
                          ghost: false,
                          quaternary: true,
                          circle: true,
                          text: false,
                          onClick: _cache[3] || (_cache[3] = ($event) => {
                            var _a2;
                            return openDrawer((_a2 = profileForm.value) == null ? void 0 : _a2.avatar[0], "avatar");
                          })
                        }, {
                          default: withCtx(() => {
                            var _a2, _b;
                            return [
                              createElementVNode("img", {
                                src: (_b = (_a2 = profileForm.value) == null ? void 0 : _a2.avatar[0]) == null ? void 0 : _b.url,
                                class: "rounded-full w-[141px] h-[141px] object-cover"
                              }, null, 8, _hoisted_16$5)
                            ];
                          }),
                          _: 1
                        }))
                      ])
                    ]),
                    createElementVNode("div", _hoisted_17$3, [
                      createElementVNode("div", _hoisted_18$3, [
                        createVNode(unref(UITextMdMedium), { class: "text-black" }, {
                          default: withCtx(() => [
                            createTextVNode(toDisplayString(unref(t2)("profileSettings.profileCover")), 1)
                          ]),
                          _: 1
                        }),
                        createVNode(unref(UITextMdMedium), {
                          onClick: _cache[4] || (_cache[4] = ($event) => {
                            var _a2;
                            return openDrawer((_a2 = profileForm.value) == null ? void 0 : _a2.profileCover[0], "profileCover");
                          }),
                          class: "text-primary-500 cursor-pointer"
                        }, {
                          default: withCtx(() => {
                            var _a2;
                            return [
                              createTextVNode(toDisplayString(((_a2 = profileForm.value) == null ? void 0 : _a2.profileCover[0]) ? unref(t2)("common.edit") : unref(t2)("common.add")), 1)
                            ];
                          }),
                          _: 1
                        })
                      ]),
                      createElementVNode("div", _hoisted_19$3, [
                        !((_a = profileForm.value) == null ? void 0 : _a.profileCover[0]) ? (openBlock(), createBlock(unref(UIButton), {
                          key: 0,
                          class: "!bg-clientportal-liteBackground rounded-md w-full h-[153px]",
                          id: void 0,
                          type: "tertiary",
                          size: "large",
                          disabled: false,
                          loading: profileCoverLoading.value || isUploading.value && uploadType.value === "profileCover",
                          ghost: false,
                          quaternary: true,
                          circle: false,
                          text: false,
                          onClick: _cache[5] || (_cache[5] = ($event) => {
                            var _a2;
                            return openDrawer((_a2 = profileForm.value) == null ? void 0 : _a2.profileCover[0], "profileCover");
                          })
                        }, {
                          default: withCtx(() => [
                            !profileCoverLoading.value && !(isUploading.value && uploadType.value === "profileCover") ? (openBlock(), createElementBlock("div", _hoisted_20$2, [
                              createVNode(unref(render$k), { class: "w-10 h-10 text-gray-300" })
                            ])) : createCommentVNode("", true),
                            isUploading.value && uploadType.value === "profileCover" ? (openBlock(), createElementBlock("div", _hoisted_21$2, toDisplayString(uploadProgress.value) + "% ", 1)) : createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 8, ["loading"])) : (openBlock(), createBlock(unref(UIButton), {
                          key: 1,
                          class: "!bg-clientportal-liteBackground block rounded-md w-full !h-[153px]",
                          id: void 0,
                          type: "tertiary",
                          size: "large",
                          disabled: false,
                          loading: false,
                          ghost: false,
                          quaternary: true,
                          circle: true,
                          text: false,
                          onClick: _cache[6] || (_cache[6] = ($event) => {
                            var _a2;
                            return openDrawer((_a2 = profileForm.value) == null ? void 0 : _a2.profileCover[0], "profileCover");
                          })
                        }, {
                          default: withCtx(() => {
                            var _a2, _b;
                            return [
                              createElementVNode("img", {
                                src: (_b = (_a2 = profileForm.value) == null ? void 0 : _a2.profileCover[0]) == null ? void 0 : _b.url,
                                class: "rounded-md w-full !h-[153px] object-cover"
                              }, null, 8, _hoisted_22$2)
                            ];
                          }),
                          _: 1
                        }))
                      ])
                    ])
                  ];
                }),
                _: 1
              }, 8, ["model"]),
              createElementVNode("div", _hoisted_23$2, [
                createElementVNode("div", _hoisted_24$2, [
                  createVNode(unref(UITextMdMedium), { class: "text-black" }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(unref(t2)("profileSettings.basicInformation")), 1)
                    ]),
                    _: 1
                  }),
                  createVNode(unref(UITextMdMedium), {
                    onClick: _cache[7] || (_cache[7] = ($event) => handleEditRoutes("EditBasicInfo")),
                    class: "text-primary-500 cursor-pointer"
                  }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(hasProfileBasicInformation.value ? unref(t2)("common.edit") : unref(t2)("common.add")), 1)
                    ]),
                    _: 1
                  })
                ]),
                createElementVNode("div", _hoisted_25$1, [
                  (openBlock(true), createElementBlock(Fragment, null, renderList(profileBasicInformation.value, (item) => {
                    return openBlock(), createElementBlock("div", {
                      class: "flex flex-col w-full gap-1",
                      key: item.title
                    }, [
                      createVNode(unref(UITextSmNormal), { class: "text-black w-full" }, {
                        default: withCtx(() => [
                          createTextVNode(toDisplayString(item.title), 1)
                        ]),
                        _: 2
                      }, 1024),
                      createVNode(unref(UITextXsRegular), {
                        onClick: () => {
                          if (!item.value) {
                            handleEditRoutes("EditBasicInfo");
                          }
                        },
                        class: normalizeClass(["w-full", item.value ? "text-gray-400" : "text-primary-500"])
                      }, {
                        default: withCtx(() => [
                          createTextVNode(toDisplayString(item.value ? item.value : "Add " + item.title[0].toLowerCase() + item.title.substring(1)), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick", "class"])
                    ]);
                  }), 128))
                ])
              ]),
              createElementVNode("div", _hoisted_26$1, [
                createElementVNode("div", _hoisted_27$1, [
                  createVNode(unref(UITextMdMedium), { class: "text-black" }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(unref(t2)("common.details")), 1)
                    ]),
                    _: 1
                  }),
                  createVNode(unref(UITextMdMedium), {
                    onClick: _cache[8] || (_cache[8] = ($event) => handleEditRoutes("EditDetails")),
                    class: "text-primary-500 cursor-pointer"
                  }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(hasProfileDetails.value ? unref(t2)("common.edit") : unref(t2)("common.add")), 1)
                    ]),
                    _: 1
                  })
                ]),
                createElementVNode("div", _hoisted_28$1, [
                  (openBlock(true), createElementBlock(Fragment, null, renderList(profileDetails.value, (item) => {
                    return openBlock(), createElementBlock("div", {
                      class: "flex flex-col w-full gap-1",
                      key: item.title
                    }, [
                      createVNode(unref(UITextSmNormal), { class: "text-black w-full" }, {
                        default: withCtx(() => [
                          createTextVNode(toDisplayString(unref(t2)(item.title)), 1)
                        ]),
                        _: 2
                      }, 1024),
                      createVNode(unref(UITextXsRegular), {
                        onClick: () => {
                          if (!item.value) {
                            handleEditRoutes("EditDetails");
                          }
                        },
                        class: normalizeClass(["w-full", item.value ? "text-gray-400" : "text-primary-500"])
                      }, {
                        default: withCtx(() => [
                          createTextVNode(toDisplayString(item.value ? item.value : "Add " + item.title[0].toLowerCase() + item.title.substring(1)), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick", "class"])
                    ]);
                  }), 128))
                ])
              ]),
              createElementVNode("div", _hoisted_29$1, [
                createElementVNode("div", _hoisted_30$1, [
                  createVNode(unref(UITextMdMedium), { class: "text-black" }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(unref(t2)("sideBar.account")), 1)
                    ]),
                    _: 1
                  }),
                  createVNode(unref(UITextMdMedium), {
                    onClick: _cache[9] || (_cache[9] = ($event) => handleEditRoutes("EditAccount")),
                    class: "text-primary-500 cursor-pointer"
                  }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(unref(t2)("common.edit")), 1)
                    ]),
                    _: 1
                  })
                ]),
                createElementVNode("div", _hoisted_31$1, [
                  (openBlock(true), createElementBlock(Fragment, null, renderList(userAccount.value, (item) => {
                    return openBlock(), createElementBlock("div", {
                      class: "flex flex-col w-full gap-1",
                      key: item.title
                    }, [
                      createVNode(unref(UITextSmNormal), {
                        class: normalizeClass([
                          "w-full",
                          item.titleClass ? item.titleClass : "text-black"
                        ]),
                        onClick: () => {
                          if (item.action) {
                            item.action();
                          }
                        }
                      }, {
                        default: withCtx(() => [
                          createTextVNode(toDisplayString(item.title), 1)
                        ]),
                        _: 2
                      }, 1032, ["class", "onClick"]),
                      createVNode(unref(UITextXsRegular), { class: "w-full text-gray-400" }, {
                        default: withCtx(() => [
                          createTextVNode(toDisplayString(item.value), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]);
                  }), 128))
                ])
              ])
            ]),
            _: 1
          })
        ], 512),
        createVNode(DeleteAccountDrawer, {
          show: showDeleteAccountDrawer.value,
          "onUpdate:show": _cache[10] || (_cache[10] = ($event) => showDeleteAccountDrawer.value = false)
        }, null, 8, ["show"]),
        createVNode(unref(UIDrawer), {
          class: "rounded-t-xl bg-white",
          show: showImageDrawer.value,
          "onUpdate:show": _cache[11] || (_cache[11] = ($event) => showImageDrawer.value = $event),
          placement: "bottom",
          id: "image-drawer",
          height: imageDrawerOptions.filter((i) => i.showOnMobile).length > 1 ? imageDrawerOptions.filter((i) => i.showOnMobile).length * 76 : imageDrawerOptions.filter((i) => i.showOnMobile).length * 96
        }, {
          default: withCtx(() => [
            withDirectives((openBlock(), createBlock(unref(UIDrawerContent), {
              id: "image-drawer-menu",
              class: "p-0",
              closable: false
            }, {
              default: withCtx(() => [
                createElementVNode("div", _hoisted_32, [
                  _cache[12] || (_cache[12] = createElementVNode("div", { class: "mt-2 h-1 w-16 mb-4 rounded-md border border-solid bg-gray-200 border-gray-200 self-center" }, null, -1)),
                  createElementVNode("div", {
                    class: normalizeClass([
                      "flex flex-col",
                      imageDrawerOptions.filter((i) => i.showOnMobile).length > 1 ? "gap-4" : "gap-0"
                    ])
                  }, [
                    (openBlock(), createElementBlock(Fragment, null, renderList(imageDrawerOptions, (option) => {
                      return createElementVNode("div", {
                        key: option.id,
                        id: "image-button",
                        class: "hover:cursor-pointer",
                        onClick: option.reaction
                      }, [
                        option.showOnMobile ? (openBlock(), createElementBlock("div", _hoisted_34, [
                          createElementVNode("div", _hoisted_35, [
                            createElementVNode("div", _hoisted_36, [
                              createElementVNode("div", _hoisted_37, [
                                createElementVNode("div", _hoisted_38, [
                                  createElementVNode("div", _hoisted_39, [
                                    createElementVNode("div", _hoisted_40, [
                                      (openBlock(), createBlock(resolveDynamicComponent(option.component), { class: "h-5 w-5" }))
                                    ])
                                  ])
                                ])
                              ]),
                              createElementVNode("div", _hoisted_41, [
                                createVNode(unref(UITextSmMedium), { class: "leading-tight text-slate-700" }, {
                                  default: withCtx(() => [
                                    createTextVNode(toDisplayString(option.title), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ])
                            ])
                          ])
                        ])) : createCommentVNode("", true)
                      ], 8, _hoisted_33);
                    }), 64))
                  ], 2)
                ])
              ]),
              _: 1
            })), [
              [_directive_swipe, {
                direction: "down",
                callback: () => showImageDrawer.value = !showImageDrawer.value
              }]
            ])
          ]),
          _: 1
        }, 8, ["show", "height"])
      ]);
    };
  }
});
const EditProfile = /* @__PURE__ */ _export_sfc(_sfc_main$1G, [["__scopeId", "data-v-c66cadde"]]);
const _hoisted_1$1u = { class: "flex flex-col h-screen w-full fixed bg-white z-[100] overflow-y-auto" };
const _hoisted_2$16 = {
  id: "edit-info-navbar",
  class: "fixed left-0 right-0 top-0 z-50 w-full bg-white"
};
const _hoisted_3$_ = { class: "relative z-50 flex justify-between items-center w-full bg-white" };
const _hoisted_4$U = { class: "relative z-50 flex items-center justify-center gap-[13px] bg-white" };
const _hoisted_5$K = { class: "relative z-50 flex items-start justify-center gap-2.5 bg-white" };
const _hoisted_6$D = { class: "flex items-start justify-start gap-1" };
const _hoisted_7$y = { class: "inline-flex flex-col items-start justify-start" };
const _hoisted_8$o = { class: "text-lg font-medium leading-7 text-slate-700" };
const _hoisted_9$k = { class: "" };
const _hoisted_10$i = { class: "flex flex-col gap-2 py-6 px-4 mt-10" };
const _hoisted_11$i = { class: "flex items-center justify-between cursor-pointer text-clientportal-font-primary px-4" };
const _hoisted_12$d = ["checked", "value", "onChange"];
const _hoisted_13$c = { class: "w-5 h-5 relative mr-2.5 flex items-center justify-center border border-gray-300 rounded-full" };
const _sfc_main$1F = /* @__PURE__ */ defineComponent({
  __name: "LanguageSettings",
  setup(__props) {
    var _a, _b;
    const routerInstance = AppState.getRouterInstance();
    const t2 = inject("t");
    const selectedLanguage = ref(((_b = (_a = UserState) == null ? void 0 : _a.state) == null ? void 0 : _b.languagePreference) ?? "en");
    const languages = [
      { name: "English", value: "en" },
      { name: "Spanish", value: "es" },
      { name: "French (Canada)", value: "fr-CA" },
      { name: "French (France)", value: "fr-FR" },
      { name: "Portuguese (Brazil)", value: "pt-BR" },
      { name: "Portuguese (Portugal)", value: "pt-PT" },
      { name: "Finnish", value: "fi" },
      { name: "German", value: "de" },
      { name: "Danish", value: "da" },
      { name: "Italian", value: "it" },
      { name: "Norwegian", value: "no" },
      { name: "Swedish", value: "sv" },
      { name: "Dutch", value: "nl" }
    ];
    const notification = useNotification();
    const handleLanguageChange = (language) => {
      selectedLanguage.value = language;
    };
    function notificationFailureAlert(title, content) {
      notification.error({
        title,
        content,
        duration: 5e3
      });
    }
    const isSaving = ref(false);
    const saveLanguagePreference = async () => {
      var _a2, _b2, _c, _d, _e, _f, _g, _h, _i, _j;
      isSaving.value = true;
      try {
        if (isAuthV2Enabled()) {
          await UserServiceV2.updateUser({
            ...(_a2 = UserState) == null ? void 0 : _a2.state,
            languagePreference: selectedLanguage.value,
            locationId: (_c = (_b2 = LocationState) == null ? void 0 : _b2.state) == null ? void 0 : _c.locationId,
            userId: (_e = (_d = UserState) == null ? void 0 : _d.state) == null ? void 0 : _e.userId
          });
        } else {
          await UserService.updateUser({
            ...(_f = UserState) == null ? void 0 : _f.state,
            languagePreference: selectedLanguage.value,
            locationId: (_h = (_g = LocationState) == null ? void 0 : _g.state) == null ? void 0 : _h.locationId,
            userId: (_j = (_i = UserState) == null ? void 0 : _i.state) == null ? void 0 : _j.userId
          });
        }
        window.localStorage.setItem("locale", selectedLanguage.value);
        window.location.reload();
      } catch (error) {
        notificationFailureAlert(
          t2("common.error"),
          t2("languageSettings.errorUpdatingLanguage")
        );
      } finally {
        isSaving.value = false;
      }
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$1u, [
        createElementVNode("div", _hoisted_2$16, [
          createVNode(unref(UICard), { class: "relative z-50 h-full w-full !rounded-none bg-white" }, {
            default: withCtx(() => [
              createElementVNode("div", _hoisted_3$_, [
                createElementVNode("div", _hoisted_4$U, [
                  createElementVNode("div", _hoisted_5$K, [
                    createElementVNode("div", {
                      onClick: _cache[0] || (_cache[0] = () => {
                        if (unref(routerInstance)) {
                          unref(routerInstance).back();
                        }
                      }),
                      class: "relative h-6 w-6 cursor-pointer"
                    }, [
                      createVNode(unref(render$6))
                    ])
                  ]),
                  createElementVNode("div", _hoisted_6$D, [
                    createElementVNode("div", _hoisted_7$y, [
                      createElementVNode("div", _hoisted_8$o, toDisplayString(unref(t2)("sideBar.languageSettings")), 1)
                    ])
                  ])
                ]),
                createElementVNode("div", _hoisted_9$k, [
                  createVNode(unref(UIButton), {
                    id: "save-language-button",
                    text: true,
                    size: "small",
                    class: "!font-semibold",
                    loading: isSaving.value,
                    onClick: saveLanguagePreference
                  }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(unref(t2)("common.save")), 1)
                    ]),
                    _: 1
                  }, 8, ["loading"])
                ])
              ])
            ]),
            _: 1
          })
        ]),
        createElementVNode("div", _hoisted_10$i, [
          createVNode(unref(UITextXsRegular), { class: "text-clientportal-font-secondary" }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(unref(t2)("languageSettings.description")), 1)
            ]),
            _: 1
          })
        ]),
        (openBlock(), createElementBlock(Fragment, null, renderList(languages, (language) => {
          return createElementVNode("div", {
            class: "flex flex-col gap-2 border-0 border-b border-solid border-gray-200 py-4",
            key: language.value
          }, [
            createElementVNode("label", _hoisted_11$i, [
              createTextVNode(toDisplayString(language.name) + " ", 1),
              createElementVNode("input", {
                type: "radio",
                name: "radio-btn",
                checked: selectedLanguage.value === language.value,
                value: language.value,
                onChange: ($event) => handleLanguageChange(language.value),
                class: "hidden"
              }, null, 40, _hoisted_12$d),
              createElementVNode("span", _hoisted_13$c, [
                createElementVNode("span", {
                  class: normalizeClass(["absolute w-1.5 h-3 border-solid border-transparent transform rotate-45", {
                    "border-0 border-r-2 border-b-2 border-solid !border-clientportal-font-primary": selectedLanguage.value === language.value
                  }])
                }, null, 2)
              ])
            ])
          ]);
        }), 64))
      ]);
    };
  }
});
const LanguageSettings = /* @__PURE__ */ _export_sfc(_sfc_main$1F, [["__scopeId", "data-v-c3c7551f"]]);
const _hoisted_1$1t = { class: "switcher" };
const _hoisted_2$15 = {
  key: 0,
  class: "h-12 border-0 border-b border-solid border-clientportal-border flex items-center px-4"
};
const _hoisted_3$Z = { class: "flex flex-col items-center justify-center mt-8" };
const _hoisted_4$T = { class: "flex flex-col items-center justify-center" };
const _hoisted_5$J = ["src", "width", "height"];
const _hoisted_6$C = ["onClick"];
const _hoisted_7$x = { class: "" };
const _hoisted_8$n = { class: "flex mt-[48px]" };
const _hoisted_9$j = ["src"];
const _sfc_main$1E = /* @__PURE__ */ defineComponent({
  __name: "AppSwitcher",
  props: {
    show: {
      type: Boolean
    },
    hideBackButton: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:show"],
  setup(__props, { emit: __emit }) {
    var _a, _b;
    const props = __props;
    const emit = __emit;
    const showModal = ref(false);
    const t2 = inject("t");
    const mobileAppSwitcherItems = dashboardManager.getMobileAppSwitcherItems();
    onMounted(async () => {
      showModal.value = props.show;
      if (dashboardManager) {
        try {
          await Promise.allSettled([
            dashboardManager.refreshData("groups"),
            dashboardManager.refreshData("courses")
          ]);
        } catch (error) {
          console.error("Error loading mobile app switcher data:", error);
        }
      }
    });
    watch(
      () => props.show,
      (showModalVal) => showModal.value = showModalVal
    );
    const handleClose = () => {
      showModal.value = false;
      emit("update:show", false);
    };
    const iconMap = {
      groups: COMMUNITIES_ICON,
      courses: COURSES_ICON
    };
    const apps = computed(() => {
      if (!(mobileAppSwitcherItems == null ? void 0 : mobileAppSwitcherItems.value) || mobileAppSwitcherItems.value.length === 0) {
        return [];
      }
      return mobileAppSwitcherItems.value.map((config) => {
        return {
          title: t2.value(config.title),
          description: t2.value(config.description || ""),
          colorGradient: config.gradient || "gradientCommunities",
          icon: iconMap[config.key] || config.icon,
          route: config.route,
          path: config.path
        };
      });
    });
    const appLogo = {
      src: ((_b = (_a = BrandedAppState) == null ? void 0 : _a.state) == null ? void 0 : _b.appIconImage) || KOLAB_IMAGE,
      width: 48,
      height: 48
    };
    return (_ctx, _cache) => {
      const _directive_swipe = resolveDirective("swipe");
      return openBlock(), createElementBlock("div", _hoisted_1$1t, [
        createVNode(unref(UIDrawer), {
          show: showModal.value,
          "onUpdate:show": [
            _cache[0] || (_cache[0] = ($event) => showModal.value = $event),
            handleClose
          ],
          id: "image-drawer",
          width: "100%",
          placement: "right"
        }, {
          default: withCtx(() => [
            withDirectives((openBlock(), createBlock(unref(UIDrawerContent), {
              id: "image-drawer-menu",
              closable: false
            }, {
              default: withCtx(() => [
                !__props.hideBackButton ? (openBlock(), createElementBlock("div", _hoisted_2$15, [
                  createVNode(unref(UIButton), {
                    type: "default",
                    id: "btn-back",
                    text: true,
                    onClick: handleClose
                  }, {
                    default: withCtx(() => [
                      createVNode(unref(render$6), { class: "w-5 h-5 text-clientportal-font-secondary" }),
                      createVNode(unref(UITextMdNormal), { class: "ml-3 text-clientportal-font-primary text-lg fontFamily" }, {
                        default: withCtx(() => [
                          createTextVNode(toDisplayString(unref(t2)("common.back")), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])) : createCommentVNode("", true),
                createElementVNode("div", _hoisted_3$Z, [
                  createElementVNode("div", _hoisted_4$T, [
                    createElementVNode("img", {
                      src: appLogo.src,
                      width: appLogo.width,
                      height: appLogo.height,
                      alt: "apps"
                    }, null, 8, _hoisted_5$J),
                    createVNode(unref(UITextMdNormal), { class: "text-clientportal-font-secondary fontFamily my-4 font-semibold" }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(unref(t2)("dashboard.selectApp")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  (openBlock(true), createElementBlock(Fragment, null, renderList(apps.value, (app) => {
                    return openBlock(), createElementBlock("div", {
                      key: app.title,
                      class: normalizeClass([
                        "rounded-xl px-4 py-4 flex justify-between items-center w-[80%] mb-8",
                        app.colorGradient
                      ]),
                      onClick: ($event) => unref(externalPathRedirect)(app.route, app.path || "", false)
                    }, [
                      createElementVNode("div", _hoisted_7$x, [
                        createVNode(unref(UITextLgMedium), { class: "text-white mb-1 fontFamily font-semibold" }, {
                          default: withCtx(() => [
                            createTextVNode(toDisplayString(app.title), 1)
                          ]),
                          _: 2
                        }, 1024),
                        createVNode(unref(UITextXsRegular), { class: "text-white fontFamily" }, {
                          default: withCtx(() => [
                            createTextVNode(toDisplayString(app.description), 1)
                          ]),
                          _: 2
                        }, 1024),
                        createElementVNode("div", _hoisted_8$n, [
                          createVNode(unref(UITextSmMedium), { class: "text-white fontFamily font-semibold" }, {
                            default: withCtx(() => [
                              createTextVNode(toDisplayString(unref(t2)("dashboard.exploreHere")), 1)
                            ]),
                            _: 1
                          }),
                          createVNode(unref(render$l), { class: "w-5 h-5 text-white ml-2" })
                        ])
                      ]),
                      createElementVNode("img", {
                        src: app.icon,
                        class: "w-36 h-32",
                        alt: "i18n.t('affiliates')"
                      }, null, 8, _hoisted_9$j)
                    ], 10, _hoisted_6$C);
                  }), 128))
                ])
              ]),
              _: 1
            })), [
              [_directive_swipe, {
                direction: "right",
                callback: () => handleClose()
              }]
            ])
          ]),
          _: 1
        }, 8, ["show"])
      ]);
    };
  }
});
const AppSwitcher$1 = /* @__PURE__ */ _export_sfc(_sfc_main$1E, [["__scopeId", "data-v-686fbaa6"]]);
const _hoisted_1$1s = { class: "mx-2 flex h-[85px] w-full cursor-pointer flex-row items-center" };
const _hoisted_2$14 = ["src"];
const _hoisted_3$Y = { class: "ml-3 flex flex-col" };
const _hoisted_4$S = ["innerHTML"];
const _hoisted_5$I = {
  key: 0,
  class: "h-3 w-3 rounded-full bg-blue-600"
};
const _sfc_main$1D = /* @__PURE__ */ defineComponent({
  __name: "NotificationItem",
  props: {
    notification: {
      type: [Object],
      required: true
    }
  },
  emits: ["onItemClicked"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const notificationBodyRef = ref(null);
    function handleClick() {
      var _a;
      if (!(((_a = props.notification) == null ? void 0 : _a.type) === NotificationTypeIds.CERTIFICATE_ISSUED && !isPwa())) {
        setAppLoading(true);
      }
      emit("onItemClicked", props.notification);
    }
    onMounted(() => {
      var _a;
      const notificationBodySpan = (_a = notificationBodyRef.value) == null ? void 0 : _a.querySelectorAll("span");
      if (!notificationBodySpan) return;
      for (let i = 0; i < notificationBodySpan.length; i++) {
        const span = notificationBodySpan[i];
        const spanType = span.getAttribute("data-type");
        if (spanType === "contact" || spanType === "community-group" || spanType === "course" || spanType === "community-channel" || spanType === "event" || spanType === "role") {
          span.classList.add("text-clientportal-font-primary");
          span.classList.add("font-bold");
        }
      }
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        createVNode(unref(UIDivider), { class: "my-2 bg-clientportal-border" }),
        createElementVNode("div", {
          class: "notification-item-layout grid w-full items-center rounded-lg pr-2 hover:bg-clientportal-fill",
          tabindex: "0",
          role: "button",
          "aria-label": "Notification Item",
          onClick: _cache[0] || (_cache[0] = withModifiers(($event) => handleClick(), ["stop"])),
          onKeyup: _cache[1] || (_cache[1] = withKeys(($event) => handleClick(), ["enter"]))
        }, [
          createElementVNode("div", _hoisted_1$1s, [
            createVNode(unref(UIBadge), {
              id: "avatar-badge",
              offset: [-7, 40],
              class: "custom-badge-sup",
              color: "bg-transparent",
              show: true
            }, {
              content: withCtx(() => [
                __props.notification.avatarData.avatarUrl ? (openBlock(), createBlock(unref(UIAvatar), {
                  key: 0,
                  size: 48,
                  src: __props.notification.avatarData.avatarUrl
                }, null, 8, ["src"])) : (openBlock(), createBlock(unref(UIAvatar), {
                  key: 1,
                  size: 48,
                  style: {
                    "border-style": "solid",
                    "border-width": "0.5px",
                    "border-color": "rgb(156 163 175)"
                    // gray-400
                  },
                  class: "flex items-center justify-center bg-clientportal-fill text-base font-medium text-clientportal-font-secondary"
                }, {
                  default: withCtx(() => [
                    createVNode(unref(UITextSmMedium), { class: "text-lg" }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(unref(getShortName)(__props.notification.avatarData.name || "Deleted User")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              ]),
              value: withCtx(() => [
                __props.notification.avatarData.badgeUrl ? (openBlock(), createElementBlock("img", {
                  key: 0,
                  src: __props.notification.avatarData.badgeUrl,
                  class: "h-5 w-5",
                  alt: "Badge"
                }, null, 8, _hoisted_2$14)) : createCommentVNode("", true)
              ]),
              _: 1
            }),
            createElementVNode("div", _hoisted_3$Y, [
              createElementVNode("div", {
                ref_key: "notificationBodyRef",
                ref: notificationBodyRef
              }, [
                createVNode(unref(UITextSmMedium), { class: "notification-content mr-5 line-clamp-2 !font-normal text-clientportal-font-primary" }, {
                  default: withCtx(() => [
                    createElementVNode("div", {
                      innerHTML: __props.notification.body
                    }, null, 8, _hoisted_4$S)
                  ]),
                  _: 1
                })
              ], 512),
              createVNode(unref(UITextXsMedium), { class: "font-semibold text-clientportal-font-primary" }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(__props.notification.relativeTime), 1)
                ]),
                _: 1
              })
            ])
          ]),
          !__props.notification.isRead ? (openBlock(), createElementBlock("div", _hoisted_5$I)) : createCommentVNode("", true)
        ], 32)
      ], 64);
    };
  }
});
const NotificationItem = /* @__PURE__ */ _export_sfc(_sfc_main$1D, [["__scopeId", "data-v-adaa036e"]]);
const _hoisted_1$1r = {
  key: 0,
  id: "id_notificationList",
  class: "pb-2"
};
const _hoisted_2$13 = { key: 1 };
const _hoisted_3$X = { class: "justify-top flex h-full flex-col items-center p-10" };
const _hoisted_4$R = { class: "rounded-[28px] bg-clientportal-fill p-2" };
const _hoisted_5$H = { class: "rounded-[28px] bg-clientportal-background px-2 pb-[1px] pt-2" };
const _hoisted_6$B = { key: 2 };
const _hoisted_7$w = { class: "flex flex-col items-center justify-center" };
const _sfc_main$1C = /* @__PURE__ */ defineComponent({
  __name: "NotificationList",
  props: {
    markAllRead: Boolean,
    loadMoreNotifications: {
      type: Boolean,
      default: false
    },
    notificationVisibility: {
      type: String,
      default: "all"
    }
  },
  emits: ["item-clicked"],
  setup(__props, { emit: __emit }) {
    const routerInstance = AppState.getRouterInstance();
    const emit = __emit;
    const props = __props;
    const t2 = inject("t");
    const isNotificationLoading = computed(() => {
      return NotificationState.state.isLoading;
    });
    onMounted(async () => {
      var _a, _b;
      await ((_a = NotificationState) == null ? void 0 : _a.getNotifications());
      await ((_b = NotificationState) == null ? void 0 : _b.getUnreadNotificationsCount());
    });
    watch(
      () => props.markAllRead,
      async (newValue) => {
        if (newValue) {
          if (NotificationState.state.unReadNotificationCount > 0) {
            await NotificationState.markNotificationAsRead();
            await setBadgeCount(0);
          }
        }
      }
    );
    watch(
      () => props.loadMoreNotifications,
      async (newValue) => {
        if (newValue) {
          await loadNewNotifications();
        }
      }
    );
    async function loadNewNotifications() {
      var _a, _b;
      try {
        await ((_b = NotificationState) == null ? void 0 : _b.getNotifications(
          props.notificationVisibility === "unread" ? false : void 0,
          {
            previousId: (_a = notifications2.value.at(-1)) == null ? void 0 : _a._id,
            limit: 10,
            pageSort: "descending"
          }
        ));
      } catch (error) {
        console.error(error);
      }
    }
    const notifications2 = computed(() => {
      return NotificationState.state.notifications;
    });
    watch(
      () => props.notificationVisibility,
      async (newValue) => {
        var _a, _b;
        if (newValue === "unread") {
          NotificationState.clearNotifications();
          await ((_a = NotificationState) == null ? void 0 : _a.getNotifications(false));
        } else {
          NotificationState.clearNotifications();
          await ((_b = NotificationState) == null ? void 0 : _b.getNotifications());
        }
      }
    );
    async function handleItemClick(notification) {
      var _a;
      try {
        await NotificationState.getUnreadNotificationsCount(99);
        await setBadgeCount(NotificationState.state.unReadNotificationCount - 1);
        emit("item-clicked", notification);
        await NotificationState.markNotificationAsRead(notification._id);
        NotificationState.clearNotifications();
        await redirectToUrl(notification);
        await ((_a = NotificationState) == null ? void 0 : _a.getNotifications());
      } catch (e) {
        console.error("Caught in handleItemClick", e);
      }
    }
    async function redirectToUrl(notification) {
      try {
        if (notification.sourceApp === SourceApp.COURSES) {
          let url = notification.redirectionUrl;
          url += `?source=communities`;
          if (notification.type === "COURSE_POST_COMMENT") {
            url += `&commentId=${notification.metaData.commentId}`;
          }
          window.open("/" + url, "_self");
        } else if (notification.type === NotificationTypeIds.CERTIFICATE_ISSUED) {
          if (isPwa() && routerInstance) {
            routerInstance.push({
              name: "ProfileContainer",
              query: { activeScreen: "Certificates" }
            });
            setAppLoading(false);
          } else {
            externalPathRedirect("account", "activeTab=Certificates", true);
          }
        } else {
          externalPathRedirect(notification.redirectionUrl);
        }
      } catch (error) {
        console.error("Error redirecting to URL:", error);
      }
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        notifications2.value.length > 0 ? (openBlock(), createElementBlock("div", _hoisted_1$1r, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(notifications2.value, (notification) => {
            return openBlock(), createBlock(NotificationItem, {
              key: notification._id,
              notification,
              onOnItemClicked: handleItemClick
            }, null, 8, ["notification"]);
          }), 128))
        ])) : !isNotificationLoading.value ? (openBlock(), createElementBlock("div", _hoisted_2$13, [
          createElementVNode("div", _hoisted_3$X, [
            createElementVNode("div", _hoisted_4$R, [
              createElementVNode("div", _hoisted_5$H, [
                createVNode(unref(render$m), { class: "h-6 w-6 text-clientportal-primary" })
              ])
            ]),
            createVNode(unref(UITextLgMedium), { class: "mt-3.5 text-center text-clientportal-font-primary" }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(unref(t2)("notifications.noNotifications")), 1)
              ]),
              _: 1
            }),
            createVNode(unref(UITextSmRegular), { class: "mt-1 text-center text-clientportal-font-primary" }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(unref(t2)("notifications.whenYouGetNotifications")), 1)
              ]),
              _: 1
            })
          ])
        ])) : createCommentVNode("", true),
        isNotificationLoading.value ? (openBlock(), createElementBlock("div", _hoisted_6$B, [
          createElementVNode("div", _hoisted_7$w, [
            (openBlock(), createElementBlock(Fragment, null, renderList(2, (i) => {
              return createElementVNode("div", {
                key: i,
                class: "w-full"
              }, [
                createElementVNode("div", {
                  class: normalizeClass(["mx-2 my-4 flex flex-row items-center", unref(AppState).state.isMobile ? "w-[87.5vw]" : "w-[405px]"])
                }, [
                  createVNode(unref(UISkeleton), {
                    height: "48px",
                    circle: ""
                  }),
                  createElementVNode("div", {
                    class: normalizeClass(["ml-3 flex grow flex-col", unref(AppState).state.isMobile ? "mr-2" : "mr-10"])
                  }, [
                    createVNode(unref(UISkeleton), { height: "68px" }),
                    createVNode(unref(UISkeleton), {
                      class: "mt-1",
                      text: true,
                      style: { "width": "20%" }
                    })
                  ], 2)
                ], 2)
              ]);
            }), 64))
          ])
        ])) : createCommentVNode("", true)
      ], 64);
    };
  }
});
const NotificationList = /* @__PURE__ */ _export_sfc(_sfc_main$1C, [["__scopeId", "data-v-2535aa39"]]);
const _hoisted_1$1q = { class: "switcher" };
const _hoisted_2$12 = { class: "mt-8 flex w-full items-center justify-center bg-gray-50" };
const _hoisted_3$W = {
  id: "notifications-navbar",
  class: "fixed left-0 right-0 top-0 z-50 w-full bg-white"
};
const _hoisted_4$Q = { class: "inline-flex h-7 w-full items-center justify-start bg-white" };
const _hoisted_5$G = { class: "flex items-start justify-center gap-[13px] bg-white" };
const _hoisted_6$A = { class: "flex items-start justify-start gap-1" };
const _hoisted_7$v = { class: "flex grow items-center justify-end" };
const _hoisted_8$m = { class: "flex w-6 items-start justify-start gap-4" };
const _hoisted_9$i = {
  class: "relative h-6 w-6 cursor-pointer",
  onClick: () => {
  }
};
const _hoisted_10$h = { class: "inline-flex h-7 items-start justify-start gap-2" };
const _hoisted_11$h = {
  key: 2,
  class: "mt-0 flex w-[260px] flex-col justify-center overflow-hidden pb-72 font-sans"
};
const _hoisted_12$c = { class: "flex flex-col" };
const __default__$e = {
  name: "NotificationMobileView"
};
const _sfc_main$1B = /* @__PURE__ */ defineComponent({
  ...__default__$e,
  props: {
    show: {
      type: Boolean
    }
  },
  emits: ["update:show"],
  setup(__props, { emit: __emit }) {
    const showLoginModal = ref(false);
    const showNotificationOptions = ref(false);
    const markAllRead = ref(false);
    const notificationVisibility = ref("all");
    const loadMoreNotifications = ref(false);
    const notificationMobileListRef = ref(null);
    const isNotificationHome = ref(false);
    const showModalNotification = ref(false);
    const loadMoreTriggerRef = ref(null);
    const enablePTR = ref(true);
    const wasAtBottom = ref(false);
    let loadMoreObserver = null;
    const props = __props;
    const t2 = inject("t");
    const emit = __emit;
    onMounted(async () => {
      var _a, _b, _c, _d;
      showModalNotification.value = props.show;
      notificationPageHeight();
      if (!((_a = UserState.state) == null ? void 0 : _a.fullName)) showLoginModal.value = true;
      (_b = notificationMobileListRef.value) == null ? void 0 : _b.addEventListener("scroll", handleScroll);
      await ((_c = NotificationState) == null ? void 0 : _c.getNotifications());
      await ((_d = NotificationState) == null ? void 0 : _d.getUnreadNotificationsCount());
    });
    onUnmounted(() => {
      var _a;
      cleanupObserver();
      (_a = notificationMobileListRef.value) == null ? void 0 : _a.removeEventListener("scroll", handleScroll);
    });
    watch(
      () => props.show,
      (showModalVal) => showModalNotification.value = showModalVal
    );
    watch(
      () => loadMoreTriggerRef.value,
      (newValue) => {
        if (newValue && !loadMoreObserver) {
          setupLoadMoreObserver();
        }
      },
      { immediate: true }
    );
    const handleClose = () => {
      showModalNotification.value = false;
      emit("update:show", false);
    };
    const routerInstance = AppState.getRouterInstance();
    watchEffect(() => {
      if (!AppState.state.isMobile) {
        routerInstance.push({ path: "/home" });
      }
    });
    const notificationPageHeight = () => {
      if (window.location.pathname === "/notifications") {
        isNotificationHome.value = true;
      } else {
        isNotificationHome.value = false;
      }
    };
    const setupLoadMoreObserver = () => {
      if (!loadMoreTriggerRef.value) return;
      loadMoreObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !NotificationState.state.isLoading) {
              loadMoreNotifications.value = true;
            } else {
              loadMoreNotifications.value = false;
            }
          });
        },
        {
          root: notificationMobileListRef.value,
          rootMargin: "20px",
          threshold: 0.1
        }
      );
      loadMoreObserver.observe(loadMoreTriggerRef.value);
    };
    const cleanupObserver = () => {
      if (loadMoreObserver) {
        loadMoreObserver.disconnect();
        loadMoreObserver = null;
      }
    };
    const menuList = ref([
      {
        label: t2.value("notifications.markAllRead"),
        key: "markAllRead",
        class: "rounded-2xl",
        icon() {
          return h(renderIcon$1(render$n), null, {});
        }
      }
    ]);
    const NotificationOptions = computed(() => {
      const tempMenuList = [];
      menuList.value.forEach((value, index2) => {
        tempMenuList.push(value);
        if (index2 < menuList.value.length - 1)
          tempMenuList.push({
            key: "divider-1",
            type: "divider",
            props: {}
          });
      });
      return tempMenuList;
    });
    async function handleScroll(event) {
      const scrollTop = event.target.scrollTop;
      const scrollHeight = event.target.scrollHeight;
      const clientHeight = event.target.clientHeight;
      const isAtBottom = scrollTop + clientHeight >= scrollHeight - 5;
      if (isAtBottom) {
        console.log(
          ">>>> NotificationMobile :: user reached bottom, setting wasAtBottom flag"
        );
        wasAtBottom.value = true;
      }
      const isAtTop = scrollTop === 0;
      const shouldEnablePTR = isAtTop && !wasAtBottom.value;
      console.log(">>>> NotificationMobile :: PTR control logic", {
        scrollTop,
        isAtTop,
        isAtBottom,
        wasAtBottom: wasAtBottom.value,
        shouldEnablePTR,
        currentPTRState: enablePTR.value
      });
      if (enablePTR.value !== shouldEnablePTR) {
        console.log(
          `>>>> NotificationMobile :: PTR control changing from ${enablePTR.value} to ${shouldEnablePTR}`
        );
        enablePTR.value = shouldEnablePTR;
      }
      if (scrollTop > 20) {
        if (wasAtBottom.value) {
          console.log(
            ">>>> NotificationMobile :: user moved away from top, resetting wasAtBottom flag"
          );
        }
        wasAtBottom.value = false;
      }
      event.stopPropagation();
    }
    function handleAction(val) {
      switch (val) {
        case "markAllRead":
          markAllRead.value = true;
          break;
      }
      showNotificationOptions.value = false;
    }
    return (_ctx, _cache) => {
      const _directive_swipe = resolveDirective("swipe");
      return openBlock(), createElementBlock(Fragment, null, [
        createElementVNode("div", _hoisted_1$1q, [
          createVNode(unref(UIDrawer), {
            show: showModalNotification.value,
            "onUpdate:show": [
              _cache[3] || (_cache[3] = ($event) => showModalNotification.value = $event),
              handleClose
            ],
            id: "image-drawer",
            width: "100%",
            height: "100%",
            placement: "right"
          }, {
            default: withCtx(() => [
              withDirectives((openBlock(), createBlock(unref(UIDrawerContent), {
                id: "image-drawer-menu",
                closable: false
              }, {
                default: withCtx(() => [
                  createElementVNode("div", _hoisted_2$12, [
                    createElementVNode("div", _hoisted_3$W, [
                      createVNode(unref(UICard), { class: "h-full w-full !rounded-none bg-white" }, {
                        default: withCtx(() => [
                          createElementVNode("div", _hoisted_4$Q, [
                            createElementVNode("div", _hoisted_5$G, [
                              createElementVNode("div", _hoisted_6$A, [
                                createVNode(unref(UIButton), {
                                  onClick: handleClose,
                                  text: true,
                                  id: "notifications-navbar-button",
                                  class: "inline-flex flex-col items-start justify-start"
                                }, {
                                  default: withCtx(() => [
                                    createVNode(unref(render$6), { class: "h-5 w-5 text-clientportal-font-secondary" }),
                                    createVNode(unref(UITextLgMedium), { class: "text-slate-700 ml-2" }, {
                                      default: withCtx(() => [
                                        createTextVNode(toDisplayString(unref(t2)("notifications.title")), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            createElementVNode("div", _hoisted_7$v, [
                              createElementVNode("div", _hoisted_8$m, [
                                createElementVNode("div", _hoisted_9$i, [
                                  createVNode(unref(render$o), {
                                    onClick: _cache[0] || (_cache[0] = ($event) => showNotificationOptions.value = !showNotificationOptions.value)
                                  })
                                ])
                              ])
                            ])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    createElementVNode("div", {
                      class: "flex w-full overflow-y-scroll",
                      ref_key: "notificationMobileListRef",
                      ref: notificationMobileListRef
                    }, [
                      createVNode(_sfc_main$1N, {
                        "enable-pull-to-refresh": enablePTR.value,
                        class: normalizeClass([
                          "w-full grid rounded bg-white px-4 pb-8 pt-8 shadow-lg ring-1 ring-gray-900/5 overflow-y-auto",
                          isNotificationHome.value ? "notification-home" : "notification-area"
                        ])
                      }, {
                        "scroll-slot": withCtx(() => {
                          var _a, _b;
                          return [
                            createElementVNode("div", _hoisted_10$h, [
                              createElementVNode("div", {
                                class: normalizeClass([
                                  "flex cursor-pointer items-center justify-start rounded-2xl px-3 py-1",
                                  notificationVisibility.value === "all" ? "bg-blue-50" : "bg-gray-100"
                                ]),
                                onClick: _cache[1] || (_cache[1] = ($event) => notificationVisibility.value = "all")
                              }, [
                                createElementVNode("div", {
                                  class: normalizeClass([
                                    "text-center text-sm font-medium leading-tight",
                                    notificationVisibility.value === "all" ? "text-blue-700" : "text-zinc-700"
                                  ])
                                }, toDisplayString(unref(t2)("notifications.all")), 3)
                              ], 2),
                              createElementVNode("div", {
                                class: normalizeClass([
                                  "flex cursor-pointer items-center justify-start rounded-2xl px-3 py-1",
                                  notificationVisibility.value === "unread" ? "bg-blue-50" : "bg-gray-100"
                                ]),
                                onClick: _cache[2] || (_cache[2] = ($event) => notificationVisibility.value = "unread")
                              }, [
                                createElementVNode("div", {
                                  class: normalizeClass([
                                    "text-center text-sm font-normal leading-tight tracking-tight",
                                    notificationVisibility.value === "unread" ? "text-blue-700" : "text-zinc-700"
                                  ])
                                }, toDisplayString(unref(t2)("notifications.unread")), 3)
                              ], 2)
                            ]),
                            ((_a = unref(UserState).state) == null ? void 0 : _a.fullName) ? (openBlock(), createBlock(NotificationList, {
                              key: 0,
                              "mark-all-read": markAllRead.value,
                              notificationVisibility: notificationVisibility.value,
                              loadMoreNotifications: loadMoreNotifications.value
                            }, null, 8, ["mark-all-read", "notificationVisibility", "loadMoreNotifications"])) : createCommentVNode("", true),
                            ((_b = unref(UserState).state) == null ? void 0 : _b.fullName) ? (openBlock(), createElementBlock("div", {
                              key: 1,
                              ref_key: "loadMoreTriggerRef",
                              ref: loadMoreTriggerRef,
                              class: "h-4 w-full"
                            }, null, 512)) : (openBlock(), createElementBlock("div", _hoisted_11$h, [
                              createVNode(unref(UIEmpty), {
                                class: "h-full w-full overflow-hidden",
                                id: "empty-notifications-message",
                                title: "Login to check notifications",
                                description: "No notifications!"
                              })
                            ]))
                          ];
                        }),
                        _: 1
                      }, 8, ["enable-pull-to-refresh", "class"])
                    ], 512)
                  ])
                ]),
                _: 1
              })), [
                [_directive_swipe, {
                  direction: "right",
                  callback: () => handleClose()
                }]
              ])
            ]),
            _: 1
          }, 8, ["show"])
        ]),
        createVNode(unref(UIDrawer), {
          class: "rounded-t-xl p-0",
          show: showNotificationOptions.value,
          "onUpdate:show": _cache[4] || (_cache[4] = ($event) => showNotificationOptions.value = $event),
          placement: "bottom",
          height: menuList.value.length * 109 - (menuList.value.length - 1) * 10,
          id: "notification-options-drawer"
        }, {
          default: withCtx(() => [
            withDirectives((openBlock(), createBlock(unref(UIDrawerContent), {
              id: "notification-options-drawer-menu",
              class: "p-0",
              closable: false
            }, {
              default: withCtx(() => [
                createElementVNode("div", _hoisted_12$c, [
                  _cache[5] || (_cache[5] = createElementVNode("div", { class: "mt-2 h-1 w-16 rounded-md border border-solid bg-gray-200 border-gray-200 self-center" }, null, -1)),
                  createVNode(unref(UIMenu), {
                    id: "notification-options-menu-mobile",
                    class: "pb-9",
                    options: NotificationOptions.value,
                    "on-update:value": handleAction
                  }, null, 8, ["options"])
                ])
              ]),
              _: 1
            })), [
              [_directive_swipe, {
                direction: "down",
                callback: () => showNotificationOptions.value = !showNotificationOptions.value
              }]
            ])
          ]),
          _: 1
        }, 8, ["show", "height"])
      ], 64);
    };
  }
});
const NotificationMobileView = /* @__PURE__ */ _export_sfc(_sfc_main$1B, [["__scopeId", "data-v-c0961175"]]);
const _hoisted_1$1p = { class: "py-1 pr-[8px] pl-[16px] flex items-center gap-4 border-b border-solid border-x-0 border-t-0 border-gray-200 bg-white w-full box-border justify-between" };
const _hoisted_2$11 = {
  key: 0,
  class: "flex items-center"
};
const _hoisted_3$V = { key: 0 };
const _hoisted_4$P = {
  key: 1,
  class: "flex items-center w-full h-[28px]"
};
const _hoisted_5$F = { class: "flex h-full w-full items-center px-2 border border-solid border-clientportal-border rounded-[18px] bg-clientportal-fill" };
const _hoisted_6$z = { class: "flex items-center" };
const _hoisted_7$u = {
  key: 0,
  class: "h-10 w-10 flex items-center"
};
const _hoisted_8$l = {
  key: 1,
  class: "h-10 w-10 flex items-center"
};
const _hoisted_9$h = { key: 2 };
const __default__$d = {
  name: "TopNavBar"
};
const _sfc_main$1A = /* @__PURE__ */ defineComponent({
  ...__default__$d,
  props: {
    App: {
      type: String,
      default: "common.home"
    },
    isNotificationVisible: {
      type: Boolean,
      default: true
    },
    isSwitcherVisible: {
      type: Boolean,
      default: true
    },
    isSearchVisible: {
      type: Boolean,
      default: false,
      required: false
    },
    searchText: {
      type: String,
      default: ""
    },
    isSearchInputVisible: {
      type: Boolean,
      default: false
    },
    topPosition: {
      type: String,
      default: "0px"
    }
  },
  emits: [
    "update:onSearchBack",
    "update:searchSubmit",
    "update:onSearchIconClicked",
    "update:onSearchClear"
  ],
  setup(__props, { emit: __emit }) {
    const mobileAppSwitcherItems = inject("mobileAppSwitcherItems");
    const showModal = ref(false);
    const showBadge = ref(false);
    const showModalNotification = ref(false);
    const slots = useSlots();
    const emit = __emit;
    const handleChangeApp = () => {
      showModal.value = true;
    };
    const t2 = ref(null);
    onBeforeMount(() => {
      t2.value = setupVueI18n(getLocalePreference());
    });
    provide("t", t2);
    if (mobileAppSwitcherItems) {
      provide("mobileAppSwitcherItems", mobileAppSwitcherItems);
    }
    const handleNotification = () => {
      showModalNotification.value = true;
    };
    const getNotifications = async () => {
      var _a, _b, _c;
      await ((_a = NotificationState) == null ? void 0 : _a.getNotifications());
      await NotificationState.getUnreadNotificationsCount();
      if (((_c = (_b = NotificationState) == null ? void 0 : _b.state) == null ? void 0 : _c.unReadNotificationCount) > 0) {
        showBadge.value = true;
      }
    };
    watch(
      () => {
        var _a, _b;
        return (_b = (_a = NotificationState) == null ? void 0 : _a.state) == null ? void 0 : _b.unReadNotificationCount;
      },
      () => {
        var _a, _b;
        if (((_b = (_a = NotificationState) == null ? void 0 : _a.state) == null ? void 0 : _b.unReadNotificationCount) > 0) {
          showBadge.value = true;
        } else {
          showBadge.value = false;
        }
      }
    );
    const props = __props;
    watch(
      () => props.isNotificationVisible,
      async () => {
        if (props.isNotificationVisible === true) {
          await getNotifications();
        }
      },
      { immediate: true }
    );
    watch(
      () => {
        var _a, _b;
        return (_b = (_a = NotificationState) == null ? void 0 : _a.state) == null ? void 0 : _b.unReadNotificationCount;
      },
      () => {
        var _a, _b;
        if (((_b = (_a = NotificationState) == null ? void 0 : _a.state) == null ? void 0 : _b.unReadNotificationCount) > 0) {
          showBadge.value = true;
        } else {
          showBadge.value = false;
        }
      }
    );
    const isSearchVisible = computed(() => props.isSearchVisible);
    const searchText = ref(props.searchText);
    const searchInputRef = ref(null);
    const isSearchInputVisible = computed(() => props.isSearchInputVisible);
    function handleSearchIconClicked() {
      emit("update:onSearchIconClicked");
    }
    function handleSearchSubmitHelper(event) {
      var _a;
      event.preventDefault();
      emit("update:searchSubmit", searchText.value);
      (_a = searchInputRef.value) == null ? void 0 : _a.blur();
    }
    function handleSearchClearHelper() {
      searchText.value = "";
      emit("update:onSearchClear");
    }
    function handleSearchBack() {
      handleSearchClearHelper();
      emit("update:onSearchBack");
    }
    watch(
      () => props.searchText,
      (newValue) => {
        searchText.value = newValue;
      },
      { immediate: true }
    );
    return (_ctx, _cache) => {
      var _a, _b;
      return openBlock(), createElementBlock("div", {
        class: "col-span-3 flex flex-col items-center justify-start left-0 right-0 fixed z-50",
        style: normalizeStyle(`top: ${__props.topPosition}`)
      }, [
        createElementVNode("div", _hoisted_1$1p, [
          !isSearchInputVisible.value ? (openBlock(), createElementBlock("div", _hoisted_2$11, [
            ((_a = unref(slots)) == null ? void 0 : _a["filter-left"]) ? (openBlock(), createElementBlock("div", _hoisted_3$V, [
              renderSlot(_ctx.$slots, "filter-left", {}, void 0, true)
            ])) : createCommentVNode("", true),
            __props.isSwitcherVisible && !isSearchInputVisible.value ? (openBlock(), createBlock(unref(UIButton), {
              key: 1,
              id: "id-mobile-switch",
              type: "default",
              class: "!rounded-lg !text-clientportal-background !h-7 !pl-3 !pr-2",
              size: "medium",
              onClick: handleChangeApp
            }, {
              default: withCtx(() => [
                createVNode(unref(UITextXsRegular), null, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(t2.value(__props.App)), 1)
                  ]),
                  _: 1
                }),
                createVNode(unref(render$d), { class: "w-4 h-4 mt-[1px] ml-[2px]" })
              ]),
              _: 1
            })) : createCommentVNode("", true)
          ])) : createCommentVNode("", true),
          isSearchInputVisible.value ? (openBlock(), createElementBlock("div", _hoisted_4$P, [
            createElementVNode("div", {
              class: "relative h-6 w-6 cursor-pointer mr-1",
              onClick: handleSearchBack
            }, [
              createVNode(unref(render$p))
            ]),
            createElementVNode("div", _hoisted_5$F, [
              createVNode(unref(render$q), { class: "h-5 w-5" }),
              createElementVNode("form", {
                onSubmit: handleSearchSubmitHelper,
                class: "ml-1 w-[calc(100%-40px)]"
              }, [
                withDirectives(createElementVNode("input", {
                  ref_key: "searchInputRef",
                  ref: searchInputRef,
                  type: "text",
                  placeholder: "Search",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => searchText.value = $event),
                  class: "h-[18px] w-full border-none bg-clientportal-fill text-base text-clientportal-font-primary outline-none placeholder:text-left placeholder:text-base placeholder:text-clientportal-font-secondary"
                }, null, 512), [
                  [vModelText, searchText.value]
                ])
              ], 32),
              searchText.value ? (openBlock(), createBlock(unref(render$r), {
                key: 0,
                class: "h-5 w-5 cursor-pointer",
                onClick: handleSearchClearHelper
              })) : createCommentVNode("", true)
            ])
          ])) : createCommentVNode("", true),
          createElementVNode("div", _hoisted_6$z, [
            isSearchVisible.value ? (openBlock(), createElementBlock("div", _hoisted_7$u, [
              createVNode(unref(UIButton), {
                id: "btn-search",
                type: "default",
                class: "-mr-[6px]",
                quaternary: true,
                circle: true,
                onClick: handleSearchIconClicked
              }, {
                default: withCtx(() => [
                  createVNode(unref(render$f), { class: "w-5 h-5 text-clientportal-font-secondary" })
                ]),
                _: 1
              })
            ])) : createCommentVNode("", true),
            __props.isNotificationVisible ? (openBlock(), createElementBlock("div", _hoisted_8$l, [
              createVNode(unref(UIButton), {
                id: "btn-notification",
                onClick: handleNotification,
                type: "default",
                class: "-mr-[6px]",
                quaternary: true,
                circle: true
              }, {
                default: withCtx(() => [
                  createVNode(unref(UIBadge), {
                    dot: true,
                    show: showBadge.value,
                    type: "default",
                    id: "badge-notification"
                  }, {
                    content: withCtx(() => [
                      createVNode(unref(render$s), { class: "w-5 h-5 text-clientportal-font-secondary" })
                    ]),
                    _: 1
                  }, 8, ["show"])
                ]),
                _: 1
              })
            ])) : createCommentVNode("", true),
            ((_b = unref(slots)) == null ? void 0 : _b["filter-right"]) ? (openBlock(), createElementBlock("div", _hoisted_9$h, [
              renderSlot(_ctx.$slots, "filter-right", {}, void 0, true)
            ])) : createCommentVNode("", true)
          ])
        ]),
        __props.isSwitcherVisible && !isSearchInputVisible.value ? (openBlock(), createBlock(AppSwitcher$1, {
          key: 0,
          show: showModal.value,
          "onUpdate:show": _cache[1] || (_cache[1] = ($event) => showModal.value = false)
        }, null, 8, ["show"])) : createCommentVNode("", true),
        showModalNotification.value ? (openBlock(), createBlock(NotificationMobileView, {
          key: 1,
          show: showModalNotification.value,
          "onUpdate:show": _cache[2] || (_cache[2] = ($event) => showModalNotification.value = false)
        }, null, 8, ["show"])) : createCommentVNode("", true)
      ], 4);
    };
  }
});
const TopNavBar = /* @__PURE__ */ _export_sfc(_sfc_main$1A, [["__scopeId", "data-v-2105d2be"]]);
const _hoisted_1$1o = { class: "py-1 pr-[8px] pl-[16px] flex items-center gap-4 border-b min-h-[49px] border-solid border-x-0 border-t-0 border-gray-200 bg-white w-full box-border justify-between" };
const _hoisted_2$10 = {
  key: 0,
  class: "flex items-center flex-1 min-w-0"
};
const _hoisted_3$U = { key: 0 };
const _hoisted_4$O = ["src"];
const _hoisted_5$E = {
  key: 3,
  class: "shrink-0"
};
const _hoisted_6$y = {
  key: 1,
  class: "flex items-center w-full h-[28px]"
};
const _hoisted_7$t = { class: "flex h-full w-full items-center px-2 border border-solid border-clientportal-border rounded-[18px] bg-clientportal-fill" };
const _hoisted_8$k = { class: "flex items-center" };
const _hoisted_9$g = {
  key: 0,
  class: "h-10 w-10 flex items-center"
};
const _hoisted_10$g = {
  key: 1,
  class: "h-10 w-10 flex items-center"
};
const _hoisted_11$g = { key: 2 };
const __default__$c = {
  name: "TopNavBarMobile"
};
const _sfc_main$1z = /* @__PURE__ */ defineComponent({
  ...__default__$c,
  props: {
    App: {
      type: String,
      default: "common.home"
    },
    isNotificationVisible: {
      type: Boolean,
      default: true
    },
    headerText: {
      type: String,
      default: ""
    },
    headerLogo: {
      type: String,
      default: ""
    },
    isSwitcherVisible: {
      type: Boolean,
      default: true
    },
    showSwitcherModal: {
      type: Boolean,
      default: false
    },
    isSearchVisible: {
      type: Boolean,
      default: false,
      required: false
    },
    searchText: {
      type: String,
      default: ""
    },
    isSearchInputVisible: {
      type: Boolean,
      default: false
    },
    hideBackButton: {
      type: Boolean,
      default: false
    },
    topPosition: {
      type: String,
      default: "0px"
    }
  },
  emits: [
    "update:onSearchBack",
    "update:searchSubmit",
    "update:onSearchIconClicked",
    "update:onSearchClear",
    "update:handleHeaderTextClick",
    "update:handleHeaderLogoClick"
  ],
  setup(__props, { emit: __emit }) {
    const showModal = ref(false);
    const showBadge = ref(false);
    const slots = useSlots();
    const showModalNotification = ref(false);
    const routerInstance = AppState.getRouterInstance();
    const route = computed(() => {
      if (!routerInstance) return null;
      return routerInstance.currentRoute;
    });
    const showBackButton = computed(() => {
      var _a;
      const routesWithBackButton = ["profile-container", "documents-and-payments"];
      return routesWithBackButton.includes(((_a = route.value) == null ? void 0 : _a.name) || "");
    });
    const emit = __emit;
    const t2 = ref(null);
    onBeforeMount(() => {
      t2.value = setupVueI18n(getLocalePreference());
    });
    provide("t", t2);
    const handleNotification = () => {
      showModalNotification.value = true;
    };
    onMounted(async () => {
      if (props.showSwitcherModal) {
        showModal.value = true;
      }
      await getNotifications();
    });
    const getNotifications = async () => {
      var _a, _b, _c, _d, _e;
      await ((_a = NotificationState) == null ? void 0 : _a.getNotifications());
      await NotificationState.getUnreadNotificationsCount(MAX_BADGE_COUNT_LIMIT);
      if (((_c = (_b = NotificationState) == null ? void 0 : _b.state) == null ? void 0 : _c.unReadNotificationCount) > 0) {
        showBadge.value = true;
      }
      setBadgeCount((_e = (_d = NotificationState) == null ? void 0 : _d.state) == null ? void 0 : _e.unReadNotificationCount);
    };
    watch(
      () => {
        var _a, _b;
        return (_b = (_a = NotificationState) == null ? void 0 : _a.state) == null ? void 0 : _b.unReadNotificationCount;
      },
      () => {
        var _a, _b;
        if (((_b = (_a = NotificationState) == null ? void 0 : _a.state) == null ? void 0 : _b.unReadNotificationCount) > 0) {
          showBadge.value = true;
        } else {
          showBadge.value = false;
        }
      }
    );
    const props = __props;
    const isSearchVisible = computed(() => props.isSearchVisible);
    const searchText = ref(props.searchText);
    const searchInputRef = ref(null);
    const isSearchInputVisible = computed(() => props.isSearchInputVisible);
    function handleSearchIconClicked() {
      emit("update:onSearchIconClicked");
    }
    function handleSearchSubmitHelper(event) {
      var _a;
      event.preventDefault();
      emit("update:searchSubmit", searchText.value);
      (_a = searchInputRef.value) == null ? void 0 : _a.blur();
    }
    function handleSearchClearHelper() {
      searchText.value = "";
      emit("update:onSearchClear");
    }
    function handleSearchBack() {
      handleSearchClearHelper();
      emit("update:onSearchBack");
    }
    function handleHeaderTextClick() {
      emit("update:handleHeaderTextClick");
    }
    function handleHeaderLogoClick() {
      emit("update:handleHeaderLogoClick");
    }
    watch(
      () => props.searchText,
      (newValue) => {
        searchText.value = newValue;
      },
      { immediate: true }
    );
    const displayHeaderText = computed(() => {
      switch (route.value.name) {
        case "communities-more":
        case "courses-more":
          return t2.value("common.more");
        case "profile-container":
          return t2.value("common.profile");
        case "documents-and-payments":
          return t2.value("common.documentsAndPayments");
        default:
          return props.headerText;
      }
    });
    const handleBackButton = () => {
      window.history.back();
    };
    return (_ctx, _cache) => {
      var _a, _b, _c;
      return openBlock(), createElementBlock("div", {
        class: "col-span-3 flex flex-col items-center justify-start left-0 right-0 fixed z-50 min-h-[49px]",
        style: normalizeStyle(`top: ${__props.topPosition}`)
      }, [
        createElementVNode("div", _hoisted_1$1o, [
          !isSearchInputVisible.value ? (openBlock(), createElementBlock("div", _hoisted_2$10, [
            showBackButton.value ? (openBlock(), createElementBlock("div", {
              key: 0,
              class: "relative h-5 w-5 cursor-pointer mr-2",
              tabindex: "0",
              role: "button",
              "aria-label": "Back",
              onClick: handleBackButton,
              onKeyup: withKeys(handleBackButton, ["enter"])
            }, [
              createVNode(unref(render$6), { class: "text-clientportal-font-secondary" })
            ], 32)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
              ((_a = unref(slots)) == null ? void 0 : _a["filter-left"]) ? (openBlock(), createElementBlock("div", _hoisted_3$U, [
                renderSlot(_ctx.$slots, "filter-left", {}, void 0, true)
              ])) : createCommentVNode("", true)
            ], 64)),
            __props.headerLogo && displayHeaderText.value === __props.headerText ? (openBlock(), createElementBlock("img", {
              key: 2,
              src: __props.headerLogo,
              alt: "Group Logo",
              class: "h-6 object-cover rounded-full mx-1 w-6 shrink-0",
              onClick: handleHeaderLogoClick
            }, null, 8, _hoisted_4$O)) : createCommentVNode("", true),
            createVNode(unref(UITextMdMedium), {
              class: "truncate min-w-0",
              onClick: handleHeaderTextClick
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(displayHeaderText.value), 1)
              ]),
              _: 1
            }),
            ((_b = unref(slots)) == null ? void 0 : _b["switcher"]) && displayHeaderText.value === __props.headerText ? (openBlock(), createElementBlock("div", _hoisted_5$E, [
              renderSlot(_ctx.$slots, "switcher", {}, void 0, true)
            ])) : createCommentVNode("", true)
          ])) : createCommentVNode("", true),
          isSearchInputVisible.value ? (openBlock(), createElementBlock("div", _hoisted_6$y, [
            createElementVNode("div", {
              class: "relative h-6 w-6 cursor-pointer mr-1",
              onClick: handleSearchBack
            }, [
              createVNode(unref(render$p))
            ]),
            createElementVNode("div", _hoisted_7$t, [
              createVNode(unref(render$q), { class: "h-5 w-5" }),
              createElementVNode("form", {
                onSubmit: handleSearchSubmitHelper,
                class: "ml-1 w-[calc(100%-40px)]"
              }, [
                withDirectives(createElementVNode("input", {
                  ref_key: "searchInputRef",
                  ref: searchInputRef,
                  type: "text",
                  placeholder: "Search",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => searchText.value = $event),
                  class: "h-[18px] w-full border-none bg-clientportal-fill text-base text-clientportal-font-primary outline-none placeholder:text-left placeholder:text-base placeholder:text-clientportal-font-secondary"
                }, null, 512), [
                  [vModelText, searchText.value]
                ])
              ], 32),
              searchText.value ? (openBlock(), createBlock(unref(render$r), {
                key: 0,
                class: "h-5 w-5 cursor-pointer",
                onClick: handleSearchClearHelper
              })) : createCommentVNode("", true)
            ])
          ])) : createCommentVNode("", true),
          createElementVNode("div", _hoisted_8$k, [
            isSearchVisible.value ? (openBlock(), createElementBlock("div", _hoisted_9$g, [
              createVNode(unref(UIButton), {
                id: "btn-search",
                type: "default",
                class: "-mr-[6px]",
                quaternary: true,
                circle: true,
                onClick: handleSearchIconClicked
              }, {
                default: withCtx(() => [
                  createVNode(unref(render$f), { class: "w-5 h-5 text-clientportal-font-secondary" })
                ]),
                _: 1
              })
            ])) : createCommentVNode("", true),
            __props.isNotificationVisible ? (openBlock(), createElementBlock("div", _hoisted_10$g, [
              createVNode(unref(UIButton), {
                id: "btn-notification",
                onClick: handleNotification,
                type: "default",
                class: "-mr-[6px]",
                quaternary: true,
                circle: true
              }, {
                default: withCtx(() => [
                  createVNode(unref(UIBadge), {
                    dot: true,
                    show: showBadge.value,
                    type: "default",
                    id: "badge-notification"
                  }, {
                    content: withCtx(() => [
                      createVNode(unref(render$s), { class: "w-5 h-5 text-clientportal-font-secondary" })
                    ]),
                    _: 1
                  }, 8, ["show"])
                ]),
                _: 1
              })
            ])) : createCommentVNode("", true),
            ((_c = unref(slots)) == null ? void 0 : _c["filter-right"]) ? (openBlock(), createElementBlock("div", _hoisted_11$g, [
              renderSlot(_ctx.$slots, "filter-right", {}, void 0, true)
            ])) : createCommentVNode("", true)
          ])
        ]),
        showModalNotification.value ? (openBlock(), createBlock(NotificationMobileView, {
          key: 0,
          show: showModalNotification.value,
          "onUpdate:show": _cache[1] || (_cache[1] = ($event) => showModalNotification.value = false)
        }, null, 8, ["show"])) : createCommentVNode("", true)
      ], 4);
    };
  }
});
const TopNavBarMobile = /* @__PURE__ */ _export_sfc(_sfc_main$1z, [["__scopeId", "data-v-517fb5ee"]]);
TopNavBar.install = (Vue) => {
  Vue.component(TopNavBar.name, TopNavBar);
  Vue.component(TopNavBarMobile.name, TopNavBarMobile);
};
const _sfc_main$1y = {};
const _hoisted_1$1n = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function _sfc_render$i(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$1n, _cache[0] || (_cache[0] = [
    createElementVNode("circle", {
      cx: "12",
      cy: "12",
      r: "10.5",
      fill: "#98A2B3"
    }, null, -1),
    createElementVNode("path", {
      d: "M15.9103 15.2112L16.3767 12.2476H13.4589V10.3252C13.4589 9.51428 13.8657 8.7233 15.1726 8.7233H16.5V6.20024C16.5 6.20024 15.2959 6 14.1452 6C11.7411 6 10.1712 7.4197 10.1712 9.98883V12.2476H7.5V15.2112H10.1712V22.3759C10.7075 22.458 11.2562 22.5 11.8151 22.5C12.374 22.5 12.9226 22.458 13.4589 22.3759V15.2112H15.9103Z",
      fill: "white"
    }, null, -1)
  ]));
}
const SocialGrayedFacebook = /* @__PURE__ */ _export_sfc(_sfc_main$1y, [["render", _sfc_render$i]]);
const _sfc_main$1x = {};
const _hoisted_1$1m = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function _sfc_render$h(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$1m, _cache[0] || (_cache[0] = [
    createStaticVNode('<rect x="1.5" y="1.5" width="21" height="21" rx="4.5" fill="url(#paint0_radial_8754_11394)"></rect><rect x="1.5" y="1.5" width="21" height="21" rx="4.5" fill="url(#paint1_radial_8754_11394)"></rect><rect x="1.5" y="1.5" width="21" height="21" rx="4.5" fill="#98A2B3"></rect><path d="M17.25 7.875C17.25 8.49632 16.7463 9 16.125 9C15.5037 9 15 8.49632 15 7.875C15 7.25368 15.5037 6.75 16.125 6.75C16.7463 6.75 17.25 7.25368 17.25 7.875Z" fill="white"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M12 15.75C14.0711 15.75 15.75 14.0711 15.75 12C15.75 9.92893 14.0711 8.25 12 8.25C9.92893 8.25 8.25 9.92893 8.25 12C8.25 14.0711 9.92893 15.75 12 15.75ZM12 14.25C13.2426 14.25 14.25 13.2426 14.25 12C14.25 10.7574 13.2426 9.75 12 9.75C10.7574 9.75 9.75 10.7574 9.75 12C9.75 13.2426 10.7574 14.25 12 14.25Z" fill="white"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M4.5 11.7C4.5 9.17976 4.5 7.91965 4.99047 6.95704C5.4219 6.11031 6.11031 5.4219 6.95704 4.99047C7.91965 4.5 9.17976 4.5 11.7 4.5H12.3C14.8202 4.5 16.0804 4.5 17.043 4.99047C17.8897 5.4219 18.5781 6.11031 19.0095 6.95704C19.5 7.91965 19.5 9.17976 19.5 11.7V12.3C19.5 14.8202 19.5 16.0804 19.0095 17.043C18.5781 17.8897 17.8897 18.5781 17.043 19.0095C16.0804 19.5 14.8202 19.5 12.3 19.5H11.7C9.17976 19.5 7.91965 19.5 6.95704 19.0095C6.11031 18.5781 5.4219 17.8897 4.99047 17.043C4.5 16.0804 4.5 14.8202 4.5 12.3V11.7ZM11.7 6H12.3C13.5849 6 14.4583 6.00117 15.1334 6.05633C15.7911 6.11006 16.1274 6.20745 16.362 6.32698C16.9265 6.6146 17.3854 7.07354 17.673 7.63803C17.7926 7.87263 17.8899 8.20893 17.9437 8.86656C17.9988 9.54169 18 10.4151 18 11.7V12.3C18 13.5849 17.9988 14.4583 17.9437 15.1334C17.8899 15.7911 17.7926 16.1274 17.673 16.362C17.3854 16.9265 16.9265 17.3854 16.362 17.673C16.1274 17.7926 15.7911 17.8899 15.1334 17.9437C14.4583 17.9988 13.5849 18 12.3 18H11.7C10.4151 18 9.54169 17.9988 8.86656 17.9437C8.20893 17.8899 7.87263 17.7926 7.63803 17.673C7.07354 17.3854 6.6146 16.9265 6.32698 16.362C6.20745 16.1274 6.11006 15.7911 6.05633 15.1334C6.00117 14.4583 6 13.5849 6 12.3V11.7C6 10.4151 6.00117 9.54169 6.05633 8.86656C6.11006 8.20893 6.20745 7.87263 6.32698 7.63803C6.6146 7.07354 7.07354 6.6146 7.63803 6.32698C7.87263 6.20745 8.20893 6.11006 8.86656 6.05633C9.54169 6.00117 10.4151 6 11.7 6Z" fill="white"></path><defs><radialGradient id="paint0_radial_8754_11394" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(9 17.25) rotate(-55.3758) scale(19.1397)"><stop stop-color="#B13589"></stop><stop offset="0.79309" stop-color="#C62F94"></stop><stop offset="1" stop-color="#8A3AC8"></stop></radialGradient><radialGradient id="paint1_radial_8754_11394" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(8.25 23.25) rotate(-65.1363) scale(16.9457)"><stop stop-color="#E0E8B7"></stop><stop offset="0.444662" stop-color="#FB8A2E"></stop><stop offset="0.71474" stop-color="#E2425C"></stop><stop offset="1" stop-color="#E2425C" stop-opacity="0"></stop></radialGradient></defs>', 7)
  ]));
}
const SocialGrayedInstagram = /* @__PURE__ */ _export_sfc(_sfc_main$1x, [["render", _sfc_render$h]]);
const _sfc_main$1w = {};
const _hoisted_1$1l = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function _sfc_render$g(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$1l, _cache[0] || (_cache[0] = [
    createElementVNode("rect", {
      x: "1.5",
      y: "1.5",
      width: "21",
      height: "21",
      rx: "10.5",
      fill: "#98A2B3"
    }, null, -1),
    createElementVNode("path", {
      d: "M9.46392 7.26911C9.46392 7.97002 8.85639 8.53822 8.10696 8.53822C7.35753 8.53822 6.75 7.97002 6.75 7.26911C6.75 6.5682 7.35753 6 8.10696 6C8.85639 6 9.46392 6.5682 9.46392 7.26911Z",
      fill: "white"
    }, null, -1),
    createElementVNode("path", {
      d: "M6.93557 9.47107H9.25515V16.5H6.93557V9.47107Z",
      fill: "white"
    }, null, -1),
    createElementVNode("path", {
      d: "M12.9897 9.47107H10.6701V16.5H12.9897C12.9897 16.5 12.9897 14.2872 12.9897 12.9036C12.9897 12.0732 13.2732 11.2392 14.4046 11.2392C15.6833 11.2392 15.6756 12.3259 15.6696 13.1678C15.6618 14.2683 15.6804 15.3914 15.6804 16.5H18V12.7903C17.9804 10.4215 17.3631 9.33006 15.3325 9.33006C14.1265 9.33006 13.379 9.87754 12.9897 10.3729V9.47107Z",
      fill: "white"
    }, null, -1)
  ]));
}
const SocialGrayedLinkedin = /* @__PURE__ */ _export_sfc(_sfc_main$1w, [["render", _sfc_render$g]]);
const _sfc_main$1v = {};
const _hoisted_1$1k = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none"
};
function _sfc_render$f(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$1k, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      d: "M17.1558 17.3914L10.4468 7.61053L10.4583 7.61968L16.5074 0.609375H14.4859L9.55812 6.31526L5.64486 0.609375H0.343269L6.60678 9.74108L6.60601 9.74032L0 17.3914H2.02147L7.50004 11.0432L11.8542 17.3914H17.1558ZM4.8439 2.13501L14.2571 15.8658H12.6552L3.23435 2.13501H4.8439Z",
      fill: "#98A2B3"
    }, null, -1)
  ]));
}
const SocialGrayedTwitter = /* @__PURE__ */ _export_sfc(_sfc_main$1v, [["render", _sfc_render$f]]);
const _sfc_main$1u = {};
const _hoisted_1$1j = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function _sfc_render$e(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$1j, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      d: "M1.68338 7.45583C1.77978 5.97175 2.97296 4.80867 4.45835 4.73508C6.60929 4.62852 9.6836 4.5 12 4.5C14.3164 4.5 17.3907 4.62852 19.5417 4.73508C21.027 4.80867 22.2202 5.97175 22.3166 7.45583C22.409 8.87769 22.5 10.6272 22.5 12C22.5 13.3728 22.409 15.1223 22.3166 16.5442C22.2202 18.0283 21.027 19.1913 19.5417 19.2649C17.3907 19.3715 14.3164 19.5 12 19.5C9.6836 19.5 6.60929 19.3715 4.45835 19.2649C2.97296 19.1913 1.77978 18.0283 1.68338 16.5442C1.59102 15.1223 1.5 13.3728 1.5 12C1.5 10.6272 1.59102 8.87769 1.68338 7.45583Z",
      fill: "#98A2B3"
    }, null, -1),
    createElementVNode("path", {
      d: "M9.75 9V15L15.75 12L9.75 9Z",
      fill: "white"
    }, null, -1)
  ]));
}
const SocialGrayedYoutube = /* @__PURE__ */ _export_sfc(_sfc_main$1u, [["render", _sfc_render$e]]);
const _hoisted_1$1i = { class: "flex flex-col h-screen w-full fixed bg-white overflow-y-auto" };
const _hoisted_2$$ = {
  id: "profile-navbar",
  class: "fixed left-0 right-0 top-0 z-50 w-full bg-white"
};
const _hoisted_3$T = {
  ref: "boxRef",
  class: "grid grid-cols-3 row-span-1 place-items-center px-4 mt-10"
};
const _hoisted_4$N = { class: "mt-4 col-span-3" };
const _hoisted_5$D = { class: "flex col-span-3 mt-2 gap-4 items-center justify-center text-gray-400" };
const _hoisted_6$x = ["onClick"];
const _hoisted_7$s = ["src"];
const _hoisted_8$j = { class: "col-span-3 w-full" };
const _hoisted_9$f = {
  key: 0,
  class: "col-span-3 w-full"
};
const _hoisted_10$f = { class: "mt-4 mb-20 pl-4" };
const _hoisted_11$f = { class: "flex flex-col mt-4 gap-6" };
const _hoisted_12$b = ["onClick"];
const _hoisted_13$b = { class: "flex flex-col" };
const _hoisted_14$8 = ["onClick"];
const _hoisted_15$6 = {
  key: 0,
  class: "hover inline-flex h-full w-[95%] items-center justify-start gap-2 rounded-lg"
};
const _hoisted_16$4 = { class: "inline-flex flex-col items-start justify-center gap-4" };
const _hoisted_17$2 = { class: "inline-flex items-center justify-start gap-4" };
const _hoisted_18$2 = { class: "relative h-10 w-10" };
const _hoisted_19$2 = { class: "h-10 w-10 rounded-md bg-gray-200" };
const _hoisted_20$1 = { class: "flex h-10 w-10 items-center justify-center rounded-full" };
const _hoisted_21$1 = { class: "flex h-8 w-8 cursor-pointer items-center justify-center rounded-full bg-gray-200 text-gray-600" };
const _hoisted_22$1 = { class: "inline-flex flex-col items-start justify-start" };
const _hoisted_23$1 = { class: "flex flex-col" };
const _hoisted_24$1 = { class: "px-6" };
const _sfc_main$1t = /* @__PURE__ */ defineComponent({
  __name: "MobileProfile",
  setup(__props) {
    const VersionDisplay = defineAsyncComponent(() => import("./VersionDisplay-BmgQS7mp.js"));
    const routerInstance = AppState.getRouterInstance();
    const showProfileDrawer = ref(false);
    const showVersionDrawer = ref(false);
    const tapCount = ref(0);
    const tapTimer = ref(null);
    const handleRoutes = (queryValue) => {
      const currentPath = window.location.pathname;
      if (routerInstance) {
        routerInstance.push({
          path: `${currentPath}`,
          query: { activeScreen: queryValue }
        });
      }
    };
    const t2 = inject("t");
    const profileDetailsInfo = computed(() => {
      var _a, _b, _c, _d;
      return [
        {
          icon: render$g,
          value: (_a = UserState.state) == null ? void 0 : _a.timeZone,
          slug: "timezone",
          isSocialMedia: false
        },
        {
          icon: render$t,
          value: (_b = UserState.state) == null ? void 0 : _b.location,
          slug: "location",
          isSocialMedia: false
        },
        {
          icon: render$u,
          value: (_c = UserState.state) == null ? void 0 : _c.socials.email,
          slug: "email",
          isSocialMedia: false
        },
        {
          icon: render$v,
          value: (_d = UserState.state) == null ? void 0 : _d.socials.phoneNumber,
          slug: "phone number",
          isSocialMedia: false
        }
      ];
    });
    const profileSocialsInfo = computed(() => {
      var _a, _b, _c, _d, _e;
      return [
        {
          icon: FACEBOOK_ICON,
          value: (_a = UserState.state) == null ? void 0 : _a.socials.facebook,
          slug: "facebook",
          isSocialMedia: true,
          grayIcon: h(SocialGrayedFacebook)
        },
        {
          icon: INSTAGRAM_ICON,
          value: (_b = UserState.state) == null ? void 0 : _b.socials.instagram,
          slug: "instagram",
          isSocialMedia: true,
          grayIcon: h(SocialGrayedInstagram)
        },
        {
          icon: LINKEDIN_ICON,
          value: (_c = UserState.state) == null ? void 0 : _c.socials.linkedin,
          slug: "linkedin",
          isSocialMedia: true,
          grayIcon: h(SocialGrayedLinkedin)
        },
        {
          icon: TWITTER_ICON,
          value: (_d = UserState.state) == null ? void 0 : _d.socials.twitter,
          slug: "twitter",
          isSocialMedia: true,
          grayIcon: h(SocialGrayedTwitter)
        },
        {
          icon: YOUTUBE_ICON,
          value: (_e = UserState.state) == null ? void 0 : _e.socials.youtube,
          slug: "youtube",
          isSocialMedia: true,
          grayIcon: h(SocialGrayedYoutube)
        }
      ];
    });
    const isNonProduction = computed(() => {
      return AppState.state.NODE_ENV !== "production";
    });
    const profileDrawerOptions = [
      {
        id: "logout",
        title: t2.value("common.logout"),
        component: render$w,
        showOnMobile: true,
        reaction: async () => {
          setAppLoading(true);
          await logoutUser().catch(() => {
            console.error("Error logging out");
          });
          setTimeout(() => setAppLoading(false), 4e3);
        }
      }
    ];
    function handleBack() {
      if (routerInstance) {
        routerInstance.back();
      }
    }
    function handleSocials(value) {
      if (value) {
        window.open(value, "_blank");
      }
    }
    const handleProfileTap = () => {
      tapCount.value++;
      if (tapTimer.value) {
        clearTimeout(tapTimer.value);
      }
      tapTimer.value = setTimeout(() => {
        tapCount.value = 0;
      }, 500);
      if (tapCount.value >= 5) {
        tapCount.value = 0;
        showVersionDrawer.value = true;
      }
    };
    onUnmounted(() => {
      if (tapTimer.value) {
        clearTimeout(tapTimer.value);
      }
    });
    return (_ctx, _cache) => {
      var _a, _b;
      const _directive_swipe = resolveDirective("swipe");
      return openBlock(), createElementBlock("div", _hoisted_1$1i, [
        createElementVNode("div", _hoisted_2$$, [
          createVNode(unref(TopNavBarMobile), {
            isNotificationVisible: false,
            isSwitcherVisible: false
          }, {
            "filter-left": withCtx(() => [
              createElementVNode("div", {
                onClick: handleBack,
                class: "flex items-center gap-2 text-slate-700"
              }, [
                createVNode(unref(render$6), { class: "w-6 h-6" }),
                createVNode(unref(UITextLgMedium), { class: "text-lg font-semibold leading-7 font-['Roboto']" }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(unref(t2)("sideBar.profile")), 1)
                  ]),
                  _: 1
                })
              ])
            ]),
            "filter-right": withCtx(() => [
              createElementVNode("div", {
                onClick: _cache[0] || (_cache[0] = ($event) => showProfileDrawer.value = !showProfileDrawer.value),
                class: "flex"
              }, [
                createVNode(unref(render$o), { class: "w-6 h-6 text-slate-700" })
              ])
            ]),
            _: 1
          })
        ]),
        createElementVNode("div", _hoisted_3$T, [
          createElementVNode("div", {
            class: "mt-10 col-span-3",
            onClick: handleProfileTap
          }, [
            ((_a = unref(UserState).state) == null ? void 0 : _a.avatar) ? (openBlock(), createBlock(unref(UIAvatar), {
              key: 0,
              class: "z-20 cursor-pointer text-base",
              size: 120,
              src: (_b = unref(UserState).state) == null ? void 0 : _b.avatar,
              ref: "ignoreElACRef"
            }, null, 8, ["src"])) : (openBlock(), createBlock(unref(UIAvatar), {
              key: 1,
              class: "z-20 cursor-pointer bg-gray-100 font-medium text-gray-600 text-4xl",
              size: 120,
              ref: "ignoreElACRef"
            }, {
              default: withCtx(() => {
                var _a2;
                return [
                  createTextVNode(toDisplayString(unref(formatNameForAvatar)((_a2 = unref(UserState).state) == null ? void 0 : _a2.fullName)), 1)
                ];
              }),
              _: 1
            }, 512))
          ]),
          createElementVNode("div", _hoisted_4$N, [
            createVNode(unref(UITextLgMedium), { class: "text-black" }, {
              default: withCtx(() => {
                var _a2;
                return [
                  createTextVNode(toDisplayString((_a2 = unref(UserState)) == null ? void 0 : _a2.state.fullName), 1)
                ];
              }),
              _: 1
            })
          ]),
          createElementVNode("div", _hoisted_5$D, [
            (openBlock(true), createElementBlock(Fragment, null, renderList(profileSocialsInfo.value, (socialItem) => {
              return openBlock(), createElementBlock("div", {
                key: socialItem == null ? void 0 : socialItem.slug
              }, [
                (socialItem == null ? void 0 : socialItem.isSocialMedia) ? (openBlock(), createElementBlock("div", {
                  key: 0,
                  onClick: ($event) => handleSocials(socialItem == null ? void 0 : socialItem.value)
                }, [
                  (socialItem == null ? void 0 : socialItem.value) ? (openBlock(), createElementBlock("img", {
                    key: 0,
                    class: normalizeClass(!(socialItem == null ? void 0 : socialItem.value) ? "" : "cursor-pointer"),
                    src: socialItem == null ? void 0 : socialItem.icon
                  }, null, 10, _hoisted_7$s)) : (openBlock(), createBlock(resolveDynamicComponent(socialItem == null ? void 0 : socialItem.grayIcon), {
                    key: 1,
                    class: "h-[20px] w-[20px]"
                  }))
                ], 8, _hoisted_6$x)) : createCommentVNode("", true)
              ]);
            }), 128))
          ]),
          createElementVNode("div", _hoisted_8$j, [
            createVNode(unref(UIButton), {
              id: "edit_profile_btn",
              type: "primary",
              color: "#000",
              class: "mt-6 gap-2 w-full",
              onClick: _cache[1] || (_cache[1] = ($event) => handleRoutes("SettingsMenu"))
            }, {
              default: withCtx(() => [
                createVNode(unref(render$x), { class: "!h-5 !w-5 mr-2" }),
                createTextVNode(" " + toDisplayString(unref(t2)("common.settings")), 1)
              ]),
              _: 1
            })
          ]),
          isNonProduction.value ? (openBlock(), createElementBlock("div", _hoisted_9$f, [
            createVNode(unref(UIButton), {
              id: "show_version_btn",
              type: "secondary",
              class: "mt-2 gap-2 w-full",
              onClick: _cache[2] || (_cache[2] = ($event) => showVersionDrawer.value = true)
            }, {
              default: withCtx(() => _cache[5] || (_cache[5] = [
                createTextVNode(" Show Version Info ")
              ])),
              _: 1
            })
          ])) : createCommentVNode("", true)
        ], 512),
        _cache[9] || (_cache[9] = createElementVNode("div", { class: "w-full bg-gray-100 h-2 mt-6" }, null, -1)),
        createElementVNode("div", _hoisted_10$f, [
          createVNode(unref(UITextSmMedium), { class: "text-black" }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(unref(t2)("common.details")), 1)
            ]),
            _: 1
          }),
          createElementVNode("div", _hoisted_11$f, [
            (openBlock(true), createElementBlock(Fragment, null, renderList(profileDetailsInfo.value, (profileInfo) => {
              return openBlock(), createElementBlock("div", {
                class: "flex items-center",
                key: profileInfo == null ? void 0 : profileInfo.slug,
                onClick: () => {
                  if (!(profileInfo == null ? void 0 : profileInfo.value)) {
                    handleRoutes("EditDetails");
                  }
                }
              }, [
                (openBlock(), createBlock(resolveDynamicComponent(profileInfo == null ? void 0 : profileInfo.icon), {
                  class: normalizeClass(["h-4 w-4", (profileInfo == null ? void 0 : profileInfo.value) ? "text-gray-900" : "text-gray-500"])
                }, null, 8, ["class"])),
                createVNode(unref(UITextSmMedium), {
                  class: normalizeClass([(profileInfo == null ? void 0 : profileInfo.value) ? "text-gray-900" : "text-gray-500", "ml-2 truncate"])
                }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString((profileInfo == null ? void 0 : profileInfo.value) ? unref(getShortenedURL)(profileInfo == null ? void 0 : profileInfo.value) : profileInfo.slug[0].toUpperCase() + profileInfo.slug.substring(1)), 1)
                  ]),
                  _: 2
                }, 1032, ["class"])
              ], 8, _hoisted_12$b);
            }), 128))
          ])
        ]),
        createVNode(unref(UIDrawer), {
          class: "rounded-t-xl bg-white",
          show: showProfileDrawer.value,
          "onUpdate:show": _cache[3] || (_cache[3] = ($event) => showProfileDrawer.value = $event),
          placement: "bottom",
          id: "image-drawer",
          height: profileDrawerOptions.filter((i) => i.showOnMobile).length * 96
        }, {
          default: withCtx(() => [
            withDirectives((openBlock(), createBlock(unref(UIDrawerContent), {
              id: "image-drawer-menu",
              class: "p-0",
              closable: false
            }, {
              default: withCtx(() => [
                createElementVNode("div", _hoisted_13$b, [
                  _cache[6] || (_cache[6] = createElementVNode("div", { class: "mt-2 h-1 w-16 mb-4 rounded-md border border-solid bg-gray-200 border-gray-200 self-center" }, null, -1)),
                  (openBlock(), createElementBlock(Fragment, null, renderList(profileDrawerOptions, (option) => {
                    return createElementVNode("div", {
                      key: option.id,
                      id: "image-button",
                      class: "hover:cursor-pointer",
                      onClick: option.reaction
                    }, [
                      option.showOnMobile ? (openBlock(), createElementBlock("div", _hoisted_15$6, [
                        createElementVNode("div", _hoisted_16$4, [
                          createElementVNode("div", _hoisted_17$2, [
                            createElementVNode("div", _hoisted_18$2, [
                              createElementVNode("div", _hoisted_19$2, [
                                createElementVNode("div", _hoisted_20$1, [
                                  createElementVNode("div", _hoisted_21$1, [
                                    (openBlock(), createBlock(resolveDynamicComponent(option.component), { class: "h-5 w-5" }))
                                  ])
                                ])
                              ])
                            ]),
                            createElementVNode("div", _hoisted_22$1, [
                              createVNode(unref(UITextSmMedium), { class: "leading-tight text-slate-700" }, {
                                default: withCtx(() => [
                                  createTextVNode(toDisplayString(option.title), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ])
                          ])
                        ])
                      ])) : createCommentVNode("", true)
                    ], 8, _hoisted_14$8);
                  }), 64))
                ])
              ]),
              _: 1
            })), [
              [_directive_swipe, {
                direction: "down",
                callback: () => showProfileDrawer.value = !showProfileDrawer.value
              }]
            ])
          ]),
          _: 1
        }, 8, ["show", "height"]),
        createVNode(unref(UIDrawer), {
          class: "rounded-t-xl bg-white",
          show: showVersionDrawer.value,
          "onUpdate:show": _cache[4] || (_cache[4] = ($event) => showVersionDrawer.value = $event),
          placement: "bottom",
          id: "version-drawer",
          height: 300
        }, {
          default: withCtx(() => [
            withDirectives((openBlock(), createBlock(unref(UIDrawerContent), {
              id: "version-drawer-menu",
              class: "p-0",
              closable: false
            }, {
              default: withCtx(() => [
                createElementVNode("div", _hoisted_23$1, [
                  _cache[8] || (_cache[8] = createElementVNode("div", { class: "mt-2 h-1 w-16 mb-4 rounded-md border border-solid bg-gray-200 border-gray-200 self-center" }, null, -1)),
                  createElementVNode("div", _hoisted_24$1, [
                    _cache[7] || (_cache[7] = createElementVNode("div", { class: "text-lg font-medium mb-4" }, "Versions", -1)),
                    createVNode(unref(VersionDisplay), {
                      environment: unref(AppState).state.NODE_ENV,
                      isMobile: true
                    }, null, 8, ["environment"])
                  ])
                ])
              ]),
              _: 1
            })), [
              [_directive_swipe, {
                direction: "down",
                callback: () => showVersionDrawer.value = false
              }]
            ])
          ]),
          _: 1
        }, 8, ["show"])
      ]);
    };
  }
});
const Profile = /* @__PURE__ */ _export_sfc(_sfc_main$1t, [["__scopeId", "data-v-69755d77"]]);
const NotificationPreferenceService = {
  async getNotificationPreferences(userId) {
    const response = await requests(
      AppState.getConfig().REST_API_URLS
    ).get(`clientclub/user-preferences/${userId}/general-preferences/all`);
    return response.data;
  },
  async updateNotificationPreferences(preferences) {
    const response = await requests(
      AppState.getConfig().REST_API_URLS
    ).post(`clientclub/user-preferences`, preferences);
    return response.data;
  },
  async updateGeneralAppNotificationPreferences(userId, appId, category, preferences) {
    const response = await requests(
      AppState.getConfig().REST_API_URLS
    ).put(
      `clientclub/user-preferences/${userId}/app-preferences/${appId}/categories/${category}/notifications`,
      preferences
    );
    return response.data;
  }
};
class NotificationPreferencesState {
  constructor() {
    __publicField(this, "state", reactive({
      preferences: {},
      isLoading: false
    }));
  }
  async fetchNotificationPreferences() {
    this.state.isLoading = true;
    if (Object.keys(this.state.preferences).length > 0) {
      return;
    }
    const userId = UserState.state.userId;
    try {
      const response = await NotificationPreferenceService.getNotificationPreferences(userId);
      this.state.preferences = response;
    } catch (e) {
      console.error(e);
    } finally {
      this.state.isLoading = false;
    }
  }
  async updateNotificationPreferences(preferences) {
    try {
      await NotificationPreferenceService.updateNotificationPreferences(
        preferences
      );
    } catch (e) {
      console.error(e);
    }
  }
  async updateGeneralAppNotificationPreferences(userId, appId, category, preferences) {
    await NotificationPreferenceService.updateGeneralAppNotificationPreferences(
      userId,
      appId,
      category,
      preferences
    );
  }
  async updatePreferencesState({
    key,
    type,
    enabled
  }) {
    if (!this.state.preferences) {
      this.state.preferences = {
        globalPreferences: { push: true, email: true },
        generalPreferences: {}
      };
    }
    if (key === "global") {
      if (!this.state.preferences.globalPreferences) {
        this.state.preferences.globalPreferences = { push: true, email: true };
      }
      this.state.preferences.globalPreferences[type] = enabled;
    } else {
      if (!this.state.preferences.generalPreferences) {
        this.state.preferences.generalPreferences = {};
      }
      if (!this.state.preferences.generalPreferences[key]) {
        this.state.preferences.generalPreferences[key] = {
          push: true,
          email: true
        };
      }
      this.state.preferences.generalPreferences[key][type] = enabled;
    }
  }
}
const notificationPreferencesState = new NotificationPreferencesState();
const _hoisted_1$1h = { class: "mx-3 grid grid-cols-5 items-center py-2" };
const _hoisted_2$_ = { class: "col-span-4 flex flex-col items-start" };
const _hoisted_3$S = { class: "col-span-1 flex justify-end" };
const _sfc_main$1s = /* @__PURE__ */ defineComponent({
  __name: "NotificationOption",
  props: {
    title: {},
    notificationKey: {},
    isDisabledOption: { type: Boolean },
    optionType: {},
    isLoading: { type: Boolean }
  },
  setup(__props) {
    var _a, _b, _c, _d;
    const t2 = inject("t");
    const props = __props;
    const isLoading = ref(props.isLoading || false);
    const notificationType = ref(props.optionType);
    const currentGeneralPreferences = ref(
      (_b = (_a = notificationPreferencesState == null ? void 0 : notificationPreferencesState.state) == null ? void 0 : _a.preferences) == null ? void 0 : _b.generalPreferences
    );
    const isEnabled = ref(
      ((_d = (_c = currentGeneralPreferences.value) == null ? void 0 : _c[props.notificationKey]) == null ? void 0 : _d[notificationType.value]) ?? true
    );
    watch(
      () => {
        var _a2, _b2;
        return (_b2 = (_a2 = notificationPreferencesState == null ? void 0 : notificationPreferencesState.state) == null ? void 0 : _a2.preferences) == null ? void 0 : _b2.generalPreferences;
      },
      (newVal) => {
        currentGeneralPreferences.value = newVal;
      }
    );
    const handleToggleChange = (type) => {
      if (type === NotificationOptionType.PUSH) {
        isEnabled.value = !isEnabled.value;
        saveNotificationPreferences({
          key: props.notificationKey,
          type: NotificationOptionType.PUSH,
          enabled: isEnabled.value
        });
      } else {
        isEnabled.value = !isEnabled.value;
        saveNotificationPreferences({
          key: props.notificationKey,
          type: NotificationOptionType.EMAIL,
          enabled: isEnabled.value
        });
      }
    };
    const notification = useNotification();
    function notificationAlert(title, content, type) {
      notification.create({
        title,
        content,
        duration: 3e3,
        type
      });
    }
    const saveNotificationPreferences = debounce(async (data) => {
      var _a2;
      const payload = {};
      try {
        const currentPreferences = (_a2 = notificationPreferencesState == null ? void 0 : notificationPreferencesState.state) == null ? void 0 : _a2.preferences;
        payload.contactId = (currentPreferences == null ? void 0 : currentPreferences.contactId) || UserState.state.userId;
        payload.type = (currentPreferences == null ? void 0 : currentPreferences.type) || NOTIFICATION_PREFERENCES_TYPE;
        payload.userId = (currentPreferences == null ? void 0 : currentPreferences.userId) || UserState.state.userId;
        payload.appPreferences = {
          [data.key]: { [data.type]: data.enabled }
        };
        await notificationPreferencesState.updateGeneralAppNotificationPreferences(
          payload.contactId,
          SOURCE_APPS_MAPPING[data.key],
          GENERAL_CATEGORY,
          payload
        );
        notificationPreferencesState.updatePreferencesState({
          key: data.key,
          type: data.type,
          enabled: data.enabled
        });
        trackPendoEvents({
          eventType: CP_Pendo_Events.USER_NOTIFICATION_PREFERENCES_UPDATED,
          properties: {
            string1: data.type,
            string2: data.enabled,
            string3: data.key
          }
        });
        notificationAlert(
          t2.value("common.updated"),
          t2.value("notificationPreferences.updateSuccess"),
          "success"
        );
      } catch (err) {
        console.error("Error saving app preferences", err);
        data.type === NotificationOptionType.PUSH ? isEnabled.value = !isEnabled.value : isEnabled.value = !isEnabled.value;
        notificationAlert(
          t2.value("common.error"),
          t2.value("notificationPreferences.errorUpdating"),
          "error"
        );
      }
    }, 300);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$1h, [
        createElementVNode("div", _hoisted_2$_, [
          createVNode(unref(UITextSmMedium), { class: "text-clientportal-font-primary" }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(_ctx.title), 1)
            ]),
            _: 1
          }),
          createVNode(unref(UITextXsRegular), { class: "text-clientportal-font-secondary" }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(unref(t2)(unref(notificationOptionDescriptions)[_ctx.notificationKey])), 1)
            ]),
            _: 1
          })
        ]),
        createElementVNode("div", _hoisted_3$S, [
          createVNode(unref(UISwitch), {
            id: _ctx.notificationKey.toLowerCase(),
            value: isEnabled.value,
            "checked-value": true,
            "default-value": true,
            disabled: _ctx.isDisabledOption || isLoading.value,
            loading: isLoading.value,
            "rubber-band": false,
            "unchecked-value": false,
            "onUpdate:value": _cache[0] || (_cache[0] = () => handleToggleChange(notificationType.value))
          }, null, 8, ["id", "value", "disabled", "loading"])
        ])
      ]);
    };
  }
});
const _hoisted_1$1g = { class: "flex flex-col h-screen w-full fixed bg-white z-[100] overflow-y-auto" };
const _hoisted_2$Z = {
  id: "edit-info-navbar",
  class: "fixed left-0 right-0 top-0 z-50 w-full bg-white"
};
const _hoisted_3$R = { class: "relative z-50 inline-flex w-full bg-white" };
const _hoisted_4$M = { class: "relative z-50 flex items-center justify-center gap-[13px] bg-white" };
const _hoisted_5$C = { class: "relative z-50 flex items-start justify-center gap-2.5 bg-white" };
const _hoisted_6$w = { class: "flex items-start justify-start gap-1" };
const _hoisted_7$r = { class: "inline-flex flex-col items-start justify-start" };
const _hoisted_8$i = { class: "flex items-center text-lg font-medium leading-7 text-slate-700" };
const _hoisted_9$e = { class: "flex w-full flex-col gap-4" };
const _hoisted_10$e = { class: "sticky top-0 z-10 bg-white pt-[50px]" };
const _hoisted_11$e = { class: "mx-3 grid grid-cols-5 items-center" };
const _hoisted_12$a = { class: "col-span-4 flex flex-col items-start" };
const _hoisted_13$a = { class: "col-span-1 flex justify-end" };
const _sfc_main$1r = /* @__PURE__ */ defineComponent({
  __name: "NotificationPreferences",
  props: {
    optionType: {}
  },
  setup(__props) {
    const routerInstance = AppState.getRouterInstance();
    const t2 = inject("t");
    const props = __props;
    const isLoading = ref(false);
    const isAllOptionEnabled = ref(true);
    const optionType = ref(props.optionType);
    onMounted(async () => {
      var _a;
      isLoading.value = true;
      try {
        await notificationPreferencesState.fetchNotificationPreferences();
        const preferences = notificationPreferencesState.state.preferences;
        if (preferences == null ? void 0 : preferences.globalPreferences) {
          isAllOptionEnabled.value = ((_a = preferences == null ? void 0 : preferences.globalPreferences) == null ? void 0 : _a[optionType.value]) ?? true;
        }
        isLoading.value = false;
      } catch (err) {
        console.error(`Error fetching notification preferences: ${err}`);
        isLoading.value = false;
      }
    });
    const notification = useNotification();
    function notificationAlert(title, content, type) {
      notification.create({
        title,
        content,
        duration: 3e3,
        type
      });
    }
    const saveNotificationPreferences = debounce(async (data) => {
      const payload = {};
      const { enabled } = data;
      try {
        const currentPreferences = notificationPreferencesState.state.preferences;
        isAllOptionEnabled.value = enabled;
        payload.contactId = (currentPreferences == null ? void 0 : currentPreferences.contactId) || UserState.state.userId;
        payload.type = (currentPreferences == null ? void 0 : currentPreferences.type) || NOTIFICATION_PREFERENCES_TYPE;
        payload.userId = (currentPreferences == null ? void 0 : currentPreferences.userId) || UserState.state.userId;
        payload.globalPreferences = {
          [optionType.value]: isAllOptionEnabled.value
        };
        await notificationPreferencesState.updateNotificationPreferences(payload);
        trackPendoEvents({
          eventType: CP_Pendo_Events.USER_NOTIFICATION_PREFERENCES_UPDATED,
          properties: {
            string1: optionType.value,
            string2: isAllOptionEnabled.value,
            string3: `ALL_${optionType.value.toUpperCase()}`
          }
        });
        notificationAlert(
          t2.value("common.updated"),
          t2.value("notificationPreferences.updateSuccess"),
          "success"
        );
        notificationPreferencesState.updatePreferencesState({
          key: "global",
          type: optionType.value,
          enabled: isAllOptionEnabled.value
        });
      } catch (err) {
        console.error("Error saving global preferences", err);
        isAllOptionEnabled.value = !isAllOptionEnabled.value;
        notificationAlert(
          t2.value("common.error"),
          t2.value("notificationPreferences.errorUpdating"),
          "error"
        );
      }
    }, 300);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$1g, [
        createElementVNode("div", _hoisted_2$Z, [
          createVNode(unref(UICard), { class: "relative z-50 h-full w-full !rounded-none bg-white" }, {
            default: withCtx(() => [
              createElementVNode("div", _hoisted_3$R, [
                createElementVNode("div", _hoisted_4$M, [
                  createElementVNode("div", _hoisted_5$C, [
                    createElementVNode("div", {
                      onClick: _cache[0] || (_cache[0] = () => {
                        if (unref(routerInstance)) {
                          unref(routerInstance).back();
                        }
                      }),
                      class: "relative h-6 w-6 cursor-pointer"
                    }, [
                      createVNode(unref(render$6))
                    ])
                  ]),
                  createElementVNode("div", _hoisted_6$w, [
                    createElementVNode("div", _hoisted_7$r, [
                      createElementVNode("div", _hoisted_8$i, [
                        createTextVNode(toDisplayString(optionType.value === unref(NotificationOptionType).EMAIL ? unref(t2)("notificationPreferences.emailNotifications") : unref(t2)("notificationPreferences.pushNotificationsTitle")) + " ", 1),
                        createVNode(unref(UITooltip), {
                          id: "helper-tooltip",
                          placement: "right",
                          trigger: "click",
                          class: "max-w-[35vw]"
                        }, {
                          trigger: withCtx(() => [
                            createVNode(unref(UIButton), {
                              id: "tooltip-button",
                              type: "default",
                              size: "small",
                              ghost: false,
                              quaternary: true,
                              circle: true,
                              text: false,
                              class: "ml-1 mt-[2px]"
                            }, {
                              default: withCtx(() => [
                                createVNode(unref(render$y), { class: "h-4 w-4" })
                              ]),
                              _: 1
                            })
                          ]),
                          default: withCtx(() => [
                            createVNode(unref(UITextXsRegular), { class: "break-words" }, {
                              default: withCtx(() => [
                                createTextVNode(toDisplayString(unref(t2)(
                                  "notificationPreferences.willNotReceiveNotificationsIfAdminDisabled"
                                )), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _: 1
          })
        ]),
        createVNode(_sfc_main$1N, { class: "overflow-y-auto overflow-x-hidden flex flex-col gap-8 py-6 px-4" }, {
          "scroll-slot": withCtx(() => [
            createElementVNode("div", _hoisted_9$e, [
              createElementVNode("div", _hoisted_10$e, [
                createElementVNode("div", _hoisted_11$e, [
                  createElementVNode("div", _hoisted_12$a, [
                    createVNode(unref(UITextSmMedium), { class: "text-clientportal-font-primary" }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(optionType.value === unref(NotificationOptionType).EMAIL ? unref(t2)("notificationPreferences.emailNotifications") : unref(t2)("notificationPreferences.pushNotificationsTitle")), 1)
                      ]),
                      _: 1
                    }),
                    createVNode(unref(UITextXsRegular), { class: "text-clientportal-font-secondary" }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(optionType.value === unref(NotificationOptionType).EMAIL ? unref(t2)(
                          "notificationPreferences.allEmailNotificationsDescription"
                        ) : unref(t2)(
                          "notificationPreferences.allPushNotificationsDescription"
                        )), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  createElementVNode("div", _hoisted_13$a, [
                    createVNode(unref(UISwitch), {
                      id: "notification-switch",
                      value: isAllOptionEnabled.value,
                      "checked-value": true,
                      "default-value": void 0,
                      disabled: isLoading.value,
                      loading: isLoading.value,
                      "rubber-band": false,
                      "unchecked-value": false,
                      "onUpdate:value": _cache[1] || (_cache[1] = (newValue) => {
                        isAllOptionEnabled.value = newValue;
                        unref(saveNotificationPreferences)({
                          key: "ALL_EMAIL",
                          enabled: newValue,
                          type: "email"
                        });
                      })
                    }, null, 8, ["value", "disabled", "loading"])
                  ])
                ]),
                createVNode(unref(UIDivider))
              ]),
              (openBlock(true), createElementBlock(Fragment, null, renderList(unref(getNotificationOptionsTemplate)(), (options) => {
                return openBlock(), createElementBlock(Fragment, null, [
                  (openBlock(true), createElementBlock(Fragment, null, renderList(options.filter(
                    (opt) => !(optionType.value === unref(NotificationOptionType).PUSH && unref(disabledPushOptions).includes(opt.key))
                  ), (option) => {
                    return openBlock(), createBlock(_sfc_main$1s, {
                      key: option.key + isAllOptionEnabled.value + isLoading.value,
                      "is-loading": isLoading.value,
                      title: unref(t2)(option.title),
                      "notification-key": option.key,
                      "is-disabled-option": !isAllOptionEnabled.value,
                      "option-type": optionType.value
                    }, null, 8, ["is-loading", "title", "notification-key", "is-disabled-option", "option-type"]);
                  }), 128))
                ], 64);
              }), 256))
            ])
          ]),
          _: 1
        })
      ]);
    };
  }
});
const NotificationPreferences = /* @__PURE__ */ _export_sfc(_sfc_main$1r, [["__scopeId", "data-v-e644874e"]]);
const _hoisted_1$1f = { class: "flex flex-col h-screen w-full fixed bg-white z-[100] overflow-y-auto" };
const _hoisted_2$Y = {
  id: "edit-info-navbar",
  class: "fixed left-0 right-0 top-0 z-50 w-full bg-white"
};
const _hoisted_3$Q = { class: "relative z-50 inline-flex w-full bg-white" };
const _hoisted_4$L = { class: "relative z-50 flex items-center justify-center gap-[13px] bg-white" };
const _hoisted_5$B = { class: "relative z-50 flex items-start justify-center gap-2.5 bg-white" };
const _hoisted_6$v = { class: "flex items-start justify-start gap-1" };
const _hoisted_7$q = { class: "inline-flex flex-col items-start justify-start" };
const _hoisted_8$h = { class: "w-full col-span-8" };
const _hoisted_9$d = ["onClick"];
const _hoisted_10$d = { class: "flex items-center justify-center col-span-1 w-10 h-10 bg-clientportal-liteBackground" };
const _hoisted_11$d = { class: "col-span-6" };
const _sfc_main$1q = /* @__PURE__ */ defineComponent({
  __name: "NotificationSettings",
  setup(__props) {
    const boxRef = ref(null);
    const routerInstance = AppState.getRouterInstance();
    const t2 = inject("t");
    const settingsOptions = [
      {
        title: t2.value("notificationPreferences.pushNotificationsTitle"),
        description: t2.value(
          "notificationPreferences.pushNotificationsDescription"
        ),
        icon: render$z,
        path: "PushNotificationsPreferences",
        isVisible: true,
        optionType: NotificationOptionType.PUSH
      },
      {
        title: t2.value("notificationPreferences.emailNotificationsTitle"),
        description: t2.value(
          "notificationPreferences.emailNotificationsDescription"
        ),
        icon: render$u,
        path: "EmailNotificationsPreferences",
        isVisible: true,
        optionType: NotificationOptionType.EMAIL
      }
    ];
    const menuOptionsFilter = computed(() => {
      return settingsOptions.filter((card) => card.isVisible);
    });
    const handleRoutes = (queryValue) => {
      const currentPath = window.location.pathname;
      if (routerInstance) {
        routerInstance.push({
          path: currentPath,
          query: { activeScreen: queryValue }
        });
      }
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$1f, [
        createElementVNode("div", _hoisted_2$Y, [
          createVNode(unref(UICard), { class: "relative z-50 h-full w-full !rounded-none bg-white" }, {
            default: withCtx(() => [
              createElementVNode("div", _hoisted_3$Q, [
                createElementVNode("div", _hoisted_4$L, [
                  createElementVNode("div", _hoisted_5$B, [
                    createElementVNode("div", {
                      onClick: _cache[0] || (_cache[0] = () => {
                        if (unref(routerInstance)) {
                          unref(routerInstance).back();
                        }
                      }),
                      class: "relative h-6 w-6 cursor-pointer"
                    }, [
                      createVNode(unref(render$6))
                    ])
                  ]),
                  createElementVNode("div", _hoisted_6$v, [
                    createElementVNode("div", _hoisted_7$q, [
                      createVNode(unref(UITextLgMedium), { class: "text-fontPrimary" }, {
                        default: withCtx(() => [
                          createTextVNode(toDisplayString(unref(t2)("notificationPreferences.title")), 1)
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ])
            ]),
            _: 1
          })
        ]),
        createElementVNode("div", {
          ref_key: "boxRef",
          ref: boxRef,
          class: "mt-[50px] py-6 grid grid-cols-8 row-span-1 px-4"
        }, [
          createVNode(unref(UILoadingBar), {
            ref: "loadingRef",
            to: boxRef.value
          }, null, 8, ["to"]),
          createElementVNode("div", _hoisted_8$h, [
            (openBlock(true), createElementBlock(Fragment, null, renderList(menuOptionsFilter.value, (option) => {
              return openBlock(), createElementBlock("div", {
                key: option.title
              }, [
                createElementVNode("div", {
                  class: "mt-4 grid items-center gap-2 grid-cols-8",
                  onClick: ($event) => handleRoutes(option.path)
                }, [
                  createElementVNode("div", _hoisted_10$d, [
                    (openBlock(), createBlock(resolveDynamicComponent(option.icon), { class: "w-5 h-5" }))
                  ]),
                  createElementVNode("div", _hoisted_11$d, [
                    createVNode(unref(UITextSmMedium), { class: "text-clientportal-font-primary" }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(option.title), 1)
                      ]),
                      _: 2
                    }, 1024),
                    createVNode(unref(UITextXsMedium), { class: "text-clientportal-font-secondary" }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(option.description), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  createVNode(unref(render$A), { class: "col-span-1 w-6 h-6 text-clientportal-font-secondary" })
                ], 8, _hoisted_9$d)
              ]);
            }), 128))
          ])
        ], 512)
      ]);
    };
  }
});
const NotificationSettings = /* @__PURE__ */ _export_sfc(_sfc_main$1q, [["__scopeId", "data-v-d3e5b6e1"]]);
const _hoisted_1$1e = { class: "flex flex-col" };
const _hoisted_2$X = {
  key: 0,
  class: "p-0"
};
const _hoisted_3$P = {
  key: 1,
  class: "p-0"
};
const _hoisted_4$K = { class: "mb-4 mt-4" };
const _sfc_main$1p = /* @__PURE__ */ defineComponent({
  __name: "DeletePaymentMethodModal",
  props: {
    show: {
      type: Boolean
    },
    userCardData: {
      type: Object
    },
    isCardLinked: {
      type: Boolean
    },
    isModalLoading: {
      type: Boolean
    }
  },
  emits: ["update:show", "canceled"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const notification = useNotification();
    const t2 = inject("t");
    const emit = __emit;
    const handleClose = () => {
      emit("update:show", false);
      emit("canceled");
    };
    async function handleDeleteCard() {
      var _a, _b, _c, _d, _e;
      try {
        await BillingService.deletePaymentMethod({
          contactId: UserState.state.userId,
          locationId: LocationState.state.locationId,
          liveMode: AppState.state.NODE_ENV === "production" ? true : false,
          paymentProvider: (_a = props.userCardData) == null ? void 0 : _a.provider,
          providerCustomerId: (_b = props.userCardData) == null ? void 0 : _b.customerId,
          providerPaymentMethodId: (_c = props.userCardData) == null ? void 0 : _c.id
        });
        notification.success({
          title: t2.value("deleteCard.cardRemovedSuccessfully"),
          content: "",
          duration: 5e3
        });
      } catch (error) {
        console.error("Failed to cancel subscription:", error);
        notification.error({
          title: t2.value("deleteCard.errorInDeletingCard"),
          content: t2.value(
            ((_e = (_d = error == null ? void 0 : error.response) == null ? void 0 : _d.data) == null ? void 0 : _e.message) || t2.value("deleteCard.errorInDeletingCard")
          ),
          duration: 5e3
        });
      } finally {
        handleClose();
      }
    }
    return (_ctx, _cache) => {
      const _directive_swipe = resolveDirective("swipe");
      return openBlock(), createBlock(unref(UIDrawer), {
        class: "rounded-t-xl bg-white",
        show: props.show,
        "onUpdate:show": handleClose,
        placement: "bottom",
        id: "image-drawer",
        height: __props.isCardLinked ? 300 : 250
      }, {
        default: withCtx(() => [
          withDirectives((openBlock(), createBlock(unref(UIDrawerContent), {
            id: "image-drawer-menu",
            class: "p-0",
            closable: false
          }, {
            default: withCtx(() => [
              createElementVNode("div", _hoisted_1$1e, [
                _cache[0] || (_cache[0] = createElementVNode("div", { class: "mt-2 h-1 w-16 mb-4 rounded-md border border-solid bg-gray-200 border-gray-200 self-center" }, null, -1)),
                __props.isModalLoading ? (openBlock(), createElementBlock("div", _hoisted_2$X, [
                  createVNode(unref(UISkeleton), { class: "h-4 mb-4 w-full" }),
                  createVNode(unref(UISkeleton), { class: "h-8 w-full" }),
                  createVNode(unref(UISkeleton), { class: "h-8 w-full" }),
                  createVNode(unref(UISkeleton), { class: "h-8 w-full" })
                ])) : (openBlock(), createElementBlock("div", _hoisted_3$P, [
                  createVNode(unref(UITextLgMedium), { class: "text-lg font-semibold mb-4" }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(unref(t2)("deleteCard.title")), 1)
                    ]),
                    _: 1
                  }),
                  createElementVNode("div", _hoisted_4$K, [
                    createVNode(unref(UITextSmMedium), { class: "mt-2 font-sans font-semibold text-clientportal-font-secondary" }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(__props.isCardLinked ? unref(t2)("deleteCard.activeCard") : unref(t2)("deleteCard.description")), 1)
                      ]),
                      _: 1
                    }),
                    createVNode(unref(UIButton), {
                      id: "conform-cancel-subscription",
                      class: "mt-4 w-full",
                      type: "error",
                      onClick: handleDeleteCard
                    }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(unref(t2)("deleteCard.deleteCard")), 1)
                      ]),
                      _: 1
                    })
                  ])
                ]))
              ])
            ]),
            _: 1
          })), [
            [_directive_swipe, {
              direction: "down",
              callback: () => handleClose()
            }]
          ])
        ]),
        _: 1
      }, 8, ["show", "height"]);
    };
  }
});
const DeletePaymentMethodModal = /* @__PURE__ */ _export_sfc(_sfc_main$1p, [["__scopeId", "data-v-b9a4c24f"]]);
const _hoisted_1$1d = { class: "flex flex-col h-screen w-full fixed bg-white z-[100] overflow-y-auto" };
const _hoisted_2$W = {
  id: "edit-info-navbar",
  class: "fixed left-0 right-0 top-0 z-50 w-full bg-white"
};
const _hoisted_3$O = { class: "relative z-50 flex justify-between items-center w-full bg-white" };
const _hoisted_4$J = { class: "relative z-50 flex items-center justify-center gap-[13px] bg-white" };
const _hoisted_5$A = { class: "relative z-50 flex items-start justify-center gap-2.5 bg-white" };
const _hoisted_6$u = { class: "flex items-start justify-start gap-1" };
const _hoisted_7$p = { class: "inline-flex flex-col items-start justify-start" };
const _hoisted_8$g = { class: "text-lg font-medium leading-7 text-slate-700" };
const _hoisted_9$c = { class: "flex mt-10 pt-6 px-4" };
const _hoisted_10$c = { key: 0 };
const _hoisted_11$c = {
  key: 1,
  class: "flex h-44 items-center justify-center"
};
const _hoisted_12$9 = { class: "flex items-center" };
const _hoisted_13$9 = ["src"];
const _hoisted_14$7 = { class: "ml-3" };
const _sfc_main$1o = /* @__PURE__ */ defineComponent({
  __name: "PaymentMethods",
  setup(__props) {
    const routerInstance = AppState.getRouterInstance();
    const t2 = inject("t");
    const isLoading = ref(false);
    const paymentMethodsData = ref([]);
    const isCardLinked = ref(false);
    const userCardData = ref(null);
    const showModalDeleteCard = ref(false);
    const isModalLoading = ref(false);
    const notification = useNotification();
    onMounted(async () => {
      await getPaymentMethodsData();
    });
    const getPaymentMethodsData = async () => {
      var _a, _b;
      isLoading.value = true;
      try {
        const paymentMethods = await BillingService.getPaymentMethods({
          contactId: UserState.state.userId,
          locationId: LocationState.state.locationId,
          liveMode: AppState.state.NODE_ENV === "production" ? true : false
        });
        paymentMethodsData.value = paymentMethods.data.filter(
          (method) => (method == null ? void 0 : method.type) !== PaymentMethodNames.US_BANK_ACCOUNT
        );
      } catch (error) {
        notification.error({
          title: t2.value("billing.errorFetchingPaymentMethods"),
          content: ((_b = (_a = error.response) == null ? void 0 : _a.data) == null ? void 0 : _b.message) || t2("common.error"),
          duration: 5e3
        });
      } finally {
        isLoading.value = false;
      }
    };
    const handleRemovedCard = () => {
      getPaymentMethodsData();
    };
    const handleDeleteCard = async (card) => {
      try {
        showModalDeleteCard.value = true;
        isModalLoading.value = true;
        const isLinked = await BillingService.isLinkedForBilling({
          contactId: UserState.state.userId,
          locationId: LocationState.state.locationId,
          liveMode: AppState.state.NODE_ENV === "production" ? true : false,
          paymentProvider: card.provider,
          providerCustomerId: card.customerId,
          providerPaymentMethodId: card.id
        });
        isCardLinked.value = isLinked.data.linkedToSubscriptions;
        userCardData.value = card;
        isModalLoading.value = false;
      } catch (error) {
        notification.error({
          title: t2.value("deleteCard.errorInDeletingCard"),
          content: error.response.data.message[0],
          duration: 5e3
        });
      }
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$1d, [
        createElementVNode("div", _hoisted_2$W, [
          createVNode(unref(UICard), { class: "relative z-50 h-full w-full !rounded-none bg-white" }, {
            default: withCtx(() => [
              createElementVNode("div", _hoisted_3$O, [
                createElementVNode("div", _hoisted_4$J, [
                  createElementVNode("div", _hoisted_5$A, [
                    createElementVNode("div", {
                      onClick: _cache[0] || (_cache[0] = () => {
                        if (unref(routerInstance)) {
                          unref(routerInstance).back();
                        }
                      }),
                      class: "relative h-6 w-6 cursor-pointer"
                    }, [
                      createVNode(unref(render$6))
                    ])
                  ]),
                  createElementVNode("div", _hoisted_6$u, [
                    createElementVNode("div", _hoisted_7$p, [
                      createElementVNode("div", _hoisted_8$g, toDisplayString(unref(t2)("account.paymentMethod")), 1)
                    ])
                  ])
                ])
              ])
            ]),
            _: 1
          })
        ]),
        createElementVNode("div", _hoisted_9$c, [
          createVNode(unref(UITextXsRegular), { class: "text-clientportal-font-secondary" }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(unref(t2)("account.paymentDetails")), 1)
            ]),
            _: 1
          })
        ]),
        createElementVNode("div", null, [
          isLoading.value ? (openBlock(), createElementBlock("div", _hoisted_10$c, [
            (openBlock(), createElementBlock(Fragment, null, renderList(3, (i) => {
              return createElementVNode("div", {
                key: i,
                class: "col-span-8 px-4 py-3"
              }, [
                createVNode(unref(UISkeleton), { class: "h-10 rounded-lg" })
              ]);
            }), 64))
          ])) : paymentMethodsData.value.length === 0 ? (openBlock(), createElementBlock("div", _hoisted_11$c, [
            createVNode(unref(UIEmpty), {
              id: "emptyTag",
              title: unref(t2)("deleteCard.noCardAvailable"),
              icon: unref(render$B)
            }, null, 8, ["title", "icon"])
          ])) : (openBlock(true), createElementBlock(Fragment, { key: 2 }, renderList(paymentMethodsData.value, (card) => {
            return openBlock(), createElementBlock("div", {
              class: "flex justify-between px-6 items-center border-0 border-b border-solid border-gray-200 py-4",
              key: card.value
            }, [
              createElementVNode("div", _hoisted_12$9, [
                createElementVNode("img", {
                  src: unref(getCardIcon)(card.brand),
                  alt: "cards",
                  class: "h-8 w-8"
                }, null, 8, _hoisted_13$9),
                createElementVNode("div", _hoisted_14$7, [
                  createVNode(unref(UITextSmRegular), { class: "font-sans text-clientportal-font-primary" }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(unref(capitalizeLetterRemoveUnderscored)(card == null ? void 0 : card.brand) + " " + unref(t2)("billing.endingIn") + " " + (card == null ? void 0 : card.last4)), 1)
                    ]),
                    _: 2
                  }, 1024),
                  (card == null ? void 0 : card.expMonth) && (card == null ? void 0 : card.expYear) ? (openBlock(), createBlock(unref(UITextSmRegular), {
                    key: 0,
                    class: "font-sans text-clientportal-font-secondary"
                  }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(unref(t2)("billing.expiresOn") + " " + card.expMonth.toString().padStart(2, "0") + "/" + card.expYear.toString().slice(-2)), 1)
                    ]),
                    _: 2
                  }, 1024)) : createCommentVNode("", true)
                ])
              ]),
              createElementVNode("div", null, [
                createVNode(unref(render$C), {
                  class: "h-5 w-5 cursor-pointer hover:scale-110 hover:text-clientportal-error-primary",
                  onClick: () => handleDeleteCard(card)
                }, null, 8, ["onClick"])
              ])
            ]);
          }), 128))
        ]),
        createVNode(DeletePaymentMethodModal, {
          show: showModalDeleteCard.value,
          isModalLoading: isModalLoading.value,
          isCardLinked: isCardLinked.value,
          userCardData: userCardData.value,
          "onUpdate:show": _cache[1] || (_cache[1] = ($event) => showModalDeleteCard.value = false),
          onClose: _cache[2] || (_cache[2] = ($event) => showModalDeleteCard.value = false),
          onCanceled: handleRemovedCard
        }, null, 8, ["show", "isModalLoading", "isCardLinked", "userCardData"])
      ]);
    };
  }
});
const PaymentMethods = /* @__PURE__ */ _export_sfc(_sfc_main$1o, [["__scopeId", "data-v-7647b4d8"]]);
const _hoisted_1$1c = { class: "flex flex-col h-screen w-full fixed bg-white z-[100] overflow-y-auto" };
const _hoisted_2$V = {
  id: "edit-info-navbar",
  class: "fixed left-0 right-0 top-0 z-50 w-full bg-white"
};
const _hoisted_3$N = { class: "relative z-50 inline-flex w-full bg-white" };
const _hoisted_4$I = { class: "relative z-50 flex items-center justify-center gap-[13px] bg-white" };
const _hoisted_5$z = { class: "relative z-50 flex items-start justify-center gap-2.5 bg-white" };
const _hoisted_6$t = { class: "flex items-start justify-start gap-1" };
const _hoisted_7$o = { class: "inline-flex flex-col items-start justify-start" };
const _hoisted_8$f = { class: "w-full col-span-8" };
const _hoisted_9$b = ["onClick"];
const _hoisted_10$b = { class: "flex items-center justify-center col-span-1 w-10 h-10 bg-clientportal-liteBackground" };
const _hoisted_11$b = { class: "col-span-6" };
const _sfc_main$1n = /* @__PURE__ */ defineComponent({
  __name: "SettingsMenu",
  setup(__props) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const boxRef = ref(null);
    const routerInstance = AppState.getRouterInstance();
    const isSecure = ref(false);
    const t2 = inject("t");
    const handleCurrentLanguage = () => {
      switch (getLocalePreference()) {
        case "en":
          return "English";
        case "es":
          return "Spanish";
        case "fr-CA":
          return "French (Canada)";
        case "fr-FR":
          return "French (France)";
        case "pt-BR":
          return "Portuguese (Brazil)";
        case "pt-PT":
          return "Portuguese (Portugal)";
        case "fi":
          return "Finnish";
        case "de":
          return "German";
        case "da":
          return "Danish";
        case "it":
          return "Italian";
        case "no":
          return "Norwegian";
        case "sv":
          return "Swedish";
        case "nl":
          return "Dutch";
        default:
          return "English";
      }
    };
    const settingsOptions = [
      {
        title: t2.value("profileSettings.editProfile"),
        description: t2.value("profileSettings.manageYourGroupDetailsHere"),
        icon: render$D,
        path: ProfileScreen.EDIT_PROFILE,
        isVisible: true
      },
      {
        title: t2.value("sideBar.billingSubscription"),
        description: t2.value("billing.manageSubscriptionsInvoicesAndTransactions"),
        icon: render$E,
        path: ProfileScreen.BILLING_SUBSCRIPTION,
        isVisible: isGokollab() || ((_b = (_a = LocationState.state) == null ? void 0 : _a.locationPermissions) == null ? void 0 : _b.subscriptionsEnabled) !== false && !TEST_EMAILS.includes((_d = (_c = UserState) == null ? void 0 : _c.state) == null ? void 0 : _d.email.toLowerCase().trim())
      },
      {
        title: t2.value("chats.chats"),
        description: t2.value("chats.chatSettingsDescription"),
        icon: render$F,
        path: ProfileScreen.COMMUNITIES_CHATS,
        isVisible: !isGokollab()
      },
      {
        title: t2.value("languageSettings.title"),
        description: handleCurrentLanguage(),
        icon: render$G,
        path: ProfileScreen.LANGUAGE_SETTINGS,
        isVisible: true
      },
      {
        title: t2.value("notificationPreferences.title"),
        description: t2.value("notificationPreferences.description"),
        icon: render$H,
        path: ProfileScreen.NOTIFICATION_SETTINGS,
        isVisible: ((_f = (_e = LocationState.state) == null ? void 0 : _e.locationPermissions) == null ? void 0 : _f.communitiesEnabled) || ((_h = (_g = LocationState.state) == null ? void 0 : _g.locationPermissions) == null ? void 0 : _h.membershipEnabled)
      },
      {
        title: t2.value("certificates.title"),
        description: t2.value("certificates.certificatesDescription"),
        icon: render$I,
        path: "Certificates",
        isVisible: true
      }
    ];
    const menuOptionsFilter = computed(() => {
      return settingsOptions.filter((card) => card.isVisible);
    });
    onBeforeMount(async () => {
      await UserState.getUserDetails();
      isSecure.value = await isTokenExpired();
    });
    onMounted(async () => {
      await Promise.all([
        CommunitiesChatState.fetchBlockedUsers(LocationState.state.locationId),
        CommunitiesChatState.fetchUserGroups(LocationState.state.locationId)
      ]);
    });
    async function isTokenExpired() {
      var _a2, _b2;
      if (isGokollab()) {
        const token = UserState.getBillingToken() || "";
        if (!token) {
          return true;
        }
        const jwtPayload = jwtDecode(token);
        return Date.now() - new Date(jwtPayload.exp * 1e3).getTime() > 0;
      }
      const expiryDate = await ((_b2 = (_a2 = UserState) == null ? void 0 : _a2.state) == null ? void 0 : _b2.billingTokenExpiry);
      if (!expiryDate) {
        return true;
      }
      return Date.now() - new Date(expiryDate).getTime() > 0;
    }
    const handleRoutes = async (queryValue) => {
      var _a2, _b2;
      const secure = await isTokenExpired();
      if (secure && queryValue === "BillingSubscription") {
        if (!TEST_EMAILS.includes((_b2 = (_a2 = UserState) == null ? void 0 : _a2.state) == null ? void 0 : _b2.email.toLowerCase().trim())) {
          queryValue = "AuthPage";
        }
      }
      const currentPath = window.location.pathname;
      if (routerInstance) {
        routerInstance.push({
          path: `${currentPath}`,
          query: { activeScreen: queryValue }
        });
      }
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$1c, [
        createElementVNode("div", _hoisted_2$V, [
          createVNode(unref(UICard), { class: "relative z-50 h-full w-full !rounded-none bg-white" }, {
            default: withCtx(() => [
              createElementVNode("div", _hoisted_3$N, [
                createElementVNode("div", _hoisted_4$I, [
                  createElementVNode("div", _hoisted_5$z, [
                    createElementVNode("div", {
                      onClick: _cache[0] || (_cache[0] = () => {
                        if (unref(routerInstance)) {
                          unref(routerInstance).back();
                        }
                      }),
                      class: "relative h-6 w-6 cursor-pointer"
                    }, [
                      createVNode(unref(render$6))
                    ])
                  ]),
                  createElementVNode("div", _hoisted_6$t, [
                    createElementVNode("div", _hoisted_7$o, [
                      createVNode(unref(UITextLgMedium), { class: "text-fontPrimary" }, {
                        default: withCtx(() => [
                          createTextVNode(toDisplayString(unref(t2)("common.settings")), 1)
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ])
            ]),
            _: 1
          })
        ]),
        createElementVNode("div", {
          ref_key: "boxRef",
          ref: boxRef,
          class: "mt-[50px] py-6 grid grid-cols-8 row-span-1 px-4"
        }, [
          createVNode(unref(UILoadingBar), {
            ref: "loadingRef",
            to: boxRef.value
          }, null, 8, ["to"]),
          createElementVNode("div", _hoisted_8$f, [
            createVNode(unref(UITextMdMedium), { class: "text-clientportal-font-primary" }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(unref(t2)("common.settings")), 1)
              ]),
              _: 1
            }),
            (openBlock(true), createElementBlock(Fragment, null, renderList(menuOptionsFilter.value, (option) => {
              return openBlock(), createElementBlock("div", {
                key: option.title
              }, [
                createElementVNode("div", {
                  class: "mt-4 grid items-center gap-2 grid-cols-8",
                  onClick: ($event) => handleRoutes(option.path)
                }, [
                  createElementVNode("div", _hoisted_10$b, [
                    (openBlock(), createBlock(resolveDynamicComponent(option.icon), { class: "w-5 h-5" }))
                  ]),
                  createElementVNode("div", _hoisted_11$b, [
                    createVNode(unref(UITextSmMedium), { class: "text-clientportal-font-primary" }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(option.title), 1)
                      ]),
                      _: 2
                    }, 1024),
                    createVNode(unref(UITextXsMedium), { class: "text-clientportal-font-secondary" }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(option.description), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  createVNode(unref(render$A), { class: "col-span-1 w-6 h-6 text-clientportal-font-secondary" })
                ], 8, _hoisted_9$b)
              ]);
            }), 128))
          ])
        ], 512)
      ]);
    };
  }
});
const SettingsMenu = /* @__PURE__ */ _export_sfc(_sfc_main$1n, [["__scopeId", "data-v-f3f04321"]]);
const _hoisted_1$1b = { class: "flex flex-col h-screen w-full fixed bg-white z-[100] overflow-y-auto" };
const _hoisted_2$U = {
  id: "edit-info-navbar",
  class: "fixed left-0 right-0 top-0 z-50 w-full bg-white"
};
const _hoisted_3$M = { class: "relative z-50 inline-flex w-full bg-white" };
const _hoisted_4$H = { class: "relative z-50 flex items-center justify-center gap-[13px] bg-white" };
const _hoisted_5$y = { class: "relative z-50 flex items-start justify-center gap-2.5 bg-white" };
const _hoisted_6$s = { class: "flex items-start justify-start gap-1" };
const _hoisted_7$n = { class: "inline-flex flex-col items-start justify-start" };
const _hoisted_8$e = {
  key: 0,
  class: "px-6 flex items-center justify-center h-[90vh]"
};
const _hoisted_9$a = {
  key: 1,
  class: "px-6"
};
const _hoisted_10$a = { class: "p-6 mt-16 rounded-xl bg-clientportal-liteBackground flex justify-between items-center mb-4" };
const _hoisted_11$a = { class: "text-right" };
const _hoisted_12$8 = { class: "mb-4" };
const _hoisted_13$8 = { class: "flex flex-col" };
const _hoisted_14$6 = { class: "p-0" };
const _hoisted_15$5 = { class: "flex justify-between items-center" };
const _hoisted_16$3 = { class: "text-clientportal-font-primary font-semibold" };
const _sfc_main$1m = /* @__PURE__ */ defineComponent({
  __name: "SubscriptionDetail",
  setup(__props) {
    const routerInstance = AppState.getRouterInstance();
    const userData = ref();
    const isSubscription = ref();
    const isLoading = ref(false);
    const showProfileDrawer = ref(false);
    const t2 = inject("t");
    onMounted(async () => {
      isLoading.value = true;
      const billingId = AppState.state.billingId;
      isSubscription.value = AppState.state.isSubscription;
      await getUserData(billingId);
      isLoading.value = false;
    });
    async function handleCancelSubscription() {
      const billingObj = AppState.state.billingObj;
      await BillingService.cancelSubscription({
        locationId: isGokollab() ? billingObj == null ? void 0 : billingObj.altId : LocationState.state.locationId,
        subscriptionId: userData.value._id,
        contactId: isGokollab() ? billingObj == null ? void 0 : billingObj.contactId : UserState.state.userId
      });
      showProfileDrawer.value = false;
    }
    const getUserData = async (billingId) => {
      if (billingId && isSubscription.value) {
        const billingObj = AppState.state.billingObj;
        const subscriptionData = await BillingService.getSubscriptionsById({
          locationId: isGokollab() ? billingObj.altId : LocationState.state.locationId,
          subscriptionId: billingId,
          contactId: isGokollab() ? billingObj.contactId : UserState.state.userId
        });
        userData.value = subscriptionData.data;
      } else {
        const transactionObj = AppState.state.transactionObj;
        const transactionData = await BillingService.getTransactionsById({
          locationId: isGokollab() ? transactionObj.altId : LocationState.state.locationId,
          transactionId: billingId,
          contactId: isGokollab() ? transactionObj.contactId : UserState.state.userId
        });
        userData.value = transactionData.data;
      }
    };
    const details = computed(() => {
      var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _A, _B, _C, _D, _E, _F, _G, _H;
      const detailsArray = [
        {
          title: isSubscription.value ? t2.value("billing.nextInvoiceOn") : t2.value("account.transactionDate"),
          data: moment.unix(
            isSubscription.value ? (_b = (_a = userData == null ? void 0 : userData.value) == null ? void 0 : _a.subscriptionSnapshot) == null ? void 0 : _b.current_period_end : (_d = (_c = userData == null ? void 0 : userData.value) == null ? void 0 : _c.chargeSnapshot) == null ? void 0 : _d.created
          ).format("MMMM D, YYYY")
        },
        {
          title: isSubscription.value ? t2.value("support.subscriptionId") : t2.value("wallet.transactionId"),
          data: (_e = userData.value) == null ? void 0 : _e._id
        },
        {
          title: t2.value("account.orderId"),
          data: (_f = userData.value) == null ? void 0 : _f.entityId
        },
        {
          title: t2.value("common.type"),
          data: (_h = (_g = userData.value) == null ? void 0 : _g.entitySource) == null ? void 0 : _h.type
        },
        {
          title: t2.value("common.id"),
          data: (_j = (_i = userData.value) == null ? void 0 : _i.entitySource) == null ? void 0 : _j.id
        }
      ];
      if ((_m = (_l = (_k = userData.value) == null ? void 0 : _k.entitySource) == null ? void 0 : _l.meta) == null ? void 0 : _m.pageUrl) {
        detailsArray.push({
          title: t2.value("billing.pageUrl"),
          data: ((_q = (_p = (_o = (_n = userData.value) == null ? void 0 : _n.entitySource) == null ? void 0 : _o.meta) == null ? void 0 : _p.pageUrl) == null ? void 0 : _q.replace(/^\//, "")) || ""
        });
      }
      if (!isSubscription.value) {
        detailsArray.push(
          {
            title: t2.value("account.paymentDetails"),
            data: "XXXX XXXX XXXX " + ((_w = (_v = (_u = (_t = (_s = (_r = userData.value) == null ? void 0 : _r.chargeSnapshot) == null ? void 0 : _s.charges) == null ? void 0 : _t.data[0]) == null ? void 0 : _u.payment_method_details) == null ? void 0 : _v.card) == null ? void 0 : _w.last4) || "NA"
          },
          {
            title: t2.value("account.expiryDate"),
            data: ((_x = userData.value) == null ? void 0 : _x.chargeSnapshot) ? ((_C = (_B = (_A = (_z = (_y = userData.value) == null ? void 0 : _y.chargeSnapshot) == null ? void 0 : _z.charges) == null ? void 0 : _A.data[0]) == null ? void 0 : _B.payment_method_details.card) == null ? void 0 : _C.exp_month) + "/" + ((_H = (_G = (_F = (_E = (_D = userData.value) == null ? void 0 : _D.chargeSnapshot) == null ? void 0 : _E.charges) == null ? void 0 : _F.data[0]) == null ? void 0 : _G.payment_method_details.card) == null ? void 0 : _H.exp_year) : "NA"
          }
        );
      }
      return detailsArray;
    });
    return (_ctx, _cache) => {
      var _a, _b;
      const _directive_swipe = resolveDirective("swipe");
      return openBlock(), createElementBlock(Fragment, null, [
        createElementVNode("div", _hoisted_1$1b, [
          createElementVNode("div", _hoisted_2$U, [
            createVNode(unref(UICard), { class: "relative z-50 h-full w-full !rounded-none bg-white" }, {
              default: withCtx(() => [
                createElementVNode("div", _hoisted_3$M, [
                  createElementVNode("div", _hoisted_4$H, [
                    createElementVNode("div", _hoisted_5$y, [
                      createElementVNode("div", {
                        onClick: _cache[0] || (_cache[0] = () => {
                          if (unref(routerInstance)) {
                            unref(routerInstance).back();
                          }
                        }),
                        class: "relative h-6 w-6 cursor-pointer"
                      }, [
                        createVNode(unref(render$6))
                      ])
                    ]),
                    createElementVNode("div", _hoisted_6$s, [
                      createElementVNode("div", _hoisted_7$n, [
                        createVNode(unref(UITextLgMedium), { class: "text-fontPrimary" }, {
                          default: withCtx(() => [
                            createTextVNode(toDisplayString(isSubscription.value ? unref(t2)("billing.subscription") : unref(t2)("billing.transaction")) + " details ", 1)
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          isLoading.value ? (openBlock(), createElementBlock("div", _hoisted_8$e, [
            createVNode(unref(UISpin), { size: "medium" })
          ])) : (openBlock(), createElementBlock("div", _hoisted_9$a, [
            createElementVNode("div", _hoisted_10$a, [
              createElementVNode("div", null, [
                createVNode(unref(UITextMdMedium), { class: "text-clientportal-font-primary font-sans" }, {
                  default: withCtx(() => {
                    var _a2, _b2;
                    return [
                      createTextVNode(toDisplayString((_b2 = (_a2 = userData.value) == null ? void 0 : _a2.entitySource) == null ? void 0 : _b2.name), 1)
                    ];
                  }),
                  _: 1
                }),
                isSubscription.value ? (openBlock(), createBlock(unref(UITextXsMedium), {
                  key: 0,
                  class: "text-clientportal-font-secondary font-sans"
                }, {
                  default: withCtx(() => {
                    var _a2, _b2, _c;
                    return [
                      createTextVNode(toDisplayString(unref(t2)("billing.billing") + " " + ((_c = (_b2 = (_a2 = userData.value) == null ? void 0 : _a2.subscriptionSnapshot) == null ? void 0 : _b2.plan) == null ? void 0 : _c.interval)), 1)
                    ];
                  }),
                  _: 1
                })) : createCommentVNode("", true)
              ]),
              createElementVNode("div", _hoisted_11$a, [
                createVNode(unref(UIDisplaySmMedium), { class: "text-clientportal-font-primary font-sans text-left mb-2" }, {
                  default: withCtx(() => {
                    var _a2, _b2;
                    return [
                      createTextVNode(toDisplayString(unref(getCurrencySymbol)(((_a2 = userData.value) == null ? void 0 : _a2.currency.toUpperCase()) || "USD")) + " " + toDisplayString((_b2 = userData.value) == null ? void 0 : _b2.amount), 1)
                    ];
                  }),
                  _: 1
                }),
                createVNode(unref(UITag), {
                  type: unref(getStatusType)((_a = userData.value) == null ? void 0 : _a.status),
                  closable: false,
                  size: "medium",
                  round: true,
                  bordered: true
                }, {
                  default: withCtx(() => {
                    var _a2;
                    return [
                      createTextVNode(toDisplayString(unref(capitalizeLetterRemoveUnderscored)((_a2 = userData.value) == null ? void 0 : _a2.status)), 1)
                    ];
                  }),
                  _: 1
                }, 8, ["type"])
              ])
            ]),
            createElementVNode("div", _hoisted_12$8, [
              (openBlock(true), createElementBlock(Fragment, null, renderList(details.value, (detail) => {
                return openBlock(), createElementBlock("div", {
                  key: detail.title,
                  class: "flex justify-between mb-2"
                }, [
                  createVNode(unref(UITextSmRegular), { class: "text-clientportal-font-secondary font-sans" }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(detail.title), 1)
                    ]),
                    _: 2
                  }, 1024),
                  createVNode(unref(UITextSmRegular), { class: "text-clientportal-font-primary font-sans" }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(detail.data), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]);
              }), 128))
            ]),
            isSubscription.value && ((_b = userData.value) == null ? void 0 : _b.status) === "active" ? (openBlock(), createBlock(unref(UIButton), {
              key: 0,
              id: `cancel-subscription`,
              class: "w-full",
              type: "error",
              onClick: _cache[1] || (_cache[1] = () => showProfileDrawer.value = !showProfileDrawer.value)
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(unref(t2)("cancelModal.cancelSubscription")), 1)
              ]),
              _: 1
            })) : createCommentVNode("", true)
          ]))
        ]),
        createVNode(unref(UIDrawer), {
          class: "rounded-t-xl bg-white",
          show: showProfileDrawer.value,
          "onUpdate:show": _cache[2] || (_cache[2] = ($event) => showProfileDrawer.value = $event),
          placement: "bottom",
          id: "image-drawer",
          height: 280
        }, {
          default: withCtx(() => [
            withDirectives((openBlock(), createBlock(unref(UIDrawerContent), {
              id: "image-drawer-menu",
              closable: false
            }, {
              default: withCtx(() => [
                createElementVNode("div", _hoisted_13$8, [
                  _cache[3] || (_cache[3] = createElementVNode("div", { class: "mt-2 h-1 w-16 mb-4 rounded-md border border-solid bg-gray-200 border-gray-200 self-center" }, null, -1)),
                  createElementVNode("div", _hoisted_14$6, [
                    createElementVNode("div", _hoisted_15$5, [
                      createVNode(unref(UITextLgMedium), { class: "text-lg font-semibold mb-4" }, {
                        default: withCtx(() => [
                          createTextVNode(toDisplayString(unref(t2)("cancelModal.cancelSubscription")), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    createElementVNode("div", null, [
                      createVNode(unref(UITextSmRegular), { class: "text-clientportal-font-secondary font-sans" }, {
                        default: withCtx(() => {
                          var _a2, _b2;
                          return [
                            createElementVNode("span", _hoisted_16$3, toDisplayString(unref(t2)("cancelModal.yourPlanName") + " " + ((_b2 = (_a2 = userData.value) == null ? void 0 : _a2.entitySource) == null ? void 0 : _b2.name) + " "), 1),
                            createTextVNode(toDisplayString(unref(t2)("cancelModal.subscriptionCancelNotice")), 1)
                          ];
                        }),
                        _: 1
                      }),
                      createVNode(unref(UITextSmMedium), { class: "text-clientportal-font-secondary font-sans mt-2 font-semibold" }, {
                        default: withCtx(() => [
                          createTextVNode(toDisplayString(unref(t2)("cancelModal.subscriptionRenewNotice")), 1)
                        ]),
                        _: 1
                      }),
                      createVNode(unref(UIButton), {
                        id: "conform-cancel-subscription",
                        class: "w-full mt-4",
                        type: "error",
                        onClick: handleCancelSubscription
                      }, {
                        default: withCtx(() => [
                          createTextVNode(toDisplayString(unref(t2)("cancelModal.cancelSubscription")), 1)
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ]),
              _: 1
            })), [
              [_directive_swipe, {
                direction: "down",
                callback: () => showProfileDrawer.value = !showProfileDrawer.value
              }]
            ])
          ]),
          _: 1
        }, 8, ["show"])
      ], 64);
    };
  }
});
const SubscriptionDetail = /* @__PURE__ */ _export_sfc(_sfc_main$1m, [["__scopeId", "data-v-b21ea3f5"]]);
const getChatWidget = async () => {
  var _a, _b, _c, _d, _e, _f;
  if ((_d = (_c = (_b = (_a = LocationState) == null ? void 0 : _a.state) == null ? void 0 : _b.chatWidgetSettings) == null ? void 0 : _c.permissions) == null ? void 0 : _d.home) {
    try {
      const response = await UserService.getChatWidgetConfig(
        (_f = (_e = LocationState) == null ? void 0 : _e.state) == null ? void 0 : _f.locationId
      );
      postscribe(`#clientportal-chatWidget`, response.code, {
        done: () => {
          const applyStyles = (element) => {
            element.style.position = "relative";
            element.style.zIndex = "50";
          };
          const chatWidget = document.querySelector("chat-widget");
          if (chatWidget) {
            applyStyles(chatWidget);
            isPwa() ? addChatWidgetPositioningScript() : null;
            return;
          }
          const observer = new MutationObserver((mutations) => {
            var _a2;
            for (const mutation of mutations) {
              for (const node of Array.from(mutation.addedNodes)) {
                if (node.nodeType === Node.ELEMENT_NODE) {
                  const element = node;
                  const widget2 = ((_a2 = element.tagName) == null ? void 0 : _a2.toLowerCase()) === "chat-widget" ? element : element.querySelector("chat-widget");
                  if (widget2) {
                    applyStyles(widget2);
                    observer.disconnect();
                    isPwa() ? addChatWidgetPositioningScript() : null;
                    return;
                  }
                }
              }
            }
          });
          observer.observe(document.body, { childList: true, subtree: true });
          setTimeout(() => observer.disconnect(), 1e4);
        }
      });
    } catch (error) {
      console.error(error);
    }
  } else {
    postscribe(`#clientportal-chatWidget`, "");
    const chatWidget = document.querySelector("chat-widget");
    if (chatWidget) {
      chatWidget.remove();
    }
  }
};
const _hoisted_1$1a = { key: 0 };
const _hoisted_2$T = { key: 1 };
const _hoisted_3$L = { key: 2 };
const _hoisted_4$G = { key: 3 };
const _hoisted_5$x = { key: 4 };
const _hoisted_6$r = { key: 5 };
const _hoisted_7$m = { key: 6 };
const _hoisted_8$d = { key: 7 };
const _hoisted_9$9 = { key: 8 };
const _hoisted_10$9 = { key: 9 };
const _hoisted_11$9 = { key: 10 };
const _hoisted_12$7 = { key: 11 };
const _hoisted_13$7 = { key: 12 };
const _hoisted_14$5 = { key: 13 };
const _hoisted_15$4 = { key: 14 };
const _hoisted_16$2 = { key: 15 };
const _sfc_main$1l = /* @__PURE__ */ defineComponent({
  __name: "ProfileContainer",
  setup(__props) {
    const activeEditScreen = ref("");
    const t2 = ref(null);
    onBeforeMount(() => {
      t2.value = setupVueI18n(getLocalePreference());
      getChatWidget();
    });
    provide("t", t2);
    const routerInstance = AppState.getRouterInstance();
    const route = computed(() => {
      if (!routerInstance) return null;
      return routerInstance.currentRoute;
    });
    watchEffect(() => {
      var _a, _b, _c;
      if (!AppState.state.isMobile) {
        const currentPath = window.location.pathname;
        if (routerInstance) {
          routerInstance.push({ path: `${currentPath}/home` });
        }
      }
      activeEditScreen.value = ((_c = (_b = (_a = route.value) == null ? void 0 : _a.query) == null ? void 0 : _b.activeScreen) == null ? void 0 : _c.toString()) || "Profile";
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(Transition, {
        "enter-from-class": "opacity-100 translate-x-2",
        "enter-active-class": "transition ease-out duration-100",
        "enter-to-class": "opacity-100 translate-x-0",
        "leave-from-class": "opacity-100 translate-x-0",
        "leave-to-class": "opacity-100 translate-x-2",
        "leave-active-class": "transition ease-in duration-100"
      }, {
        default: withCtx(() => [
          activeEditScreen.value ? (openBlock(), createElementBlock("div", {
            key: activeEditScreen.value,
            class: "activeEditScreen"
          }, [
            activeEditScreen.value === unref(ProfileScreen).EDIT_BASIC_INFO ? (openBlock(), createElementBlock("div", _hoisted_1$1a, [
              createVNode(EditBasicInfo)
            ])) : activeEditScreen.value === unref(ProfileScreen).EDIT_DETAILS ? (openBlock(), createElementBlock("div", _hoisted_2$T, [
              createVNode(EditDetails)
            ])) : activeEditScreen.value === unref(ProfileScreen).EDIT_ACCOUNT ? (openBlock(), createElementBlock("div", _hoisted_3$L, [
              createVNode(EditAccount)
            ])) : activeEditScreen.value === unref(ProfileScreen).EDIT_PROFILE ? (openBlock(), createElementBlock("div", _hoisted_4$G, [
              createVNode(EditProfile)
            ])) : activeEditScreen.value === unref(ProfileScreen).SETTINGS_MENU ? (openBlock(), createElementBlock("div", _hoisted_5$x, [
              createVNode(SettingsMenu)
            ])) : activeEditScreen.value === unref(ProfileScreen).BILLING_SUBSCRIPTION ? (openBlock(), createElementBlock("div", _hoisted_6$r, [
              createVNode(BillingSubscription)
            ])) : activeEditScreen.value === unref(ProfileScreen).AUTH_PAGE ? (openBlock(), createElementBlock("div", _hoisted_7$m, [
              createVNode(AuthPage)
            ])) : activeEditScreen.value === unref(ProfileScreen).SUBSCRIPTION_DETAIL ? (openBlock(), createElementBlock("div", _hoisted_8$d, [
              createVNode(SubscriptionDetail)
            ])) : activeEditScreen.value === unref(ProfileScreen).COMMUNITIES_CHATS ? (openBlock(), createElementBlock("div", _hoisted_9$9, [
              createVNode(ChatSettings)
            ])) : activeEditScreen.value === unref(ProfileScreen).CERTIFICATES ? (openBlock(), createElementBlock("div", _hoisted_10$9, [
              createVNode(CertificatesListing)
            ])) : activeEditScreen.value === unref(ProfileScreen).NOTIFICATION_SETTINGS ? (openBlock(), createElementBlock("div", _hoisted_11$9, [
              createVNode(NotificationSettings)
            ])) : activeEditScreen.value === unref(ProfileScreen).PUSH_NOTIFICATIONS_PREFERENCES ? (openBlock(), createElementBlock("div", _hoisted_12$7, [
              createVNode(NotificationPreferences, {
                optionType: unref(NotificationOptionType).PUSH
              }, null, 8, ["optionType"])
            ])) : activeEditScreen.value === unref(ProfileScreen).EMAIL_NOTIFICATIONS_PREFERENCES ? (openBlock(), createElementBlock("div", _hoisted_13$7, [
              createVNode(NotificationPreferences, {
                optionType: unref(NotificationOptionType).EMAIL
              }, null, 8, ["optionType"])
            ])) : activeEditScreen.value === unref(ProfileScreen).LANGUAGE_SETTINGS ? (openBlock(), createElementBlock("div", _hoisted_14$5, [
              createVNode(LanguageSettings)
            ])) : activeEditScreen.value === unref(ProfileScreen).PAYMENT_METHODS ? (openBlock(), createElementBlock("div", _hoisted_15$4, [
              createVNode(PaymentMethods)
            ])) : (openBlock(), createElementBlock("div", _hoisted_16$2, [
              createVNode(Profile)
            ]))
          ])) : createCommentVNode("", true)
        ]),
        _: 1
      });
    };
  }
});
const ProfileContainer = /* @__PURE__ */ _export_sfc(_sfc_main$1l, [["__scopeId", "data-v-7102a082"]]);
const onLoad = (callback, delay = 1) => {
  if (document.readyState === "complete") {
    setTimeout(() => callback(), delay);
  } else {
    window.addEventListener("load", function() {
      setTimeout(() => callback(), delay);
    });
  }
};
const _sfc_main$1k = /* @__PURE__ */ defineComponent({
  __name: "ReCaptcha",
  props: {
    siteKey: {
      type: String,
      default: "6LeA0l8pAAAAAMjF87jhpIngHsYPUOsWzM9RwNac"
    }
  },
  emits: ["verify", "expired", "error"],
  setup(__props, { emit: __emit }) {
    const emit = __emit;
    const loadScript = () => {
      onLoad(() => {
        const scriptTag = document.createElement("script");
        scriptTag.type = "text/javascript";
        scriptTag.async = true;
        scriptTag.src = AppState.getConfig().reCaptchaDomain;
        document.head.appendChild(scriptTag);
      });
    };
    const onVerify = (event) => {
      emit("verify", event);
    };
    const onExpired = (event) => {
      emit("expired", event);
    };
    const onError = (event) => {
      emit("error", event);
    };
    return (_ctx, _cache) => {
      const _directive_visibility_observer = resolveDirective("visibility-observer");
      return withDirectives((openBlock(), createBlock(unref(Recaptcha), {
        onExpired,
        onVerify,
        onError,
        sitekey: __props.siteKey,
        class: "g-recaptcha mt-[22px] flex"
      }, null, 8, ["sitekey"])), [
        [_directive_visibility_observer, loadScript]
      ]);
    };
  }
});
const __default__$b = {
  name: "CPButton",
  inheritAttrs: false
};
const _sfc_main$1j = /* @__PURE__ */ defineComponent({
  ...__default__$b,
  props: {
    type: { default: "primary" },
    id: {},
    style: {},
    color: { default: "primary" }
  },
  setup(__props) {
    const props = __props;
    const buttonStyles = computed(() => {
      const baseStyles = props.style || "";
      const typeStyles = {
        primary: {
          "--n-color": "var(--primary)",
          "--n-color-hover": "var(--primaryDark)",
          "--n-color-pressed": "var(--primaryDark)",
          "--n-color-focus": "var(--primary)",
          "--n-color-disabled": "var(--primaryLight)",
          "--n-text-color": "var(--staticWhite)",
          "--n-text-color-hover": "var(--staticWhite)",
          "--n-text-color-pressed": "var(--staticWhite)",
          "--n-text-color-focus": "var(--staticWhite)",
          "--n-text-color-disabled": "var(--staticWhite)",
          "--n-border": "1px solid var(--primary)",
          "--n-border-hover": "1px solid var(--primaryDark)",
          "--n-border-pressed": "1px solid var(--primaryDark)",
          "--n-border-focus": "1px solid var(--primary)",
          "--n-border-disabled": "1px solid var(--primaryLight)"
        },
        secondary: props.color === "primary" ? {
          "--n-color": "transparent",
          "--n-color-hover": "var(--primaryLight)",
          "--n-color-pressed": "var(--primaryLight)",
          "--n-color-focus": "var(--primaryLight)",
          "--n-color-disabled": "transparent",
          "--n-text-color": "var(--primary)",
          "--n-text-color-hover": "var(--primary)",
          "--n-text-color-pressed": "var(--primary)",
          "--n-text-color-focus": "var(--primary)",
          "--n-text-color-disabled": "var(--primaryLight)",
          "--n-border": "1px solid var(--primary)",
          "--n-border-hover": "1px solid var(--primary)",
          "--n-border-pressed": "1px solid var(--primary)",
          "--n-border-focus": "1px solid var(--primary)",
          "--n-border-disabled": "1px solid var(--primaryLight)"
        } : {
          "--n-color": "transparent",
          "--n-color-hover": "var(--backgroundDark)",
          "--n-color-pressed": "var(--backgroundDark)",
          "--n-color-focus": "var(--backgroundDark)",
          "--n-color-disabled": "transparent",
          "--n-text-color": "var(--fontSecondary)",
          "--n-text-color-hover": "var(--fontPrimary)",
          "--n-text-color-pressed": "var(--fontPrimary)",
          "--n-text-color-focus": "var(--fontPrimary)",
          "--n-text-color-disabled": "var(--fill)",
          "--n-border": "1px solid var(--fontSecondary)",
          "--n-border-hover": "1px solid var(--fontPrimary)",
          "--n-border-pressed": "1px solid var(--fontPrimary)",
          "--n-border-focus": "1px solid var(--fontPrimary)",
          "--n-border-disabled": "1px solid var(--fill)"
        },
        tertiary: {
          //   '--n-color': 'transparent',
          //   '--n-color-hover': 'rgba(var(--primary-rgb), 0.1)',
          //   '--n-color-pressed': 'rgba(var(--primary-rgb), 0.2)',
          //   '--n-color-focus': 'transparent',
          //   '--n-color-disabled': 'transparent',
          //   '--n-text-color': 'var(--primary)',
          //   '--n-text-color-hover': 'var(--primary-hover)',
          //   '--n-text-color-pressed': 'var(--primary-pressed)',
          //   '--n-text-color-focus': 'var(--primary)',
          //   '--n-text-color-disabled': 'var(--primary-disabled)',
          //   '--n-border': 'none',
          //   '--n-border-hover': 'none',
          //   '--n-border-pressed': 'none',
          //   '--n-border-focus': 'none',
          //   '--n-border-disabled': 'none',
        },
        text: props.color === "primary" ? {
          "--n-color": "transparent",
          "--n-color-hover": "rgba(var(--primary-rgb), 0.1)",
          "--n-color-pressed": "rgba(var(--primary-rgb), 0.2)",
          "--n-color-focus": "transparent",
          "--n-color-disabled": "transparent",
          "--n-text-color": "var(--primary)",
          "--n-text-color-hover": "var(--primary)",
          "--n-text-color-pressed": "var(--primary)",
          "--n-text-color-focus": "var(--primary)",
          "--n-text-color-disabled": "var(--primaryLight)",
          "--n-border": "none",
          "--n-border-hover": "none",
          "--n-border-pressed": "none",
          "--n-border-focus": "none",
          "--n-border-disabled": "none"
        } : {
          "--n-color": "transparent",
          "--n-color-hover": "var(--backgroundDark)",
          "--n-color-pressed": "var(--backgroundDark)",
          "--n-color-focus": "transparent",
          "--n-color-disabled": "transparent",
          "--n-text-color": "var(--fontSecondary)",
          "--n-text-color-hover": "var(--fontPrimary)",
          "--n-text-color-pressed": "var(--fontPrimary)",
          "--n-text-color-focus": "var(--fontSecondary)",
          "--n-text-color-disabled": "var(--fill)",
          "--n-border": "none",
          "--n-border-hover": "none",
          "--n-border-pressed": "none",
          "--n-border-focus": "none",
          "--n-border-disabled": "none"
        }
      };
      const typeStyleString = Object.entries(typeStyles[props.type]).map(([key, value]) => `${key}: ${value}`).join("; ");
      return `${baseStyles}; ${typeStyleString}`;
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(HLButton), mergeProps(_ctx.$attrs, {
        id: props.id,
        variant: props.type,
        style: buttonStyles.value
      }), createSlots({
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 2
      }, [
        _ctx.$slots["iconLeft"] ? {
          name: "iconLeft",
          fn: withCtx(() => [
            renderSlot(_ctx.$slots, "iconLeft")
          ]),
          key: "0"
        } : void 0,
        _ctx.$slots.icon ? {
          name: "icon",
          fn: withCtx(() => [
            renderSlot(_ctx.$slots, "icon")
          ]),
          key: "1"
        } : void 0,
        _ctx.$slots["iconRight"] ? {
          name: "iconRight",
          fn: withCtx(() => [
            renderSlot(_ctx.$slots, "iconRight")
          ]),
          key: "2"
        } : void 0
      ]), 1040, ["id", "variant", "style"]);
    };
  }
});
const _imports_0 = "data:image/svg+xml,%3csvg%20width='428'%20height='926'%20viewBox='0%200%20428%20926'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20fill='%23fff'%20d='M0%200h428v926H0z'/%3e%3cg%20opacity='.08'%20clip-path='url(%23a)'%3e%3cpath%20d='M54.777%2076.715a4.812%204.812%200%201%201-1.74-6.362m-.29%2025.426%203.21-1.607a5.8%205.8%200%200%201%201.315-.472l3.803-.874c.825-.19%201.6-.556%202.272-1.073l3.383-2.608a5.8%205.8%200%200%200%201.933-2.671l1.36-3.91a2.067%202.067%200%200%200-1.335-2.665%202.214%202.214%200%200%200-2.621%201.093l-1.962%203.804a2.9%202.9%200%200%201-1.286%201.267l-2.985%201.496%201.9-.952c1.07-.537%201.516-1.815.994-2.857l-.19-.377c-.432-.865-1.416-1.316-2.383-1.093l-3.29.755a7%207%200%200%200-1.544.556c-1.186.594-2.841%202.652-2.841%202.652l-2.85%203.313m11.961-19.102a4.812%204.812%200%201%201-8.605%204.31%204.812%204.812%200%200%201%208.605-4.31m-17.14%2021.043%203.572%207.13c.345.689.517%201.033.783%201.229.234.172.516.266.806.268.33.002.675-.17%201.363-.515l.984-.493c.688-.345%201.033-.517%201.228-.783.173-.233.267-.516.269-.806.002-.33-.17-.674-.516-1.363l-3.572-7.13c-.344-.689-.517-1.033-.782-1.23a1.38%201.38%200%200%200-.807-.267c-.33-.002-.674.17-1.363.515l-.983.493c-.689.344-1.033.517-1.229.783a1.37%201.37%200%200%200-.268.806c-.002.33.17.674.515%201.363'%20stroke='%23344054'%20stroke-width='1.414'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/g%3e%3cg%20opacity='.08'%20clip-path='url(%23b)'%3e%3cpath%20d='M197.777%20170.715a4.813%204.813%200%201%201-1.74-6.362m-.289%2025.426%203.209-1.607c.418-.21.859-.368%201.314-.472l3.804-.875a5.9%205.9%200%200%200%202.272-1.072l3.383-2.608a5.8%205.8%200%200%200%201.934-2.671l1.359-3.909a2.067%202.067%200%200%200-1.335-2.666%202.21%202.21%200%200%200-2.621%201.093l-1.962%203.804c-.281.546-.732.99-1.286%201.267l-2.985%201.496%201.9-.952c1.071-.537%201.516-1.815.994-2.857l-.189-.377c-.433-.865-1.417-1.316-2.384-1.093l-3.29.755a7%207%200%200%200-1.544.556c-1.186.594-2.841%202.652-2.841%202.652l-2.85%203.313m11.961-19.102a4.812%204.812%200%201%201-8.605%204.311%204.813%204.813%200%201%201%208.605-4.311m-17.14%2021.043%203.572%207.13c.345.689.517%201.033.783%201.229.234.172.516.266.806.268.331.002.675-.17%201.363-.515l.984-.493c.688-.345%201.033-.517%201.228-.783.173-.234.267-.516.269-.806.002-.33-.171-.675-.516-1.363l-3.571-7.13c-.345-.689-.518-1.033-.784-1.229a1.38%201.38%200%200%200-.806-.268c-.33-.002-.674.17-1.363.515l-.983.493c-.689.345-1.033.517-1.229.783a1.38%201.38%200%200%200-.268.806c-.002.33.17.674.515%201.363'%20stroke='%23344054'%20stroke-width='1.414'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/g%3e%3cg%20opacity='.08'%20clip-path='url(%23c)'%3e%3cpath%20d='M277.777%20275.715a4.813%204.813%200%201%201-1.74-6.362m-.289%2025.426%203.209-1.607c.418-.21.859-.368%201.314-.472l3.804-.875a5.9%205.9%200%200%200%202.272-1.072l3.383-2.608a5.8%205.8%200%200%200%201.934-2.671l1.359-3.909a2.067%202.067%200%200%200-1.335-2.666%202.21%202.21%200%200%200-2.621%201.093l-1.962%203.804c-.281.546-.732.99-1.286%201.267l-2.985%201.496%201.9-.952c1.071-.537%201.516-1.815.994-2.857l-.189-.377c-.433-.865-1.417-1.316-2.384-1.093l-3.29.755a7%207%200%200%200-1.544.556c-1.186.594-2.841%202.652-2.841%202.652l-2.85%203.313m11.961-19.102a4.812%204.812%200%201%201-8.605%204.311%204.813%204.813%200%201%201%208.605-4.311m-17.14%2021.043%203.572%207.13c.345.689.517%201.033.783%201.229.234.172.516.266.806.268.331.002.675-.17%201.363-.515l.984-.493c.688-.345%201.033-.517%201.228-.783.173-.234.267-.516.269-.806.002-.33-.171-.675-.516-1.363l-3.571-7.13c-.345-.689-.518-1.033-.784-1.229a1.38%201.38%200%200%200-.806-.268c-.33-.002-.674.17-1.363.515l-.983.493c-.689.345-1.033.517-1.229.783a1.38%201.38%200%200%200-.268.806c-.002.33.17.674.515%201.363'%20stroke='%23344054'%20stroke-width='1.414'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/g%3e%3cg%20opacity='.08'%20clip-path='url(%23d)'%3e%3cpath%20d='M74.777%20533.715a4.813%204.813%200%201%201-1.74-6.362m-.29%2025.426%203.21-1.607q.629-.316%201.315-.472l3.803-.875a5.9%205.9%200%200%200%202.272-1.072l3.383-2.608a5.8%205.8%200%200%200%201.933-2.671l1.36-3.909a2.067%202.067%200%200%200-1.335-2.666%202.21%202.21%200%200%200-2.621%201.093l-1.962%203.804c-.28.546-.732.99-1.286%201.267l-2.985%201.496%201.9-.952c1.07-.537%201.516-1.815.994-2.857l-.19-.377c-.432-.865-1.416-1.316-2.383-1.093l-3.29.755a7%207%200%200%200-1.544.556c-1.186.594-2.841%202.652-2.841%202.652l-2.85%203.313m11.961-19.102a4.812%204.812%200%201%201-8.604%204.31%204.812%204.812%200%200%201%208.604-4.31m-17.14%2021.043%203.572%207.13c.345.689.517%201.033.783%201.229.234.172.516.266.806.268.33.002.675-.17%201.363-.515l.984-.493c.688-.345%201.033-.517%201.228-.783.173-.234.267-.516.269-.806.002-.33-.17-.675-.516-1.363l-3.572-7.13c-.344-.689-.517-1.033-.782-1.229a1.38%201.38%200%200%200-.807-.268c-.33-.002-.674.17-1.363.515l-.983.493c-.689.345-1.033.517-1.229.783a1.37%201.37%200%200%200-.268.806c-.002.33.17.674.515%201.363'%20stroke='%23344054'%20stroke-width='1.414'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/g%3e%3cg%20opacity='.08'%20clip-path='url(%23e)'%3e%3cpath%20d='M228.777%20682.715a4.813%204.813%200%201%201-1.74-6.362m-.289%2025.426%203.209-1.607c.418-.21.859-.368%201.314-.472l3.804-.875a5.9%205.9%200%200%200%202.272-1.072l3.383-2.608a5.8%205.8%200%200%200%201.934-2.671l1.359-3.909a2.067%202.067%200%200%200-1.335-2.666%202.21%202.21%200%200%200-2.621%201.093l-1.962%203.804c-.281.546-.732.99-1.286%201.267l-2.985%201.496%201.9-.952c1.071-.537%201.516-1.815.994-2.857l-.189-.377c-.433-.865-1.417-1.316-2.384-1.093l-3.29.755a7%207%200%200%200-1.544.556c-1.186.594-2.841%202.652-2.841%202.652l-2.85%203.313m11.961-19.102a4.812%204.812%200%201%201-8.605%204.311%204.813%204.813%200%201%201%208.605-4.311m-17.14%2021.043%203.572%207.13c.345.689.517%201.033.783%201.229.234.172.516.266.806.268.331.002.675-.17%201.363-.515l.984-.493c.688-.345%201.033-.517%201.228-.783.173-.234.267-.516.269-.806.002-.33-.171-.675-.516-1.363l-3.571-7.13c-.345-.689-.518-1.033-.784-1.229a1.38%201.38%200%200%200-.806-.268c-.33-.002-.674.17-1.363.515l-.983.493c-.689.345-1.033.517-1.229.783a1.38%201.38%200%200%200-.268.806c-.002.33.17.674.515%201.363'%20stroke='%23344054'%20stroke-width='1.414'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/g%3e%3cg%20opacity='.08'%20clip-path='url(%23f)'%3e%3cpath%20d='M231.777%20596.715a4.813%204.813%200%201%201-1.74-6.362m-.289%2025.426%203.209-1.607c.418-.21.859-.368%201.314-.472l3.804-.875a5.9%205.9%200%200%200%202.272-1.072l3.383-2.608a5.8%205.8%200%200%200%201.934-2.671l1.359-3.909a2.067%202.067%200%200%200-1.335-2.666%202.21%202.21%200%200%200-2.621%201.093l-1.962%203.804c-.281.546-.732.99-1.286%201.267l-2.985%201.496%201.9-.952c1.071-.537%201.516-1.815.994-2.857l-.189-.377c-.433-.865-1.417-1.316-2.384-1.093l-3.29.755a7%207%200%200%200-1.544.556c-1.186.594-2.841%202.652-2.841%202.652l-2.85%203.313m11.961-19.102a4.812%204.812%200%201%201-8.605%204.311%204.813%204.813%200%201%201%208.605-4.311m-17.14%2021.043%203.572%207.13c.345.689.517%201.033.783%201.229.234.172.516.266.806.268.331.002.675-.17%201.363-.515l.984-.493c.688-.345%201.033-.517%201.228-.783.173-.234.267-.516.269-.806.002-.33-.171-.675-.516-1.363l-3.571-7.13c-.345-.689-.518-1.033-.784-1.229a1.38%201.38%200%200%200-.806-.268c-.33-.002-.674.17-1.363.515l-.983.493c-.689.345-1.033.517-1.229.783a1.38%201.38%200%200%200-.268.806c-.002.33.17.674.515%201.363'%20stroke='%23344054'%20stroke-width='1.414'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/g%3e%3cg%20opacity='.08'%20clip-path='url(%23g)'%3e%3cpath%20d='M327.777%20401.715a4.813%204.813%200%201%201-1.74-6.362m-.289%2025.426%203.209-1.607c.418-.21.859-.368%201.314-.472l3.804-.875a5.9%205.9%200%200%200%202.272-1.072l3.383-2.608a5.8%205.8%200%200%200%201.934-2.671l1.359-3.909a2.067%202.067%200%200%200-1.335-2.666%202.21%202.21%200%200%200-2.621%201.093l-1.962%203.804c-.281.546-.732.99-1.286%201.267l-2.985%201.496%201.9-.952c1.071-.537%201.516-1.815.994-2.857l-.189-.377c-.433-.865-1.417-1.316-2.384-1.093l-3.29.755a7%207%200%200%200-1.544.556c-1.186.594-2.841%202.652-2.841%202.652l-2.85%203.313m11.961-19.102a4.812%204.812%200%201%201-8.605%204.311%204.813%204.813%200%201%201%208.605-4.311m-17.14%2021.043%203.572%207.13c.345.689.517%201.033.783%201.229.234.172.516.266.806.268.331.002.675-.17%201.363-.515l.984-.493c.688-.345%201.033-.517%201.228-.783.173-.234.267-.516.269-.806.002-.33-.171-.675-.516-1.363l-3.571-7.13c-.345-.689-.518-1.033-.784-1.229a1.38%201.38%200%200%200-.806-.268c-.33-.002-.674.17-1.363.515l-.983.493c-.689.345-1.033.517-1.229.783a1.38%201.38%200%200%200-.268.806c-.002.33.17.674.515%201.363'%20stroke='%23344054'%20stroke-width='1.414'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/g%3e%3cg%20opacity='.08'%20clip-path='url(%23h)'%3e%3cpath%20d='M99.777%20778.715a4.813%204.813%200%201%201-1.74-6.362m-.29%2025.426%203.21-1.607c.418-.21.859-.368%201.314-.472l3.804-.875a5.9%205.9%200%200%200%202.272-1.072l3.383-2.608a5.8%205.8%200%200%200%201.934-2.671l1.359-3.909a2.067%202.067%200%200%200-1.335-2.666%202.21%202.21%200%200%200-2.621%201.093l-1.962%203.804c-.281.546-.732.99-1.286%201.267l-2.985%201.496%201.9-.952c1.071-.537%201.516-1.815.994-2.857l-.189-.377c-.433-.865-1.417-1.316-2.384-1.093l-3.29.755a7%207%200%200%200-1.544.556c-1.186.594-2.841%202.652-2.841%202.652l-2.85%203.313m11.961-19.102a4.812%204.812%200%201%201-8.605%204.311%204.813%204.813%200%200%201%208.605-4.311m-17.14%2021.043%203.572%207.13c.345.689.517%201.033.783%201.229.234.172.516.266.806.268.33.002.675-.17%201.363-.515l.984-.493c.688-.345%201.033-.517%201.228-.783.173-.234.267-.516.269-.806.002-.33-.17-.675-.516-1.363l-3.572-7.13c-.344-.689-.517-1.033-.782-1.229a1.38%201.38%200%200%200-.807-.268c-.33-.002-.674.17-1.363.515l-.983.493c-.689.345-1.033.517-1.229.783a1.37%201.37%200%200%200-.268.806c-.002.33.17.674.515%201.363'%20stroke='%23344054'%20stroke-width='1.414'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/g%3e%3cg%20opacity='.08'%20clip-path='url(%23i)'%3e%3cpath%20d='M334.777%20499.715a4.813%204.813%200%201%201-1.74-6.362m-.289%2025.426%203.209-1.607c.418-.21.859-.368%201.314-.472l3.804-.875a5.9%205.9%200%200%200%202.272-1.072l3.383-2.608a5.8%205.8%200%200%200%201.934-2.671l1.359-3.909a2.067%202.067%200%200%200-1.335-2.666%202.21%202.21%200%200%200-2.621%201.093l-1.962%203.804c-.281.546-.732.99-1.286%201.267l-2.985%201.496%201.9-.952c1.071-.537%201.516-1.815.994-2.857l-.189-.377c-.433-.865-1.417-1.316-2.384-1.093l-3.29.755a7%207%200%200%200-1.544.556c-1.186.594-2.841%202.652-2.841%202.652l-2.85%203.313m11.961-19.102a4.812%204.812%200%201%201-8.605%204.311%204.813%204.813%200%201%201%208.605-4.311m-17.14%2021.043%203.572%207.13c.345.689.517%201.033.783%201.229.234.172.516.266.806.268.331.002.675-.17%201.363-.515l.984-.493c.688-.345%201.033-.517%201.228-.783.173-.234.267-.516.269-.806.002-.33-.171-.675-.516-1.363l-3.571-7.13c-.345-.689-.518-1.033-.784-1.229a1.38%201.38%200%200%200-.806-.268c-.33-.002-.674.17-1.363.515l-.983.493c-.689.345-1.033.517-1.229.783a1.38%201.38%200%200%200-.268.806c-.002.33.17.674.515%201.363'%20stroke='%23344054'%20stroke-width='1.414'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/g%3e%3cg%20opacity='.08'%20clip-path='url(%23j)'%3e%3cpath%20d='M363.777%20341.715a4.813%204.813%200%201%201-1.74-6.362m-.289%2025.426%203.209-1.607c.418-.21.859-.368%201.314-.472l3.804-.875a5.9%205.9%200%200%200%202.272-1.072l3.383-2.608a5.8%205.8%200%200%200%201.934-2.671l1.359-3.909a2.067%202.067%200%200%200-1.335-2.666%202.21%202.21%200%200%200-2.621%201.093l-1.962%203.804c-.281.546-.732.99-1.286%201.267l-2.985%201.496%201.9-.952c1.071-.537%201.516-1.815.994-2.857l-.189-.377c-.433-.865-1.417-1.316-2.384-1.093l-3.29.755a7%207%200%200%200-1.544.556c-1.186.594-2.841%202.652-2.841%202.652l-2.85%203.313m11.961-19.102a4.812%204.812%200%201%201-8.605%204.311%204.813%204.813%200%201%201%208.605-4.311m-17.14%2021.043%203.572%207.13c.345.689.517%201.033.783%201.229.234.172.516.266.806.268.331.002.675-.17%201.363-.515l.984-.493c.688-.345%201.033-.517%201.228-.783.173-.234.267-.516.269-.806.002-.33-.171-.675-.516-1.363l-3.571-7.13c-.345-.689-.518-1.033-.784-1.229a1.38%201.38%200%200%200-.806-.268c-.33-.002-.674.17-1.363.515l-.983.493c-.689.345-1.033.517-1.229.783a1.38%201.38%200%200%200-.268.806c-.002.33.17.674.515%201.363'%20stroke='%23344054'%20stroke-width='1.414'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/g%3e%3cg%20opacity='.08'%20clip-path='url(%23k)'%3e%3cpath%20d='M51.777%20246.715a4.813%204.813%200%201%201-1.74-6.362m-.29%2025.426%203.21-1.607a5.8%205.8%200%200%201%201.315-.472l3.803-.875a5.9%205.9%200%200%200%202.272-1.072l3.383-2.608a5.8%205.8%200%200%200%201.934-2.671l1.36-3.909a2.067%202.067%200%200%200-1.336-2.666%202.21%202.21%200%200%200-2.622%201.093l-1.961%203.804c-.28.546-.732.99-1.286%201.267l-2.985%201.496%201.9-.952c1.07-.537%201.516-1.815.994-2.857l-.19-.377c-.432-.865-1.416-1.316-2.383-1.093l-3.29.755a7%207%200%200%200-1.544.556c-1.186.594-2.841%202.652-2.841%202.652l-2.85%203.313m11.961-19.102a4.812%204.812%200%201%201-8.604%204.31%204.812%204.812%200%200%201%208.604-4.31m-17.14%2021.043%203.572%207.13c.345.689.517%201.033.783%201.229.234.172.516.266.806.268.33.002.675-.17%201.363-.515l.984-.493c.688-.345%201.033-.517%201.228-.783.173-.234.267-.516.269-.806.002-.33-.17-.675-.516-1.363l-3.572-7.13c-.344-.689-.517-1.033-.782-1.229a1.38%201.38%200%200%200-.807-.268c-.33-.002-.674.17-1.363.515l-.983.493c-.689.345-1.033.517-1.229.783a1.37%201.37%200%200%200-.268.806c-.002.33.17.674.515%201.363'%20stroke='%23344054'%20stroke-width='1.414'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/g%3e%3cg%20opacity='.08'%20clip-path='url(%23l)'%3e%3cpath%20d='M345.777%20834.715a4.813%204.813%200%201%201-1.74-6.362m-.289%2025.426%203.209-1.607c.418-.21.859-.368%201.314-.472l3.804-.875a5.9%205.9%200%200%200%202.272-1.072l3.383-2.608a5.8%205.8%200%200%200%201.934-2.671l1.359-3.909a2.067%202.067%200%200%200-1.335-2.666%202.21%202.21%200%200%200-2.621%201.093l-1.962%203.804c-.281.546-.732.99-1.286%201.267l-2.985%201.496%201.9-.952c1.071-.537%201.516-1.815.994-2.857l-.189-.377c-.433-.865-1.417-1.316-2.384-1.093l-3.29.755a7%207%200%200%200-1.544.556c-1.186.594-2.841%202.652-2.841%202.652l-2.85%203.313m11.961-19.102a4.812%204.812%200%201%201-8.605%204.311%204.813%204.813%200%201%201%208.605-4.311m-17.14%2021.043%203.572%207.13c.345.689.517%201.033.783%201.229.234.172.516.266.806.268.331.002.675-.17%201.363-.515l.984-.493c.688-.345%201.033-.517%201.228-.783.173-.234.267-.516.269-.806.002-.33-.171-.675-.516-1.363l-3.571-7.13c-.345-.689-.518-1.033-.784-1.229a1.38%201.38%200%200%200-.806-.268c-.33-.002-.674.17-1.363.515l-.983.493c-.689.345-1.033.517-1.229.783a1.38%201.38%200%200%200-.268.806c-.002.33.17.674.515%201.363'%20stroke='%23344054'%20stroke-width='1.414'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/g%3e%3cg%20opacity='.08'%20clip-path='url(%23m)'%3e%3cpath%20d='m244.572%20549.353-.833-2.621a5.5%205.5%200%200%200-5.544-3.829m-9.512-14.053a5.5%205.5%200%200%201%203.087%209.722m6.249%2012.862c-.776-2.443-1.163-3.664-1.868-4.501a5.5%205.5%200%200%200-3.738-1.936c-1.09-.093-2.312.295-4.754%201.071l-3.932%201.248c-2.442.776-3.663%201.164-4.5%201.869a5.5%205.5%200%200%200-1.936%203.738c-.093%201.09.295%202.311%201.071%204.753m9.244-23.133a5.5%205.5%200%201%201-10.486%203.328%205.5%205.5%200%200%201%2010.486-3.328'%20stroke='%23344054'%20stroke-width='1.414'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/g%3e%3cg%20opacity='.08'%20clip-path='url(%23n)'%3e%3cpath%20d='m72.044%20441.803%201.26-2.444a5.5%205.5%200%200%200-1.222-6.625m3.186-16.668a5.5%205.5%200%200%201-4.678%209.064m-4.656%2013.52c1.175-2.277%201.763-3.416%201.854-4.506a5.5%205.5%200%200%200-1.28-4.01c-.706-.836-1.844-1.423-4.122-2.598l-3.666-1.892c-2.277-1.175-3.415-1.763-4.506-1.855a5.5%205.5%200%200%200-4.01%201.281c-.835.706-1.423%201.844-2.598%204.122m22.88-9.855a5.5%205.5%200%201%201-9.776-5.046%205.5%205.5%200%200%201%209.776%205.046'%20stroke='%23344054'%20stroke-width='1.414'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/g%3e%3cg%20opacity='.08'%20clip-path='url(%23o)'%3e%3cpath%20d='m296.638%20198.584.868-2.609a5.5%205.5%200%200%200-2.231-6.357m.574-16.96a5.501%205.501%200%200%201-3.222%209.678m-2.512%2014.077c.809-2.432%201.214-3.648%201.136-4.739a5.5%205.5%200%200%200-1.884-3.764c-.827-.717-2.043-1.121-4.474-1.931l-3.914-1.303c-2.431-.809-3.647-1.214-4.738-1.136a5.5%205.5%200%200%200-3.765%201.884c-.716.827-1.121%202.042-1.93%204.474m21.083-13.27a5.5%205.5%200%201%201-10.437-3.475%205.5%205.5%200%200%201%2010.437%203.475'%20stroke='%23344054'%20stroke-width='1.414'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/g%3e%3cg%20opacity='.08'%20clip-path='url(%23p)'%3e%3cpath%20d='m351.335%20101.689%201.22-2.465a5.504%205.504%200%200%200-1.335-6.603m2.903-16.72a5.5%205.5%200%200%201-4.523%209.142m-4.427%2013.597c1.137-2.297%201.705-3.445%201.778-4.537a5.5%205.5%200%200%200-1.348-3.987c-.72-.824-1.869-1.392-4.166-2.529l-3.697-1.83c-2.297-1.136-3.445-1.704-4.537-1.777a5.5%205.5%200%200%200-3.988%201.348c-.823.72-1.391%201.869-2.528%204.166m22.71-10.242a5.5%205.5%200%201%201-9.86-4.88%205.5%205.5%200%200%201%209.86%204.88'%20stroke='%23344054'%20stroke-width='1.414'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/g%3e%3cg%20opacity='.08'%20clip-path='url(%23q)'%3e%3cpath%20d='m212.25%2091.924.737-2.65a5.504%205.504%200%200%200-2.548-6.237m-.276-16.968a5.503%205.503%200%200%201-2.733%209.828m-1.804%2014.185c.687-2.47%201.03-3.704.897-4.79a5.5%205.5%200%200%200-2.07-3.665c-.862-.674-2.096-1.017-4.565-1.704l-3.974-1.105c-2.469-.686-3.704-1.03-4.79-.897a5.5%205.5%200%200%200-3.665%202.07c-.674.862-1.017%202.096-1.704%204.565m20.392-14.31a5.5%205.5%200%201%201-10.599-2.948%205.5%205.5%200%200%201%2010.599%202.948'%20stroke='%23344054'%20stroke-width='1.414'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/g%3e%3cg%20opacity='.08'%20clip-path='url(%23r)'%3e%3cpath%20d='m108.862%20179.145-1.209-2.47a5.5%205.5%200%200%200-6.046-2.971m-11.475-12.503a5.501%205.501%200%200%201%204.483%209.163m8.071%2011.803c-1.126-2.302-1.689-3.453-2.51-4.177a5.5%205.5%200%200%200-3.981-1.365c-1.092.068-2.243.631-4.545%201.758l-3.705%201.813c-2.302%201.126-3.453%201.689-4.177%202.509a5.5%205.5%200%200%200-1.366%203.982c.069%201.092.632%202.243%201.758%204.545m5.743-24.241a5.5%205.5%200%201%201-9.88%204.835%205.5%205.5%200%200%201%209.88-4.835'%20stroke='%23344054'%20stroke-width='1.414'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/g%3e%3cg%20opacity='.08'%20clip-path='url(%23s)'%3e%3cpath%20d='m155.862%20242.145-1.209-2.47a5.5%205.5%200%200%200-6.046-2.971m-11.475-12.503a5.501%205.501%200%200%201%204.483%209.163m8.071%2011.803c-1.126-2.302-1.689-3.453-2.51-4.177a5.5%205.5%200%200%200-3.981-1.365c-1.092.068-2.243.631-4.545%201.758l-3.705%201.813c-2.302%201.126-3.453%201.689-4.177%202.509a5.5%205.5%200%200%200-1.366%203.982c.069%201.092.632%202.243%201.758%204.545m5.743-24.241a5.5%205.5%200%201%201-9.882%204.835%205.5%205.5%200%200%201%209.882-4.835'%20stroke='%23344054'%20stroke-width='1.414'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/g%3e%3cg%20opacity='.08'%20clip-path='url(%23t)'%3e%3cpath%20d='m169.158%20704.34%201.1-2.521a5.5%205.5%200%200%200-1.652-6.531m2.094-16.841a5.503%205.503%200%200%201-4.078%209.35m-3.766%2013.795c1.025-2.349%201.537-3.524%201.557-4.617a5.5%205.5%200%200%200-1.538-3.919c-.759-.788-1.934-1.3-4.283-2.324l-3.781-1.649c-2.349-1.025-3.523-1.537-4.617-1.557a5.5%205.5%200%200%200-3.919%201.538c-.787.76-1.3%201.934-2.324%204.283m22.189-11.324a5.5%205.5%200%201%201-10.083-4.397%205.5%205.5%200%200%201%2010.083%204.397'%20stroke='%23344054'%20stroke-width='1.414'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/g%3e%3cg%20opacity='.08'%20clip-path='url(%23u)'%3e%3cpath%20d='m65.679%20875.093%201.02-2.554c.95-2.38.122-5.03-1.855-6.477m1.569-16.897a5.5%205.5%200%200%201-3.785%209.472m-3.334%2013.905c.95-2.38%201.426-3.569%201.413-4.663a5.5%205.5%200%200%200-1.66-3.869c-.784-.764-1.973-1.239-4.353-2.19l-3.83-1.53c-2.38-.951-3.57-1.426-4.665-1.412a5.5%205.5%200%200%200-3.868%201.659c-.764.784-1.24%201.974-2.19%204.353m21.826-12.009a5.5%205.5%200%201%201-10.216-4.083%205.5%205.5%200%200%201%2010.216%204.083'%20stroke='%23344054'%20stroke-width='1.414'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/g%3e%3cpath%20d='M194.25%20868.875v-2.75a5.5%205.5%200%200%200-4.125-5.327m-4.812-16.273a5.502%205.502%200%200%201%200%2010.2m2.062%2014.15c0-2.563%200-3.844-.419-4.855a5.5%205.5%200%200%200-2.976-2.976c-1.011-.419-2.292-.419-4.855-.419H175c-2.563%200-3.844%200-4.855.419a5.5%205.5%200%200%200-2.976%202.976c-.419%201.011-.419%202.292-.419%204.855m15.813-19.25a5.5%205.5%200%201%201-11%200%205.5%205.5%200%200%201%2011%200m121.687-58.75v-2.75a5.5%205.5%200%200%200-4.125-5.327m-4.812-16.273a5.502%205.502%200%200%201%200%2010.2m2.062%2014.15c0-2.563%200-3.844-.419-4.855a5.5%205.5%200%200%200-2.976-2.976c-1.011-.419-2.292-.419-4.855-.419H285c-2.563%200-3.844%200-4.855.419a5.5%205.5%200%200%200-2.976%202.976c-.419%201.011-.419%202.292-.419%204.855m15.813-19.25a5.5%205.5%200%201%201-11%200%205.5%205.5%200%200%201%2011%200m50.687-105.75v-2.75a5.5%205.5%200%200%200-4.125-5.327m-4.812-16.273a5.502%205.502%200%200%201%200%2010.2m2.062%2014.15c0-2.563%200-3.844-.419-4.855a5.5%205.5%200%200%200-2.976-2.976c-1.011-.419-2.292-.419-4.855-.419H324c-2.563%200-3.844%200-4.855.419a5.5%205.5%200%200%200-2.976%202.976c-.419%201.011-.419%202.292-.419%204.855m15.813-19.25a5.5%205.5%200%201%201-11%200%205.5%205.5%200%200%201%2011%200'%20stroke='%23344054'%20stroke-width='1.414'%20stroke-linecap='round'%20stroke-linejoin='round'%20opacity='.08'/%3e%3cg%20opacity='.08'%20clip-path='url(%23v)'%3e%3cpath%20d='m160.233%20603.826%201.141-2.502a5.5%205.5%200%200%200-1.542-6.559m2.376-16.803a5.5%205.5%200%200%201-4.233%209.281m-3.997%2013.729c1.064-2.331%201.596-3.497%201.634-4.591a5.5%205.5%200%200%200-1.472-3.943c-.746-.801-1.912-1.332-4.243-2.396l-3.753-1.712c-2.332-1.064-3.498-1.596-4.591-1.634a5.5%205.5%200%200%200-3.943%201.472c-.801.746-1.333%201.912-2.396%204.243m22.376-10.95a5.5%205.5%200%201%201-10.008-4.565%205.5%205.5%200%200%201%2010.008%204.565'%20stroke='%23344054'%20stroke-width='1.414'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/g%3e%3cg%20opacity='.08'%20clip-path='url(%23w)'%3e%3cpath%20d='m81.34%20664.632%201.11-2.516a5.5%205.5%200%200%200-1.622-6.539m2.169-16.831a5.502%205.502%200%200%201-4.119%209.332m-3.827%2013.777c1.035-2.344%201.552-3.516%201.577-4.61a5.5%205.5%200%200%200-1.52-3.925c-.756-.791-1.929-1.309-4.273-2.344l-3.774-1.665c-2.344-1.035-3.516-1.553-4.61-1.578a5.5%205.5%200%200%200-3.925%201.521c-.791.756-1.309%201.928-2.344%204.273m22.24-11.226a5.5%205.5%200%201%201-10.064-4.443%205.5%205.5%200%200%201%2010.064%204.443'%20stroke='%23344054'%20stroke-width='1.414'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/g%3e%3cg%20opacity='.08'%20clip-path='url(%23x)'%3e%3cpath%20d='m341.171%20244.135-.012-.248c-.088-1.719-.132-2.579-.409-3.348a5.5%205.5%200%200%200-1.109-1.839c-.55-.604-1.29-1.044-2.77-1.925l-1.624-.967c-1.323-.788-1.985-1.182-2.337-1.74a2.75%202.75%200%200%201-.418-1.648c.043-.658.437-1.32%201.225-2.644l6.048-10.161c.788-1.323%201.182-1.985%201.74-2.337a2.75%202.75%200%200%201%201.648-.418c.658.043%201.32.437%202.643%201.225l.473.281c2.647%201.576%203.97%202.364%204.675%203.481.619.982.912%202.135.836%203.294-.087%201.318-.875%202.641-2.45%205.288m-8.159%2013.706%208.159-13.706m-8.159%2013.706.224-.107c1.554-.743%202.331-1.114%203.138-1.237a5.5%205.5%200%200%201%202.146.098c.793.196%201.533.636%203.012%201.517l1.625.967c1.323.788%201.985%201.181%202.644%201.225a2.75%202.75%200%200%200%201.647-.418c.558-.352.952-1.014%201.74-2.338l6.049-10.161c.787-1.323%201.181-1.985%201.224-2.644a2.75%202.75%200%200%200-.417-1.647c-.353-.558-1.014-.952-2.338-1.74l-.472-.281c-2.647-1.576-3.971-2.364-5.288-2.45a5.5%205.5%200%200%200-3.295.836c-1.117.704-1.905%202.027-3.48%204.674'%20stroke='%23344054'%20stroke-width='1.414'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/g%3e%3cg%20opacity='.08'%20clip-path='url(%23y)'%3e%3cpath%20d='m191.289%20329.252-.013-.248c-.088-1.719-.132-2.579-.409-3.347a5.5%205.5%200%200%200-1.109-1.84c-.55-.604-1.29-1.044-2.769-1.925l-1.625-.967c-1.323-.788-1.985-1.182-2.337-1.74a2.75%202.75%200%200%201-.418-1.647c.043-.659.437-1.321%201.225-2.644l6.048-10.161c.788-1.324%201.182-1.986%201.74-2.338a2.75%202.75%200%200%201%201.648-.418c.659.044%201.32.437%202.644%201.225l.472.282c2.647%201.575%203.971%202.363%204.675%203.48.619.982.912%202.136.836%203.295-.087%201.317-.875%202.641-2.45%205.287m-8.158%2013.706%208.158-13.706m-8.158%2013.706.223-.107c1.554-.742%202.331-1.114%203.138-1.237a5.5%205.5%200%200%201%202.146.098c.793.196%201.533.636%203.012%201.517l1.625.967c1.323.788%201.985%201.182%202.644%201.225a2.75%202.75%200%200%200%201.647-.418c.559-.352.953-1.014%201.74-2.337l6.049-10.161c.787-1.324%201.181-1.986%201.225-2.644a2.76%202.76%200%200%200-.418-1.648c-.352-.558-1.014-.952-2.338-1.74l-.472-.281c-2.647-1.576-3.971-2.364-5.288-2.45a5.5%205.5%200%200%200-3.295.836c-1.117.704-1.905%202.028-3.48%204.674'%20stroke='%23344054'%20stroke-width='1.414'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/g%3e%3cg%20opacity='.08'%20clip-path='url(%23z)'%3e%3cpath%20d='m339.289%20157.252-.013-.248c-.088-1.719-.132-2.579-.409-3.347a5.5%205.5%200%200%200-1.109-1.84c-.55-.604-1.29-1.044-2.769-1.925l-1.625-.967c-1.323-.788-1.985-1.182-2.337-1.74a2.75%202.75%200%200%201-.418-1.647c.043-.659.437-1.321%201.225-2.644l6.048-10.161c.788-1.324%201.182-1.986%201.74-2.338a2.75%202.75%200%200%201%201.648-.418c.659.044%201.32.437%202.644%201.225l.472.282c2.647%201.575%203.971%202.363%204.675%203.48.619.982.912%202.136.836%203.295-.087%201.317-.875%202.641-2.45%205.287m-8.158%2013.706%208.158-13.706m-8.158%2013.706.223-.107c1.554-.742%202.331-1.114%203.138-1.237a5.5%205.5%200%200%201%202.146.098c.793.196%201.533.636%203.012%201.517l1.625.967c1.323.788%201.985%201.182%202.644%201.225a2.75%202.75%200%200%200%201.647-.418c.559-.352.953-1.014%201.74-2.337l6.049-10.161c.787-1.324%201.181-1.986%201.225-2.644a2.76%202.76%200%200%200-.418-1.648c-.352-.558-1.014-.952-2.338-1.74l-.472-.281c-2.647-1.576-3.971-2.364-5.288-2.45a5.5%205.5%200%200%200-3.295.836c-1.117.704-1.905%202.028-3.48%204.674'%20stroke='%23344054'%20stroke-width='1.414'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/g%3e%3cg%20opacity='.08'%20clip-path='url(%23A)'%3e%3cpath%20d='m147.398%20130.253-.22-.114c-1.528-.793-2.293-1.189-3.096-1.338a5.5%205.5%200%200%200-2.148.027c-.799.17-1.552.586-3.06%201.418l-1.655.913c-1.349.745-2.023%201.117-2.683%201.138a2.74%202.74%200%200%201-1.632-.471c-.547-.37-.919-1.045-1.663-2.393l-5.714-10.353c-.744-1.349-1.116-2.023-1.138-2.683a2.75%202.75%200%200%201%20.472-1.633c.37-.546%201.044-.918%202.393-1.662l.481-.266c2.697-1.488%204.046-2.233%205.365-2.276a5.5%205.5%200%200%201%203.266.943c1.093.74%201.837%202.089%203.326%204.786m7.706%2013.964-7.706-13.964m7.706%2013.964.021-.247c.144-1.716.216-2.573.518-3.332a5.5%205.5%200%200%201%201.168-1.803c.57-.585%201.324-1.001%202.831-1.833l1.655-.914c1.349-.744%202.023-1.116%202.393-1.663.326-.48.491-1.052.472-1.632-.022-.66-.394-1.334-1.138-2.683l-5.714-10.353c-.744-1.349-1.116-2.023-1.662-2.393a2.75%202.75%200%200%200-1.633-.472c-.66.022-1.334.394-2.683%201.138l-.481.266c-2.697%201.489-4.046%202.233-4.786%203.326a5.5%205.5%200%200%200-.943%203.266c.043%201.319.787%202.668%202.276%205.365'%20stroke='%23344054'%20stroke-width='1.414'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/g%3e%3cg%20opacity='.08'%20clip-path='url(%23B)'%3e%3cpath%20d='m300.398%20602.253-.22-.114c-1.528-.793-2.293-1.189-3.096-1.338a5.5%205.5%200%200%200-2.148.027c-.799.17-1.552.586-3.06%201.418l-1.655.913c-1.349.745-2.023%201.117-2.683%201.138a2.74%202.74%200%200%201-1.632-.471c-.547-.37-.919-1.045-1.663-2.393l-5.714-10.353c-.744-1.349-1.116-2.023-1.138-2.683a2.75%202.75%200%200%201%20.472-1.633c.37-.546%201.044-.918%202.393-1.662l.481-.266c2.697-1.488%204.046-2.233%205.365-2.276a5.5%205.5%200%200%201%203.266.943c1.093.74%201.837%202.089%203.326%204.786m7.706%2013.964-7.706-13.964m7.706%2013.964.021-.247c.144-1.716.216-2.573.518-3.332a5.5%205.5%200%200%201%201.168-1.803c.57-.585%201.324-1.001%202.831-1.833l1.655-.914c1.349-.744%202.023-1.116%202.393-1.663.326-.48.491-1.052.472-1.632-.022-.66-.394-1.334-1.138-2.683l-5.714-10.353c-.744-1.349-1.116-2.023-1.662-2.393a2.75%202.75%200%200%200-1.633-.472c-.66.022-1.334.394-2.683%201.138l-.481.266c-2.697%201.489-4.046%202.233-4.786%203.326a5.5%205.5%200%200%200-.943%203.266c.043%201.319.787%202.668%202.276%205.365'%20stroke='%23344054'%20stroke-width='1.414'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/g%3e%3cg%20opacity='.08'%20clip-path='url(%23C)'%3e%3cpath%20d='m355.398%20755.253-.22-.114c-1.528-.793-2.293-1.189-3.096-1.338a5.5%205.5%200%200%200-2.148.027c-.799.17-1.552.586-3.06%201.418l-1.655.913c-1.349.745-2.023%201.117-2.683%201.138a2.74%202.74%200%200%201-1.632-.471c-.547-.37-.919-1.045-1.663-2.393l-5.714-10.353c-.744-1.349-1.116-2.023-1.138-2.683a2.75%202.75%200%200%201%20.472-1.633c.37-.546%201.044-.918%202.393-1.662l.481-.266c2.697-1.488%204.046-2.233%205.365-2.276a5.5%205.5%200%200%201%203.266.943c1.093.74%201.837%202.089%203.326%204.786m7.706%2013.964-7.706-13.964m7.706%2013.964.021-.247c.144-1.716.216-2.573.518-3.332a5.5%205.5%200%200%201%201.168-1.803c.57-.585%201.324-1.001%202.831-1.833l1.655-.914c1.349-.744%202.023-1.116%202.393-1.663.326-.48.491-1.052.472-1.632-.022-.66-.394-1.334-1.138-2.683l-5.714-10.353c-.744-1.349-1.116-2.023-1.662-2.393a2.75%202.75%200%200%200-1.633-.472c-.66.022-1.334.394-2.683%201.138l-.481.266c-2.697%201.489-4.046%202.233-4.786%203.326a5.5%205.5%200%200%200-.943%203.266c.043%201.319.787%202.668%202.276%205.365'%20stroke='%23344054'%20stroke-width='1.414'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/g%3e%3cg%20opacity='.08'%20clip-path='url(%23D)'%3e%3cpath%20d='m53.448%20746.887.028-.247c.192-1.711.288-2.566.14-3.37a5.5%205.5%200%200%200-.797-1.995c-.445-.685-1.104-1.239-2.421-2.348l-1.446-1.217c-1.179-.992-1.768-1.488-2.025-2.096a2.75%202.75%200%200%201-.145-1.693c.15-.643.645-1.233%201.637-2.411l7.615-9.047c.992-1.178%201.487-1.767%202.096-2.024a2.75%202.75%200%200%201%201.693-.146c.643.15%201.232.646%202.41%201.638l.421.354c2.357%201.983%203.535%202.975%204.05%204.191a5.5%205.5%200%200%201%20.29%203.387c-.299%201.286-1.29%202.465-3.274%204.821m-10.272%2012.203%2010.272-12.203m-10.272%2012.203.239-.07c1.653-.481%202.48-.721%203.296-.711a5.5%205.5%200%200%201%202.102.444c.75.321%201.41.876%202.727%201.985l1.446%201.217c1.178.992%201.767%201.488%202.41%201.637a2.75%202.75%200%200%200%201.694-.145c.608-.257%201.104-.846%202.096-2.025l7.615-9.046c.992-1.179%201.487-1.768%201.637-2.411a2.75%202.75%200%200%200-.146-1.693c-.257-.608-.846-1.104-2.024-2.096l-.42-.354c-2.358-1.984-3.536-2.976-4.822-3.275a5.5%205.5%200%200%200-3.387.291c-1.216.514-2.208%201.693-4.191%204.049'%20stroke='%23344054'%20stroke-width='1.414'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/g%3e%3cg%20opacity='.08'%20clip-path='url(%23E)'%3e%3cpath%20d='m66.279%20345.717.027-.247c.192-1.711.288-2.566.14-3.369a5.5%205.5%200%200%200-.797-1.996c-.445-.684-1.104-1.239-2.421-2.348l-1.446-1.217c-1.179-.992-1.768-1.488-2.025-2.096a2.75%202.75%200%200%201-.145-1.693c.15-.643.645-1.232%201.637-2.411l7.615-9.047c.992-1.178%201.487-1.767%202.096-2.024a2.76%202.76%200%200%201%201.693-.146c.643.15%201.232.646%202.41%201.638l.421.354c2.357%201.983%203.535%202.975%204.05%204.192a5.5%205.5%200%200%201%20.29%203.386c-.299%201.286-1.29%202.465-3.274%204.821m-10.272%2012.203%2010.272-12.203m-10.272%2012.203.239-.069c1.653-.481%202.48-.722%203.296-.712a5.5%205.5%200%200%201%202.102.444c.75.322%201.41.876%202.727%201.985l1.446%201.217c1.178.992%201.768%201.488%202.41%201.637a2.75%202.75%200%200%200%201.694-.145c.608-.257%201.104-.846%202.096-2.025l7.615-9.046c.992-1.179%201.487-1.768%201.637-2.411a2.75%202.75%200%200%200-.146-1.693c-.257-.608-.846-1.104-2.024-2.096l-.42-.354c-2.357-1.984-3.536-2.976-4.822-3.275a5.5%205.5%200%200%200-3.386.291c-1.217.514-2.209%201.693-4.192%204.049'%20stroke='%23344054'%20stroke-width='1.414'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/g%3e%3cg%20opacity='.08'%20clip-path='url(%23F)'%3e%3cpath%20d='m122.279%20498.717.027-.247c.192-1.711.288-2.566.139-3.369a5.5%205.5%200%200%200-.796-1.996c-.445-.684-1.104-1.239-2.421-2.348l-1.446-1.217c-1.179-.992-1.768-1.488-2.025-2.096a2.75%202.75%200%200%201-.145-1.693c.149-.643.645-1.232%201.637-2.411l7.615-9.047c.992-1.178%201.488-1.767%202.096-2.024a2.75%202.75%200%200%201%201.693-.146c.643.15%201.232.646%202.41%201.638l.421.354c2.357%201.983%203.535%202.975%204.049%204.192a5.5%205.5%200%200%201%20.291%203.386c-.299%201.286-1.291%202.465-3.274%204.821m-10.271%2012.203%2010.271-12.203m-10.271%2012.203.238-.069c1.653-.481%202.48-.722%203.296-.712a5.5%205.5%200%200%201%202.102.444c.751.322%201.41.876%202.727%201.985l1.446%201.217c1.178.992%201.768%201.488%202.411%201.637a2.75%202.75%200%200%200%201.693-.145c.608-.257%201.104-.846%202.096-2.025l7.615-9.046c.992-1.179%201.487-1.768%201.637-2.411a2.75%202.75%200%200%200-.146-1.693c-.257-.608-.846-1.104-2.024-2.096l-.421-.354c-2.356-1.984-3.535-2.976-4.821-3.275a5.5%205.5%200%200%200-3.387.291c-1.216.514-2.208%201.693-4.191%204.049'%20stroke='%23344054'%20stroke-width='1.414'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/g%3e%3cg%20opacity='.08'%20clip-path='url(%23G)'%3e%3cpath%20d='m186.909%20791.551-.114-.22c-.794-1.528-1.192-2.291-1.763-2.875a5.5%205.5%200%200%200-1.773-1.213c-.751-.321-1.607-.414-3.319-.6l-1.879-.205c-1.531-.167-2.297-.25-2.849-.612a2.76%202.76%200%200%201-1.065-1.324c-.234-.618-.15-1.383.016-2.914l1.281-11.756c.166-1.531.25-2.296.611-2.849a2.75%202.75%200%200%201%201.325-1.064c.617-.235%201.383-.151%202.914.015l.547.06c3.062.333%204.593.5%205.698%201.223a5.5%205.5%200%200%201%202.129%202.65c.469%201.235.302%202.766-.032%205.828m-1.727%2015.856%201.727-15.856m-1.727%2015.856.16-.19c1.104-1.321%201.657-1.981%202.34-2.429a5.5%205.5%200%200%201%201.993-.802c.802-.152%201.658-.058%203.37.128l1.879.205c1.531.166%202.297.25%202.914.016a2.75%202.75%200%200%200%201.325-1.065c.362-.552.445-1.318.612-2.849l1.28-11.756c.167-1.531.25-2.296.016-2.913a2.75%202.75%200%200%200-1.065-1.325c-.552-.362-1.318-.445-2.849-.612l-.547-.06c-3.062-.333-4.593-.5-5.827-.031a5.5%205.5%200%200%200-2.65%202.129c-.723%201.105-.89%202.636-1.224%205.698'%20stroke='%23344054'%20stroke-width='1.414'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='a'%3e%3cpath%20fill='%23fff'%20d='M33%2074.78%2062.503%2060l14.78%2029.504-29.505%2014.78z'/%3e%3c/clipPath%3e%3cclipPath%20id='b'%3e%3cpath%20fill='%23fff'%20d='m175.998%20168.779%2029.505-14.78%2014.78%2029.505-29.505%2014.78z'/%3e%3c/clipPath%3e%3cclipPath%20id='c'%3e%3cpath%20fill='%23fff'%20d='m255.998%20273.778%2029.505-14.78%2014.78%2029.505-29.505%2014.78z'/%3e%3c/clipPath%3e%3cclipPath%20id='d'%3e%3cpath%20fill='%23fff'%20d='m52.999%20531.776%2029.505-14.78%2014.78%2029.505-29.505%2014.78z'/%3e%3c/clipPath%3e%3cclipPath%20id='e'%3e%3cpath%20fill='%23fff'%20d='m206.997%20680.775%2029.505-14.78%2014.78%2029.505-29.505%2014.78z'/%3e%3c/clipPath%3e%3cclipPath%20id='f'%3e%3cpath%20fill='%23fff'%20d='m209.998%20594.776%2029.505-14.78%2014.78%2029.505-29.505%2014.78z'/%3e%3c/clipPath%3e%3cclipPath%20id='g'%3e%3cpath%20fill='%23fff'%20d='m305.997%20399.778%2029.505-14.78%2014.78%2029.504-29.505%2014.78z'/%3e%3c/clipPath%3e%3cclipPath%20id='h'%3e%3cpath%20fill='%23fff'%20d='m77.998%20776.774%2029.505-14.78%2014.78%2029.505-29.505%2014.78z'/%3e%3c/clipPath%3e%3cclipPath%20id='i'%3e%3cpath%20fill='%23fff'%20d='m312.997%20497.777%2029.505-14.78%2014.78%2029.505-29.505%2014.78z'/%3e%3c/clipPath%3e%3cclipPath%20id='j'%3e%3cpath%20fill='%23fff'%20d='m341.997%20339.778%2029.505-14.78%2014.78%2029.505-29.505%2014.78z'/%3e%3c/clipPath%3e%3cclipPath%20id='k'%3e%3cpath%20fill='%23fff'%20d='m30%20244.778%2029.504-14.78%2014.78%2029.505-29.505%2014.78z'/%3e%3c/clipPath%3e%3cclipPath%20id='l'%3e%3cpath%20fill='%23fff'%20d='m323.996%20832.774%2029.505-14.78%2014.78%2029.505-29.504%2014.78z'/%3e%3c/clipPath%3e%3cclipPath%20id='m'%3e%3cpath%20fill='%23fff'%20d='m207.002%20530.992%2031.452-9.989%209.988%2031.452-31.452%209.989z'/%3e%3c/clipPath%3e%3cclipPath%20id='n'%3e%3cpath%20fill='%23fff'%20d='m58.404%20402.277%2029.325%2015.134-15.134%2029.325-29.325-15.134z'/%3e%3c/clipPath%3e%3cclipPath%20id='o'%3e%3cpath%20fill='%23fff'%20d='m277.054%20161.63%2031.31%2010.424-10.423%2031.31-31.31-10.423z'/%3e%3c/clipPath%3e%3cclipPath%20id='p'%3e%3cpath%20fill='%23fff'%20d='m337.032%2062.396%2029.577%2014.634-14.634%2029.578-29.578-14.635z'/%3e%3c/clipPath%3e%3cclipPath%20id='q'%3e%3cpath%20fill='%23fff'%20d='m190.844%2056.001%2031.794%208.841-8.841%2031.794-31.794-8.841z'/%3e%3c/clipPath%3e%3cclipPath%20id='r'%3e%3cpath%20fill='%23fff'%20d='m68.998%20166.502%2029.642-14.504%2014.504%2029.642-29.642%2014.504z'/%3e%3c/clipPath%3e%3cclipPath%20id='s'%3e%3cpath%20fill='%23fff'%20d='m115.997%20229.501%2029.642-14.503%2014.504%2029.642-29.642%2014.503z'/%3e%3c/clipPath%3e%3cclipPath%20id='t'%3e%3cpath%20fill='%23fff'%20d='m152.973%20665.768%2030.248%2013.192-13.191%2030.248-30.249-13.191z'/%3e%3c/clipPath%3e%3cclipPath%20id='u'%3e%3cpath%20fill='%23fff'%20d='m48.299%20837.056%2030.645%2012.243L66.7%20879.944%2036.056%20867.7z'/%3e%3c/clipPath%3e%3cclipPath%20id='v'%3e%3cpath%20fill='%23fff'%20d='M144.697%20565.002%20174.72%20578.7l-13.697%2030.024L131%20595.026z'/%3e%3c/clipPath%3e%3cclipPath%20id='w'%3e%3cpath%20fill='%23fff'%20d='m65.326%20626.002%2030.19%2013.326-13.326%2030.19L52%20656.192z'/%3e%3c/clipPath%3e%3cclipPath%20id='x'%3e%3cpath%20fill='%23fff'%20d='m341.76%20210.881%2028.357%2016.88-16.88%2028.356-28.356-16.88z'/%3e%3c/clipPath%3e%3cclipPath%20id='y'%3e%3cpath%20fill='%23fff'%20d='m191.879%20295.998%2028.356%2016.879-16.879%2028.357-28.357-16.88z'/%3e%3c/clipPath%3e%3cclipPath%20id='z'%3e%3cpath%20fill='%23fff'%20d='m339.877%20123.999%2028.356%2016.879-16.879%2028.356-28.356-16.879z'/%3e%3c/clipPath%3e%3cclipPath%20id='A'%3e%3cpath%20fill='%23fff'%20d='m119%20112.944%2028.892-15.945%2015.944%2028.893-28.892%2015.944z'/%3e%3c/clipPath%3e%3cclipPath%20id='B'%3e%3cpath%20fill='%23fff'%20d='m271.998%20584.942%2028.893-15.944%2015.944%2028.892-28.892%2015.945z'/%3e%3c/clipPath%3e%3cclipPath%20id='C'%3e%3cpath%20fill='%23fff'%20d='m326.998%20737.942%2028.893-15.944%2015.944%2028.892-28.893%2015.944z'/%3e%3c/clipPath%3e%3cclipPath%20id='D'%3e%3cpath%20fill='%23fff'%20d='m59.422%20714.163%2025.247%2021.25-21.251%2025.248-25.247-21.251z'/%3e%3c/clipPath%3e%3cclipPath%20id='E'%3e%3cpath%20fill='%23fff'%20d='m72.25%20312.997%2025.247%2021.25-21.25%2025.247L51%20338.244z'/%3e%3c/clipPath%3e%3cclipPath%20id='F'%3e%3cpath%20fill='%23fff'%20d='m128.25%20465.995%2025.247%2021.25-21.25%2025.248L107%20491.242z'/%3e%3c/clipPath%3e%3cclipPath%20id='G'%3e%3cpath%20fill='%23fff'%20d='m173.623%20761.004%2032.806%203.573-3.572%2032.806-32.806-3.573z'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e";
const KollabLogo = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='124'%20height='123'%20viewBox='0%200%20124%20123'%20fill='none'%3e%3crect%20x='0.317139'%20width='123'%20height='123'%20rx='25.1591'%20fill='white'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M50.2786%2057.9084C50.2786%2060.0182%2051.1167%2062.0415%2052.6084%2063.5332L85.0975%20103.081C88.2039%20106.188%2093.2405%20106.188%2096.3469%20103.081C99.4534%2099.9745%2099.4534%2094.9388%2096.3469%2091.8319L69.4827%2057.9086L87.7215%2039.6702C90.8281%2036.5638%2090.8282%2031.5272%2087.7217%2028.4208C84.6153%2025.3143%2079.5788%2025.3141%2076.4723%2028.4206L52.6085%2052.2837C51.1167%2053.7754%2050.2786%2055.7987%2050.2786%2057.9084Z'%20fill='%23101828'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M50.2786%2057.9084C50.2786%2060.0182%2051.1167%2062.0415%2052.6084%2063.5332L85.0975%20103.081C88.2039%20106.188%2093.2405%20106.188%2096.3469%20103.081C99.4534%2099.9745%2099.4534%2094.9388%2096.3469%2091.8319L69.4827%2057.9086L87.7215%2039.6702C90.8281%2036.5638%2090.8282%2031.5272%2087.7217%2028.4208C84.6153%2025.3143%2079.5788%2025.3141%2076.4723%2028.4206L52.6085%2052.2837C51.1167%2053.7754%2050.2786%2055.7987%2050.2786%2057.9084Z'%20fill='url(%23paint0_linear_13415_10790)'/%3e%3cpath%20d='M38.0899%2082.0801C42.483%2082.0801%2046.0444%2078.5187%2046.0444%2074.1255L46.0444%2042.3072C46.0444%2037.9141%2042.483%2034.3526%2038.0899%2034.3526C33.6968%2034.3526%2030.1353%2037.9141%2030.1353%2042.3072L30.1353%2074.1255C30.1353%2078.5187%2033.6968%2082.0801%2038.0899%2082.0801Z'%20fill='%23FD6F8E'/%3e%3cdefs%3e%3clinearGradient%20id='paint0_linear_13415_10790'%20x1='70.1643'%20y1='26.0902'%20x2='70.1643'%20y2='89.726'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%235ABDF4'/%3e%3cstop%20offset='1'%20stop-color='%233060C8'/%3e%3c/linearGradient%3e%3c/defs%3e%3c/svg%3e";
const _hoisted_1$19 = {
  key: 0,
  class: "flex flex-col w-full justify-center items-center"
};
const _hoisted_2$S = { class: "flex flex-col items-center element" };
const _hoisted_3$K = ["src", "width", "height"];
const __default__$a = {
  name: "AppLoader"
};
const _sfc_main$1i = /* @__PURE__ */ defineComponent({
  ...__default__$a,
  setup(__props) {
    var _a, _b;
    const appLogo = {
      src: ((_b = (_a = BrandedAppState) == null ? void 0 : _a.state) == null ? void 0 : _b.appIconImage) || KollabLogo,
      width: 124,
      height: 123
    };
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(UIContentWrap), null, {
        default: withCtx(() => [
          unref(isPwa)() ? (openBlock(), createElementBlock("div", _hoisted_1$19, [
            _cache[1] || (_cache[1] = createElementVNode("img", {
              class: "flex elementBackground h-full w-full object-cover",
              src: _imports_0
            }, null, -1)),
            createElementVNode("div", _hoisted_2$S, [
              createElementVNode("img", {
                src: appLogo.src,
                width: appLogo.width,
                height: appLogo.height
              }, null, 8, _hoisted_3$K),
              _cache[0] || (_cache[0] = createElementVNode("div", { class: "flex dot-typing" }, null, -1))
            ])
          ])) : createCommentVNode("", true)
        ]),
        _: 1
      });
    };
  }
});
const AppLoader = /* @__PURE__ */ _export_sfc(_sfc_main$1i, [["__scopeId", "data-v-bc16fb36"]]);
const t = setupVueI18n(getLocalePreference());
const getErrorMessage = (error) => {
  var _a, _b;
  try {
    const message = (_b = (_a = error == null ? void 0 : error.response) == null ? void 0 : _a.data) == null ? void 0 : _b.message;
    if (message) {
      return typeof message === "string" ? message : typeof message[0] === "string" ? message[0] : t("loginPage.somethingWentWrong");
    }
    return t("loginPage.somethingWentWrong");
  } catch (e) {
    return t("loginPage.somethingWentWrong");
  }
};
function isNetworkError(error) {
  var _a, _b, _c, _d;
  return (error == null ? void 0 : error.code) === NETWORK_ERROR_CODES.ECONNABORTED || (error == null ? void 0 : error.code) === NETWORK_ERROR_CODES.ERR_NETWORK || (error == null ? void 0 : error.code) === NETWORK_ERROR_CODES.ERR_INTERNET_DISCONNECTED || ((_a = error == null ? void 0 : error.response) == null ? void 0 : _a.status) === 0 || ((_b = error == null ? void 0 : error.message) == null ? void 0 : _b.toLowerCase().includes("network error")) || ((_c = error == null ? void 0 : error.message) == null ? void 0 : _c.toLowerCase().includes("timeout")) || ((_d = error == null ? void 0 : error.message) == null ? void 0 : _d.toLowerCase().includes("abort")) || !navigator.onLine;
}
function getNetworkAwareErrorMessage(error) {
  if (isNetworkError(error)) {
    return t("common.networkError.message");
  }
  return getErrorMessage(error);
}
const _hoisted_1$18 = { class: "centered h-full w-full" };
const _hoisted_2$R = { class: "centered h-full w-full" };
const _hoisted_3$J = { class: "align-start m-0 flex w-full" };
const _hoisted_4$F = {
  key: 0,
  class: "w-full text-rose-600"
};
const _sfc_main$1h = /* @__PURE__ */ defineComponent({
  __name: "ForgotPassword",
  emits: ["changeScreen"],
  setup(__props, { emit: __emit }) {
    const emit = __emit;
    const errorMessage = ref();
    const t2 = inject("t");
    const loading = ref(false);
    const showRecaptcha = ref(false);
    const reCaptchaToken = ref(void 0);
    const resetPasswordDisabled = ref(false);
    const rules = {
      email: {
        required: true,
        validator: async (_, value) => {
          return await yup.string().email().required().validate(value);
        },
        message: t2.value("loginPage.emailRequired"),
        trigger: ["input", "blur"]
      },
      username: {
        required: true,
        message: t2.value("loginPage.fullNameRequired"),
        trigger: ["input"]
      },
      password: {
        required: true,
        min: 8,
        message: t2.value("loginPage.passwordRequired"),
        trigger: ["input"]
      }
    };
    const formValue = ref({
      email: "",
      password: "",
      username: ""
    });
    const formRef = ref();
    const handleValidateClick = async (e) => {
      loading.value = true;
      e.preventDefault();
      errorMessage.value = null;
      await formRef.value.getForm().restoreValidation();
      const result = await validateForm(formRef.value);
      if (!result) {
        loading.value = false;
        return;
      }
      try {
        const { data } = await UserService.forgotPassword({
          locationId: AppState.state.locationData.locationId,
          email: formValue.value.email.trim(),
          captchaToken: reCaptchaToken.value
        });
        if (data == null ? void 0 : data.multiple_users) {
          loading.value = false;
          emit("changeScreen", {
            email: formValue.value.email,
            multiUser: data == null ? void 0 : data.multiple_users,
            resetPassword: true,
            page: Screens.SELECT_USER_MULTI_USER
          });
        } else {
          loading.value = false;
          emit("changeScreen", {
            page: Screens.LOGIN
          });
        }
      } catch (error) {
        if (error.response.status === 429) {
          resetPasswordDisabled.value = true;
          showRecaptcha.value = true;
        } else {
          showRecaptcha.value = false;
          errorMessage.value = getErrorMessage(error);
        }
        loading.value = false;
      }
    };
    const onVerify = (response) => {
      reCaptchaToken.value = response;
      resetPasswordDisabled.value = false;
    };
    const onError = (response) => {
      resetPasswordDisabled.value = true;
    };
    const onExpired = (response) => {
      reCaptchaToken.value = void 0;
      resetPasswordDisabled.value = true;
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$18, [
        createElementVNode("div", _hoisted_2$R, [
          createVNode(unref(UIForm), {
            id: "forgot-password-form",
            ref_key: "formRef",
            ref: formRef,
            class: "flex flex-col items-center w-full",
            model: formValue.value,
            rules
          }, {
            default: withCtx(() => [
              createElementVNode("div", _hoisted_3$J, [
                createVNode(unref(UIHeader), { id: "text-only-header" })
              ]),
              createVNode(unref(UIFormItem), {
                class: "w-full form-item",
                path: "email"
              }, {
                default: withCtx(() => [
                  createVNode(unref(UIInput), {
                    size: "large",
                    id: "forgot-password-form-email",
                    modelValue: formValue.value.email,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => formValue.value.email = $event),
                    placeholder: unref(t2)("loginPage.email"),
                    onInput: _cache[1] || (_cache[1] = ($event) => errorMessage.value = null)
                  }, {
                    prefix: withCtx(() => [
                      createVNode(unref(render$u), { class: "h-5 w-5 pr-1 mr-2" })
                    ]),
                    _: 1
                  }, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
              }),
              errorMessage.value ? (openBlock(), createElementBlock("div", _hoisted_4$F, toDisplayString(errorMessage.value), 1)) : createCommentVNode("", true),
              showRecaptcha.value ? (openBlock(), createBlock(_sfc_main$1k, {
                key: 1,
                class: "flex w-full justify-center",
                onExpired,
                onVerify,
                onError
              })) : createCommentVNode("", true),
              createVNode(unref(UIButton), {
                id: "forgot-password-form-btn",
                style: normalizeStyle(unref(AppState).state.authButtonStyle),
                disabled: loading.value || resetPasswordDisabled.value,
                onClick: handleValidateClick,
                loading: loading.value,
                class: "w-full mt-8"
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(unref(t2)("loginPage.resetPassword")), 1)
                ]),
                _: 1
              }, 8, ["style", "disabled", "loading"]),
              createElementVNode("div", null, [
                createTextVNode(toDisplayString(unref(t2)("loginPage.alreadyHaveAccount")) + " ", 1),
                createElementVNode("span", null, [
                  createVNode(unref(UIButton), {
                    id: "open-login-button",
                    class: "ml-2 my-2 cursor-pointer no-underline",
                    text: true,
                    onClick: _cache[2] || (_cache[2] = ($event) => emit("changeScreen", {
                      page: unref(Screens).LOGIN
                    }))
                  }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(unref(t2)("loginPage.login")), 1)
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _: 1
          }, 8, ["model"])
        ])
      ]);
    };
  }
});
const _hoisted_1$17 = { class: "centered h-full w-full" };
const _hoisted_2$Q = { class: "centered h-full w-full" };
const _hoisted_3$I = {
  id: "sign-up-form",
  class: "flex flex-col items-center w-full"
};
const _hoisted_4$E = { class: "align-start m-0 flex w-full" };
const _hoisted_5$w = { class: "text-center my-8" };
const _hoisted_6$q = { class: "footer flex w-full justify-between" };
const _hoisted_7$l = {
  key: 0,
  class: "m-2 flex items-center"
};
const _hoisted_8$c = {
  key: 1,
  class: "m-2 flex items-center"
};
const _sfc_main$1g = /* @__PURE__ */ defineComponent({
  __name: "ProceedToLogin",
  emits: ["changeScreen"],
  setup(__props, { emit: __emit }) {
    const emit = __emit;
    const t2 = inject("t");
    history.pushState({}, "", "");
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$17, [
        createElementVNode("div", _hoisted_2$Q, [
          createElementVNode("div", _hoisted_3$I, [
            createElementVNode("div", _hoisted_4$E, [
              createVNode(unref(UIHeader), { id: "text-only-header" })
            ]),
            createElementVNode("div", _hoisted_5$w, toDisplayString(unref(t2)("loginPage.resetPasswordLink")), 1),
            createVNode(unref(UIButton), {
              id: "open-login-button",
              class: "my-2 w-full cursor-pointer",
              onClick: _cache[0] || (_cache[0] = ($event) => emit("changeScreen", {
                page: unref(Screens).LOGIN
              }))
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(unref(t2)("loginPage.proceedToLogin")), 1)
              ]),
              _: 1
            })
          ])
        ]),
        createElementVNode("div", _hoisted_6$q, [
          unref(AppState).state.locationData.branding.copyRight && unref(AppState).state.locationData.branding.copyRight.length > 1 ? (openBlock(), createElementBlock("div", _hoisted_7$l, [
            _cache[1] || (_cache[1] = createElementVNode("span", { class: "copyright mr-1 mt-0.5" }, "©", -1)),
            createElementVNode("div", null, toDisplayString(unref(AppState).state.locationData.branding.copyRight), 1)
          ])) : createCommentVNode("", true),
          unref(AppState).state.locationData.branding.supportEmail && unref(AppState).state.locationData.branding.supportEmail.length > 1 ? (openBlock(), createElementBlock("div", _hoisted_8$c, [
            createVNode(unref(render$u), { class: "mr-2 h-4 w-4" }),
            createTextVNode(toDisplayString(unref(AppState).state.locationData.branding.supportEmail), 1)
          ])) : createCommentVNode("", true)
        ])
      ]);
    };
  }
});
const _hoisted_1$16 = { class: "flex flex-col" };
const _hoisted_2$P = { class: "max-h-72 w-full user-list-scrollbar" };
const _hoisted_3$H = ["onClick"];
const _hoisted_4$D = { class: "flex flex-row items-center gap-3 p-3" };
const _hoisted_5$v = {
  key: 0,
  class: "w-full text-rose-600"
};
const _sfc_main$1f = /* @__PURE__ */ defineComponent({
  __name: "LoginMultiUser",
  props: {
    title: {
      type: String,
      default: "Login"
    },
    email: {
      type: String,
      required: true
    },
    password: {
      type: String,
      default: ""
    },
    otp: {
      type: []
    },
    token: {
      type: String
    },
    users: {
      default: []
    },
    resetPassword: {
      default: false
    },
    idToken: {
      type: String
    },
    fullName: {
      type: String
    }
  },
  emits: ["changeScreen", LoginEvents.LOGIN_CALLBACK],
  setup(__props, { emit: __emit }) {
    const emit = __emit;
    const selectedCheckbox = ref("");
    const showRecaptcha = ref(false);
    const reCaptchaToken = ref(void 0);
    const loginDisabled = ref(false);
    const contactId = ref("");
    const errorMessage = ref();
    const loading = ref();
    const t2 = inject("t");
    const props = __props;
    const handleCheckBoxUpdate = (item) => {
      const value = item.userId;
      if (selectedCheckbox.value === value) {
        selectedCheckbox.value = "";
        contactId.value = "";
      } else {
        selectedCheckbox.value = value;
        contactId.value = item.contactId;
      }
    };
    const handleLogin = async () => {
      var _a;
      loading.value = true;
      let response;
      try {
        errorMessage.value = null;
        if (!selectedCheckbox.value) {
          errorMessage.value = "Select at least one user";
          loading.value = false;
          return;
        }
        if ((props == null ? void 0 : props.otp) && props.token) {
          const { data } = await UserService.loginWithSecureEmail({
            email: props.email,
            otp: Number(props.otp),
            token: props.token,
            userId: selectedCheckbox.value,
            locationId: AppState.state.locationData.locationId,
            captchaToken: reCaptchaToken.value
          });
          response = data;
        } else if (props.idToken) {
          const { data } = await UserService.loginWithSocialID({
            email: props.email,
            authProvider: "Google",
            idToken: props.idToken,
            fullName: props.fullName,
            userId: selectedCheckbox.value,
            locationId: AppState.state.locationData.locationId
          });
          response = data;
        } else if (props.resetPassword && props.email) {
          const { data } = await UserService.forgotPassword({
            locationId: AppState.state.locationData.locationId,
            email: props.email.trim(),
            userId: contactId.value,
            captchaToken: reCaptchaToken.value
          });
          response = data;
          if (data.success) {
            emit("changeScreen", {
              email: props.email,
              page: Screens.PROCEED_TO_LOGIN
            });
          }
        } else {
          const { data } = await UserService.login({
            email: props.email,
            password: props.password,
            userId: selectedCheckbox.value,
            locationId: AppState.state.locationData.locationId,
            captchaToken: reCaptchaToken.value
          });
          response = data;
        }
        if (response) {
          await postLogin(response);
          if (!response.isPasswordVerified) {
            emit("changeScreen", {
              email: props.email,
              passwordResetToken: response.passwordResetToken,
              contactId: response.contactId,
              page: Screens.SET_PASSWORD
            });
          } else {
            emit(LoginEvents.LOGIN_CALLBACK, {
              eventType: LoginEvents.LOGIN_SUCCESSFUL,
              ...response
            });
          }
        }
      } catch (error) {
        if (((_a = error == null ? void 0 : error.response) == null ? void 0 : _a.status) === 429) {
          loginDisabled.value = true;
          showRecaptcha.value = true;
        } else {
          showRecaptcha.value = false;
          errorMessage.value = getErrorMessage(error);
        }
        loading.value = false;
      }
    };
    const onVerify = (response) => {
      reCaptchaToken.value = response;
      loginDisabled.value = false;
    };
    const onError = (response) => {
      loginDisabled.value = true;
    };
    const onExpired = (response) => {
      reCaptchaToken.value = void 0;
      loginDisabled.value = true;
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$16, [
        _cache[0] || (_cache[0] = createElementVNode("div", { class: "align-center m-0 flex w-full" }, null, -1)),
        createElementVNode("div", _hoisted_2$P, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(props.users, (item) => {
            return openBlock(), createElementBlock("div", {
              key: item.userId,
              style: normalizeStyle([
                selectedCheckbox.value === item.userId ? { border: "2px solid #004EEB" } : {}
              ]),
              class: "mb-4 max-w-2xl cursor-pointer hover:border-blue-400 border-solid border-1px rounded-lg border-gray-200 user_account_card",
              onClick: () => handleCheckBoxUpdate(item)
            }, [
              createElementVNode("div", _hoisted_4$D, [
                (item == null ? void 0 : item.avatarUrl) ? (openBlock(), createBlock(unref(UIAvatar), {
                  key: 0,
                  size: "large",
                  src: item.avatarUrl
                }, null, 8, ["src"])) : (openBlock(), createBlock(unref(UIAvatar), {
                  key: 1,
                  size: "large",
                  class: "flex items-center justify-center bg-gray-100 text-md font-medium text-gray-600"
                }, {
                  default: withCtx(() => [
                    createVNode(unref(UITextSmMedium), null, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(unref(getShortName)(item.fullName || "Deleted User")), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024)),
                createElementVNode("div", null, [
                  createVNode(unref(UITextSmMedium), { class: "text-gray-700 font-semibold" }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(item.fullName), 1)
                    ]),
                    _: 2
                  }, 1024),
                  (item == null ? void 0 : item.lastLogin) ? (openBlock(), createBlock(unref(UITextSmMedium), {
                    key: 0,
                    class: "text-gray-600 font-light"
                  }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(unref(t2)("loginPage.lastLogin")) + ": " + toDisplayString(unref(timestampFormat)(item == null ? void 0 : item.lastLogin)), 1)
                    ]),
                    _: 2
                  }, 1024)) : createCommentVNode("", true)
                ])
              ])
            ], 12, _hoisted_3$H);
          }), 128))
        ]),
        createVNode(unref(UITextSmRegular), { class: "mt-2 text-sm text-gray-600 flex al" }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(`${unref(t2)("loginPage.selectAccount")} ${props.resetPassword ? unref(t2)("loginPage.resetPassword") : unref(t2)("loginPage.login")} `), 1)
          ]),
          _: 1
        }),
        errorMessage.value ? (openBlock(), createElementBlock("div", _hoisted_5$v, toDisplayString(errorMessage.value), 1)) : createCommentVNode("", true),
        showRecaptcha.value ? (openBlock(), createBlock(_sfc_main$1k, {
          key: 1,
          class: "flex w-full justify-center",
          onExpired,
          onVerify,
          onError
        })) : createCommentVNode("", true),
        createVNode(unref(UIButton), {
          id: "btn-select-acc-id",
          onClick: handleLogin,
          style: normalizeStyle(unref(AppState).state.authButtonStyle),
          loading: loading.value,
          disabled: loading.value || loginDisabled.value,
          class: "w-full mt-6"
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(props.resetPassword ? unref(t2)("loginPage.resetPassword") : `${props.title}`), 1)
          ]),
          _: 1
        }, 8, ["style", "loading", "disabled"])
      ]);
    };
  }
});
const LoginMultiUser = /* @__PURE__ */ _export_sfc(_sfc_main$1f, [["__scopeId", "data-v-4ba56ee7"]]);
const _hoisted_1$15 = { class: "form-group mt-4" };
const _hoisted_2$O = { class: "flex flex-row justify-center text-center" };
const _hoisted_3$G = { class: "flex" };
const _hoisted_4$C = {
  key: 0,
  class: "w-full text-rose-600"
};
const _sfc_main$1e = /* @__PURE__ */ defineComponent({
  __name: "LoginOtpInput",
  props: {
    title: {
      type: String,
      default: "Login"
    },
    email: {
      type: String,
      required: true
    },
    token: {
      type: String
    },
    password: {
      type: String
    },
    username: {
      type: String
    },
    locationId: {
      type: String
    },
    defaultOtp: {
      type: Number,
      default: null
    }
  },
  emits: ["changeScreen", LoginEvents.LOGIN_CALLBACK],
  setup(__props, { emit: __emit }) {
    const emit = __emit;
    const props = __props;
    const errorMessage = ref();
    const routerInstance = AppState.getRouterInstance();
    const route = computed(() => {
      if (!routerInstance) return null;
      return routerInstance.currentRoute;
    });
    const otpCode = ref("");
    const loading = ref(false);
    const showRecaptcha = ref(false);
    const reCaptchaToken = ref(void 0);
    const verifyDisabled = ref(false);
    const t2 = inject("t");
    const handleOnChange = (value) => {
      otpCode.value = value;
    };
    const handleOnComplete = async () => {
      var _a, _b, _c, _d, _e;
      loading.value = true;
      try {
        if (!Number(otpCode.value)) {
          errorMessage.value = t2.value("loginPage.secureCodeNumeric");
          loading.value = false;
          return false;
        }
        errorMessage.value = null;
        const { data } = props.password ? await UserService.signUp({
          email: props.email,
          otp: Number(otpCode.value),
          token: props.token,
          locationId: AppState.state.locationData.locationId,
          redirectUrl: (_b = (_a = route.value) == null ? void 0 : _a.query) == null ? void 0 : _b.redirectUrl,
          password: props.password.trim() || null,
          username: props.username.trim() || null,
          captchaToken: reCaptchaToken.value
        }) : await UserService.loginWithSecureEmail({
          email: props.email,
          otp: Number(otpCode.value),
          token: props.token,
          locationId: AppState.state.locationData.locationId,
          redirectUrl: (_d = (_c = route.value) == null ? void 0 : _c.query) == null ? void 0 : _d.redirectUrl,
          captchaToken: reCaptchaToken.value
        });
        if (data == null ? void 0 : data.multiple_users) {
          emit("changeScreen", {
            email: props.email,
            otp: Number(otpCode.value),
            token: props.token,
            multiUser: data == null ? void 0 : data.multiple_users,
            page: Screens.SELECT_USER_MULTI_USER
          });
        } else if (data.token) {
          await postLogin(data);
          if (!data.isPasswordVerified && (data == null ? void 0 : data.passwordResetToken)) {
            emit("changeScreen", {
              email: props.email,
              passwordResetToken: data.passwordResetToken,
              contactId: data.contactId,
              page: Screens.SET_PASSWORD
            });
          } else {
            await postLogin(data);
            emit(LoginEvents.LOGIN_CALLBACK, {
              eventType: LoginEvents.LOGIN_SUCCESSFUL,
              ...data
            });
          }
          loading.value = false;
        }
        showRecaptcha.value = false;
        loading.value = false;
      } catch (error) {
        if (((_e = error == null ? void 0 : error.response) == null ? void 0 : _e.status) === 429) {
          verifyDisabled.value = true;
          showRecaptcha.value = true;
        } else {
          showRecaptcha.value = false;
          errorMessage.value = getErrorMessage(error);
          if (errorMessage.value == "User not found") {
            emit("changeScreen", {
              email: props.email,
              page: Screens.SIGN_UP
            });
          }
        }
        loading.value = false;
      }
    };
    const isResendButtonDisabled = ref(false);
    async function resendOtp() {
      var _a;
      try {
        const { data } = await UserService.loginWithSecureEmail({
          email: props.email,
          locationId: AppState.state.locationData.locationId,
          captchaToken: reCaptchaToken.value
        });
        emit("changeScreen", {
          page: Screens.VERIFY_SECURE_CODE,
          email: props.email,
          token: data.token
        });
        isResendButtonDisabled.value = true;
        setTimeout(() => isResendButtonDisabled.value = false, 3e4);
      } catch (error) {
        if (((_a = error == null ? void 0 : error.response) == null ? void 0 : _a.status) === 429) {
          verifyDisabled.value = true;
          isResendButtonDisabled.value = true;
          showRecaptcha.value = true;
        } else {
          errorMessage.value = getErrorMessage(error);
          showRecaptcha.value = false;
        }
      }
    }
    watch(otpCode, () => errorMessage.value = null);
    history.pushState({}, "", "");
    const onVerify = (response) => {
      reCaptchaToken.value = response;
      verifyDisabled.value = false;
    };
    const onError = (response) => {
      verifyDisabled.value = true;
    };
    const onExpired = (response) => {
      reCaptchaToken.value = void 0;
      verifyDisabled.value = true;
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$15, [
        createVNode(unref(UITextMdNormal), { class: "my-2 text-gray-700" }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(unref(t2)("loginPage.secureCode")), 1)
          ]),
          _: 1
        }),
        createElementVNode("div", _hoisted_2$O, [
          createVNode(unref(entry_esm), {
            ref: "otpInput",
            "input-classes": "otp-input",
            class: "text-3xl",
            value: otpCode.value,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event) => otpCode.value = $event),
            separator: " ",
            "num-inputs": 6,
            "should-auto-focus": true,
            "input-type": "tel",
            placeholder: ["0", "0", "0", "0", "0", "0"],
            onOnChange: handleOnChange
          }, null, 8, ["value"])
        ]),
        createElementVNode("div", _hoisted_3$G, [
          createVNode(unref(UITextSmRegular), { class: "text-gray-700" }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(unref(t2)("loginPage.secureCodeEmail")) + " ", 1),
              createElementVNode("span", null, [
                createVNode(unref(UIButton), {
                  id: "resend-otp--button",
                  class: "underline-offset-4",
                  onClick: resendOtp,
                  disabled: isResendButtonDisabled.value,
                  text: true
                }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(unref(t2)("loginPage.resendOtp")), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ])
            ]),
            _: 1
          })
        ]),
        errorMessage.value ? (openBlock(), createElementBlock("div", _hoisted_4$C, toDisplayString(errorMessage.value), 1)) : createCommentVNode("", true),
        showRecaptcha.value ? (openBlock(), createBlock(_sfc_main$1k, {
          key: 1,
          class: "flex w-full justify-center",
          onExpired,
          onVerify,
          onError
        })) : createCommentVNode("", true),
        createVNode(unref(UIButton), {
          id: "login-secure-form-btn",
          onClick: handleOnComplete,
          disabled: loading.value || verifyDisabled.value,
          loading: loading.value,
          style: normalizeStyle(unref(AppState).state.authButtonStyle),
          class: "w-full mt-4 mb-2"
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(unref(t2)("loginPage.verifySecureCode")), 1)
          ]),
          _: 1
        }, 8, ["disabled", "loading", "style"]),
        createElementVNode("div", null, [
          createVNode(unref(UIButton), {
            id: "open-signup-button",
            class: "cursor-pointer no-underline w-full justify-center",
            text: true,
            onClick: _cache[1] || (_cache[1] = ($event) => emit("changeScreen", {
              page: unref(Screens).LOGIN
            }))
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(unref(t2)("loginPage.loginWithPassword")), 1)
            ]),
            _: 1
          })
        ])
      ]);
    };
  }
});
const _hoisted_1$14 = ["src", "title"];
const _hoisted_2$N = { class: "flex w-full items-center justify-center" };
const _hoisted_3$F = {
  key: 0,
  class: "flex h-[40px] mt-6 w-full items-center justify-center border border-solid border-gray-300 bg-white px-0 text-white hover:bg-gray-50 rounded-md cursor-pointer"
};
const _sfc_main$1d = /* @__PURE__ */ defineComponent({
  __name: "SignInWithGoogle",
  props: {
    loginType: {
      type: String,
      required: true
    }
  },
  emits: [
    "changeScreen",
    LoginEvents.LOGIN_CALLBACK,
    "onClick",
    "updateLoader"
  ],
  setup(__props, { emit: __emit }) {
    const emit = __emit;
    const t2 = inject("t");
    const ssoApp = ref(
      `${AppState.getConfig().CLIENT_PORTAL_SSO_URL}/login?origin=${window.location.origin}`
    );
    const handleMessage = async function(event) {
      var _a, _b, _c, _d;
      if (event.origin === AppState.getConfig().CLIENT_PORTAL_SSO_URL && ((_a = event == null ? void 0 : event.data) == null ? void 0 : _a.credential)) {
        emit("updateLoader", true);
        const dataFromPopup = (_b = event == null ? void 0 : event.data) == null ? void 0 : _b.credential;
        try {
          const { data } = await UserService.loginWithSocialID({
            authProvider: AuthProvider.GOOGLE,
            idToken: dataFromPopup,
            locationId: (_c = AppState.state.locationData) == null ? void 0 : _c.locationId
          });
          if (!data) {
            throw new Error("No data received from authentication service");
          }
          if (data == null ? void 0 : data.multiple_users) {
            emit("changeScreen", {
              email: data == null ? void 0 : data.email,
              fullName: data == null ? void 0 : data.displayName,
              authProvider: AuthProvider.GOOGLE,
              idToken: dataFromPopup,
              locationId: (_d = AppState.state.locationData) == null ? void 0 : _d.locationId,
              page: Screens.SELECT_USER_MULTI_USER,
              multiUser: data == null ? void 0 : data.multiple_users
            });
          } else if (data.token) {
            await postLogin(data);
            if (!data.isPasswordVerified && (data == null ? void 0 : data.passwordResetToken)) {
              emit("changeScreen", {
                email: data == null ? void 0 : data.email,
                passwordResetToken: data.passwordResetToken,
                contactId: data.contactId,
                page: Screens.SET_PASSWORD
              });
            } else {
              emit(LoginEvents.LOGIN_CALLBACK, {
                eventType: LoginEvents.LOGIN_SUCCESSFUL,
                ...data
              });
            }
          } else {
            throw new Error("Invalid authentication response: Missing token");
          }
        } catch (error) {
          throw new Error("Network error: Unable to reach authentication service");
        } finally {
          emit("updateLoader", false);
        }
      }
    };
    onMounted(() => {
      window.addEventListener("message", handleMessage);
    });
    onUnmounted(() => {
      window.removeEventListener("message", handleMessage);
    });
    const isLoading = ref(true);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        createElementVNode("div", {
          id: "google-one-tap1",
          class: normalizeClass(["flex items-center justify-center h-[50px] mt-6 -mx-4", isLoading.value ? "hidden" : "block"]),
          style: { "width": "calc(100% + 32px)" }
        }, [
          createElementVNode("iframe", {
            src: ssoApp.value,
            id: "google-one-tap",
            width: "100%",
            height: "44",
            style: { "border": "none" },
            allow: "identity-credentials-get",
            title: unref(t2)("accessibility.continueWithGoogle"),
            onLoad: _cache[0] || (_cache[0] = () => isLoading.value = false)
          }, null, 40, _hoisted_1$14)
        ], 2),
        createElementVNode("div", _hoisted_2$N, [
          isLoading.value ? (openBlock(), createElementBlock("div", _hoisted_3$F, [
            createVNode(unref(UISpin), { size: 16 })
          ])) : createCommentVNode("", true)
        ]),
        createVNode(unref(UIDivider), null, {
          default: withCtx(() => [
            createVNode(unref(UITextSmRegular), {
              class: "text-gray-600 divider-text",
              style: {}
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(__props.loginType === "SIGN_IN" ? unref(t2)("loginPage.signInWithEmail") : unref(t2)("loginPage.signUpWithEmail")), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ], 64);
    };
  }
});
const SignInWithGoogle = /* @__PURE__ */ _export_sfc(_sfc_main$1d, [["__scopeId", "data-v-d3cac125"]]);
const _hoisted_1$13 = {
  key: 0,
  class: "w-full pt-4 mx-2 text-rose-600 justify-center items-center"
};
const _hoisted_2$M = { class: "my-2 w-full flex items-end justify-end" };
const __default__$9 = {
  name: "LoginWithEmailPassword"
};
const _sfc_main$1c = /* @__PURE__ */ defineComponent({
  ...__default__$9,
  emits: ["changeScreen", LoginEvents.LOGIN_CALLBACK],
  setup(__props, { emit: __emit }) {
    const emit = __emit;
    const errorMessage = ref();
    const loading = ref(false);
    const showRecaptcha = ref(false);
    const reCaptchaToken = ref(void 0);
    const loginDisabled = ref(false);
    const t2 = inject("t");
    const rules = {
      email: {
        required: true,
        validator: (_, value) => {
          errorMessage.value = null;
          return string().email().required().validate(value);
        },
        message: t2.value("loginPage.emailRequired"),
        trigger: ["input", "blur"]
      },
      password: {
        required: true,
        min: 8,
        validator: (_, value) => {
          errorMessage.value = null;
        },
        message: t2.value("loginPage.passwordRequired"),
        trigger: ["input", "blur"]
      }
    };
    const formValue = ref({
      email: "",
      password: ""
    });
    const formRef = ref();
    async function handleValidateClick(e) {
      var _a, _b;
      e.preventDefault();
      loading.value = true;
      errorMessage.value = null;
      const result = await validateForm(formRef.value);
      if (!result) {
        loading.value = false;
        return;
      }
      try {
        const { data } = await UserService.login({
          email: formValue.value.email.trim(),
          password: formValue.value.password.trim(),
          locationId: AppState.state.locationData.locationId,
          captchaToken: reCaptchaToken.value
        });
        if (data == null ? void 0 : data.multiple_users) {
          emit("changeScreen", {
            ...formValue.value,
            page: Screens.SELECT_USER_MULTI_USER,
            multiUser: data == null ? void 0 : data.multiple_users
          });
          loading.value = false;
        } else if (data.token) {
          await postLogin(data);
          emit(LoginEvents.LOGIN_CALLBACK, {
            eventType: LoginEvents.LOGIN_SUCCESSFUL,
            ...data
          });
          loading.value = false;
        }
        showRecaptcha.value = false;
      } catch (error) {
        if (((_a = error == null ? void 0 : error.response) == null ? void 0 : _a.status) === 429) {
          loginDisabled.value = true;
          showRecaptcha.value = true;
        } else if (((_b = error == null ? void 0 : error.response) == null ? void 0 : _b.status) === 403) {
          showRecaptcha.value = false;
          errorMessage.value = t2.value(
            "loginPage.validationErrors.bannedUser.message"
          );
        } else {
          showRecaptcha.value = false;
          errorMessage.value = getErrorMessage(error);
        }
        loading.value = false;
      }
    }
    watch(formValue.value, () => errorMessage.value = null);
    const onVerify = (response) => {
      reCaptchaToken.value = response;
      loginDisabled.value = false;
    };
    const onError = (response) => {
      loginDisabled.value = true;
    };
    const onExpired = (response) => {
      reCaptchaToken.value = void 0;
      loginDisabled.value = true;
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        !unref(AppState).state.isSSODisabled && !unref(AppState).state.isThirdPartyInAppBrowser ? (openBlock(), createBlock(SignInWithGoogle, {
          key: 0,
          loginType: "SIGN_IN",
          onUpdateLoader: _cache[0] || (_cache[0] = (val) => loading.value = val),
          onChangeScreen: _cache[1] || (_cache[1] = (val) => emit("changeScreen", val)),
          onLoginCallback: _cache[2] || (_cache[2] = (val) => emit(unref(LoginEvents).LOGIN_CALLBACK, val))
        })) : createCommentVNode("", true),
        createVNode(unref(UIForm), {
          id: "login-page-email-form",
          ref_key: "formRef",
          ref: formRef,
          class: "flex flex-col items-center",
          model: formValue.value,
          rules,
          onKeyup: withKeys(handleValidateClick, ["enter"])
        }, {
          default: withCtx(() => [
            createVNode(unref(UIFormItem), {
              class: "w-full form-item",
              path: "email"
            }, {
              default: withCtx(() => [
                createVNode(unref(UIInput), {
                  size: "large",
                  id: "sign-in-form-email",
                  modelValue: formValue.value.email,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => formValue.value.email = $event),
                  placeholder: unref(t2)("loginPage.email")
                }, {
                  prefix: withCtx(() => [
                    createVNode(unref(render$u), { class: "h-5 w-5 pr-1 mr-2" })
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }),
            createVNode(unref(UIFormItem), {
              class: "w-full form-item",
              path: "password"
            }, {
              default: withCtx(() => [
                createVNode(unref(UIInput), {
                  id: "sign-in-form-password",
                  type: "password",
                  modelValue: formValue.value.password,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => formValue.value.password = $event),
                  placeholder: unref(t2)("loginPage.password"),
                  "show-password-on": "click"
                }, {
                  prefix: withCtx(() => [
                    createVNode(unref(render$J), { class: "h-5 w-5 pr-1 mr-2" })
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }),
            errorMessage.value ? (openBlock(), createElementBlock("div", _hoisted_1$13, toDisplayString(errorMessage.value), 1)) : createCommentVNode("", true),
            showRecaptcha.value ? (openBlock(), createBlock(_sfc_main$1k, {
              key: 1,
              class: "flex w-full justify-center",
              onExpired,
              onVerify,
              onError
            })) : createCommentVNode("", true),
            createElementVNode("div", _hoisted_2$M, [
              createVNode(unref(UIButton), {
                id: "open-forgot-password-button",
                class: "ml-2 my-2 cursor-pointer no-underline",
                text: true,
                onClick: _cache[5] || (_cache[5] = ($event) => emit("changeScreen", {
                  page: unref(Screens).FORGOT_PASSWORD
                }))
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(unref(t2)("loginPage.forgotPassword")), 1)
                ]),
                _: 1
              })
            ]),
            createVNode(unref(UIButton), {
              id: "login--button",
              onClick: handleValidateClick,
              class: "w-full mv-2",
              style: normalizeStyle(unref(AppState).state.authButtonStyle),
              disabled: loading.value || loginDisabled.value,
              loading: loading.value,
              keyboard: true
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(unref(t2)("loginPage.login")), 1)
              ]),
              _: 1
            }, 8, ["style", "disabled", "loading"]),
            createVNode(unref(UIButton), {
              id: "sec-log-btn-login-page",
              class: "my-2 w-full cursor-pointer",
              style: normalizeStyle(unref(AppState).state.secondaryButtonStyle),
              onClick: _cache[6] || (_cache[6] = () => emit("changeScreen", {
                page: unref(Screens).LOGIN_WITH_SECURE_CODE
              }))
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(unref(t2)("loginPage.loginWithSecureCode")), 1)
              ]),
              _: 1
            }, 8, ["style"]),
            createElementVNode("div", null, [
              createTextVNode(toDisplayString(unref(t2)("loginPage.newUser")) + " ", 1),
              createElementVNode("span", null, [
                createVNode(unref(UIButton), {
                  id: "open-signup-button",
                  class: "ml-2 my-2 cursor-pointer no-underline",
                  text: true,
                  onClick: _cache[7] || (_cache[7] = ($event) => emit("changeScreen", {
                    page: unref(Screens).SIGN_UP
                  }))
                }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(unref(t2)("loginPage.signUp")), 1)
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        }, 8, ["model"])
      ], 64);
    };
  }
});
const LoginWithEmailPassword = /* @__PURE__ */ _export_sfc(_sfc_main$1c, [["__scopeId", "data-v-96feb078"]]);
const _hoisted_1$12 = {
  key: 0,
  class: "w-full text-rose-600 py-2"
};
const _sfc_main$1b = /* @__PURE__ */ defineComponent({
  __name: "LoginWithSecureCode",
  emits: ["changeScreen", LoginEvents.LOGIN_CALLBACK],
  setup(__props, { emit: __emit }) {
    const emit = __emit;
    const errorMessage = ref();
    const loading = ref(false);
    const showRecaptcha = ref(false);
    const reCaptchaToken = ref(void 0);
    const loginDisabled = ref(false);
    const t2 = inject("t");
    const rules = {
      email: {
        required: true,
        validator: (_, value) => {
          errorMessage.value = null;
          return yup.string().email().required().validate(value);
        },
        message: t2.value("loginPage.emailRequired"),
        trigger: ["input", "blur"]
      }
    };
    const formValue = ref({
      email: ""
    });
    const formRef = ref();
    const handleValidateClick = async () => {
      var _a;
      loading.value = true;
      const result = await validateForm(formRef.value);
      if (!result) {
        loading.value = false;
        return;
      }
      try {
        errorMessage.value = null;
        const { data } = await UserService.loginWithSecureEmail({
          email: formValue.value.email.trim(),
          locationId: AppState.state.locationData.locationId,
          action: "SIGN_IN",
          captchaToken: reCaptchaToken.value
        });
        if (data == null ? void 0 : data.token) {
          emit("changeScreen", {
            email: formValue.value.email,
            otp: String(data == null ? void 0 : data.otp),
            token: data.token,
            page: Screens.VERIFY_SECURE_CODE
          });
          loading.value = false;
        }
        showRecaptcha.value = false;
      } catch (error) {
        if (((_a = error == null ? void 0 : error.response) == null ? void 0 : _a.status) === 429) {
          loginDisabled.value = true;
          showRecaptcha.value = true;
        } else {
          showRecaptcha.value = false;
          errorMessage.value = getErrorMessage(error);
        }
        loading.value = false;
      }
    };
    const onVerify = (response) => {
      reCaptchaToken.value = response;
      loginDisabled.value = false;
    };
    const onError = (response) => {
      loginDisabled.value = true;
    };
    const onExpired = (response) => {
      reCaptchaToken.value = void 0;
      loginDisabled.value = true;
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        !unref(AppState).state.isSSODisabled && !unref(AppState).state.isThirdPartyInAppBrowser ? (openBlock(), createBlock(SignInWithGoogle, {
          key: 0,
          loginType: "SIGN_IN",
          onUpdateLoader: _cache[0] || (_cache[0] = (val) => loading.value = val),
          onChangeScreen: _cache[1] || (_cache[1] = (val) => emit("changeScreen", val)),
          onLoginCallback: _cache[2] || (_cache[2] = (val) => emit(unref(LoginEvents).LOGIN_CALLBACK, val))
        })) : createCommentVNode("", true),
        createVNode(unref(UIForm), {
          ref_key: "formRef",
          ref: formRef,
          id: "login-secure-form",
          class: "flex flex-col items-center",
          model: formValue.value,
          rules,
          onKeyup: withKeys(handleValidateClick, ["enter"])
        }, {
          default: withCtx(() => [
            createVNode(unref(UIFormItem), {
              class: "w-full form-item",
              path: "email"
            }, {
              default: withCtx(() => [
                createVNode(unref(UIInput), {
                  id: "sign-up-form-email",
                  modelValue: formValue.value.email,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => formValue.value.email = $event),
                  placeholder: unref(t2)("loginPage.email")
                }, {
                  prefix: withCtx(() => [
                    createVNode(unref(render$u), { class: "h-5 w-5 pr-1 mr-2" })
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }),
            errorMessage.value ? (openBlock(), createElementBlock("div", _hoisted_1$12, toDisplayString(errorMessage.value), 1)) : createCommentVNode("", true),
            showRecaptcha.value ? (openBlock(), createBlock(_sfc_main$1k, {
              key: 1,
              class: "flex w-full justify-center",
              onExpired,
              onVerify,
              onError
            })) : createCommentVNode("", true),
            createVNode(unref(UIButton), {
              id: "login-secure-form-btn",
              onClick: handleValidateClick,
              disabled: loading.value || loginDisabled.value,
              loading: loading.value,
              style: normalizeStyle(unref(AppState).state.authButtonStyle),
              class: "w-full mt-8"
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(unref(t2)("loginPage.generateSecureCode")), 1)
              ]),
              _: 1
            }, 8, ["disabled", "loading", "style"]),
            createVNode(unref(UIButton), {
              id: "open-signup-button",
              class: "my-2 w-full cursor-pointer",
              style: normalizeStyle(unref(AppState).state.secondaryButtonStyle),
              onClick: _cache[4] || (_cache[4] = ($event) => emit("changeScreen", {
                page: unref(Screens).LOGIN
              }))
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(unref(t2)("loginPage.loginWithPassword")), 1)
              ]),
              _: 1
            }, 8, ["style"]),
            createElementVNode("div", null, [
              createTextVNode(toDisplayString(unref(t2)("loginPage.newUser")) + " ", 1),
              createElementVNode("span", null, [
                createVNode(unref(UIButton), {
                  id: "open-signup-button",
                  class: "ml-2 my-2 cursor-pointer no-underline",
                  text: true,
                  onClick: _cache[5] || (_cache[5] = ($event) => emit("changeScreen", {
                    page: unref(Screens).SIGN_UP
                  }))
                }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(unref(t2)("loginPage.signUp")), 1)
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        }, 8, ["model"])
      ], 64);
    };
  }
});
const LoginWithSecureCode = /* @__PURE__ */ _export_sfc(_sfc_main$1b, [["__scopeId", "data-v-4f7d4007"]]);
const _hoisted_1$11 = {
  key: 0,
  class: "w-full text-rose-600 py-2"
};
const _sfc_main$1a = /* @__PURE__ */ defineComponent({
  __name: "SetPassword",
  props: {
    passwordResetToken: {
      type: String,
      required: true
    },
    contactId: {
      type: String,
      required: true
    }
  },
  emits: ["changeScreen", LoginEvents.LOGIN_CALLBACK],
  setup(__props, { emit: __emit }) {
    const emit = __emit;
    const props = __props;
    const errorMessage = ref();
    const loading = ref(false);
    const showRecaptcha = ref(false);
    const reCaptchaToken = ref(void 0);
    const setPasswordDisabled = ref(false);
    const t2 = inject("t");
    const rules = {
      newPassword: {
        required: true,
        min: 8,
        message: t2.value("setPassword.minLength"),
        trigger: ["input", "blur"]
      },
      confirmPassword: {
        required: true,
        validator: (_, value) => {
          return yup.string().required().oneOf(
            [formValue.value.newPassword],
            t2.value("setPassword.passwordsMustMatch")
          ).validate(value);
        },
        message: t2.value("setPassword.passwordsMustMatch"),
        trigger: ["input", "blur"]
      }
    };
    const formValue = ref({
      newPassword: "",
      confirmPassword: ""
    });
    const formRef = ref();
    const handleValidateClick = async () => {
      var _a;
      const isValidated = await validateForm(formRef.value);
      if (!isValidated) {
        return false;
      }
      try {
        loading.value = true;
        errorMessage.value = null;
        const { data } = await UserService.setPassword({
          newPassword: formValue.value.newPassword.trim(),
          confirmPassword: formValue.value.confirmPassword.trim(),
          locationId: AppState.state.locationData.locationId,
          passwordResetToken: props.passwordResetToken,
          contactId: props.contactId,
          captchaToken: reCaptchaToken.value
        });
        emit(LoginEvents.LOGIN_CALLBACK, {
          eventType: LoginEvents.LOGIN_SUCCESSFUL,
          ...data
        });
      } catch (error) {
        if (((_a = error == null ? void 0 : error.response) == null ? void 0 : _a.status) === 429) {
          setPasswordDisabled.value = true;
          showRecaptcha.value = true;
        } else {
          showRecaptcha.value = false;
          errorMessage.value = getErrorMessage(error);
        }
        loading.value = false;
      }
    };
    const onVerify = (response) => {
      reCaptchaToken.value = response;
      setPasswordDisabled.value = false;
    };
    const onError = (response) => {
      setPasswordDisabled.value = true;
    };
    const onExpired = (response) => {
      reCaptchaToken.value = void 0;
      setPasswordDisabled.value = true;
    };
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(UIForm), {
        ref_key: "formRef",
        ref: formRef,
        id: "set-password-form",
        class: "flex flex-col items-center",
        model: formValue.value,
        rules,
        onKeyup: withKeys(handleValidateClick, ["enter"])
      }, {
        default: withCtx(() => [
          createVNode(unref(UIFormItem), {
            class: "w-full form-item",
            path: "newPassword"
          }, {
            default: withCtx(() => [
              createVNode(unref(UIInput), {
                id: "set-password-form-new-password",
                type: "password",
                modelValue: formValue.value.newPassword,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => formValue.value.newPassword = $event),
                placeholder: unref(t2)("changePassword.newPassword"),
                "show-password-on": "click"
              }, {
                prefix: withCtx(() => [
                  createVNode(unref(render$J), { class: "h-5 w-5 pr-1 mr-2" })
                ]),
                _: 1
              }, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }),
          createVNode(unref(UIFormItem), {
            class: "w-full form-item",
            path: "confirmPassword"
          }, {
            default: withCtx(() => [
              createVNode(unref(UIInput), {
                id: "set-password-form-confirm-password",
                type: "password",
                modelValue: formValue.value.confirmPassword,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => formValue.value.confirmPassword = $event),
                placeholder: unref(t2)("changePassword.confirmNewPassword"),
                "show-password-on": "click"
              }, {
                prefix: withCtx(() => [
                  createVNode(unref(render$J), { class: "h-5 w-5 pr-1 mr-2" })
                ]),
                _: 1
              }, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }),
          errorMessage.value ? (openBlock(), createElementBlock("div", _hoisted_1$11, toDisplayString(errorMessage.value), 1)) : (openBlock(), createBlock(unref(UITextSmNormal), {
            key: 1,
            class: "text-gray-700 w-full pt-4"
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(unref(t2)("setPassword.setSecurePassword")), 1)
            ]),
            _: 1
          })),
          showRecaptcha.value ? (openBlock(), createBlock(_sfc_main$1k, {
            key: 2,
            class: "flex w-full justify-center",
            onExpired,
            onVerify,
            onError
          })) : createCommentVNode("", true),
          createVNode(unref(UIButton), {
            id: "set-password-form-btn",
            onClick: handleValidateClick,
            disabled: loading.value,
            loading: loading.value,
            style: normalizeStyle(unref(AppState).state.authButtonStyle),
            class: "w-full mt-8"
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(unref(t2)("setPassword.setPasswordButton")), 1)
            ]),
            _: 1
          }, 8, ["disabled", "loading", "style"])
        ]),
        _: 1
      }, 8, ["model"]);
    };
  }
});
const SetPassword = /* @__PURE__ */ _export_sfc(_sfc_main$1a, [["__scopeId", "data-v-9a3098a6"]]);
const _hoisted_1$10 = {
  key: 0,
  class: "w-full text-rose-600"
};
const _hoisted_2$L = { class: "my-2" };
const __default__$8 = {
  name: "SignUp"
};
const _sfc_main$19 = /* @__PURE__ */ defineComponent({
  ...__default__$8,
  emits: ["changeScreen", LoginEvents.LOGIN_CALLBACK],
  setup(__props, { emit: __emit }) {
    const emit = __emit;
    const t2 = inject("t");
    const rules = {
      email: {
        required: true,
        validator: (_, value) => {
          return yup.string().email().required().validate(value);
        },
        message: t2.value("loginPage.emailRequired"),
        trigger: ["input", "blur"]
      },
      username: {
        required: true,
        message: t2.value("loginPage.fullNameRequired"),
        trigger: ["input", "blur"],
        validator: (_, value) => {
          return textValidation.validate(value);
        }
      },
      password: {
        required: true,
        min: 8,
        message: t2.value("loginPage.passwordRequired"),
        trigger: ["input"]
      }
    };
    const formValue = ref({
      email: "",
      password: "",
      username: ""
    });
    const formRef = ref();
    const loading = ref(false);
    const showRecaptcha = ref(false);
    const reCaptchaToken = ref(void 0);
    const signUpDisabled = ref(false);
    const errorMessage = ref();
    const otpToken = ref();
    const handleValidateClick = async (e) => {
      var _a;
      const isValidated = await validateForm(formRef.value);
      if (!isValidated) {
        return false;
      }
      try {
        loading.value = true;
        errorMessage.value = null;
        const { data } = await UserService.loginWithSecureEmail({
          email: formValue.value.email.trim(),
          locationId: AppState.state.locationData.locationId,
          fullName: formValue.value.username.trim(),
          captchaToken: reCaptchaToken.value
        });
        emit("changeScreen", {
          page: Screens.VERIFY_SECURE_CODE,
          email: formValue.value.email,
          token: data.token,
          password: formValue.value.password.trim(),
          username: formValue.value.username.trim(),
          //username,
          locationId: AppState.state.locationData.locationId
        });
        loading.value = false;
      } catch (error) {
        if (((_a = error == null ? void 0 : error.response) == null ? void 0 : _a.status) === 429) {
          signUpDisabled.value = true;
          showRecaptcha.value = true;
        } else {
          showRecaptcha.value = false;
          errorMessage.value = getErrorMessage(error);
          if (errorMessage.value === "User already exist") {
            emit("changeScreen", {
              page: Screens.VERIFY_SECURE_CODE,
              email: formValue.value.email,
              token: otpToken.value,
              password: formValue.value.password.trim(),
              username: formValue.value.username.trim(),
              //username,
              locationId: AppState.state.locationData.locationId
            });
          }
        }
        loading.value = false;
      }
    };
    const onVerify = (response) => {
      reCaptchaToken.value = response;
      signUpDisabled.value = false;
    };
    const onError = (response) => {
      signUpDisabled.value = true;
    };
    const onExpired = (response) => {
      reCaptchaToken.value = void 0;
      signUpDisabled.value = true;
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        !unref(AppState).state.isSSODisabled && !unref(AppState).state.isThirdPartyInAppBrowser ? (openBlock(), createBlock(SignInWithGoogle, {
          key: 0,
          loginType: "SIGN_UP",
          onUpdateLoader: _cache[0] || (_cache[0] = (val) => loading.value = val),
          onChangeScreen: _cache[1] || (_cache[1] = (val) => emit("changeScreen", val)),
          onLoginCallback: _cache[2] || (_cache[2] = (val) => emit(unref(LoginEvents).LOGIN_CALLBACK, val))
        })) : createCommentVNode("", true),
        createVNode(unref(UIForm), {
          id: "sign-up-form",
          ref_key: "formRef",
          ref: formRef,
          class: "flex flex-col items-center",
          model: formValue.value,
          rules,
          onKeyup: withKeys(handleValidateClick, ["enter"])
        }, {
          default: withCtx(() => [
            createVNode(unref(UIFormItem), {
              class: "w-full form-item",
              path: "username"
            }, {
              default: withCtx(() => [
                createVNode(unref(UIInput), {
                  id: "sign-up-form-username",
                  maxlength: 50,
                  modelValue: formValue.value.username,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => formValue.value.username = $event),
                  placeholder: unref(t2)("loginPage.fullName")
                }, {
                  prefix: withCtx(() => [
                    createVNode(unref(render$j), { class: "h-5 w-5 pr-1 mr-2" })
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }),
            createVNode(unref(UIFormItem), {
              class: "w-full form-item",
              path: "email"
            }, {
              default: withCtx(() => [
                createVNode(unref(UIInput), {
                  id: "sign-up-form-email",
                  modelValue: formValue.value.email,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => formValue.value.email = $event),
                  placeholder: unref(t2)("loginPage.email")
                }, {
                  prefix: withCtx(() => [
                    createVNode(unref(render$u), { class: "h-5 w-5 pr-1 mr-2" })
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }),
            createVNode(unref(UIFormItem), {
              class: "w-full form-item",
              path: "password"
            }, {
              default: withCtx(() => [
                createVNode(unref(UIInput), {
                  id: "sign-up-form-password",
                  type: "password",
                  modelValue: formValue.value.password,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => formValue.value.password = $event),
                  placeholder: unref(t2)("loginPage.password")
                }, {
                  prefix: withCtx(() => [
                    createVNode(unref(render$J), { class: "h-5 w-5 pr-1 mr-2" })
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }),
            errorMessage.value ? (openBlock(), createElementBlock("div", _hoisted_1$10, toDisplayString(unref(t2)(errorMessage.value)), 1)) : createCommentVNode("", true),
            showRecaptcha.value ? (openBlock(), createBlock(_sfc_main$1k, {
              key: 1,
              class: "flex w-full justify-center",
              onExpired,
              onVerify,
              onError
            })) : createCommentVNode("", true),
            createVNode(unref(UIButton), {
              id: "sign-up--button",
              onClick: handleValidateClick,
              class: "w-full mt-8",
              style: normalizeStyle(unref(AppState).state.authButtonStyle),
              loading: loading.value,
              disabled: loading.value || signUpDisabled.value
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(unref(t2)("loginPage.signUp")), 1)
              ]),
              _: 1
            }, 8, ["style", "loading", "disabled"]),
            createElementVNode("div", _hoisted_2$L, [
              createTextVNode(toDisplayString(unref(t2)("loginPage.alreadyHaveAccount")) + " ", 1),
              createElementVNode("span", null, [
                createVNode(unref(UIButton), {
                  id: "open-signup-button",
                  class: "ml-2 cursor-pointer no-underline",
                  text: true,
                  onClick: _cache[6] || (_cache[6] = ($event) => emit("changeScreen", {
                    page: unref(Screens).LOGIN
                  }))
                }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(unref(t2)("loginPage.login")), 1)
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        }, 8, ["model"])
      ], 64);
    };
  }
});
const SignUp = /* @__PURE__ */ _export_sfc(_sfc_main$19, [["__scopeId", "data-v-763883b8"]]);
const _hoisted_1$$ = {
  key: 0,
  class: "w-full"
};
const _hoisted_2$K = { key: 1 };
const _hoisted_3$E = {
  key: 2,
  class: "max-w-md pb-6 px-8 login-page-width text-gray-900"
};
const __default__$7 = {
  name: "LoginPage"
};
const _sfc_main$18 = /* @__PURE__ */ defineComponent({
  ...__default__$7,
  props: {
    page: {
      type: String,
      required: true
    },
    locationData: {
      required: true
    },
    isTitleEnabled: {
      type: Boolean,
      default: false
    },
    isSSODisabled: {
      type: Boolean,
      default: false
    },
    referrerUser: {
      type: Object,
      default: null,
      required: false
    },
    v2Modal: {
      type: Boolean,
      default: false
    },
    nodeEnv: String
  },
  emits: [
    LoginEvents.CHANGE_SCREEN,
    LoginEvents.LOGIN_CALLBACK
  ],
  setup(__props, { emit: __emit }) {
    const AuthHandlerV2 = defineAsyncComponent(
      () => import("./AuthHandlerV2-D5fh92DY.js")
    );
    const AuthHandlerHR = defineAsyncComponent(
      () => import("./AuthHandlerHighrise-CEeUE8rF.js")
    );
    const t2 = ref(null);
    onBeforeMount(() => {
      t2.value = setupVueI18n(getLocalePreference());
    });
    const emit = __emit;
    const props = __props;
    const isAuthV2Flag = ref(true);
    onBeforeMount(async () => {
      isAuthV2Flag.value = await isAuthV2Enabled();
    });
    onMounted(() => {
      if (AppState.state.isThirdPartyInAppBrowser) {
        handleRedirectToExternalBrowser();
      }
      AppState.state.locationData = props.locationData;
      if (props == null ? void 0 : props.isTitleEnabled) {
        AppState.state.isTitleEnabled = props.isTitleEnabled;
      }
      AppState.state.isSSODisabled = props.isSSODisabled;
      AppState.state.NODE_ENV = props.nodeEnv;
    });
    const screen = ref({
      email: history.state.email || "",
      username: "",
      password: "",
      token: history.state.token || "",
      otp: history.state.otp || "",
      page: props.page || Screens.LOGIN,
      multiUser: history.state.multiUser || [],
      resetPassword: history.state.resetPassword || false,
      passwordResetToken: history.state.passwordResetToken || "",
      contactId: history.state.contactId || "",
      fullName: "",
      idToken: ""
    });
    async function callback(event) {
      emit(LoginEvents.LOGIN_CALLBACK, event);
      if (event.eventType == LoginEvents.LOGIN_SUCCESSFUL) {
        await UserState.getUserDetails();
      }
    }
    watch(
      () => props.page,
      (newPage) => {
        screen.value.page = newPage;
      },
      { immediate: true }
    );
    function onChangeScreen(val) {
      screen.value = { ...screen.value, ...val };
      emit(LoginEvents.CHANGE_SCREEN, screen.value);
    }
    const title = computed(() => {
      if (screen.value.page === Screens.SIGN_UP) {
        return t2.value("loginPage.signUp");
      }
      if (screen.value.page === Screens.VERIFY_SECURE_CODE) {
        return t2.value("loginPage.enterOtp");
      }
      if (screen.value.page === Screens.SELECT_USER_MULTI_USER) {
        return t2.value("loginPage.selectUser");
      }
      if (screen.value.page === Screens.FORGOT_PASSWORD) {
        return t2.value("loginPage.resetPassword");
      }
      return t2.value("loginPage.login");
    });
    provide("t", t2);
    return (_ctx, _cache) => {
      var _a, _b;
      return openBlock(), createElementBlock(Fragment, null, [
        renderSlot(_ctx.$slots, "header"),
        __props.v2Modal ? (openBlock(), createElementBlock("div", _hoisted_1$$, [
          createVNode(unref(AuthHandlerHR), {
            page: __props.page,
            locationData: __props.locationData,
            isTitleEnabled: __props.isTitleEnabled,
            isSSODisabled: __props.isSSODisabled,
            NODE_ENV: __props.nodeEnv,
            onLoginCallback: callback,
            onChangeScreen,
            referrerUser: props.referrerUser
          }, null, 8, ["page", "locationData", "isTitleEnabled", "isSSODisabled", "NODE_ENV", "referrerUser"])
        ])) : isAuthV2Flag.value ? (openBlock(), createElementBlock("div", _hoisted_2$K, [
          createVNode(unref(AuthHandlerV2), {
            page: __props.page,
            locationData: __props.locationData,
            isTitleEnabled: __props.isTitleEnabled,
            isSSODisabled: __props.isSSODisabled,
            NODE_ENV: __props.nodeEnv,
            onLoginCallback: callback,
            onChangeScreen,
            referrerUser: props.referrerUser
          }, null, 8, ["page", "locationData", "isTitleEnabled", "isSSODisabled", "NODE_ENV", "referrerUser"])
        ])) : (openBlock(), createElementBlock("div", _hoisted_3$E, [
          unref(AppState).state.isTitleEnabled ? (openBlock(), createBlock(unref(UIDisplaySmSemibold), {
            key: 0,
            class: "font-semibold text-3xl mb-2"
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(title.value), 1)
            ]),
            _: 1
          })) : createCommentVNode("", true),
          screen.value.page === unref(Screens).LOGIN ? (openBlock(), createBlock(LoginWithEmailPassword, {
            key: 1,
            onChangeScreen,
            onLoginCallback: callback
          })) : screen.value.page === unref(Screens).LOGIN_WITH_SECURE_CODE ? (openBlock(), createBlock(LoginWithSecureCode, {
            key: 2,
            onChangeScreen,
            onLoginCallback: callback
          })) : screen.value.page === unref(Screens).VERIFY_SECURE_CODE ? (openBlock(), createBlock(_sfc_main$1e, {
            key: 3,
            email: screen.value.email,
            token: screen.value.token,
            password: screen.value.password,
            username: screen.value.username,
            defaultOtp: screen.value.otp,
            onChangeScreen,
            onLoginCallback: callback
          }, null, 8, ["email", "token", "password", "username", "defaultOtp"])) : createCommentVNode("", true),
          screen.value.page === unref(Screens).SELECT_USER_MULTI_USER ? (openBlock(), createBlock(LoginMultiUser, {
            key: 4,
            email: screen.value.email,
            password: screen.value.password,
            users: screen.value.multiUser,
            otp: screen.value.otp,
            token: screen.value.token,
            "reset-password": screen.value.resetPassword,
            idToken: (_a = screen.value) == null ? void 0 : _a.idToken,
            fullName: (_b = screen.value) == null ? void 0 : _b.fullName,
            onChangeScreen,
            onLoginCallback: callback
          }, null, 8, ["email", "password", "users", "otp", "token", "reset-password", "idToken", "fullName"])) : createCommentVNode("", true),
          screen.value.page === unref(Screens).SET_PASSWORD ? (openBlock(), createBlock(SetPassword, {
            key: 5,
            email: screen.value.email,
            contactId: screen.value.contactId,
            passwordResetToken: screen.value.passwordResetToken,
            onChangeScreen,
            onLoginCallback: callback
          }, null, 8, ["email", "contactId", "passwordResetToken"])) : createCommentVNode("", true),
          screen.value.page === unref(Screens).FORGOT_PASSWORD ? (openBlock(), createBlock(_sfc_main$1h, {
            key: 6,
            onChangeScreen,
            onLoginCallback: callback
          })) : createCommentVNode("", true),
          screen.value.page === unref(Screens).PROCEED_TO_LOGIN ? (openBlock(), createBlock(_sfc_main$1g, {
            key: 7,
            onChangeScreen,
            onLoginCallback: callback
          })) : createCommentVNode("", true),
          screen.value.page === unref(Screens).SIGN_UP ? (openBlock(), createBlock(SignUp, {
            key: 8,
            onChangeScreen,
            onLoginCallback: callback
          })) : createCommentVNode("", true)
        ]))
      ], 64);
    };
  }
});
const _hoisted_1$_ = {
  key: 0,
  class: "w-full"
};
const _hoisted_2$J = {
  id: "info-container",
  class: ""
};
const _hoisted_3$D = { class: "relative h-44 w-full" };
const _hoisted_4$B = ["src"];
const _hoisted_5$u = {
  key: 1,
  class: "flex h-[147px] w-full bg-gradient-to-r from-[#4E54C8] to-[#8F94FB] bg-cover bg-center bg-blend-multiply"
};
const _hoisted_6$p = { class: "flex h-full w-full items-center justify-center bg-[url('https://storage.googleapis.com/revex-communities-production/assets/hero-section-background1-compressed.webp')] bg-cover bg-center" };
const _hoisted_7$k = ["src"];
const _hoisted_8$b = { class: "login-modal-button flex items-center justify-center pb-4 pt-4" };
const __default__$6 = {
  name: "LoginModalMobile"
};
const _sfc_main$17 = /* @__PURE__ */ defineComponent({
  ...__default__$6,
  props: {
    show: {
      type: Boolean,
      default: false
    },
    page: {
      type: String,
      default: "LOGIN"
    },
    loginConfirmation: {
      type: Function,
      required: true
    }
  },
  emits: ["update:show", "update:confirmed"],
  setup(__props, { emit: __emit }) {
    const maskClosable = ref(true);
    const env = computed(() => {
      return AppState.state.NODE_ENV === "production" ? "production" : "staging";
    });
    const props = __props;
    const emit = __emit;
    const showModal = ref(false);
    const isLoading = ref(false);
    onMounted(() => {
      isLoading.value = false;
      showModal.value = props.show;
    });
    watch(
      () => props.show,
      (showModalVal) => {
        showModal.value = showModalVal;
      }
    );
    function closeModal() {
      showModal.value = false;
      emit("update:show", false);
    }
    async function loginCallback(event) {
      isLoading.value = true;
      if (event.eventType === LoginEvents.LOGIN_SUCCESSFUL) {
        emit("update:confirmed", true);
        closeModal();
      }
      isLoading.value = false;
    }
    async function handleChangeScreen(event) {
      var _a, _b;
      if (((_a = event == null ? void 0 : event.value) == null ? void 0 : _a.page) === Screens.SET_PASSWORD || ((_b = event == null ? void 0 : event.value) == null ? void 0 : _b.page) === Screens.VERIFY_SECURE_CODE) {
        maskClosable.value = false;
      } else {
        maskClosable.value = true;
      }
    }
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(UIModal), {
        show: showModal.value,
        "onUpdate:show": [
          _cache[0] || (_cache[0] = ($event) => showModal.value = $event),
          closeModal
        ],
        "mask-closable": maskClosable.value,
        "class-name": "w-full fixed md:absolute h-full rounded-none md:rounded-xl md:h-auto left-0 right-0 flex justify-center custom-modal-width !p-0 overflow-y-auto"
      }, {
        header: withCtx(() => [
          createVNode(unref(UIModalHeader), {
            id: "modal-header",
            type: "custom",
            onClose: closeModal
          }, {
            customHeader: withCtx(() => {
              var _a;
              return [
                !unref(isGokollab)() ? (openBlock(), createElementBlock("div", _hoisted_1$_, [
                  createElementVNode("div", _hoisted_2$J, [
                    createElementVNode("div", _hoisted_3$D, [
                      createElementVNode("img", {
                        id: "cover-image",
                        alt: "Cover Image",
                        src: (_a = unref(LocationState).state.branding) == null ? void 0 : _a.portalBackgroundImage,
                        class: "max-h-[180px] w-full object-cover sm:rounded-t-xl"
                      }, null, 8, _hoisted_4$B)
                    ])
                  ])
                ])) : (openBlock(), createElementBlock("div", _hoisted_5$u, [
                  createElementVNode("div", _hoisted_6$p, [
                    createElementVNode("img", {
                      class: "info-logo h-12 w-56",
                      src: `${unref(AppState).getConfig().GOKOLLAB_ASSETS_BUCKET_URL}/gokollab-logo-white.png`,
                      alt: "Gokollab Logo"
                    }, null, 8, _hoisted_7$k)
                  ])
                ])),
                createElementVNode("div", {
                  class: "absolute right-2 top-2 h-6 w-6 cursor-pointer rounded-full bg-clientportal-primary text-white opacity-50 shadow-sm md:hidden",
                  tabindex: "0",
                  role: "button",
                  "aria-label": "Close Login Modal",
                  onClick: closeModal,
                  onKeyup: withKeys(closeModal, ["enter"])
                }, [
                  createVNode(unref(render$r))
                ], 32)
              ];
            }),
            _: 1
          })
        ]),
        default: withCtx(() => [
          createElementVNode("div", _hoisted_8$b, [
            isLoading.value ? (openBlock(), createBlock(unref(UISpin), {
              key: 0,
              class: "flex h-48 items-center justify-center"
            })) : (openBlock(), createBlock(_sfc_main$18, {
              key: 1,
              "node-env": env.value,
              page: __props.page,
              "location-data": unref(LocationState).state.locationData,
              class: "user-list-scrollbar overflow-y-auto",
              onLoginCallback: loginCallback,
              onChangeScreen: handleChangeScreen
            }, null, 8, ["node-env", "page", "location-data"]))
          ])
        ]),
        _: 1
      }, 8, ["show", "mask-closable"]);
    };
  }
});
const LoginModalMobile = /* @__PURE__ */ _export_sfc(_sfc_main$17, [["__scopeId", "data-v-6a8aa059"]]);
const _hoisted_1$Z = { class: "h-dvh w-full flex flex-col overflow-y-auto" };
const _hoisted_2$I = { class: "flex-1 p-5 flex flex-col gap-5 mt-12" };
const _hoisted_3$C = { class: "flex w-full cursor-pointer flex-row items-center justify-between" };
const _hoisted_4$A = { class: "flex flex-row items-center gap-4" };
const _hoisted_5$t = {
  key: 1,
  class: "flex flex-row gap-2"
};
const _hoisted_6$o = { class: "flex h-[40px] flex-row items-center justify-between" };
const _hoisted_7$j = { class: "flex items-center gap-2" };
const _hoisted_8$a = { class: "mt-auto mb-10" };
const _hoisted_9$8 = { class: "flex flex-row items-center justify-between" };
const _hoisted_10$8 = { class: "flex flex-row items-center gap-2" };
const _hoisted_11$8 = { class: "flex h-10 w-10 items-center justify-center rounded-xl bg-communities-surface" };
const _hoisted_12$6 = {
  key: 0,
  class: "loading-spinner h-5 w-5 border-2 border-communities-font-primary border-t-transparent rounded-full animate-spin"
};
const _hoisted_13$6 = { class: "flex flex-row items-center justify-center" };
const _sfc_main$16 = /* @__PURE__ */ defineComponent({
  __name: "MorePage",
  setup(__props) {
    const t2 = ref(setupVueI18n(window.localStorage.getItem("locale") || "en"));
    provide("t", t2);
    const router = AppState.getRouterInstance();
    const isLoggingOut = ref(false);
    const showLoginModal = ref(false);
    const handleLogout = async () => {
      isLoggingOut.value = true;
      try {
        await logoutUser();
        if (isGokollab()) {
          const path = isPwa() ? "mobile-landing" : "discovery";
          externalPathRedirect(path);
        } else {
          window.location.reload();
        }
      } catch (error) {
        isLoggingOut.value = false;
        console.error(error);
      }
    };
    const handleLogin = () => {
      showLoginModal.value = true;
    };
    const handleLoginModalClose = () => {
      showLoginModal.value = false;
    };
    const handleLoginSuccess = () => {
      showLoginModal.value = false;
      window.location.reload();
    };
    return (_ctx, _cache) => {
      var _a, _b, _c, _d;
      return openBlock(), createElementBlock("div", _hoisted_1$Z, [
        createElementVNode("div", _hoisted_2$I, [
          ((_b = (_a = unref(UserState)) == null ? void 0 : _a.state) == null ? void 0 : _b.userId) ? (openBlock(), createBlock(unref(UICard), {
            key: 0,
            id: "profile-card",
            onClick: _cache[0] || (_cache[0] = ($event) => unref(router).push({ name: "profile-container" }))
          }, {
            default: withCtx(() => {
              var _a2, _b2;
              return [
                createElementVNode("div", _hoisted_3$C, [
                  createElementVNode("div", _hoisted_4$A, [
                    createVNode(unref(UIAvatar), {
                      size: "large",
                      src: (_b2 = (_a2 = unref(UserState)) == null ? void 0 : _a2.state) == null ? void 0 : _b2.avatar,
                      class: normalizeClass("!border-[0px]"),
                      style: { "border": "0px solid var(--border) !important" }
                    }, null, 8, ["src"]),
                    createVNode(unref(UITextMdMedium), { class: "text-clamp-1 max-w-[calc(100vw-180px)] truncate text-communities-font-primary" }, {
                      default: withCtx(() => {
                        var _a3, _b3;
                        return [
                          createTextVNode(toDisplayString((_b3 = (_a3 = unref(UserState)) == null ? void 0 : _a3.state) == null ? void 0 : _b3.fullName), 1)
                        ];
                      }),
                      _: 1
                    })
                  ]),
                  createVNode(unref(render$d), { class: "h-6 w-6 text-communities-font-primary" })
                ])
              ];
            }),
            _: 1
          })) : createCommentVNode("", true),
          unref(isGokollab)() ? (openBlock(), createElementBlock("div", _hoisted_5$t, [
            createVNode(unref(UICard), {
              id: "documents-and-payments-card",
              class: "flex-1",
              tabindex: "0",
              role: "button",
              "aria-label": "Documents and Payments",
              onClick: _cache[1] || (_cache[1] = ($event) => unref(router).push({
                name: "documents-and-payments"
              }))
            }, {
              default: withCtx(() => [
                createElementVNode("div", _hoisted_6$o, [
                  createElementVNode("div", _hoisted_7$j, [
                    createVNode(unref(render$K), { class: "h-6 w-6 text-communities-font-primary" }),
                    createElementVNode("div", null, [
                      createVNode(unref(UITextMdMedium), { class: "text-communities-font-primary" }, {
                        default: withCtx(() => [
                          createTextVNode(toDisplayString(t2.value("common.documentsAndPayments")), 1)
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ]),
              _: 1
            })
          ])) : createCommentVNode("", true),
          createElementVNode("div", _hoisted_8$a, [
            ((_d = (_c = unref(UserState)) == null ? void 0 : _c.state) == null ? void 0 : _d.userId) ? (openBlock(), createElementBlock("div", {
              key: 0,
              id: "logout-card",
              class: "rounded-lg border-[1px] border-solid border-[--errorDark] p-[10px]",
              tabindex: "0",
              role: "button",
              "aria-label": "Log Out",
              onClick: handleLogout,
              onKeyup: withKeys(handleLogout, ["enter"])
            }, [
              createElementVNode("div", _hoisted_9$8, [
                createElementVNode("div", _hoisted_10$8, [
                  createElementVNode("div", _hoisted_11$8, [
                    createVNode(unref(render$L), { class: "h-6 w-6 text-communities-font-primary" })
                  ]),
                  createVNode(unref(UITextMdMedium), { class: "text-communities-font-primary" }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(t2.value("common.logout")), 1)
                    ]),
                    _: 1
                  })
                ]),
                isLoggingOut.value ? (openBlock(), createElementBlock("div", _hoisted_12$6)) : createCommentVNode("", true)
              ])
            ], 32)) : (openBlock(), createElementBlock("div", {
              key: 1,
              id: "login-card",
              class: "rounded-lg border-[1px] border-solid border-communities-border p-[10px]",
              tabindex: "0",
              role: "button",
              "aria-label": "Log In",
              onClick: handleLogin,
              onKeyup: withKeys(handleLogin, ["enter"])
            }, [
              createElementVNode("div", _hoisted_13$6, [
                createVNode(unref(UITextMdMedium), { class: "text-communities-font-primary" }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(t2.value("common.login")), 1)
                  ]),
                  _: 1
                })
              ])
            ], 32))
          ])
        ]),
        createVNode(LoginModalMobile, {
          show: showLoginModal.value,
          "onUpdate:show": handleLoginModalClose,
          "onUpdate:confirmed": handleLoginSuccess
        }, null, 8, ["show"])
      ]);
    };
  }
});
const MorePage = /* @__PURE__ */ _export_sfc(_sfc_main$16, [["__scopeId", "data-v-28a56923"]]);
const __default__$5 = {
  name: "TransitionWrapper"
};
var TransitionType = /* @__PURE__ */ ((TransitionType2) => {
  TransitionType2["NONE"] = "no-transition";
  TransitionType2["SLIDE_FORWARD"] = "slide-forward";
  TransitionType2["SLIDE_BACKWARD"] = "slide-backward";
  TransitionType2["FADE"] = "fade";
  return TransitionType2;
})(TransitionType || {});
var TransitionMode = /* @__PURE__ */ ((TransitionMode2) => {
  TransitionMode2["IN_OUT"] = "in-out";
  TransitionMode2["OUT_IN"] = "out-in";
  return TransitionMode2;
})(TransitionMode || {});
const _sfc_main$15 = /* @__PURE__ */ defineComponent({
  ...__default__$5,
  props: {
    // The transition type to use
    type: {
      type: String,
      default: "no-transition",
      validator: (value) => Object.values(TransitionType).includes(value)
    },
    // Whether to apply the transition when the component first appears
    appear: {
      type: Boolean,
      default: true
    },
    // Transition mode (default: undefined)
    mode: {
      type: String,
      default: void 0,
      validator: (value) => value === void 0 || Object.values(TransitionMode).includes(value)
    }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createBlock(Transition, {
        name: __props.type,
        appear: __props.appear,
        mode: __props.mode
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["name", "appear", "mode"]);
    };
  }
});
const _sfc_main$14 = /* @__PURE__ */ defineComponent({
  __name: "MenuModal",
  props: {
    show: {
      type: Boolean
    }
  },
  emits: ["update:show"],
  setup(__props, { emit: __emit }) {
    const routerInstance = AppState.getRouterInstance();
    const props = __props;
    const isSecure = ref(false);
    const t2 = inject("t");
    const emit = __emit;
    const showModal = ref(false);
    onMounted(() => showModal.value = props.show);
    watch(
      () => props.show,
      (showModalVal) => showModal.value = showModalVal
    );
    const handleClose = () => {
      showModal.value = false;
      emit("update:show", false);
    };
    onBeforeMount(async () => {
      await UserState.getUserDetails();
      isSecure.value = await isTokenExpired();
    });
    async function isTokenExpired() {
      var _a, _b;
      const expiryDate = await ((_b = (_a = UserState) == null ? void 0 : _a.state) == null ? void 0 : _b.billingTokenExpiry);
      if (!expiryDate) {
        return true;
      }
      return Date.now() - new Date(expiryDate).getTime() > 0;
    }
    const handleRoutes = (queryValue) => {
      var _a, _b, _c;
      if (isSecure.value && queryValue === ProfileScreen.BILLING_SUBSCRIPTION) {
        if (!TEST_EMAILS.includes((_b = (_a = UserState) == null ? void 0 : _a.state) == null ? void 0 : _b.email.toLowerCase().trim())) {
          queryValue = ProfileScreen.AUTH_PAGE;
        }
      }
      if (routerInstance) {
        const profileItem = (_c = AppState.state.childNavigationItems) == null ? void 0 : _c.find(
          (item) => {
            var _a2;
            return ((_a2 = item == null ? void 0 : item.name) == null ? void 0 : _a2.toLowerCase()) == "profile";
          }
        );
        if (profileItem && profileItem.routeName) {
          const routeName = profileItem.routeName[0];
          routerInstance.push({
            name: routeName,
            query: { activeScreen: queryValue }
          });
        } else {
          console.error(
            "Profile item or routeName not found in childNavigationItems"
          );
        }
      }
    };
    const mobileMenuItems = inject("mobileMenuItems");
    const iconMap = {
      Users01Icon: render$5,
      BookOpen01Icon: render$4,
      CurrencyDollarCircleIcon: render$1,
      FileCheck02Icon: render,
      Briefcase02Icon: render$3,
      FolderIcon: render$2
    };
    return (_ctx, _cache) => {
      const _directive_swipe = resolveDirective("swipe");
      return openBlock(), createElementBlock("div", null, [
        createVNode(unref(UIDrawer), {
          class: "!rounded-xl bg-gray-50 !bottom-4 !left-4 !right-4",
          show: showModal.value,
          "onUpdate:show": handleClose,
          placement: "bottom",
          id: "image-drawer",
          height: 60 * unref(mobileMenuItems).length
        }, {
          default: withCtx(() => [
            withDirectives((openBlock(), createBlock(unref(UIDrawerContent), {
              id: "image-drawer-menu",
              closable: false
            }, {
              default: withCtx(() => [
                (openBlock(true), createElementBlock(Fragment, null, renderList(unref(mobileMenuItems), (app, index2) => {
                  return openBlock(), createBlock(unref(UIButton), {
                    type: "default",
                    id: "btn-menu",
                    text: true,
                    key: app.key,
                    onClick: ($event) => app.title === "dashboard.manageSubscriptions" ? handleRoutes("BillingSubscription") : unref(externalPathRedirect)(app.route, app.path || "", false),
                    class: normalizeClass([
                      "flex items-center",
                      unref(mobileMenuItems).length - 1 !== index2 && "mb-4"
                    ])
                  }, {
                    default: withCtx(() => [
                      createVNode(unref(UIAvatar), {
                        id: "menu-options",
                        class: "bg-gray-200 w-10 h-10 rounded-md",
                        round: false
                      }, {
                        default: withCtx(() => [
                          (openBlock(), createBlock(resolveDynamicComponent(iconMap[app.icon] || app.icon), { class: "h-5 w-5 text-clientportal-font-primary mt-1" }))
                        ]),
                        _: 2
                      }, 1024),
                      createVNode(unref(UITextSmRegular), { class: "text-clientportal-font-primary ml-4" }, {
                        default: withCtx(() => [
                          createTextVNode(toDisplayString(unref(t2)(app.title)), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["onClick", "class"]);
                }), 128))
              ]),
              _: 1
            })), [
              [_directive_swipe, {
                direction: "down",
                callback: () => handleClose()
              }]
            ])
          ]),
          _: 1
        }, 8, ["show", "height"])
      ]);
    };
  }
});
const MenuModal = /* @__PURE__ */ _export_sfc(_sfc_main$14, [["__scopeId", "data-v-1a2aacfa"]]);
const _hoisted_1$Y = ["src", "alt"];
const _hoisted_2$H = { class: "mb-4 flex justify-between rounded-xl border border-solid border-clientportal-border p-4" };
const _hoisted_3$B = { class: "flex items-center" };
const _hoisted_4$z = { class: "ml-4" };
const _hoisted_5$s = { key: 0 };
const _sfc_main$13 = /* @__PURE__ */ defineComponent({
  __name: "ContractsWidgets",
  setup(__props) {
    const loadingContractId = ref(null);
    const contractData = inject("contractData");
    const getContractsData = inject("getContractsData");
    const componentsLength = inject("componentsLength");
    const contractDataCount = inject("contractDataCount");
    const currentPageNumber = ref(1);
    const isDataLoading = ref(false);
    const t2 = inject("t");
    async function handleScroll(event) {
      const { scrollTop, scrollHeight, clientHeight } = event.target;
      if (scrollTop + clientHeight >= scrollHeight - 1) {
        currentPageNumber.value += 1;
        if (contractData.value.length < contractDataCount.value) {
          isDataLoading.value = true;
          await getContractsData(currentPageNumber.value);
          isDataLoading.value = false;
        }
      }
    }
    const notification = useNotification();
    function notificationAlert(title, content) {
      notification.create({
        type: "error",
        title,
        content,
        duration: 5e3
      });
    }
    const handleDocumentAction = async (contract) => {
      var _a, _b, _c, _d;
      const locationId = isGokollab() ? contract.locationId : LocationState.state.locationId;
      try {
        if (contract.hasCompleted) {
          loadingContractId.value = contract.documentId;
          const data = await BillingService.downloadContractPdf({
            documentId: contract.documentId,
            altType: "location",
            altId: locationId,
            isPublicRequest: true
          });
          await AnalyticsService.trackPageViewEvents({
            locationId,
            eventType: CPPageEvents.CLIENT_PORTAL_CONTRACT_DOWNLOAD,
            platform: UserPlatform.PWA,
            route: (_a = data == null ? void 0 : data.data) == null ? void 0 : _a.url
          });
          await Browser.open({ url: (_b = data == null ? void 0 : data.data) == null ? void 0 : _b.url });
        } else {
          await AnalyticsService.trackPageViewEvents({
            locationId,
            eventType: CPPageEvents.CLIENT_PORTAL_CONTRACT_VIEW,
            platform: UserPlatform.PWA,
            route: contract == null ? void 0 : contract.url
          });
          await Browser.open({ url: contract == null ? void 0 : contract.url });
        }
      } catch (error) {
        notificationAlert(
          t2.value("widget.notAbleToDownloadContract"),
          ((_d = (_c = error == null ? void 0 : error.response) == null ? void 0 : _c.data) == null ? void 0 : _d.message) || t2.value("profileSettings.selectPageError")
        );
      } finally {
        loadingContractId.value = null;
      }
    };
    return (_ctx, _cache) => {
      return unref(contractData).length === 0 ? (openBlock(), createElementBlock("div", {
        key: 0,
        class: normalizeClass([
          "flex flex-col justify-center items-center",
          unref(calcHeight)(unref(componentsLength))
        ])
      }, [
        createElementVNode("img", {
          src: unref(EMPTY_FOLDER),
          alt: unref(t2)("widget.noInvoices"),
          class: "h-16 w-16"
        }, null, 8, _hoisted_1$Y),
        createVNode(unref(UITextXsRegular), { class: "text-clientportal-font-secondary mt-2" }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(unref(t2)("widget.youDoNotHaveAny")), 1)
          ]),
          _: 1
        })
      ], 2)) : (openBlock(), createElementBlock("div", {
        key: 1,
        class: normalizeClass([
          "col-span-2 overflow-y-auto rounded-xl bg-white py-4",
          unref(calcHeight)(unref(componentsLength))
        ]),
        onScroll: handleScroll
      }, [
        (openBlock(true), createElementBlock(Fragment, null, renderList(unref(contractData), (contract) => {
          return openBlock(), createElementBlock("div", {
            key: contract._id
          }, [
            createElementVNode("div", _hoisted_2$H, [
              createElementVNode("div", _hoisted_3$B, [
                createVNode(unref(UIAvatar), {
                  id: "file-logo",
                  class: normalizeClass([
                    "h-10 w-10",
                    contract.hasCompleted ? "bg-clientportal-fill" : "bg-warning-100"
                  ])
                }, {
                  default: withCtx(() => [
                    createVNode(unref(render$M), {
                      class: normalizeClass([
                        "h-5 w-5 mt-1",
                        contract.hasCompleted ? "text-clientportal-font-primary" : "text-warning-600"
                      ])
                    }, null, 8, ["class"])
                  ]),
                  _: 2
                }, 1032, ["class"]),
                createElementVNode("div", _hoisted_4$z, [
                  createVNode(unref(UITextMdMedium), { class: "text-clientportal-font-primary truncate max-w-[26vw]" }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(contract.name), 1)
                    ]),
                    _: 2
                  }, 1024),
                  createVNode(unref(UITextXsMedium), { class: "text-clientportal-font-secondary" }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(`${unref(t2)("widget.addedOn")} ${unref(formatDateDay)(contract.createdAt)}`), 1)
                    ]),
                    _: 2
                  }, 1024)
                ])
              ]),
              createVNode(unref(UIButton), {
                id: "contracts-view-all",
                type: "default",
                onClick: ($event) => handleDocumentAction(contract),
                class: normalizeClass([
                  "!font-semibold",
                  contract.hasCompleted && "text-clientportal-font-primary"
                ]),
                text: true
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(contract.hasCompleted ? unref(t2)("widget.download") : unref(t2)("widget.sign")) + " ", 1),
                  contract.hasCompleted ? (openBlock(), createElementBlock("div", _hoisted_5$s, [
                    loadingContractId.value === contract.documentId ? (openBlock(), createBlock(unref(UISpin), {
                      key: 0,
                      id: contract.documentId,
                      size: "small",
                      class: "ml-2 mt-2 h-5 w-5 text-clientportal-font-primary"
                    }, null, 8, ["id"])) : (openBlock(), createBlock(unref(render$c), {
                      key: 1,
                      class: "ml-2 h-5 w-5 text-clientportal-font-primary"
                    }))
                  ])) : (openBlock(), createBlock(unref(render$N), {
                    key: 1,
                    class: "ml-2 h-5 w-5"
                  }))
                ]),
                _: 2
              }, 1032, ["onClick", "class"])
            ])
          ]);
        }), 128)),
        isDataLoading.value ? (openBlock(), createBlock(unref(UISkeleton), {
          key: 0,
          class: "h-16 w-full rounded-xl"
        })) : createCommentVNode("", true)
      ], 34));
    };
  }
});
const ContractsWidgets = /* @__PURE__ */ _export_sfc(_sfc_main$13, [["__scopeId", "data-v-b653c470"]]);
const _hoisted_1$X = ["src", "alt"];
const _hoisted_2$G = { class: "mb-4 flex justify-between rounded-xl border border-solid border-clientportal-border p-4" };
const _hoisted_3$A = { class: "flex items-center" };
const _hoisted_4$y = { class: "ml-4" };
const _hoisted_5$r = { key: 0 };
const _sfc_main$12 = /* @__PURE__ */ defineComponent({
  __name: "EstimatesWidgets",
  setup(__props) {
    const loadingEstimateId = ref(null);
    const estimateData = inject("estimateData");
    const getEstimatesData = inject("getEstimatesData");
    const componentsLength = inject("componentsLength");
    const estimateDataCount = inject("estimateDataCount");
    const currentPageNumber = ref(1);
    const isDataLoading = ref(false);
    const t2 = inject("t");
    async function handleScroll(event) {
      const { scrollTop, scrollHeight, clientHeight } = event.target;
      if (scrollTop + clientHeight >= scrollHeight - 1) {
        currentPageNumber.value += 1;
        if (estimateData.value.length < estimateDataCount.value) {
          isDataLoading.value = true;
          await getEstimatesData(currentPageNumber.value);
          isDataLoading.value = false;
        }
      }
    }
    const notification = useNotification();
    function notificationAlert(title, content) {
      notification.create({
        type: "error",
        title,
        content,
        duration: 5e3
      });
    }
    const handleDocumentAction = async (estimate) => {
      var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
      const locationId = isGokollab() ? estimate.altId : LocationState.state.locationId;
      try {
        if (estimate.estimateStatus === EstimateStatus.ACCEPTED) {
          loadingEstimateId.value = estimate._id;
          const data = await BillingService.downloadEstimatePdf({
            estimateId: estimate._id,
            altType: "location",
            locationId
          });
          await AnalyticsService.trackPageViewEvents({
            locationId: LocationState.state.locationId,
            eventType: CPPageEvents.CLIENT_PORTAL_ESTIMATE_DOWNLOAD,
            platform: UserPlatform.PWA,
            route: (_a = data == null ? void 0 : data.data) == null ? void 0 : _a.url
          });
          await Browser.open({ url: (_b = data == null ? void 0 : data.data) == null ? void 0 : _b.url });
        } else {
          const link = await BillingService.generateUrl({
            locationId: (_d = (_c = LocationState) == null ? void 0 : _c.state) == null ? void 0 : _d.locationId,
            id: estimate._id,
            type: "estimate",
            contactId: (_f = (_e = UserState) == null ? void 0 : _e.state) == null ? void 0 : _f.userId
          });
          await AnalyticsService.trackPageViewEvents({
            locationId: LocationState.state.locationId,
            eventType: CPPageEvents.CLIENT_PORTAL_ESTIMATE_VIEW,
            platform: UserPlatform.PWA,
            route: (_g = link == null ? void 0 : link.data) == null ? void 0 : _g.url
          });
          await Browser.open({ url: (_h = link == null ? void 0 : link.data) == null ? void 0 : _h.url });
        }
      } catch (error) {
        notificationAlert(
          t2.value("widget.notAbleToDownloadContract"),
          ((_j = (_i = error == null ? void 0 : error.response) == null ? void 0 : _i.data) == null ? void 0 : _j.message) || t2.value("profileSettings.selectPageError")
        );
      } finally {
        loadingEstimateId.value = null;
      }
    };
    return (_ctx, _cache) => {
      return unref(estimateData).length === 0 ? (openBlock(), createElementBlock("div", {
        key: 0,
        class: normalizeClass([
          "flex flex-col justify-center items-center",
          unref(calcHeight)(unref(componentsLength))
        ])
      }, [
        createElementVNode("img", {
          src: unref(EMPTY_FOLDER),
          alt: unref(t2)("widget.noEstimates"),
          class: "h-16 w-16"
        }, null, 8, _hoisted_1$X),
        createVNode(unref(UITextXsRegular), { class: "text-clientportal-font-secondary mt-2" }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(unref(t2)("widget.youDoNotHaveAny")), 1)
          ]),
          _: 1
        })
      ], 2)) : (openBlock(), createElementBlock("div", {
        key: 1,
        class: normalizeClass([
          "col-span-2 overflow-y-auto rounded-xl bg-white py-4",
          unref(calcHeight)(unref(componentsLength))
        ]),
        onScroll: handleScroll
      }, [
        (openBlock(true), createElementBlock(Fragment, null, renderList(unref(estimateData), (estimate) => {
          return openBlock(), createElementBlock("div", {
            key: estimate._id
          }, [
            createElementVNode("div", _hoisted_2$G, [
              createElementVNode("div", _hoisted_3$A, [
                createVNode(unref(UIAvatar), {
                  id: "file-logo",
                  class: normalizeClass([
                    "h-10 w-10",
                    estimate.estimateStatus === unref(EstimateStatus).ACCEPTED ? "bg-clientportal-fill" : "bg-warning-100"
                  ])
                }, {
                  default: withCtx(() => [
                    createVNode(unref(render$M), {
                      class: normalizeClass([
                        "h-5 w-5 mt-1",
                        estimate.estimateStatus === unref(EstimateStatus).ACCEPTED ? "text-clientportal-font-primary" : "text-warning-600"
                      ])
                    }, null, 8, ["class"])
                  ]),
                  _: 2
                }, 1032, ["class"]),
                createElementVNode("div", _hoisted_4$y, [
                  createVNode(unref(UITextMdMedium), { class: "text-clientportal-font-primary truncate max-w-[26vw]" }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(estimate.name), 1)
                    ]),
                    _: 2
                  }, 1024),
                  createVNode(unref(UITextXsMedium), { class: "text-clientportal-font-secondary" }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(`${unref(t2)("widget.addedOn")} ${unref(formatDateDay)(estimate.createdAt)}`), 1)
                    ]),
                    _: 2
                  }, 1024)
                ])
              ]),
              createVNode(unref(UIButton), {
                id: "contracts-view-all",
                type: "default",
                onClick: ($event) => handleDocumentAction(estimate),
                class: normalizeClass([
                  "!font-semibold",
                  estimate.estimateStatus === unref(EstimateStatus).ACCEPTED && "text-clientportal-font-primary"
                ]),
                text: true
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(estimate.estimateStatus === unref(EstimateStatus).ACCEPTED ? unref(t2)("common.download") : unref(t2)("common.view")) + " ", 1),
                  estimate.estimateStatus === unref(EstimateStatus).ACCEPTED ? (openBlock(), createElementBlock("div", _hoisted_5$r, [
                    loadingEstimateId.value === estimate._id ? (openBlock(), createBlock(unref(UISpin), {
                      key: 0,
                      id: estimate._id,
                      size: "small",
                      class: "ml-2 mt-2 h-5 w-5 text-clientportal-font-primary"
                    }, null, 8, ["id"])) : (openBlock(), createBlock(unref(render$c), {
                      key: 1,
                      class: "ml-2 h-5 w-5 text-clientportal-font-primary"
                    }))
                  ])) : (openBlock(), createBlock(unref(render$O), {
                    key: 1,
                    class: "ml-2 h-5 w-5"
                  }))
                ]),
                _: 2
              }, 1032, ["onClick", "class"])
            ])
          ]);
        }), 128)),
        isDataLoading.value ? (openBlock(), createBlock(unref(UISkeleton), {
          key: 0,
          class: "h-16 w-full rounded-xl"
        })) : createCommentVNode("", true)
      ], 34));
    };
  }
});
const EstimatesWidgets = /* @__PURE__ */ _export_sfc(_sfc_main$12, [["__scopeId", "data-v-3bcdf6c9"]]);
const _hoisted_1$W = ["src", "alt"];
const _hoisted_2$F = { class: "mb-4 flex items-center justify-between rounded-xl border border-solid border-clientportal-border p-4" };
const _hoisted_3$z = { class: "flex items-center" };
const _hoisted_4$x = { class: "ml-4" };
const _hoisted_5$q = { key: 0 };
const _sfc_main$11 = /* @__PURE__ */ defineComponent({
  __name: "InvoicesWidgets",
  setup(__props) {
    const invoiceData = inject("invoiceData");
    const getInvoiceData = inject("getInvoiceData");
    const invoiceDataCount = inject("invoiceDataCount");
    const componentsLength = inject("componentsLength");
    const currentPageNumber = ref(1);
    const isDataLoading = ref(false);
    const t2 = inject("t");
    const loadingInvoiceId = ref(null);
    async function handleScroll(event) {
      const { scrollTop, scrollHeight, clientHeight } = event.target;
      if (scrollTop + clientHeight >= scrollHeight - 1) {
        currentPageNumber.value += 1;
        if (invoiceData.value.length < invoiceDataCount.value) {
          isDataLoading.value = true;
          await getInvoiceData(currentPageNumber.value);
          isDataLoading.value = false;
        }
      }
    }
    const notification = useNotification();
    function notificationAlert(title, content) {
      notification.create({
        type: "error",
        title,
        content,
        duration: 5e3
      });
    }
    async function handleActionInvoice(invoice) {
      var _a, _b, _c, _d, _e, _f;
      const id = invoice._id;
      const isDownloadable = invoice.customFields.isDownloadable;
      const locationId = isGokollab() ? invoice.altId : (_b = (_a = LocationState) == null ? void 0 : _a.state) == null ? void 0 : _b.locationId;
      const contactId = isGokollab() ? invoice.contactDetails.id : (_d = (_c = UserState) == null ? void 0 : _c.state) == null ? void 0 : _d.userId;
      try {
        if (isDownloadable) {
          loadingInvoiceId.value = id;
          const data = await BillingService.downloadInvoiceById({
            locationId,
            invoiceId: id,
            contactId
          });
          await Browser.open({ url: (_e = data == null ? void 0 : data.data) == null ? void 0 : _e.url });
        } else {
          const link = await BillingService.generateUrl({
            locationId,
            id,
            type: "invoice",
            contactId
          });
          await Browser.open({ url: (_f = link == null ? void 0 : link.data) == null ? void 0 : _f.url });
        }
      } catch (error) {
        notificationAlert(
          t2("widget.notAbleToDownloadInvoice"),
          (error == null ? void 0 : error.message) || t2("profileSettings.selectPageError")
        );
      } finally {
        loadingInvoiceId.value = null;
      }
    }
    return (_ctx, _cache) => {
      return unref(invoiceData).length === 0 ? (openBlock(), createElementBlock("div", {
        key: 0,
        class: normalizeClass([
          "flex flex-col justify-center items-center",
          unref(calcHeight)(unref(componentsLength))
        ])
      }, [
        createElementVNode("img", {
          src: unref(EMPTY_FOLDER),
          alt: unref(t2)("widget.noInvoices"),
          class: "h-16 w-16"
        }, null, 8, _hoisted_1$W),
        createVNode(unref(UITextXsRegular), {
          class: "text-clientportal-font-secondary mt-2",
          id: "no-invoices-text"
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(unref(t2)("widget.youDoNotHaveAny")), 1)
          ]),
          _: 1
        })
      ], 2)) : (openBlock(), createElementBlock("div", {
        key: 1,
        class: normalizeClass([
          "col-span-2 overflow-y-auto rounded-xl bg-white py-4",
          unref(calcHeight)(unref(componentsLength))
        ]),
        onScroll: handleScroll
      }, [
        (openBlock(true), createElementBlock(Fragment, null, renderList(unref(invoiceData), (invoice) => {
          return openBlock(), createElementBlock("div", {
            key: invoice._id
          }, [
            createElementVNode("div", _hoisted_2$F, [
              createElementVNode("div", _hoisted_3$z, [
                createVNode(unref(UIAvatar), {
                  id: "file-logo",
                  class: normalizeClass(["h-10 w-10", invoice.customFields.avatarColor])
                }, {
                  default: withCtx(() => [
                    createVNode(unref(render$P), {
                      class: normalizeClass(["h-5 w-5 mt-1", invoice.customFields.iconColor])
                    }, null, 8, ["class"])
                  ]),
                  _: 2
                }, 1032, ["class"]),
                createElementVNode("div", _hoisted_4$x, [
                  createVNode(unref(UITextMdMedium), { class: "text-clientportal-font-primary truncate max-w-[26vw]" }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(unref(t2)(`widget.invoice`)) + " #" + toDisplayString(invoice.invoiceNumber), 1)
                    ]),
                    _: 2
                  }, 1024),
                  createVNode(unref(UITextXsMedium), {
                    class: normalizeClass([invoice.customFields.textColor])
                  }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(unref(t2)(invoice.customFields.text) + " " + invoice.customFields.status), 1)
                    ]),
                    _: 2
                  }, 1032, ["class"])
                ])
              ]),
              createVNode(unref(UIButton), {
                id: "contracts-view-all",
                type: "default",
                class: normalizeClass([
                  "!font-semibold",
                  invoice.customFields.isDownloadable && "text-clientportal-font-primary"
                ]),
                text: true,
                onClick: ($event) => handleActionInvoice(invoice)
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(invoice.customFields.isDownloadable ? unref(t2)("widget.download") : unref(t2)("widget.payment")) + " ", 1),
                  invoice.customFields.isDownloadable ? (openBlock(), createElementBlock("div", _hoisted_5$q, [
                    loadingInvoiceId.value === invoice._id ? (openBlock(), createBlock(unref(UISpin), {
                      key: 0,
                      id: invoice._id,
                      size: "small",
                      class: "ml-2 mt-2 h-5 w-5 text-clientportal-font-primary"
                    }, null, 8, ["id"])) : (openBlock(), createBlock(unref(render$c), {
                      key: 1,
                      class: "ml-2 h-5 w-5 text-clientportal-font-primary"
                    }))
                  ])) : (openBlock(), createBlock(unref(render$N), {
                    key: 1,
                    class: "ml-2 h-5 w-5"
                  }))
                ]),
                _: 2
              }, 1032, ["class", "onClick"])
            ])
          ]);
        }), 128)),
        isDataLoading.value ? (openBlock(), createBlock(unref(UISkeleton), {
          key: 0,
          class: "h-16 w-full rounded-xl"
        })) : createCommentVNode("", true)
      ], 34));
    };
  }
});
const InvoicesWidgets = /* @__PURE__ */ _export_sfc(_sfc_main$11, [["__scopeId", "data-v-c6abafa8"]]);
var DOCUMENT_TYPE = /* @__PURE__ */ ((DOCUMENT_TYPE2) => {
  DOCUMENT_TYPE2["SHARED"] = "shared";
  DOCUMENT_TYPE2["RECEIVED"] = "received";
  return DOCUMENT_TYPE2;
})(DOCUMENT_TYPE || {});
const _hoisted_1$V = { class: "flex flex-col" };
const _hoisted_2$E = { class: "p-0" };
const _hoisted_3$y = { class: "flex justify-between items-center" };
const _sfc_main$10 = /* @__PURE__ */ defineComponent({
  __name: "DeleteConfirmationPopup",
  emits: ["update:show", "confirmDelete"],
  setup(__props, { emit: __emit }) {
    const showDeleteDrawer = ref(false);
    const t2 = inject("t");
    const emit = __emit;
    const handleDelete = () => {
      emit("confirmDelete");
      handleClose();
    };
    function handleClose() {
      showDeleteDrawer.value = false;
      emit("update:show", false);
    }
    return (_ctx, _cache) => {
      const _directive_swipe = resolveDirective("swipe");
      return openBlock(), createBlock(unref(UIDrawer), {
        class: "rounded-t-xl bg-white",
        show: showDeleteDrawer.value,
        "onUpdate:show": [
          _cache[0] || (_cache[0] = ($event) => showDeleteDrawer.value = $event),
          handleClose
        ],
        placement: "bottom",
        id: "image-drawer",
        height: 280
      }, {
        default: withCtx(() => [
          withDirectives((openBlock(), createBlock(unref(UIDrawerContent), {
            id: "image-drawer-menu",
            closable: false
          }, {
            default: withCtx(() => [
              createElementVNode("div", _hoisted_1$V, [
                _cache[1] || (_cache[1] = createElementVNode("div", { class: "mt-2 h-1 w-16 mb-4 rounded-md border border-solid bg-gray-200 border-gray-200 self-center" }, null, -1)),
                createElementVNode("div", _hoisted_2$E, [
                  createElementVNode("div", _hoisted_3$y, [
                    createVNode(unref(UITextLgMedium), { class: "text-lg font-semibold mb-4" }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(unref(t2)("uploadDocument.confirmDeletion")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  createElementVNode("div", null, [
                    createVNode(unref(UITextSmRegular), { class: "text-clientportal-font-secondary font-sans" }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(unref(t2)("uploadDocument.deleteFileDescription")), 1)
                      ]),
                      _: 1
                    }),
                    createVNode(unref(UITextSmMedium), { class: "text-clientportal-font-secondary font-sans mt-2 font-semibold" }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(unref(t2)("uploadDocument.deleteFileDescription")), 1)
                      ]),
                      _: 1
                    }),
                    createVNode(unref(UIButton), {
                      id: "conform-cancel-subscription",
                      class: "w-full mt-4",
                      type: "error",
                      onClick: handleDelete
                    }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(unref(t2)("common.delete")), 1)
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ]),
            _: 1
          })), [
            [_directive_swipe, {
              direction: "down",
              callback: () => handleClose()
            }]
          ])
        ]),
        _: 1
      }, 8, ["show"]);
    };
  }
});
const FILE_SIZE_LIMIT = 100 * 1024 * 1024;
const allowedFileTypesString = ".pdf,.jpeg,.png,.gif,.txt,.csv,.doc,.docx,.ppt,.pptx,.xls,.xlsx,.jpg";
function checkAllowedExtension(allowedTypeString, fileName) {
  var _a;
  const extension = (_a = fileName.split(".").pop()) == null ? void 0 : _a.toLowerCase();
  const allowedType = allowedTypeString.split(",");
  return allowedType.includes(`.${extension}`);
}
const _hoisted_1$U = ["accept"];
const _sfc_main$$ = /* @__PURE__ */ defineComponent({
  __name: "UploadDocumentPopup",
  emits: ["update:show", "uploaded"],
  setup(__props, { emit: __emit }) {
    const emit = __emit;
    const t2 = inject("t");
    const notification = useNotification();
    const showModal = ref(false);
    const fileInput = ref(null);
    const isSaveDisabled = ref(true);
    const fileList = ref([]);
    const fileUploadingRef = ref(null);
    const handleClose = () => {
      showModal.value = false;
      fileList.value = [];
      emit("update:show", false);
    };
    watchEffect(() => {
      isSaveDisabled.value = fileList.value.length === 0;
    });
    function handleUpload() {
      var _a;
      (_a = fileInput.value) == null ? void 0 : _a.click();
    }
    async function handleFileChange(event) {
      const files = Array.from(
        event.target.files || []
      );
      if (files.length > 10) {
        notification.error({
          title: t2.value("uploadDocument.maxFilesExceeded")
        });
        return;
      }
      for (const file of files) {
        if (file.size > FILE_SIZE_LIMIT) {
          notification.error({
            title: t2.value("uploadDocument.fileSizeExceeded")
          });
          continue;
        }
        if (!checkAllowedExtension(allowedFileTypesString, file.name)) {
          notification.error({
            title: t2.value("uploadDocument.invalidFileType")
          });
          continue;
        }
        await uploadFile(file);
      }
    }
    async function uploadFile(file) {
      var _a, _b, _c;
      try {
        (_a = fileUploadingRef.value) == null ? void 0 : _a.startLoadBar();
        await DashboardService.uploadSharedFiles(
          LocationState.state.locationId,
          UserState.state.userId,
          SourceType.CLIENT_PORTAL,
          file
        );
        notification.success({
          title: t2.value("uploadDocument.fileUploadedSuccessfully"),
          duration: 5e3
        });
        emit("uploaded");
      } catch (error) {
        (_b = fileUploadingRef.value) == null ? void 0 : _b.errorLoadBar();
        notification.error({
          title: t2.value("uploadDocument.notAbleToUploadFile"),
          duration: 5e3
        });
      } finally {
        handleClose();
        (_c = fileUploadingRef.value) == null ? void 0 : _c.stopLoadBar();
      }
    }
    return (_ctx, _cache) => {
      const _directive_swipe = resolveDirective("swipe");
      return openBlock(), createBlock(unref(UIDrawer), {
        class: "!rounded-xl bg-gray-50 !bottom-4 !left-4 !right-4",
        show: showModal.value,
        "onUpdate:show": handleClose,
        placement: "bottom",
        id: "file-drawer",
        height: 80
      }, {
        default: withCtx(() => [
          withDirectives((openBlock(), createBlock(unref(UIDrawerContent), {
            id: "file-drawer-menu",
            closable: false
          }, {
            default: withCtx(() => [
              createElementVNode("input", {
                ref_key: "fileInput",
                ref: fileInput,
                type: "file",
                multiple: "",
                accept: unref(allowedFileTypesString),
                class: "hidden",
                onChange: handleFileChange
              }, null, 40, _hoisted_1$U),
              createVNode(unref(UIButton), {
                type: "default",
                id: "btn-upload",
                text: true,
                class: "flex justify-between w-full",
                onClick: handleUpload
              }, {
                default: withCtx(() => [
                  createVNode(unref(UIAvatar), {
                    id: "upload-option",
                    class: "bg-gray-200 w-10 h-10 rounded-md",
                    round: false
                  }, {
                    default: withCtx(() => [
                      createVNode(unref(render$Q), { class: "h-5 w-5 text-clientportal-font-primary mt-1" })
                    ]),
                    _: 1
                  }),
                  createVNode(unref(UITextSmRegular), { class: "text-clientportal-font-primary ml-4" }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(unref(t2)("widget.uploadFile")), 1)
                    ]),
                    _: 1
                  }),
                  createVNode(unref(UILoadingBar), {
                    ref_key: "fileUploadingRef",
                    ref: fileUploadingRef,
                    containerStyle: { position: "absolute" }
                  }, null, 512)
                ]),
                _: 1
              })
            ]),
            _: 1
          })), [
            [_directive_swipe, {
              direction: "down",
              callback: () => handleClose()
            }]
          ])
        ]),
        _: 1
      }, 8, ["show"]);
    };
  }
});
const _hoisted_1$T = ["src", "alt"];
const _hoisted_2$D = { class: "mb-4 flex justify-between items-center rounded-xl border border-solid border-clientportal-border p-4" };
const _hoisted_3$x = { class: "flex items-center" };
const _hoisted_4$w = { class: "ml-4" };
const _sfc_main$_ = /* @__PURE__ */ defineComponent({
  __name: "SharedFilesWidgets",
  setup(__props) {
    const sharedFilesData = inject("sharedFilesData");
    const getSharedFilesData = inject("getSharedFilesData");
    const componentsLength = inject("componentsLength");
    const sharedFilesDataCount = inject("sharedFilesDataCount");
    const t2 = inject("t");
    const currentPageNumber = ref(1);
    const isDataLoading = ref(false);
    const isFileDeleting = ref(false);
    const fileToDeleteId = ref(null);
    const fileToDeleteLocationId = ref(null);
    const fileToDeleteContactId = ref(null);
    const showDeleteModal = ref(false);
    const showFileModal = ref(false);
    const fileDownloadingRef = ref(null);
    const isNewFileUploading = ref(false);
    const debouncedScroll = debounce(async (event) => {
      const target = event.target;
      const { scrollTop, scrollHeight, clientHeight } = target;
      if (scrollTop + clientHeight >= scrollHeight - 1) {
        currentPageNumber.value += 1;
        if ((sharedFilesData == null ? void 0 : sharedFilesData.value.length) < sharedFilesDataCount.value) {
          isDataLoading.value = true;
          await (getSharedFilesData == null ? void 0 : getSharedFilesData(currentPageNumber.value));
          isDataLoading.value = false;
        }
      }
    }, 200);
    const notification = useNotification();
    async function handlePreview(id) {
      await AnalyticsService.trackPageViewEvents({
        locationId: LocationState.state.locationId,
        eventType: CPPageEvents.CLIENT_PORTAL_SHARED_FILE_VIEW,
        platform: UserPlatform.PWA,
        route: `${AppState.getConfig().DOCUMENT_MANAGEMENT_SERVICE}/download/${id}`
      });
      await Browser.open({
        url: `${AppState.getConfig().DOCUMENT_MANAGEMENT_SERVICE}/download/${id}`
      });
    }
    const handleAddFiles = () => {
      showFileModal.value = true;
    };
    async function handleDelete(sharedFile) {
      var _a, _b, _c, _d;
      fileToDeleteId.value = sharedFile.id;
      fileToDeleteLocationId.value = isGokollab() ? sharedFile.locationId : (_b = (_a = LocationState) == null ? void 0 : _a.state) == null ? void 0 : _b.locationId;
      fileToDeleteContactId.value = isGokollab() ? sharedFile.contactId : (_d = (_c = UserState) == null ? void 0 : _c.state) == null ? void 0 : _d.userId;
      showDeleteModal.value = true;
    }
    async function deleteFile() {
      var _a, _b;
      try {
        await BillingService.deleteSharedFile({
          documentId: fileToDeleteId.value,
          locationId: fileToDeleteLocationId.value,
          contactId: fileToDeleteContactId.value,
          documentType: DOCUMENT_TYPE.RECEIVED
        });
        notification.success({
          title: t2.value("uploadDocument.deleteFileSuccessTitle"),
          duration: 5e3
        });
        if (isNewFileUploading.value) return;
        isFileDeleting.value = true;
        currentPageNumber.value = 1;
        if (sharedFilesData) {
          sharedFilesData.value = [];
        }
        await (getSharedFilesData == null ? void 0 : getSharedFilesData(1));
      } catch (error) {
        notification.error({
          title: t2.value("uploadDocument.deleteFileErrorTitle"),
          content: ((_b = (_a = error == null ? void 0 : error.response) == null ? void 0 : _a.data) == null ? void 0 : _b.message) || t2.value("uploadDocument.deleteFileErrorMessage"),
          duration: 5e3
        });
      } finally {
        isFileDeleting.value = false;
      }
    }
    async function onSelect(key, sharedFile) {
      switch (key) {
        case FileAction.PREVIEW: {
          handlePreview(sharedFile.id);
          return;
        }
        case FileAction.DELETE: {
          handleDelete(sharedFile);
          return;
        }
      }
    }
    function getFileOptions(sharedFile) {
      const options = [
        {
          label: t2.value("common.view"),
          key: "Preview",
          icon() {
            return h(renderIcon$1(render$R), null, {});
          }
        }
      ];
      if (sharedFile.source === SourceType.CLIENT_PORTAL) {
        options.push({
          label: () => h(
            "span",
            { class: "text-clientportal-error-primary" },
            t2.value("common.delete")
          ),
          key: "Delete",
          icon() {
            return h(
              renderIcon$1(render$C),
              { class: "text-clientportal-error-primary" },
              {}
            );
          }
        });
      }
      return options;
    }
    const handleUpload = async () => {
      if (isNewFileUploading.value) return;
      isNewFileUploading.value = true;
      currentPageNumber.value = 1;
      if (sharedFilesData) {
        sharedFilesData.value = [];
      }
      await (getSharedFilesData == null ? void 0 : getSharedFilesData(1));
      isNewFileUploading.value = false;
    };
    return (_ctx, _cache) => {
      var _a;
      return openBlock(), createElementBlock(Fragment, null, [
        createVNode(unref(UILoadingBar), {
          ref_key: "fileDownloadingRef",
          ref: fileDownloadingRef,
          containerStyle: {
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            zIndex: 100
          }
        }, null, 512),
        !unref(isGokollab)() ? (openBlock(), createBlock(unref(UIButton), {
          key: 0,
          id: "add-files-button",
          onClick: handleAddFiles,
          class: "w-full mb-4 rounded-xl border border-solid border-clientportal-border flex items-center justify-center gap-2 bg-white sticky top-0 z-10 backdrop-blur shadow-sm"
        }, {
          default: withCtx(() => [
            _cache[3] || (_cache[3] = createElementVNode("span", { class: "text-xl font-medium mr-1" }, "+ ", -1)),
            createTextVNode(" " + toDisplayString(unref(t2)("widget.addFiles")), 1)
          ]),
          _: 1
        })) : createCommentVNode("", true),
        isNewFileUploading.value || isFileDeleting.value ? (openBlock(), createElementBlock(Fragment, { key: 1 }, renderList(10, (n) => {
          return createElementVNode("div", {
            key: n,
            class: "mb-4"
          }, [
            createVNode(unref(UISkeleton), { class: "h-[72px] w-full rounded-xl" })
          ]);
        }), 64)) : ((_a = unref(sharedFilesData)) == null ? void 0 : _a.length) === 0 ? (openBlock(), createElementBlock("div", {
          key: 2,
          class: normalizeClass([
            "flex flex-col justify-center items-center",
            unref(calcHeight)(unref(componentsLength))
          ]),
          role: "status",
          "aria-label": "No files available"
        }, [
          createElementVNode("img", {
            src: unref(EMPTY_FOLDER),
            alt: unref(t2)("widget.noFiles"),
            class: "h-16 w-16"
          }, null, 8, _hoisted_1$T),
          createVNode(unref(UITextXsRegular), { class: "text-clientportal-font-secondary mt-2" }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(unref(t2)("widget.youDoNotHaveAny")), 1)
            ]),
            _: 1
          })
        ], 2)) : (openBlock(), createElementBlock("div", {
          key: 3,
          class: normalizeClass([
            "col-span-2 overflow-y-auto rounded-xl bg-white relative",
            unref(calcHeight)(unref(componentsLength))
          ]),
          onScroll: _cache[0] || (_cache[0] = //@ts-ignore
          (...args) => unref(debouncedScroll) && unref(debouncedScroll)(...args)),
          role: "list",
          "aria-label": "Shared files list"
        }, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(unref(sharedFilesData), (sharedFile) => {
            return openBlock(), createElementBlock("div", {
              key: sharedFile._id,
              role: "listitem"
            }, [
              createElementVNode("div", _hoisted_2$D, [
                createElementVNode("div", _hoisted_3$x, [
                  createVNode(unref(UIAvatar), {
                    id: "file-logo",
                    class: "bg-clientportal-fill h-10 w-10",
                    "aria-label": "File icon"
                  }, {
                    default: withCtx(() => [
                      createVNode(unref(render$P), { class: "text-clientportal-font-primary h-5 w-5 mt-1" })
                    ]),
                    _: 1
                  }),
                  createElementVNode("div", _hoisted_4$w, [
                    createVNode(unref(UITextMdMedium), { class: "text-clientportal-font-primary truncate max-w-[26vw]" }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(sharedFile.name), 1)
                      ]),
                      _: 2
                    }, 1024),
                    createVNode(unref(UITextXsMedium), { class: "text-clientportal-font-secondary" }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(`${unref(t2)("widget.addedOn")} ${unref(formatDateDay)(
                          sharedFile.createdAt
                        )} ${unref(t2)("widget.by")} ${sharedFile.source === unref(SourceType).CLIENT_PORTAL ? unref(t2)("widget.you") : unref(t2)("widget.admin")}`), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ])
                ]),
                createVNode(unref(UIDropdown), {
                  options: getFileOptions(sharedFile),
                  onSelect: (key) => onSelect(key, sharedFile),
                  id: "fileActionOptions"
                }, {
                  default: withCtx(() => [
                    createVNode(unref(render$o), { class: "w-5 h-5" })
                  ]),
                  _: 2
                }, 1032, ["options", "onSelect"])
              ])
            ]);
          }), 128)),
          isDataLoading.value ? (openBlock(), createBlock(unref(UISkeleton), {
            key: 0,
            class: "h-16 w-full rounded-xl",
            "aria-label": "Loading more files"
          })) : createCommentVNode("", true)
        ], 34)),
        createVNode(_sfc_main$$, {
          show: showFileModal.value,
          "onUpdate:show": _cache[1] || (_cache[1] = ($event) => showFileModal.value = $event),
          onUploaded: handleUpload
        }, null, 8, ["show"]),
        createVNode(_sfc_main$10, {
          show: showDeleteModal.value,
          "onUpdate:show": _cache[2] || (_cache[2] = ($event) => showDeleteModal.value = $event),
          onConfirmDelete: deleteFile
        }, null, 8, ["show"])
      ], 64);
    };
  }
});
const SharedFilesWidgets = /* @__PURE__ */ _export_sfc(_sfc_main$_, [["__scopeId", "data-v-01ccddaa"]]);
const _hoisted_1$S = {
  key: 0,
  class: "col-span-2 mt-2 mb-6"
};
const _hoisted_2$C = {
  key: 1,
  class: ""
};
const _sfc_main$Z = /* @__PURE__ */ defineComponent({
  __name: "MobileTabs",
  props: {
    visibleTabs: {
      type: Array,
      required: true
    }
  },
  setup(__props) {
    const isLoading = inject("isLoading");
    const componentMap = {
      InvoicesWidgets,
      ContractsWidgets,
      EstimatesWidgets,
      SharedFilesWidgets
    };
    return (_ctx, _cache) => {
      var _a;
      return unref(isLoading) ? (openBlock(), createElementBlock("div", _hoisted_1$S, [
        createVNode(unref(UISkeleton), {
          text: false,
          repeat: 1,
          class: "h-20 rounded-xl"
        })
      ])) : (openBlock(), createElementBlock("div", _hoisted_2$C, [
        createVNode(unref(UITabs), {
          type: "line",
          animated: true,
          placement: "top",
          value: void 0,
          defaultValue: (_a = __props.visibleTabs[0]) == null ? void 0 : _a.name
        }, {
          default: withCtx(() => [
            (openBlock(true), createElementBlock(Fragment, null, renderList(__props.visibleTabs, (tab) => {
              return openBlock(), createBlock(unref(UITabPane), {
                key: tab.key || tab.name,
                name: tab.name,
                tab: tab.name
              }, {
                default: withCtx(() => [
                  componentMap[tab.component] ? (openBlock(), createBlock(resolveDynamicComponent(componentMap[tab.component] || tab.component), { key: 0 })) : createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["name", "tab"]);
            }), 128))
          ]),
          _: 1
        }, 8, ["defaultValue"])
      ]));
    };
  }
});
const MobileTabs = /* @__PURE__ */ _export_sfc(_sfc_main$Z, [["__scopeId", "data-v-2c19c2d4"]]);
const _hoisted_1$R = { class: "col-span-2 mt-2 mb-4 rounded-xl p-4 shadow" };
const _hoisted_2$B = { class: "flex justify-between items-center" };
const _hoisted_3$w = { class: "max-w-48" };
const _hoisted_4$v = { class: "flex items-center" };
const _hoisted_5$p = { class: "ml-4" };
const _hoisted_6$n = { class: "mt-2" };
const _hoisted_7$i = { class: "progress" };
const _sfc_main$Y = /* @__PURE__ */ defineComponent({
  __name: "CoursesWidgets",
  setup(__props) {
    const dashboardManager2 = inject("dashboardManager");
    const coursesActivityData = computed(
      () => {
        var _a;
        return ((_a = dashboardManager2 == null ? void 0 : dashboardManager2.data) == null ? void 0 : _a.coursesActivity) || {};
      }
    );
    const t2 = inject("t");
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$R, [
        createElementVNode("div", _hoisted_2$B, [
          createElementVNode("div", _hoisted_3$w, [
            createElementVNode("div", _hoisted_4$v, [
              createVNode(unref(UIAvatar), {
                id: "file-logo",
                class: "h-10 w-10 bg-primary-50"
              }, {
                default: withCtx(() => [
                  createVNode(unref(render$P), { class: "h-5 w-5 mt-1 text-clientportal-font-primary" })
                ]),
                _: 1
              }),
              createElementVNode("div", _hoisted_5$p, [
                createVNode(unref(UITextSmMedium), { class: "text-clientportal-font-primary" }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(unref(t2)("widget.courseProgress")), 1)
                  ]),
                  _: 1
                })
              ])
            ]),
            createElementVNode("div", _hoisted_6$n, [
              createVNode(unref(UITextXsMedium), { class: "text-clientportal-font-primary truncate" }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(coursesActivityData.value.courseName), 1)
                ]),
                _: 1
              }),
              createVNode(unref(UITextXsRegular), { class: "text-clientportal-font-primary truncate" }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(`You marked ${coursesActivityData.value.completedPosts}/${coursesActivityData.value.totalPosts} in course`), 1)
                ]),
                _: 1
              }),
              createVNode(unref(UIButton), {
                id: "courses-btn",
                type: "default",
                class: "!font-semibold !text-xs text-clientportal-tertiary",
                text: true,
                onClick: _cache[0] || (_cache[0] = ($event) => unref(externalPathRedirect)(
                  `courses/products/${coursesActivityData.value.productId}`,
                  "",
                  false
                ))
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(unref(t2)("widget.completeCourse")), 1)
                ]),
                _: 1
              })
            ])
          ]),
          createElementVNode("div", _hoisted_7$i, [
            createVNode(unref(UIProgress), {
              type: "circle",
              gapDegree: 0,
              percentage: coursesActivityData.value.progress,
              strokeWidth: 12,
              offsetDegree: 180,
              color: "var(--tertiary)",
              railColor: "var(--primary-100)"
            }, null, 8, ["percentage"])
          ])
        ])
      ]);
    };
  }
});
const CoursesWidgets = /* @__PURE__ */ _export_sfc(_sfc_main$Y, [["__scopeId", "data-v-0a287324"]]);
const _hoisted_1$Q = {
  key: 0,
  class: "col-span-2 mt-2 mb-4 rounded-xl p-4 shadow"
};
const _hoisted_2$A = { class: "flex justify-between items-center" };
const _hoisted_3$v = { class: "max-w-48" };
const _hoisted_4$u = { class: "flex items-center" };
const _hoisted_5$o = { class: "ml-4" };
const _hoisted_6$m = { class: "mt-2" };
const _hoisted_7$h = ["src"];
const _sfc_main$X = /* @__PURE__ */ defineComponent({
  __name: "GroupsWidgets",
  setup(__props) {
    const dashboardManager2 = inject("dashboardManager");
    const groupsData = computed(() => {
      var _a;
      return ((_a = dashboardManager2 == null ? void 0 : dashboardManager2.data) == null ? void 0 : _a.groups) || [];
    });
    const t2 = inject("t");
    return (_ctx, _cache) => {
      var _a, _b, _c, _d;
      return groupsData.value.length > 0 ? (openBlock(), createElementBlock("div", _hoisted_1$Q, [
        createElementVNode("div", _hoisted_2$A, [
          createElementVNode("div", _hoisted_3$v, [
            createElementVNode("div", _hoisted_4$u, [
              createVNode(unref(UIAvatar), {
                id: "file-logo",
                class: "h-10 w-10 bg-primary-50"
              }, {
                default: withCtx(() => [
                  createVNode(unref(render$S), { class: "h-5 w-5 mt-1 text-clientportal-font-primary" })
                ]),
                _: 1
              }),
              createElementVNode("div", _hoisted_5$o, [
                createVNode(unref(UITextSmMedium), { class: "text-clientportal-font-primary" }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(unref(t2)("widget.recentlyOpened")), 1)
                  ]),
                  _: 1
                })
              ])
            ]),
            createElementVNode("div", _hoisted_6$m, [
              createVNode(unref(UITextXsMedium), { class: "text-clientportal-font-primary truncate" }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(groupsData.value[0].name), 1)
                ]),
                _: 1
              }),
              createVNode(unref(UITextXsRegular), { class: "text-clientportal-font-primary truncate" }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(groupsData.value[0].description), 1)
                ]),
                _: 1
              }),
              createVNode(unref(UIButton), {
                id: "courses-btn",
                type: "default",
                class: "!font-semibold !text-xs text-clientportal-tertiary",
                text: true,
                onClick: _cache[0] || (_cache[0] = ($event) => unref(externalPathRedirect)(
                  `communities/groups/${groupsData.value[0].slug}/home`,
                  "",
                  false
                ))
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(unref(t2)("widget.viewGroup")), 1)
                ]),
                _: 1
              })
            ])
          ]),
          createElementVNode("img", {
            src: ((_b = (_a = groupsData.value[0]) == null ? void 0 : _a.branding) == null ? void 0 : _b.cover) ? (_d = (_c = groupsData.value[0]) == null ? void 0 : _c.branding) == null ? void 0 : _d.cover : unref(DEFAULT_COVER),
            alt: "group",
            class: "h-24 w-[120px] rounded-lg object-cover"
          }, null, 8, _hoisted_7$h)
        ])
      ])) : createCommentVNode("", true);
    };
  }
});
const _hoisted_1$P = {
  key: 0,
  ref: "boxRef",
  class: "fixed flex h-screen w-full items-center justify-center bg-white"
};
const _hoisted_2$z = {
  key: 1,
  class: "grid h-screen grid-rows-5 shortScreen"
};
const _hoisted_3$u = { key: 0 };
const _hoisted_4$t = { class: "flex flex-col mt-12" };
const _hoisted_5$n = { class: "mt-4 p-6" };
const _hoisted_6$l = { key: 1 };
const _hoisted_7$g = { class: "flex flex-col mt-12 p-4" };
const _hoisted_8$9 = {
  key: 1,
  class: "flex flex-col h-screen items-center justify-start mt-20"
};
const _hoisted_9$7 = ["src"];
const _hoisted_10$7 = {
  key: 2,
  class: "px-4 w-[100vw] box-border"
};
const _hoisted_11$7 = { class: "absolute bottom-14 left-4" };
const _sfc_main$W = /* @__PURE__ */ defineComponent({
  __name: "MobilePwaDashboard",
  emits: ["logout"],
  setup(__props, { emit: __emit }) {
    const scrollHeight = ref(0);
    const isHome = ref(false);
    const isCourses = ref(false);
    const t2 = inject("t");
    onBeforeUnmount(() => {
      window.removeEventListener("scroll", handleScroll);
    });
    onMounted(() => {
      if (window.location.pathname === "/home") {
        isHome.value = true;
      } else if (window.location.pathname === "/courses/home") {
        isCourses.value = true;
      }
      window.addEventListener("scroll", handleScroll);
    });
    const showModal = ref(false);
    const handleMenu = () => {
      showModal.value = true;
    };
    const mobileHomeWidgets = inject("mobileHomeWidgets");
    const mobileTabWidgets = inject("mobileTabWidgets");
    const mobileComponentMap = {
      groups: _sfc_main$X,
      courses: CoursesWidgets
    };
    const components = computed(() => {
      var _a;
      return ((_a = mobileHomeWidgets == null ? void 0 : mobileHomeWidgets.value) == null ? void 0 : _a.map((widget2) => ({
        ...widget2,
        component: mobileComponentMap[widget2.key]
      }))) || [];
    });
    const visibleTabs = computed(() => {
      var _a;
      return ((_a = mobileTabWidgets == null ? void 0 : mobileTabWidgets.value) == null ? void 0 : _a.map((widget2) => ({
        name: t2.value(widget2.title),
        key: widget2.key,
        component: widget2.component
      }))) || [];
    });
    const isLoading = inject("isLoading");
    const componentsLength = computed(() => components.value.length);
    function handleScroll(e) {
      scrollHeight.value = document.documentElement.scrollTop;
    }
    provide("componentsLength", componentsLength);
    return (_ctx, _cache) => {
      return unref(isAppLoading)() ? (openBlock(), createElementBlock("div", _hoisted_1$P, [
        createVNode(unref(UIContentWrap), null, {
          default: withCtx(() => [
            unref(isPwa)() ? (openBlock(), createBlock(AppLoader, { key: 0 })) : createCommentVNode("", true)
          ]),
          _: 1
        })
      ], 512)) : (openBlock(), createElementBlock("div", _hoisted_2$z, [
        unref(isLoading) ? (openBlock(), createElementBlock("div", _hoisted_3$u, [
          createElementVNode("div", _hoisted_4$t, [
            createVNode(unref(UISkeleton), {
              text: false,
              repeat: 1,
              class: "h-10 w-1/3 rounded-xl ml-6"
            }),
            createVNode(unref(UISkeleton), {
              text: false,
              repeat: 1,
              class: "h-12 w-2/3 rounded-xl ml-6 mt-2"
            })
          ]),
          createElementVNode("div", _hoisted_5$n, [
            createVNode(unref(UISkeleton), {
              text: false,
              repeat: 1,
              class: "h-36 rounded-xl"
            }),
            createVNode(unref(UISkeleton), {
              text: false,
              repeat: 1,
              class: "h-36 rounded-xl mt-6"
            }),
            createVNode(unref(UISkeleton), {
              text: false,
              repeat: 1,
              class: "h-16 rounded-xl mt-6"
            })
          ])
        ])) : (openBlock(), createElementBlock("div", _hoisted_6$l, [
          isHome.value || isCourses.value ? (openBlock(), createBlock(resolveDynamicComponent(unref(isGokollab)() ? unref(TopNavBarMobile) : unref(TopNavBar)), {
            key: 0,
            App: isHome.value ? "Home" : "Courses"
          }, null, 8, ["App"])) : createCommentVNode("", true),
          createElementVNode("div", _hoisted_7$g, [
            createVNode(unref(UITextMdMedium), { class: "text-clientportal-font-secondary text-xl" }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(unref(t2)("dashboard.hello")), 1)
              ]),
              _: 1
            }),
            createVNode(unref(UIDisplaySmMedium), { class: "text-clientportal-font-primary text-2xl truncate max-w-[70vw]" }, {
              default: withCtx(() => {
                var _a, _b;
                return [
                  createTextVNode(toDisplayString((_b = (_a = unref(UserState)) == null ? void 0 : _a.state) == null ? void 0 : _b.fullName), 1)
                ];
              }),
              _: 1
            })
          ]),
          components.value.length === 0 && visibleTabs.value.length === 0 ? (openBlock(), createElementBlock("div", _hoisted_8$9, [
            createElementVNode("img", {
              src: unref(EMPTY_STATE),
              alt: "empty-state",
              class: "w-60 h-60"
            }, null, 8, _hoisted_9$7),
            createVNode(unref(UITextXsRegular), { class: "text-clientportal-font-secondary" }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(unref(t2)("userActivityOverview.dustBunnies")), 1)
              ]),
              _: 1
            })
          ])) : (openBlock(), createElementBlock("div", _hoisted_10$7, [
            (openBlock(true), createElementBlock(Fragment, null, renderList(components.value, (comp) => {
              return openBlock(), createBlock(resolveDynamicComponent(comp.component), {
                key: comp.key
              });
            }), 128)),
            createVNode(MobileTabs, { visibleTabs: visibleTabs.value }, null, 8, ["visibleTabs"])
          ])),
          createElementVNode("div", _hoisted_11$7, [
            createVNode(unref(UIAvatar), {
              id: "file-logo",
              class: "h-10 w-10 bg-clientportal-font-primary",
              onClick: handleMenu
            }, {
              default: withCtx(() => [
                createVNode(unref(render$T), { class: "mt-1 h-5 w-5 text-clientportal-background" })
              ]),
              _: 1
            })
          ]),
          createVNode(MenuModal, {
            show: showModal.value,
            "onUpdate:show": _cache[0] || (_cache[0] = ($event) => showModal.value = false)
          }, null, 8, ["show"])
        ]))
      ]));
    };
  }
});
const MobilePwaDashboard = /* @__PURE__ */ _export_sfc(_sfc_main$W, [["__scopeId", "data-v-4670f161"]]);
const _hoisted_1$O = { class: "z-20 font-semibold text-clientportal-sidebar-font-secondary" };
const _hoisted_2$y = {
  key: 0,
  class: "absolute right-0 top-0 h-2.5 w-2.5 rounded-full bg-red-500"
};
const _hoisted_3$t = { class: "p-0" };
const _hoisted_4$s = {
  key: 0,
  class: "flex flex-row justify-between py-3.5"
};
const _hoisted_5$m = {
  id: "post-action-dropdown-trigger",
  class: "flex h-7 w-7 items-center justify-center rounded-full hover:bg-clientportal-fill"
};
const _hoisted_6$k = { class: "px-2" };
const _sfc_main$V = /* @__PURE__ */ defineComponent({
  __name: "NotificationWeb",
  props: {
    app_launcher_is_open: Boolean,
    profile_card_is_open: Boolean,
    notification_list_is_open: Boolean,
    mark_all_read: Boolean,
    position: {
      type: String,
      required: false
    }
  },
  emits: ["update:notification-list-is-open"],
  setup(__props, { emit: __emit }) {
    onMounted(async () => {
      var _a, _b;
      await ((_a = NotificationState) == null ? void 0 : _a.getNotifications());
      await ((_b = NotificationState) == null ? void 0 : _b.getUnreadNotificationsCount());
    });
    const emit = __emit;
    const props = __props;
    const markAllRead = ref(false);
    const t2 = inject("t");
    const notificationWebListRef = ref(null);
    const ignoreElNotificationIconRef = ref();
    const notificationVisibility = ref("all");
    const loadMoreNotifications = ref(false);
    const notificationListCloseEvent = [
      () => {
        emit("update:notification-list-is-open");
      },
      { ignore: [ignoreElNotificationIconRef, ".n-dropdown-option-body"] }
    ];
    watch(
      () => props.notification_list_is_open,
      (newValue) => {
        var _a;
        if (newValue) {
          nextTick(() => {
            var _a2;
            (_a2 = notificationWebListRef.value) == null ? void 0 : _a2.addEventListener("scroll", handleScroll);
          });
        } else {
          (_a = notificationWebListRef.value) == null ? void 0 : _a.removeEventListener("scroll", handleScroll);
        }
      }
    );
    const toggleNotificationList = () => {
      notificationVisibility.value = "all";
      emit("update:notification-list-is-open");
    };
    async function handleScroll(event) {
      const scrollPending = event.target.scrollHeight - event.target.scrollTop - notificationWebListRef.value.offsetHeight;
      if (scrollPending < 20 && !NotificationState.state.isLoading) {
        loadMoreNotifications.value = true;
      } else {
        loadMoreNotifications.value = false;
      }
      event.stopPropagation();
    }
    const unreadNotificationCount = computed(() => {
      return NotificationState.state.unReadNotificationCount;
    });
    const PostActionOption = computed(() => {
      const menuList = [
        {
          label: t2.value("notifications.markAllRead"),
          key: "markAllRead",
          class: "rounded-2xl",
          icon() {
            return h(renderIcon$1(render$n), null, {});
          }
        }
        // {
        //   label: 'Notification Settings',
        //   key: 'notificationSettings',
        //   class: 'rounded-2xl',
        //   icon() {
        //     return h(renderIcon(Settings01Icon), null, {})
        //   },
        // },
      ];
      return menuList;
    });
    const notificationCounterOffset = computed(() => {
      if (NotificationState.state.unReadNotificationCount < 10) {
        return [0, 0];
      } else {
        return [2, -2];
      }
    });
    async function handlePostAction(val) {
      switch (val) {
        case "markAllRead":
          markAllRead.value = true;
          break;
      }
    }
    return (_ctx, _cache) => {
      const _directive_on_click_outside = resolveDirective("on-click-outside");
      return openBlock(), createElementBlock("div", _hoisted_1$O, [
        !unref(AppState).state.isMobile ? (openBlock(), createElementBlock("div", {
          key: 0,
          onClick: toggleNotificationList,
          id: "pg-afcp-navbar__navigation-page-app-launcher-btn",
          class: normalizeClass(["flex h-10 w-10 cursor-pointer hover:sidebar-selected-item-font items-center justify-center rounded-full hover:bg-clientportal-sidebar-fill", [
            !__props.profile_card_is_open && !__props.app_launcher_is_open && __props.notification_list_is_open ? "bg-clientportal-sidebar-fill" : ""
          ]]),
          ref_key: "ignoreElNotificationIconRef",
          ref: ignoreElNotificationIconRef
        }, [
          createVNode(unref(UIBadge), {
            offset: notificationCounterOffset.value,
            show: !unref(AppState).state.isMobile && unreadNotificationCount.value > 0,
            id: "unread-notification-count-badge"
          }, {
            content: withCtx(() => [
              createVNode(unref(render$U), { class: "h-5 w-5 topNavIconColor" }),
              unref(AppState).state.isMobile && unreadNotificationCount.value > 0 ? (openBlock(), createElementBlock("div", _hoisted_2$y)) : createCommentVNode("", true)
            ]),
            value: withCtx(() => [
              createElementVNode("div", _hoisted_3$t, toDisplayString(unreadNotificationCount.value > 9 ? "9+" : unreadNotificationCount.value), 1)
            ]),
            _: 1
          }, 8, ["offset", "show"])
        ], 2)) : createCommentVNode("", true),
        createElementVNode("div", null, [
          createVNode(Transition, {
            "enter-from-class": "opacity-0 translate-y-1",
            "enter-active-class": "transition ease-out duration-200",
            "enter-to-class": "opacity-100 translate-y-0",
            "leave-from-class": "opacity-100 translate-y-0",
            "leave-to-class": "opacity-0 translate-y-1",
            "leave-active-class": "transition ease-in duration-150"
          }, {
            default: withCtx(() => [
              !__props.profile_card_is_open && !__props.app_launcher_is_open && __props.notification_list_is_open ? withDirectives((openBlock(), createElementBlock("div", {
                key: 0,
                ref_key: "notificationWebListRef",
                ref: notificationWebListRef,
                class: normalizeClass(["notification-height absolute right-0 z-10 mt-4 flex w-full flex-auto flex-col overflow-y-auto rounded bg-clientportal-background px-4 shadow-lg ring-1 ring-gray-900/5 md:mr-4 md:w-[437px]", __props.position === "end" ? " right-0 " : " -right-80 "])
              }, [
                !unref(AppState).state.isMobile ? (openBlock(), createElementBlock("div", _hoisted_4$s, [
                  createVNode(unref(UITextLgMedium), { class: "fw-600 text-xl text-gray-900" }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(unref(t2)("notifications.title")), 1)
                    ]),
                    _: 1
                  }),
                  createVNode(unref(UIDropdown), {
                    options: PostActionOption.value,
                    onSelect: handlePostAction,
                    placement: "bottom-end",
                    id: "post-action-dropdown",
                    class: "w-20 rounded-3xl"
                  }, {
                    default: withCtx(() => [
                      createElementVNode("div", _hoisted_5$m, [
                        createVNode(unref(render$V), { class: "w-4 text-clientportal-font-secondary" })
                      ])
                    ]),
                    _: 1
                  }, 8, ["options"])
                ])) : createCommentVNode("", true),
                createElementVNode("div", _hoisted_6$k, [
                  createVNode(unref(UIButton), {
                    bordered: false,
                    focusable: false,
                    type: notificationVisibility.value === "all" ? "tertiary" : "default",
                    quaternary: true,
                    tertiary: true,
                    id: "btn-all",
                    onClick: _cache[0] || (_cache[0] = ($event) => notificationVisibility.value = "all"),
                    class: "mr-2"
                  }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(unref(t2)("notifications.all")), 1)
                    ]),
                    _: 1
                  }, 8, ["type"]),
                  createVNode(unref(UIButton), {
                    quaternary: true,
                    focusable: false,
                    bordered: false,
                    tertiary: true,
                    type: notificationVisibility.value === "unread" ? "tertiary" : "default",
                    id: "btn-unread",
                    size: "medium",
                    onClick: _cache[1] || (_cache[1] = ($event) => notificationVisibility.value = "unread"),
                    class: "bg-clientportal-primary"
                  }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(unref(t2)("notifications.unread")), 1)
                    ]),
                    _: 1
                  }, 8, ["type"])
                ]),
                createVNode(NotificationList, {
                  "mark-all-read": markAllRead.value,
                  notificationVisibility: notificationVisibility.value,
                  loadMoreNotifications: loadMoreNotifications.value,
                  onItemClicked: toggleNotificationList
                }, null, 8, ["mark-all-read", "notificationVisibility", "loadMoreNotifications"])
              ], 2)), [
                [_directive_on_click_outside, notificationListCloseEvent]
              ]) : createCommentVNode("", true)
            ]),
            _: 1
          })
        ])
      ]);
    };
  }
});
const NotificationWeb = /* @__PURE__ */ _export_sfc(_sfc_main$V, [["__scopeId", "data-v-f8222bd0"]]);
const _hoisted_1$N = { class: "z-20 font-semibold text-gray-500" };
const _hoisted_2$x = { class: "w-screen max-w-xs flex-auto overflow-hidden rounded bg-white text-sm leading-6 shadow-lg ring-1 ring-gray-900/5 lg:max-w-xs" };
const _hoisted_3$s = { class: "grid grid-cols-1 gap-x-1 gap-y-1 p-4 lg:grid-cols-2" };
const _hoisted_4$r = ["onClick"];
const _hoisted_5$l = { class: "flex flex-col items-center justify-center" };
const _hoisted_6$j = {
  key: 0,
  class: "inline-flex items-center rounded-full bg-yellow-50 px-2 py-1 text-xs font-medium text-yellow-800 ring-1 ring-inset ring-yellow-600/20"
};
const _sfc_main$U = /* @__PURE__ */ defineComponent({
  __name: "AppSwitcher",
  props: {
    app_launcher_is_open: Boolean,
    profile_card_is_open: Boolean,
    position: {
      type: String,
      required: true
    },
    isUserAdmin: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:app-launcher-is-open"],
  setup(__props, { emit: __emit }) {
    const emit = __emit;
    const props = __props;
    const t2 = inject("t");
    const webAppSwitcherItems = ref([]);
    onMounted(async () => {
      if (dashboardManager) {
        try {
          await Promise.allSettled([
            dashboardManager.refreshData(WIDGET_KEYS.GROUPS),
            dashboardManager.refreshData(WIDGET_KEYS.COURSES),
            dashboardManager.refreshData(WIDGET_KEYS.AFFILIATES)
          ]);
          const childApps = await dashboardManager.getWebAppSwitcherItems();
          webAppSwitcherItems.value = childApps.value;
        } catch (error) {
          console.error("Error loading app switcher data:", error);
        }
      }
    });
    const toggleAppLauncher = () => {
      if (props.isUserAdmin) {
        return null;
      } else {
        emit("update:app-launcher-is-open");
      }
    };
    const ignoreElAppRef = ref();
    const launcherCloseEvent = [
      () => {
        emit("update:app-launcher-is-open");
      },
      { ignore: [ignoreElAppRef] }
    ];
    const CHILD_APPS = computed(
      () => {
        var _a;
        return ((_a = webAppSwitcherItems == null ? void 0 : webAppSwitcherItems.value) == null ? void 0 : _a.map((config) => ({
          name: t2.value(config.title),
          icon: config.icon,
          route: config.route,
          tag: config == null ? void 0 : config.tag
        }))) || [];
      }
    );
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$N, [
        createElementVNode("div", {
          onClick: _cache[0] || (_cache[0] = ($event) => CHILD_APPS.value.length > 0 ? toggleAppLauncher() : null),
          id: "pg-afcp-navbar__navigation-page-app-launcher-btn",
          class: normalizeClass(["flex h-10 w-10 cursor-pointer items-center justify-center rounded-full", [
            !__props.profile_card_is_open && __props.app_launcher_is_open ? "bg-gray-300" : "hover:bg-gray-200",
            CHILD_APPS.value.length == 0 && " cursor-not-allowed text-gray-300 "
          ]]),
          ref_key: "ignoreElAppRef",
          ref: ignoreElAppRef
        }, [
          createVNode(unref(render$W), {
            class: "h-5 w-5 topNavIconColor",
            "aria-hidden": "true"
          })
        ], 2),
        createElementVNode("div", null, [
          createVNode(Transition, {
            "enter-from-class": "opacity-0 translate-y-1",
            "enter-active-class": "transition ease-out duration-200",
            "enter-to-class": "opacity-100 translate-y-0",
            "leave-from-class": "opacity-100 translate-y-0",
            "leave-to-class": "opacity-0 translate-y-1",
            "leave-active-class": "transition ease-in duration-150"
          }, {
            default: withCtx(() => [
              !__props.profile_card_is_open && __props.app_launcher_is_open ? withDirectives((openBlock(), createElementBlock("div", {
                key: 0,
                class: normalizeClass(
                  __props.position === "end" ? "absolute -right-16 z-10 mt-4 flex w-72 px-4" : "absolute -right-56 z-10 mt-4 flex w-72 px-4"
                )
              }, [
                createElementVNode("div", _hoisted_2$x, [
                  createElementVNode("div", _hoisted_3$s, [
                    (openBlock(true), createElementBlock(Fragment, null, renderList(CHILD_APPS.value, (item) => {
                      return openBlock(), createElementBlock("div", {
                        key: item.name,
                        class: "group relative flex items-start justify-center gap-x-1 rounded-lg p-4 hover:bg-gray-50"
                      }, [
                        createElementVNode("div", {
                          id: "pg-afcp-navbar__navigation-page-communities-btn",
                          class: "flex cursor-pointer flex-col items-center justify-center",
                          onClick: ($event) => unref(externalPathRedirect)(item.route, "")
                        }, [
                          (openBlock(), createBlock(resolveDynamicComponent(item.icon), {
                            onClick: toggleAppLauncher,
                            class: "h-5 w-5"
                          })),
                          createElementVNode("div", _hoisted_5$l, [
                            createTextVNode(toDisplayString(item.name) + " ", 1),
                            (item == null ? void 0 : item.tag) ? (openBlock(), createElementBlock("span", _hoisted_6$j, toDisplayString(item == null ? void 0 : item.tag), 1)) : createCommentVNode("", true)
                          ])
                        ], 8, _hoisted_4$r)
                      ]);
                    }), 128))
                  ])
                ])
              ], 2)), [
                [unref(vOnClickOutside), launcherCloseEvent]
              ]) : createCommentVNode("", true)
            ]),
            _: 1
          })
        ])
      ]);
    };
  }
});
const AppSwitcher = /* @__PURE__ */ _export_sfc(_sfc_main$U, [["__scopeId", "data-v-caf5685c"]]);
const EditIcon = "data:image/svg+xml,%3csvg%20width='33'%20height='32'%20viewBox='0%200%2033%2032'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20id='edit-01'%20filter='url(%23filter0_d_25665_17542)'%3e%3crect%20x='2.5'%20y='1'%20width='28'%20height='28'%20rx='14'%20fill='%23FEFEFF'/%3e%3crect%20x='3'%20y='1.5'%20width='27'%20height='27'%20rx='13.5'%20stroke='%23E4E4E4'/%3e%3cpath%20id='Icon'%20d='M10.9597%2018.745C10.9871%2018.4984%2011.0008%2018.375%2011.0381%2018.2598C11.0712%2018.1575%2011.118%2018.0602%2011.1771%2017.9704C11.2438%2017.8693%2011.3316%2017.7816%2011.5071%2017.6061L19.3846%209.72853C20.0435%209.06966%2021.1117%209.06966%2021.7706%209.72853C22.4295%2010.3874%2022.4295%2011.4557%2021.7706%2012.1145L13.8931%2019.9921C13.7176%2020.1676%2013.6298%2020.2553%2013.5287%2020.322C13.439%2020.3812%2013.3416%2020.428%2013.2394%2020.4611C13.1241%2020.4984%2013.0008%2020.5121%2012.7541%2020.5395L10.7354%2020.7638L10.9597%2018.745Z'%20stroke='%231D2939'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/g%3e%3cdefs%3e%3cfilter%20id='filter0_d_25665_17542'%20x='0.5'%20y='0'%20width='32'%20height='32'%20filterUnits='userSpaceOnUse'%20color-interpolation-filters='sRGB'%3e%3cfeFlood%20flood-opacity='0'%20result='BackgroundImageFix'/%3e%3cfeColorMatrix%20in='SourceAlpha'%20type='matrix'%20values='0%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%20127%200'%20result='hardAlpha'/%3e%3cfeOffset%20dy='1'/%3e%3cfeGaussianBlur%20stdDeviation='1'/%3e%3cfeColorMatrix%20type='matrix'%20values='0%200%200%200%200.0627451%200%200%200%200%200.0941176%200%200%200%200%200.156863%200%200%200%200.05%200'/%3e%3cfeBlend%20mode='normal'%20in2='BackgroundImageFix'%20result='effect1_dropShadow_25665_17542'/%3e%3cfeBlend%20mode='normal'%20in='SourceGraphic'%20in2='effect1_dropShadow_25665_17542'%20result='shape'/%3e%3c/filter%3e%3c/defs%3e%3c/svg%3e";
const _hoisted_1$M = { class: "contents" };
const _hoisted_2$w = {
  for: "file-upload",
  class: "flex h-44 w-44 cursor-pointer items-center justify-center rounded-full"
};
const _hoisted_3$r = ["src"];
const _hoisted_4$q = {
  key: 1,
  class: "hover:bg-clientportal-fill absolute flex h-10 w-10 items-center justify-center rounded-full p-1"
};
const _hoisted_5$k = {
  key: 2,
  class: "bg-clientportal-fill flex h-12 w-12 items-center justify-center rounded-full"
};
const _hoisted_6$i = {
  key: 0,
  class: "mt-2 flex flex-row items-center justify-center gap-2"
};
const _hoisted_7$f = { key: 0 };
const _hoisted_8$8 = {
  key: 0,
  class: "crop-modal-title mb-5 flex items-center justify-center"
};
const _hoisted_9$6 = { key: 1 };
const _hoisted_10$6 = { class: "mb-5 flex flex-row items-center justify-center" };
const _hoisted_11$6 = { class: "inline-block max-w-full align-top" };
const _hoisted_12$5 = { class: "inline-block max-w-[16rem] overflow-hidden text-ellipsis whitespace-nowrap align-middle sm:max-w-full" };
const _hoisted_13$5 = {
  key: 0,
  class: "flex items-center justify-center"
};
const _hoisted_14$4 = { class: "absolute z-50 mt-24 flex w-44 select-none flex-row items-center justify-center gap-2 rounded-md bg-black p-0.5 text-white opacity-70" };
const _hoisted_15$3 = { class: "aspect-square rounded-lg" };
const _hoisted_16$1 = ["src"];
const _hoisted_17$1 = {
  key: 1,
  class: "mb-5 mt-5 flex w-full flex-row items-center gap-2"
};
const _hoisted_18$1 = {
  key: 0,
  class: "mt-5 flex flex-row items-center justify-end gap-2"
};
const _hoisted_19$1 = {
  key: 1,
  class: "w-full"
};
const DEFAULT_IMAGE_FORMAT = "image/jpeg";
const _sfc_main$T = /* @__PURE__ */ defineComponent({
  __name: "ImageUpload",
  props: {
    beforeUpload: {
      type: Function,
      required: true
    },
    remove: {
      type: Function,
      required: true
    },
    handleCropImage: {
      type: Function,
      required: true
    },
    cropBoxWidth: {
      type: Number,
      required: true
    },
    cropBoxHeight: {
      type: Number,
      required: true
    },
    aspectRatio: {
      type: Number,
      required: true
    }
  },
  emits: ["file-selected", "removed", "image-cropped"],
  setup(__props, { emit: __emit }) {
    var _a;
    const props = __props;
    const emits = __emit;
    const cropperLoading = ref(false);
    const t2 = inject("t");
    const imageSrc = ref("");
    const showClearIcon = ref(false);
    const selectedFileName = ref(null);
    const uploadContainer = ref(null);
    const avatar = ref(void 0);
    const zoom = ref(0);
    const showCropperModal = ref(false);
    const croppedImage = ref((_a = UserState.state) == null ? void 0 : _a.avatar);
    const selectedFile = ref(null);
    let cropper;
    const img = ref(null);
    const fileReader = new FileReader();
    const showDragMessage = ref(true);
    const isImageZoomed = ref(false);
    const isMobile = ref(false);
    fileReader.onload = (event) => {
      var _a2;
      imageSrc.value = (_a2 = event == null ? void 0 : event.target) == null ? void 0 : _a2.result;
      showCropperModal.value = true;
    };
    function checkMobileStyling() {
      if (window.innerWidth <= 930) {
        isMobile.value = true;
      } else {
        isMobile.value = false;
      }
    }
    const handleSave = () => {
      var _a2;
      showCropperModal.value = false;
      const base64Image = cropper.getCroppedCanvas({
        width: props.cropBoxWidth,
        height: props.cropBoxHeight,
        imageSmoothingQuality: "high"
      }).toDataURL(DEFAULT_IMAGE_FORMAT);
      croppedImage.value = base64Image;
      const blobedFile = new File([selectedFile.value], (_a2 = selectedFile == null ? void 0 : selectedFile.value) == null ? void 0 : _a2.name, {
        type: DEFAULT_IMAGE_FORMAT
      });
      const fileToBeUploaded = {
        file: blobedFile,
        url: croppedImage.value
      };
      emits("image-cropped", fileToBeUploaded);
      props.handleCropImage(fileToBeUploaded);
    };
    const handleFileChange = async (fileChangeEvent) => {
      fileChangeEvent.target.disabled = true;
      cropperLoading.value = true;
      const files = fileChangeEvent.target.files;
      const selectedImageBlob = new File([files[0]], files[0].name, {
        type: files[0].type
      });
      const isSuccess = await props.beforeUpload({ file: selectedImageBlob });
      if (!isSuccess) {
        cropperLoading.value = false;
        fileChangeEvent.target.disabled = false;
        return false;
      }
      if (files.length) {
        selectedFileName.value = files[0].name;
        const blobedFile = new File([files[0]], files[0].name, {
          type: files[0].type
        });
        selectedFile.value = blobedFile;
      }
      fileChangeEvent.target.value = null;
      fileChangeEvent.target.disabled = false;
      emits("file-selected", selectedFile.value);
    };
    onMounted(() => {
      uploadContainer.value.addEventListener("dragover", (dragoverEvent) => {
        dragoverEvent.preventDefault();
        if (dragoverEvent.dataTransfer)
          dragoverEvent.dataTransfer.dropEffect = "copy";
      });
      uploadContainer.value.addEventListener("drop", (dropEvent) => {
        dropEvent.preventDefault();
        if (dropEvent.dataTransfer && dropEvent.target) {
          const files = dropEvent.dataTransfer.files;
          dropEvent.target.files = files;
          if (files.length) {
            handleFileChange(dropEvent);
          }
        }
      });
      checkMobileStyling();
    });
    onUnmounted(() => {
      cropper == null ? void 0 : cropper.destroy();
    });
    watchEffect(() => {
      if (selectedFile.value) {
        fileReader.readAsDataURL(selectedFile.value);
      } else {
        imageSrc.value = null;
      }
    });
    watch(
      imageSrc,
      () => {
        if (imageSrc.value) {
          cropper = new Cropper(img.value, {
            aspectRatio: props.aspectRatio,
            autoCropArea: 0.95,
            minCropBoxWidth: props.cropBoxWidth,
            minCropBoxHeight: props.cropBoxHeight,
            viewMode: 3,
            center: true,
            dragMode: "move",
            background: true,
            cropBoxMovable: false,
            cropBoxResizable: false,
            toggleDragModeOnDblclick: false,
            zoomOnWheel: false,
            ready: () => {
              cropperLoading.value = false;
            },
            guides: false,
            cropmove: () => {
              showDragMessage.value = false;
            }
          });
          cropper.replace(imageSrc.value);
        }
      },
      {
        flush: "post"
      }
    );
    const zoomImage = (value) => {
      isImageZoomed.value = true;
      if (zoom.value < value && value > 1) return false;
      if (zoom.value > value && value < 0) return false;
      if (zoom.value < value) {
        cropper.zoom(0.1);
      } else {
        cropper.zoom(-0.1);
      }
      zoom.value = value;
    };
    const handleZoom = (value) => {
      zoomImage(value);
    };
    const clearFile = (pointerEvent) => {
      pointerEvent == null ? void 0 : pointerEvent.preventDefault();
      zoom.value = 0;
      showCropperModal.value = false;
      showClearIcon.value = false;
      selectedFile.value = null;
      selectedFileName.value = null;
      croppedImage.value = null;
      showDragMessage.value = true;
      cropper == null ? void 0 : cropper.destroy();
      props.remove();
      emits("removed");
    };
    const handleMouseLeave = (event) => {
      var _a2;
      if (event.target !== ((_a2 = event == null ? void 0 : event.currentTarget) == null ? void 0 : _a2.querySelector("button"))) {
        showClearIcon.value = false;
      }
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        createElementVNode("div", _hoisted_1$M, [
          createElementVNode("div", {
            ref_key: "uploadContainer",
            ref: uploadContainer,
            class: "upload-container flex h-44 w-44 items-center justify-center rounded-full",
            onMouseleave: handleMouseLeave
          }, [
            createElementVNode("label", _hoisted_2$w, [
              createElementVNode("input", {
                id: "file-upload",
                type: "file",
                onChange: handleFileChange,
                style: { "display": "none" }
              }, null, 32),
              croppedImage.value ? (openBlock(), createElementBlock("img", {
                key: 0,
                src: croppedImage.value,
                class: "h-44 w-44 rounded-full",
                ref_key: "avatar",
                ref: avatar,
                onMouseover: _cache[0] || (_cache[0] = ($event) => showClearIcon.value = true)
              }, null, 40, _hoisted_3$r)) : createCommentVNode("", true),
              showClearIcon.value && !isMobile.value ? (openBlock(), createElementBlock("div", _hoisted_4$q, [
                createVNode(unref(render$X), { class: "text-clientportal-font-secondary hover:text-clientportal-font-primary h-8 w-8" })
              ])) : createCommentVNode("", true),
              !croppedImage.value && cropperLoading.value ? (openBlock(), createElementBlock("div", _hoisted_5$k, [
                createVNode(unref(UISpin), {
                  size: "medium",
                  class: "h-full px-2"
                })
              ])) : createCommentVNode("", true)
            ])
          ], 544),
          selectedFileName.value && croppedImage.value ? (openBlock(), createElementBlock("div", _hoisted_6$i, [
            createVNode(unref(UITextSmNormal), null, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(selectedFileName.value), 1)
              ]),
              _: 1
            }),
            isMobile.value && imageSrc.value ? (openBlock(), createElementBlock("div", _hoisted_7$f, [
              createElementVNode("div", {
                onClick: clearFile,
                role: "button",
                "aria-label": "Remove profile avatar",
                class: "flex h-7 w-7 items-center justify-center rounded-full p-1 text-warning-700"
              }, [
                createVNode(unref(render$i))
              ])
            ])) : createCommentVNode("", true)
          ])) : createCommentVNode("", true)
        ]),
        createVNode(unref(UIModal), {
          show: showCropperModal.value,
          maskClosable: true,
          closeOnEsc: true,
          "z-index": 60,
          "class-name": "image-uploader flex h-full rounded-none md:h-auto md:rounded-xl"
        }, {
          header: withCtx(() => [
            !isMobile.value ? (openBlock(), createElementBlock("div", _hoisted_8$8, [
              createVNode(unref(UITextLgMedium), { class: "text-clientportal-font-primary font-semibold" }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(unref(t2)("mandatedInfoModal.cropYourAvatar")), 1)
                ]),
                _: 1
              })
            ])) : createCommentVNode("", true),
            isMobile.value ? (openBlock(), createElementBlock("div", _hoisted_9$6, [
              createElementVNode("div", _hoisted_10$6, [
                createVNode(unref(UITextLgMedium), { class: "text-clientportal-font-primary font-semibold" }, {
                  default: withCtx(() => [
                    createElementVNode("div", _hoisted_11$6, [
                      createElementVNode("div", _hoisted_12$5, toDisplayString(unref(t2)("mandatedInfoModal.cropYourAvatar")), 1)
                    ])
                  ]),
                  _: 1
                }),
                createVNode(unref(render$r), {
                  class: "absolute right-3 h-8 w-8",
                  onClick: clearFile
                })
              ])
            ])) : createCommentVNode("", true)
          ]),
          footer: withCtx(() => [
            imageSrc.value && !isMobile.value ? (openBlock(), createElementBlock("div", _hoisted_18$1, [
              imageSrc.value ? (openBlock(), createBlock(unref(UIButton), {
                key: 0,
                id: "cancel-crop-image",
                "button-type": "tertiary",
                size: "medium",
                class: "w-32 text-base",
                onClick: clearFile
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(unref(t2)("common.cancel")), 1)
                ]),
                _: 1
              })) : createCommentVNode("", true),
              imageSrc.value ? (openBlock(), createBlock(unref(UIButton), {
                key: 1,
                id: "save-cropped-image",
                "button-type": "primary",
                size: "medium",
                class: "w-32 text-base",
                onClick: handleSave
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(unref(t2)("common.save")), 1)
                ]),
                _: 1
              })) : createCommentVNode("", true)
            ])) : createCommentVNode("", true),
            imageSrc.value && isMobile.value ? (openBlock(), createElementBlock("div", _hoisted_19$1, [
              imageSrc.value ? (openBlock(), createBlock(unref(UIButton), {
                key: 0,
                id: "save-cropped-image",
                "button-type": "primary",
                size: "medium",
                class: "btn btn-blue w-full text-base",
                onClick: handleSave
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(unref(t2)("common.save")), 1)
                ]),
                _: 1
              })) : createCommentVNode("", true)
            ])) : createCommentVNode("", true)
          ]),
          default: withCtx(() => [
            showDragMessage.value ? (openBlock(), createElementBlock("div", _hoisted_13$5, [
              createElementVNode("div", _hoisted_14$4, [
                createVNode(unref(render$Y), { style: { "width": "18px", "height": "18px" } }),
                createVNode(unref(UITextMdNormal), null, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(unref(t2)("mandatedInfoModal.dragToReposition")), 1)
                  ]),
                  _: 1
                })
              ])
            ])) : createCommentVNode("", true),
            withDirectives(createElementVNode("div", _hoisted_15$3, [
              createElementVNode("img", {
                ref_key: "img",
                ref: img,
                class: "rounded-full",
                src: imageSrc.value,
                style: { "width": "100%", "height": "100%", "border-radius": "10px" }
              }, null, 8, _hoisted_16$1)
            ], 512), [
              [vShow, imageSrc.value]
            ]),
            imageSrc.value && !isMobile.value ? (openBlock(), createElementBlock("div", _hoisted_17$1, [
              createVNode(unref(render$Z), {
                style: { "width": "18px", "height": "18px" },
                class: "hover: hover:bg-clientportal-fill cursor-pointer rounded-full",
                role: "button",
                "aria-label": "zoom in button",
                onClick: _cache[1] || (_cache[1] = () => zoomImage(zoom.value - 0.1))
              }),
              createVNode(unref(UISlider), {
                value: zoom.value,
                step: 0.1,
                min: 0,
                max: 1,
                "show-tooltip": false,
                tooltip: false,
                "onUpdate:value": handleZoom
              }, null, 8, ["value"]),
              createVNode(unref(render$_), {
                class: "hover: hover:bg-clientportal-fill cursor-pointer rounded-full",
                style: { "width": "18px", "height": "18px" },
                role: "button",
                onClick: _cache[2] || (_cache[2] = () => zoomImage(zoom.value + 0.1))
              })
            ])) : createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["show"])
      ], 64);
    };
  }
});
const ImageUpload = /* @__PURE__ */ _export_sfc(_sfc_main$T, [["__scopeId", "data-v-06ba9f6c"]]);
const _hoisted_1$L = { class: "flex flex-col items-center" };
const _hoisted_2$v = { class: "inline-block max-w-full align-top" };
const _hoisted_3$q = { class: "inline-block max-w-[16rem] overflow-hidden text-ellipsis whitespace-nowrap align-middle sm:max-w-full" };
const _hoisted_4$p = { class: "mt-[24px] select-none px-[2px]" };
const _hoisted_5$j = { class: "my-4 flex flex-col items-center justify-center" };
const _hoisted_6$h = { class: "mt-2 flex flex-col items-center justify-between" };
const _sfc_main$S = /* @__PURE__ */ defineComponent({
  __name: "MandatedInfoModal",
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:show", "update:save", "update:edited"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const t2 = inject("t");
    const emit = __emit;
    const isUpdatingInfo = ref(false);
    const isCompleteLoading = ref(false);
    const profilePic = ref([]);
    const uploadedUrl = ref();
    const actionUrl = ref();
    const showErrorProfilePhoto = ref(false);
    const aspectRatioError = ref(false);
    const notification = useNotification();
    const showMandatedInfoModal = ref(false);
    const currentSelectedFile = ref();
    const imageFileToBeUploaded = ref();
    onMounted(() => showMandatedInfoModal.value = props.showModal);
    watch(
      () => props.showModal,
      (value) => {
        showMandatedInfoModal.value = value;
      }
    );
    onMounted(() => {
      var _a, _b;
      if ((_a = UserState.state) == null ? void 0 : _a.avatar) {
        profilePic.value = [
          {
            status: "finished",
            url: (_b = UserState.state) == null ? void 0 : _b.avatar,
            name: "user_profile_pic",
            type: "image/jpeg"
          }
        ];
      }
    });
    function handleCropImage(file) {
      imageFileToBeUploaded.value = file;
      showErrorProfilePhoto.value = false;
    }
    async function completeProfile() {
      var _a;
      isCompleteLoading.value = true;
      if (!((_a = imageFileToBeUploaded == null ? void 0 : imageFileToBeUploaded.value) == null ? void 0 : _a.file)) {
        showErrorProfilePhoto.value = true;
        return;
      }
      await customRequest();
      if (props.isLoading) {
        handleClose();
      }
    }
    async function saveMandatedInfo() {
      if (!profilePic.value[0].url) {
        showErrorProfilePhoto.value = !profilePic.value[0].url;
      } else {
        showErrorProfilePhoto.value = false;
        emit("update:save", profilePic.value[0].url);
        handleClose();
      }
    }
    function handleClose() {
      showMandatedInfoModal.value = false;
      isCompleteLoading.value = false;
      emit("update:show", false);
    }
    async function handleUploadFinish(file) {
      if (file.file.status === "finished") {
        file.file.url = uploadedUrl.value;
        const image = {
          name: file.file.name,
          type: file.file.type,
          url: uploadedUrl.value,
          status: "finished"
        };
        profilePic.value = [image];
        showErrorProfilePhoto.value = false;
        await saveMandatedInfo();
      } else {
        showErrorProfilePhoto.value = true;
      }
    }
    async function getSignedUrl(data) {
      if (!ALLOWED_FILE_TYPES.includes(data.file.type)) {
        return false;
      }
      const { url, signedUrl } = (await MediaService.generateSignedUrl({
        name: v4(),
        folder: "users",
        type: "image/jpeg"
      })).data;
      actionUrl.value = signedUrl;
      uploadedUrl.value = url;
    }
    async function beforeUpload(data) {
      try {
        currentSelectedFile.value = data;
        if (profilePic.value.length > 0) {
          profilePic.value = [];
        }
        const file = data == null ? void 0 : data.file;
        if (!file) {
          return;
        }
        if (!ALLOWED_FILE_TYPES.includes(file == null ? void 0 : file.type)) {
          notification.create({
            type: "error",
            title: t2.value("mandatedInfoModal.invalidFileFormat"),
            content: t2.value("mandatedInfoModal.pleaseUploadImage"),
            duration: 4e3
          });
          return false;
        }
        if ((file == null ? void 0 : file.size) > 100 * 1024 * 1024) {
          notification.create({
            type: "error",
            title: t2.value("mandatedInfoModal.fileSizeTooLarge"),
            content: t2.value("mandatedInfoModal.pleaseUploadFileLessThan100MB"),
            duration: 4e3
          });
          return false;
        }
        if (file) {
          const img = new Image();
          const blobedFile = new File([file.file], file.name, {
            type: file.type
          });
          img.src = URL.createObjectURL(blobedFile);
          await getSignedUrl(data);
          return true;
        }
      } catch (error) {
        if (error === "Invalid Aspect Ratio") {
          aspectRatioError.value = true;
        } else {
          notification.create({
            title: t2.value("mandatedInfoModal.oopsUnableToUploadImage"),
            content: t2.value("mandatedInfoModal.pleaseTryAgainLater"),
            duration: 3e3
          });
        }
        console.error(error);
        return false;
      }
    }
    function handleImageUploadError() {
      isUpdatingInfo.value = false;
      notification.create({
        title: t2.value("mandatedInfoModal.oopsUnableToUploadImage"),
        content: t2.value("mandatedInfoModal.pleaseTryAgainLater"),
        duration: 3e3
      });
    }
    async function customRequest() {
      try {
        isUpdatingInfo.value = true;
        const imageData = await fetch(imageFileToBeUploaded.value.url);
        const imageBlob = await imageData.blob();
        const formData = new FormData();
        formData.append("file", imageFileToBeUploaded.value.file);
        const fileUploadRequest = new XMLHttpRequest();
        fileUploadRequest.open("PUT", actionUrl.value, true);
        fileUploadRequest.onload = async () => {
          const status = fileUploadRequest.status;
          if (status === 200) {
            try {
              await MediaService.compressImage(uploadedUrl.value, 256);
              handleUploadFinish({
                file: { ...imageFileToBeUploaded.value.file, status: "finished" }
              });
            } catch (error) {
              handleImageUploadError();
              throw new Error("Upload failed");
            }
          } else {
            handleImageUploadError();
            throw new Error("Upload failed");
          }
        };
        fileUploadRequest.setRequestHeader(
          "Content-Type",
          imageFileToBeUploaded.value.file.type
        );
        fileUploadRequest.send(imageBlob);
      } catch (error) {
        handleImageUploadError();
        throw error;
      } finally {
        isUpdatingInfo.value = false;
      }
    }
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(UIModal), {
        show: showMandatedInfoModal.value,
        "onUpdate:show": handleClose,
        "z-index": 60,
        width: 480,
        maskClosable: true,
        closeOnEsc: true,
        "class-name": "mandated-info-modal flex h-full rounded-none md:h-auto md:rounded-xl"
      }, {
        header: withCtx(() => [
          createVNode(unref(UIModalHeader), {
            type: "custom",
            id: "post-editor-header"
          }, {
            customHeader: withCtx(() => [
              createElementVNode("div", _hoisted_1$L, [
                createVNode(unref(UITextLgMedium), { class: "text-clientportal-font-primary font-semibold" }, {
                  default: withCtx(() => [
                    createElementVNode("div", _hoisted_2$v, [
                      createElementVNode("div", _hoisted_3$q, toDisplayString(unref(t2)("mandatedInfoModal.completeYourProfile")), 1)
                    ])
                  ]),
                  _: 1
                }),
                createVNode(unref(UITextSmRegular), null, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(unref(t2)("mandatedInfoModal.putAFaceToYourProfile")), 1)
                  ]),
                  _: 1
                }),
                createVNode(unref(UITextSmRegular), null, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(unref(t2)("mandatedInfoModal.profilesBuildConnection")), 1)
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          })
        ]),
        footer: withCtx(() => [
          createElementVNode("div", _hoisted_6$h, [
            createVNode(unref(UIButton), {
              id: "mandated_info_save__btn",
              "button-type": "primary",
              class: "w-full rounded text-base font-semibold",
              loading: isCompleteLoading.value,
              disabled: showErrorProfilePhoto.value,
              onClick: completeProfile
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(unref(t2)("mandatedInfoModal.complete")), 1)
              ]),
              _: 1
            }, 8, ["loading", "disabled"])
          ])
        ]),
        default: withCtx(() => [
          createElementVNode("div", _hoisted_4$p, [
            createElementVNode("div", _hoisted_5$j, [
              createVNode(ImageUpload, {
                remove: () => {
                  profilePic.value = [];
                  imageFileToBeUploaded.value = void 0;
                },
                beforeUpload,
                handleCropImage,
                cropBoxWidth: 256,
                cropBoxHeight: 256,
                aspectRatio: 1
              }, null, 8, ["remove"]),
              createElementVNode("div", {
                class: normalizeClass([
                  "text-md mt-5 flex justify-center font-normal",
                  showErrorProfilePhoto.value ? "text-clientportal-error" : "text-clientportal-font-secondary"
                ])
              }, toDisplayString(unref(t2)("mandatedInfoModal.uploadASVGPNGJPG")) + " " + toDisplayString(unref(t2)("mandatedInfoModal.recommendedAspectRatio11")), 3)
            ])
          ])
        ]),
        _: 1
      }, 8, ["show"]);
    };
  }
});
const MandatedInfoModal = /* @__PURE__ */ _export_sfc(_sfc_main$S, [["__scopeId", "data-v-3fb71235"]]);
const _hoisted_1$K = { class: "flex-auto overflow-hidden rounded-2xl bg-clientportal-background text-sm leading-6 shadow-lg ring-1 ring-gray-900/5" };
const _hoisted_2$u = { class: "flex h-full min-h-[240px] flex-col justify-between" };
const _hoisted_3$p = { class: "mt-6 px-2 flex flex-col items-center" };
const _hoisted_4$o = {
  key: 0,
  class: "flex my-2"
};
const _sfc_main$R = /* @__PURE__ */ defineComponent({
  __name: "ProfileCard",
  props: {
    app_launcher_is_open: Boolean,
    profile_card_is_open: Boolean,
    position: {
      type: String,
      required: true
    },
    isUserAdmin: {
      type: Boolean,
      default: false
    },
    showPaymentIntegration: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:profile-card-is-open", "logout"],
  setup(__props, { emit: __emit }) {
    const isOpen = ref(false);
    const isLoading = ref(false);
    const isProfileModalOpen = ref(false);
    const emit = __emit;
    const t2 = inject("t");
    const props = __props;
    const handleProfileModal = () => {
      isProfileModalOpen.value = true;
    };
    const handleUploadImage = async (e) => {
      var _a, _b, _c, _d;
      isLoading.value = true;
      UserState.state.avatar = e;
      await UserState.updateUserProfile({
        locationId: (_b = (_a = LocationState) == null ? void 0 : _a.state) == null ? void 0 : _b.locationId,
        userId: (_d = (_c = UserState) == null ? void 0 : _c.state) == null ? void 0 : _d.userId,
        avatar: e
      });
      isLoading.value = false;
    };
    const ignoreElACRef = ref();
    const accountCloseEvent = [
      () => {
        emit("update:profile-card-is-open");
      },
      { ignore: [ignoreElACRef] }
    ];
    const handleLogout = async () => {
      emit("logout");
      isOpen.value = false;
      emit("update:profile-card-is-open");
    };
    const toggleMenu = () => {
      if (props.isUserAdmin) {
        return null;
      } else {
        emit("update:profile-card-is-open");
      }
    };
    return (_ctx, _cache) => {
      var _a, _b;
      return openBlock(), createElementBlock(Fragment, null, [
        createElementVNode("div", {
          class: normalizeClass([
            "flex h-10 w-10 items-center justify-center rounded-full",
            __props.profile_card_is_open && !__props.app_launcher_is_open ? "bg-clientportal-background" : ""
          ])
        }, [
          ((_a = unref(UserState).state) == null ? void 0 : _a.avatar) ? (openBlock(), createBlock(unref(UIAvatar), {
            key: 0,
            id: "pg-afcp-navbar__navigation-page-img-avatar-profile-btn",
            class: "z-20 cursor-pointer text-base",
            size: 32,
            onClick: toggleMenu,
            src: (_b = unref(UserState).state) == null ? void 0 : _b.avatar,
            ref_key: "ignoreElACRef",
            ref: ignoreElACRef
          }, null, 8, ["src"])) : (openBlock(), createBlock(unref(UIAvatar), {
            key: 1,
            id: "pg-afcp-navbar__navigation-page-txt-avatar-profile-btn",
            class: "z-20 cursor-pointer bg-clientportal-background text-base font-medium text-clientportal-font-primary",
            size: 32,
            onClick: toggleMenu,
            ref_key: "ignoreElACRef",
            ref: ignoreElACRef
          }, {
            default: withCtx(() => {
              var _a2;
              return [
                createTextVNode(toDisplayString(unref(formatNameForAvatar)((_a2 = unref(UserState).state) == null ? void 0 : _a2.fullName)), 1)
              ];
            }),
            _: 1
          }, 512))
        ], 2),
        createElementVNode("div", null, [
          createVNode(Transition, {
            "enter-from-class": "opacity-0 translate-y-1",
            "enter-active-class": "transition ease-out duration-200",
            "enter-to-class": "opacity-100 translate-y-0",
            "leave-from-class": "opacity-100 translate-y-0",
            "leave-to-class": "opacity-0 translate-y-1",
            "leave-active-class": "transition ease-in duration-150"
          }, {
            default: withCtx(() => {
              var _a2, _b2;
              return [
                __props.profile_card_is_open && !__props.app_launcher_is_open ? withDirectives((openBlock(), createElementBlock("div", {
                  key: 0,
                  class: normalizeClass(["absolute -right-4 z-10 mt-10 flex w-[258px] px-4 box-content", __props.position === "end" ? "-right-4 " : "-right-24"])
                }, [
                  createElementVNode("div", _hoisted_1$K, [
                    createElementVNode("div", _hoisted_2$u, [
                      createElementVNode("div", _hoisted_3$p, [
                        createElementVNode("div", { onClick: handleProfileModal }, [
                          ((_a2 = unref(UserState).state) == null ? void 0 : _a2.avatar) ? (openBlock(), createBlock(unref(UIAvatar), {
                            key: 0,
                            class: "shadow !border-none",
                            size: 104,
                            src: (_b2 = unref(UserState).state) == null ? void 0 : _b2.avatar,
                            indicator: unref(EditIcon)
                          }, null, 8, ["src", "indicator"])) : (openBlock(), createBlock(unref(UIAvatar), {
                            key: 1,
                            class: "bg-clientportal-background text-2xl !border-none font-medium text-clientportal-font-primary shadow",
                            size: 104,
                            indicator: unref(EditIcon)
                          }, {
                            default: withCtx(() => {
                              var _a3;
                              return [
                                createTextVNode(toDisplayString(unref(formatNameForAvatar)((_a3 = unref(UserState).state) == null ? void 0 : _a3.fullName)), 1)
                              ];
                            }),
                            _: 1
                          }, 8, ["indicator"]))
                        ]),
                        createVNode(unref(UITextLgMedium), { class: "pt-4 text-clientportal-font-primary text-xl w-full truncate text-center" }, {
                          default: withCtx(() => {
                            var _a3;
                            return [
                              createTextVNode(toDisplayString(unref(t2)("navbar.hi")) + ", " + toDisplayString(unref(capitalizeFirstLetterName)((_a3 = unref(UserState).state) == null ? void 0 : _a3.fullName)) + "! ", 1)
                            ];
                          }),
                          _: 1
                        }),
                        createVNode(unref(UITextSmRegular), { class: "w-full truncate text-center text-sm font-normal text-clientportal-font-primary" }, {
                          default: withCtx(() => {
                            var _a3;
                            return [
                              createTextVNode(toDisplayString((_a3 = unref(UserState).state) == null ? void 0 : _a3.email), 1)
                            ];
                          }),
                          _: 1
                        }),
                        __props.showPaymentIntegration ? (openBlock(), createElementBlock("div", _hoisted_4$o, [
                          createVNode(unref(UIPopover), null, {
                            trigger: withCtx(() => [
                              createVNode(unref(UIAvatar), {
                                class: "mr-2 !bg-transparent !text-clientportal-font-primary !border-none",
                                id: "account-settings",
                                onClick: _cache[0] || (_cache[0] = () => unref(externalPathRedirect)(
                                  "account",
                                  "activeTab=Account",
                                  true
                                ))
                              }, {
                                default: withCtx(() => [
                                  createVNode(unref(render$$), { class: "w-5 h-5" })
                                ]),
                                _: 1
                              })
                            ]),
                            default: withCtx(() => [
                              _cache[4] || (_cache[4] = createElementVNode("span", { class: "font-semibold p-2" }, "Account Settings", -1))
                            ]),
                            _: 1
                          }),
                          createVNode(unref(UIPopover), null, {
                            trigger: withCtx(() => [
                              createVNode(unref(UIAvatar), {
                                class: "!bg-transparent !text-clientportal-font-primary !border-none",
                                id: "payment-integration",
                                onClick: _cache[1] || (_cache[1] = () => unref(externalPathRedirect)("payments-integration", "", true))
                              }, {
                                default: withCtx(() => [
                                  createVNode(unref(render$B), { class: "w-5 h-5" })
                                ]),
                                _: 1
                              })
                            ]),
                            default: withCtx(() => [
                              _cache[5] || (_cache[5] = createElementVNode("span", { class: "font-semibold p-2" }, "Manage Payments", -1))
                            ]),
                            _: 1
                          })
                        ])) : createCommentVNode("", true),
                        createElementVNode("div", {
                          class: normalizeClass(["mb-6 flex flex-col gap-5", __props.showPaymentIntegration ? "mb-6" : "my-6"])
                        }, [
                          createElementVNode("div", {
                            id: "btn-profile",
                            class: "rounded-lg py-4 px-3 !font-semibold text-base hover:scale-105 text-white !hover:bg-clientportal-primary flex items-center bg-clientportal-primary",
                            onClick: _cache[2] || (_cache[2] = () => unref(externalPathRedirect)("account", "activeTab=Profile", true))
                          }, [
                            createVNode(unref(render$x), { class: "h-5 w-5 mr-2 text-white" }),
                            createTextVNode(" " + toDisplayString(unref(t2)("navbar.manageYourAccount")), 1)
                          ]),
                          createElementVNode("div", {
                            id: "pg-afcp-common__navbar-logout-btn",
                            onClick: handleLogout,
                            class: "text-clientportal-error-dark text-base !font-medium hover:scale-105 !hover:text-clientportal-error-dark flex justify-center items-center"
                          }, [
                            createVNode(unref(render$L), { class: "h-5 w-5 mr-2" }),
                            createTextVNode(" " + toDisplayString(unref(t2)("navbar.logOut")), 1)
                          ])
                        ], 2)
                      ])
                    ])
                  ])
                ], 2)), [
                  [unref(vOnClickOutside), accountCloseEvent]
                ]) : createCommentVNode("", true)
              ];
            }),
            _: 1
          })
        ]),
        createVNode(MandatedInfoModal, {
          showModal: isProfileModalOpen.value,
          "onUpdate:show": _cache[3] || (_cache[3] = ($event) => isProfileModalOpen.value = false),
          "onUpdate:save": handleUploadImage,
          isLoading: isLoading.value
        }, null, 8, ["showModal", "isLoading"])
      ], 64);
    };
  }
});
const ProfileCard = /* @__PURE__ */ _export_sfc(_sfc_main$R, [["__scopeId", "data-v-cdd5f9b3"]]);
const _hoisted_1$J = ["src"];
const _hoisted_2$t = { class: "ml-4 h-full flex items-center justify-center" };
const _hoisted_3$o = { key: 1 };
const _hoisted_4$n = { class: "absolute left-1/2 -translate-x-1/2 z-40 flex h-16 items-center" };
const _hoisted_5$i = { key: 0 };
const _hoisted_6$g = { key: 0 };
const _hoisted_7$e = { class: "relative" };
const __default__$4 = {
  name: "NavBar"
};
const _sfc_main$Q = /* @__PURE__ */ defineComponent({
  ...__default__$4,
  props: {
    routes: {
      type: Object
    },
    scrollHeight: {
      type: Number,
      default: 0
    },
    isLeftIcon: {
      type: Boolean,
      default: true
    },
    isHomeLeftIcon: {
      type: Boolean,
      default: true
    },
    isHome: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    backgroundImage: {
      type: String,
      default: ""
    },
    position: {
      type: String,
      default: "end"
    },
    opacityImg: {
      type: Number,
      default: 1
    },
    isUserAdmin: {
      type: Boolean,
      default: false
    },
    customAdminError: {
      type: String,
      default: ""
    },
    showPaymentIntegration: {
      type: Boolean,
      default: false
    },
    showProfile: {
      type: Boolean,
      default: true
    },
    showNotifications: {
      type: Boolean,
      default: true
    }
  },
  emits: ["toggle", "logout"],
  setup(__props, { emit: __emit }) {
    const slots = useSlots();
    const routerInstance = AppState.getRouterInstance();
    const route = computed(() => {
      if (!routerInstance) return null;
      return routerInstance.currentRoute;
    });
    const t2 = ref(null);
    onBeforeMount(() => {
      t2.value = setupVueI18n(getLocalePreference());
    });
    const emit = __emit;
    const notification = useNotification();
    const handleToggle = (item) => {
      emit("toggle", item);
    };
    const profile_card_is_open = ref(false);
    const app_launcher_is_open = ref(false);
    const notification_list_is_open = ref(false);
    provide("t", t2);
    const props = __props;
    function handleAdminError() {
      notification.create({
        type: "error",
        title: "An error occurred...",
        content: props.customAdminError || `This user is not the part of client-portal`,
        duration: 5e3
      });
    }
    function toggleProfileCard() {
      app_launcher_is_open.value = false;
      notification_list_is_open.value = false;
      profile_card_is_open.value = !profile_card_is_open.value;
    }
    function toggleNotificationList() {
      profile_card_is_open.value = false;
      app_launcher_is_open.value = false;
      notification_list_is_open.value = !notification_list_is_open.value;
    }
    function toggleAppLauncher() {
      notification_list_is_open.value = false;
      profile_card_is_open.value = false;
      app_launcher_is_open.value = !app_launcher_is_open.value;
    }
    function receiveLogoutUser(logoutUser2) {
      emit("logout", logoutUser2);
    }
    return (_ctx, _cache) => {
      var _a, _b, _c, _d, _e, _f, _g;
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["left-0 right-0 top-0 z-50 items-center nav-container flex justify-between shadow border-0 border-b border-solid border-clientportal-border", unref(isGokollab)() ? "h-[60px]" : "h-16"])
      }, [
        __props.backgroundImage ? (openBlock(), createElementBlock("img", {
          key: 0,
          src: __props.backgroundImage,
          style: normalizeStyle({ opacity: __props.opacityImg }),
          class: normalizeClass(`absolute object-fill h-16 w-full`)
        }, null, 12, _hoisted_1$J)) : createCommentVNode("", true),
        createElementVNode("div", _hoisted_2$t, [
          __props.isLeftIcon && !unref(isGokollab)() ? (openBlock(), createBlock(unref(UIAvatar), {
            key: 0,
            onClick: _cache[0] || (_cache[0] = ($event) => __props.isUserAdmin ? handleAdminError() : unref(externalPathRedirect)("home", "")),
            class: normalizeClass(
              __props.isHome ? __props.scrollHeight > 0 ? "h-6 w-6 bg-gray-100 cursor-pointer z-10" : "hidden" : "h-6 w-6 bg-gray-100 cursor-pointer z-10"
            ),
            src: ((_b = (_a = unref(LocationState).state) == null ? void 0 : _a.branding) == null ? void 0 : _b.logo) ? (_c = unref(LocationState).state) == null ? void 0 : _c.branding.logo : unref(GROUP_BRANDING_NAVBAR)
          }, null, 8, ["class", "src"])) : createCommentVNode("", true),
          ((_d = unref(slots)) == null ? void 0 : _d["filter-left"]) ? (openBlock(), createElementBlock("div", _hoisted_3$o, [
            renderSlot(_ctx.$slots, "filter-left", {}, void 0, true)
          ])) : createCommentVNode("", true)
        ]),
        createElementVNode("div", _hoisted_4$n, [
          ((_e = unref(slots)) == null ? void 0 : _e["filter-middle"]) ? (openBlock(), createElementBlock("div", _hoisted_5$i, [
            renderSlot(_ctx.$slots, "filter-middle", {}, void 0, true)
          ])) : (openBlock(), createBlock(unref(UIToolbarGroup), { key: 1 }, {
            default: withCtx(() => [
              createVNode(unref(UIButtonGroup), null, {
                default: withCtx(() => [
                  (openBlock(true), createElementBlock(Fragment, null, renderList(__props.routes, (item) => {
                    var _a2;
                    return openBlock(), createBlock(unref(UIButton), {
                      key: item.name,
                      onClick: () => handleToggle(item),
                      ghost: "",
                      disabled: __props.disabled,
                      id: `pg-afcp-navbar__navigation-page-${item.name.toLowerCase().replace("/", "-")}-btn`,
                      active: ((_a2 = route.value) == null ? void 0 : _a2.name) == item.routeName,
                      class: normalizeClass(item.current ? "!bg-gray-200 !text-black" : "")
                    }, {
                      default: withCtx(() => [
                        createElementVNode("span", null, toDisplayString(item.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick", "disabled", "id", "active", "class"]);
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        ]),
        createElementVNode("div", {
          class: normalizeClass(`flex w-full items-center gap-2 ml-4 justify-${__props.position}`)
        }, [
          ((_f = unref(slots)) == null ? void 0 : _f["filter-right"]) ? (openBlock(), createElementBlock("div", _hoisted_6$g, [
            renderSlot(_ctx.$slots, "filter-right", {}, void 0, true)
          ])) : createCommentVNode("", true),
          __props.isHomeLeftIcon && !unref(isGokollab)() ? (openBlock(), createElementBlock("div", {
            key: 1,
            id: "app-launcher",
            class: "flex z-20 h-10 w-10 cursor-pointer items-center justify-center rounded-full text-gray-500 hover:bg-gray-200",
            onClick: _cache[1] || (_cache[1] = ($event) => __props.isUserAdmin ? handleAdminError() : unref(externalPathRedirect)("home", "")),
            role: "button",
            tabindex: "0"
          }, [
            createVNode(unref(render$10), { class: "h-5 w-5 topNavIconColor" })
          ])) : createCommentVNode("", true),
          !unref(isGokollab)() ? (openBlock(), createBlock(unref(UIButton), {
            key: 2,
            id: "btn-app",
            onClick: _cache[2] || (_cache[2] = ($event) => __props.isUserAdmin && handleAdminError()),
            text: true,
            "aria-label": t2.value("accessibility.appSwitcher")
          }, {
            default: withCtx(() => [
              createVNode(AppSwitcher, {
                "onUpdate:appLauncherIsOpen": toggleAppLauncher,
                profile_card_is_open: profile_card_is_open.value,
                app_launcher_is_open: app_launcher_is_open.value,
                position: __props.position,
                isUserAdmin: __props.isUserAdmin
              }, null, 8, ["profile_card_is_open", "app_launcher_is_open", "position", "isUserAdmin"])
            ]),
            _: 1
          }, 8, ["aria-label"])) : createCommentVNode("", true),
          createElementVNode("div", _hoisted_7$e, [
            __props.showNotifications && ((_g = unref(UserState).state) == null ? void 0 : _g.fullName) ? (openBlock(), createBlock(NotificationWeb, {
              key: 0,
              "onUpdate:notificationListIsOpen": toggleNotificationList,
              profile_card_is_open: profile_card_is_open.value,
              app_launcher_is_open: app_launcher_is_open.value,
              notification_list_is_open: notification_list_is_open.value,
              position: __props.position
            }, null, 8, ["profile_card_is_open", "app_launcher_is_open", "notification_list_is_open", "position"])) : createCommentVNode("", true)
          ]),
          __props.showProfile ? (openBlock(), createBlock(unref(UIButton), {
            key: 3,
            id: "btn-profile",
            onClick: _cache[3] || (_cache[3] = ($event) => __props.isUserAdmin && handleAdminError()),
            text: true,
            class: "mr-4"
          }, {
            default: withCtx(() => {
              var _a2;
              return [
                ((_a2 = unref(UserState).state) == null ? void 0 : _a2.fullName) ? (openBlock(), createBlock(ProfileCard, {
                  key: 0,
                  "onUpdate:profileCardIsOpen": toggleProfileCard,
                  profile_card_is_open: profile_card_is_open.value,
                  app_launcher_is_open: app_launcher_is_open.value,
                  onLogout: receiveLogoutUser,
                  position: __props.position,
                  isUserAdmin: __props.isUserAdmin,
                  showPaymentIntegration: __props.showPaymentIntegration
                }, null, 8, ["profile_card_is_open", "app_launcher_is_open", "position", "isUserAdmin", "showPaymentIntegration"])) : createCommentVNode("", true)
              ];
            }),
            _: 1
          })) : createCommentVNode("", true)
        ], 2)
      ], 2);
    };
  }
});
const NavBar = /* @__PURE__ */ _export_sfc(_sfc_main$Q, [["__scopeId", "data-v-ae969c90"]]);
NavBar.install = (Vue) => {
  Vue.component(NavBar.name, NavBar);
};
const _hoisted_1$I = { class: "sticky top-24 overflow-hidden" };
const _hoisted_2$s = { class: "flex flex-col items-center justify-center border-0 border-b border-solid border-clientportal-border px-4 pb-6" };
const _hoisted_3$n = ["onClick"];
const _hoisted_4$m = { class: "col-span-1 mt-2" };
const _hoisted_5$h = {
  key: 0,
  class: "px-6 py-8 text-center"
};
const _sfc_main$P = /* @__PURE__ */ defineComponent({
  __name: "SideBar",
  setup(__props) {
    const sidebarApps = inject("sidebarApps");
    const t2 = inject("t");
    const isHome = inject("isHome");
    const iconMap = {
      Users01Icon: render$5,
      BookOpen01Icon: render$4,
      CurrencyDollarCircleIcon: render$1,
      FileCheck02Icon: render,
      Briefcase02Icon: render$3,
      FolderIcon: render$2
    };
    return (_ctx, _cache) => {
      var _a, _b, _c;
      return openBlock(), createElementBlock("div", {
        class: normalizeClass([{
          "min-w-[240px] lg:min-w-[340px]": !unref(isHome)
        }, "w-[24vw] border-r border-clientportal-border bg-clientportal-background shadow"])
      }, [
        createElementVNode("div", _hoisted_1$I, [
          createElementVNode("div", _hoisted_2$s, [
            createVNode(unref(UIAvatar), {
              class: "h-28 w-28 border-4 border-solid border-white shadow-lg",
              round: true,
              src: ((_b = (_a = unref(LocationState).state) == null ? void 0 : _a.branding) == null ? void 0 : _b.logo) ? (_c = unref(LocationState).state) == null ? void 0 : _c.branding.logo : unref(DEFAULT_AVATAR),
              alt: unref(t2)("accessibility.portalImage")
            }, null, 8, ["src", "alt"]),
            createVNode(unref(UIDisplaySmMedium), { class: "mt-4 text-clientportal-font-primary" }, {
              default: withCtx(() => {
                var _a2, _b2;
                return [
                  createTextVNode(toDisplayString((_b2 = (_a2 = unref(LocationState).state) == null ? void 0 : _a2.branding) == null ? void 0 : _b2.portalBannerText), 1)
                ];
              }),
              _: 1
            })
          ]),
          (openBlock(true), createElementBlock(Fragment, null, renderList(unref(sidebarApps), (app) => {
            return openBlock(), createElementBlock("div", {
              key: app.key
            }, [
              createElementVNode("div", {
                onClick: ($event) => unref(externalPathRedirect)(app.route, app.path || "", false),
                class: "grid grid-cols-6 items-center border-0 border-b border-solid border-clientportal-fill cursor-pointer px-6 py-4 hover:bg-clientportal-fill"
              }, [
                createElementVNode("div", _hoisted_4$m, [
                  (openBlock(), createBlock(resolveDynamicComponent(iconMap[app.icon] || app.icon), { class: "h-5 w-5 text-clientportal-font-primary" }))
                ]),
                createVNode(unref(UITextMdMedium), { class: "col-span-4 text-clientportal-font-primary" }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(unref(t2)(app.title)), 1)
                  ]),
                  _: 2
                }, 1024),
                createVNode(unref(UIButton), {
                  id: "btn-trigger",
                  class: "ml-2",
                  type: "default",
                  size: "medium",
                  quaternary: true,
                  circle: true,
                  "aria-label": unref(t2)(app.title)
                }, {
                  default: withCtx(() => [
                    createVNode(unref(render$11), {
                      class: "col-span-1 h-5 w-5 text-clientportal-primary",
                      "aria-hidden": "true"
                    })
                  ]),
                  _: 2
                }, 1032, ["aria-label"])
              ], 8, _hoisted_3$n)
            ]);
          }), 128)),
          unref(sidebarApps).length === 0 ? (openBlock(), createElementBlock("div", _hoisted_5$h, [
            createVNode(unref(UITextSmRegular), { class: "text-clientportal-font-secondary" }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(unref(t2)("userActivityOverview.dustBunnies")), 1)
              ]),
              _: 1
            })
          ])) : createCommentVNode("", true)
        ])
      ], 2);
    };
  }
});
const _hoisted_1$H = { class: "col-span-2 mb-6 rounded-xl bg-white p-4 shadow overflow-y-auto" };
const _hoisted_2$r = {
  key: 0,
  class: "flex flex-col justify-center items-center h-[246px]"
};
const _hoisted_3$m = ["src", "alt"];
const _hoisted_4$l = { class: "mb-4 flex justify-between rounded-xl border border-solid border-clientportal-border p-4" };
const _hoisted_5$g = { class: "flex items-center" };
const _hoisted_6$f = { class: "ml-4" };
const _hoisted_7$d = { key: 0 };
const _sfc_main$O = /* @__PURE__ */ defineComponent({
  __name: "ContractsWeb",
  setup(__props) {
    const isHome = inject("isHome");
    const contractData = inject("contractData");
    const contractDataCount = inject("contractDataCount");
    const isLoading = ref(false);
    const loadingContractId = ref(null);
    const validPageSizes = [5, 10, 20];
    const t2 = inject("t");
    const pageSize = ref(5);
    const pageCount = computed(
      () => Math.ceil(contractDataCount.value / pageSize.value)
    );
    async function updatePageSize(size) {
      pageSize.value = size;
      await getContractsPageData(1);
    }
    const notification = useNotification();
    function notificationAlert(title, content) {
      notification.create({
        type: "error",
        title,
        content,
        duration: 5e3
      });
    }
    const getContractsPageData = async (offset = 1) => {
      var _a, _b, _c;
      isLoading.value = true;
      const contracts = await BillingService.getContracts({
        contactId: UserState.state.userId,
        locationId: (_b = (_a = LocationState) == null ? void 0 : _a.state) == null ? void 0 : _b.locationId,
        limit: pageSize.value,
        offset: (offset - 1) * pageSize.value
      });
      contractData.value = ((_c = contracts == null ? void 0 : contracts.data) == null ? void 0 : _c.documents) || [];
      isLoading.value = false;
    };
    async function updatePageNumber(pageNumber) {
      await getContractsPageData(pageNumber);
    }
    const handleDocumentAction = async (contract) => {
      var _a, _b;
      try {
        if (contract.hasCompleted) {
          loadingContractId.value = contract.documentId;
          const data = await BillingService.downloadContractPdf({
            documentId: contract.documentId,
            altType: "location",
            altId: LocationState.state.locationId,
            isPublicRequest: true
          });
          await AnalyticsService.trackPageViewEvents({
            locationId: LocationState.state.locationId,
            eventType: CPPageEvents.CLIENT_PORTAL_CONTRACT_DOWNLOAD,
            platform: UserPlatform.WEB,
            route: data == null ? void 0 : data.data.url
          });
          downloadPdf(data == null ? void 0 : data.data.url);
        } else {
          await AnalyticsService.trackPageViewEvents({
            locationId: LocationState.state.locationId,
            eventType: CPPageEvents.CLIENT_PORTAL_CONTRACT_VIEW,
            platform: UserPlatform.WEB,
            route: contract == null ? void 0 : contract.url
          });
          window.open(contract == null ? void 0 : contract.url, "_blank");
        }
      } catch (error) {
        notificationAlert(
          t2.value("widget.notAbleToDownloadContract"),
          ((_b = (_a = error == null ? void 0 : error.response) == null ? void 0 : _a.data) == null ? void 0 : _b.message) || t2.value("widget.selectPageError")
        );
      } finally {
        loadingContractId.value = null;
      }
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$H, [
        createVNode(unref(UITextLgMedium), { class: "mb-4 text-clientportal-font-primary" }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(unref(t2)("widget.contracts")), 1)
          ]),
          _: 1
        }),
        unref(contractData).length === 0 ? (openBlock(), createElementBlock("div", _hoisted_2$r, [
          createElementVNode("img", {
            src: unref(EMPTY_FOLDER),
            alt: unref(t2)("widget.noContracts"),
            class: "h-24 w-24"
          }, null, 8, _hoisted_3$m),
          createVNode(unref(UITextXsRegular), { class: "text-clientportal-font-secondary mt-2" }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(unref(t2)("widget.youDoNotHaveAny")), 1)
            ]),
            _: 1
          })
        ])) : isLoading.value ? (openBlock(true), createElementBlock(Fragment, { key: 1 }, renderList(pageSize.value, (i) => {
          return openBlock(), createElementBlock("div", { key: i }, [
            createVNode(unref(UISkeleton), {
              text: false,
              repeat: 1,
              class: "h-20 mb-4 rounded-xl"
            })
          ]);
        }), 128)) : (openBlock(true), createElementBlock(Fragment, { key: 2 }, renderList(unref(contractData), (contract) => {
          return openBlock(), createElementBlock("div", {
            key: contract._id
          }, [
            createElementVNode("div", _hoisted_4$l, [
              createElementVNode("div", _hoisted_5$g, [
                createVNode(unref(UIAvatar), {
                  id: "file-logo",
                  class: normalizeClass([
                    "h-10 w-10",
                    contract.hasCompleted ? "bg-clientportal-fill" : "bg-warning-100"
                  ])
                }, {
                  default: withCtx(() => [
                    createVNode(unref(render$M), {
                      class: normalizeClass([
                        "mt-1 h-5 w-5",
                        contract.hasCompleted ? "text-clientportal-font-primary" : "text-warning-600"
                      ])
                    }, null, 8, ["class"])
                  ]),
                  _: 2
                }, 1032, ["class"]),
                createElementVNode("div", _hoisted_6$f, [
                  createVNode(unref(UITextMdMedium), { class: "text-clientportal-font-primary truncate max-w-[12vw]" }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(contract.name), 1)
                    ]),
                    _: 2
                  }, 1024),
                  createVNode(unref(UITextXsMedium), { class: "text-clientportal-font-secondary" }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(unref(t2)("widget.addedOn")) + " " + toDisplayString(unref(formatDateDay)(contract.createdAt)), 1)
                    ]),
                    _: 2
                  }, 1024)
                ])
              ]),
              createVNode(unref(UIButton), {
                id: "contracts-view-all",
                type: "primary",
                onClick: ($event) => handleDocumentAction(contract),
                class: normalizeClass(["hover:scale-105 hover:text-clientportal-tertiary", [
                  "!font-semibold",
                  contract.hasCompleted && "text-clientportal-font-primary"
                ]]),
                text: true
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(contract.hasCompleted ? unref(t2)("widget.download") : unref(t2)("widget.signContract")) + " ", 1),
                  contract.hasCompleted ? (openBlock(), createElementBlock("div", _hoisted_7$d, [
                    loadingContractId.value === contract.documentId ? (openBlock(), createBlock(unref(UISpin), {
                      key: 0,
                      id: contract.documentId,
                      size: "small",
                      class: "ml-2 h-5 w-5 text-clientportal-font-primary"
                    }, null, 8, ["id"])) : (openBlock(), createBlock(unref(render$c), {
                      key: 1,
                      class: "ml-2 h-5 w-5 text-clientportal-font-primary hover:text-clientportal-tertiary"
                    }))
                  ])) : (openBlock(), createBlock(unref(render$N), {
                    key: 1,
                    class: "ml-2 h-5 w-5"
                  }))
                ]),
                _: 2
              }, 1032, ["onClick", "class"])
            ])
          ]);
        }), 128)),
        !unref(isHome) ? (openBlock(), createBlock(unref(UIPagination), {
          key: 3,
          pageCount: pageCount.value,
          id: "pagination-contracts",
          pageSize: pageSize.value,
          pageSizes: validPageSizes,
          showSizePicker: true,
          "onUpdate:page": updatePageNumber,
          "onUpdate:pageSize": updatePageSize
        }, null, 8, ["pageCount", "pageSize"])) : createCommentVNode("", true),
        unref(contractData).length >= 5 && unref(isHome) ? (openBlock(), createBlock(unref(UIButton), {
          key: 4,
          id: "contracts-view-all",
          type: "default",
          class: "mr-5 !font-semibold contents",
          text: true,
          onClick: _cache[0] || (_cache[0] = ($event) => unref(externalPathRedirect)("contracts", "", false))
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(unref(t2)("widget.viewAll")), 1)
          ]),
          _: 1
        })) : createCommentVNode("", true)
      ]);
    };
  }
});
const Contracts = /* @__PURE__ */ _export_sfc(_sfc_main$O, [["__scopeId", "data-v-0e1b285f"]]);
const _hoisted_1$G = { class: "col-span-2 mb-6 rounded-xl bg-white p-4 shadow" };
const _hoisted_2$q = { class: "flex justify-between items-center" };
const _hoisted_3$l = { class: "flex items-center" };
const _hoisted_4$k = { class: "progress" };
const _sfc_main$N = /* @__PURE__ */ defineComponent({
  __name: "CoursesWeb",
  setup(__props) {
    const dashboardManager2 = inject("dashboardManager");
    const coursesActivityData = computed(
      () => {
        var _a;
        return ((_a = dashboardManager2 == null ? void 0 : dashboardManager2.data) == null ? void 0 : _a.coursesActivity) || {};
      }
    );
    const t2 = inject("t");
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$G, [
        createElementVNode("div", _hoisted_2$q, [
          createElementVNode("div", null, [
            createVNode(unref(UITextLgMedium), { class: "text-clientportal-font-primary" }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(unref(t2)("widget.courseProgress")), 1)
              ]),
              _: 1
            }),
            createElementVNode("div", _hoisted_3$l, [
              createVNode(unref(UITextXsMedium), { class: "text-clientportal-font-secondary" }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(`${unref(t2)("widget.youMarked")} ${coursesActivityData.value.completedPosts}/${coursesActivityData.value.totalPosts} ${unref(t2)("widget.inCourse")}`), 1)
                ]),
                _: 1
              }),
              createVNode(unref(UITextSmMedium), { class: "ml-1 text-clientportal-tertiary" }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(`"${coursesActivityData.value.courseName}"`), 1)
                ]),
                _: 1
              })
            ]),
            createVNode(unref(UIButton), {
              id: "courses-btn",
              type: "primary",
              class: "mt-6 !font-semibold hover:scale-105",
              onClick: _cache[0] || (_cache[0] = ($event) => unref(externalPathRedirect)(
                `courses/products/${coursesActivityData.value.productId}`,
                "",
                false
              ))
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(unref(t2)("widget.completeCourse")), 1)
              ]),
              _: 1
            })
          ]),
          createElementVNode("div", _hoisted_4$k, [
            createVNode(unref(UIProgress), {
              type: "circle",
              gapDegree: 0,
              percentage: coursesActivityData.value.progress,
              strokeWidth: 16,
              offsetDegree: 180,
              color: "var(--tertiary)",
              railColor: "var(--primary-100)"
            }, null, 8, ["percentage"])
          ])
        ])
      ]);
    };
  }
});
const Courses = /* @__PURE__ */ _export_sfc(_sfc_main$N, [["__scopeId", "data-v-0d8dd942"]]);
const _hoisted_1$F = { class: "col-span-2 mb-6 rounded-xl bg-white p-4 shadow overflow-y-auto" };
const _hoisted_2$p = {
  key: 0,
  class: "flex flex-col justify-center items-center h-[226px]"
};
const _hoisted_3$k = ["src", "alt"];
const _hoisted_4$j = { class: "mb-4 flex justify-between rounded-xl border border-solid border-clientportal-border p-4" };
const _hoisted_5$f = { class: "flex items-center" };
const _hoisted_6$e = { class: "ml-4" };
const _hoisted_7$c = { key: 0 };
const _sfc_main$M = /* @__PURE__ */ defineComponent({
  __name: "EstimatesWeb",
  setup(__props) {
    const estimateData = inject("estimateData");
    const estimateDataCount = inject("estimateDataCount");
    const isLoading = ref(false);
    const loadingEstimateId = ref(null);
    const validPageSizes = [5, 10, 20];
    const locale = ref(getLocalePreference());
    const t2 = inject("t");
    const isHome = inject("isHome");
    const pageSize = ref(5);
    const pageCount = computed(
      () => Math.ceil(estimateDataCount.value / pageSize.value)
    );
    async function updatePageSize(size) {
      pageSize.value = size;
      await getEstimatesPageData(1);
    }
    const notification = useNotification();
    function notificationAlert(title, content) {
      notification.create({
        type: "error",
        title,
        content,
        duration: 5e3
      });
    }
    const getEstimatesPageData = async (offset = 1) => {
      var _a, _b, _c;
      isLoading.value = true;
      const newEstimates = await BillingService.getEstimates({
        contactId: UserState.state.userId,
        locationId: (_b = (_a = LocationState) == null ? void 0 : _a.state) == null ? void 0 : _b.locationId,
        limit: pageSize.value,
        offset: (offset - 1) * pageSize.value,
        status: "all"
      });
      estimateData.value = ((_c = newEstimates == null ? void 0 : newEstimates.data) == null ? void 0 : _c.estimates) || [];
      isLoading.value = false;
    };
    async function updatePageNumber(pageNumber) {
      await getEstimatesPageData(pageNumber);
    }
    const handleEstimatesAction = async (estimate) => {
      var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
      try {
        if (estimate.estimateStatus === EstimateStatus.ACCEPTED) {
          loadingEstimateId.value = estimate._id;
          const downloadEstimate = await BillingService.downloadEstimatePdf({
            estimateId: estimate._id,
            altType: "location",
            locationId: LocationState.state.locationId
          });
          await AnalyticsService.trackPageViewEvents({
            locationId: LocationState.state.locationId,
            eventType: CPPageEvents.CLIENT_PORTAL_ESTIMATE_DOWNLOAD,
            platform: UserPlatform.WEB,
            route: (_a = downloadEstimate == null ? void 0 : downloadEstimate.data) == null ? void 0 : _a.url
          });
          downloadPdf((_b = downloadEstimate == null ? void 0 : downloadEstimate.data) == null ? void 0 : _b.url);
        } else {
          const link = await BillingService.generateUrl({
            locationId: (_d = (_c = LocationState) == null ? void 0 : _c.state) == null ? void 0 : _d.locationId,
            id: estimate._id,
            type: "estimate",
            contactId: (_f = (_e = UserState) == null ? void 0 : _e.state) == null ? void 0 : _f.userId
          });
          await AnalyticsService.trackPageViewEvents({
            locationId: LocationState.state.locationId,
            eventType: CPPageEvents.CLIENT_PORTAL_ESTIMATE_VIEW,
            platform: UserPlatform.WEB,
            route: (_g = link == null ? void 0 : link.data) == null ? void 0 : _g.url
          });
          window.open((_h = link == null ? void 0 : link.data) == null ? void 0 : _h.url, "_blank");
        }
      } catch (error) {
        notificationAlert(
          t2.value("widget.notAbleToDownloadEstimate"),
          ((_j = (_i = error == null ? void 0 : error.response) == null ? void 0 : _i.data) == null ? void 0 : _j.message) || t2.value("widget.selectPageError")
        );
      } finally {
        loadingEstimateId.value = null;
      }
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$F, [
        createVNode(unref(UITextLgMedium), { class: "mb-4 text-clientportal-font-primary" }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(unref(t2)("widget.estimates")), 1)
          ]),
          _: 1
        }),
        unref(estimateData).length === 0 ? (openBlock(), createElementBlock("div", _hoisted_2$p, [
          createElementVNode("img", {
            src: unref(EMPTY_FOLDER),
            alt: unref(t2)("widget.noEstimates"),
            class: "h-24 w-24"
          }, null, 8, _hoisted_3$k),
          createVNode(unref(UITextXsRegular), { class: "text-clientportal-font-secondary mt-2" }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(unref(t2)("widget.youDoNotHaveAny")), 1)
            ]),
            _: 1
          })
        ])) : isLoading.value ? (openBlock(true), createElementBlock(Fragment, { key: 1 }, renderList(pageSize.value, (i) => {
          return openBlock(), createElementBlock("div", { key: i }, [
            createVNode(unref(UISkeleton), {
              text: false,
              repeat: 1,
              class: "h-20 mb-4 rounded-xl"
            })
          ]);
        }), 128)) : (openBlock(true), createElementBlock(Fragment, { key: 2 }, renderList(unref(estimateData), (estimate) => {
          return openBlock(), createElementBlock("div", {
            key: estimate._id
          }, [
            createElementVNode("div", _hoisted_4$j, [
              createElementVNode("div", _hoisted_5$f, [
                createVNode(unref(UIAvatar), {
                  id: "file-logo",
                  class: normalizeClass([
                    "h-10 w-10",
                    estimate.estimateStatus === unref(EstimateStatus).ACCEPTED ? "bg-clientportal-fill" : "bg-warning-100"
                  ])
                }, {
                  default: withCtx(() => [
                    createVNode(unref(render$P), {
                      class: normalizeClass([
                        "mt-1 h-5 w-5",
                        estimate.estimateStatus === unref(EstimateStatus).ACCEPTED ? "text-clientportal-font-primary" : "text-warning-600"
                      ])
                    }, null, 8, ["class"])
                  ]),
                  _: 2
                }, 1032, ["class"]),
                createElementVNode("div", _hoisted_6$e, [
                  createVNode(unref(UITextMdMedium), { class: "text-clientportal-font-primary truncate max-w-[12vw]" }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(estimate.name), 1)
                    ]),
                    _: 2
                  }, 1024),
                  createVNode(unref(UITextXsMedium), { class: "text-clientportal-font-secondary" }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(unref(t2)("widget.addedOn")) + " " + toDisplayString(unref(formatDateDay)(estimate.createdAt)), 1)
                    ]),
                    _: 2
                  }, 1024)
                ])
              ]),
              createVNode(unref(UIButton), {
                id: "estimates-view-all",
                type: "primary",
                onClick: ($event) => handleEstimatesAction(estimate),
                class: normalizeClass(["hover:scale-105 hover:text-clientportal-tertiary", [
                  "!font-semibold",
                  estimate.estimateStatus === unref(EstimateStatus).ACCEPTED && "text-clientportal-font-primary"
                ]]),
                text: true
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(!unref(isHome) ? estimate.estimateStatus === unref(EstimateStatus).ACCEPTED ? unref(t2)("common.download") : unref(t2)("common.view") : null) + " ", 1),
                  estimate.estimateStatus === unref(EstimateStatus).ACCEPTED ? (openBlock(), createElementBlock("div", _hoisted_7$c, [
                    loadingEstimateId.value === estimate._id ? (openBlock(), createBlock(unref(UISpin), {
                      key: 0,
                      id: estimate._id,
                      size: "small",
                      class: "ml-2 h-5 w-5 text-clientportal-font-primary"
                    }, null, 8, ["id"])) : (openBlock(), createBlock(unref(render$c), {
                      key: 1,
                      class: "ml-2 h-5 w-5 text-clientportal-font-primary hover:text-clientportal-tertiary cursor-pointer"
                    }))
                  ])) : (openBlock(), createBlock(unref(render$O), {
                    key: 1,
                    class: "ml-2 h-5 w-5 text-clientportal-tertiary cursor-pointer"
                  }))
                ]),
                _: 2
              }, 1032, ["onClick", "class"])
            ])
          ]);
        }), 128)),
        createVNode(unref(UIContentWrap), {
          fullScreen: false,
          locale: locale.value
        }, {
          default: withCtx(() => [
            !unref(isHome) ? (openBlock(), createBlock(unref(UIPagination), {
              key: 0,
              pageCount: pageCount.value,
              id: "pagination-estimates",
              pageSize: pageSize.value,
              pageSizes: validPageSizes,
              showSizePicker: true,
              "onUpdate:page": updatePageNumber,
              "onUpdate:pageSize": updatePageSize
            }, null, 8, ["pageCount", "pageSize"])) : createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["locale"]),
        unref(estimateData).length >= 5 && unref(isHome) ? (openBlock(), createBlock(unref(UIButton), {
          key: 3,
          id: "estimates-view-all",
          type: "default",
          class: "mr-5 !font-semibold contents",
          text: true,
          onClick: _cache[0] || (_cache[0] = ($event) => unref(externalPathRedirect)("estimates", "", false))
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(unref(t2)("widget.viewAll")), 1)
          ]),
          _: 1
        })) : createCommentVNode("", true)
      ]);
    };
  }
});
const EstimatesWeb = /* @__PURE__ */ _export_sfc(_sfc_main$M, [["__scopeId", "data-v-14b2e9bd"]]);
const _hoisted_1$E = { class: "col-span-2 mb-6 rounded-xl bg-white p-4 shadow" };
const _hoisted_2$o = { class: "flex justify-between" };
const _hoisted_3$j = ["onClick"];
const _hoisted_4$i = ["src", "alt"];
const _sfc_main$L = /* @__PURE__ */ defineComponent({
  __name: "GroupsWeb",
  setup(__props) {
    const dashboardManager2 = inject("dashboardManager");
    const groupsData = computed(() => {
      var _a;
      return ((_a = dashboardManager2 == null ? void 0 : dashboardManager2.data) == null ? void 0 : _a.groups) || [];
    });
    const t2 = inject("t");
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$E, [
        createElementVNode("div", _hoisted_2$o, [
          createVNode(unref(UITextLgMedium), { class: "text-clientportal-font-primary" }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(unref(t2)("widget.recentlyOpened")), 1)
            ]),
            _: 1
          }),
          createVNode(unref(UIButton), {
            id: "groups-view-all",
            type: "default",
            class: "!font-semibold",
            text: true,
            onClick: _cache[0] || (_cache[0] = ($event) => unref(externalPathRedirect)("communities", "", false))
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(unref(t2)("widget.viewAllGroups")), 1)
            ]),
            _: 1
          })
        ]),
        createElementVNode("div", {
          class: normalizeClass(
            groupsData.value.length === 1 ? "flex justify-center" : "flex justify-between"
          )
        }, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(groupsData.value, (group) => {
            var _a, _b;
            return openBlock(), createElementBlock("div", {
              key: group.name,
              onClick: ($event) => unref(externalPathRedirect)(
                `communities/groups/${group.slug}/home`,
                "",
                false
              ),
              class: normalizeClass([
                "rounded-lg border border-solid border-clientportal-border p-3 h-[200px] mx-2 cursor-pointer hover:shadow-md hover:scale-105 mt-4",
                groupsData.value.length > 2 ? "w-[50%]" : "w-[45%]"
              ])
            }, [
              createElementVNode("img", {
                src: ((_a = group == null ? void 0 : group.branding) == null ? void 0 : _a.cover) ? (_b = group == null ? void 0 : group.branding) == null ? void 0 : _b.cover : unref(DEFAULT_COVER),
                alt: group.name,
                class: normalizeClass([
                  "h-24 w-full rounded-lg object-cover",
                  groupsData.value.length > 2 ? "w-full" : "w-full"
                ])
              }, null, 10, _hoisted_4$i),
              createVNode(unref(UITextXsMedium), { class: "my-2 text-clientportal-font-primary max-w-[10vw] truncate" }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(group.name), 1)
                ]),
                _: 2
              }, 1024),
              createVNode(unref(UITextXsRegular), { class: "text-clientportal-font-secondary line-clamp-3" }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(group.description), 1)
                ]),
                _: 2
              }, 1024)
            ], 10, _hoisted_3$j);
          }), 128))
        ], 2)
      ]);
    };
  }
});
const _hoisted_1$D = { class: "col-span-2 mb-6 rounded-xl bg-white p-4 shadow" };
const _hoisted_2$n = {
  key: 0,
  class: "flex flex-col justify-center items-center h-[246px]"
};
const _hoisted_3$i = ["src", "alt"];
const _hoisted_4$h = { class: "mb-4 flex items-center justify-between rounded-xl border border-solid border-clientportal-border p-4" };
const _hoisted_5$e = { class: "flex items-center" };
const _hoisted_6$d = { class: "ml-4" };
const _hoisted_7$b = { key: 0 };
const _sfc_main$K = /* @__PURE__ */ defineComponent({
  __name: "InvoicesWeb",
  setup(__props) {
    const invoiceData = inject("invoiceData");
    const loadingInvoiceId = ref(null);
    const t2 = inject("t");
    const invoiceStatus = getInvoiceStatus(invoiceData);
    const notification = useNotification();
    function notificationAlert(title, content) {
      notification.create({
        type: "error",
        title,
        content,
        duration: 5e3
      });
    }
    async function handleActionInvoice(id, isDownloadable) {
      var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
      try {
        if (isDownloadable) {
          loadingInvoiceId.value = id;
          const data = await BillingService.downloadInvoiceById({
            locationId: (_b = (_a = LocationState) == null ? void 0 : _a.state) == null ? void 0 : _b.locationId,
            invoiceId: id,
            contactId: (_d = (_c = UserState) == null ? void 0 : _c.state) == null ? void 0 : _d.userId
          });
          downloadPdf((_e = data == null ? void 0 : data.data) == null ? void 0 : _e.url);
        } else {
          const link = await BillingService.generateUrl({
            locationId: (_g = (_f = LocationState) == null ? void 0 : _f.state) == null ? void 0 : _g.locationId,
            id,
            type: "invoice",
            contactId: (_i = (_h = UserState) == null ? void 0 : _h.state) == null ? void 0 : _i.userId
          });
          window.open((_j = link == null ? void 0 : link.data) == null ? void 0 : _j.url, "_blank");
        }
      } catch (error) {
        notificationAlert(
          t2.value("widget.notAbleToDownloadInvoice"),
          (error == null ? void 0 : error.message) || t2.value("profileSettings.selectPageError")
        );
      } finally {
        loadingInvoiceId.value = null;
      }
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$D, [
        createVNode(unref(UITextLgMedium), { class: "mb-4 text-clientportal-font-primary" }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(unref(t2)("billing.invoices")), 1)
          ]),
          _: 1
        }),
        unref(invoiceData).length === 0 ? (openBlock(), createElementBlock("div", _hoisted_2$n, [
          createElementVNode("img", {
            src: unref(EMPTY_FOLDER),
            alt: unref(t2)("widget.noInvoices"),
            class: "h-24 w-24"
          }, null, 8, _hoisted_3$i),
          createVNode(unref(UITextXsRegular), { class: "text-clientportal-font-secondary mt-2" }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(unref(t2)("widget.youDoNotHaveAny")), 1)
            ]),
            _: 1
          })
        ])) : (openBlock(true), createElementBlock(Fragment, { key: 1 }, renderList(unref(invoiceStatus), (invoice) => {
          var _a, _b, _c;
          return openBlock(), createElementBlock("div", {
            key: invoice._id
          }, [
            createElementVNode("div", _hoisted_4$h, [
              createElementVNode("div", _hoisted_5$e, [
                createVNode(unref(UIAvatar), {
                  id: "file-logo",
                  class: normalizeClass(["h-10 w-10", (_a = invoice == null ? void 0 : invoice.customFields) == null ? void 0 : _a.avatarColor])
                }, {
                  default: withCtx(() => {
                    var _a2;
                    return [
                      createVNode(unref(render$P), {
                        class: normalizeClass(["mt-1 h-5 w-5", (_a2 = invoice == null ? void 0 : invoice.customFields) == null ? void 0 : _a2.iconColor])
                      }, null, 8, ["class"])
                    ];
                  }),
                  _: 2
                }, 1032, ["class"]),
                createElementVNode("div", _hoisted_6$d, [
                  createVNode(unref(UITextMdMedium), { class: "text-clientportal-font-primary truncate max-w-[26vw]" }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(`${unref(t2)("widget.invoice")} #${invoice.invoiceNumber}`), 1)
                    ]),
                    _: 2
                  }, 1024)
                ])
              ]),
              createVNode(unref(UITextXsMedium), {
                class: normalizeClass([(_b = invoice == null ? void 0 : invoice.customFields) == null ? void 0 : _b.textColor])
              }, {
                default: withCtx(() => {
                  var _a2, _b2;
                  return [
                    createTextVNode(toDisplayString(unref(t2)((_a2 = invoice == null ? void 0 : invoice.customFields) == null ? void 0 : _a2.text) + " " + ((_b2 = invoice == null ? void 0 : invoice.customFields) == null ? void 0 : _b2.status)), 1)
                  ];
                }),
                _: 2
              }, 1032, ["class"]),
              createVNode(unref(UIButton), {
                id: "contracts-view-all",
                type: "primary",
                class: normalizeClass(["hover:scale-105 hover:text-clientportal-tertiary", [
                  "!font-semibold",
                  ((_c = invoice == null ? void 0 : invoice.customFields) == null ? void 0 : _c.isDownloadable) && "text-clientportal-font-primary"
                ]]),
                text: true,
                onClick: ($event) => {
                  var _a2;
                  return handleActionInvoice(
                    invoice._id,
                    (_a2 = invoice == null ? void 0 : invoice.customFields) == null ? void 0 : _a2.isDownloadable
                  );
                }
              }, {
                default: withCtx(() => {
                  var _a2, _b2;
                  return [
                    createTextVNode(toDisplayString(((_a2 = invoice == null ? void 0 : invoice.customFields) == null ? void 0 : _a2.isDownloadable) ? unref(t2)("widget.downloadInvoice") : unref(t2)("widget.makePayment")) + " ", 1),
                    ((_b2 = invoice == null ? void 0 : invoice.customFields) == null ? void 0 : _b2.isDownloadable) ? (openBlock(), createElementBlock("div", _hoisted_7$b, [
                      loadingInvoiceId.value === invoice._id ? (openBlock(), createBlock(unref(UISpin), {
                        key: 0,
                        id: invoice._id,
                        size: "small",
                        class: "ml-2 h-5 w-5 text-clientportal-font-primary"
                      }, null, 8, ["id"])) : (openBlock(), createBlock(unref(render$c), {
                        key: 1,
                        class: "ml-2 h-5 w-5 text-clientportal-font-primary"
                      }))
                    ])) : (openBlock(), createBlock(unref(render$N), {
                      key: 1,
                      class: "ml-2 h-5 w-5"
                    }))
                  ];
                }),
                _: 2
              }, 1032, ["class", "onClick"])
            ])
          ]);
        }), 128)),
        unref(invoiceData).length >= 5 ? (openBlock(), createBlock(unref(UIButton), {
          key: 2,
          id: "contracts-view-all",
          type: "default",
          class: "mr-5 !font-semibold contents",
          text: true,
          onClick: _cache[0] || (_cache[0] = ($event) => unref(externalPathRedirect)("account?activeTab=BillingSubscription", "", false))
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(unref(t2)("widget.viewAll")), 1)
          ]),
          _: 1
        })) : createCommentVNode("", true)
      ]);
    };
  }
});
const Invoices = /* @__PURE__ */ _export_sfc(_sfc_main$K, [["__scopeId", "data-v-1b366ca8"]]);
const _sfc_main$J = {
  __name: "DeleteConfirmationModal",
  props: {
    show: {
      type: Boolean
    }
  },
  emits: ["confirmDelete", "canceled"],
  setup(__props, { emit: __emit }) {
    const t2 = inject("t");
    const props = __props;
    const showModal = ref(props.show);
    const emit = __emit;
    onMounted(() => showModal.value = props.show);
    watch(
      () => props.show,
      (showModalVal) => showModal.value = showModalVal
    );
    const handleClose = () => {
      showModal.value = false;
      emit("canceled");
    };
    function handleDelete() {
      emit("confirmDelete");
      showModal.value = false;
    }
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(UIModal), {
        width: 544,
        autoFocus: false,
        maskClosable: true,
        onOnMaskClick: handleClose,
        show: showModal.value,
        modalAriaLabel: unref(t2)("uploadDocument.confirmDeletion"),
        class: "fixed top-10 left-0 right-0 flex justify-center"
      }, {
        header: withCtx(() => [
          createVNode(unref(UIModalHeader), {
            type: "error",
            title: unref(t2)("uploadDocument.confirmDeletion"),
            description: unref(t2)("uploadDocument.deleteFileDescription"),
            icon: unref(render$12),
            onClose: handleClose,
            id: "modal-header"
          }, null, 8, ["title", "description", "icon"])
        ]),
        footer: withCtx(() => [
          createVNode(unref(UIModalFooter), {
            positiveText: unref(t2)("uploadDocument.deleteFileButton"),
            negativeText: unref(t2)("uploadDocument.cancel"),
            onPositiveClick: handleDelete,
            onNegativeClick: handleClose,
            loading: false,
            disabled: false,
            id: "modal-footer",
            type: "error",
            disableNegativeBtn: false
          }, null, 8, ["positiveText", "negativeText"])
        ]),
        _: 1
      }, 8, ["show", "modalAriaLabel"]);
    };
  }
};
var FileUploadStatus = /* @__PURE__ */ ((FileUploadStatus2) => {
  FileUploadStatus2["FINISHED"] = "finished";
  FileUploadStatus2["UPLOADING"] = "uploading";
  FileUploadStatus2["PENDING"] = "pending";
  FileUploadStatus2["ERROR"] = "error";
  return FileUploadStatus2;
})(FileUploadStatus || {});
const _hoisted_1$C = { id: "documents-upload-draggable-section" };
const _hoisted_2$m = { class: "flex justify-stretch !mt-6" };
const _sfc_main$I = /* @__PURE__ */ defineComponent({
  __name: "UploadDocumentModal",
  props: {
    show: {
      type: Boolean
    }
  },
  emits: ["update:show", "canceled"],
  setup(__props, { emit: __emit }) {
    const t2 = inject("t");
    const showModal = ref(false);
    const isUploading = ref(false);
    const fileList = ref([]);
    const props = __props;
    const emit = __emit;
    const notification = useNotification();
    const isSaveDisabled = ref(true);
    onMounted(() => showModal.value = props.show);
    watch(
      () => props.show,
      (showModalVal) => showModal.value = showModalVal
    );
    const handleClose = () => {
      showModal.value = false;
      fileList.value = [];
      emit("update:show", false);
      emit("canceled");
    };
    watchEffect(() => {
      isSaveDisabled.value = fileList.value.length === 0;
    });
    function handleChange(data) {
      fileList.value = data.fileList.map((file) => {
        if (file.file.size > FILE_SIZE_LIMIT) file.status = "error";
        if (!checkAllowedExtension(allowedFileTypesString, file.file.name))
          file.status = "error";
        return {
          ...file
        };
      });
    }
    async function handleSaveDocuments() {
      isUploading.value = true;
      await handleMultipleFilesUpload();
      fileList.value = [];
      emit("update:show", false);
      isUploading.value = false;
    }
    async function handleMultipleFilesUpload() {
      const uploadingFiles = fileList.value.map(async (file) => {
        if (file.file.size > FILE_SIZE_LIMIT || file.status === FileUploadStatus.FINISHED || file.status === FileUploadStatus.UPLOADING || !checkAllowedExtension(allowedFileTypesString, file.name)) {
          if (file.file.size > FILE_SIZE_LIMIT)
            notification.error({
              title: t2("uploadDocument.fileSizeExceeded", { fileName: file.name })
            });
          if (!checkAllowedExtension(allowedFileTypesString, file.name))
            notification.error({
              title: t2("uploadDocument.invalidFileType", { fileName: file.name })
            });
          return Promise.resolve();
        }
        return uploadFile(file.file);
      });
      await Promise.allSettled(uploadingFiles);
    }
    async function uploadFile(file) {
      try {
        await DashboardService.uploadSharedFiles(
          LocationState.state.locationId,
          UserState.state.userId,
          SourceType.CLIENT_PORTAL,
          file
        );
        notification.success({
          title: t2("uploadDocument.fileUploadedSuccessfully"),
          duration: 5e3
        });
      } catch (error) {
        notification.error({
          title: t2("uploadDocument.notAbleToUploadFile"),
          duration: 5e3
        });
      }
    }
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(UIModal), {
        show: showModal.value,
        className: "fixed top-10 left-0 right-0 flex justify-center document-management-upload-model",
        "onUpdate:show": handleClose,
        "close-on-esc": true
      }, {
        header: withCtx(() => [
          createVNode(unref(UIModalHeader), {
            type: "primary",
            title: unref(t2)("uploadDocument.uploadHeader"),
            description: unref(t2)("uploadDocument.uploadDescription"),
            icon: unref(render$13),
            onClose: handleClose,
            id: "modal-header"
          }, null, 8, ["title", "description", "icon"]),
          createVNode(unref(UIAlert), {
            id: "alert-shared-files",
            type: "warning",
            closable: true
          }, {
            content: withCtx(() => [
              createTextVNode(toDisplayString(unref(t2)("uploadDocument.uploadWarning")), 1)
            ]),
            _: 1
          })
        ]),
        footer: withCtx(() => [
          createElementVNode("div", _hoisted_2$m, [
            createVNode(unref(UIButton), {
              id: "modal-footer-cancel",
              class: "grow",
              onClick: handleClose
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(unref(t2)("uploadDocument.cancelButton")), 1)
              ]),
              _: 1
            }),
            createVNode(unref(UIButton), {
              id: "modal-footer-save",
              onClick: handleSaveDocuments,
              type: "primary",
              class: "!ml-4 grow",
              loading: isUploading.value,
              disabled: isSaveDisabled.value || isUploading.value
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(unref(t2)("uploadDocument.uploadButton")), 1)
              ]),
              _: 1
            }, 8, ["loading", "disabled"])
          ])
        ]),
        default: withCtx(() => [
          createVNode(unref(UIModalContent), null, {
            default: withCtx(() => [
              createElementVNode("div", _hoisted_1$C, [
                createVNode(unref(UIUpload), {
                  onChange: handleChange,
                  fileList: fileList.value,
                  "show-retry-button": false,
                  accept: unref(allowedFileTypesString),
                  class: "bg-inherit",
                  multiple: true,
                  max: 10
                }, {
                  extra: withCtx(() => [
                    createVNode(unref(UITextSmRegular), { class: "text-clientportal-font-secondary font-['Roboto']" }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(unref(t2)("uploadDocument.uploadInstruction")), 1)
                      ]),
                      _: 1
                    }),
                    createVNode(unref(UITextXsRegular), { class: "text-clientportal-font-secondary font-['Roboto']" }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(unref(t2)("uploadDocument.allowedFiles")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["fileList", "accept"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["show"]);
    };
  }
});
const UploadDocumentModal = /* @__PURE__ */ _export_sfc(_sfc_main$I, [["__scopeId", "data-v-6068d108"]]);
const _hoisted_1$B = { class: "col-span-2 mb-6 rounded-xl bg-white p-4 shadow overflow-y-auto" };
const _hoisted_2$l = { class: "flex justify-between items-center" };
const _hoisted_3$h = {
  key: 0,
  class: "flex flex-col justify-center items-center h-[226px]"
};
const _hoisted_4$g = ["src", "alt"];
const _hoisted_5$d = { class: "mb-4 flex justify-between items-center rounded-xl border border-solid border-clientportal-border p-4" };
const _hoisted_6$c = { class: "flex items-center" };
const _hoisted_7$a = { class: "ml-4" };
const _sfc_main$H = /* @__PURE__ */ defineComponent({
  __name: "SharedFilesWeb",
  setup(__props) {
    const sharedFilesData = inject("sharedFilesData");
    const sharedFilesDataCount = inject("sharedFilesDataCount");
    const getSharedFilesData = inject("getSharedFilesData");
    const isLoading = ref(false);
    const locale = ref(getLocalePreference());
    const showModalUploadDocument = ref(false);
    const downloadDocumentId = ref(null);
    const validPageSizes = [5, 10, 20];
    const t2 = inject("t");
    const isHome = inject("isHome");
    const pageSize = ref(5);
    const pageCount = computed(
      () => Math.ceil((sharedFilesDataCount == null ? void 0 : sharedFilesDataCount.value) || 0 / pageSize.value)
    );
    const showDeleteModal = ref(false);
    const fileToDeleteId = ref(null);
    const notification = useNotification();
    async function deleteFile() {
      var _a, _b, _c, _d;
      try {
        await BillingService.deleteSharedFile({
          documentId: fileToDeleteId.value,
          locationId: (_b = (_a = LocationState) == null ? void 0 : _a.state) == null ? void 0 : _b.locationId,
          contactId: UserState.state.userId,
          documentType: DOCUMENT_TYPE.RECEIVED
        });
        notification.success({
          title: t2.value("uploadDocument.deleteFileSuccessTitle"),
          duration: 5e3
        });
        await getSharedFilesPageData(1);
      } catch (error) {
        notification.error({
          title: t2.value("uploadDocument.deleteFileErrorTitle"),
          content: ((_d = (_c = error == null ? void 0 : error.response) == null ? void 0 : _c.data) == null ? void 0 : _d.message) || t2.value("uploadDocument.deleteFileErrorMessage"),
          duration: 5e3
        });
      } finally {
        showDeleteModal.value = false;
        fileToDeleteId.value = null;
      }
    }
    async function updatePageSize(size) {
      pageSize.value = size;
      await getSharedFilesPageData(1);
    }
    const getSharedFilesPageData = async (skip = 1) => {
      isLoading.value = true;
      try {
        await getSharedFilesData(skip);
      } catch (error) {
        console.error("Error fetching shared files:", error);
      } finally {
        isLoading.value = false;
      }
    };
    async function updatePageNumber(pageNumber) {
      await getSharedFilesPageData(pageNumber);
    }
    const handleFinishUploadDocument = () => {
      showModalUploadDocument.value = false;
      getSharedFilesPageData(1);
    };
    function getFileOptions(sharedFile) {
      const options = [
        {
          label: t2.value("common.download"),
          key: "Download",
          icon() {
            return h(renderIcon$1(render$c), null, {});
          }
        },
        {
          label: t2.value("common.view"),
          key: "Preview",
          icon() {
            return h(renderIcon$1(render$R), null, {});
          }
        }
      ];
      if (sharedFile.source === SourceType.CLIENT_PORTAL) {
        options.push({
          label: () => h(
            "span",
            { class: "text-clientportal-error-primary" },
            t2.value("common.delete")
          ),
          key: "Delete",
          icon() {
            return h(
              renderIcon$1(render$C),
              { class: "text-clientportal-error-primary" },
              {}
            );
          }
        });
      }
      return options;
    }
    async function handleDownloadFile(id) {
      var _a, _b;
      try {
        downloadDocumentId.value = id;
        const downloadDocument = await BillingService.downloadSharedFile({
          documentId: id
        });
        await AnalyticsService.trackPageViewEvents({
          locationId: LocationState.state.locationId,
          eventType: CPPageEvents.CLIENT_PORTAL_SHARED_FILE_DOWNLOAD,
          platform: UserPlatform.WEB,
          route: `${AppState.getConfig().DOCUMENT_MANAGEMENT_SERVICE}/download/${id}`
        });
        const contentType = downloadDocument.headers["content-type"] || "application/octet-stream";
        const blob = new Blob([downloadDocument.data], { type: contentType });
        const contentDisposition = downloadDocument.headers["content-disposition"];
        const fileName = contentDisposition ? contentDisposition.split("filename=")[1].replace(/"/g, "") : "document";
        const blobURL = window.URL.createObjectURL(blob);
        const tempLink = document.createElement("a");
        tempLink.href = blobURL;
        tempLink.download = fileName;
        document.body.appendChild(tempLink);
        tempLink.click();
        document.body.removeChild(tempLink);
        window.URL.revokeObjectURL(blobURL);
      } catch (error) {
        notification.error({
          title: t2("uploadDocument.notAbleToDownloadFile"),
          content: ((_b = (_a = error == null ? void 0 : error.response) == null ? void 0 : _a.data) == null ? void 0 : _b.message) || t2("uploadDocument.downloadError"),
          duration: 5e3
        });
      } finally {
        downloadDocumentId.value = null;
      }
    }
    async function handlePreview(id) {
      await AnalyticsService.trackPageViewEvents({
        locationId: LocationState.state.locationId,
        eventType: CPPageEvents.CLIENT_PORTAL_SHARED_FILE_VIEW,
        platform: UserPlatform.WEB,
        route: `${AppState.getConfig().DOCUMENT_MANAGEMENT_SERVICE}/download/${id}`
      });
      window.open(
        `${AppState.getConfig().DOCUMENT_MANAGEMENT_SERVICE}/download/${id}`,
        "_blank"
      );
    }
    async function handleDelete(id) {
      fileToDeleteId.value = id;
      showDeleteModal.value = true;
    }
    async function onSelect(key, id) {
      switch (key) {
        case FileAction.DOWNLOAD: {
          handleDownloadFile(id);
          return;
        }
        case FileAction.PREVIEW: {
          handlePreview(id);
          return;
        }
        case FileAction.DELETE: {
          handleDelete(id);
          return;
        }
      }
    }
    const handleAddFilesAction = () => {
      showModalUploadDocument.value = true;
    };
    const handleCancelUploadDocument = () => {
      showModalUploadDocument.value = false;
    };
    const handleCancelDeleteFile = () => {
      showDeleteModal.value = false;
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$B, [
        createElementVNode("div", _hoisted_2$l, [
          createVNode(unref(UITextLgMedium), { class: "mb-4 text-clientportal-font-primary" }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(unref(t2)("widget.sharedFiles")), 1)
            ]),
            _: 1
          }),
          createVNode(unref(UITextSmMedium), {
            class: "mb-4 text-clientportal-font-primary flex items-center cursor-pointer",
            id: "add-files",
            onClick: handleAddFilesAction
          }, {
            default: withCtx(() => [
              createVNode(unref(render$14), { class: "h-5 w-5 mr-1" }),
              createTextVNode(" " + toDisplayString(unref(t2)("widget.addFiles")), 1)
            ]),
            _: 1
          })
        ]),
        unref(sharedFilesData).length === 0 ? (openBlock(), createElementBlock("div", _hoisted_3$h, [
          createElementVNode("img", {
            src: unref(EMPTY_FOLDER),
            alt: unref(t2)("widget.noSharedFiles"),
            class: "h-24 w-24"
          }, null, 8, _hoisted_4$g),
          createVNode(unref(UITextXsRegular), { class: "text-clientportal-font-secondary mt-2" }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(unref(t2)("widget.youDoNotHaveAny")), 1)
            ]),
            _: 1
          })
        ])) : isLoading.value ? (openBlock(true), createElementBlock(Fragment, { key: 1 }, renderList(pageSize.value, (i) => {
          return openBlock(), createElementBlock("div", { key: i }, [
            createVNode(unref(UISkeleton), {
              text: false,
              repeat: 1,
              class: "h-20 mb-4 rounded-xl"
            })
          ]);
        }), 128)) : (openBlock(true), createElementBlock(Fragment, { key: 2 }, renderList(unref(sharedFilesData), (sharedFile) => {
          return openBlock(), createElementBlock("div", {
            key: sharedFile._id
          }, [
            createElementVNode("div", _hoisted_5$d, [
              createElementVNode("div", _hoisted_6$c, [
                createVNode(unref(UIAvatar), {
                  id: "file-logo",
                  class: "h-10 w-10 bg-clientportal-fill"
                }, {
                  default: withCtx(() => [
                    createVNode(unref(render$P), { class: "mt-1 h-5 w-5 text-clientportal-font-primary" })
                  ]),
                  _: 1
                }),
                createElementVNode("div", _hoisted_7$a, [
                  createVNode(unref(UITextMdMedium), { class: "text-clientportal-font-primary truncate max-w-[12vw]" }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(sharedFile.name), 1)
                    ]),
                    _: 2
                  }, 1024),
                  createVNode(unref(UITextXsMedium), { class: "text-clientportal-font-secondary" }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(`${unref(t2)("widget.addedOn")} ${unref(formatDateDay)(
                        sharedFile.createdAt
                      )} ${unref(t2)("widget.by")} ${sharedFile.source === unref(SourceType).CLIENT_PORTAL ? unref(t2)("widget.you") : unref(t2)("widget.admin")}`), 1)
                    ]),
                    _: 2
                  }, 1024)
                ])
              ]),
              createVNode(unref(UIDropdown), {
                options: getFileOptions(sharedFile),
                onSelect: (key) => onSelect(key, sharedFile.id),
                id: "fileActionOptions"
              }, {
                default: withCtx(() => [
                  downloadDocumentId.value === sharedFile.id ? (openBlock(), createBlock(unref(UISpin), {
                    key: 0,
                    id: sharedFile.id,
                    size: "small",
                    class: "h-5 w-5 text-clientportal-font-primary"
                  }, null, 8, ["id"])) : (openBlock(), createBlock(unref(render$o), {
                    key: 1,
                    class: "w-5 h-5"
                  }))
                ]),
                _: 2
              }, 1032, ["options", "onSelect"])
            ])
          ]);
        }), 128)),
        createVNode(unref(UIContentWrap), {
          fullScreen: false,
          locale: locale.value
        }, {
          default: withCtx(() => [
            !unref(isHome) ? (openBlock(), createBlock(unref(UIPagination), {
              key: 0,
              pageCount: pageCount.value,
              id: "pagination-shared-files",
              pageSize: pageSize.value,
              pageSizes: validPageSizes,
              showSizePicker: true,
              "onUpdate:page": updatePageNumber,
              "onUpdate:pageSize": updatePageSize
            }, null, 8, ["pageCount", "pageSize"])) : createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["locale"]),
        unref(sharedFilesData).length >= 5 && unref(isHome) ? (openBlock(), createBlock(unref(UIButton), {
          key: 3,
          id: "shared-files-view-all",
          type: "default",
          class: "mr-5 !font-semibold contents",
          text: true,
          onClick: _cache[0] || (_cache[0] = ($event) => unref(externalPathRedirect)("shared-files", "", false))
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(unref(t2)("widget.viewAll")), 1)
          ]),
          _: 1
        })) : createCommentVNode("", true),
        createVNode(UploadDocumentModal, {
          show: showModalUploadDocument.value,
          "onUpdate:show": handleFinishUploadDocument,
          onClose: _cache[1] || (_cache[1] = ($event) => showModalUploadDocument.value = false),
          onCanceled: handleCancelUploadDocument
        }, null, 8, ["show"]),
        createVNode(_sfc_main$J, {
          show: showDeleteModal.value,
          onConfirmDelete: deleteFile,
          onClose: _cache[2] || (_cache[2] = ($event) => showDeleteModal.value = false),
          onCanceled: handleCancelDeleteFile
        }, null, 8, ["show"])
      ]);
    };
  }
});
const SharedFilesWeb = /* @__PURE__ */ _export_sfc(_sfc_main$H, [["__scopeId", "data-v-8994fb34"]]);
const _hoisted_1$A = {
  key: 0,
  class: "flex flex-col h-screen items-center justify-start mt-20"
};
const _hoisted_2$k = ["src"];
const _hoisted_3$g = {
  key: 1,
  class: "w-full"
};
const _hoisted_4$f = { key: 1 };
const _sfc_main$G = /* @__PURE__ */ defineComponent({
  __name: "MiddleContainer",
  props: {
    widgets: { default: void 0 }
  },
  setup(__props) {
    const props = __props;
    const isContracts = inject("isContracts");
    const isEstimates = inject("isEstimates");
    const isSharedFiles = inject("isSharedFiles");
    const isHome = inject("isHome");
    const homeWidgets = inject("homeWidgets");
    const t2 = inject("t");
    const currentView = computed(() => {
      switch (true) {
        case isContracts.value:
          return Contracts;
        case isEstimates.value:
          return EstimatesWeb;
        case isSharedFiles.value:
          return SharedFilesWeb;
        default:
          return null;
      }
    });
    const componentMap = {
      Groups: _sfc_main$L,
      Courses,
      Invoices,
      Contracts,
      Estimates: EstimatesWeb,
      SharedFiles: SharedFilesWeb
    };
    const displayWidgets = computed(() => {
      return props.widgets || (homeWidgets == null ? void 0 : homeWidgets.value) || [];
    });
    const components = computed(() => {
      return displayWidgets.value.map((widget2) => ({
        ...widget2,
        component: componentMap[widget2.component]
      })) || [];
    });
    const containerClasses = computed(() => {
      const base = "overflow-auto pr-6";
      const width = !isHome.value ? "w-[60vw] flex flex-col items-center" : "w-[45vw]";
      return `${base} ${width}`;
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(containerClasses.value)
      }, [
        components.value.length === 0 && unref(isHome) ? (openBlock(), createElementBlock("div", _hoisted_1$A, [
          createElementVNode("img", {
            src: unref(EMPTY_STATE),
            alt: "empty-state",
            class: "w-80 h-80"
          }, null, 8, _hoisted_2$k),
          createVNode(unref(UITextSmRegular), { class: "text-clientportal-font-secondary" }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(unref(t2)("userActivityOverview.dustBunnies")), 1)
            ]),
            _: 1
          })
        ])) : (openBlock(), createElementBlock("div", _hoisted_3$g, [
          currentView.value ? (openBlock(), createBlock(resolveDynamicComponent(currentView.value), { key: 0 })) : (openBlock(), createElementBlock("div", _hoisted_4$f, [
            (openBlock(true), createElementBlock(Fragment, null, renderList(components.value, (dashboardComponent) => {
              return openBlock(), createBlock(resolveDynamicComponent(dashboardComponent.component), {
                key: dashboardComponent.key
              });
            }), 128))
          ]))
        ]))
      ], 2);
    };
  }
});
const _hoisted_1$z = { class: "w-[26vw] overflow-auto" };
const _sfc_main$F = /* @__PURE__ */ defineComponent({
  __name: "RightContainer",
  props: {
    widgets: { default: void 0 }
  },
  setup(__props) {
    const props = __props;
    const webHomeWidgets = inject("webHomeWidgets");
    const componentMap = {
      Estimates: EstimatesWeb,
      SharedFiles: SharedFilesWeb
    };
    const displayWidgets = computed(() => {
      if (props.widgets) {
        return props.widgets;
      }
      if (!(webHomeWidgets == null ? void 0 : webHomeWidgets.value)) return [];
      return webHomeWidgets.value.filter(
        (widget2) => widget2.key === WIDGET_KEYS.ESTIMATES || widget2.key === WIDGET_KEYS.SHARED_FILES
      );
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$z, [
        (openBlock(true), createElementBlock(Fragment, null, renderList(displayWidgets.value, (dashboardComponent) => {
          return openBlock(), createBlock(resolveDynamicComponent(
            componentMap[dashboardComponent.component] || dashboardComponent.component
          ), {
            key: dashboardComponent.key
          });
        }), 128))
      ]);
    };
  }
});
const _hoisted_1$y = {
  class: /* @__PURE__ */ normalizeClass(["w-full flex", "justify-center"])
};
const _hoisted_2$j = {
  key: 0,
  class: "w-[70vw] overflow-auto py-3 px-6"
};
const _hoisted_3$f = { class: "flex flex-col" };
const _hoisted_4$e = { key: 0 };
const _hoisted_5$c = {
  key: 1,
  class: "flex w-full"
};
const _hoisted_6$b = { class: "mt-7 w-[765px]" };
const _hoisted_7$9 = { class: "mt-7 ml-4 w-[400px]" };
const _hoisted_8$7 = {
  key: 1,
  class: "flex flex-col"
};
const _hoisted_9$5 = { class: "flex flex-col items-start py-6" };
const _hoisted_10$5 = { class: "flex" };
const _hoisted_11$5 = {
  key: 1,
  class: "w-[26vw] overflow-auto"
};
const _sfc_main$E = /* @__PURE__ */ defineComponent({
  __name: "WidgetContainer",
  setup(__props) {
    const webHomeWidgets = inject("webHomeWidgets");
    const t2 = inject("t");
    const isLoading = inject("isLoading");
    const isHome = inject("isHome");
    const isContracts = inject("isContracts");
    const isEstimates = inject("isEstimates");
    const isSharedFiles = inject("isSharedFiles");
    const smartWidgetDistribution = computed(() => {
      if (!(webHomeWidgets == null ? void 0 : webHomeWidgets.value)) return { middle: [], right: [] };
      const mainWidgets = webHomeWidgets.value.filter(
        (widget2) => [
          WIDGET_KEYS.GROUPS,
          WIDGET_KEYS.COURSES,
          WIDGET_KEYS.INVOICES,
          WIDGET_KEYS.CONTRACTS
        ].includes(widget2.key)
      );
      const rightSideWidgets = webHomeWidgets.value.filter(
        (widget2) => [WIDGET_KEYS.ESTIMATES, WIDGET_KEYS.SHARED_FILES].includes(
          widget2.key
        )
      );
      if (mainWidgets.length > 0) {
        return {
          middle: mainWidgets,
          right: rightSideWidgets
        };
      } else if (rightSideWidgets.length > 0) {
        return {
          middle: rightSideWidgets,
          right: []
        };
      }
      return { middle: [], right: [] };
    });
    const shouldShowRightContainer = computed(() => {
      return isHome.value && smartWidgetDistribution.value.right.length > 0;
    });
    const activityText = computed(() => {
      switch (true) {
        case isContracts.value:
          return t2.value("userActivityOverview.contracts");
        case isEstimates.value:
          return t2.value("userActivityOverview.estimates");
        case isSharedFiles.value:
          return t2.value("userActivityOverview.sharedFiles");
        default:
          return "";
      }
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$y, [
        unref(isLoading) ? (openBlock(), createElementBlock("div", _hoisted_2$j, [
          createElementVNode("div", _hoisted_3$f, [
            createVNode(unref(UISkeleton), {
              text: false,
              repeat: 1,
              class: "h-10 w-1/3 rounded-xl"
            }),
            createVNode(unref(UISkeleton), {
              text: false,
              repeat: 1,
              class: "h-12 w-2/3 rounded-xl mt-2"
            })
          ]),
          !unref(isHome) ? (openBlock(), createElementBlock("div", _hoisted_4$e, [
            createVNode(unref(UISkeleton), {
              text: false,
              repeat: 1,
              class: "h-[500px] w-[765px] rounded-xl mt-7"
            })
          ])) : (openBlock(), createElementBlock("div", _hoisted_5$c, [
            createElementVNode("div", _hoisted_6$b, [
              (openBlock(), createElementBlock(Fragment, null, renderList(["h-52", "h-36", "h-36", "h-36"], (height, index2) => {
                return createVNode(unref(UISkeleton), {
                  key: index2,
                  text: false,
                  repeat: 1,
                  class: normalizeClass([height, "rounded-xl", index2 > 0 ? "mt-6" : ""])
                }, null, 8, ["class"]);
              }), 64))
            ]),
            createElementVNode("div", _hoisted_7$9, [
              (openBlock(), createElementBlock(Fragment, null, renderList(2, (_, index2) => {
                return createVNode(unref(UISkeleton), {
                  key: index2,
                  text: false,
                  repeat: 1,
                  class: normalizeClass(["h-96", "rounded-xl", index2 > 0 ? "mt-6" : ""])
                }, null, 8, ["class"]);
              }), 64))
            ])
          ]))
        ])) : (openBlock(), createElementBlock("div", _hoisted_8$7, [
          createElementVNode("div", _hoisted_9$5, [
            createVNode(unref(UITextMdNormal), { class: "text-clientportal-font-secondary" }, {
              default: withCtx(() => {
                var _a, _b;
                return [
                  createTextVNode(toDisplayString(unref(t2)("navbar.hi")) + ", " + toDisplayString((_b = (_a = unref(UserState)) == null ? void 0 : _a.state) == null ? void 0 : _b.fullName), 1)
                ];
              }),
              _: 1
            }),
            !unref(isHome) ? (openBlock(), createBlock(unref(UIButton), {
              key: 0,
              id: "btn-back",
              onClick: _cache[0] || (_cache[0] = ($event) => unref(externalPathRedirect)("home", "")),
              text: true
            }, {
              default: withCtx(() => [
                createVNode(unref(render$6), { class: "h-6 w-6 text-clientportal-font-primary mr-1" }),
                createVNode(unref(UITextLgMedium), { class: "text-clientportal-font-primary" }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(activityText.value), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })) : (openBlock(), createBlock(unref(UIDisplaySmMedium), {
              key: 1,
              class: "text-clientportal-font-primary"
            }, {
              default: withCtx(() => {
                var _a, _b;
                return [
                  createTextVNode(toDisplayString(unref(t2)("userActivityOverview.welcomeBanner")) + " " + toDisplayString((_b = (_a = unref(LocationState).state) == null ? void 0 : _a.branding) == null ? void 0 : _b.portalBannerText), 1)
                ];
              }),
              _: 1
            }))
          ]),
          createElementVNode("div", _hoisted_10$5, [
            createVNode(_sfc_main$G, {
              widgets: smartWidgetDistribution.value.middle
            }, null, 8, ["widgets"]),
            shouldShowRightContainer.value ? (openBlock(), createBlock(_sfc_main$F, {
              key: 0,
              widgets: smartWidgetDistribution.value.right
            }, null, 8, ["widgets"])) : unref(isHome) ? (openBlock(), createElementBlock("div", _hoisted_11$5)) : createCommentVNode("", true)
          ])
        ]))
      ]);
    };
  }
});
const WidgetContainer = /* @__PURE__ */ _export_sfc(_sfc_main$E, [["__scopeId", "data-v-36bd96f9"]]);
const _hoisted_1$x = { class: "flex mt-16" };
const _hoisted_2$i = { class: "w-full min-h-[94vh] flex" };
const _sfc_main$D = /* @__PURE__ */ defineComponent({
  __name: "WebDashboard",
  emits: ["logout"],
  setup(__props, { emit: __emit }) {
    const emit = __emit;
    const t2 = inject("t");
    function receiveLogoutUser() {
      emit("logout", logoutUser());
    }
    const isContracts = ref(false);
    const isEstimates = ref(false);
    const isSharedFiles = ref(false);
    const isHome = ref(true);
    onMounted(() => {
      if (window.location.href.includes("/contracts")) {
        isContracts.value = true;
        isHome.value = false;
      } else if (window.location.href.includes("/estimates")) {
        isEstimates.value = true;
        isHome.value = false;
      } else if (window.location.href.includes("/shared-files")) {
        isSharedFiles.value = true;
        isHome.value = false;
      } else {
        isHome.value = true;
      }
    });
    provide("isHome", isHome);
    provide("isContracts", isContracts);
    provide("isEstimates", isEstimates);
    provide("isSharedFiles", isSharedFiles);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        createVNode(unref(NavBar), {
          onLogout: receiveLogoutUser,
          isHome: false,
          isLeftIcon: false,
          isHomeLeftIcon: false
        }, {
          "filter-left": withCtx(() => [
            createVNode(unref(UIButton), {
              id: "btn-app",
              onClick: _cache[0] || (_cache[0] = ($event) => unref(externalPathRedirect)("home", "")),
              text: true,
              "aria-label": unref(t2)("common.home")
            }, {
              default: withCtx(() => [
                createVNode(unref(render$10), {
                  class: "h-5 w-5 fontColor mt-[2px]",
                  "aria-hidden": "true"
                })
              ]),
              _: 1
            }, 8, ["aria-label"])
          ]),
          _: 1
        }),
        createElementVNode("div", _hoisted_1$x, [
          createElementVNode("div", _hoisted_2$i, [
            createVNode(_sfc_main$P),
            createVNode(WidgetContainer)
          ])
        ])
      ], 64);
    };
  }
});
const WebDashboard = /* @__PURE__ */ _export_sfc(_sfc_main$D, [["__scopeId", "data-v-d6b60bc1"]]);
const _hoisted_1$w = { key: 0 };
const _hoisted_2$h = {
  key: 2,
  class: "bg-clientportal-liteBackground"
};
const _sfc_main$C = /* @__PURE__ */ defineComponent({
  __name: "DashBoard.index",
  setup(__props) {
    const t2 = ref(null);
    onBeforeMount(async () => {
      t2.value = setupVueI18n(getLocalePreference());
      await getChatWidget();
    });
    onMounted(async () => {
      try {
        await dashboardManager.loadAllData();
      } catch (error) {
        console.error("Failed to load dashboard:", error);
      }
    });
    dashboardManager.provideToComponents();
    provide("t", t2);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", null, [
        unref(isPwa)() ? (openBlock(), createElementBlock("div", _hoisted_1$w, [
          createVNode(MobilePwaDashboard)
        ])) : unref(AppState).state.isMobile ? (openBlock(), createBlock(MobilePwaDashboard, { key: 1 })) : (openBlock(), createElementBlock("div", _hoisted_2$h, [
          createVNode(WebDashboard)
        ]))
      ]);
    };
  }
});
const DashBoard = /* @__PURE__ */ _export_sfc(_sfc_main$C, [["__scopeId", "data-v-c10c41d7"]]);
DashBoard.install = (Vue) => {
  Vue.component(DashBoard.name, DashBoard);
};
const _hoisted_1$v = { class: "p-4 h-screen bg-white overflow-auto mt-10" };
const _sfc_main$B = /* @__PURE__ */ defineComponent({
  __name: "DocumentsAndPayments",
  setup(__props) {
    const t2 = ref(null);
    onBeforeMount(() => {
      t2.value = setupVueI18n(window.localStorage.getItem("locale") || "en");
    });
    const isLoading = ref(false);
    const estimateData = ref([]);
    const contractData = ref([]);
    const invoiceData = ref([]);
    const sharedFilesData = ref([]);
    const invoiceDataCount = ref(0);
    const contractDataCount = ref(0);
    const estimateDataCount = ref(0);
    const sharedFilesCount = ref(0);
    onMounted(async () => {
      isLoading.value = true;
      try {
        await Promise.allSettled([
          getInvoiceData(),
          getContractsData(),
          getEstimatesData(),
          getSharedFilesData()
        ]);
      } catch (error) {
        console.error(error);
      } finally {
        isLoading.value = false;
      }
    });
    const getInvoiceData = async (offset = 1) => {
      var _a, _b, _c, _d;
      try {
        const data = await BillingService.getInvoices({
          contactId: UserState.state.userId,
          locationId: (_b = (_a = LocationState) == null ? void 0 : _a.state) == null ? void 0 : _b.locationId,
          limit: isPwa() ? 10 : 5,
          offset: (offset - 1) * (isPwa() ? 10 : 5)
        });
        const invoicesList = ((_c = data == null ? void 0 : data.data) == null ? void 0 : _c.invoices) || [];
        invoiceData.value = [...invoiceData.value, ...invoicesList];
        invoiceData.value = getInvoiceStatus(invoiceData);
        invoiceDataCount.value = (_d = data == null ? void 0 : data.data) == null ? void 0 : _d.total;
      } catch (error) {
        console.error(error);
        invoiceData.value = [];
        invoiceDataCount.value = 0;
      }
    };
    const getContractsData = async (offset = 1) => {
      var _a, _b, _c, _d;
      try {
        const contracts = await BillingService.getContracts({
          contactId: UserState.state.userId,
          locationId: (_b = (_a = LocationState) == null ? void 0 : _a.state) == null ? void 0 : _b.locationId,
          limit: isPwa() ? 10 : 5,
          offset: (offset - 1) * (isPwa() ? 10 : 5)
        });
        const documentsList = ((_c = contracts == null ? void 0 : contracts.data) == null ? void 0 : _c.documents) || [];
        contractData.value = [...contractData.value, ...documentsList];
        contractDataCount.value = ((_d = contracts == null ? void 0 : contracts.data) == null ? void 0 : _d.total) || 0;
      } catch (error) {
        console.error(error);
        contractData.value = [];
        contractDataCount.value = 0;
      }
    };
    const getEstimatesData = async (offset = 1) => {
      var _a, _b, _c, _d;
      try {
        const params = {
          contactId: UserState.state.userId,
          locationId: (_b = (_a = LocationState) == null ? void 0 : _a.state) == null ? void 0 : _b.locationId,
          limit: isPwa() ? 10 : 5,
          offset: (offset - 1) * (isPwa() ? 10 : 5),
          status: "all"
        };
        const estimatesData = await BillingService.getEstimates(params);
        const estimatesList = ((_c = estimatesData == null ? void 0 : estimatesData.data) == null ? void 0 : _c.estimates) || [];
        estimateData.value = [...estimateData.value, ...estimatesList];
        estimateData.value = getInvoiceStatus(estimateData);
        estimateDataCount.value = (_d = estimatesData == null ? void 0 : estimatesData.data) == null ? void 0 : _d.total;
      } catch (error) {
        console.error(error);
        estimateData.value = [];
        estimateDataCount.value = 0;
      }
    };
    const getSharedFilesData = async (offset = 1) => {
      var _a, _b, _c, _d;
      try {
        const response = await BillingService.getSharedFiles({
          contactId: UserState.state.userId,
          locationId: (_b = (_a = LocationState) == null ? void 0 : _a.state) == null ? void 0 : _b.locationId,
          limit: isPwa() ? 10 : 5,
          skip: (offset - 1) * (isPwa() ? 10 : 5)
        });
        const filesList = ((_c = response == null ? void 0 : response.data) == null ? void 0 : _c.documents) || [];
        sharedFilesData.value = [...sharedFilesData.value, ...filesList];
        sharedFilesCount.value = ((_d = response == null ? void 0 : response.data) == null ? void 0 : _d.total) || 0;
      } catch (error) {
        console.error(error);
        sharedFilesData.value = [];
        sharedFilesCount.value = 0;
      }
    };
    const visibleTabs = computed(() => {
      return DashboardConfigManager.getMobileTabs().filter((widget2) => widget2.component !== "InvoicesWidgets").map((widget2) => {
        return {
          name: t2.value(widget2.title),
          key: widget2.key,
          component: widget2.component
        };
      });
    });
    provide("t", t2);
    provide("isLoading", isLoading);
    provide("estimateData", estimateData);
    provide("invoiceData", invoiceData);
    provide("contractData", contractData);
    provide("sharedFilesData", sharedFilesData);
    provide("invoiceDataCount", invoiceDataCount);
    provide("contractDataCount", contractDataCount);
    provide("estimateDataCount", estimateDataCount);
    provide("sharedFilesCount", sharedFilesCount);
    provide("getEstimatesData", getEstimatesData);
    provide("getContractsData", getContractsData);
    provide("getInvoiceData", getInvoiceData);
    provide("getSharedFilesData", getSharedFilesData);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$v, [
        createVNode(MobileTabs, { visibleTabs: visibleTabs.value }, null, 8, ["visibleTabs"])
      ]);
    };
  }
});
const clearBrowserHistory = () => {
  window.history.replaceState(null, "", window.location.href);
  const popStateHandler = () => {
    window.history.replaceState(null, "", window.location.href);
  };
  window.addEventListener("popstate", popStateHandler);
  return () => window.removeEventListener("popstate", popStateHandler);
};
const clearRouterHistory = (router) => {
  if (!router) return;
  router.replace(window.location.pathname);
  router.beforeEach((to, from, next) => {
    if (to.path !== from.path) {
      next(false);
    } else {
      next();
    }
  });
};
const blockNavigation = (router) => {
  const cleanupBrowser = clearBrowserHistory();
  clearRouterHistory(router);
  return cleanupBrowser;
};
const _hoisted_1$u = { class: "relative z-[2] mb-16 flex w-full max-w-[90%] flex-col items-center justify-center px-4" };
const _hoisted_2$g = { class: "mb-3 flex h-[50px] w-[50px] items-center justify-center sm:mb-[18px] sm:h-[66px] sm:w-[66px]" };
const _hoisted_3$e = ["src", "alt"];
const _sfc_main$A = /* @__PURE__ */ defineComponent({
  __name: "ForcedAppUpdate",
  props: {
    customLogoUrl: {},
    title: {},
    description: {},
    buttonText: {},
    updateUrl: {}
  },
  setup(__props) {
    const t2 = ref(null);
    onBeforeMount(() => {
      t2.value = setupVueI18n(getLocalePreference());
    });
    const props = __props;
    const customLogoUrl = computed(() => props.customLogoUrl || "");
    const title = computed(() => props.title || t2.value("forceUpdate.title"));
    const description = computed(
      () => props.description || t2.value("forceUpdate.description")
    );
    const buttonText = computed(
      () => props.buttonText || t2.value("forceUpdate.buttonText")
    );
    const updateUrl = computed(() => props.updateUrl || "");
    const imageLoaded = ref(false);
    const loadBackgroundImage = () => {
      const img = preloadImage(FORCE_APP_UPDATE_BG);
      img.onload = () => {
        imageLoaded.value = true;
      };
    };
    const logoUrl = computed(() => {
      if (AppVersionsInstance.state.isGreyLabel) {
        return KollabLogo;
      }
      return customLogoUrl.value || BrandedAppState.state.appIconImage;
    });
    const appInitials = computed(() => getShortName(BrandedAppState.state.appName));
    const showInitials = computed(() => {
      return !AppVersionsInstance.state.isGreyLabel && !customLogoUrl.value && !BrandedAppState.state.appIconImage;
    });
    const handleUpdate = async () => {
      try {
        await trackForceUpdateEvent(ForceUpdateEvents.FORCE_UPDATE_BUTTON_CLICKED);
      } catch (error) {
        console.error("Error in tracking force_update_button_clicked:", error);
      }
      const targetUrl = updateUrl.value || AppVersionsInstance.platformSpecificUpdateUrl;
      await openNativeUrls(targetUrl);
    };
    let cleanupNavigation;
    let touchStartX = 0;
    let touchStartY = 0;
    const preventSwipe = (event) => {
      try {
        if (event.type === WINDOW_EVENTS.TOUCH_START) {
          touchStartX = event.touches[0].clientX;
          touchStartY = event.touches[0].clientY;
        } else if (event.type === WINDOW_EVENTS.TOUCH_MOVE) {
          const deltaX = Math.abs(event.touches[0].clientX - touchStartX);
          const deltaY = Math.abs(event.touches[0].clientY - touchStartY);
          if (deltaX > deltaY) {
            event.preventDefault();
          }
        }
      } catch (error) {
        console.error("Error handling touch event:", error);
      }
    };
    onMounted(async () => {
      const router = AppState.getRouterInstance();
      if (router) {
        cleanupNavigation = blockNavigation(router);
      }
      loadBackgroundImage();
      window.addEventListener(WINDOW_EVENTS.TOUCH_START, preventSwipe, {
        passive: false
      });
      window.addEventListener(WINDOW_EVENTS.TOUCH_MOVE, preventSwipe, {
        passive: false
      });
      try {
        await trackForceUpdateEvent(ForceUpdateEvents.FORCE_UPDATE_SCREEN_SEEN);
      } catch (error) {
        console.error("Error in tracking force_update_screen_seen:", error);
      }
    });
    onUnmounted(() => {
      cleanupNavigation == null ? void 0 : cleanupNavigation();
      window.removeEventListener(WINDOW_EVENTS.TOUCH_START, preventSwipe);
      window.removeEventListener(WINDOW_EVENTS.TOUCH_MOVE, preventSwipe);
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: "fixed inset-0 z-[9999] flex items-end justify-center bg-[linear-gradient(180deg,rgba(16,33,58,0.10)_-77.11%,rgba(16,33,58,0.89)_45.61%,rgba(16,33,58,0.98)_72.28%)] bg-cover bg-no-repeat",
        style: normalizeStyle(
          imageLoaded.value ? { backgroundImage: `url('${unref(FORCE_APP_UPDATE_BG)}')` } : {}
        )
      }, [
        createElementVNode("div", _hoisted_1$u, [
          createElementVNode("div", _hoisted_2$g, [
            showInitials.value ? (openBlock(), createBlock(unref(UIAvatar), {
              key: 0,
              size: 60,
              objectFit: "fill",
              round: false
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(appInitials.value), 1)
              ]),
              _: 1
            })) : (openBlock(), createElementBlock("img", {
              key: 1,
              src: logoUrl.value,
              alt: unref(BrandedAppState).state.appName,
              class: "h-full w-full object-contain"
            }, null, 8, _hoisted_3$e))
          ]),
          createVNode(unref(UITextMdMedium), { class: "mb-1 text-center font-['Inter'] text-sm font-normal leading-5 text-[#909090] sm:mb-2 sm:text-base sm:leading-6" }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(title.value), 1)
            ]),
            _: 1
          }),
          createVNode(unref(UIDisplaySmMedium), { class: "mb-4 text-center font-['Inter'] text-xl font-medium leading-7 text-[#FEFEFF] sm:mb-[18px] sm:text-[24px] sm:leading-[32px]" }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(description.value), 1)
            ]),
            _: 1
          }),
          createVNode(unref(UIButton), {
            id: "update-button",
            type: "default",
            size: "large",
            disabled: false,
            loading: false,
            ghost: false,
            quaternary: false,
            onClick: handleUpdate
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(buttonText.value), 1)
            ]),
            _: 1
          })
        ])
      ], 4);
    };
  }
});
const _hoisted_1$t = { class: "flex cursor-pointer items-center w-[200px]" };
const _hoisted_2$f = ["src"];
const _hoisted_3$d = ["src"];
const _hoisted_4$d = { class: "" };
const _hoisted_5$b = {
  key: 0,
  class: "dropdown-content mx-6 max-h-[80vh] !w-80 overflow-y-auto rounded-lg border border-solid border-clientportal-border bg-clientportal-background"
};
const _hoisted_6$a = { class: "flex h-[45px] items-center" };
const _hoisted_7$8 = { class: "mr-3 flex h-8 w-8 items-center justify-center rounded-md bg-clientportal-fill" };
const _hoisted_8$6 = { class: "flex h-[45px] items-center" };
const _hoisted_9$4 = { class: "mr-3 flex h-8 w-8 items-center justify-center rounded-md bg-clientportal-fill" };
const _hoisted_10$4 = { class: "flex h-[45px] items-center" };
const _hoisted_11$4 = { class: "mr-3 flex h-8 w-8 items-center justify-center rounded-md bg-clientportal-fill" };
const _hoisted_12$4 = { key: 2 };
const _hoisted_13$4 = ["onClick"];
const _hoisted_14$3 = ["src", "alt"];
const _hoisted_15$2 = { class: "truncate text-base text-clientportal-font-primary" };
const _sfc_main$z = /* @__PURE__ */ defineComponent({
  __name: "Switcher",
  props: {
    isDarkMode: {
      type: Boolean,
      default: false
    },
    itemsList: {
      type: Array,
      required: false
    }
  },
  emits: ["itemClicked"],
  setup(__props, { emit: __emit }) {
    const emit = __emit;
    const routerInstance = AppState.getRouterInstance();
    const isOpen = ref(false);
    const toggleDropdown = () => {
      isOpen.value = !isOpen.value;
    };
    const closeDropdown = () => {
      isOpen.value = false;
    };
    const navigateToRoute = (route) => {
      window.location.href = `/${route}`;
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$t, [
        __props.isDarkMode ? (openBlock(), createElementBlock("img", {
          key: 0,
          src: unref(GOKOLLAB_GRADIENT_LOGO).DARK,
          alt: "Gokollab",
          class: "ml-2 mr-6 h-10",
          onClick: _cache[0] || (_cache[0] = ($event) => navigateToRoute(""))
        }, null, 8, _hoisted_2$f)) : (openBlock(), createElementBlock("img", {
          key: 1,
          src: unref(GOKOLLAB_GRADIENT_LOGO).LIGHT,
          alt: "Gokollab",
          class: "ml-2 mr-6 h-10",
          onClick: _cache[1] || (_cache[1] = ($event) => navigateToRoute(""))
        }, null, 8, _hoisted_3$d)),
        withDirectives((openBlock(), createElementBlock("div", _hoisted_4$d, [
          createVNode(unref(UITooltip), {
            placement: "bottom",
            trigger: isOpen.value ? "manual" : "hover",
            class: "!bg-clientportal-background !text-clientportal-font-primary !border-clientportal-border border-solid border-1",
            disabled: isOpen.value
          }, {
            trigger: withCtx(() => [
              createElementVNode("div", {
                class: "flex cursor-pointer flex-col",
                onClick: toggleDropdown
              }, [
                createVNode(unref(render$15), { class: "h-12 w-6 text-clientportal-font-primary" })
              ])
            ]),
            default: withCtx(() => [
              _cache[5] || (_cache[5] = createTextVNode(" Group Switcher "))
            ]),
            _: 1
          }, 8, ["trigger", "disabled"]),
          createVNode(Transition, { name: "dropdown" }, {
            default: withCtx(() => {
              var _a, _b;
              return [
                isOpen.value ? (openBlock(), createElementBlock("div", _hoisted_5$b, [
                  createElementVNode("div", {
                    onClick: _cache[2] || (_cache[2] = ($event) => navigateToRoute("create-community")),
                    class: "dropdown-item flex items-center p-2.5 hover:bg-clientportal-fill rounded-md"
                  }, [
                    createElementVNode("div", _hoisted_6$a, [
                      createElementVNode("div", _hoisted_7$8, [
                        createVNode(unref(render$_), {
                          class: "h-6 text-base font-light text-clientportal-font-primary",
                          "stroke-width": "0.5"
                        })
                      ]),
                      _cache[6] || (_cache[6] = createElementVNode("span", { class: "text-base text-clientportal-font-primary" }, " Create Community ", -1))
                    ])
                  ]),
                  !unref(routerInstance).currentRoute.path.endsWith("/discovery") ? (openBlock(), createElementBlock("div", {
                    key: 0,
                    class: "dropdown-item p-2.5 hover:bg-clientportal-fill rounded-md",
                    onClick: _cache[3] || (_cache[3] = ($event) => navigateToRoute("discovery"))
                  }, [
                    createElementVNode("div", _hoisted_8$6, [
                      createElementVNode("div", _hoisted_9$4, [
                        createVNode(unref(render$16), {
                          "stroke-width": "0.5",
                          class: "h-6 text-base text-clientportal-font-primary hover:text-clientportal-font-secondary"
                        })
                      ]),
                      _cache[7] || (_cache[7] = createElementVNode("span", { class: "text-base text-clientportal-font-primary" }, " Discover ", -1))
                    ])
                  ])) : createCommentVNode("", true),
                  ((_a = unref(UserState).state) == null ? void 0 : _a.fullName) && !unref(routerInstance).currentRoute.path.endsWith("/my-courses") ? (openBlock(), createElementBlock("div", {
                    key: 1,
                    class: "dropdown-item p-2.5 hover:bg-clientportal-fill rounded-md",
                    onClick: _cache[4] || (_cache[4] = ($event) => navigateToRoute("courses/my-courses"))
                  }, [
                    createElementVNode("div", _hoisted_10$4, [
                      createElementVNode("div", _hoisted_11$4, [
                        createVNode(unref(render$4), {
                          "stroke-width": "0.5",
                          class: "h-6 text-base text-clientportal-font-primary hover:text-clientportal-font-secondary"
                        })
                      ]),
                      _cache[8] || (_cache[8] = createElementVNode("span", { class: "text-base text-clientportal-font-primary" }, " My Courses ", -1))
                    ])
                  ])) : createCommentVNode("", true),
                  ((_b = __props.itemsList) == null ? void 0 : _b.length) > 0 ? (openBlock(), createElementBlock("div", _hoisted_12$4, [
                    (openBlock(true), createElementBlock(Fragment, null, renderList(__props.itemsList, (item, index2) => {
                      return openBlock(), createElementBlock("div", {
                        key: item.name,
                        class: "dropdown-item p-2.5 h-[45px] hover:bg-clientportal-fill rounded-md",
                        onClick: ($event) => emit("itemClicked", index2)
                      }, [
                        createElementVNode("img", {
                          src: item.logo,
                          class: "mr-3 h-8 w-8 rounded-full",
                          alt: item.name
                        }, null, 8, _hoisted_14$3),
                        createElementVNode("span", _hoisted_15$2, toDisplayString(item.name), 1)
                      ], 8, _hoisted_13$4);
                    }), 128))
                  ])) : createCommentVNode("", true)
                ])) : createCommentVNode("", true)
              ];
            }),
            _: 1
          })
        ])), [
          [unref(vOnClickOutside), closeDropdown]
        ])
      ]);
    };
  }
});
const GokollabSwitcher = /* @__PURE__ */ _export_sfc(_sfc_main$z, [["__scopeId", "data-v-fe13dc2a"]]);
GokollabSwitcher.install = (Vue) => {
  Vue.component(GokollabSwitcher.name, GokollabSwitcher);
};
_sfc_main$18.install = (Vue) => {
  Vue.component(_sfc_main$18.name, _sfc_main$18);
};
const index = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({ __proto__: null, default: _sfc_main$18 }, Symbol.toStringTag, { value: "Module" }));
const _hoisted_1$s = { class: "flex h-[147px] w-full bg-gradient-to-r from-[#4E54C8] to-[#8F94FB] bg-cover bg-center bg-blend-multiply" };
const _hoisted_2$e = { class: "flex h-full w-full items-center justify-center bg-[url('https://storage.googleapis.com/revex-gokollab-production/assets/hero-section-background1.png')] bg-cover bg-center" };
const _hoisted_3$c = ["src"];
const _hoisted_4$c = { key: 0 };
const _hoisted_5$a = ["src"];
const _hoisted_6$9 = { class: "ml-2" };
const _hoisted_7$7 = { class: "flex items-center justify-center pb-4 pt-4" };
const _sfc_main$y = /* @__PURE__ */ defineComponent({
  __name: "LoginModal",
  props: {
    show: Boolean,
    page: String,
    referrerUser: {
      type: Object,
      default: null,
      required: false
    },
    env: String
  },
  emits: ["update:show", "onLoginCallback"],
  setup(__props, { emit: __emit }) {
    const maskClosable = ref(true);
    const locationDataWithGroupBranding = ref();
    onMounted(() => {
      locationDataWithGroupBranding.value = {
        _id: "66ffa1c1570dae59ffde4993",
        locationId: AppState.getConfig().GOKOLLAB_LOCATION_ID,
        subDomain: "communities",
        branding: {
          brandColor1: "#3F288AFF",
          brandColor2: "#2F00FF",
          _id: "66f6b3e7e1a652c756d89709"
        },
        createdAt: "2023-07-20T05:45:51.319Z",
        updatedAt: "2024-10-01T12:50:57.688Z",
        __v: 0,
        copyRight: "©",
        portalBannerText: " Staging PortalStagi",
        portalDescription: null,
        supportEmail: "Email@gmail.com",
        joined: 1,
        totalUsers: 569,
        invitedUsers: 5,
        defaultPage: "home",
        locationPermissions: {
          communitiesEnabled: true,
          membershipEnabled: true,
          affiliateManagerEnabled: true,
          subscriptionsEnabled: true,
          contractsEnabled: true
        },
        lastSyncTime: "2024-09-30T10:50:45.137Z",
        customCss: null,
        customJs: null,
        footerCode: null,
        headerCode: null,
        isMigrated: true,
        isSSODisabled: false,
        currencySymbol: "$"
      };
    });
    const props = __props;
    const emit = __emit;
    const showModal = ref(false);
    onMounted(() => {
      isLoading.value = false;
      showModal.value = props.show;
    });
    watch(
      () => props.show,
      async (showModalVal) => {
        if (showModalVal == true) {
          showModal.value = showModalVal;
        }
        showModal.value = showModalVal;
      }
    );
    function closeModal() {
      showModal.value = false;
      emit("update:show", false);
    }
    const isLoading = ref(false);
    async function loginCallback(event) {
      isLoading.value = true;
      if (event.eventType == LoginEvents.LOGIN_SUCCESSFUL) {
        closeModal();
        showModal.value = false;
      }
      emit("onLoginCallback", event);
    }
    async function handleChangeScreen(event) {
      var _a, _b;
      if (((_a = event == null ? void 0 : event.value) == null ? void 0 : _a.page) === Screens.SET_PASSWORD || ((_b = event == null ? void 0 : event.value) == null ? void 0 : _b.page) === Screens.VERIFY_SECURE_CODE) {
        maskClosable.value = false;
      } else {
        maskClosable.value = true;
      }
    }
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(UIModal), {
        show: showModal.value,
        "onUpdate:show": [
          _cache[0] || (_cache[0] = ($event) => showModal.value = $event),
          closeModal
        ],
        maskClosable: maskClosable.value,
        "class-name": "w-full fixed md:absolute h-full rounded-none md:rounded-xl md:h-auto left-0 right-0 flex justify-center max-w-[455px] min-w-[375px] w-auto !p-0 overflow-y-auto"
      }, {
        header: withCtx(() => [
          createVNode(unref(UIModalHeader), {
            type: "custom",
            onClose: closeModal,
            id: "modal-header"
          }, {
            customHeader: withCtx(() => [
              createElementVNode("div", _hoisted_1$s, [
                createElementVNode("div", _hoisted_2$e, [
                  createElementVNode("img", {
                    class: "info-logo h-12 w-56",
                    src: unref(GOKOLLAB_LOGO).LIGHT,
                    alt: "Group Logo"
                  }, null, 8, _hoisted_3$c)
                ])
              ]),
              createElementVNode("div", {
                class: "absolute right-2 top-2 h-6 w-6 cursor-pointer rounded-full bg-clientportal-primary text-clientportal-sidebar-selected-item-font opacity-50 shadow-sm md:hidden",
                onClick: closeModal
              }, [
                createVNode(unref(render$r))
              ])
            ]),
            _: 1
          })
        ]),
        default: withCtx(() => {
          var _a;
          return [
            ((_a = props.referrerUser) == null ? void 0 : _a.fullName) ? (openBlock(), createElementBlock("div", _hoisted_4$c, [
              createVNode(unref(UITextMdNormal), { class: "flex justify-center items-center pt-3" }, {
                default: withCtx(() => {
                  var _a2;
                  return [
                    _cache[1] || (_cache[1] = createTextVNode(" You were referred by ")),
                    ((_a2 = props.referrerUser) == null ? void 0 : _a2.avatar) ? (openBlock(), createElementBlock("img", {
                      key: 0,
                      src: props.referrerUser.avatar,
                      class: "w-7 h-7 rounded-full ml-2 border-2 border-white border-solid shadow-md"
                    }, null, 8, _hoisted_5$a)) : (openBlock(), createBlock(unref(UIAvatar), {
                      key: 1,
                      class: "w-7 h-7 rounded-full ml-2 border-2 border-white border-solid shadow-md",
                      size: "small",
                      objectFit: "fill",
                      round: true,
                      style: void 0,
                      src: void 0,
                      fallbackSrc: void 0,
                      indicator: void 0
                    }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(props.referrerUser.fullName.includes(" ") ? props.referrerUser.fullName.split(" ")[0].charAt(0).toUpperCase() + props.referrerUser.fullName.split(" ")[1].charAt(0).toUpperCase() : props.referrerUser.fullName.charAt(0).toUpperCase()), 1)
                      ]),
                      _: 1
                    })),
                    createElementVNode("span", _hoisted_6$9, toDisplayString(props.referrerUser.fullName), 1)
                  ];
                }),
                _: 1
              })
            ])) : createCommentVNode("", true),
            createElementVNode("div", _hoisted_7$7, [
              isLoading.value ? (openBlock(), createBlock(unref(UISpin), {
                key: 0,
                class: "flex h-48 items-center justify-center"
              })) : (openBlock(), createBlock(unref(_sfc_main$18), {
                key: 1,
                "node-env": __props.env,
                page: __props.page,
                onLoginCallback: loginCallback,
                onChangeScreen: handleChangeScreen,
                locationData: locationDataWithGroupBranding.value,
                referrerUser: props.referrerUser,
                class: "user-list-scrollbar overflow-y-auto"
              }, null, 8, ["node-env", "page", "locationData", "referrerUser"]))
            ])
          ];
        }),
        _: 1
      }, 8, ["show", "maskClosable"]);
    };
  }
});
const GokollabLoginModal = /* @__PURE__ */ _export_sfc(_sfc_main$y, [["__scopeId", "data-v-d2e88cdc"]]);
const _hoisted_1$r = {
  key: 0,
  class: "flex items-center justify-between w-[451px] mx-auto"
};
const _hoisted_2$d = { class: "flex items-center justify-start gap-2" };
const _hoisted_3$b = {
  key: 1,
  class: "flex items-center justify-between w-[451px] mx-auto"
};
const _hoisted_4$b = { class: "flex items-center justify-start gap-2" };
const _hoisted_5$9 = {
  key: 2,
  class: "flex items-center justify-between w-[396px] mx-auto"
};
const _hoisted_6$8 = { class: "flex items-center gap-2 justify-start min-w-0 w-full" };
const _hoisted_7$6 = { class: "flex items-center gap-2 min-w-0 w-full" };
const _hoisted_8$5 = { class: "flex flex-col min-w-0 w-full" };
const _hoisted_9$3 = {
  key: 3,
  class: "flex items-center justify-between w-[451px] mx-auto"
};
const _hoisted_10$3 = { class: "flex" };
const _hoisted_11$3 = ["src"];
const _hoisted_12$3 = { class: "flex flex-col items-center justify-center" };
const _hoisted_13$3 = { key: 0 };
const _hoisted_14$2 = ["src"];
const _hoisted_15$1 = { class: "ml-2" };
const _sfc_main$x = /* @__PURE__ */ defineComponent({
  __name: "LoginModalV2",
  props: {
    referrerUser: {
      type: Object,
      default: null,
      required: false
    },
    loginModalPage: {
      type: String,
      default: Screens.LOGIN
    },
    showModal: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:show-modal", "login-callback"],
  setup(__props, { emit: __emit }) {
    const LoginPage = defineAsyncComponent(
      () => Promise.resolve().then(() => index).then((module) => module.default)
    );
    const env = computed(() => {
      return AppState.state.NODE_ENV === "production" ? "production" : "staging";
    });
    const props = __props;
    onMounted(() => {
      locationDataWithGroupBranding.value = {
        _id: "66ffa1c1570dae59ffde4993",
        locationId: AppState.getConfig().GOKOLLAB_LOCATION_ID,
        subDomain: "communities",
        branding: {
          brandColor1: "#3F288AFF",
          brandColor2: "#2F00FF",
          _id: "66f6b3e7e1a652c756d89709"
        },
        createdAt: "2023-07-20T05:45:51.319Z",
        updatedAt: "2024-10-01T12:50:57.688Z",
        __v: 0,
        copyRight: "©",
        portalBannerText: " Staging PortalStagi",
        portalDescription: null,
        supportEmail: "Email@gmail.com",
        joined: 1,
        totalUsers: 569,
        invitedUsers: 5,
        defaultPage: "home",
        locationPermissions: {
          communitiesEnabled: true,
          membershipEnabled: true,
          affiliateManagerEnabled: true,
          subscriptionsEnabled: true,
          contractsEnabled: true
        },
        lastSyncTime: "2024-09-30T10:50:45.137Z",
        customCss: null,
        customJs: null,
        footerCode: null,
        headerCode: null,
        isMigrated: true,
        isSSODisabled: false,
        currencySymbol: "$"
      };
    });
    const visible = ref(props.showModal);
    ref(props.referrerUser);
    const page = ref(props.loginModalPage);
    const isLoading = ref(false);
    const currentScreen = ref("");
    const navigationHistory = ref([]);
    const currentUserEmail = ref("");
    async function handleChangeScreen(screen) {
      currentScreen.value = screen.page;
      if (screen.page === Screens.LOGIN) {
        navigationHistory.value = [Screens.LOGIN];
      } else {
        if (navigationHistory.value.length === 0 || navigationHistory.value[navigationHistory.value.length - 1] !== screen.page) {
          navigationHistory.value.push(screen.page);
        }
      }
      page.value = screen.page;
      currentUserEmail.value = screen.email;
    }
    const locationDataWithGroupBranding = ref();
    const emit = __emit;
    async function loginCallback(event) {
      if (event.eventType == LoginEvents.LOGIN_SUCCESSFUL) {
        isLoading.value = true;
        window.localStorage.removeItem("refCode");
        emit("login-callback", event);
        isLoading.value = false;
        visible.value = false;
      }
    }
    onMounted(() => {
      page.value = props.loginModalPage;
      navigationHistory.value.push(page.value);
    });
    watch(
      () => props.showModal,
      (newVal) => {
        page.value = props.loginModalPage;
        visible.value = newVal;
      }
    );
    watch(visible, (newVal) => {
      if (newVal === false) {
        emit("update:show-modal", false);
      }
    });
    function handleBack() {
      navigationHistory.value.pop();
      const previousScreen = navigationHistory.value[navigationHistory.value.length - 1] || Screens.LOGIN;
      page.value = previousScreen;
      currentScreen.value = previousScreen;
    }
    const modalWidth = computed(() => {
      return currentScreen.value === Screens.VERIFY_SECURE_CODE ? 425 : 483;
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(HLModal), {
        id: "login-modal",
        show: visible.value,
        "onUpdate:show": _cache[1] || (_cache[1] = ($event) => visible.value = $event),
        width: modalWidth.value,
        "show-header-icon": false,
        "show-footer": false,
        showClose: false
      }, {
        header: withCtx(() => [
          currentScreen.value === unref(Screens).LOGIN_WITH_SECURE_CODE ? (openBlock(), createElementBlock("div", _hoisted_1$r, [
            createElementVNode("div", _hoisted_2$d, [
              createVNode(unref(render$p), {
                class: "w-5 h-5 rounded-full hover:bg-gokollab-fill",
                onClick: handleBack
              }),
              createVNode(unref(HLText), {
                size: "xl",
                weight: "semibold",
                class: "text-gokollab-font-secondary"
              }, {
                default: withCtx(() => _cache[2] || (_cache[2] = [
                  createTextVNode("Enter email to login")
                ])),
                _: 1
              })
            ])
          ])) : currentScreen.value === unref(Screens).FORGOT_PASSWORD ? (openBlock(), createElementBlock("div", _hoisted_3$b, [
            createElementVNode("div", _hoisted_4$b, [
              createVNode(unref(render$p), {
                class: "w-5 h-5 rounded-full hover:bg-gokollab-fill",
                onClick: handleBack
              }),
              createVNode(unref(HLText), {
                size: "xl",
                weight: "semibold",
                class: "text-gokollab-font-secondary"
              }, {
                default: withCtx(() => _cache[3] || (_cache[3] = [
                  createTextVNode("Reset Your Password")
                ])),
                _: 1
              })
            ])
          ])) : currentScreen.value === unref(Screens).VERIFY_SECURE_CODE ? (openBlock(), createElementBlock("div", _hoisted_5$9, [
            createElementVNode("div", _hoisted_6$8, [
              createVNode(unref(render$p), {
                class: "w-5 h-5 rounded-full hover:bg-gokollab-fill flex-shrink-0",
                onClick: handleBack
              }),
              createElementVNode("div", _hoisted_7$6, [
                createVNode(unref(render$u), { class: "w-6 h-6 flex-shrink-0" }),
                createElementVNode("div", _hoisted_8$5, [
                  createVNode(unref(HLText), {
                    size: "xl",
                    weight: "semibold",
                    class: "text-gokollab-font-secondary"
                  }, {
                    default: withCtx(() => _cache[4] || (_cache[4] = [
                      createTextVNode("Verify secure code")
                    ])),
                    _: 1
                  }),
                  createVNode(unref(HLText), {
                    size: "sm",
                    weight: "regular",
                    class: "text-gokollab-font-secondary truncate"
                  }, {
                    default: withCtx(() => [
                      createTextVNode("Sent to " + toDisplayString(currentUserEmail.value), 1)
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ])) : (openBlock(), createElementBlock("div", _hoisted_9$3, [
            createElementVNode("div", _hoisted_10$3, [
              createElementVNode("img", {
                alt: "Gokollab Logo",
                src: unref(GOKOLLAB_DEFAULT_LOGO),
                class: "",
                height: "32px"
              }, null, 8, _hoisted_11$3)
            ]),
            createVNode(unref(render$r), {
              class: "h-6 w-6 text-gokollab-font-secondary",
              onClick: _cache[0] || (_cache[0] = ($event) => visible.value = false)
            })
          ]))
        ]),
        default: withCtx(() => {
          var _a;
          return [
            createElementVNode("div", _hoisted_12$3, [
              ((_a = props.referrerUser) == null ? void 0 : _a.fullName) ? (openBlock(), createElementBlock("div", _hoisted_13$3, [
                createVNode(unref(UITextMdNormal), { class: "flex items-center justify-center px-6" }, {
                  default: withCtx(() => {
                    var _a2;
                    return [
                      _cache[5] || (_cache[5] = createTextVNode(" You were referred by ")),
                      ((_a2 = props.referrerUser) == null ? void 0 : _a2.avatar) ? (openBlock(), createElementBlock("img", {
                        key: 0,
                        src: props.referrerUser.avatar,
                        class: "ml-2 h-7 w-7 rounded-full border-2 border-solid border-white shadow-md"
                      }, null, 8, _hoisted_14$2)) : (openBlock(), createBlock(unref(UIAvatar), {
                        key: 1,
                        class: "ml-2 h-7 w-7 rounded-full border-2 border-solid border-white shadow-md",
                        size: "small",
                        objectFit: "fill",
                        round: true,
                        style: void 0,
                        src: void 0,
                        fallbackSrc: void 0,
                        indicator: void 0
                      }, {
                        default: withCtx(() => [
                          createTextVNode(toDisplayString(props.referrerUser.fullName.includes(" ") ? props.referrerUser.fullName.split(" ")[0].charAt(0).toUpperCase() + props.referrerUser.fullName.split(" ")[1].charAt(0).toUpperCase() : props.referrerUser.fullName.charAt(0).toUpperCase()), 1)
                        ]),
                        _: 1
                      })),
                      createElementVNode("span", _hoisted_15$1, toDisplayString(props.referrerUser.fullName), 1)
                    ];
                  }),
                  _: 1
                })
              ])) : createCommentVNode("", true),
              createVNode(unref(LoginPage), {
                "node-env": env.value,
                page: page.value,
                v2Modal: true,
                onLoginCallback: loginCallback,
                onChangeScreen: handleChangeScreen,
                "location-data": locationDataWithGroupBranding.value,
                "referrer-user": props.referrerUser
              }, null, 8, ["node-env", "page", "location-data", "referrer-user"])
            ])
          ];
        }),
        _: 1
      }, 8, ["show", "width"]);
    };
  }
});
const LoginModalV2 = /* @__PURE__ */ _export_sfc(_sfc_main$x, [["__scopeId", "data-v-9d8591e0"]]);
GokollabLoginModal.install = (Vue) => {
  Vue.component(GokollabLoginModal.name, GokollabLoginModal);
};
const _hoisted_1$q = ["id"];
const _hoisted_2$c = ["onKeydown", "onClick"];
const _hoisted_3$a = { class: "flex flex-row items-center" };
const _hoisted_4$a = { class: "flex-shrink-0 flex items-center" };
const _hoisted_5$8 = ["src", "alt"];
const _hoisted_6$7 = { class: "min-w-0 flex-1" };
const _hoisted_7$5 = ["onClick"];
const _hoisted_8$4 = ["onClick"];
const _sfc_main$w = /* @__PURE__ */ defineComponent({
  __name: "SidebarPopoverContent",
  props: {
    pinnedItems: {
      type: Array,
      default: () => []
    },
    unpinnedItems: {
      type: Array,
      default: () => []
    },
    canPin: {
      type: Boolean,
      default: true
    },
    itemType: {
      type: String,
      default: "community"
    }
  },
  emits: ["select", "pin", "unpin"],
  setup(__props, { emit: __emit }) {
    const loadingStates = ref({});
    const emits = __emit;
    const props = __props;
    const allItems = computed(() => [...props.pinnedItems, ...props.unpinnedItems]);
    const handleItemSelect = (item) => {
      emits("select", item.id, item.source);
    };
    const handlePin = (id, event) => {
      if (loadingStates.value[id]) return;
      event.stopPropagation();
      loadingStates.value[id] = true;
      emits("pin", id, () => {
        loadingStates.value[id] = false;
      });
    };
    const handleUnpin = (id, event) => {
      if (loadingStates.value[id]) return;
      event.stopPropagation();
      loadingStates.value[id] = true;
      emits("unpin", id, () => {
        loadingStates.value[id] = false;
      });
    };
    return (_ctx, _cache) => {
      return openBlock(true), createElementBlock(Fragment, null, renderList(allItems.value, (item) => {
        return openBlock(), createElementBlock("div", {
          key: item.id,
          id: unref(createElementId)("sidenav", "popover-item", item.id.toString()),
          class: "flex h-[24px] w-[284px] items-center justify-center px-2 py-1 hover:bg-clientportal-fill"
        }, [
          createElementVNode("div", {
            class: "flex w-full cursor-pointer items-center justify-between flex-row",
            role: "button",
            "aria-label": "Select item",
            onKeydown: withKeys(($event) => handleItemSelect(item), ["enter"]),
            onClick: ($event) => handleItemSelect(item)
          }, [
            createElementVNode("div", _hoisted_3$a, [
              createElementVNode("div", _hoisted_4$a, [
                createElementVNode("img", {
                  src: item == null ? void 0 : item.avatar,
                  alt: item.name,
                  class: "!h-6 !w-6 rounded-full border-solid border-gokollab-fill border-1 object-cover"
                }, null, 8, _hoisted_5$8)
              ]),
              createElementVNode("div", _hoisted_6$7, [
                createVNode(unref(HLText), {
                  size: "md",
                  weight: "regular",
                  class: "ml-1 line-clamp-1 break-all"
                }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(item.name), 1)
                  ]),
                  _: 2
                }, 1024)
              ])
            ]),
            item.isPinned ? (openBlock(), createElementBlock("div", {
              key: 0,
              class: "relative flex h-[16px] w-[16px] items-center justify-center rounded-full flex-shrink-0",
              onClick: ($event) => handleUnpin(item.id, $event)
            }, [
              loadingStates.value[item.id] ? (openBlock(), createBlock(unref(HLSpin), {
                key: 0,
                id: unref(createElementId)("sidenav", "pin-loading", item.id.toString()),
                size: "sm"
              }, null, 8, ["id"])) : (openBlock(), createBlock(unref(render$17), {
                key: 1,
                class: "h-[12px] w-[12px] fill-gokollab-primary",
                alt: "Unpin Icon"
              }))
            ], 8, _hoisted_7$5)) : (openBlock(), createBlock(unref(HLTooltip), {
              key: 1,
              id: unref(createElementId)("sidenav", "pin-tooltip", item.id.toString()),
              placement: "right",
              disabled: __props.canPin
            }, {
              trigger: withCtx(() => [
                createElementVNode("div", {
                  class: normalizeClass(["relative flex h-[16px] w-[16px] items-center justify-center rounded-full flex-shrink-0", { "cursor-not-allowed opacity-50": !__props.canPin }]),
                  onClick: ($event) => __props.canPin && handlePin(item.id, $event)
                }, [
                  loadingStates.value[item.id] ? (openBlock(), createBlock(unref(HLSpin), {
                    key: 0,
                    id: unref(createElementId)("sidenav", "unpin-loading", item.id.toString()),
                    size: "sm"
                  }, null, 8, ["id"])) : (openBlock(), createBlock(unref(render$17), {
                    key: 1,
                    class: "h-[12px] w-[12px] text-gokollab-primary",
                    alt: "Pin Icon"
                  }))
                ], 10, _hoisted_8$4)
              ]),
              default: withCtx(() => [
                !__props.canPin ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                  createTextVNode("You can only pin up to 4 " + toDisplayString(__props.itemType === "course" ? "courses" : "groups"), 1)
                ], 64)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                  createTextVNode("Pin to sidebar")
                ], 64))
              ]),
              _: 2
            }, 1032, ["id", "disabled"]))
          ], 40, _hoisted_2$c)
        ], 8, _hoisted_1$q);
      }), 128);
    };
  }
});
const SidebarPopoverContent = /* @__PURE__ */ _export_sfc(_sfc_main$w, [["__scopeId", "data-v-aa1344bd"]]);
const _hoisted_1$p = { class: "border-gokollab-fill flex h-full w-[40px] flex-shrink-0 flex-col items-center gap-1 border-r border-t-0 border-b-0 border-l-0 border-solid bg-clientportal-background" };
const _hoisted_2$b = ["src"];
const _hoisted_3$9 = ["src"];
const _hoisted_4$9 = {
  key: 0,
  class: "flex flex-col gap-1 items-center justify-center w-full"
};
const _hoisted_5$7 = ["src"];
const _hoisted_6$6 = {
  key: 1,
  class: "flex flex-col items-center gap-1 h-full w-full"
};
const _hoisted_7$4 = ["id"];
const _hoisted_8$3 = {
  key: 0,
  class: "p-2"
};
const _hoisted_9$2 = {
  key: 2,
  class: "p-2"
};
const _hoisted_10$2 = ["src", "alt"];
const _hoisted_11$2 = ["id"];
const _hoisted_12$2 = {
  key: 0,
  class: "p-2"
};
const _hoisted_13$2 = {
  key: 2,
  class: "p-2"
};
const _hoisted_14$1 = ["src", "alt"];
const CDN_DOMAIN$1 = "https://staging.cdnmembership.apisystem.tech";
const _sfc_main$v = /* @__PURE__ */ defineComponent({
  __name: "GokollabSidebar",
  props: {
    currentPath: {
      type: String,
      default: "/"
    }
  },
  emits: [
    "onCommunityClick",
    "onCourseClick",
    "onExploreClick",
    "onAddClick",
    "onCreateProductClick",
    "onLogoClick"
  ],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const isPinnedGroupsLoading = ref(true);
    const isGroupsLoading = ref(false);
    const isCoursesLoading = ref(false);
    const hasLoadedGroups = ref(false);
    const hasLoadedCourses = ref(false);
    const fetchUserGroups = async () => {
      isGroupsLoading.value = true;
      try {
        await UserState.getUserGroups();
      } catch (err) {
        console.error("Error loading groups:", err);
      } finally {
        isGroupsLoading.value = false;
      }
    };
    const fetchPinnedGroups = async () => {
      isPinnedGroupsLoading.value = true;
      try {
        await UserState.getPinnedGroups();
      } catch (err) {
        console.error("Error loading pinned groups:", err);
      } finally {
        isPinnedGroupsLoading.value = false;
      }
    };
    const loadCourseData = async () => {
      isCoursesLoading.value = true;
      try {
        await UserState.getCourses();
        await UserState.getPinnedCourses();
      } catch (err) {
        console.error("Error loading courses:", err);
      } finally {
        isCoursesLoading.value = false;
      }
    };
    const isAuthenticated = computed(() => {
      return !!UserState.state.userId;
    });
    onMounted(() => {
      if (isAuthenticated.value) {
        fetchPinnedGroups();
        loadCourseData();
      }
    });
    watch(isAuthenticated, (newValue) => {
      if (newValue) {
        fetchPinnedGroups();
        loadCourseData();
      }
    });
    const emit = __emit;
    const pinnedGroups = computed(() => {
      var _a;
      return ((_a = UserState.state.pinnedGroups) == null ? void 0 : _a.map((group) => ({
        id: group.id,
        slug: group.slug,
        name: group.name,
        avatar: group == null ? void 0 : group.logo,
        isPinned: true
      }))) ?? [];
    });
    const pinnedCourses = computed(() => {
      var _a;
      return ((_a = UserState.state.pinnedCourses) == null ? void 0 : _a.map((course) => {
        var _a2;
        let logoUrl = (_a2 = course.customization) == null ? void 0 : _a2.logoImage;
        if (logoUrl && logoUrl.startsWith("/") && !logoUrl.startsWith("http")) {
          logoUrl = `${CDN_DOMAIN$1}${logoUrl}`;
        }
        return {
          id: course.id,
          name: course.title,
          avatar: logoUrl ?? DEFAULT_COURSE_LOGO,
          isPinned: true,
          source: course == null ? void 0 : course.source
        };
      })) ?? [];
    });
    const groups = computed(() => {
      var _a;
      return (_a = UserState.state.groups) == null ? void 0 : _a.map((group) => {
        var _a2;
        return {
          id: group._id,
          slug: group.slug,
          name: group.name,
          avatar: ((_a2 = group.branding) == null ? void 0 : _a2.logo) ?? DEFAULT_COMMUNITY_LOGO
        };
      });
    });
    const unpinnedGroups = computed(() => {
      var _a;
      const pinnedIds = new Set(pinnedGroups.value.map((group) => group.id));
      return ((_a = groups.value) == null ? void 0 : _a.filter((group) => !pinnedIds.has(group.id)).map((group) => ({
        ...group,
        isPinned: false
      }))) ?? [];
    });
    const courses = computed(() => {
      var _a;
      return ((_a = UserState.state.courses) == null ? void 0 : _a.map((course) => {
        var _a2;
        let logoUrl = (_a2 = course.customization) == null ? void 0 : _a2.logoImage;
        if (logoUrl && logoUrl.startsWith("/") && !logoUrl.startsWith("http")) {
          logoUrl = `${CDN_DOMAIN$1}${logoUrl}`;
        }
        return {
          id: course.id,
          name: course.title,
          avatar: logoUrl ?? DEFAULT_COURSE_LOGO,
          source: course.source
        };
      })) ?? [];
    });
    const unpinnedCourses = computed(() => {
      var _a;
      const pinnedIds = new Set(pinnedCourses.value.map((course) => course.id));
      return ((_a = courses.value) == null ? void 0 : _a.filter((course) => !pinnedIds.has(course.id)).map((course) => ({
        ...course,
        isPinned: false
      }))) ?? [];
    });
    const selectedTab = computed(() => {
      if (props.currentPath.startsWith("/discovery/") && !props.currentPath.includes("/search")) {
        return "explore";
      } else if (props.currentPath.includes("/create-community")) {
        return "add";
      } else if (props.currentPath == "/" || props.currentPath == "/mastermind") {
        return "home";
      } else {
        return "default";
      }
    });
    const navigateToTab = (tab) => {
      console.log("tab", tab);
      if (!props.currentPath.includes("/discovery") || props.currentPath.includes("/search")) {
        emit("onExploreClick", "/discovery");
      }
    };
    const navigateToHome = () => {
      emit("onLogoClick", "/");
    };
    const navigateToCommunity = (communityId) => {
      const community = [...pinnedGroups.value, ...unpinnedGroups.value].find(
        (group) => group.id === communityId
      );
      const communitySlug = community == null ? void 0 : community.slug;
      emit("onCommunityClick", communitySlug);
    };
    const navigateToCourse = (courseId, source) => {
      emit("onCourseClick", courseId, source);
    };
    const canPinMoreGroups = computed(() => {
      var _a;
      return ((_a = pinnedGroups.value) == null ? void 0 : _a.length) < 4;
    });
    const canPinMoreCourses = computed(() => {
      var _a;
      return ((_a = pinnedCourses.value) == null ? void 0 : _a.length) < 4;
    });
    const handlePinGroup = async (groupId, callback) => {
      try {
        await UserState.pinGroup(groupId.toString());
      } catch (err) {
        console.error("Error pinning group:", err);
      } finally {
        callback == null ? void 0 : callback();
      }
    };
    const handleUnpinGroup = async (groupId, callback) => {
      try {
        await UserState.unpinGroup(groupId.toString());
      } catch (err) {
        console.error("Error unpinning group:", err);
      } finally {
        callback == null ? void 0 : callback();
      }
    };
    const handlePinCourse = async (courseId, callback) => {
      try {
        await UserState.pinCourse(courseId.toString());
      } catch (err) {
        console.error("Error pinning course:", err);
      } finally {
        callback == null ? void 0 : callback();
      }
    };
    const handleUnpinCourse = async (courseId, callback) => {
      try {
        await UserState.unpinCourse(courseId.toString());
      } catch (err) {
        console.error("Error unpinning course:", err);
      } finally {
        callback == null ? void 0 : callback();
      }
    };
    const handleGroupsPopoverShow = async () => {
      if (!hasLoadedGroups.value) {
        await fetchUserGroups();
        hasLoadedGroups.value = true;
      }
    };
    const handleCoursesPopoverShow = async () => {
      if (!hasLoadedCourses.value) {
        await loadCourseData();
        hasLoadedCourses.value = true;
      }
    };
    return (_ctx, _cache) => {
      var _a, _b;
      return openBlock(), createElementBlock("div", _hoisted_1$p, [
        createVNode(_sfc_main$1j, {
          type: "text",
          id: unref(createElementId)("sidenav", "logo", "button"),
          class: "h-[50px] w-10",
          onClick: navigateToHome
        }, {
          default: withCtx(() => [
            createElementVNode("img", {
              src: unref(GOKOLLAB_K_LOGO_WITHOUT_BORDER),
              alt: "GoKollab Logo",
              class: "h-7 w-7 object-contain"
            }, null, 8, _hoisted_2$b)
          ]),
          _: 1
        }, 8, ["id"]),
        createVNode(unref(HLDivider), {
          "margin-top": false,
          "margin-bottom": false
        }),
        createElementVNode("div", {
          class: normalizeClass(["tab-item relative", { "active-button": selectedTab.value === "explore" }])
        }, [
          createVNode(unref(HLTooltip), {
            id: unref(createElementId)("sidenav", "explore", "tooltip"),
            placement: "right"
          }, {
            trigger: withCtx(() => [
              createVNode(_sfc_main$1j, {
                type: "text",
                id: unref(createElementId)("sidenav", "explore", "button"),
                class: "relative flex h-10 w-10 items-center justify-center p-2",
                onClick: _cache[0] || (_cache[0] = ($event) => navigateToTab("explore"))
              }, {
                iconLeft: withCtx(() => [
                  createElementVNode("img", {
                    src: unref(EXPLORE_ICON),
                    alt: "Explore",
                    class: "h-6 w-6"
                  }, null, 8, _hoisted_3$9)
                ]),
                _: 1
              }, 8, ["id"])
            ]),
            default: withCtx(() => [
              _cache[2] || (_cache[2] = createTextVNode(" Explore "))
            ]),
            _: 1
          }, 8, ["id"])
        ], 2),
        createVNode(unref(HLDivider), {
          "margin-top": false,
          "margin-bottom": false
        }),
        unref(UserState).state.fullName ? (openBlock(), createElementBlock("div", _hoisted_4$9, [
          createElementVNode("div", {
            class: normalizeClass(["tab-item relative", {
              "active-tab": selectedTab.value === "add"
            }])
          }, [
            createVNode(unref(HLTooltip), {
              id: unref(createElementId)("sidenav", "create-community", "tooltip"),
              placement: "right"
            }, {
              trigger: withCtx(() => [
                createVNode(_sfc_main$1j, {
                  type: "text",
                  id: unref(createElementId)("sidenav", "create-community", "button"),
                  class: normalizeClass([{ "active-button": selectedTab.value === "add" }, "relative flex h-10 w-10 items-center justify-center p-2"]),
                  onClick: _cache[1] || (_cache[1] = ($event) => emit("onCreateProductClick"))
                }, {
                  iconLeft: withCtx(() => [
                    createElementVNode("img", {
                      src: unref(ADD_ICON),
                      alt: "Add",
                      class: "h-6 w-6"
                    }, null, 8, _hoisted_5$7)
                  ]),
                  _: 1
                }, 8, ["id", "class"])
              ]),
              default: withCtx(() => [
                _cache[3] || (_cache[3] = createTextVNode(" Create Product "))
              ]),
              _: 1
            }, 8, ["id"])
          ], 2),
          createVNode(unref(HLDivider), {
            "margin-top": false,
            "margin-bottom": false
          })
        ])) : createCommentVNode("", true),
        unref(UserState).state.fullName ? (openBlock(), createElementBlock("div", _hoisted_6$6, [
          createVNode(unref(HLPopover), {
            trigger: "hover",
            "show-arrow": false,
            placement: "right-start",
            "content-class": "!max-h-[192px] !overflow-y-auto",
            onShow: handleGroupsPopoverShow
          }, {
            trigger: withCtx(() => [
              createElementVNode("div", {
                type: "text",
                id: unref(createElementId)("sidenav", "communities", "icon"),
                class: "h-10 w-10 flex items-center justify-center cursor-pointer"
              }, [
                createVNode(unref(render$S), { class: "text-gokollab-primary !h-6 !w-6" })
              ], 8, _hoisted_7$4)
            ]),
            default: withCtx(() => [
              !isGroupsLoading.value && pinnedGroups.value.length === 0 && unpinnedGroups.value.length === 0 ? (openBlock(), createElementBlock("div", _hoisted_8$3, [
                createVNode(unref(HLText), {
                  size: "md",
                  weight: "regular"
                }, {
                  default: withCtx(() => _cache[4] || (_cache[4] = [
                    createTextVNode("You are not part of any group")
                  ])),
                  _: 1
                })
              ])) : !isGroupsLoading.value ? (openBlock(), createBlock(SidebarPopoverContent, {
                key: 1,
                "pinned-items": pinnedGroups.value,
                "unpinned-items": unpinnedGroups.value,
                "item-type": "community",
                "can-pin": canPinMoreGroups.value,
                onSelect: navigateToCommunity,
                onPin: handlePinGroup,
                onUnpin: handleUnpinGroup
              }, null, 8, ["pinned-items", "unpinned-items", "can-pin"])) : (openBlock(), createElementBlock("div", _hoisted_9$2, [
                createVNode(unref(HLSkeleton), {
                  id: unref(createElementId)("sidenav", "groups-loading", "skeleton"),
                  class: "!h-6 !w-[200px]"
                }, null, 8, ["id"])
              ]))
            ]),
            _: 1
          }),
          isPinnedGroupsLoading.value ? (openBlock(), createElementBlock(Fragment, { key: 0 }, renderList(3, (i) => {
            return createElementVNode("div", {
              key: `shimmer-${i}`,
              class: "h-10 w-10 flex items-center justify-center"
            }, [
              createVNode(unref(HLSkeleton), {
                id: unref(createElementId)("sidenav", "group-skeleton", i.toString()),
                class: "!h-6 !w-6",
                round: true
              }, null, 8, ["id"])
            ]);
          }), 64)) : (openBlock(true), createElementBlock(Fragment, { key: 1 }, renderList((_a = pinnedGroups.value) == null ? void 0 : _a.slice(0, 4), (community) => {
            var _a2;
            return openBlock(), createBlock(unref(HLTooltip), {
              key: community.id,
              id: unref(createElementId)(
                "sidenav",
                "pinned-group",
                "tooltip",
                (_a2 = community.id) == null ? void 0 : _a2.toString()
              ),
              placement: "right"
            }, {
              trigger: withCtx(() => {
                var _a3;
                return [
                  createVNode(_sfc_main$1j, {
                    type: "text",
                    id: unref(createElementId)(
                      "sidenav",
                      "pinned-group",
                      "button",
                      (_a3 = community.id) == null ? void 0 : _a3.toString()
                    ),
                    class: "h-10 w-10 flex relative items-center justify-center",
                    onClick: ($event) => emit("onCommunityClick", community.slug)
                  }, {
                    iconLeft: withCtx(() => [
                      createElementVNode("img", {
                        src: community.avatar ?? unref(DEFAULT_COMMUNITY_LOGO),
                        alt: community.name,
                        class: "h-6 w-6 rounded-full object-cover border-solid border-gokollab-fill border-1"
                      }, null, 8, _hoisted_10$2)
                    ]),
                    _: 2
                  }, 1032, ["id", "onClick"])
                ];
              }),
              default: withCtx(() => [
                createTextVNode(" " + toDisplayString(community.name), 1)
              ]),
              _: 2
            }, 1032, ["id"]);
          }), 128)),
          createVNode(unref(HLDivider), {
            "margin-top": false,
            "margin-bottom": false
          }),
          createVNode(unref(HLPopover), {
            trigger: "hover",
            "show-arrow": false,
            placement: "right-start",
            "content-class": "!max-h-[192px] !overflow-y-auto",
            onShow: handleCoursesPopoverShow
          }, {
            trigger: withCtx(() => [
              createElementVNode("div", {
                id: unref(createElementId)("sidenav", "courses", "icon"),
                class: "h-10 w-10 flex items-center justify-center cursor-pointer"
              }, [
                createVNode(unref(render$18), { class: "text-gokollab-primary !h-6 !w-6" })
              ], 8, _hoisted_11$2)
            ]),
            default: withCtx(() => [
              !isCoursesLoading.value && pinnedCourses.value.length === 0 && unpinnedCourses.value.length === 0 ? (openBlock(), createElementBlock("div", _hoisted_12$2, [
                createVNode(unref(HLText), {
                  size: "md",
                  weight: "regular"
                }, {
                  default: withCtx(() => _cache[5] || (_cache[5] = [
                    createTextVNode("You are not enrolled in any course")
                  ])),
                  _: 1
                })
              ])) : !isCoursesLoading.value ? (openBlock(), createBlock(SidebarPopoverContent, {
                key: 1,
                "pinned-items": pinnedCourses.value,
                "unpinned-items": unpinnedCourses.value,
                "item-type": "course",
                "can-pin": canPinMoreCourses.value,
                onSelect: navigateToCourse,
                onPin: handlePinCourse,
                onUnpin: handleUnpinCourse
              }, null, 8, ["pinned-items", "unpinned-items", "can-pin"])) : (openBlock(), createElementBlock("div", _hoisted_13$2, [
                createVNode(unref(HLSkeleton), {
                  id: unref(createElementId)("sidenav", "courses-loading", "skeleton"),
                  class: "!h-6 !w-[200px]"
                }, null, 8, ["id"])
              ]))
            ]),
            _: 1
          }),
          isCoursesLoading.value ? (openBlock(), createElementBlock(Fragment, { key: 2 }, renderList(3, (i) => {
            return createElementVNode("div", {
              key: `course-shimmer-${i}`,
              class: "h-10 w-10 flex items-center justify-center"
            }, [
              createVNode(unref(HLSkeleton), {
                id: unref(createElementId)("sidenav", "course-skeleton", i.toString()),
                class: "!h-6 !w-6",
                round: true
              }, null, 8, ["id"])
            ]);
          }), 64)) : (openBlock(true), createElementBlock(Fragment, { key: 3 }, renderList((_b = pinnedCourses.value) == null ? void 0 : _b.slice(0, 4), (course) => {
            var _a2;
            return openBlock(), createBlock(unref(HLTooltip), {
              key: course.id,
              id: unref(createElementId)(
                "sidenav",
                "pinned-course",
                "tooltip",
                (_a2 = course.id) == null ? void 0 : _a2.toString()
              ),
              placement: "right"
            }, {
              trigger: withCtx(() => {
                var _a3;
                return [
                  createVNode(_sfc_main$1j, {
                    type: "text",
                    id: unref(createElementId)(
                      "sidenav",
                      "pinned-course",
                      "button",
                      (_a3 = course.id) == null ? void 0 : _a3.toString()
                    ),
                    class: "h-10 w-10 flex relative items-center justify-center",
                    onClick: ($event) => emit("onCourseClick", course.id, course == null ? void 0 : course.source)
                  }, {
                    iconLeft: withCtx(() => [
                      createElementVNode("img", {
                        src: course.avatar ?? unref(DEFAULT_COURSE_LOGO),
                        alt: course.name,
                        class: "h-6 w-6 rounded-full object-cover border-solid border-gokollab-fill border-1"
                      }, null, 8, _hoisted_14$1)
                    ]),
                    _: 2
                  }, 1032, ["id", "onClick"])
                ];
              }),
              default: withCtx(() => [
                createTextVNode(" " + toDisplayString(course.name), 1)
              ]),
              _: 2
            }, 1032, ["id"]);
          }), 128))
        ])) : createCommentVNode("", true)
      ]);
    };
  }
});
const GokollabSidebar = /* @__PURE__ */ _export_sfc(_sfc_main$v, [["__scopeId", "data-v-0e0166c0"]]);
const _hoisted_1$o = { class: "flex flex-col items-center w-full" };
const _hoisted_2$a = { class: "flex flex-col items-center w-full max-w-[170px]" };
const _hoisted_3$8 = { class: "flex flex-col items-center gap-2 py-2 px-2 w-full" };
const _hoisted_4$8 = { class: "w-full flex flex-col items-center" };
const _hoisted_5$6 = { class: "w-full" };
const _hoisted_6$5 = { class: "w-full" };
const _sfc_main$u = /* @__PURE__ */ defineComponent({
  __name: "ProfileCardV2",
  props: {
    app_launcher_is_open: Boolean,
    profile_card_is_open: Boolean,
    hasUserLocation: Boolean
  },
  emits: ["update:profile-card-is-open", "logout"],
  setup(__props, { emit: __emit }) {
    const emit = __emit;
    const props = __props;
    const profileCardRef = ref(null);
    const avatarRef = ref(null);
    const handleLogout = async () => {
      emit("logout");
      emit("update:profile-card-is-open");
    };
    const toggleMenu = () => {
      emit("update:profile-card-is-open");
    };
    const navigateTo = (route) => {
      window.location.href = `/${route}`;
      emit("update:profile-card-is-open");
    };
    const handleClickOutside = (event) => {
      if (props.profile_card_is_open && profileCardRef.value && !profileCardRef.value.contains(event.target) && avatarRef.value && !avatarRef.value.contains(event.target)) {
        emit("update:profile-card-is-open");
      }
    };
    onMounted(() => {
      document.addEventListener("mousedown", handleClickOutside);
    });
    onUnmounted(() => {
      document.removeEventListener("mousedown", handleClickOutside);
    });
    return (_ctx, _cache) => {
      var _a, _b, _c, _d;
      return openBlock(), createElementBlock(Fragment, null, [
        createElementVNode("div", {
          class: normalizeClass(["flex h-10 w-10 items-center justify-center rounded-full", {
            "bg-gokollab-fill": __props.profile_card_is_open && !__props.app_launcher_is_open
          }]),
          ref_key: "avatarRef",
          ref: avatarRef
        }, [
          ((_b = (_a = unref(UserState)) == null ? void 0 : _a.state) == null ? void 0 : _b.avatar) ? (openBlock(), createBlock(unref(HLAvatar), {
            key: 0,
            size: "sm",
            class: "cursor-pointer",
            src: (_d = (_c = unref(UserState)) == null ? void 0 : _c.state) == null ? void 0 : _d.avatar,
            onClick: toggleMenu
          }, null, 8, ["src"])) : (openBlock(), createBlock(unref(HLAvatar), {
            key: 1,
            size: "sm",
            class: "cursor-pointer",
            onClick: toggleMenu
          }, {
            default: withCtx(() => {
              var _a2, _b2;
              return [
                createTextVNode(toDisplayString(unref(formatNameForAvatar)((_b2 = (_a2 = unref(UserState)) == null ? void 0 : _a2.state) == null ? void 0 : _b2.fullName)), 1)
              ];
            }),
            _: 1
          }))
        ], 2),
        createElementVNode("div", null, [
          createVNode(Transition, {
            "enter-from-class": "opacity-0 translate-y-1",
            "enter-active-class": "transition ease-out duration-200",
            "enter-to-class": "opacity-100 translate-y-0",
            "leave-from-class": "opacity-100 translate-y-0",
            "leave-to-class": "opacity-0 translate-y-1",
            "leave-active-class": "transition ease-in duration-150"
          }, {
            default: withCtx(() => [
              __props.profile_card_is_open && !__props.app_launcher_is_open ? (openBlock(), createElementBlock("div", {
                key: 0,
                class: "absolute z-10 mt-2 w-[190px] right-[10px]",
                ref_key: "profileCardRef",
                ref: profileCardRef
              }, [
                createVNode(unref(HLCard), {
                  id: "profile-card",
                  class: "shadow-lg w-full overflow-hidden"
                }, {
                  default: withCtx(() => {
                    var _a2, _b2, _c2, _d2;
                    return [
                      createElementVNode("div", _hoisted_1$o, [
                        createElementVNode("div", _hoisted_2$a, [
                          createElementVNode("div", _hoisted_3$8, [
                            ((_b2 = (_a2 = unref(UserState)) == null ? void 0 : _a2.state) == null ? void 0 : _b2.avatar) ? (openBlock(), createBlock(unref(HLAvatar), {
                              key: 0,
                              size: "xl",
                              src: (_d2 = (_c2 = unref(UserState)) == null ? void 0 : _c2.state) == null ? void 0 : _d2.avatar
                            }, null, 8, ["src"])) : (openBlock(), createBlock(unref(HLAvatar), {
                              key: 1,
                              size: "xl"
                            }, {
                              default: withCtx(() => {
                                var _a3, _b3;
                                return [
                                  createTextVNode(toDisplayString(unref(formatNameForAvatar)((_b3 = (_a3 = unref(UserState)) == null ? void 0 : _a3.state) == null ? void 0 : _b3.fullName)), 1)
                                ];
                              }),
                              _: 1
                            })),
                            createElementVNode("div", _hoisted_4$8, [
                              createVNode(unref(HLText), {
                                size: "lg",
                                weight: "semibold",
                                class: "text-clientportal-font-primary text-center w-full truncate"
                              }, {
                                default: withCtx(() => {
                                  var _a3, _b3;
                                  return [
                                    createTextVNode(toDisplayString((_b3 = (_a3 = unref(UserState)) == null ? void 0 : _a3.state) == null ? void 0 : _b3.fullName), 1)
                                  ];
                                }),
                                _: 1
                              }),
                              createVNode(unref(HLText), {
                                size: "sm",
                                class: "text-clientportal-font-secondary mb-2 w-full truncate text-center"
                              }, {
                                default: withCtx(() => {
                                  var _a3, _b3;
                                  return [
                                    createTextVNode(toDisplayString((_b3 = (_a3 = unref(UserState)) == null ? void 0 : _a3.state) == null ? void 0 : _b3.email), 1)
                                  ];
                                }),
                                _: 1
                              })
                            ])
                          ]),
                          createVNode(unref(HLDivider), {
                            "margin-top": false,
                            "margin-bottom": false
                          })
                        ]),
                        createElementVNode("div", _hoisted_5$6, [
                          createElementVNode("div", {
                            onClick: _cache[0] || (_cache[0] = ($event) => navigateTo("account?activeTab=Profile")),
                            class: "cursor-pointer hover:bg-clientportal-fill text-clientportal-font-secondary gap-1 p-2 w-full flex items-center"
                          }, [
                            createVNode(unref(render$19), { class: "w-3 h-3" }),
                            createVNode(unref(HLText), {
                              size: "md",
                              weight: "regular",
                              class: "truncate"
                            }, {
                              default: withCtx(() => _cache[5] || (_cache[5] = [
                                createTextVNode("Profile Settings")
                              ])),
                              _: 1
                            })
                          ]),
                          createElementVNode("div", {
                            onClick: _cache[1] || (_cache[1] = ($event) => navigateTo("account?activeTab=Account")),
                            class: "cursor-pointer hover:bg-clientportal-fill text-clientportal-font-secondary gap-1 p-2 w-full flex items-center"
                          }, [
                            createVNode(unref(render$1a), { class: "w-3 h-3" }),
                            createVNode(unref(HLText), {
                              size: "md",
                              weight: "regular",
                              class: "truncate"
                            }, {
                              default: withCtx(() => _cache[6] || (_cache[6] = [
                                createTextVNode("Account Settings")
                              ])),
                              _: 1
                            })
                          ]),
                          !unref(AppState).state.isMobile ? (openBlock(), createElementBlock("div", {
                            key: 0,
                            onClick: _cache[2] || (_cache[2] = ($event) => navigateTo("studio")),
                            class: "cursor-pointer hover:bg-clientportal-fill text-clientportal-font-secondary gap-1 p-2 w-full flex items-center"
                          }, [
                            createVNode(unref(render$1b), { class: "w-3 h-3" }),
                            createVNode(unref(HLText), {
                              size: "md",
                              weight: "regular",
                              class: "truncate"
                            }, {
                              default: withCtx(() => _cache[7] || (_cache[7] = [
                                createTextVNode("Kollab Studio")
                              ])),
                              _: 1
                            })
                          ])) : createCommentVNode("", true),
                          __props.hasUserLocation ? (openBlock(), createElementBlock("div", {
                            key: 1,
                            onClick: _cache[3] || (_cache[3] = ($event) => navigateTo("payments-integration")),
                            class: "cursor-pointer hover:bg-clientportal-fill text-clientportal-font-secondary gap-1 p-2 w-full flex items-center"
                          }, [
                            createVNode(unref(render$1c), { class: "w-3 h-3" }),
                            createVNode(unref(HLText), {
                              size: "md",
                              weight: "regular",
                              class: "truncate"
                            }, {
                              default: withCtx(() => _cache[8] || (_cache[8] = [
                                createTextVNode("Manage Payments")
                              ])),
                              _: 1
                            })
                          ])) : createCommentVNode("", true),
                          !unref(AppState).state.isMobile ? (openBlock(), createElementBlock("div", {
                            key: 2,
                            onClick: _cache[4] || (_cache[4] = ($event) => navigateTo("affiliate-manager")),
                            class: "cursor-pointer hover:bg-clientportal-fill text-clientportal-font-secondary gap-1 p-2 w-full flex items-center"
                          }, [
                            createVNode(unref(render$5), { class: "w-3 h-3" }),
                            createVNode(unref(HLText), {
                              size: "md",
                              weight: "regular",
                              class: "truncate"
                            }, {
                              default: withCtx(() => _cache[9] || (_cache[9] = [
                                createTextVNode("Affiliates")
                              ])),
                              _: 1
                            })
                          ])) : createCommentVNode("", true)
                        ]),
                        createVNode(unref(HLDivider), {
                          "margin-top": false,
                          "margin-bottom": false
                        }),
                        createElementVNode("div", _hoisted_6$5, [
                          createElementVNode("div", {
                            class: "cursor-pointer hover:bg-clientportal-fill flex text-clientportal-error gap-1 w-full p-2 items-center",
                            onClick: handleLogout
                          }, [
                            createVNode(unref(render$L), { class: "h-3 w-3" }),
                            createVNode(unref(HLText), {
                              size: "md",
                              weight: "regular",
                              class: "truncate"
                            }, {
                              default: withCtx(() => _cache[10] || (_cache[10] = [
                                createTextVNode("Log Out")
                              ])),
                              _: 1
                            })
                          ])
                        ])
                      ])
                    ];
                  }),
                  _: 1
                })
              ], 512)) : createCommentVNode("", true)
            ]),
            _: 1
          })
        ])
      ], 64);
    };
  }
});
const ProfileCardV2 = /* @__PURE__ */ _export_sfc(_sfc_main$u, [["__scopeId", "data-v-98327f59"]]);
const _hoisted_1$n = { class: "flex items-center ml-4" };
const _hoisted_2$9 = { class: "absolute left-1/2 -translate-x-1/2 flex items-center" };
const _hoisted_3$7 = { class: "flex flex-row items-center gap-4 mr-4" };
const _hoisted_4$7 = {
  key: 0,
  class: "flex items-center"
};
const _hoisted_5$5 = { class: "ml-2" };
const _hoisted_6$4 = {
  key: 1,
  class: "flex flex-row gap-2 items-center"
};
const _sfc_main$t = /* @__PURE__ */ defineComponent({
  __name: "NavBarV2",
  props: {
    showActionButtons: {
      type: Boolean,
      default: true
    },
    showBottomBorder: {
      type: Boolean,
      default: false
    },
    isMobile: {
      type: Boolean,
      default: false
    },
    hasUserLocation: {
      type: Boolean,
      default: false
    }
  },
  emits: ["logout", "searchClick"],
  setup(__props, { emit: __emit }) {
    const emit = __emit;
    const profile_card_is_open = ref(false);
    const app_launcher_is_open = ref(false);
    const notification_list_is_open = ref(false);
    function handleSearchClick() {
      emit("searchClick");
    }
    function toggleProfileCard() {
      app_launcher_is_open.value = false;
      notification_list_is_open.value = false;
      profile_card_is_open.value = !profile_card_is_open.value;
    }
    const isUserLoggedIn = computed(() => {
      var _a;
      return !!((_a = UserState.state) == null ? void 0 : _a.fullName);
    });
    function receiveLogoutUser(logoutUser2) {
      emit("logout", logoutUser2);
    }
    return (_ctx, _cache) => {
      var _a;
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["flex flex-row border-0 items-center justify-between h-[52px] bg-white relative", {
          "border-b border-solid border-clientportal-fill": __props.showBottomBorder
        }])
      }, [
        createElementVNode("div", _hoisted_1$n, [
          renderSlot(_ctx.$slots, "logo")
        ]),
        createElementVNode("div", _hoisted_2$9, [
          renderSlot(_ctx.$slots, "center-content")
        ]),
        createElementVNode("div", _hoisted_3$7, [
          isUserLoggedIn.value ? (openBlock(), createElementBlock("div", _hoisted_4$7, [
            __props.isMobile ? (openBlock(), createBlock(unref(render$1d), {
              key: 0,
              class: "w-5 h-5 text-clientportal-font-secondary",
              onClick: handleSearchClick
            })) : createCommentVNode("", true),
            renderSlot(_ctx.$slots, "right-filter"),
            createElementVNode("div", _hoisted_5$5, [
              ((_a = unref(UserState).state) == null ? void 0 : _a.fullName) ? (openBlock(), createBlock(ProfileCardV2, {
                key: 0,
                "onUpdate:profileCardIsOpen": toggleProfileCard,
                profile_card_is_open: profile_card_is_open.value,
                app_launcher_is_open: app_launcher_is_open.value,
                "has-user-location": __props.hasUserLocation,
                onLogout: receiveLogoutUser
              }, null, 8, ["profile_card_is_open", "app_launcher_is_open", "has-user-location"])) : createCommentVNode("", true)
            ])
          ])) : createCommentVNode("", true),
          !isUserLoggedIn.value && __props.showActionButtons ? (openBlock(), createElementBlock("div", _hoisted_6$4, [
            renderSlot(_ctx.$slots, "action-buttons")
          ])) : createCommentVNode("", true)
        ])
      ], 2);
    };
  }
});
ProfileCardV2.install = (Vue) => {
  Vue.component(ProfileCardV2.name, ProfileCardV2);
};
const _hoisted_1$m = { class: "flex flex-col h-full overflow-y-auto" };
const _hoisted_2$8 = { class: "px-2 py-3" };
const _hoisted_3$6 = { class: "flex items-center gap-1" };
const _hoisted_4$6 = ["src"];
const _hoisted_5$4 = { class: "flex items-center" };
const _hoisted_6$3 = { class: "space-y-2 ml-4" };
const _hoisted_7$3 = { class: "px-2 my-4" };
const _hoisted_8$2 = { class: "flex-1 px-2 mt-2" };
const _hoisted_9$1 = { class: "mb-2" };
const _hoisted_10$1 = { class: "flex items-center gap-1" };
const _hoisted_11$1 = { class: "flex items-center" };
const _hoisted_12$1 = {
  key: 0,
  class: "p-4 text-center ml-4"
};
const _hoisted_13$1 = {
  key: 1,
  class: "space-y-1 ml-4"
};
const _hoisted_14 = {
  key: 0,
  class: "space-y-1"
};
const _hoisted_15 = ["onClick"];
const _hoisted_16 = ["src", "alt"];
const _hoisted_17 = {
  key: 1,
  class: "space-y-1"
};
const _hoisted_18 = ["onClick"];
const _hoisted_19 = ["src", "alt"];
const _hoisted_20 = {
  key: 2,
  class: "space-y-2 ml-4"
};
const _hoisted_21 = { class: "flex items-center gap-1" };
const _hoisted_22 = { class: "flex items-center" };
const _hoisted_23 = {
  key: 0,
  class: "p-4 text-center ml-4"
};
const _hoisted_24 = {
  key: 1,
  class: "space-y-1 ml-4"
};
const _hoisted_25 = {
  key: 0,
  class: "space-y-1"
};
const _hoisted_26 = ["onClick"];
const _hoisted_27 = ["src", "alt"];
const _hoisted_28 = {
  key: 1,
  class: "space-y-1"
};
const _hoisted_29 = ["onClick"];
const _hoisted_30 = ["src", "alt"];
const _hoisted_31 = {
  key: 2,
  class: "space-y-2 ml-4"
};
const CDN_DOMAIN = "https://staging.cdnmembership.apisystem.tech";
const _sfc_main$s = /* @__PURE__ */ defineComponent({
  __name: "GokollabSidebarMobile",
  props: {
    currentPath: {
      type: String,
      default: "/"
    },
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  emits: [
    "onCourseClick",
    "onExploreClick",
    "onAddClick",
    "onLogoClick",
    "close"
  ],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const isPinnedGroupsLoading = ref(true);
    const isGroupsLoading = ref(false);
    const isCoursesLoading = ref(false);
    const isDiscoverExpanded = ref(true);
    const isCommunitiesExpanded = ref(true);
    const isCoursesExpanded = ref(true);
    const fetchUserGroups = async () => {
      isGroupsLoading.value = true;
      try {
        await UserState.getUserGroups();
      } catch (err) {
        console.error("Error loading groups:", err);
      } finally {
        isGroupsLoading.value = false;
      }
    };
    const fetchPinnedGroups = async () => {
      isPinnedGroupsLoading.value = true;
      try {
        await UserState.getPinnedGroups();
      } catch (err) {
        console.error("Error loading pinned groups:", err);
      } finally {
        isPinnedGroupsLoading.value = false;
      }
    };
    const loadCourseData = async () => {
      isCoursesLoading.value = true;
      try {
        await UserState.getCourses();
        await UserState.getPinnedCourses();
      } catch (err) {
        console.error("Error loading courses:", err);
      } finally {
        isCoursesLoading.value = false;
      }
    };
    const isAuthenticated = computed(() => {
      return !!UserState.state.userId;
    });
    onMounted(() => {
      if (isAuthenticated.value) {
        fetchPinnedGroups();
        loadCourseData();
        fetchUserGroups();
      }
    });
    watch(isAuthenticated, (newValue) => {
      if (newValue) {
        fetchPinnedGroups();
        loadCourseData();
        fetchUserGroups();
      }
    });
    const pinnedGroups = computed(() => {
      var _a;
      return ((_a = UserState.state.pinnedGroups) == null ? void 0 : _a.map((group) => ({
        id: group.id,
        slug: group.slug,
        name: group.name,
        avatar: group == null ? void 0 : group.logo,
        isPinned: true
      }))) ?? [];
    });
    const pinnedCourses = computed(() => {
      var _a;
      return ((_a = UserState.state.pinnedCourses) == null ? void 0 : _a.map((course) => {
        var _a2;
        let logoUrl = (_a2 = course.customization) == null ? void 0 : _a2.logoImage;
        if (logoUrl && logoUrl.startsWith("/") && !logoUrl.startsWith("http")) {
          logoUrl = `${CDN_DOMAIN}${logoUrl}`;
        }
        return {
          id: course.id,
          name: course.title,
          avatar: logoUrl ?? DEFAULT_COURSE_LOGO,
          isPinned: true
        };
      })) ?? [];
    });
    const groups = computed(() => {
      var _a;
      return (_a = UserState.state.groups) == null ? void 0 : _a.map((group) => {
        var _a2;
        return {
          id: group._id,
          slug: group.slug,
          name: group.name,
          avatar: ((_a2 = group.branding) == null ? void 0 : _a2.logo) ?? DEFAULT_COMMUNITY_LOGO
        };
      });
    });
    const unpinnedGroups = computed(() => {
      var _a;
      const pinnedIds = new Set(pinnedGroups.value.map((group) => group.id));
      return ((_a = groups.value) == null ? void 0 : _a.filter((group) => !pinnedIds.has(group.id)).map((group) => ({
        ...group,
        isPinned: false
      }))) ?? [];
    });
    const courses = computed(() => {
      var _a;
      return ((_a = UserState.state.courses) == null ? void 0 : _a.map((course) => {
        var _a2;
        let logoUrl = (_a2 = course.customization) == null ? void 0 : _a2.logoImage;
        if (logoUrl && logoUrl.startsWith("/") && !logoUrl.startsWith("http")) {
          logoUrl = `${CDN_DOMAIN}${logoUrl}`;
        }
        return {
          id: course.id,
          name: course.title,
          avatar: logoUrl ?? DEFAULT_COURSE_LOGO
        };
      })) ?? [];
    });
    const unpinnedCourses = computed(() => {
      var _a;
      const pinnedIds = new Set(pinnedCourses.value.map((course) => course.id));
      return ((_a = courses.value) == null ? void 0 : _a.filter((course) => !pinnedIds.has(course.id)).map((course) => ({
        ...course,
        isPinned: false
      }))) ?? [];
    });
    const routerInstance = AppState.getRouterInstance();
    const navigateToTab = (tab) => {
      console.log("tab", tab);
      if (tab === "communities" && !props.currentPath.includes("/community")) {
        console.log("navigating to communities", routerInstance);
        routerInstance.push("/community/all");
      } else if (tab === "add" && !props.currentPath.includes("/create-community")) {
        routerInstance.push("/create-community");
      } else if (tab === "courses" && !props.currentPath.includes("/course")) {
        routerInstance.push("/course/all");
      } else if (tab === "creators" && !props.currentPath.includes("/creator")) {
        routerInstance.push("/creator/all");
      } else if (tab === "home" && !props.currentPath.includes("/")) {
        routerInstance.push("/");
      }
      closeSidebar();
    };
    const navigateToCommunity = (communityId) => {
      const community = [...pinnedGroups.value, ...unpinnedGroups.value].find(
        (group) => group.id === communityId
      );
      const communitySlug = community == null ? void 0 : community.slug;
      window.location.href = `/${communitySlug}`;
      closeSidebar();
    };
    const navigateToCourse = (courseId) => {
      window.location.href = `/courses/products/${courseId}`;
      closeSidebar();
    };
    const closeSidebar = () => {
      emit("close");
    };
    const toggleDiscover = () => {
      isDiscoverExpanded.value = !isDiscoverExpanded.value;
    };
    const toggleCommunities = () => {
      isCommunitiesExpanded.value = !isCommunitiesExpanded.value;
    };
    const toggleCourses = () => {
      isCoursesExpanded.value = !isCoursesExpanded.value;
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        __props.isOpen ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: "fixed inset-0 z-[9999] bg-black bg-opacity-50 transition-opacity duration-300",
          onClick: closeSidebar
        })) : createCommentVNode("", true),
        createElementVNode("div", {
          class: normalizeClass([
            "fixed left-0 top-0 z-[9999] h-full w-[250px] transform bg-clientportal-background border-r border-gokollab-fill transition-transform duration-300 ease-in-out",
            __props.isOpen ? "translate-x-0" : "-translate-x-full"
          ])
        }, [
          createElementVNode("div", _hoisted_1$m, [
            createElementVNode("div", _hoisted_2$8, [
              createElementVNode("div", {
                class: "flex items-center justify-between cursor-pointer p-1 mb-2 rounded transition-colors duration-200",
                onClick: toggleDiscover
              }, [
                createElementVNode("div", _hoisted_3$6, [
                  createElementVNode("img", {
                    src: unref(EXPLORE_ICON),
                    alt: "Explore",
                    class: "h-4 w-4"
                  }, null, 8, _hoisted_4$6),
                  createVNode(unref(HLText), {
                    size: "md",
                    weight: "medium",
                    class: "text-clientportal-font-primary"
                  }, {
                    default: withCtx(() => _cache[4] || (_cache[4] = [
                      createTextVNode(" Discover ")
                    ])),
                    _: 1
                  })
                ]),
                createElementVNode("div", _hoisted_5$4, [
                  isDiscoverExpanded.value ? (openBlock(), createBlock(unref(render$e), {
                    key: 0,
                    class: "h-4 w-4 text-clientportal-font-secondary"
                  })) : (openBlock(), createBlock(unref(render$d), {
                    key: 1,
                    class: "h-4 w-4 text-clientportal-font-secondary"
                  }))
                ])
              ]),
              withDirectives(createElementVNode("div", {
                class: normalizeClass([
                  "transition-all duration-300 gap-2 ease-in-out overflow-hidden",
                  isDiscoverExpanded.value ? "max-h-screen opacity-100" : "max-h-0 opacity-0"
                ])
              }, [
                createElementVNode("div", _hoisted_6$3, [
                  createElementVNode("div", {
                    class: "flex items-center gap-1 p-1 rounded cursor-pointer hover:bg-clientportal-fill",
                    onClick: _cache[0] || (_cache[0] = ($event) => navigateToTab("communities"))
                  }, [
                    createVNode(unref(render$S), { class: "h-4 w-4 text-clientportal-font-primary" }),
                    createVNode(unref(HLText), {
                      size: "sm",
                      weight: "medium",
                      class: "text-clientportal-font-primary"
                    }, {
                      default: withCtx(() => _cache[5] || (_cache[5] = [
                        createTextVNode(" Communities ")
                      ])),
                      _: 1
                    })
                  ]),
                  createElementVNode("div", {
                    class: "flex items-center gap-1 p-1 rounded cursor-pointer hover:bg-clientportal-fill",
                    onClick: _cache[1] || (_cache[1] = ($event) => navigateToTab("courses"))
                  }, [
                    createVNode(unref(render$18), { class: "h-4 w-4 text-clientportal-font-primary" }),
                    createVNode(unref(HLText), {
                      size: "sm",
                      weight: "medium",
                      class: "text-clientportal-font-primary"
                    }, {
                      default: withCtx(() => _cache[6] || (_cache[6] = [
                        createTextVNode(" Courses ")
                      ])),
                      _: 1
                    })
                  ]),
                  createElementVNode("div", {
                    class: "flex items-center gap-1 p-1 rounded cursor-pointer hover:bg-clientportal-fill",
                    onClick: _cache[2] || (_cache[2] = ($event) => navigateToTab("creators"))
                  }, [
                    createVNode(unref(render$1e), { class: "h-4 w-4 text-clientportal-font-primary" }),
                    createVNode(unref(HLText), {
                      size: "sm",
                      weight: "medium",
                      class: "text-clientportal-font-primary"
                    }, {
                      default: withCtx(() => _cache[7] || (_cache[7] = [
                        createTextVNode(" Creators ")
                      ])),
                      _: 1
                    })
                  ])
                ])
              ], 2), [
                [vShow, isDiscoverExpanded.value]
              ])
            ]),
            createVNode(unref(HLDivider), { class: "mx-4" }),
            createElementVNode("div", _hoisted_7$3, [
              createVNode(_sfc_main$1j, {
                id: "create-button",
                type: "primary",
                class: "w-full h-[30px] rounded-sm",
                onClick: _cache[3] || (_cache[3] = ($event) => navigateToTab("add"))
              }, {
                iconLeft: withCtx(() => [
                  createVNode(unref(render$14), { class: "h-4 w-4 p-0 m-0" })
                ]),
                default: withCtx(() => [
                  createVNode(unref(HLText), {
                    size: "lg",
                    weight: "semibold",
                    class: "ml-2"
                  }, {
                    default: withCtx(() => _cache[8] || (_cache[8] = [
                      createTextVNode("Create")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            createVNode(unref(HLDivider), { class: "mx-4" }),
            createElementVNode("div", _hoisted_8$2, [
              createElementVNode("div", _hoisted_9$1, [
                createElementVNode("div", {
                  class: "flex items-center justify-between cursor-pointer py-2 rounded transition-colors duration-200",
                  onClick: toggleCommunities
                }, [
                  createElementVNode("div", _hoisted_10$1, [
                    createVNode(unref(render$S), { class: "h-4 w-4 text-gokollab-primary" }),
                    createVNode(unref(HLText), {
                      size: "md",
                      weight: "medium",
                      class: "text-clientportal-font-primary"
                    }, {
                      default: withCtx(() => _cache[9] || (_cache[9] = [
                        createTextVNode(" My Communities ")
                      ])),
                      _: 1
                    })
                  ]),
                  createElementVNode("div", _hoisted_11$1, [
                    isCommunitiesExpanded.value ? (openBlock(), createBlock(unref(render$e), {
                      key: 0,
                      class: "h-4 w-4 text-clientportal-font-secondary"
                    })) : (openBlock(), createBlock(unref(render$d), {
                      key: 1,
                      class: "h-4 w-4 text-clientportal-font-secondary"
                    }))
                  ])
                ]),
                withDirectives(createElementVNode("div", {
                  class: normalizeClass([
                    "transition-all duration-300 ease-in-out overflow-hidden",
                    isCommunitiesExpanded.value ? " opacity-100" : "max-h-0 opacity-0"
                  ])
                }, [
                  !isGroupsLoading.value && pinnedGroups.value.length === 0 && unpinnedGroups.value.length === 0 ? (openBlock(), createElementBlock("div", _hoisted_12$1, [
                    createVNode(unref(HLText), {
                      size: "md",
                      weight: "regular",
                      class: "text-clientportal-font-secondary"
                    }, {
                      default: withCtx(() => _cache[10] || (_cache[10] = [
                        createTextVNode(" You are not part of any group ")
                      ])),
                      _: 1
                    })
                  ])) : !isGroupsLoading.value ? (openBlock(), createElementBlock("div", _hoisted_13$1, [
                    pinnedGroups.value.length > 0 ? (openBlock(), createElementBlock("div", _hoisted_14, [
                      (openBlock(true), createElementBlock(Fragment, null, renderList(pinnedGroups.value, (community) => {
                        return openBlock(), createElementBlock("div", {
                          key: `pinned-${community.id}`,
                          class: "flex items-center gap-1 py-2 rounded cursor-pointer",
                          onClick: ($event) => navigateToCommunity(community.id)
                        }, [
                          createElementVNode("img", {
                            src: community.avatar ?? unref(DEFAULT_COMMUNITY_LOGO),
                            alt: community.name,
                            class: "h-4 w-4 rounded-full object-cover border-solid border-gokollab-fill border-1"
                          }, null, 8, _hoisted_16),
                          createVNode(unref(HLText), {
                            size: "sm",
                            weight: "medium",
                            class: "flex-1 line-clamp-1"
                          }, {
                            default: withCtx(() => [
                              createTextVNode(toDisplayString(community.name), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ], 8, _hoisted_15);
                      }), 128))
                    ])) : createCommentVNode("", true),
                    unpinnedGroups.value.length > 0 ? (openBlock(), createElementBlock("div", _hoisted_17, [
                      (openBlock(true), createElementBlock(Fragment, null, renderList(unpinnedGroups.value, (community) => {
                        return openBlock(), createElementBlock("div", {
                          key: `unpinned-${community.id}`,
                          class: "flex items-center gap-1 py-2 rounded cursor-pointer",
                          onClick: ($event) => navigateToCommunity(community.id)
                        }, [
                          createElementVNode("img", {
                            src: community.avatar ?? unref(DEFAULT_COMMUNITY_LOGO),
                            alt: community.name,
                            class: "h-4 w-4 rounded-full object-cover border-solid border-gokollab-fill border-1"
                          }, null, 8, _hoisted_19),
                          createVNode(unref(HLText), {
                            size: "md",
                            weight: "regular",
                            class: "flex-1 line-clamp-1"
                          }, {
                            default: withCtx(() => [
                              createTextVNode(toDisplayString(community.name), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ], 8, _hoisted_18);
                      }), 128))
                    ])) : createCommentVNode("", true)
                  ])) : (openBlock(), createElementBlock("div", _hoisted_20, [
                    (openBlock(), createElementBlock(Fragment, null, renderList(3, (i) => {
                      return createElementVNode("div", {
                        key: `shimmer-${i}`,
                        class: "flex items-center gap-1 p-2"
                      }, [
                        createVNode(unref(HLSkeleton), {
                          id: unref(createElementId)(
                            "mobile-sidenav",
                            "group-skeleton",
                            i.toString()
                          ),
                          class: "!h-4 !w-4",
                          round: true
                        }, null, 8, ["id"]),
                        createVNode(unref(HLSkeleton), {
                          id: unref(createElementId)(
                            "mobile-sidenav",
                            "group-text-skeleton",
                            i.toString()
                          ),
                          class: "!h-4 !w-32"
                        }, null, 8, ["id"])
                      ]);
                    }), 64))
                  ]))
                ], 2), [
                  [vShow, isCommunitiesExpanded.value]
                ])
              ]),
              createElementVNode("div", null, [
                createElementVNode("div", {
                  class: "flex items-center justify-between cursor-pointer py-2 rounded transition-colors duration-200",
                  onClick: toggleCourses
                }, [
                  createElementVNode("div", _hoisted_21, [
                    createVNode(unref(render$18), { class: "h-4 w-4 text-gokollab-primary" }),
                    createVNode(unref(HLText), {
                      size: "md",
                      weight: "medium",
                      class: "text-clientportal-font-primary"
                    }, {
                      default: withCtx(() => _cache[11] || (_cache[11] = [
                        createTextVNode(" My Courses ")
                      ])),
                      _: 1
                    })
                  ]),
                  createElementVNode("div", _hoisted_22, [
                    isCoursesExpanded.value ? (openBlock(), createBlock(unref(render$e), {
                      key: 0,
                      class: "h-4 w-4 text-clientportal-font-secondary"
                    })) : (openBlock(), createBlock(unref(render$d), {
                      key: 1,
                      class: "h-4 w-4 text-clientportal-font-secondary"
                    }))
                  ])
                ]),
                withDirectives(createElementVNode("div", {
                  class: normalizeClass(["transition-all duration-300 ease-in-out overflow-hidden", isCoursesExpanded.value ? "opacity-100" : "max-h-0 opacity-0"])
                }, [
                  !isCoursesLoading.value && pinnedCourses.value.length === 0 && unpinnedCourses.value.length === 0 ? (openBlock(), createElementBlock("div", _hoisted_23, [
                    createVNode(unref(HLText), {
                      size: "md",
                      weight: "regular",
                      class: "text-clientportal-font-secondary"
                    }, {
                      default: withCtx(() => _cache[12] || (_cache[12] = [
                        createTextVNode(" You are not enrolled in any course ")
                      ])),
                      _: 1
                    })
                  ])) : !isCoursesLoading.value ? (openBlock(), createElementBlock("div", _hoisted_24, [
                    pinnedCourses.value.length > 0 ? (openBlock(), createElementBlock("div", _hoisted_25, [
                      (openBlock(true), createElementBlock(Fragment, null, renderList(pinnedCourses.value, (course) => {
                        return openBlock(), createElementBlock("div", {
                          key: `pinned-course-${course.id}`,
                          class: "flex items-center gap-1 py-2 rounded cursor-pointer",
                          onClick: ($event) => navigateToCourse(course.id)
                        }, [
                          createElementVNode("img", {
                            src: course.avatar ?? unref(DEFAULT_COURSE_LOGO),
                            alt: course.name,
                            class: "h-4 w-4 rounded-full object-cover border-solid border-gokollab-fill border-1"
                          }, null, 8, _hoisted_27),
                          createVNode(unref(HLText), {
                            size: "sm",
                            weight: "medium",
                            class: "flex-1 line-clamp-1"
                          }, {
                            default: withCtx(() => [
                              createTextVNode(toDisplayString(course.name), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ], 8, _hoisted_26);
                      }), 128))
                    ])) : createCommentVNode("", true),
                    unpinnedCourses.value.length > 0 ? (openBlock(), createElementBlock("div", _hoisted_28, [
                      (openBlock(true), createElementBlock(Fragment, null, renderList(unpinnedCourses.value, (course) => {
                        return openBlock(), createElementBlock("div", {
                          key: `unpinned-course-${course.id}`,
                          class: "flex items-center gap-1 py-2 rounded cursor-pointer",
                          onClick: ($event) => navigateToCourse(course.id)
                        }, [
                          createElementVNode("img", {
                            src: course.avatar ?? unref(DEFAULT_COURSE_LOGO),
                            alt: course.name,
                            class: "h-4 w-4 rounded-full object-cover border-solid border-gokollab-fill border-1"
                          }, null, 8, _hoisted_30),
                          createVNode(unref(HLText), {
                            size: "md",
                            weight: "regular",
                            class: "flex-1 line-clamp-1"
                          }, {
                            default: withCtx(() => [
                              createTextVNode(toDisplayString(course.name), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ], 8, _hoisted_29);
                      }), 128))
                    ])) : createCommentVNode("", true)
                  ])) : (openBlock(), createElementBlock("div", _hoisted_31, [
                    (openBlock(), createElementBlock(Fragment, null, renderList(3, (i) => {
                      return createElementVNode("div", {
                        key: `course-shimmer-${i}`,
                        class: "flex items-center gap-1 p-2"
                      }, [
                        createVNode(unref(HLSkeleton), {
                          id: unref(createElementId)(
                            "mobile-sidenav",
                            "course-skeleton",
                            i.toString()
                          ),
                          class: "!h-4 !w-4",
                          round: true
                        }, null, 8, ["id"]),
                        createVNode(unref(HLSkeleton), {
                          id: unref(createElementId)(
                            "mobile-sidenav",
                            "course-text-skeleton",
                            i.toString()
                          ),
                          class: "!h-4 !w-32"
                        }, null, 8, ["id"])
                      ]);
                    }), 64))
                  ]))
                ], 2), [
                  [vShow, isCoursesExpanded.value]
                ])
              ])
            ])
          ])
        ], 2)
      ], 64);
    };
  }
});
const GokollabSidebarMobile = /* @__PURE__ */ _export_sfc(_sfc_main$s, [["__scopeId", "data-v-bb3e4b6a"]]);
const _hoisted_1$l = { class: "flex items-center" };
const _hoisted_2$7 = ["src"];
const _hoisted_3$5 = {
  key: 0,
  class: "flex flex-col items-center"
};
const _hoisted_4$5 = ["src"];
const _hoisted_5$3 = { key: 1 };
const _hoisted_6$2 = {
  key: 0,
  class: "flex flex-col items-center"
};
const _hoisted_7$2 = ["src"];
const _hoisted_8$1 = { key: 1 };
const MOBILE_WIDTH = 768;
const SMALL_SCREEN_WIDTH = 450;
const _sfc_main$r = /* @__PURE__ */ defineComponent({
  __name: "GoKollabTopBar",
  props: {
    showBottomBorder: {
      type: Boolean,
      default: false
    },
    currentPath: {
      type: String,
      default: "/"
    },
    hasUserLocation: {
      type: Boolean,
      default: false
    }
  },
  emits: ["signupClick", "loginClick", "logout", "searchClick"],
  setup(__props, { emit: __emit }) {
    const emit = __emit;
    const routerInstance = AppState.getRouterInstance();
    const route = computed(() => {
      if (!routerInstance) return null;
      return routerInstance.currentRoute;
    });
    const isMobile = ref(false);
    const isSmallScreen = ref(false);
    const getDeviceFormFactor = () => {
      const width = window.innerWidth;
      if (width <= MOBILE_WIDTH) {
        isMobile.value = true;
      } else {
        isMobile.value = false;
      }
      isSmallScreen.value = width <= SMALL_SCREEN_WIDTH;
    };
    onMounted(() => {
      getDeviceFormFactor();
      window.addEventListener("resize", getDeviceFormFactor);
    });
    onUnmounted(() => {
      window.removeEventListener("resize", getDeviceFormFactor);
    });
    const isMobileSearch = computed(() => {
      var _a;
      return isMobile.value && ((_a = route.value) == null ? void 0 : _a.path.includes("/search"));
    });
    const handleHomeScreen = () => {
      window.location.href = "/";
      if (isGokollab()) {
        AppState.getRouterInstance().push("/");
      }
    };
    const handleLoginClick = () => {
      emit("loginClick");
    };
    const handleSignupClick = () => {
      emit("signupClick");
    };
    const handleLogout = (logoutUser2) => {
      emit("logout", logoutUser2);
    };
    const handleSearchClick = () => {
      emit("searchClick");
    };
    const isDiscoveryPage = computed(() => {
      const path = window.location.pathname;
      return path.startsWith("/discovery/") || path === "/discovery";
    });
    const logoSrc = computed(() => {
      return window.location.pathname.endsWith("/mastermind") ? GOKOLLAB_MASTERMIND_LOGO : GOKOLLAB_DEFAULT_LOGO;
    });
    const isMastermindPage = computed(() => {
      return window.location.pathname.endsWith("/mastermind");
    });
    const isMasterMindMobile = computed(() => {
      return isMastermindPage.value && isMobile.value;
    });
    const isMobileSidebarOpen = ref(false);
    const toggleMobileSidebar = () => {
      isMobileSidebarOpen.value = !isMobileSidebarOpen.value;
    };
    const closeMobileSidebar = () => {
      isMobileSidebarOpen.value = false;
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        isMobileSearch.value ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: normalizeClass(["flex flex-row border-0 items-center justify-between h-[52px] bg-white relative", {
            "border-b border-solid border-clientportal-fill": __props.showBottomBorder
          }])
        }, [
          renderSlot(_ctx.$slots, "center-content")
        ], 2)) : (openBlock(), createBlock(unref(_sfc_main$t), {
          key: 1,
          onLogout: handleLogout,
          onSearchClick: handleSearchClick,
          "show-bottom-border": __props.showBottomBorder,
          "is-mobile": isMobile.value,
          "has-user-location": __props.hasUserLocation
        }, createSlots({
          logo: withCtx(() => [
            createElementVNode("div", _hoisted_1$l, [
              isMobile.value && unref(UserState).state.fullName ? (openBlock(), createElementBlock("button", {
                key: 0,
                id: "hamburger-menu",
                class: "h-8 w-8 p-0 mr-2 text-clientportal-font-primary bg-transparent border-0",
                onClick: toggleMobileSidebar
              }, [
                createVNode(unref(render$1f), { class: "h-6 w-6" })
              ])) : createCommentVNode("", true),
              createElementVNode("button", {
                class: "flex bg-transparent border-0 items-center cursor-pointer",
                onClick: handleHomeScreen
              }, [
                createElementVNode("img", {
                  alt: "Gokollab img Logo",
                  class: "h-7",
                  src: logoSrc.value
                }, null, 8, _hoisted_2$7)
              ]),
              isDiscoveryPage.value ? (openBlock(), createBlock(unref(HLText), {
                key: 1,
                size: "2xl",
                weight: "semibold",
                class: "text-clientportal-font-secondary"
              }, {
                default: withCtx(() => _cache[0] || (_cache[0] = [
                  createTextVNode("/  Discover")
                ])),
                _: 1
              })) : createCommentVNode("", true)
            ])
          ]),
          "right-filter": withCtx(() => [
            renderSlot(_ctx.$slots, "filter-right")
          ]),
          "action-buttons": withCtx(() => [
            isMobile.value ? (openBlock(), createBlock(unref(render$1d), {
              key: 0,
              class: "w-5 h-5 text-clientportal-font-secondary",
              onClick: handleSearchClick
            })) : createCommentVNode("", true),
            renderSlot(_ctx.$slots, "action-buttons", {}, () => [
              createVNode(_sfc_main$1j, {
                id: "login",
                size: "xs",
                type: "secondary",
                class: normalizeClass(isMasterMindMobile.value ? "h-8 w-8 p-0" : ""),
                onClick: handleLoginClick
              }, {
                default: withCtx(() => [
                  isMasterMindMobile.value ? (openBlock(), createElementBlock("div", _hoisted_3$5, [
                    createElementVNode("img", {
                      src: unref(LOGIN_LOGO),
                      alt: "Login Logo",
                      class: "w-4 h-4"
                    }, null, 8, _hoisted_4$5),
                    createVNode(unref(HLText), {
                      "html-tag": "div",
                      size: "4xs",
                      style: { "line-height": "9px" },
                      weight: "semibold"
                    }, {
                      default: withCtx(() => _cache[1] || (_cache[1] = [
                        createTextVNode("Login")
                      ])),
                      _: 1
                    })
                  ])) : (openBlock(), createElementBlock("div", _hoisted_5$3, [
                    createVNode(unref(HLText), {
                      "html-tag": "div",
                      size: "lg",
                      weight: "semibold"
                    }, {
                      default: withCtx(() => _cache[2] || (_cache[2] = [
                        createTextVNode("Login")
                      ])),
                      _: 1
                    })
                  ]))
                ]),
                _: 1
              }, 8, ["class"]),
              createVNode(_sfc_main$1j, {
                id: "signup",
                size: "xs",
                type: "primary",
                class: normalizeClass(isMasterMindMobile.value ? "h-8 w-8 p-0" : ""),
                onClick: handleSignupClick
              }, {
                default: withCtx(() => [
                  isMasterMindMobile.value ? (openBlock(), createElementBlock("div", _hoisted_6$2, [
                    createElementVNode("img", {
                      src: unref(SIGN_UP_LOGO),
                      alt: "Sign Up Logo",
                      class: "w-4 h-4"
                    }, null, 8, _hoisted_7$2),
                    createVNode(unref(HLText), {
                      "html-tag": "div",
                      size: "4xs",
                      style: { "line-height": "9px" },
                      weight: "semibold"
                    }, {
                      default: withCtx(() => _cache[3] || (_cache[3] = [
                        createTextVNode("Signup")
                      ])),
                      _: 1
                    })
                  ])) : (openBlock(), createElementBlock("div", _hoisted_8$1, [
                    createVNode(unref(HLText), {
                      "html-tag": "div",
                      size: "lg",
                      weight: "semibold"
                    }, {
                      default: withCtx(() => _cache[4] || (_cache[4] = [
                        createTextVNode("Sign Up")
                      ])),
                      _: 1
                    })
                  ]))
                ]),
                _: 1
              }, 8, ["class"])
            ])
          ]),
          _: 2
        }, [
          !isMobile.value ? {
            name: "center-content",
            fn: withCtx(() => [
              renderSlot(_ctx.$slots, "center-content")
            ]),
            key: "0"
          } : void 0
        ]), 1032, ["show-bottom-border", "is-mobile", "has-user-location"])),
        createVNode(GokollabSidebarMobile, {
          "is-open": isMobileSidebarOpen.value,
          "current-path": __props.currentPath,
          onClose: closeMobileSidebar
        }, null, 8, ["is-open", "current-path"])
      ], 64);
    };
  }
});
const _hoisted_1$k = { class: "container" };
const _hoisted_2$6 = ["src"];
const __default__$3 = {
  name: "LockoutPage"
};
const _sfc_main$q = /* @__PURE__ */ defineComponent({
  ...__default__$3,
  setup(__props) {
    onMounted(() => {
      logoutUser();
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$k, [
        createElementVNode("img", {
          class: "illustration",
          src: unref(LOCKOUT_IMAGE),
          alt: "lockout image"
        }, null, 8, _hoisted_2$6),
        createVNode(unref(UITextSmRegular), { class: "label" }, {
          default: withCtx(() => _cache[0] || (_cache[0] = [
            createTextVNode(" Oops! Something went wrong. Please contact your business. ")
          ])),
          _: 1
        })
      ]);
    };
  }
});
const LockoutPage = /* @__PURE__ */ _export_sfc(_sfc_main$q, [["__scopeId", "data-v-0a2da543"]]);
const _hoisted_1$j = { class: "w-full" };
const _hoisted_2$5 = {
  class: "",
  id: "info-container"
};
const _hoisted_3$4 = { class: "relative h-40 w-full" };
const _hoisted_4$4 = ["src"];
const _hoisted_5$2 = { class: "absolute bottom-10 left-1/2 z-10 -translate-x-1/2 translate-y-2/3 transform" };
const _hoisted_6$1 = ["src"];
const _hoisted_7$1 = { class: "mt-20 flex justify-center" };
const _sfc_main$p = /* @__PURE__ */ defineComponent({
  __name: "LoginModal",
  props: {
    show: Boolean,
    locationData: Object,
    NODE_ENV: {
      type: String,
      default: "staging"
    }
  },
  emits: ["update:confirmed", "update:show"],
  setup(__props, { emit: __emit }) {
    const logoUrl = computed(() => {
      return DEFAULT_GROUP_LOGO;
    });
    const coverUrl = computed(() => {
      return DEFAULT_GROUP_COVER_IMAGE;
    });
    const props = __props;
    const emit = __emit;
    const showModal = ref(false);
    onMounted(() => {
      AppState.state.NODE_ENV = props.NODE_ENV;
      showModal.value = props.show;
      isGokollab();
    });
    watch(
      () => props.show,
      (showModalVal) => showModal.value = showModalVal
    );
    function closeModal() {
      showModal.value = false;
      emit("update:show", false);
    }
    function callback() {
      closeModal();
    }
    function changeScreen(event) {
      console.error(event.value.page);
    }
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(UIModal), {
        show: showModal.value,
        "onUpdate:show": [
          _cache[0] || (_cache[0] = ($event) => showModal.value = $event),
          closeModal
        ],
        "class-name": "fixed top-0 h-full  rounded-none md:rounded-xl  md:h-auto sm:top-8 2xl:top-16 left-0 right-0 flex justify-center custom-modal-width p-0"
      }, {
        header: withCtx(() => [
          createVNode(unref(UIModalHeader), {
            type: "custom",
            onClose: closeModal,
            id: "modal-header"
          }, {
            customHeader: withCtx(() => [
              createElementVNode("div", _hoisted_1$j, [
                createElementVNode("div", _hoisted_2$5, [
                  createElementVNode("div", _hoisted_3$4, [
                    createElementVNode("img", {
                      src: coverUrl.value || unref(DEFAULT_GROUP_COVER_IMAGE),
                      id: "cover-image",
                      class: "max-h-[120px] w-full object-cover sm:rounded-t-xl"
                    }, null, 8, _hoisted_4$4),
                    createElementVNode("div", _hoisted_5$2, [
                      createElementVNode("img", {
                        class: "info-logo h-32 w-32 rounded-full border bg-white shadow-md",
                        src: logoUrl.value,
                        alt: "Group Logo"
                      }, null, 8, _hoisted_6$1)
                    ])
                  ])
                ])
              ]),
              createElementVNode("div", _hoisted_7$1, [
                createVNode(unref(UITextSmRegular), { class: "text-gray-600 font-normal text-sm" }, {
                  default: withCtx(() => _cache[1] || (_cache[1] = [
                    createElementVNode("span", { class: "font-semibold" }, "Admin Name", -1),
                    createTextVNode(" Invited you to join "),
                    createElementVNode("span", { class: "font-semibold" }, " Group Name", -1)
                  ])),
                  _: 1
                })
              ])
            ]),
            _: 1
          })
        ]),
        default: withCtx(() => [
          createVNode(_sfc_main$18, {
            page: "LOGIN_WITH_SECURE_CODE",
            locationData: __props.locationData,
            onLoginCallback: callback,
            onChangeScreen: changeScreen,
            NODE_ENV: "development"
          }, null, 8, ["locationData"])
        ]),
        _: 1
      }, 8, ["show"]);
    };
  }
});
const LoginModal = /* @__PURE__ */ _export_sfc(_sfc_main$p, [["__scopeId", "data-v-7085be9c"]]);
LoginModal.install = (Vue) => {
  Vue.component(LoginModal.name, LoginModal);
};
var NavigationItemType = /* @__PURE__ */ ((NavigationItemType2) => {
  NavigationItemType2["APP_ROUTE"] = "app_route";
  NavigationItemType2["REDIRECTION"] = "redirection";
  NavigationItemType2["APP_ACTION"] = "app_action";
  return NavigationItemType2;
})(NavigationItemType || {});
const _sfc_main$o = {};
const _hoisted_1$i = {
  "data-v-05a08b96": "",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "2",
  stroke: "currentColor",
  "aria-hidden": "true",
  class: "h-[24px] w-[24px]"
};
function _sfc_render$d(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$i, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M17 14.5v-3.005c0-.18 0-.27-.027-.349a.5.5 0 00-.116-.187c-.058-.06-.139-.1-.3-.18L12 8.5m-8 1v6.807c0 .372 0 .558.058.72a1 1 0 00.244.381c.124.12.293.198.631.353l6.4 2.934c.246.112.368.168.496.19.113.02.229.02.342 0 .128-.022.25-.078.496-.19l6.4-2.934c.338-.155.507-.232.63-.353a1 1 0 00.245-.38c.058-.163.058-.35.058-.721V9.5m-18-1l9.642-4.821c.131-.066.197-.098.266-.111a.5.5 0 01.184 0c.069.013.135.045.266.11L22 8.5l-9.642 4.821c-.131.066-.197.099-.266.111a.501.501 0 01-.184 0c-.069-.012-.135-.045-.266-.11L2 8.5z"
    }, null, -1)
  ]));
}
const AllCoursesIcon = /* @__PURE__ */ _export_sfc(_sfc_main$o, [["render", _sfc_render$d]]);
const _sfc_main$n = {};
const _hoisted_1$h = {
  "data-v-05a08b96": "",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  "aria-hidden": "true",
  class: "nav-item-color h-[24px] w-[24px]"
};
function _sfc_render$c(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$h, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M14 21h-4m8-13A6 6 0 106 8c0 3.09-.78 5.206-1.65 6.605-.735 1.18-1.102 1.771-1.089 1.936.015.182.054.252.2.36.133.099.732.099 1.928.099H18.61c1.196 0 1.795 0 1.927-.098.147-.11.186-.179.2-.361.014-.165-.353-.755-1.088-1.936C18.78 13.206 18 11.09 18 8z"
    }, null, -1)
  ]));
}
const BellIcon = /* @__PURE__ */ _export_sfc(_sfc_main$n, [["render", _sfc_render$c]]);
const _sfc_main$m = {};
const _hoisted_1$g = {
  "data-v-05a08b96": "",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "2",
  stroke: "black",
  "aria-hidden": "true",
  class: "h-[24px] w-[24px]"
};
function _sfc_render$b(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$g, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M17 14.5v-3.005c0-.18 0-.27-.027-.349a.5.5 0 00-.116-.187c-.058-.06-.139-.1-.3-.18L12 8.5m-8 1v6.807c0 .372 0 .558.058.72a1 1 0 00.244.381c.124.12.293.198.631.353l6.4 2.934c.246.112.368.168.496.19.113.02.229.02.342 0 .128-.022.25-.078.496-.19l6.4-2.934c.338-.155.507-.232.63-.353a1 1 0 00.245-.38c.058-.163.058-.35.058-.721V9.5m-18-1l9.642-4.821c.131-.066.197-.098.266-.111a.5.5 0 01.184 0c.069.013.135.045.266.11L22 8.5l-9.642 4.821c-.131.066-.197.099-.266.111a.501.501 0 01-.184 0c-.069-.012-.135-.045-.266-.11L2 8.5z"
    }, null, -1)
  ]));
}
const FillAllCoursesIcon = /* @__PURE__ */ _export_sfc(_sfc_main$m, [["render", _sfc_render$b]]);
const _sfc_main$l = {};
const _hoisted_1$f = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function _sfc_render$a(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$f, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      d: "M18 8C18 6.4087 17.3678 4.88258 16.2426 3.75736C15.1174 2.63214 13.5913 2 12 2C10.4087 2 8.88257 2.63214 7.75735 3.75736C6.63213 4.88258 5.99999 6.4087 5.99999 8C5.99999 11.0902 5.22046 13.206 4.34965 14.6054C3.61512 15.7859 3.24785 16.3761 3.26131 16.5408C3.27622 16.7231 3.31485 16.7926 3.46176 16.9016C3.59445 17 4.19258 17 5.38884 17H18.6111C19.8074 17 20.4055 17 20.5382 16.9016C20.6851 16.7926 20.7238 16.7231 20.7387 16.5408C20.7521 16.3761 20.3849 15.7859 19.6503 14.6054C18.7795 13.206 18 11.0902 18 8Z",
      fill: "none"
    }, null, -1),
    createElementVNode("path", {
      d: "M14 21H9.99999M18 8C18 6.4087 17.3678 4.88258 16.2426 3.75736C15.1174 2.63214 13.5913 2 12 2C10.4087 2 8.88257 2.63214 7.75735 3.75736C6.63213 4.88258 5.99999 6.4087 5.99999 8C5.99999 11.0902 5.22046 13.206 4.34965 14.6054C3.61512 15.7859 3.24785 16.3761 3.26131 16.5408C3.27622 16.7231 3.31485 16.7926 3.46176 16.9016C3.59445 17 4.19258 17 5.38884 17H18.6111C19.8074 17 20.4055 17 20.5382 16.9016C20.6851 16.7926 20.7238 16.7231 20.7387 16.5408C20.7521 16.3761 20.3849 15.7859 19.6503 14.6054C18.7795 13.206 18 11.0902 18 8Z",
      stroke: "black",
      "stroke-width": "1.8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]));
}
const FillBellIcon = /* @__PURE__ */ _export_sfc(_sfc_main$l, [["render", _sfc_render$a]]);
const _sfc_main$k = {};
const _hoisted_1$e = {
  "data-v-05a08b96": "",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.8",
  stroke: "black",
  "aria-hidden": "true",
  class: "nav-item-color h-[24px] w-[24px]"
};
function _sfc_render$9(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$e, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12.982 2.764c-.351-.273-.527-.41-.72-.462a1 1 0 00-.523 0c-.194.052-.37.189-.721.462L4.235 8.039c-.453.353-.68.53-.843.75a2 2 0 00-.318.65C3 9.704 3 9.991 3 10.565V17.8c0 1.12 0 1.68.218 2.108a2 2 0 00.874.874C4.52 21 5.08 21 6.2 21h2c.28 0 .42 0 .527-.055a.5.5 0 00.218-.218C9 20.62 9 20.48 9 20.2v-6.6c0-.56 0-.84.109-1.054a1 1 0 01.437-.437C9.76 12 10.04 12 10.6 12h2.8c.56 0 .84 0 1.054.109a1 1 0 01.437.437C15 12.76 15 13.04 15 13.6v6.6c0 .28 0 .42.055.527a.5.5 0 00.218.218c.107.055.247.055.527.055h2c1.12 0 1.68 0 2.108-.218a2 2 0 00.874-.874C21 19.48 21 18.92 21 17.8v-7.235c0-.574 0-.861-.074-1.126a2.002 2.002 0 00-.318-.65c-.163-.22-.39-.397-.843-.75l-6.783-5.275z"
    }, null, -1)
  ]));
}
const FillHomeIcon = /* @__PURE__ */ _export_sfc(_sfc_main$k, [["render", _sfc_render$9]]);
const _sfc_main$j = {};
const _hoisted_1$d = {
  "data-v-05a08b96": "",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.8",
  stroke: "black",
  "aria-hidden": "true",
  class: "nav-item-color h-[24px] w-[24px]"
};
function _sfc_render$8(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$d, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M7.135 11.189L3.33 4.381c-.437-.783-.656-1.175-.619-1.495a1 1 0 01.41-.697C3.38 2 3.83 2 4.726 2h2.235c.333 0 .5 0 .65.048a1 1 0 01.357.205c.118.104.202.248.372.535L12 9l3.659-6.212c.169-.287.254-.43.37-.535a1 1 0 01.359-.205c.15-.048.316-.048.65-.048h2.234c.897 0 1.345 0 1.607.189a1 1 0 01.41.697c.036.32-.183.712-.62 1.495l-3.805 6.808M10.5 14l1.5-1v5m-1.25 0h2.5m3.346-7.096a6.5 6.5 0 11-9.192 9.192 6.5 6.5 0 019.192-9.192z"
    }, null, -1)
  ]));
}
const FillLeaderBoardIcon = /* @__PURE__ */ _export_sfc(_sfc_main$j, [["render", _sfc_render$8]]);
const _sfc_main$i = {};
const _hoisted_1$c = {
  "data-v-05a08b96": "",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.8",
  stroke: "black",
  "aria-hidden": "true",
  class: "nav-item-color h-[24px] w-[24px]"
};
function _sfc_render$7(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$c, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M20 19v-3H7a3 3 0 00-3 3m4.8 3h8c1.12 0 1.68 0 2.108-.218a2 2 0 00.874-.874C20 20.48 20 19.92 20 18.8V5.2c0-1.12 0-1.68-.218-2.108a2 2 0 00-.874-.874C18.48 2 17.92 2 16.8 2h-8c-1.68 0-2.52 0-3.162.327a3 3 0 00-1.311 1.311C4 4.28 4 5.12 4 6.8v10.4c0 1.68 0 2.52.327 3.162a3 3 0 001.311 1.311C6.28 22 7.12 22 8.8 22z"
    }, null, -1)
  ]));
}
const FillLearningIcon = /* @__PURE__ */ _export_sfc(_sfc_main$i, [["render", _sfc_render$7]]);
const _sfc_main$h = {};
const _hoisted_1$b = {
  "data-v-05a08b96": "",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.8",
  stroke: "black",
  "aria-hidden": "true",
  class: "nav-item-color h-[24px] w-[24px]"
};
function _sfc_render$6(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$b, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M6.094 11.229A8.01 8.01 0 016 10c0-4.418 3.605-8 8.053-8 4.447 0 8.052 3.582 8.052 8 0 .998-.184 1.954-.52 2.835-.07.182-.105.274-.12.345a.897.897 0 00-.024.194c-.002.073.008.153.028.314l.403 3.27c.043.355.065.532.006.66a.5.5 0 01-.257.252c-.13.055-.306.03-.66-.022l-3.184-.467c-.167-.024-.25-.037-.326-.036a.898.898 0 00-.2.021c-.074.016-.169.051-.358.122a8.174 8.174 0 01-4.07.42M7.632 22C10.597 22 13 19.538 13 16.5S10.597 11 7.632 11c-2.965 0-5.369 2.462-5.369 5.5 0 .61.097 1.198.277 1.747.075.232.113.348.126.427.013.083.015.13.01.213-.005.08-.025.17-.065.351L2 22l2.995-.409c.163-.022.245-.034.316-.033.076 0 .115.005.19.02.07.013.173.05.381.123a5.246 5.246 0 001.75.299z"
    }, null, -1)
  ]));
}
const FillMessageChatIcon = /* @__PURE__ */ _export_sfc(_sfc_main$h, [["render", _sfc_render$6]]);
const _sfc_main$g = {};
const _hoisted_1$a = {
  "data-v-05a08b96": "",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "black",
  "aria-hidden": "true",
  class: "nav-item-color h-[24px] w-[24px]"
};
function _sfc_render$5(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$a, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12 15c-3.17 0-5.99 1.53-7.784 3.906-.386.511-.58.767-.573 1.112.005.267.172.604.382.769.272.213.649.213 1.402.213h13.146c.753 0 1.13 0 1.402-.213.21-.165.377-.502.382-.769.006-.345-.187-.6-.573-1.112C17.989 16.531 15.17 15 12 15zM12 12a4.5 4.5 0 100-9 4.5 4.5 0 000 9z"
    }, null, -1)
  ]));
}
const FillProfileIcon = /* @__PURE__ */ _export_sfc(_sfc_main$g, [["render", _sfc_render$5]]);
const _sfc_main$f = {};
const _hoisted_1$9 = {
  "data-v-05a08b96": "",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  "aria-hidden": "true",
  class: "nav-item-color h-[24px] w-[24px]"
};
function _sfc_render$4(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$9, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12.982 2.764c-.351-.273-.527-.41-.72-.462a1 1 0 00-.523 0c-.194.052-.37.189-.721.462L4.235 8.039c-.453.353-.68.53-.843.75a2 2 0 00-.318.65C3 9.704 3 9.991 3 10.565V17.8c0 1.12 0 1.68.218 2.108a2 2 0 00.874.874C4.52 21 5.08 21 6.2 21h2c.28 0 .42 0 .527-.055a.5.5 0 00.218-.218C9 20.62 9 20.48 9 20.2v-6.6c0-.56 0-.84.109-1.054a1 1 0 01.437-.437C9.76 12 10.04 12 10.6 12h2.8c.56 0 .84 0 1.054.109a1 1 0 01.437.437C15 12.76 15 13.04 15 13.6v6.6c0 .28 0 .42.055.527a.5.5 0 00.218.218c.107.055.247.055.527.055h2c1.12 0 1.68 0 2.108-.218a2 2 0 00.874-.874C21 19.48 21 18.92 21 17.8v-7.235c0-.574 0-.861-.074-1.126a2.002 2.002 0 00-.318-.65c-.163-.22-.39-.397-.843-.75l-6.783-5.275z"
    }, null, -1)
  ]));
}
const HomeIcon = /* @__PURE__ */ _export_sfc(_sfc_main$f, [["render", _sfc_render$4]]);
const _sfc_main$e = {};
const _hoisted_1$8 = {
  "data-v-05a08b96": "",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  "aria-hidden": "true",
  class: "nav-item-color h-[24px] w-[24px]"
};
function _sfc_render$3(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$8, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M7.135 11.189L3.33 4.381c-.437-.783-.656-1.175-.619-1.495a1 1 0 01.41-.697C3.38 2 3.83 2 4.726 2h2.235c.333 0 .5 0 .65.048a1 1 0 01.357.205c.118.104.202.248.372.535L12 9l3.659-6.212c.169-.287.254-.43.37-.535a1 1 0 01.359-.205c.15-.048.316-.048.65-.048h2.234c.897 0 1.345 0 1.607.189a1 1 0 01.41.697c.036.32-.183.712-.62 1.495l-3.805 6.808M10.5 14l1.5-1v5m-1.25 0h2.5m3.346-7.096a6.5 6.5 0 11-9.192 9.192 6.5 6.5 0 019.192-9.192z"
    }, null, -1)
  ]));
}
const LeaderBoardIcon = /* @__PURE__ */ _export_sfc(_sfc_main$e, [["render", _sfc_render$3]]);
const _sfc_main$d = {};
const _hoisted_1$7 = {
  "data-v-05a08b96": "",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  "aria-hidden": "true",
  class: "nav-item-color h-[24px] w-[24px]"
};
function _sfc_render$2(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$7, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M20 19v-3H7a3 3 0 00-3 3m4.8 3h8c1.12 0 1.68 0 2.108-.218a2 2 0 00.874-.874C20 20.48 20 19.92 20 18.8V5.2c0-1.12 0-1.68-.218-2.108a2 2 0 00-.874-.874C18.48 2 17.92 2 16.8 2h-8c-1.68 0-2.52 0-3.162.327a3 3 0 00-1.311 1.311C4 4.28 4 5.12 4 6.8v10.4c0 1.68 0 2.52.327 3.162a3 3 0 001.311 1.311C6.28 22 7.12 22 8.8 22z"
    }, null, -1)
  ]));
}
const LearningIcon = /* @__PURE__ */ _export_sfc(_sfc_main$d, [["render", _sfc_render$2]]);
const _sfc_main$c = {};
const _hoisted_1$6 = {
  "data-v-05a08b96": "",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  "aria-hidden": "true",
  class: "nav-item-color h-[24px] w-[24px]"
};
function _sfc_render$1(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$6, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M6.094 11.229A8.01 8.01 0 016 10c0-4.418 3.605-8 8.053-8 4.447 0 8.052 3.582 8.052 8 0 .998-.184 1.954-.52 2.835-.07.182-.105.274-.12.345a.897.897 0 00-.024.194c-.002.073.008.153.028.314l.403 3.27c.043.355.065.532.006.66a.5.5 0 01-.257.252c-.13.055-.306.03-.66-.022l-3.184-.467c-.167-.024-.25-.037-.326-.036a.898.898 0 00-.2.021c-.074.016-.169.051-.358.122a8.174 8.174 0 01-4.07.42M7.632 22C10.597 22 13 19.538 13 16.5S10.597 11 7.632 11c-2.965 0-5.369 2.462-5.369 5.5 0 .61.097 1.198.277 1.747.075.232.113.348.126.427.013.083.015.13.01.213-.005.08-.025.17-.065.351L2 22l2.995-.409c.163-.022.245-.034.316-.033.076 0 .115.005.19.02.07.013.173.05.381.123a5.246 5.246 0 001.75.299z"
    }, null, -1)
  ]));
}
const MessageChatIcon = /* @__PURE__ */ _export_sfc(_sfc_main$c, [["render", _sfc_render$1]]);
const _sfc_main$b = {};
const _hoisted_1$5 = {
  "data-v-05a08b96": "",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  "aria-hidden": "true",
  class: "nav-item-color h-[24px] w-[24px]"
};
function _sfc_render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$5, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12 15c-3.17 0-5.99 1.53-7.784 3.906-.386.511-.58.767-.573 1.112.005.267.172.604.382.769.272.213.649.213 1.402.213h13.146c.753 0 1.13 0 1.402-.213.21-.165.377-.502.382-.769.006-.345-.187-.6-.573-1.112C17.989 16.531 15.17 15 12 15zM12 12a4.5 4.5 0 100-9 4.5 4.5 0 000 9z"
    }, null, -1)
  ]));
}
const ProfileIcon = /* @__PURE__ */ _export_sfc(_sfc_main$b, [["render", _sfc_render]]);
const _hoisted_1$4 = {
  key: 0,
  class: "flex flex-col w-full"
};
const _hoisted_2$4 = { class: "inline-flex w-full justify-center bg-white border-t-[0.75px] border-solid border-x-0 border-b-0 border-gray-200 items-center" };
const _hoisted_3$3 = ["onClick"];
const _hoisted_4$3 = { class: "relative h-[24px] w-[24px] mb-[2px] mt-[7px]" };
const __default__$2 = {
  name: "BottomNavBar"
};
const _sfc_main$a = /* @__PURE__ */ defineComponent({
  ...__default__$2,
  props: {
    navigationItems: {
      type: Array,
      required: true
    }
  },
  setup(__props) {
    const routerInstance = AppState.getRouterInstance();
    const route = computed(() => {
      if (!routerInstance) return null;
      return routerInstance.currentRoute;
    });
    const props = __props;
    const t2 = ref(null);
    onBeforeMount(() => {
      t2.value = setupVueI18n(getLocalePreference());
    });
    const tabWidth = ref(0);
    const isLoading = ref(true);
    let attemptCount = 0;
    const MAX_ATTEMPTS = 5;
    onMounted(async () => {
      AppState.state.childNavigationItems = props.navigationItems;
      getElementWidth();
      setIcons();
      isLoading.value = false;
      await getNotifications();
      window.addEventListener("resize", getElementWidth);
    });
    const getElementWidth = () => {
      const element = document.getElementById("mobile-bottom-navigation");
      if (element) {
        tabWidth.value = element.offsetWidth;
        return;
      }
      if (attemptCount < MAX_ATTEMPTS) {
        attemptCount++;
        setTimeout(getElementWidth, 200);
      }
    };
    const navigationItemsWithIcons = ref([]);
    function setIcons() {
      var _a;
      navigationItemsWithIcons.value = (_a = props.navigationItems) == null ? void 0 : _a.map((item) => {
        if (item.name === "LeadCustomer") {
          return {
            ...item,
            label: "affiliates.leadCustomer"
          };
        }
        if (item.name === "Commissions") {
          return {
            ...item,
            label: "affiliates.commissions"
          };
        }
        if (item.name === "PayoutMethods") {
          return {
            ...item,
            label: "affiliates.payoutMethod"
          };
        }
        if (item.name === "Home") {
          return {
            ...item,
            label: "common.home",
            icon: () => h(HomeIcon),
            selectedIcon: () => h(FillHomeIcon)
          };
        }
        if (item.name === "Notifications") {
          return {
            ...item,
            label: "notifications.title",
            icon: () => h(BellIcon),
            selectedIcon: () => h(FillBellIcon)
          };
        }
        if (item.name === "Profile") {
          return {
            ...item,
            label: "sideBar.profile",
            icon: () => h(ProfileIcon),
            selectedIcon: () => h(FillProfileIcon)
          };
        }
        if (item.name === "Discussion") {
          return {
            ...item,
            label: "common.discussion",
            icon: () => h(MessageChatIcon),
            selectedIcon: () => h(FillMessageChatIcon)
          };
        }
        if (item.name === "All Courses") {
          return {
            ...item,
            label: "common.allCourses",
            icon: () => h(AllCoursesIcon),
            selectedIcon: () => h(FillAllCoursesIcon)
          };
        }
        if (item.name === "My Courses") {
          return {
            ...item,
            label: "common.myCourses",
            icon: () => h(LearningIcon),
            selectedIcon: () => h(FillLearningIcon)
          };
        }
        if (item.name === "Learning") {
          return {
            ...item,
            label: "common.learning",
            icon: () => h(LearningIcon),
            selectedIcon: () => h(FillLearningIcon)
          };
        }
        if (item.name === "Leaderboard") {
          return {
            ...item,
            label: "common.leaderboard",
            icon: () => h(LeaderBoardIcon),
            selectedIcon: () => h(FillLeaderBoardIcon)
          };
        }
        return item;
      });
    }
    watch(
      () => {
        var _a, _b;
        return (_b = (_a = NotificationState) == null ? void 0 : _a.state) == null ? void 0 : _b.unReadNotificationCount;
      },
      () => {
        for (const item of props.navigationItems) {
          if (item.routeName.includes("NotificationMobileView")) {
            if (unreadNotificationCount.value > 0) {
              item.showBadge = true;
            } else {
              item.showBadge = false;
            }
          }
        }
        setIcons();
      }
    );
    const unreadNotificationCount = computed(() => {
      return NotificationState.state.unReadNotificationCount;
    });
    const getNotifications = async () => {
      var _a, _b;
      if (props.navigationItems) {
        for (const item of props.navigationItems) {
          if (item.routeName.includes("NotificationMobileView")) {
            await ((_a = NotificationState) == null ? void 0 : _a.getNotifications());
            await ((_b = NotificationState) == null ? void 0 : _b.getUnreadNotificationsCount());
            if (unreadNotificationCount.value > 0) {
              item.showBadge = true;
            }
          }
        }
      }
    };
    const handleToggle = (item) => {
      try {
        switch (item.type) {
          case NavigationItemType.APP_ROUTE: {
            if (routerInstance) {
              if (["group-home-search", "channel-search"].includes(
                routerInstance.currentRoute.name
              ) && item.name === "Discussion") {
                return;
              }
              routerInstance.push({ name: item.routeName[0] });
            }
            break;
          }
          case NavigationItemType.REDIRECTION: {
            window.location.replace(item.redirectionUrl);
            break;
          }
          case NavigationItemType.APP_ACTION: {
            if (item.action) item.action();
            break;
          }
        }
      } catch (error) {
        console.error(error);
      }
    };
    const selectedNavigationIndex = computed(() => {
      var _a;
      const selectedIndex = (_a = navigationItemsWithIcons == null ? void 0 : navigationItemsWithIcons.value.filter((i) => i == null ? void 0 : i.showOnMobile)) == null ? void 0 : _a.findIndex(
        (item) => {
          var _a2, _b;
          return item.routeName && ((_a2 = routerInstance == null ? void 0 : routerInstance.currentRoute) == null ? void 0 : _a2.name) && item.routeName.includes((_b = routerInstance == null ? void 0 : routerInstance.currentRoute) == null ? void 0 : _b.name);
        }
      );
      return selectedIndex === -1 ? 0 : selectedIndex;
    });
    const selectedIndicatorPosition = computed(() => {
      const itemWidth = tabWidth.value;
      return selectedNavigationIndex.value * itemWidth;
    });
    return (_ctx, _cache) => {
      var _a;
      return !isLoading.value ? (openBlock(), createElementBlock("div", _hoisted_1$4, [
        createElementVNode("div", {
          class: "h-[2px] rounded-xl bg-gray-900 absolute top-0 left-0 transition-transform duration-300 ease-in-out",
          style: normalizeStyle({
            transform: `translateX(${selectedIndicatorPosition.value + 4}px)`,
            width: `${tabWidth.value ? tabWidth.value - 8 : 0}px`
          })
        }, null, 4),
        createElementVNode("div", _hoisted_2$4, [
          (openBlock(true), createElementBlock(Fragment, null, renderList((_a = navigationItemsWithIcons.value) == null ? void 0 : _a.filter((i) => i == null ? void 0 : i.showOnMobile), (item) => {
            var _a2, _b;
            return openBlock(), createElementBlock("div", {
              key: item.name,
              id: `mobile-bottom-navigation`,
              class: normalizeClass([
                "inline-flex shrink grow basis-0 cursor-pointer flex-col items-center",
                item.routeName.includes((_a2 = route.value) == null ? void 0 : _a2.name) ? "text-black" : "text-gray-400"
              ]),
              onClick: () => handleToggle(item)
            }, [
              _cache[0] || (_cache[0] = createElementVNode("div", { class: "h-[1px] w-full bg-white" }, null, -1)),
              createElementVNode("div", _hoisted_4$3, [
                createVNode(unref(UIBadge), {
                  dot: true,
                  max: void 0,
                  showZero: false,
                  show: (item == null ? void 0 : item.showBadge) ? true : false,
                  type: "default",
                  id: item.name
                }, {
                  content: withCtx(() => [
                    item.routeName.includes(route.value.name) ? (openBlock(), createBlock(resolveDynamicComponent(item.selectedIcon), {
                      key: 0,
                      class: "h-[24px] w-[24px]"
                    })) : (openBlock(), createBlock(resolveDynamicComponent(item.icon), {
                      key: 1,
                      class: "h-[24px] w-[24px] nav-item-color"
                    }))
                  ]),
                  _: 2
                }, 1032, ["show", "id"])
              ]),
              createElementVNode("div", {
                class: normalizeClass([
                  "text-center text-[8px] font-normal",
                  item.routeName.includes((_b = route.value) == null ? void 0 : _b.name) ? "text-gray-900" : "nav-item-color"
                ])
              }, toDisplayString(t2.value(item.label)), 3)
            ], 10, _hoisted_3$3);
          }), 128))
        ])
      ])) : createCommentVNode("", true);
    };
  }
});
const BottomNavBar = /* @__PURE__ */ _export_sfc(_sfc_main$a, [["__scopeId", "data-v-60452f69"]]);
const _sfc_main$9 = /* @__PURE__ */ defineComponent({
  __name: "AvatarIcon",
  props: {
    src: {
      type: String,
      required: true
    },
    size: {
      type: Number,
      default: 24
    },
    className: {
      type: String,
      default: ""
    },
    active: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      var _a, _b;
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["avatar-wrapper", { active: __props.active }])
      }, [
        createVNode(unref(UIAvatar), {
          id: "communities-ui-avatar-icon",
          src: __props.src || ((_b = (_a = unref(UserState)) == null ? void 0 : _a.state) == null ? void 0 : _b.avatar),
          size: __props.size,
          class: normalizeClass([__props.className, { active: __props.active }])
        }, null, 8, ["src", "size", "class"]),
        createVNode(unref(render$1f), {
          class: normalizeClass(["menu-icon", { active: __props.active }])
        }, null, 8, ["class"])
      ], 2);
    };
  }
});
const AvatarIcon = /* @__PURE__ */ _export_sfc(_sfc_main$9, [["__scopeId", "data-v-aea74aa5"]]);
const _hoisted_1$3 = {
  key: 0,
  class: "flex flex-col w-full"
};
const _hoisted_2$3 = { class: "inline-flex w-full justify-center bg-white border-t-[0.75px] border-solid border-x-0 border-b-0 border-gray-200 items-center" };
const _hoisted_3$2 = ["onClick"];
const _hoisted_4$2 = { class: "relative h-[24px] w-[24px] mb-[2px] mt-[7px]" };
const __default__$1 = {
  name: "BottomNavBarMobile"
};
const _sfc_main$8 = /* @__PURE__ */ defineComponent({
  ...__default__$1,
  props: {
    routeConfig: {
      type: Array,
      required: true
    }
  },
  setup(__props) {
    const router = AppState.getRouterInstance();
    const route = computed(() => {
      if (!router) return null;
      return router.currentRoute;
    });
    const t2 = ref(null);
    onBeforeMount(() => {
      t2.value = setupVueI18n(window.localStorage.getItem("locale") || "en");
    });
    const props = __props;
    const isCourses = computed(() => {
      return window.location.pathname.startsWith("/courses/");
    });
    const isCommunities = computed(() => {
      return !window.location.pathname.startsWith("/courses/");
    });
    const navigationItems = [
      {
        name: "Home",
        label: "bottomNavBar.home",
        routeName: [],
        type: NavigationItemType.APP_ROUTE,
        showOnMobile: !isGokollab(),
        showOnWeb: false,
        icon: () => h(HomeIcon),
        selectedIcon: () => h(FillHomeIcon)
      },
      {
        name: "Discover",
        label: "bottomNavBar.discover",
        routeName: ["discovery"],
        type: NavigationItemType.APP_ROUTE,
        showOnMobile: false,
        showOnWeb: false,
        icon: () => h(render$16),
        selectedIcon: () => h(render$16)
      },
      {
        name: "Communities",
        label: "bottomNavBar.communities",
        routeName: [],
        type: isCourses.value ? NavigationItemType.REDIRECTION : NavigationItemType.APP_ROUTE,
        showOnMobile: isGokollab() || isCommunities.value ? true : false,
        showOnWeb: false,
        icon: () => h(MessageChatIcon),
        selectedIcon: () => h(FillMessageChatIcon),
        redirectionUrl: isGokollab() ? "/load-communities" : "/communities/groups/load-communities"
      },
      {
        name: "Courses",
        label: "bottomNavBar.courses",
        routeName: [],
        type: isCommunities.value ? isGokollab() ? NavigationItemType.APP_ROUTE : NavigationItemType.REDIRECTION : NavigationItemType.APP_ROUTE,
        showOnMobile: isGokollab() || isCourses.value ? true : false,
        showOnWeb: false,
        icon: () => h(AllCoursesIcon),
        selectedIcon: () => h(FillAllCoursesIcon),
        redirectionUrl: isGokollab() ? "/courses/my-courses" : "/courses/library-v2"
      },
      {
        name: "More",
        label: "bottomNavBar.more",
        routeName: [],
        type: NavigationItemType.APP_ROUTE,
        showOnMobile: true,
        showOnWeb: false,
        icon: () => h(AvatarIcon, { active: false, size: "small" }),
        selectedIcon: () => h(AvatarIcon, { active: true, size: "small" })
      }
    ];
    const tabWidth = ref(0);
    const isLoading = ref(true);
    let attemptCount = 0;
    const MAX_ATTEMPTS = 5;
    onMounted(() => {
      AppState.state.childNavigationItems = navigationItems;
      getElementWidth();
      updateRouteConfig();
      isLoading.value = false;
      window.addEventListener("resize", getElementWidth);
    });
    function updateRouteConfig() {
      navigationItems.forEach((item) => {
        var _a;
        const foundRoute = (_a = props.routeConfig.find(
          (route2) => route2.name === item.name
        )) == null ? void 0 : _a.routeName;
        if (foundRoute) {
          item.routeName = [...item.routeName, ...foundRoute];
        }
      });
    }
    const getElementWidth = () => {
      const element = document.getElementById("mobile-bottom-navigation");
      if (element) {
        tabWidth.value = element.offsetWidth;
        return;
      }
      if (attemptCount < MAX_ATTEMPTS) {
        attemptCount++;
        setTimeout(getElementWidth, 200);
      }
    };
    const handleToggle = (item) => {
      try {
        switch (item.type) {
          case NavigationItemType.APP_ROUTE: {
            if (router) {
              if (["group-home-search", "channel-search"].includes(
                router.currentRoute.name
              ) && item.name === "Discussion") {
                return;
              }
              router.push({ name: item.routeName[0] });
            }
            break;
          }
          case NavigationItemType.REDIRECTION: {
            window.location.replace(item.redirectionUrl);
            break;
          }
          case NavigationItemType.APP_ACTION: {
            if (item.action) item.action();
            break;
          }
        }
      } catch (error) {
        console.error(error);
      }
    };
    const selectedNavigationIndex = computed(() => {
      var _a;
      const selectedIndex = (_a = navigationItems.filter((i) => i == null ? void 0 : i.showOnMobile)) == null ? void 0 : _a.findIndex(
        (item) => {
          var _a2;
          return item.routeName && item.routeName.includes((_a2 = route.value) == null ? void 0 : _a2.name);
        }
      );
      return selectedIndex === -1 ? 0 : selectedIndex;
    });
    const selectedIndicatorPosition = computed(() => {
      const itemWidth = tabWidth.value;
      return selectedNavigationIndex.value * itemWidth;
    });
    return (_ctx, _cache) => {
      return !isLoading.value ? (openBlock(), createElementBlock("div", _hoisted_1$3, [
        createElementVNode("div", {
          class: "h-[2px] rounded-xl bg-gray-900 absolute top-0 left-0 transition-transform duration-300 ease-in-out",
          style: normalizeStyle({
            transform: `translateX(${selectedIndicatorPosition.value + 4}px)`,
            width: `${tabWidth.value ? tabWidth.value - 8 : 0}px`
          })
        }, null, 4),
        createElementVNode("div", _hoisted_2$3, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(navigationItems == null ? void 0 : navigationItems.filter((i) => i == null ? void 0 : i.showOnMobile), (item) => {
            var _a, _b;
            return openBlock(), createElementBlock("div", {
              key: item.name,
              id: `mobile-bottom-navigation`,
              class: normalizeClass([
                "inline-flex shrink grow basis-0 cursor-pointer flex-col items-center",
                item.routeName.includes((_a = route.value) == null ? void 0 : _a.name) ? "text-black" : "text-gray-400"
              ]),
              onClick: () => handleToggle(item)
            }, [
              _cache[0] || (_cache[0] = createElementVNode("div", { class: "h-[1px] w-full bg-white" }, null, -1)),
              createElementVNode("div", _hoisted_4$2, [
                createVNode(unref(UIBadge), {
                  dot: true,
                  max: void 0,
                  showZero: false,
                  show: (item == null ? void 0 : item.showBadge) ? true : false,
                  type: "default",
                  id: item.name
                }, {
                  content: withCtx(() => {
                    var _a2;
                    return [
                      item.routeName.includes((_a2 = route.value) == null ? void 0 : _a2.name) ? (openBlock(), createBlock(resolveDynamicComponent(item.selectedIcon), {
                        key: 0,
                        class: "h-[24px] w-[24px]"
                      })) : (openBlock(), createBlock(resolveDynamicComponent(item.icon), {
                        key: 1,
                        class: "h-[24px] w-[24px] nav-item-color"
                      }))
                    ];
                  }),
                  _: 2
                }, 1032, ["show", "id"])
              ]),
              createElementVNode("div", {
                class: normalizeClass([
                  "text-center text-[8px] font-normal",
                  item.routeName.includes((_b = route.value) == null ? void 0 : _b.name) ? "text-gray-900" : "nav-item-color"
                ])
              }, toDisplayString(t2.value(item.label)), 3)
            ], 10, _hoisted_3$2);
          }), 128))
        ])
      ])) : createCommentVNode("", true);
    };
  }
});
const BottomNavBarMobile = /* @__PURE__ */ _export_sfc(_sfc_main$8, [["__scopeId", "data-v-24ac9374"]]);
BottomNavBar.install = (Vue) => {
  Vue.component(BottomNavBar.name, BottomNavBar);
};
BottomNavBarMobile.install = (Vue) => {
  Vue.component(BottomNavBarMobile.name, BottomNavBarMobile);
};
NotificationMobileView.install = (Vue) => {
  Vue.component(NotificationMobileView.name, NotificationMobileView);
};
const _hoisted_1$2 = { class: "max-h-48 overflow-auto" };
const _hoisted_2$2 = { class: "flex items-center -ml-2" };
const _sfc_main$7 = /* @__PURE__ */ defineComponent({
  __name: "LoginMultiUserPwa",
  props: {
    title: {
      type: String,
      default: "Login"
    },
    email: {
      type: String,
      required: true
    },
    password: {
      type: String,
      default: ""
    },
    otp: {
      type: []
    },
    token: {
      type: String
    },
    users: {
      default: []
    },
    resetPassword: {
      default: false
    },
    loginOtp: {
      default: false
    },
    idToken: {
      type: String
    },
    fullName: {
      type: String
    },
    locationId: {
      type: String,
      required: true
    },
    domain: {
      type: String
    }
  },
  emits: ["changeScreen", LoginEvents.LOGIN_CALLBACK],
  setup(__props, { emit: __emit }) {
    const emit = __emit;
    const notification = useNotification();
    const loadingRef = ref(null);
    const buttonDisable = ref(false);
    const selectedValue = ref("");
    const loginDisabled = ref(false);
    const props = __props;
    function notificationFailureAlert(title, content) {
      notification.error({
        title,
        content,
        duration: 5e3
      });
    }
    const handleLogin = async () => {
      var _a, _b, _c, _d;
      buttonDisable.value = true;
      (_a = loadingRef.value) == null ? void 0 : _a.startLoadBar();
      let response;
      try {
        if (!selectedValue.value) {
          notificationFailureAlert("Select at least one user", "Try Again");
          (_b = loadingRef.value) == null ? void 0 : _b.stopLoadBar();
          buttonDisable.value = false;
          return;
        }
        if (props.loginOtp || props.resetPassword) {
          const { data } = await UserService.loginWithSecureEmail({
            email: props.email,
            otp: Number(props.otp),
            token: props.token,
            userId: selectedValue.value,
            locationId: props.locationId
          });
          response = data;
        } else {
          const { data } = await UserService.login({
            email: props.email,
            password: props.password,
            userId: selectedValue.value,
            locationId: props.locationId
          });
          response = data;
        }
        if (response) {
          await postLogin(response);
          if (!response.isPasswordVerified || props.resetPassword) {
            emit("changeScreen", {
              email: props.email,
              passwordResetToken: response.passwordResetToken,
              contactId: response.contactId,
              userId: response.userId,
              token: response.token,
              isPasswordVerified: response.isPasswordVerified,
              data: response,
              page: Screens.SET_PASSWORD
            });
          } else {
            if (TEST_EMAILS.includes(props.email.toLowerCase().trim())) {
              await checkUserConsent(response);
              emit("changeScreen", {
                domain: props.domain,
                data: response,
                page: Screens.TERMS_CONSENT
              });
            } else {
              const userConsent = await checkUserConsent(response);
              if (userConsent) {
                await postLogin(response);
                emit(LoginEvents.LOGIN_CALLBACK, {
                  eventType: LoginEvents.LOGIN_SUCCESSFUL,
                  domain: props.domain,
                  ...response
                });
              } else {
                emit("changeScreen", {
                  domain: props.domain,
                  data: response,
                  page: Screens.TERMS_CONSENT
                });
              }
            }
          }
        }
      } catch (error) {
        console.error("Login error:", error);
        if (((_c = error == null ? void 0 : error.response) == null ? void 0 : _c.status) === 429) {
          loginDisabled.value = true;
        } else {
          notificationFailureAlert(getErrorMessage(error), "Try Again");
        }
        (_d = loadingRef.value) == null ? void 0 : _d.stopLoadBar();
        buttonDisable.value = false;
      }
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        createVNode(unref(UILoadingBar), {
          ref_key: "loadingRef",
          ref: loadingRef
        }, null, 512),
        createElementVNode("div", null, [
          createVNode(unref(UITextLgMedium), { class: "text-gray-700 text-center mb-2" }, {
            default: withCtx(() => _cache[1] || (_cache[1] = [
              createTextVNode("Select User")
            ])),
            _: 1
          }),
          createElementVNode("div", _hoisted_1$2, [
            createVNode(unref(UIRadioGroup), {
              value: selectedValue.value,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event) => selectedValue.value = $event),
              name: "radiobuttongroup1",
              class: "w-full radio-container"
            }, {
              default: withCtx(() => [
                createVNode(unref(UISpace), { vertical: "" }, {
                  default: withCtx(() => [
                    (openBlock(true), createElementBlock(Fragment, null, renderList(__props.users, (item) => {
                      return openBlock(), createBlock(unref(UIRadioGroupItem), {
                        value: item.userId,
                        "onUpdate:value": ($event) => item.userId = $event,
                        key: item.userId,
                        disabled: false,
                        compact: void 0,
                        class: "w-full my-1 py-1"
                      }, {
                        content: withCtx(() => [
                          createElementVNode("div", _hoisted_2$2, [
                            item.avatarUrl ? (openBlock(), createBlock(unref(UIAvatar), {
                              key: 0,
                              class: "h-12 w-12",
                              objectFit: "cover",
                              src: item.avatarUrl
                            }, null, 8, ["src"])) : (openBlock(), createBlock(unref(UIAvatar), {
                              key: 1,
                              class: "h-12 w-12",
                              objectFit: "cover"
                            }, {
                              default: withCtx(() => [
                                createTextVNode(toDisplayString(unref(formatNameForAvatar)(item.fullName)), 1)
                              ]),
                              _: 2
                            }, 1024)),
                            createElementVNode("div", null, [
                              createVNode(unref(UITextSmMedium), { class: "ml-2 text-gray-700" }, {
                                default: withCtx(() => [
                                  createTextVNode(toDisplayString(item.fullName), 1)
                                ]),
                                _: 2
                              }, 1024),
                              (item == null ? void 0 : item.lastLogin) ? (openBlock(), createBlock(unref(UITextXsRegular), {
                                key: 0,
                                class: "ml-2 mt-[6px] text-gray-500"
                              }, {
                                default: withCtx(() => [
                                  createTextVNode("Last Login: " + toDisplayString(unref(timestampFormat)(item.lastLogin)), 1)
                                ]),
                                _: 2
                              }, 1024)) : createCommentVNode("", true)
                            ])
                          ])
                        ]),
                        _: 2
                      }, 1032, ["value", "onUpdate:value"]);
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          createVNode(unref(UIButton), {
            onClick: handleLogin,
            type: "primary",
            class: "!bg-black h-12 w-full row-span-1 mt-8 buttonBorder",
            id: "next-domain-btn",
            size: "large",
            disabled: selectedValue.value === "" || buttonDisable.value
          }, {
            default: withCtx(() => _cache[2] || (_cache[2] = [
              createTextVNode("Login")
            ])),
            _: 1
          }, 8, ["disabled"])
        ])
      ], 64);
    };
  }
});
const LoginMultiUserPwa = /* @__PURE__ */ _export_sfc(_sfc_main$7, [["__scopeId", "data-v-f526ec51"]]);
const _sfc_main$6 = /* @__PURE__ */ defineComponent({
  __name: "LoginPagePwa",
  props: {
    locationId: {
      type: String,
      required: true
    },
    email: {
      type: String,
      required: true
    },
    domain: {
      type: String
    }
  },
  emits: ["changeScreen", LoginEvents.LOGIN_CALLBACK],
  setup(__props, { emit: __emit }) {
    const notification = useNotification();
    const loadingRef = ref(null);
    const showRecaptcha = ref(false);
    const buttonDisable = ref(false);
    const reCaptchaToken = ref(void 0);
    const props = __props;
    const rules = {
      email: {
        required: true,
        validator: (_, value) => {
          return string().email().required().validate(value);
        },
        message: "Please enter a valid  email",
        trigger: ["input", "blur"]
      },
      password: {
        required: true,
        min: 8,
        message: "Please enter a password of mininum 8 characters",
        trigger: ["input", "blur"]
      }
    };
    const formValue = ref({
      password: ""
    });
    function notificationFailureAlert(title, content) {
      notification.error({
        title,
        content,
        duration: 5e3
      });
    }
    const formRef = ref();
    const handleValidateResetPassword = async () => {
      var _a, _b, _c, _d;
      buttonDisable.value = true;
      (_a = loadingRef.value) == null ? void 0 : _a.startLoadBar();
      try {
        const { data } = await UserService.loginWithSecureEmail({
          email: props.email.trim(),
          locationId: props.locationId,
          action: "RESET_PASSWORD"
        });
        if (data == null ? void 0 : data.token) {
          emit("changeScreen", {
            email: props.email,
            otp: String(data == null ? void 0 : data.otp),
            token: data.token,
            page: Screens.SET_PASSWORD_WITH_SECURE_CODE
          });
          (_b = loadingRef.value) == null ? void 0 : _b.stopLoadBar();
          buttonDisable.value = false;
        }
      } catch (error) {
        if (((_c = error == null ? void 0 : error.response) == null ? void 0 : _c.status) !== 429) {
          notificationFailureAlert(getErrorMessage(error), "Try Again");
        }
        (_d = loadingRef.value) == null ? void 0 : _d.stopLoadBar();
        buttonDisable.value = false;
      }
    };
    const handleValidateSendOtp = async () => {
      var _a, _b, _c;
      buttonDisable.value = true;
      (_a = loadingRef.value) == null ? void 0 : _a.startLoadBar();
      try {
        const { data } = await UserService.loginWithSecureEmail({
          email: props.email.trim(),
          locationId: props.locationId,
          action: "SIGN_IN"
        });
        if (data == null ? void 0 : data.token) {
          emit("changeScreen", {
            email: props.email,
            otp: String(data == null ? void 0 : data.otp),
            token: data.token,
            page: Screens.VERIFY_SECURE_CODE
          });
        }
      } catch (error) {
        if (((_b = error == null ? void 0 : error.response) == null ? void 0 : _b.status) !== 429) {
          notificationFailureAlert(getErrorMessage(error), "Try Again");
        }
        (_c = loadingRef.value) == null ? void 0 : _c.stopLoadBar();
        buttonDisable.value = false;
      }
    };
    async function handleValidateClick(e) {
      var _a, _b, _c, _d, _e, _f, _g;
      e.preventDefault();
      buttonDisable.value = true;
      (_a = loadingRef.value) == null ? void 0 : _a.startLoadBar();
      const result = await validateForm(formRef.value);
      if (!result) {
        (_b = loadingRef.value) == null ? void 0 : _b.stopLoadBar();
        buttonDisable.value = false;
        return;
      }
      try {
        const { data } = await UserService.login({
          email: props.email.trim(),
          password: formValue.value.password.trim(),
          locationId: props.locationId,
          captchaToken: reCaptchaToken.value
        });
        if (data == null ? void 0 : data.multiple_users) {
          emit("changeScreen", {
            ...formValue.value,
            email: props.email,
            page: Screens.SELECT_USER_MULTI_USER,
            multiUser: data == null ? void 0 : data.multiple_users
          });
          (_c = loadingRef.value) == null ? void 0 : _c.stopLoadBar();
          buttonDisable.value = false;
        } else if (data.token) {
          if (TEST_EMAILS.includes(props.email.toLowerCase().trim())) {
            await checkUserConsent(data);
            emit("changeScreen", {
              domain: props.domain,
              data,
              page: Screens.TERMS_CONSENT
            });
          } else {
            const userConsent = await checkUserConsent(data);
            if (userConsent) {
              await postLogin(data);
              emit(LoginEvents.LOGIN_CALLBACK, {
                eventType: LoginEvents.LOGIN_SUCCESSFUL,
                domain: props.domain,
                ...data
              });
            } else {
              emit("changeScreen", {
                domain: props.domain,
                data,
                page: Screens.TERMS_CONSENT
              });
            }
          }
          (_d = loadingRef.value) == null ? void 0 : _d.stopLoadBar();
          buttonDisable.value = false;
        }
        showRecaptcha.value = false;
      } catch (error) {
        if (((_e = error == null ? void 0 : error.response) == null ? void 0 : _e.status) === 429) {
          (_f = loadingRef.value) == null ? void 0 : _f.stopLoadBar();
          buttonDisable.value = false;
          showRecaptcha.value = true;
        } else {
          showRecaptcha.value = false;
          notificationFailureAlert(getErrorMessage(error), "Try Again");
        }
        (_g = loadingRef.value) == null ? void 0 : _g.stopLoadBar();
        buttonDisable.value = false;
      }
    }
    const emit = __emit;
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        createVNode(unref(UILoadingBar), {
          ref_key: "loadingRef",
          ref: loadingRef
        }, null, 512),
        createElementVNode("div", null, [
          createVNode(unref(UIForm), {
            id: "login-page-email-form",
            ref_key: "formRef",
            ref: formRef,
            model: formValue.value,
            rules
          }, {
            default: withCtx(() => [
              createVNode(unref(UITextMdNormal), { class: "text-gray-600" }, {
                default: withCtx(() => _cache[1] || (_cache[1] = [
                  createTextVNode("Email")
                ])),
                _: 1
              }),
              createVNode(unref(UIInput), {
                value: __props.email,
                disabled: true,
                size: "large",
                placeholder: "",
                id: "domain-form-email"
              }, null, 8, ["value"]),
              createVNode(unref(UITextMdNormal), { class: "text-gray-600 mt-2" }, {
                default: withCtx(() => _cache[2] || (_cache[2] = [
                  createTextVNode("Password")
                ])),
                _: 1
              }),
              createVNode(unref(UIInput), {
                modelValue: formValue.value.password,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => formValue.value.password = $event),
                size: "large",
                placeholder: "",
                type: "password",
                "show-password-on": "click",
                id: "form-password"
              }, null, 8, ["modelValue"]),
              createVNode(unref(UITextSmMedium), {
                onClick: handleValidateResetPassword,
                class: "float-right w-fit text-gray-600 cursor-pointer mt-4"
              }, {
                default: withCtx(() => _cache[3] || (_cache[3] = [
                  createTextVNode("Forgot password?")
                ])),
                _: 1
              }),
              createVNode(unref(UIButton), {
                onClick: handleValidateClick,
                type: "primary",
                class: "!bg-black w-full row-span-1 mt-4 h-12 buttonBorder text-white",
                id: "signin-btn",
                size: "large",
                disabled: buttonDisable.value
              }, {
                default: withCtx(() => _cache[4] || (_cache[4] = [
                  createTextVNode("Sign In")
                ])),
                _: 1
              }, 8, ["disabled"]),
              createVNode(unref(UITextSmMedium), { class: "text-center text-gray-400 my-4" }, {
                default: withCtx(() => _cache[5] || (_cache[5] = [
                  createTextVNode("or")
                ])),
                _: 1
              }),
              createVNode(unref(UIButton), {
                type: "default",
                class: "w-full row-span-1 h-12 buttonBorder",
                id: "code-btn",
                size: "large",
                onClick: handleValidateSendOtp,
                disabled: buttonDisable.value
              }, {
                default: withCtx(() => _cache[6] || (_cache[6] = [
                  createTextVNode("Sign in with secure code")
                ])),
                _: 1
              }, 8, ["disabled"])
            ]),
            _: 1
          }, 8, ["model"])
        ])
      ], 64);
    };
  }
});
const LoginPagePwa = /* @__PURE__ */ _export_sfc(_sfc_main$6, [["__scopeId", "data-v-64b208d0"]]);
const _sfc_main$5 = /* @__PURE__ */ defineComponent({
  __name: "SetPasswordPwa",
  props: {
    passwordResetToken: {
      type: String,
      required: true
    },
    userId: {
      type: String,
      required: true
    },
    contactId: {
      type: String,
      required: true
    },
    token: {
      type: String,
      required: true
    },
    locationId: {
      type: String,
      required: true
    },
    isPasswordVerified: {
      type: Boolean,
      default: true
    },
    domain: {
      type: String
    },
    data: {
      type: Object,
      required: true
    }
  },
  emits: ["changeScreen", LoginEvents.LOGIN_CALLBACK],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const notification = useNotification();
    const loadingRef = ref(null);
    const buttonDisable = ref(false);
    const rules = {
      newPassword: {
        required: true,
        min: 8,
        message: "Please enter a password of mininum 8 characters",
        trigger: ["input", "blur"]
      },
      confirmPassword: {
        required: true,
        validator: (_, value) => {
          return yup.string().required().oneOf([formValue.value.newPassword], "Passwords must match").validate(value);
        },
        message: "Passwords must match",
        trigger: ["input", "blur"]
      }
    };
    function notificationFailureAlert(title, content) {
      notification.error({
        title,
        content,
        duration: 5e3
      });
    }
    const formValue = ref({
      newPassword: "",
      confirmPassword: ""
    });
    const formRef = ref();
    const emit = __emit;
    const handleValidateClick = async () => {
      var _a;
      buttonDisable.value = true;
      (_a = loadingRef.value) == null ? void 0 : _a.startLoadBar();
      formRef.value.getForm().validate().then(async () => {
        if (props.isPasswordVerified) {
          const { data } = await UserService.resetPassword({
            userId: props.userId,
            token: props.token,
            password: formValue.value.newPassword.trim(),
            locationId: props.locationId
          });
          emit("changeScreen", {
            page: Screens.LOGIN
          });
        } else {
          await UserService.setPassword({
            newPassword: formValue.value.newPassword.trim(),
            confirmPassword: formValue.value.confirmPassword.trim(),
            locationId: props.locationId,
            passwordResetToken: props.passwordResetToken,
            contactId: props.contactId
          });
          if (await checkUserConsent(props.data)) {
            await postLogin(props.data);
            emit(LoginEvents.LOGIN_CALLBACK, {
              eventType: LoginEvents.LOGIN_SUCCESSFUL,
              domain: props.domain,
              ...props.data
            });
          } else {
            emit("changeScreen", {
              domain: props.domain,
              data: props.data,
              page: Screens.TERMS_CONSENT
            });
          }
        }
      }).catch((error) => {
        var _a2;
        notificationFailureAlert(getErrorMessage(error), "Try Again");
        (_a2 = loadingRef.value) == null ? void 0 : _a2.stopLoadBar();
        buttonDisable.value = false;
      });
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        createVNode(unref(UILoadingBar), {
          ref_key: "loadingRef",
          ref: loadingRef
        }, null, 512),
        createElementVNode("div", null, [
          createVNode(unref(UIForm), {
            id: "reset-password-page",
            ref_key: "formRef",
            ref: formRef,
            model: formValue.value,
            rules
          }, {
            default: withCtx(() => [
              createVNode(unref(UITextMdNormal), { class: "text-gray-600 mt-2" }, {
                default: withCtx(() => _cache[3] || (_cache[3] = [
                  createTextVNode("New Password")
                ])),
                _: 1
              }),
              createVNode(unref(UIFormItem), {
                class: "block min-h-0",
                path: "newPassword"
              }, {
                default: withCtx(() => [
                  createVNode(unref(UIInput), {
                    modelValue: formValue.value.newPassword,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => formValue.value.newPassword = $event),
                    size: "large",
                    placeholder: "",
                    "show-password-on": "click",
                    type: "password",
                    id: "form-password"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              createVNode(unref(UITextMdNormal), { class: "text-gray-600 mt-2" }, {
                default: withCtx(() => _cache[4] || (_cache[4] = [
                  createTextVNode("Confirm Password")
                ])),
                _: 1
              }),
              createVNode(unref(UIFormItem), {
                class: "block min-h-0",
                path: "confirmPassword"
              }, {
                default: withCtx(() => [
                  createVNode(unref(UIInput), {
                    modelValue: formValue.value.confirmPassword,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => formValue.value.confirmPassword = $event),
                    size: "large",
                    placeholder: "",
                    "show-password-on": "click",
                    type: "password",
                    id: "form-password"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              createVNode(unref(UIButton), {
                type: "primary",
                class: "!bg-black w-full h-12 row-span-1 mt-4 buttonBorder text-white",
                id: "signin-btn",
                size: "large",
                onClick: handleValidateClick,
                disabled: buttonDisable.value
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(props.isPasswordVerified ? "Reset password" : "Set password"), 1)
                ]),
                _: 1
              }, 8, ["disabled"]),
              createVNode(unref(UITextXsMedium), { class: "text-center text-gray-400 my-4" }, {
                default: withCtx(() => _cache[5] || (_cache[5] = [
                  createTextVNode("or")
                ])),
                _: 1
              }),
              createVNode(unref(UIButton), {
                type: "default",
                class: "w-full row-span-1 h-12 text-gray-900",
                id: "code-btn",
                size: "large",
                disabled: buttonDisable.value,
                onClick: _cache[2] || (_cache[2] = () => emit("changeScreen", {
                  page: unref(Screens).LOGIN
                }))
              }, {
                default: withCtx(() => _cache[6] || (_cache[6] = [
                  createTextVNode("Back to login")
                ])),
                _: 1
              }, 8, ["disabled"])
            ]),
            _: 1
          }, 8, ["model"])
        ])
      ], 64);
    };
  }
});
const SetPasswordPwa = /* @__PURE__ */ _export_sfc(_sfc_main$5, [["__scopeId", "data-v-b5c49944"]]);
const _sfc_main$4 = /* @__PURE__ */ defineComponent({
  __name: "SetPasswordWithSecureCodePwa",
  props: {
    title: {
      type: String,
      default: "Login"
    },
    email: {
      type: String,
      required: true
    },
    token: {
      type: String
    },
    password: {
      type: String
    },
    username: {
      type: String
    },
    locationId: {
      type: String
    },
    defaultOtp: {
      type: Number,
      default: null
    }
  },
  emits: ["changeScreen", LoginEvents.LOGIN_CALLBACK],
  setup(__props, { emit: __emit }) {
    const emit = __emit;
    const otpCode = ref("");
    const loadingRef = ref(null);
    const buttonDisable = ref(false);
    const notification = useNotification();
    const isResendButtonDisabled = ref(false);
    const routerInstance = AppState.getRouterInstance();
    const route = computed(() => {
      if (!routerInstance) return null;
      return routerInstance.currentRoute;
    });
    const props = __props;
    function notificationFailureAlert(title, content) {
      notification.error({
        title,
        content,
        duration: 5e3
      });
    }
    const handleOnComplete = async () => {
      var _a, _b, _c, _d, _e, _f, _g, _h;
      buttonDisable.value = true;
      (_a = loadingRef.value) == null ? void 0 : _a.startLoadBar();
      try {
        if (!Number(otpCode.value)) {
          notificationFailureAlert(
            "Secure code must be a numeric value and must be of 6 digits",
            "Try Again"
          );
          (_b = loadingRef.value) == null ? void 0 : _b.stopLoadBar();
          buttonDisable.value = false;
          return false;
        }
        const { data } = await UserService.loginWithSecureEmail({
          email: props.email,
          otp: Number(otpCode.value),
          token: props.token,
          locationId: props.locationId,
          redirectUrl: (_d = (_c = route.value) == null ? void 0 : _c.query) == null ? void 0 : _d.redirectUrl
        });
        if (data == null ? void 0 : data.multiple_users) {
          emit("changeScreen", {
            email: props.email,
            otp: Number(otpCode.value),
            token: props.token,
            multiUser: data == null ? void 0 : data.multiple_users,
            resetPassword: true,
            page: Screens.SELECT_USER_MULTI_USER
          });
        } else if (data.token) {
          emit("changeScreen", {
            email: props.email,
            token: props.token,
            passwordResetToken: data.passwordResetToken,
            contactId: data.contactId,
            userId: data.userId,
            page: Screens.SET_PASSWORD
          });
          (_e = loadingRef.value) == null ? void 0 : _e.stopLoadBar();
          buttonDisable.value = false;
        }
        (_f = loadingRef.value) == null ? void 0 : _f.stopLoadBar();
        buttonDisable.value = false;
      } catch (error) {
        if (((_g = error == null ? void 0 : error.response) == null ? void 0 : _g.status) !== 429) {
          notificationFailureAlert(getErrorMessage(error), "Try Again");
        }
        (_h = loadingRef.value) == null ? void 0 : _h.stopLoadBar();
        buttonDisable.value = false;
      }
    };
    async function resendOtp() {
      var _a;
      try {
        const { data } = await UserService.loginWithSecureEmail({
          email: props.email,
          locationId: props.locationId
        });
        emit("changeScreen", {
          page: Screens.VERIFY_SECURE_CODE,
          email: props.email,
          token: data.token
        });
        isResendButtonDisabled.value = true;
        setTimeout(() => isResendButtonDisabled.value = false, 3e4);
      } catch (error) {
        if (((_a = error == null ? void 0 : error.response) == null ? void 0 : _a.status) === 429) {
          isResendButtonDisabled.value = true;
        } else {
          notificationFailureAlert(getErrorMessage(error), "Try Again");
        }
      }
    }
    const handleOnChange = (value) => {
      otpCode.value = value;
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        createVNode(unref(UILoadingBar), {
          ref_key: "loadingRef",
          ref: loadingRef
        }, null, 512),
        createElementVNode("div", null, [
          createVNode(unref(UITextMdNormal), { class: "text-gray-500" }, {
            default: withCtx(() => _cache[2] || (_cache[2] = [
              createTextVNode("Secure code")
            ])),
            _: 1
          }),
          createVNode(unref(entry_esm), {
            class: "justify-center",
            ref: "otpInput",
            "input-classes": "otpStyle",
            value: otpCode.value,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event) => otpCode.value = $event),
            separator: " ",
            "num-inputs": 6,
            "should-auto-focus": true,
            "input-type": "tel",
            placeholder: ["0", "0", "0", "0", "0", "0"],
            onOnChange: handleOnChange,
            onOnComplete: handleOnComplete
          }, null, 8, ["value"]),
          createVNode(unref(UITextXsMedium), { class: "text-gray-900 mt-2 font-normal" }, {
            default: withCtx(() => [
              _cache[4] || (_cache[4] = createTextVNode("Please check your email for the secure code. If you did not receive any email from us,,")),
              createElementVNode("span", null, [
                createVNode(unref(UIButton), {
                  id: "resend-otp--button",
                  class: "underline-offset-4",
                  onClick: resendOtp,
                  disabled: isResendButtonDisabled.value,
                  text: true
                }, {
                  default: withCtx(() => _cache[3] || (_cache[3] = [
                    createTextVNode(" tap here to resend. ")
                  ])),
                  _: 1
                }, 8, ["disabled"])
              ])
            ]),
            _: 1
          }),
          createVNode(unref(UIButton), {
            type: "primary",
            class: "!bg-black h-12 w-full row-span-1 mt-4 buttonBorder text-white",
            id: "signin-btn",
            size: "large",
            onClick: handleOnComplete,
            disabled: buttonDisable.value
          }, {
            default: withCtx(() => _cache[5] || (_cache[5] = [
              createTextVNode("Verify")
            ])),
            _: 1
          }, 8, ["disabled"]),
          createVNode(unref(UITextXsMedium), { class: "text-center text-gray-400 my-4" }, {
            default: withCtx(() => _cache[6] || (_cache[6] = [
              createTextVNode("or")
            ])),
            _: 1
          }),
          createVNode(unref(UIButton), {
            type: "default",
            class: "w-full h-12 row-span-1 buttonBorder",
            id: "code-btn",
            size: "large",
            disabled: buttonDisable.value,
            onClick: _cache[1] || (_cache[1] = () => emit("changeScreen", {
              page: unref(Screens).LOGIN
            }))
          }, {
            default: withCtx(() => _cache[7] || (_cache[7] = [
              createTextVNode("Sign in with password")
            ])),
            _: 1
          }, 8, ["disabled"])
        ])
      ], 64);
    };
  }
});
const _hoisted_1$1 = { class: "flex flex-col justify-center h-full mt-5" };
const _hoisted_2$1 = { class: "flex flex-col justify-center mt-5" };
const _hoisted_3$1 = ["href"];
const _hoisted_4$1 = ["href"];
const _hoisted_5$1 = ["href"];
const _sfc_main$3 = /* @__PURE__ */ defineComponent({
  __name: "TermsAndConditionsPwa",
  props: {
    domain: {
      type: String
    },
    data: {
      type: Object,
      required: true
    }
  },
  emits: ["changeScreen", LoginEvents.LOGIN_CALLBACK],
  setup(__props, { emit: __emit }) {
    const loadingRef = ref(null);
    const notification = useNotification();
    const buttonDisable = ref(false);
    const emit = __emit;
    const props = __props;
    function notificationFailureAlert(title, content) {
      notification.error({
        title,
        content,
        duration: 5e3
      });
    }
    async function handleUserConsent(e) {
      var _a, _b, _c, _d;
      buttonDisable.value = true;
      e.preventDefault();
      (_a = loadingRef.value) == null ? void 0 : _a.startLoadBar();
      try {
        window.localStorage.setItem("cat", window.btoa(JSON.stringify(props.data)));
        await UserState.updateUserProfile({
          termsConsent: true,
          locationId: (_b = props == null ? void 0 : props.data) == null ? void 0 : _b.locationId,
          userId: (_c = UserState.state) == null ? void 0 : _c.userId
        });
        await postLogin(props.data);
        emit(LoginEvents.LOGIN_CALLBACK, {
          eventType: LoginEvents.LOGIN_SUCCESSFUL,
          domain: props.domain,
          ...props.data
        });
      } catch (error) {
        window.localStorage.removeItem("cat");
        window.localStorage.removeItem("cat-v2");
        notificationFailureAlert("Something went wrong", "Try Again!");
      } finally {
        (_d = loadingRef.value) == null ? void 0 : _d.stopLoadBar();
        buttonDisable.value = false;
      }
    }
    const handleBack = () => {
      emit("changeScreen", {
        page: Screens.LOGIN
      });
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        createVNode(unref(UILoadingBar), {
          ref_key: "loadingRef",
          ref: loadingRef
        }, null, 512),
        createElementVNode("div", _hoisted_1$1, [
          createVNode(unref(render$6), {
            onClick: handleBack,
            class: "w-8 h-8 -ml-2 cursor-pointer"
          }),
          createElementVNode("div", _hoisted_2$1, [
            createVNode(unref(UITextMdMedium), { class: "mb-4 text-2xl font-bold" }, {
              default: withCtx(() => {
                var _a, _b, _c, _d;
                return [
                  createTextVNode("Agree to " + toDisplayString(((_b = (_a = unref(BrandedAppState)) == null ? void 0 : _a.state) == null ? void 0 : _b.appName) ? ((_d = (_c = unref(BrandedAppState)) == null ? void 0 : _c.state) == null ? void 0 : _d.appName) + "'s" : "Kollab's") + " terms and policies", 1)
                ];
              }),
              _: 1
            }),
            createVNode(unref(UITextMdMedium), { class: "mb-4" }, {
              default: withCtx(() => {
                var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l;
                return [
                  _cache[3] || (_cache[3] = createTextVNode("By tapping ")),
                  _cache[4] || (_cache[4] = createElementVNode("b", null, "I agree", -1)),
                  createTextVNode(", you agree to " + toDisplayString(((_b = (_a = unref(BrandedAppState)) == null ? void 0 : _a.state) == null ? void 0 : _b.appName) ? ((_d = (_c = unref(BrandedAppState)) == null ? void 0 : _c.state) == null ? void 0 : _d.appName) + "'s" : "Kollab's") + " ", 1),
                  createElementVNode("a", {
                    class: "no-underline text-primary-500",
                    href: ((_f = (_e = unref(BrandedAppState)) == null ? void 0 : _e.state) == null ? void 0 : _f.termsConditionsUrl) ? (_h = (_g = unref(BrandedAppState)) == null ? void 0 : _g.state) == null ? void 0 : _h.termsConditionsUrl : "https://www.leadconnectorhq.com/terms2",
                    target: "_blank",
                    onClick: _cache[0] || (_cache[0] = //@ts-ignore
                    (...args) => unref(handleLinkClick) && unref(handleLinkClick)(...args))
                  }, "terms of services", 8, _hoisted_3$1),
                  _cache[5] || (_cache[5] = createTextVNode(" and ")),
                  createElementVNode("a", {
                    class: "no-underline text-primary-500",
                    href: ((_j = (_i = unref(BrandedAppState)) == null ? void 0 : _i.state) == null ? void 0 : _j.privacyPolicyUrl) ? (_l = (_k = unref(BrandedAppState)) == null ? void 0 : _k.state) == null ? void 0 : _l.privacyPolicyUrl : "https://www.leadconnectorhq.com/privacy-policy",
                    onClick: _cache[1] || (_cache[1] = //@ts-ignore
                    (...args) => unref(handleLinkClick) && unref(handleLinkClick)(...args)),
                    target: "_blank"
                  }, "Privacy Policy", 8, _hoisted_4$1)
                ];
              }),
              _: 1
            }),
            createVNode(unref(UITextMdMedium), { class: "mb-4" }, {
              default: withCtx(() => {
                var _a, _b, _c, _d;
                return [
                  _cache[6] || (_cache[6] = createTextVNode("The ")),
                  createElementVNode("a", {
                    class: "no-underline text-primary-500",
                    href: ((_b = (_a = unref(BrandedAppState)) == null ? void 0 : _a.state) == null ? void 0 : _b.privacyPolicyUrl) ? (_d = (_c = unref(BrandedAppState)) == null ? void 0 : _c.state) == null ? void 0 : _d.privacyPolicyUrl : "https://www.leadconnectorhq.com/privacy-policy",
                    target: "_blank",
                    onClick: _cache[2] || (_cache[2] = //@ts-ignore
                    (...args) => unref(handleLinkClick) && unref(handleLinkClick)(...args))
                  }, "Privacy Policy", 8, _hoisted_5$1),
                  _cache[7] || (_cache[7] = createTextVNode(" describes the ways we can use the information we collect when you create an account. "))
                ];
              }),
              _: 1
            }),
            createVNode(unref(UIButton), {
              onClick: handleUserConsent,
              class: "w-full self-center",
              type: "primary",
              id: "agree-btn",
              size: "large",
              disabled: buttonDisable.value
            }, {
              default: withCtx(() => _cache[8] || (_cache[8] = [
                createTextVNode("I Agree ")
              ])),
              _: 1
            }, 8, ["disabled"])
          ])
        ])
      ], 64);
    };
  }
});
const _sfc_main$2 = /* @__PURE__ */ defineComponent({
  __name: "VerifySecureCodePwa",
  props: {
    title: {
      type: String,
      default: "Login"
    },
    email: {
      type: String,
      required: true
    },
    token: {
      type: String
    },
    password: {
      type: String
    },
    username: {
      type: String
    },
    locationId: {
      type: String
    },
    defaultOtp: {
      type: Number,
      default: null
    },
    domain: {
      type: String
    }
  },
  emits: ["changeScreen", LoginEvents.LOGIN_CALLBACK],
  setup(__props, { emit: __emit }) {
    const otpCode = ref("");
    const isResendButtonDisabled = ref(false);
    const loadingRef = ref(null);
    const buttonDisable = ref(false);
    const notification = useNotification();
    const emit = __emit;
    const routerInstance = AppState.getRouterInstance();
    const route = computed(() => {
      if (!routerInstance) return null;
      return routerInstance.currentRoute;
    });
    const props = __props;
    function notificationFailureAlert(title, content) {
      notification.error({
        title,
        content,
        duration: 5e3
      });
    }
    const handleOnComplete = async () => {
      var _a, _b, _c, _d, _e, _f, _g, _h;
      buttonDisable.value = true;
      (_a = loadingRef.value) == null ? void 0 : _a.startLoadBar();
      try {
        if (!Number(otpCode.value)) {
          notificationFailureAlert(
            "Secure code must be a numeric value and must be of 6 digits",
            "Try Again"
          );
          (_b = loadingRef.value) == null ? void 0 : _b.stopLoadBar();
          buttonDisable.value = false;
          return false;
        }
        const { data } = await UserService.loginWithSecureEmail({
          email: props.email,
          otp: Number(otpCode.value),
          token: props.token,
          locationId: props.locationId,
          redirectUrl: (_d = (_c = route.value) == null ? void 0 : _c.query) == null ? void 0 : _d.redirectUrl
        });
        if (data == null ? void 0 : data.multiple_users) {
          emit("changeScreen", {
            email: props.email,
            otp: Number(otpCode.value),
            token: props.token,
            multiUser: data == null ? void 0 : data.multiple_users,
            loginOtp: true,
            page: Screens.SELECT_USER_MULTI_USER
          });
        } else if (data.token) {
          await postLogin(data);
          if (!data.isPasswordVerified && (data == null ? void 0 : data.passwordResetToken)) {
            emit("changeScreen", {
              email: props.email,
              passwordResetToken: data.passwordResetToken,
              contactId: data.contactId,
              isPasswordVerified: data.isPasswordVerified,
              data,
              page: Screens.SET_PASSWORD
            });
          } else {
            if (TEST_EMAILS.includes(props.email.toLowerCase().trim())) {
              await checkUserConsent(data);
              emit("changeScreen", {
                email: props.email,
                domain: props.domain,
                data,
                page: Screens.TERMS_CONSENT
              });
            } else {
              if (await checkUserConsent(data)) {
                await postLogin(data);
                emit(LoginEvents.LOGIN_CALLBACK, {
                  eventType: LoginEvents.LOGIN_SUCCESSFUL,
                  domain: props.domain,
                  ...data
                });
              } else {
                emit("changeScreen", {
                  email: props.email,
                  domain: props.domain,
                  data,
                  page: Screens.TERMS_CONSENT
                });
              }
            }
          }
          (_e = loadingRef.value) == null ? void 0 : _e.stopLoadBar();
          buttonDisable.value = false;
        }
        (_f = loadingRef.value) == null ? void 0 : _f.stopLoadBar();
        buttonDisable.value = false;
      } catch (error) {
        if (((_g = error == null ? void 0 : error.response) == null ? void 0 : _g.status) !== 429) {
          notificationFailureAlert(getErrorMessage(error), "Try Again");
        }
        (_h = loadingRef.value) == null ? void 0 : _h.stopLoadBar();
        buttonDisable.value = false;
      }
    };
    async function resendOtp() {
      var _a;
      try {
        const { data } = await UserService.loginWithSecureEmail({
          email: props.email,
          locationId: props.locationId
        });
        emit("changeScreen", {
          page: Screens.VERIFY_SECURE_CODE,
          email: props.email,
          token: data.token,
          action: "RESET_PASSWORD"
        });
        isResendButtonDisabled.value = true;
        setTimeout(() => isResendButtonDisabled.value = false, 3e4);
      } catch (error) {
        if (((_a = error == null ? void 0 : error.response) == null ? void 0 : _a.status) === 429) {
          isResendButtonDisabled.value = true;
        } else {
          notificationFailureAlert(getErrorMessage(error), "Try Again");
        }
      }
    }
    const handleOnChange = (value) => {
      otpCode.value = value;
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        createVNode(unref(UILoadingBar), {
          ref_key: "loadingRef",
          ref: loadingRef
        }, null, 512),
        createElementVNode("div", null, [
          createVNode(unref(UITextMdNormal), { class: "text-gray-500" }, {
            default: withCtx(() => _cache[2] || (_cache[2] = [
              createTextVNode("Secure code")
            ])),
            _: 1
          }),
          createVNode(unref(entry_esm), {
            class: "justify-center",
            ref: "otpInput",
            "input-classes": "otpStyle",
            value: otpCode.value,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event) => otpCode.value = $event),
            separator: " ",
            "num-inputs": 6,
            "should-auto-focus": true,
            "input-type": "tel",
            placeholder: ["0", "0", "0", "0", "0", "0"],
            onOnChange: handleOnChange,
            onOnComplete: handleOnComplete
          }, null, 8, ["value"]),
          createVNode(unref(UITextSmMedium), { class: "text-gray-900 font-normal" }, {
            default: withCtx(() => [
              _cache[4] || (_cache[4] = createTextVNode("Please check your email for the secure code. If you did not receive any email from us, ")),
              createElementVNode("span", null, [
                createVNode(unref(UIButton), {
                  id: "resend-otp--button",
                  class: "underline-offset-4",
                  onClick: resendOtp,
                  disabled: isResendButtonDisabled.value,
                  text: true
                }, {
                  default: withCtx(() => _cache[3] || (_cache[3] = [
                    createTextVNode(" tap here to resend. ")
                  ])),
                  _: 1
                }, 8, ["disabled"])
              ])
            ]),
            _: 1
          }),
          createVNode(unref(UIButton), {
            onClick: handleOnComplete,
            type: "primary",
            class: "!bg-black h-12 w-full row-span-1 mt-4 buttonBorder text-white",
            id: "signin-btn",
            size: "large",
            disabled: buttonDisable.value
          }, {
            default: withCtx(() => _cache[5] || (_cache[5] = [
              createTextVNode("Verify")
            ])),
            _: 1
          }, 8, ["disabled"]),
          createVNode(unref(UITextXsMedium), { class: "text-center text-gray-400 my-4" }, {
            default: withCtx(() => _cache[6] || (_cache[6] = [
              createTextVNode("or")
            ])),
            _: 1
          }),
          createVNode(unref(UIButton), {
            type: "default",
            class: "w-full h-12 row-span-1 text-gray-900",
            id: "code-btn",
            size: "large",
            disabled: buttonDisable.value,
            onClick: _cache[1] || (_cache[1] = () => emit("changeScreen", {
              page: unref(Screens).LOGIN
            }))
          }, {
            default: withCtx(() => _cache[7] || (_cache[7] = [
              createTextVNode("Back to login")
            ])),
            _: 1
          }, 8, ["disabled"])
        ])
      ], 64);
    };
  }
});
const VerifySecureCodePwa = /* @__PURE__ */ _export_sfc(_sfc_main$2, [["__scopeId", "data-v-8b51ac76"]]);
const _hoisted_1 = {
  id: "touchScreen",
  class: "fixed max-w-3xl p-6 h-[90vh] grid grid-rows-6"
};
const _hoisted_2 = { class: "flex items-center flex-col" };
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  key: 0,
  class: "p-1"
};
const _hoisted_5 = { class: "flex" };
const _hoisted_6 = { class: "w-full" };
const _hoisted_7 = { key: 1 };
const _hoisted_8 = { class: "max-h-48 overflow-auto" };
const _hoisted_9 = { class: "flex items-center -ml-2" };
const _hoisted_10 = { class: "w-full h-full" };
const _hoisted_11 = {
  key: 0,
  class: "flex flex-col px-4 min-h-screen"
};
const _hoisted_12 = ["src"];
const _hoisted_13 = {
  key: 0,
  class: "py-4 px-6"
};
const __default__ = {
  name: "PwaLogin"
};
const _sfc_main$1 = /* @__PURE__ */ defineComponent({
  ...__default__,
  props: {
    nodeEnv: String
  },
  emits: [
    LoginEvents.CHANGE_SCREEN,
    LoginEvents.LOGIN_CALLBACK
  ],
  setup(__props, { emit: __emit }) {
    const emit = __emit;
    const props = __props;
    const showModal = ref(false);
    const show = ref(false);
    const isDomainError = ref(false);
    const currPage = ref("signIn");
    const selectedValue = ref("");
    const notification = useNotification();
    const loadingRef = ref(null);
    const loading = ref(false);
    const errorMessage = ref();
    const optionsDomains = ref([]);
    const screen = ref({
      email: history.state.email || "",
      username: "",
      password: "",
      token: history.state.token || "",
      otp: history.state.otp || "",
      page: Screens.LOGIN,
      multiUser: history.state.multiUser || [],
      resetPassword: history.state.resetPassword || false,
      loginOtp: history.state.loginOtp || false,
      passwordResetToken: history.state.passwordResetToken || "",
      contactId: "",
      fullName: "",
      idToken: "",
      isPasswordVerified: ""
    });
    const handlePopstate = (event) => {
      history.pushState(null, null, window.location.pathname);
    };
    onMounted(async () => {
      setAppLoading(true);
      await setCarouselImages();
      window.addEventListener("popstate", handlePopstate, false);
    });
    const carousels = ref([]);
    async function setCarouselImages() {
      var _a, _b, _c, _d, _e, _f, _g, _h;
      const appCarousel = [];
      for (let i = 0; i < 4; i++) {
        if (((_b = (_a = BrandedAppState) == null ? void 0 : _a.state) == null ? void 0 : _b[`appCarouselImage${i + 1}`]) && ((_d = (_c = BrandedAppState) == null ? void 0 : _c.state) == null ? void 0 : _d[`appCarouselDescription${i + 1}`])) {
          appCarousel.push({
            title: (_f = (_e = BrandedAppState) == null ? void 0 : _e.state) == null ? void 0 : _f[`appCarouselDescription${i + 1}`],
            image: (_h = (_g = BrandedAppState) == null ? void 0 : _g.state) == null ? void 0 : _h[`appCarouselImage${i + 1}`]
          });
        }
      }
      if (appCarousel.length >= 2) {
        carousels.value = appCarousel;
      } else {
        carousels.value = defaultCarousels;
      }
      setAppLoading(false);
    }
    const defaultCarousels = [
      {
        title: "Getting started is easy! Enter your email and we will connect your account.",
        image: FRAME1
      },
      {
        title: "Connect with other people in a community on topics and shared interests",
        image: FRAME2
      },
      {
        title: "Watch courses, take quizzes and view resources",
        image: FRAME3
      },
      {
        title: "Communicate effortlessly with business on-the-go",
        image: FRAME4
      }
    ];
    onBeforeUnmount(() => {
      window.removeEventListener("popstate", handlePopstate, false);
    });
    const rules = {
      email: {
        required: true,
        validator: (_, value) => {
          errorMessage.value = null;
          return string().email().required().validate(value);
        },
        message: "Please enter a valid  email",
        trigger: ["blur"]
      }
    };
    const formValue = ref({
      email: "",
      password: "",
      domainName: "",
      domain: "",
      portalImage: "",
      locationId: ""
    });
    watch(formValue.value, () => isDomainError.value = false);
    const formRef = ref();
    function notificationFailureAlert(title, content) {
      notification.error({
        title,
        content,
        duration: 5e3
      });
    }
    function handleClose() {
      currPage.value = "signIn";
    }
    function handleLoginClose() {
      screen.value.page = Screens.LOGIN;
    }
    async function handleValidateClick(e) {
      var _a, _b, _c, _d, _e, _f;
      if (Capacitor.getPlatform() === "ios") {
        await KeyboardPlugin.hideKeyboard();
      }
      e.preventDefault();
      (_a = loadingRef.value) == null ? void 0 : _a.startLoadBar();
      const result = await validateForm(formRef.value);
      if (!result) {
        (_b = loadingRef.value) == null ? void 0 : _b.stopLoadBar();
        return;
      }
      const suffixDomain = props.nodeEnv === "production" ? ".app" : ".staging";
      try {
        let { data } = await UserService.getUserDomains({
          email: formValue.value.email.trim()
        });
        if (formValue.value.email.toLowerCase().trim() == TEST_EMAIL_ID && TEST_LOCATION_ID) {
          data = data == null ? void 0 : data.filter((val) => val.locationId === TEST_LOCATION_ID);
        } else {
          const brandedAppLocationId = (_d = (_c = BrandedAppState) == null ? void 0 : _c.state) == null ? void 0 : _d.locationId;
          if (brandedAppLocationId) {
            data = data == null ? void 0 : data.filter((val) => val.locationId === brandedAppLocationId);
          }
        }
        if ((data == null ? void 0 : data.length) === 1) {
          const listDomains = data.map((val) => {
            return {
              domain: (val == null ? void 0 : val.customDomain) || val.subDomain + suffixDomain + ".clientclub.net",
              label: (val == null ? void 0 : val.portalBannerText) || "Client Portal",
              portalImage: (val == null ? void 0 : val.logo) || GROUP_MOBILE_ICON,
              locationId: (val == null ? void 0 : val.locationId) || ""
            };
          });
          formValue.value.domainName = listDomains[0].label;
          formValue.value.domain = listDomains[0].domain;
          formValue.value.portalImage = listDomains[0].portalImage;
          formValue.value.locationId = listDomains[0].locationId;
          show.value = true;
        } else if ((data == null ? void 0 : data.length) > 1) {
          const listDomains = data.map((val) => {
            return {
              domain: (val == null ? void 0 : val.customDomain) || val.subDomain + suffixDomain + ".clientclub.net",
              label: (val == null ? void 0 : val.portalBannerText) || "Client Portal",
              portalImage: (val == null ? void 0 : val.logo) || GROUP_MOBILE_ICON,
              locationId: (val == null ? void 0 : val.locationId) || ""
            };
          });
          currPage.value = "welcomePage";
          optionsDomains.value = listDomains;
        } else {
          notificationFailureAlert(
            "Uh oh! Your email isn't registered with any business",
            "Try Again"
          );
        }
      } catch (error) {
        (_e = loadingRef.value) == null ? void 0 : _e.stopLoadBar();
        throw error;
      } finally {
        (_f = loadingRef.value) == null ? void 0 : _f.stopLoadBar();
      }
    }
    const styleName = computed(() => {
      if (screen.value.page === Screens.LOGIN) {
        return "siteContainerLogin";
      }
      if (screen.value.page === Screens.LOGIN_WITH_SECURE_CODE) {
        return "siteContainerSecureCode";
      }
      if (screen.value.page === Screens.FORGOT_PASSWORD) {
        return "siteContainerForgotPassword";
      }
      if (screen.value.page === Screens.VERIFY_SECURE_CODE || screen.value.page === Screens.SET_PASSWORD_WITH_SECURE_CODE) {
        return "siteContainerVerifyCode";
      }
      if (screen.value.page === Screens.SET_PASSWORD) {
        return "siteContainerSetPassword";
      }
      if (screen.value.page === Screens.SELECT_USER_MULTI_USER) {
        return "siteContainerMultiUser";
      }
      return "siteContainer";
    });
    async function callback(event) {
      try {
        await NotificationState.getUnreadNotificationsCount(99);
      } catch (e) {
        console.error("Login callback error:", e);
      }
      try {
        await setBadgeCount(NotificationState.state.unReadNotificationCount);
      } catch (e) {
        console.error("Error setting badge count:", e);
      }
      emit(LoginEvents.LOGIN_CALLBACK, event);
    }
    function onChangeScreen(val) {
      screen.value = { ...screen, ...val };
      emit(LoginEvents.CHANGE_SCREEN, screen);
    }
    function onSignIn() {
      showModal.value = true;
    }
    function handleHeight() {
      if (currPage.value === "signIn") {
        return 180;
      } else {
        return 420;
      }
    }
    function handleLocationPage() {
      const selected = optionsDomains.value.filter(
        (val) => val.domain == selectedValue.value
      );
      formValue.value.domainName = selected[0].label;
      formValue.value.domain = selected[0].domain;
      formValue.value.portalImage = selected[0].portalImage;
      formValue.value.locationId = selected[0].locationId;
      showModal.value = false;
      show.value = true;
    }
    KeyboardPlugin == null ? void 0 : KeyboardPlugin.addListener("keyboardWillHide", () => {
      handleKeyboardWillHide();
    });
    function handleKeyboardWillHide() {
      setTimeout(() => {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
          left: 0
        });
      }, 50);
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        createVNode(unref(UILoadingBar), {
          ref_key: "loadingRef",
          ref: loadingRef
        }, null, 512),
        createElementVNode("div", _hoisted_1, [
          createVNode(unref(UICarousel), {
            autoPlay: true,
            showDots: true,
            draggable: true,
            dotType: "line",
            direction: "horizontal",
            spaceBetweenItems: 13,
            transitionStyle: {
              transitionTimingFunction: "linear",
              transitionDuration: "0.3s"
            },
            touchable: true,
            mousewheel: true,
            classNames: "row-span-5"
          }, {
            customRender: withCtx(() => [
              (openBlock(true), createElementBlock(Fragment, null, renderList(carousels.value, (carousel) => {
                return openBlock(), createElementBlock("div", {
                  key: carousel.title
                }, [
                  createElementVNode("div", _hoisted_2, [
                    createVNode(unref(UITextLgMedium), { class: "text-gray-700 text-lg font-semibold text-center mt-10 mb-16" }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(carousel.title), 1)
                      ]),
                      _: 2
                    }, 1024),
                    createElementVNode("div", null, [
                      createElementVNode("img", {
                        class: "w-full h-[380px] object-contain",
                        src: carousel.image
                      }, null, 8, _hoisted_3)
                    ])
                  ])
                ]);
              }), 128))
            ]),
            _: 1
          }),
          createVNode(unref(UIButton), {
            onClick: onSignIn,
            type: "primary",
            class: "!bg-black w-full h-12 row-span-1 mt-12 buttonBorder",
            id: "download-certificate-btn",
            size: "large"
          }, {
            default: withCtx(() => _cache[4] || (_cache[4] = [
              createTextVNode("Sign In")
            ])),
            _: 1
          }),
          createVNode(unref(UIDrawer), {
            class: "p-0",
            show: showModal.value,
            "onUpdate:show": _cache[2] || (_cache[2] = ($event) => showModal.value = $event),
            placement: "bottom",
            id: "post-signup-drawer",
            height: handleHeight(),
            "on-after-leave": handleClose,
            "auto-focus": false
          }, {
            default: withCtx(() => [
              createVNode(unref(UIDrawerContent), {
                id: "post-options-drawer-menu",
                class: "p-0",
                closable: false
              }, {
                default: withCtx(() => [
                  currPage.value == "signIn" ? (openBlock(), createElementBlock("div", _hoisted_4, [
                    createVNode(unref(UIForm), {
                      id: "login-page-email-form",
                      ref_key: "formRef",
                      ref: formRef,
                      model: formValue.value,
                      rules
                    }, {
                      default: withCtx(() => [
                        createElementVNode("div", _hoisted_5, [
                          createElementVNode("div", _hoisted_6, [
                            createVNode(unref(UITextMdNormal), { class: "text-gray-600" }, {
                              default: withCtx(() => _cache[5] || (_cache[5] = [
                                createTextVNode("Email")
                              ])),
                              _: 1
                            }),
                            createVNode(unref(UIFormItem), {
                              class: "block",
                              path: "email"
                            }, {
                              default: withCtx(() => [
                                createVNode(unref(UIInput), {
                                  modelValue: formValue.value.email,
                                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => formValue.value.email = $event),
                                  size: "large",
                                  placeholder: "",
                                  id: "domain-form-email"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            createVNode(unref(UITextXsMedium), { class: "text-gray-400 -mt-[2px]" }, {
                              default: withCtx(() => _cache[6] || (_cache[6] = [
                                createTextVNode("Enter your email address")
                              ])),
                              _: 1
                            })
                          ]),
                          createVNode(unref(UIButton), {
                            onClick: handleValidateClick,
                            id: "proceed-button",
                            type: "primary",
                            class: "!bg-black h-12 w-12 ml-4 mt-4 rounded-xl buttonBorder",
                            loading: loading.value
                          }, {
                            default: withCtx(() => [
                              !loading.value ? (openBlock(), createBlock(unref(render$1g), {
                                key: 0,
                                class: "w-7 h-7"
                              })) : createCommentVNode("", true)
                            ]),
                            _: 1
                          }, 8, ["loading"])
                        ])
                      ]),
                      _: 1
                    }, 8, ["model"])
                  ])) : createCommentVNode("", true),
                  currPage.value == "welcomePage" ? (openBlock(), createElementBlock("div", _hoisted_7, [
                    createVNode(unref(UITextLgMedium), { class: "text-gray-600 text-center mb-2" }, {
                      default: withCtx(() => _cache[7] || (_cache[7] = [
                        createTextVNode("Welcome")
                      ])),
                      _: 1
                    }),
                    createVNode(unref(UITextSmMedium), { class: "text-gray-400 text-center mb-6" }, {
                      default: withCtx(() => _cache[8] || (_cache[8] = [
                        createTextVNode("Select the website you would like to add. You can always sign in to more later")
                      ])),
                      _: 1
                    }),
                    createElementVNode("div", _hoisted_8, [
                      createVNode(unref(UIRadioGroup), {
                        value: selectedValue.value,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event) => selectedValue.value = $event),
                        name: "radiobuttongroup1",
                        class: "w-full radio-container"
                      }, {
                        default: withCtx(() => [
                          createVNode(unref(UISpace), { vertical: "" }, {
                            default: withCtx(() => [
                              (openBlock(true), createElementBlock(Fragment, null, renderList(optionsDomains.value, (item) => {
                                return openBlock(), createBlock(unref(UIRadioGroupItem), {
                                  value: item.domain,
                                  "onUpdate:value": ($event) => item.domain = $event,
                                  key: item.domain,
                                  disabled: false,
                                  compact: void 0,
                                  class: "w-full my-1 py-1"
                                }, {
                                  content: withCtx(() => [
                                    createElementVNode("div", _hoisted_9, [
                                      createVNode(unref(UIAvatar), {
                                        class: "h-12 w-12",
                                        objectFit: "cover",
                                        src: item.portalImage
                                      }, null, 8, ["src"]),
                                      createElementVNode("div", null, [
                                        createVNode(unref(UITextSmMedium), { class: "ml-2 text-gray-700" }, {
                                          default: withCtx(() => [
                                            createTextVNode(toDisplayString(item.label), 1)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        createVNode(unref(UITextXsRegular), { class: "ml-2 mt-[6px] truncate max-w-[50vw] text-gray-500" }, {
                                          default: withCtx(() => [
                                            createTextVNode(toDisplayString(item.domain), 1)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ])
                                    ])
                                  ]),
                                  _: 2
                                }, 1032, ["value", "onUpdate:value"]);
                              }), 128))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ]),
                    createVNode(unref(UIButton), {
                      onClick: handleLocationPage,
                      type: "primary",
                      class: "!bg-black w-full h-12 row-span-1 mt-4 buttonBorder",
                      id: "next-domain-btn",
                      size: "large",
                      disabled: selectedValue.value === ""
                    }, {
                      default: withCtx(() => _cache[9] || (_cache[9] = [
                        createTextVNode("Next")
                      ])),
                      _: 1
                    }, 8, ["disabled"])
                  ])) : createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["show", "height"]),
          createVNode(unref(UIDrawer), {
            show: show.value,
            "onUpdate:show": _cache[3] || (_cache[3] = ($event) => show.value = $event),
            width: "100vw",
            "on-after-leave": handleLoginClose,
            placement: "right",
            id: "drawer"
          }, {
            default: withCtx(() => [
              createVNode(unref(UIDrawerContent), {
                class: "signIn",
                id: "drawer-component"
              }, {
                default: withCtx(() => {
                  var _a;
                  return [
                    createElementVNode("div", _hoisted_10, [
                      createElementVNode("div", {
                        class: normalizeClass([
                          "w-full",
                          screen.value.page === unref(Screens).TERMS_CONSENT ? "bg-white" : "bg-gray-900"
                        ])
                      }, [
                        screen.value.page === unref(Screens).TERMS_CONSENT ? (openBlock(), createElementBlock("div", _hoisted_11, [
                          createVNode(_sfc_main$3, {
                            onChangeScreen,
                            email: screen.value.email,
                            onLoginCallback: callback,
                            domain: screen.value.domain,
                            data: screen.value.data
                          }, null, 8, ["email", "domain", "data"])
                        ])) : screen.value.page !== unref(Screens).SET_PASSWORD_WITH_SECURE_CODE && screen.value.page !== unref(Screens).VERIFY_SECURE_CODE ? (openBlock(), createElementBlock("div", {
                          key: 1,
                          class: normalizeClass(`flex justify-center items-center flex-col ${styleName.value}`)
                        }, [
                          createVNode(unref(UIAvatar), {
                            size: "medium",
                            objectFit: "cover",
                            round: false,
                            style: void 0,
                            src: formValue.value.portalImage,
                            class: "w-24 h-24 rounded-lg"
                          }, null, 8, ["src"]),
                          createVNode(unref(UITextLgMedium), { class: "text-white mt-6 text-xl font-semibold" }, {
                            default: withCtx(() => [
                              createTextVNode(toDisplayString(formValue.value.domainName), 1)
                            ]),
                            _: 1
                          }),
                          createVNode(unref(UITextSmRegular), { class: "text-white" }, {
                            default: withCtx(() => _cache[10] || (_cache[10] = [
                              createTextVNode("Login")
                            ])),
                            _: 1
                          })
                        ], 2)) : (openBlock(), createElementBlock("div", {
                          key: 2,
                          class: normalizeClass(`flex justify-center items-center flex-col ${styleName.value}`)
                        }, [
                          createElementVNode("img", {
                            class: "ml-4",
                            src: unref(MAIL_MOBILE_ICON)
                          }, null, 8, _hoisted_12),
                          createVNode(unref(UITextSmMedium), { class: "text-white mt-6 mb-2 font-semibold" }, {
                            default: withCtx(() => _cache[11] || (_cache[11] = [
                              createTextVNode("Check your email")
                            ])),
                            _: 1
                          }),
                          createVNode(unref(UITextSmMedium), { class: "text-white mt-6 mb-2 font-medium" }, {
                            default: withCtx(() => [
                              createTextVNode(toDisplayString(formValue.value.email), 1)
                            ]),
                            _: 1
                          })
                        ], 2))
                      ], 2),
                      screen.value.page !== unref(Screens).TERMS_CONSENT ? (openBlock(), createElementBlock("div", _hoisted_13, [
                        screen.value.page === unref(Screens).LOGIN ? (openBlock(), createBlock(LoginPagePwa, {
                          key: 0,
                          onChangeScreen,
                          onLoginCallback: callback,
                          locationId: formValue.value.locationId,
                          email: formValue.value.email,
                          domain: formValue.value.domain
                        }, null, 8, ["locationId", "email", "domain"])) : createCommentVNode("", true),
                        screen.value.page === unref(Screens).VERIFY_SECURE_CODE ? (openBlock(), createBlock(VerifySecureCodePwa, {
                          key: 1,
                          onChangeScreen,
                          onLoginCallback: callback,
                          email: screen.value.email,
                          locationId: formValue.value.locationId,
                          token: screen.value.token,
                          domain: formValue.value.domain
                        }, null, 8, ["email", "locationId", "token", "domain"])) : createCommentVNode("", true),
                        screen.value.page === unref(Screens).SET_PASSWORD_WITH_SECURE_CODE ? (openBlock(), createBlock(_sfc_main$4, {
                          key: 2,
                          onChangeScreen,
                          onLoginCallback: callback,
                          email: screen.value.email,
                          locationId: formValue.value.locationId,
                          token: screen.value.token
                        }, null, 8, ["email", "locationId", "token"])) : createCommentVNode("", true),
                        screen.value.page === unref(Screens).SET_PASSWORD ? (openBlock(), createBlock(SetPasswordPwa, {
                          key: 3,
                          onChangeScreen,
                          onLoginCallback: callback,
                          locationId: formValue.value.locationId,
                          passwordResetToken: screen.value.passwordResetToken,
                          userId: screen.value.userId,
                          domain: formValue.value.domain,
                          contactId: screen.value.contactId,
                          isPasswordVerified: screen.value.isPasswordVerified,
                          token: screen.value.token,
                          data: screen.value.data
                        }, null, 8, ["locationId", "passwordResetToken", "userId", "domain", "contactId", "isPasswordVerified", "token", "data"])) : createCommentVNode("", true),
                        screen.value.page === unref(Screens).SELECT_USER_MULTI_USER ? (openBlock(), createBlock(LoginMultiUserPwa, {
                          key: 4,
                          onChangeScreen,
                          onLoginCallback: callback,
                          email: screen.value.email,
                          otp: screen.value.otp,
                          users: screen.value.multiUser,
                          token: screen.value.token,
                          resetPassword: screen.value.resetPassword,
                          loginOtp: screen.value.loginOtp,
                          idToken: (_a = screen.value) == null ? void 0 : _a.idToken,
                          locationId: formValue.value.locationId,
                          domain: formValue.value.domain
                        }, null, 8, ["email", "otp", "users", "token", "resetPassword", "loginOtp", "idToken", "locationId", "domain"])) : createCommentVNode("", true)
                      ])) : createCommentVNode("", true)
                    ])
                  ];
                }),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["show"])
        ])
      ], 64);
    };
  }
});
const PwaLogin = /* @__PURE__ */ _export_sfc(_sfc_main$1, [["__scopeId", "data-v-5e858a6a"]]);
PwaLogin.install = (Vue) => {
  Vue.component(PwaLogin.name, PwaLogin);
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "SafeArea",
  setup(__props) {
    const statusbarBackground = ref(null);
    onMounted(async () => {
      if (Capacitor.getPlatform() === "ios") {
        SafeArea.getStatusBarHeight().then(({ statusBarHeight }) => {
          if (statusbarBackground.value) {
            statusbarBackground.value.style.height = `${statusBarHeight + 5}px`;
          }
        });
        const safeAreaData = await SafeArea.getSafeAreaInsets();
        const { insets } = safeAreaData;
        for (const [key, value] of Object.entries(insets)) {
          document.documentElement.style.setProperty(
            `--safe-area-inset-${key}`,
            `${value}px`
          );
        }
      }
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        unref(Capacitor).getPlatform() === "ios" ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: "fixed w-full",
          id: "statusbar-background",
          ref_key: "statusbarBackground",
          ref: statusbarBackground
        }, null, 512)) : createCommentVNode("", true),
        renderSlot(_ctx.$slots, "default")
      ], 64);
    };
  }
});
const renderIcon = (icon) => {
  return () => {
    return h(
      icon,
      {
        class: "h-4 w-4"
      },
      {}
    );
  };
};
const FullScreenImageViewNative = registerPlugin("FullScreenImageView");
const FullScreenImageViewPlugin = {
  async showFullScreenView() {
    try {
      await FullScreenImageViewNative.showFullScreenView();
    } catch (error) {
      console.warn("FullScreenImageView plugin not available:", error);
    }
  },
  async hideFullScreenView() {
    try {
      await FullScreenImageViewNative.hideFullScreenView();
    } catch (error) {
      console.warn("FullScreenImageView plugin not available:", error);
    }
  }
};
const NativeScreenOrientationPlugin = registerPlugin("ScreenOrientationPlugin");
const ScreenOrientationPlugin = {
  async lockPortraitOrientation() {
    try {
      if (isGokollab() && Capacitor.getPlatform() === CAPACITOR_PLATFORM.IOS) {
        await NativeScreenOrientationPlugin.lockPortraitOrientation();
      } else {
        await SafeScreenOrientation.lock({ orientation: "portrait" });
      }
    } catch (error) {
      console.error("Failed to lock orientation:", error);
    }
  },
  async unlockOrientation() {
    try {
      if (isGokollab() && Capacitor.getPlatform() === CAPACITOR_PLATFORM.IOS) {
        await NativeScreenOrientationPlugin.unlockOrientation();
      } else {
        await SafeScreenOrientation.unlock();
      }
    } catch (error) {
      console.error("Failed to unlock orientation:", error);
    }
  },
  async getOrientationStatus() {
    try {
      if (isGokollab() && Capacitor.getPlatform() === CAPACITOR_PLATFORM.IOS) {
        return await NativeScreenOrientationPlugin.getOrientationStatus();
      } else {
        return {
          isPortraitRestricted: false,
          // Capacitor handles this
          isSplashAnimationCompleted: true,
          isBackgroundRemoved: true,
          canRotate: true
        };
      }
    } catch (error) {
      console.error("Failed to get orientation status:", error);
      return {
        isPortraitRestricted: false,
        isSplashAnimationCompleted: true,
        isBackgroundRemoved: true,
        canRotate: true
      };
    }
  }
};
const PACKAGE_VERSION = "3.2.39";
export {
  NotificationMobileView as $,
  AuthProvider as A,
  setPullToRefreshAndroid as B,
  sv as C,
  ProfileContainer as D,
  AppLoader as E,
  _sfc_main$1N as F,
  DashBoard as G,
  _sfc_main$B as H,
  _sfc_main$A as I,
  GokollabSwitcher as J,
  KeyboardPlugin as K,
  GokollabLoginModal as L,
  MorePage as M,
  LoginModalV2 as N,
  GokollabSidebar as O,
  PACKAGE_VERSION as P,
  _sfc_main$r as Q,
  LockoutPage as R,
  SignInWithGoogle as S,
  LoginModal as T,
  _sfc_main$18 as U,
  BottomNavBar as V,
  BottomNavBarMobile as W,
  TopNavBar as X,
  TopNavBarMobile as Y,
  NavBar as Z,
  _sfc_main$15 as _,
  _sfc_main$1k as a,
  PwaLogin as a0,
  _sfc_main as a1,
  NavigationItemType as a2,
  StripeMinimumChargeAmount as a3,
  currency as a4,
  currencyCode as a5,
  getCurrencySymbol as a6,
  renderIcon as a7,
  FullScreenImageViewPlugin as a8,
  ScreenOrientationPlugin as a9,
  ProfileCardV2 as aa,
  _sfc_main$1j as b,
  getNetworkAwareErrorMessage as c,
  getLocalePreference as d,
  SafeScreenOrientation as e,
  SafeStatusBar as f,
  getErrorMessage as g,
  da as h,
  dashboardManager as i,
  de as j,
  en as k,
  es as l,
  fi as m,
  frCA as n,
  openNativeUrls as o,
  frFR as p,
  getAllIndexedDBData as q,
  getAllLocalStorageData as r,
  setupVueI18n as s,
  getAllStorageData as t,
  handleLinkClick as u,
  it as v,
  nl as w,
  no as x,
  ptBR as y,
  ptPT as z
};
